import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
  Upload: any;
};


/** An Account */
export type Account = Node & {
  __typename?: 'Account';
  accountable: Accountable;
  bankInformation?: Maybe<BankInformation>;
  birthDate?: Maybe<Scalars['ISO8601DateTime']>;
  civility?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  /** Account is Completed ? */
  completed?: Maybe<Scalars['Boolean']>;
  corporateForm?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  /** État de l'email (admin uniquement) */
  emailState?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** JWT du widget support Freshdesk (propriétaire du compte) */
  freshdeskWidgetToken?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identityDocuments?: Maybe<Array<CustomFile>>;
  importConditionAccepted?: Maybe<Scalars['Boolean']>;
  isProfessional?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  nbItems?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['String']>;
  ribDocuments?: Maybe<Array<CustomFile>>;
  shippingAddress?: Maybe<Address>;
  siret?: Maybe<Scalars['String']>;
  state?: Maybe<AccountStateEnum>;
  tvaNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  users: UserConnection;
  writerFixFees?: Maybe<Scalars['Float']>;
  writerPourcentageFees?: Maybe<Scalars['Float']>;
  writerType?: Maybe<Scalars['String']>;
};


/** An Account */
export type AccountUsersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Account. */
export type AccountConnection = {
  __typename?: 'AccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Account>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AccountEdge = {
  __typename?: 'AccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Account>;
};

export type AccountFilter = {
  OR?: Maybe<Array<AccountFilter>>;
  companyName?: Maybe<OperatorStringFilter>;
  firstName?: Maybe<OperatorStringFilter>;
  id?: Maybe<OperatorIdFilter>;
  lastName?: Maybe<OperatorStringFilter>;
};

export enum AccountStateEnum {
  ToVerify = 'TO_VERIFY',
  Verified = 'VERIFIED',
  Archived = 'ARCHIVED',
  Blocked = 'BLOCKED',
  Refused = 'REFUSED',
  Removed = 'REMOVED'
}

/** Objects which may belongs_to an account */
export type Accountable = Buyer | Expert | Vendor | Writer;

/** An Address */
export type Address = Node & {
  __typename?: 'Address';
  account: Account;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLine3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  /** Optional address name */
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  phone1?: Maybe<Scalars['String']>;
  phone2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  zip?: Maybe<Scalars['String']>;
};

/** The connection type for Address. */
export type AddressConnection = {
  __typename?: 'AddressConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AddressEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Address>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AddressEdge = {
  __typename?: 'AddressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Address>;
};

export type AddressFilter = {
  OR?: Maybe<Array<AddressFilter>>;
  addressLine1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Objet proposé dans une alerte desiderata */
export type AlertItem = {
  __typename?: 'AlertItem';
  item: Item;
  /** Score de correspondance (%) */
  score?: Maybe<Scalars['Int']>;
};

export type AlreadyPaidStats = {
  __typename?: 'AlreadyPaidStats';
  count: Scalars['Int'];
  totalAmount: Scalars['Float'];
};

/** Container for all analytics metrics requested in one GraphQL call. */
export type Analytics = {
  __typename?: 'Analytics';
  /** Computed metrics in the same order as the requested metrics argument. */
  metrics: Array<MetricResult>;
};

/** Autogenerated input type of ArchiveItemCategoryMutation */
export type ArchiveItemCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ArchiveItemCategoryMutation. */
export type ArchiveItemCategoryMutationPayload = {
  __typename?: 'ArchiveItemCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  itemCategory?: Maybe<ItemCategory>;
};

/** Autogenerated input type of ArchiveItemSubCategoryMutation */
export type ArchiveItemSubCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ArchiveItemSubCategoryMutation. */
export type ArchiveItemSubCategoryMutationPayload = {
  __typename?: 'ArchiveItemSubCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  itemSubCategory?: Maybe<ItemSubCategory>;
};

/** An Artist */
export type Artist = Node & {
  __typename?: 'Artist';
  createdAt: Scalars['ISO8601DateTime'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isGroup?: Maybe<Scalars['Boolean']>;
  itemCategoryId: Scalars['ID'];
  lastName: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Artist. */
export type ArtistConnection = {
  __typename?: 'ArtistConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ArtistEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Artist>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ArtistEdge = {
  __typename?: 'ArtistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Artist>;
};

export type ArtistFilter = {
  OR?: Maybe<Array<ArtistFilter>>;
  firstName?: Maybe<OperatorStringFilter>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<OperatorStringFilter>;
  tag?: Maybe<Scalars['String']>;
};

/** A BankInformation */
export type BankInformation = Node & {
  __typename?: 'BankInformation';
  account: Account;
  bic?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  fullName?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A Book */
export type Book = Node & {
  __typename?: 'Book';
  assemblySpecification?: Maybe<Scalars['String']>;
  assemblyType?: Maybe<Scalars['String']>;
  bibliographyComment?: Maybe<Scalars['String']>;
  bindingAdditionalOptions?: Maybe<Scalars['String']>;
  bindingAge?: Maybe<Scalars['String']>;
  bindingColor?: Maybe<Scalars['String']>;
  bindingFormat?: Maybe<Scalars['String']>;
  bindingFormatDetails?: Maybe<Scalars['String']>;
  bindingMaterial?: Maybe<Scalars['String']>;
  bindingMaterialOptions?: Maybe<Scalars['String']>;
  bindingStyle?: Maybe<Scalars['String']>;
  bindingType?: Maybe<Scalars['String']>;
  bindingTypeOptions?: Maybe<Scalars['String']>;
  bookBinder?: Maybe<Scalars['String']>;
  bookSpineMaterial?: Maybe<Scalars['String']>;
  bookSpineOrnament1?: Maybe<Scalars['String']>;
  bookSpineOrnament1Option?: Maybe<Scalars['String']>;
  bookSpineOrnament2?: Maybe<Scalars['String']>;
  bookSpineOrnament2Option?: Maybe<Scalars['String']>;
  bookSpineOrnamentOption?: Maybe<Scalars['String']>;
  bookSpineType?: Maybe<Scalars['String']>;
  casingType?: Maybe<Scalars['String']>;
  collationComment?: Maybe<Scalars['String']>;
  coverColor?: Maybe<Scalars['String']>;
  coverMaterial?: Maybe<Scalars['String']>;
  coverOrnament1?: Maybe<Scalars['String']>;
  coverOrnament1Option?: Maybe<Scalars['String']>;
  coverOrnament2?: Maybe<Scalars['String']>;
  coverOrnament2Option?: Maybe<Scalars['String']>;
  coverOrnamentOption?: Maybe<Scalars['String']>;
  coverQuality?: Maybe<Scalars['String']>;
  coverType?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  dumbSpine?: Maybe<Scalars['Boolean']>;
  /** color */
  edgeColor?: Maybe<Scalars['String']>;
  edgeStyle?: Maybe<Scalars['String']>;
  edgeType?: Maybe<Scalars['String']>;
  editingAttribute?: Maybe<Scalars['String']>;
  editingAttributeDetails?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  illustrationComment?: Maybe<Scalars['String']>;
  isApproximatelyPaginating?: Maybe<Scalars['Boolean']>;
  isBindingSigned?: Maybe<Scalars['Boolean']>;
  isOblong?: Maybe<Scalars['Boolean']>;
  isPaginating?: Maybe<Scalars['Boolean']>;
  item: Item;
  paginationInfo?: Maybe<Scalars['String']>;
  paperbackType?: Maybe<Scalars['String']>;
  publisherKnownButNotMentioned?: Maybe<Scalars['Boolean']>;
  publishers?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  volumes?: Maybe<VolumeConnection>;
  withFolder?: Maybe<Scalars['Boolean']>;
};


/** A Book */
export type BookVolumesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Dimensions available for grouped analytics results. */
export enum BreakdownDimensionEnum {
  /** Group by order_items.vendor_id. */
  Vendor = 'VENDOR',
  /** Group by items.item_category_id. */
  Category = 'CATEGORY',
  /** Group by items.expert_id. */
  Expert = 'EXPERT',
  /** Group by items.writer_id. */
  Writer = 'WRITER'
}

/** Optional grouping configuration for analytics metrics. */
export type BreakdownInput = {
  /** Dimension used in the SQL GROUP BY, for example VENDOR, CATEGORY, EXPERT, or WRITER. */
  dimension: BreakdownDimensionEnum;
};

/** One metric value for one requested breakdown dimension bucket. */
export type BreakdownResult = {
  __typename?: 'BreakdownResult';
  /** ID of the grouped entity. Null means the grouped foreign key was empty. */
  dimensionId?: Maybe<Scalars['ID']>;
  /** Human readable name of the grouped entity (category name, writer full name, etc.). */
  name?: Maybe<Scalars['String']>;
  /** Aggregated value for this bucket. Shape depends on the metric. */
  value?: Maybe<Scalars['JSON']>;
};

/** Autogenerated input type of BulkMarkExpertPaymentsAsPaid */
export type BulkMarkExpertPaymentsAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkMarkExpertPaymentsAsPaid. */
export type BulkMarkExpertPaymentsAsPaidPayload = {
  __typename?: 'BulkMarkExpertPaymentsAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  updatedCount: Scalars['Int'];
};

/** Autogenerated input type of BulkMarkExpertStatementPaymentsAsPaid */
export type BulkMarkExpertStatementPaymentsAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkMarkExpertStatementPaymentsAsPaid. */
export type BulkMarkExpertStatementPaymentsAsPaidPayload = {
  __typename?: 'BulkMarkExpertStatementPaymentsAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  updatedCount: Scalars['Int'];
};

/** Autogenerated input type of BulkMarkImportPaymentsAsPaid */
export type BulkMarkImportPaymentsAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkMarkImportPaymentsAsPaid. */
export type BulkMarkImportPaymentsAsPaidPayload = {
  __typename?: 'BulkMarkImportPaymentsAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  updatedCount: Scalars['Int'];
};

/** Autogenerated input type of BulkMarkImportStatementPaymentsAsPaid */
export type BulkMarkImportStatementPaymentsAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkMarkImportStatementPaymentsAsPaid. */
export type BulkMarkImportStatementPaymentsAsPaidPayload = {
  __typename?: 'BulkMarkImportStatementPaymentsAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  updatedCount: Scalars['Int'];
};

/** Autogenerated input type of BulkMarkMonthlyVendorPaymentsAsPaid */
export type BulkMarkMonthlyVendorPaymentsAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkMarkMonthlyVendorPaymentsAsPaid. */
export type BulkMarkMonthlyVendorPaymentsAsPaidPayload = {
  __typename?: 'BulkMarkMonthlyVendorPaymentsAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  updatedCount: Scalars['Int'];
};

/** Autogenerated input type of BulkMarkProjectIntroducerPaymentsAsPaid */
export type BulkMarkProjectIntroducerPaymentsAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkMarkProjectIntroducerPaymentsAsPaid. */
export type BulkMarkProjectIntroducerPaymentsAsPaidPayload = {
  __typename?: 'BulkMarkProjectIntroducerPaymentsAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  updatedCount: Scalars['Int'];
};

/** Autogenerated input type of BulkMarkVendorStatementPaymentsAsPaid */
export type BulkMarkVendorStatementPaymentsAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkMarkVendorStatementPaymentsAsPaid. */
export type BulkMarkVendorStatementPaymentsAsPaidPayload = {
  __typename?: 'BulkMarkVendorStatementPaymentsAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  updatedCount: Scalars['Int'];
};

/** Autogenerated input type of BulkMarkWriterPaymentsAsPaid */
export type BulkMarkWriterPaymentsAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkMarkWriterPaymentsAsPaid. */
export type BulkMarkWriterPaymentsAsPaidPayload = {
  __typename?: 'BulkMarkWriterPaymentsAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  updatedCount: Scalars['Int'];
};

/** Autogenerated input type of BulkMarkWriterStatementPaymentsAsPaid */
export type BulkMarkWriterStatementPaymentsAsPaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkMarkWriterStatementPaymentsAsPaid. */
export type BulkMarkWriterStatementPaymentsAsPaidPayload = {
  __typename?: 'BulkMarkWriterStatementPaymentsAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  updatedCount: Scalars['Int'];
};

/** Autogenerated input type of BulkRelistItemsMutation */
export type BulkRelistItemsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  forceLibraryFund?: Maybe<Scalars['Boolean']>;
  itemIds: Array<Scalars['ID']>;
  saleId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of BulkRelistItemsMutation. */
export type BulkRelistItemsMutationPayload = {
  __typename?: 'BulkRelistItemsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of BulkRemoveReturnedItemsMutation */
export type BulkRemoveReturnedItemsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  itemIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkRemoveReturnedItemsMutation. */
export type BulkRemoveReturnedItemsMutationPayload = {
  __typename?: 'BulkRemoveReturnedItemsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of BulkReturnItemsMutation */
export type BulkReturnItemsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  itemIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkReturnItemsMutation. */
export type BulkReturnItemsMutationPayload = {
  __typename?: 'BulkReturnItemsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  returnSlipId?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of BulkUpdateSalePositionsMutation */
export type BulkUpdateSalePositionsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  updates: Array<SalePositionUpdateInput>;
};

/** Autogenerated return type of BulkUpdateSalePositionsMutation. */
export type BulkUpdateSalePositionsMutationPayload = {
  __typename?: 'BulkUpdateSalePositionsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  items?: Maybe<Array<Item>>;
};

/** A BusinessIntroducer */
export type BusinessIntroducer = Node & {
  __typename?: 'BusinessIntroducer';
  createdAt: Scalars['ISO8601DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  identityDocument?: Maybe<CustomFile>;
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  rib?: Maybe<CustomFile>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for BusinessIntroducer. */
export type BusinessIntroducerConnection = {
  __typename?: 'BusinessIntroducerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BusinessIntroducerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BusinessIntroducer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type BusinessIntroducerEdge = {
  __typename?: 'BusinessIntroducerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<BusinessIntroducer>;
};

export type BusinessIntroducerFilter = {
  OR?: Maybe<Array<BusinessIntroducerFilter>>;
  email?: Maybe<OperatorStringFilter>;
  firstName?: Maybe<OperatorStringFilter>;
  lastName?: Maybe<OperatorStringFilter>;
};

/** An Buyer */
export type Buyer = Node & {
  __typename?: 'Buyer';
  account: Account;
  autoTags?: Maybe<TagConnection>;
  bookmarkTags?: Maybe<TagConnection>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  /** Desiderata, plus récents en premier (admin uniquement) */
  desires?: Maybe<DesireConnection>;
  /** Date de vérification des desiderata par un admin (admin uniquement) */
  desiresReviewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Admin qui a vérifié les desiderata (admin uniquement) */
  desiresReviewedBy?: Maybe<Scalars['String']>;
  expertTags?: Maybe<TagConnection>;
  /** Objets mis en favoris, plus récents en premier (admin uniquement) */
  favorites?: Maybe<FavoriteConnection>;
  id: Scalars['ID'];
  importTags?: Maybe<TagConnection>;
  items?: Maybe<ItemConnection>;
  /** Objets achetés (commandes payées), plus récents en premier (admin uniquement) */
  purchases?: Maybe<OrderItemConnection>;
  /** Statistiques d'achat (admin uniquement) */
  stats?: Maybe<BuyerStats>;
  tags?: Maybe<TagConnection>;
  /** Tags les plus fréquents parmi les objets achetés (admin uniquement) */
  topTags?: Maybe<Array<BuyerTopTag>>;
  /** Types d'envoi dont l'acheteur s'est désabonné, via l'email de son compte (admin uniquement) */
  unsubscriptions?: Maybe<Array<CustomerUnsubscription>>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** An Buyer */
export type BuyerAutoTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Buyer */
export type BuyerBookmarkTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Buyer */
export type BuyerDesiresArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Buyer */
export type BuyerExpertTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Buyer */
export type BuyerFavoritesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Buyer */
export type BuyerImportTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Buyer */
export type BuyerItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Buyer */
export type BuyerPurchasesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Buyer */
export type BuyerTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Buyer */
export type BuyerTopTagsArgs = {
  limit?: Maybe<Scalars['Int']>;
};

/** The connection type for Buyer. */
export type BuyerConnection = {
  __typename?: 'BuyerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BuyerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Buyer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Desiderata vérifiés par un admin ou restant à vérifier */
export enum BuyerDesireReviewEnum {
  /** Desiderata pas encore vérifiés par un admin */
  NotReviewed = 'NOT_REVIEWED',
  /** Desiderata déjà vérifiés par un admin */
  Reviewed = 'REVIEWED'
}

/** Acheteurs ayant au moins un desiderata actif, ou aucun */
export enum BuyerDesireStatusEnum {
  /** Au moins un desiderata actif */
  WithDesires = 'WITH_DESIRES',
  /** Aucun desiderata actif */
  WithoutDesires = 'WITHOUT_DESIRES'
}

/** An edge in a connection. */
export type BuyerEdge = {
  __typename?: 'BuyerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Buyer>;
};

export type BuyerFilter = {
  OR?: Maybe<Array<BuyerFilter>>;
  account?: Maybe<AccountFilter>;
  id?: Maybe<OperatorIdFilter>;
};

/** Acheteurs ayant déjà acheté ou jamais acheté (commandes payées) */
export enum BuyerPurchaseStatusEnum {
  /** Au moins une commande payée */
  WithOrders = 'WITH_ORDERS',
  /** Aucune commande payée */
  WithoutOrders = 'WITHOUT_ORDERS'
}

/** Statistiques d'achat agrégées d'un acheteur */
export type BuyerStats = {
  __typename?: 'BuyerStats';
  /** Nombre de desiderata actifs */
  activeDesiresCount: Scalars['Int'];
  /** Panier moyen TTC (total dépensé / commandes) */
  averageBasket: Scalars['Float'];
  /** Nombre total de desiderata */
  desiresCount: Scalars['Int'];
  /** Nombre d'objets en favoris */
  favoritesCount: Scalars['Int'];
  /** Date de la première commande payée */
  firstOrderAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastClickedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastNewsletterAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastOpenedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Date de la dernière commande payée */
  lastOrderAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Newsletters dont un lien a été cliqué */
  newslettersClickedCount: Scalars['Int'];
  /** Newsletters ouvertes */
  newslettersOpenedCount: Scalars['Int'];
  /** Newsletters reçues */
  newslettersReceivedCount: Scalars['Int'];
  /** Nombre de commandes payées */
  ordersCount: Scalars['Int'];
  /** Nombre d'objets achetés */
  purchasesCount: Scalars['Int'];
  /** Montant total TTC payé (commandes payées) */
  totalSpent: Scalars['Float'];
};

/** Tag les plus présents parmi les objets achetés par un acheteur */
export type BuyerTopTag = {
  __typename?: 'BuyerTopTag';
  /** Nombre d'objets achetés portant ce tag */
  purchasesCount: Scalars['Int'];
  tag: Tag;
};

/** A CarpetTextile */
export type CarpetTextile = Node & {
  __typename?: 'CarpetTextile';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A Ceramic */
export type Ceramic = Node & {
  __typename?: 'Ceramic';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A CoinsMedalsStamps */
export type CoinsMedalsStamps = Node & {
  __typename?: 'CoinsMedalsStamps';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Reference period options used to compare analytics metrics. */
export enum CompareToEnum {
  /** Do not compute any comparison. */
  None = 'NONE',
  /** Compare with the immediately preceding period of the same duration. */
  PreviousPeriod = 'PREVIOUS_PERIOD',
  /** Compare with the same date range shifted one year earlier. */
  PreviousYear = 'PREVIOUS_YEAR'
}

/** Comparison between the current metric value and a reference period. */
export type Comparison = {
  __typename?: 'Comparison';
  /** Difference between the current value and previousValue. Null when no comparison is available. */
  delta?: Maybe<Scalars['JSON']>;
  /** Percentage difference for numeric metrics. Null for non-numeric metrics or zero previousValue. */
  deltaPercentage?: Maybe<Scalars['Float']>;
  /** Metric value computed on the reference period. Null when the reference period has no data. */
  previousValue?: Maybe<Scalars['JSON']>;
};

/** Attributes to create a Account. */
export type CreateAccountInput = {
  /** email */
  email: Scalars['String'];
  /** first_name */
  firstName?: Maybe<Scalars['String']>;
  /** identity_document */
  identityDocument?: Maybe<UploadFileInput>;
  /** Type of the created vendor */
  kind?: Maybe<VendorKindEnum>;
  /** last_name */
  lastName?: Maybe<Scalars['String']>;
  /** phone */
  phone?: Maybe<Scalars['String']>;
  /** rib */
  rib?: Maybe<UploadFileInput>;
  /** role */
  role?: Maybe<Scalars['String']>;
  /** state */
  state?: Maybe<AccountStateEnum>;
  /** writer_fix_fees */
  writerFixFees?: Maybe<Scalars['Float']>;
  /** writer_pourcentage_fees */
  writerPourcentageFees?: Maybe<Scalars['Float']>;
  /** writerType */
  writerType?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateAccountMutation */
export type CreateAccountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateAccountInput;
};

/** Autogenerated return type of CreateAccountMutation. */
export type CreateAccountMutationPayload = {
  __typename?: 'CreateAccountMutationPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to create a Artist. */
export type CreateArtistInput = {
  /** first_name */
  firstName?: Maybe<Scalars['String']>;
  /** is_group */
  isGroup?: Maybe<Scalars['String']>;
  itemCategoryId?: Maybe<Scalars['ID']>;
  /** last_name */
  lastName: Scalars['String'];
  /** tag */
  tag?: Maybe<Scalars['String']>;
};

/** Attributes to create a BankInformation. */
export type CreateBankInformationInput = {
  /** lang */
  bic?: Maybe<Scalars['String']>;
  /** lang */
  fullName?: Maybe<Scalars['String']>;
  /** lang */
  iban?: Maybe<Scalars['String']>;
  /** lang */
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateBankInformationMutation */
export type CreateBankInformationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateBankInformationInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of CreateBankInformationMutation. */
export type CreateBankInformationMutationPayload = {
  __typename?: 'CreateBankInformationMutationPayload';
  bankInformation?: Maybe<BankInformation>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to create a book. */
export type CreateBookInput = {
  /** assembly_specification */
  assemblySpecification?: Maybe<Scalars['String']>;
  /** assembly_type */
  assemblyType?: Maybe<Scalars['String']>;
  /** binding_color */
  bindingColor?: Maybe<Scalars['String']>;
  /** binding_format */
  bindingFormat?: Maybe<Scalars['String']>;
  /** binding_material */
  bindingMaterial?: Maybe<Scalars['String']>;
  /** binding_style */
  bindingStyle?: Maybe<Scalars['String']>;
  /** binding_type */
  bindingType?: Maybe<Scalars['String']>;
  /** book_spine_material */
  bookSpineMaterial?: Maybe<Scalars['String']>;
  /** book_spine_ornament */
  bookSpineOrnament?: Maybe<Scalars['String']>;
  /** book_spine_type */
  bookSpineType?: Maybe<Scalars['String']>;
  /** cover_color */
  coverColor?: Maybe<Scalars['String']>;
  /** cover_material */
  coverMaterial?: Maybe<Scalars['String']>;
  /** cover_ornament */
  coverOrnament?: Maybe<Scalars['String']>;
  /** date_from */
  dateFrom?: Maybe<Scalars['String']>;
  /** date_option */
  dateOption?: Maybe<Scalars['String']>;
  /** date_to */
  dateTo?: Maybe<Scalars['String']>;
  /** edge_color */
  edgeColor?: Maybe<Scalars['String']>;
  /** edge_style */
  edgeStyle?: Maybe<Scalars['String']>;
  /** edge_type */
  edgeType?: Maybe<Scalars['String']>;
  /** editing_attribute */
  editingAttribute?: Maybe<Scalars['String']>;
  /** editing_attribute_details */
  editingAttributeDetails?: Maybe<Scalars['String']>;
  /** is_binding_signed */
  isBindingSigned?: Maybe<Scalars['Boolean']>;
  item?: Maybe<NestedItemInput>;
  /** paperback_type */
  paperbackType?: Maybe<Scalars['String']>;
  /** publisher_known_but_not_mentioned */
  publisherKnownButNotMentioned?: Maybe<Scalars['Boolean']>;
  /** publishers */
  publishers?: Maybe<Scalars['String']>;
  bibliographyComment?: Maybe<Scalars['String']>;
  collationComment?: Maybe<Scalars['String']>;
  illustrationComment?: Maybe<Scalars['String']>;
  isApproximatelyPaginating?: Maybe<Scalars['Boolean']>;
  paginationInfo?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateBookMutation */
export type CreateBookMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateBookInput;
};

/** Autogenerated return type of CreateBookMutation. */
export type CreateBookMutationPayload = {
  __typename?: 'CreateBookMutationPayload';
  book?: Maybe<Book>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to Create a Business Introducer. */
export type CreateBusinessIntroducerInput = {
  /** email */
  email: Scalars['String'];
  /** first_name */
  firstName: Scalars['String'];
  /** identity_document */
  identityDocument?: Maybe<UploadFileInput>;
  /** last_name */
  lastName: Scalars['String'];
  /** phone */
  phone?: Maybe<Scalars['String']>;
  /** rib */
  rib?: Maybe<UploadFileInput>;
};

/** Autogenerated input type of CreateBusinessIntroducerMutation */
export type CreateBusinessIntroducerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateBusinessIntroducerInput;
};

/** Autogenerated return type of CreateBusinessIntroducerMutation. */
export type CreateBusinessIntroducerMutationPayload = {
  __typename?: 'CreateBusinessIntroducerMutationPayload';
  businessIntroducer?: Maybe<BusinessIntroducer>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to create a CarpetTextile. */
export type CreateCarpetTextileInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateCarpetTextileMutation */
export type CreateCarpetTextileMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateCarpetTextileInput;
};

/** Autogenerated return type of CreateCarpetTextileMutation. */
export type CreateCarpetTextileMutationPayload = {
  __typename?: 'CreateCarpetTextileMutationPayload';
  carpetTextile?: Maybe<CarpetTextile>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to create a Ceramic. */
export type CreateCeramicInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateCeramicMutation */
export type CreateCeramicMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateCeramicInput;
};

/** Autogenerated return type of CreateCeramicMutation. */
export type CreateCeramicMutationPayload = {
  __typename?: 'CreateCeramicMutationPayload';
  ceramic?: Maybe<Ceramic>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to create a CoinsMedalsStamps. */
export type CreateCoinsMedalsStampsInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateCoinsMedalsStampsMutation */
export type CreateCoinsMedalsStampsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateCoinsMedalsStampsInput;
};

/** Autogenerated return type of CreateCoinsMedalsStampsMutation. */
export type CreateCoinsMedalsStampsMutationPayload = {
  __typename?: 'CreateCoinsMedalsStampsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  coinsMedalsStamps?: Maybe<CoinsMedalsStamps>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to import files from a commissaire-priseur (CP) */
export type CreateCpImportInput = {
  /** account ID of the importer */
  accountId: Scalars['String'];
  /** Buyer email file (XLSX) */
  cpBuyersFiles: Array<UploadFileInput>;
  /** Lot recap files (XLSX) */
  cpLotsFiles: Array<UploadFileInput>;
  /** filename */
  filename?: Maybe<Scalars['String']>;
  /** type */
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCpImportMutation */
export type CreateCpImportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateCpImportInput;
};

/** Autogenerated return type of CreateCpImportMutation. */
export type CreateCpImportMutationPayload = {
  __typename?: 'CreateCpImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  import?: Maybe<Import>;
};

/** Attributes to Create a Customer. */
export type CreateCustomerInput = {
  /** Description */
  addressLine1?: Maybe<Scalars['String']>;
  /** Description */
  addressLine2?: Maybe<Scalars['String']>;
  /** Description */
  addressLine3?: Maybe<Scalars['String']>;
  /** Description */
  city?: Maybe<Scalars['String']>;
  /** Description */
  country?: Maybe<Scalars['String']>;
  /** desires */
  desires?: Maybe<Scalars['String']>;
  /** Description */
  email: Scalars['String'];
  /** Expert Id */
  expertId?: Maybe<Scalars['ID']>;
  /** Description */
  firstName?: Maybe<Scalars['String']>;
  /** Description */
  fullName?: Maybe<Scalars['String']>;
  /** Description */
  lastName?: Maybe<Scalars['String']>;
  /** Description */
  phone1?: Maybe<Scalars['String']>;
  /** Description */
  phone2?: Maybe<Scalars['String']>;
  /** Vendor Id */
  vendorId?: Maybe<Scalars['ID']>;
  /** Description */
  zip?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCustomerMutation */
export type CreateCustomerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateCustomerInput;
};

/** Autogenerated return type of CreateCustomerMutation. */
export type CreateCustomerMutationPayload = {
  __typename?: 'CreateCustomerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to create a Desire. */
export type CreateDesireInput = {
  /** Admin only: create the desire on behalf of this buyer */
  buyerId?: Maybe<Scalars['ID']>;
  /** Admin only: create the desire on behalf of this customer (imported contact) */
  customerId?: Maybe<Scalars['ID']>;
  /** name */
  title?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateDesireMutation */
export type CreateDesireMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateDesireInput;
};

/** Autogenerated return type of CreateDesireMutation. */
export type CreateDesireMutationPayload = {
  __typename?: 'CreateDesireMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  desire?: Maybe<Desire>;
  errors?: Maybe<ValidationErrors>;
};

export type CreateDesiresRainworxImportInput = {
  accountId: Scalars['ID'];
  desiresFiles: Array<UploadFileInput>;
  /** filename */
  filename?: Maybe<Scalars['String']>;
  /** type */
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateDesiresRainworxImportMutation */
export type CreateDesiresRainworxImportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateDesiresRainworxImportInput;
};

/** Autogenerated return type of CreateDesiresRainworxImportMutation. */
export type CreateDesiresRainworxImportMutationPayload = {
  __typename?: 'CreateDesiresRainworxImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  import?: Maybe<Import>;
};

/** Autogenerated input type of CreateDrouotExportCsvMutation */
export type CreateDrouotExportCsvMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  itemIds: Array<Scalars['ID']>;
  saleId: Scalars['ID'];
};

/** Autogenerated return type of CreateDrouotExportCsvMutation. */
export type CreateDrouotExportCsvMutationPayload = {
  __typename?: 'CreateDrouotExportCsvMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sale?: Maybe<Sale>;
};

/** Attributes to update a Import. */
export type CreateDrouotImportInput = {
  /** filename */
  accountId: Scalars['String'];
  /** filename */
  filename?: Maybe<Scalars['String']>;
  salesInvoiceFiles: Array<UploadFileInput>;
  salesTransactionFiles: Array<UploadFileInput>;
  /** type */
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateDrouotImportMutation */
export type CreateDrouotImportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateDrouotImportInput;
};

/** Autogenerated return type of CreateDrouotImportMutation. */
export type CreateDrouotImportMutationPayload = {
  __typename?: 'CreateDrouotImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  import?: Maybe<Import>;
};

/** Attributes to create a Engraving. */
export type CreateEngravingInput = {
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateEngravingMutation */
export type CreateEngravingMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateEngravingInput;
};

/** Autogenerated return type of CreateEngravingMutation. */
export type CreateEngravingMutationPayload = {
  __typename?: 'CreateEngravingMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  engraving?: Maybe<Engraving>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to create a FashionLuxuryAccessory. */
export type CreateFashionLuxuryAccessoryInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateFashionLuxuryAccessoryMutation */
export type CreateFashionLuxuryAccessoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateFashionLuxuryAccessoryInput;
};

/** Autogenerated return type of CreateFashionLuxuryAccessoryMutation. */
export type CreateFashionLuxuryAccessoryMutationPayload = {
  __typename?: 'CreateFashionLuxuryAccessoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  fashionLuxuryAccessory?: Maybe<FashionLuxuryAccessory>;
};

export type CreateFavoritesRainworxImportInput = {
  accountId: Scalars['ID'];
  favoritesFiles: Array<UploadFileInput>;
  /** filename */
  filename?: Maybe<Scalars['String']>;
  /** type */
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateFavoritesRainworxImportMutation */
export type CreateFavoritesRainworxImportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateFavoritesRainworxImportInput;
};

/** Autogenerated return type of CreateFavoritesRainworxImportMutation. */
export type CreateFavoritesRainworxImportMutationPayload = {
  __typename?: 'CreateFavoritesRainworxImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  import?: Maybe<Import>;
};

/** Attributes to create a Furniture. */
export type CreateFurnitureInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateFurnitureMutation */
export type CreateFurnitureMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateFurnitureInput;
};

/** Autogenerated return type of CreateFurnitureMutation. */
export type CreateFurnitureMutationPayload = {
  __typename?: 'CreateFurnitureMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  furniture?: Maybe<Furniture>;
};

/** Attributes to create a GeographicMap. */
export type CreateGeographicMapInput = {
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateGeographicMapMutation */
export type CreateGeographicMapMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateGeographicMapInput;
};

/** Autogenerated return type of CreateGeographicMapMutation. */
export type CreateGeographicMapMutationPayload = {
  __typename?: 'CreateGeographicMapMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  geographicMap?: Maybe<GeographicMap>;
};

/** Attributes to update a Import. */
export type CreateImportInput = {
  /** filename */
  accountId: Scalars['String'];
  /** filename */
  filename?: Maybe<Scalars['String']>;
  /** list of item_category ids */
  itemCategories?: Maybe<Array<Scalars['ID']>>;
  /** llist of item_sub_category ids */
  itemSubCategories?: Maybe<Array<Scalars['ID']>>;
  /** mapping */
  mapping: Scalars['JSON'];
  /** list of tags */
  tags?: Maybe<Array<Scalars['String']>>;
  /** type */
  type?: Maybe<Scalars['String']>;
  files: Array<UploadFileInput>;
};

/** Autogenerated input type of CreateImportMutation */
export type CreateImportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateImportInput;
};

/** Autogenerated return type of CreateImportMutation. */
export type CreateImportMutationPayload = {
  __typename?: 'CreateImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  import?: Maybe<Import>;
};

/** Autogenerated input type of CreateItemCategoryMutation */
export type CreateItemCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  externalRainworxId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** Autogenerated return type of CreateItemCategoryMutation. */
export type CreateItemCategoryMutationPayload = {
  __typename?: 'CreateItemCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  itemCategory?: Maybe<ItemCategory>;
};

/** Attributes to create an item. */
export type CreateItemInput = {
  /** saleTitle */
  saleTitle?: Maybe<Scalars['String']>;
  /** Title */
  title?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** The template id */
  templateId?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  expertId?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  vendorId: Scalars['String'];
  lotId?: Maybe<Scalars['Int']>;
  vacationId?: Maybe<Scalars['Int']>;
  writerId?: Maybe<Scalars['ID']>;
  customSkuPart?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['String']>;
  otherComment?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
  /** Number of identical articles the weight applies to */
  unitCount?: Maybe<Scalars['Int']>;
  conditionsComment?: Maybe<Scalars['String']>;
  globalComment?: Maybe<Scalars['String']>;
  highEstimatedPrice?: Maybe<Scalars['Float']>;
  lowEstimatedPrice?: Maybe<Scalars['Float']>;
  reservedPrice?: Maybe<Scalars['Float']>;
  startingPrice?: Maybe<Scalars['Float']>;
  locationKnownButNotMentioned?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateOption?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  itemCategoryId?: Maybe<Scalars['String']>;
  itemSubCategoryId?: Maybe<Scalars['String']>;
  artistCollectif?: Maybe<Scalars['Boolean']>;
  artistKnownButNotMentioned?: Maybe<Scalars['Boolean']>;
  artistUnknown?: Maybe<Scalars['Boolean']>;
  /** mode */
  mode?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['ID']>;
  /** Vente CP pour laquelle l'objet est préparé (sans effet sur son statut) */
  plannedSaleId?: Maybe<Scalars['ID']>;
};

/** Attributes to Create a ItemMovement. */
export type CreateItemMovementInput = {
  accountId?: Maybe<Scalars['ID']>;
  fromLocation: Scalars['String'];
  selectedItemIds?: Maybe<Array<Scalars['ID']>>;
  toLocation: Scalars['String'];
};

/** Autogenerated input type of CreateItemMovementMutation */
export type CreateItemMovementMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateItemMovementInput;
};

/** Autogenerated return type of CreateItemMovementMutation. */
export type CreateItemMovementMutationPayload = {
  __typename?: 'CreateItemMovementMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  itemMovement?: Maybe<ItemMovement>;
};

/** Autogenerated input type of CreateItemMutation */
export type CreateItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateItemInput;
};

/** Autogenerated return type of CreateItemMutation. */
export type CreateItemMutationPayload = {
  __typename?: 'CreateItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  item?: Maybe<Item>;
};

/** Autogenerated input type of CreateItemSubCategoryMutation */
export type CreateItemSubCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  externalRainworxId?: Maybe<Scalars['Int']>;
  itemCategoryId: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated return type of CreateItemSubCategoryMutation. */
export type CreateItemSubCategoryMutationPayload = {
  __typename?: 'CreateItemSubCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  itemSubCategory?: Maybe<ItemSubCategory>;
};

/** Attributes to create a Jewelry. */
export type CreateJewelryInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateJewelryMutation */
export type CreateJewelryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateJewelryInput;
};

/** Autogenerated return type of CreateJewelryMutation. */
export type CreateJewelryMutationPayload = {
  __typename?: 'CreateJewelryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  jewelry?: Maybe<Jewelry>;
};

/** Attributes to update a Import. */
export type CreateLotUrlRainworxImportInput = {
  /** filename */
  accountId: Scalars['String'];
  /** filename */
  filename?: Maybe<Scalars['String']>;
  lotUrlsRainworxFiles: Array<UploadFileInput>;
  /** type */
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateLotUrlsRainworxImportMutation */
export type CreateLotUrlsRainworxImportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateLotUrlRainworxImportInput;
};

/** Autogenerated return type of CreateLotUrlsRainworxImportMutation. */
export type CreateLotUrlsRainworxImportMutationPayload = {
  __typename?: 'CreateLotUrlsRainworxImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  import?: Maybe<Import>;
};

/** Attributes to create a Manuscript. */
export type CreateManuscriptInput = {
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateManuscriptMutation */
export type CreateManuscriptMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateManuscriptInput;
};

/** Autogenerated return type of CreateManuscriptMutation. */
export type CreateManuscriptMutationPayload = {
  __typename?: 'CreateManuscriptMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  manuscript?: Maybe<Manuscript>;
};

/** Attributes to create a Militaria. */
export type CreateMilitariaInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateMilitariaMutation */
export type CreateMilitariaMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateMilitariaInput;
};

/** Autogenerated return type of CreateMilitariaMutation. */
export type CreateMilitariaMutationPayload = {
  __typename?: 'CreateMilitariaMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  militaria?: Maybe<Militaria>;
};

export type CreateMyAlertsDesiresImportInput = {
  accountId: Scalars['ID'];
  /** CSV files containing MyAlerts desires to import */
  desiresFiles: Array<UploadFileInput>;
  /** Import filename */
  filename?: Maybe<Scalars['String']>;
  /** Import STI type */
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateMyAlertsDesiresImportMutation */
export type CreateMyAlertsDesiresImportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateMyAlertsDesiresImportInput;
};

/** Autogenerated return type of CreateMyAlertsDesiresImportMutation. */
export type CreateMyAlertsDesiresImportMutationPayload = {
  __typename?: 'CreateMyAlertsDesiresImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  import?: Maybe<Import>;
};

/** Attributes to Create a NewsLetter. */
export type CreateNewsLetterInput = {
  /** Is it a general newsletter ? */
  general: Scalars['Boolean'];
  /** Number limit of users to send the newsletter */
  limit?: Maybe<Scalars['Int']>;
  /** sale */
  saleId: Scalars['ID'];
  /** Is it test newsletter or real one ? */
  test: Scalars['Boolean'];
};

/** Autogenerated input type of CreateNewsLetterMutation */
export type CreateNewsLetterMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateNewsLetterInput;
};

/** Autogenerated return type of CreateNewsLetterMutation. */
export type CreateNewsLetterMutationPayload = {
  __typename?: 'CreateNewsLetterMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sale?: Maybe<Sale>;
};

/** Attributes to create a PaintingSculpture. */
export type CreatePaintingSculptureInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreatePaintingSculptureMutation */
export type CreatePaintingSculptureMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreatePaintingSculptureInput;
};

/** Autogenerated return type of CreatePaintingSculptureMutation. */
export type CreatePaintingSculptureMutationPayload = {
  __typename?: 'CreatePaintingSculptureMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  paintingSculpture?: Maybe<PaintingSculpture>;
};

/** Attributes to create a Photography. */
export type CreatePhotographyInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreatePhotographyMutation */
export type CreatePhotographyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreatePhotographyInput;
};

/** Autogenerated return type of CreatePhotographyMutation. */
export type CreatePhotographyMutationPayload = {
  __typename?: 'CreatePhotographyMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  photography?: Maybe<Photography>;
};

/** Attributes for creating a pickup request */
export type CreatePickupRequestInput = {
  /** Vendor address to use for pickup */
  addressId: Scalars['ID'];
  /** Instructions for the carrier */
  instructions?: Maybe<Scalars['String']>;
  /** Vendor parcels to include in the pickup */
  labelIds: Array<Scalars['ID']>;
  /** Maximum label age in days; 0 removes the age limit */
  maxAgeDays?: Maybe<Scalars['Int']>;
  /** Where the carrier should collect the parcels */
  pickupLocation?: Maybe<Scalars['String']>;
  /** Closing time in HH:MM format */
  pickupLocationCloseTime: Scalars['String'];
  /** Requested pickup date and start time */
  pickupTimestamp: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of CreatePickupRequestMutation */
export type CreatePickupRequestMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Pickup details and selected parcels */
  attributes: CreatePickupRequestInput;
};

/** Autogenerated return type of CreatePickupRequestMutation. */
export type CreatePickupRequestMutationPayload = {
  __typename?: 'CreatePickupRequestMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Input validation errors */
  errors?: Maybe<ValidationErrors>;
  /** Created pickup request and its current result */
  pickupRequest?: Maybe<PickupRequest>;
};

/** Attributes to Create a Project Fee. */
export type CreateProjectFeeInput = {
  /** title */
  name: Scalars['String'];
  /** title */
  value: Scalars['Float'];
  projectId: Scalars['ID'];
};

/** Autogenerated input type of CreateProjectFeeMutation */
export type CreateProjectFeeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateProjectFeeInput;
};

/** Autogenerated return type of CreateProjectFeeMutation. */
export type CreateProjectFeeMutationPayload = {
  __typename?: 'CreateProjectFeeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  projectFee?: Maybe<ProjectFee>;
};

/** Attributes to Create a Project. */
export type CreateProjectInput = {
  ownerId: Scalars['ID'];
  /** title */
  title: Scalars['String'];
};

/** Autogenerated input type of CreateProjectMutation */
export type CreateProjectMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateProjectInput;
};

/** Autogenerated return type of CreateProjectMutation. */
export type CreateProjectMutationPayload = {
  __typename?: 'CreateProjectMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  project?: Maybe<Project>;
};

/** Attributes to Create a QuickText. */
export type CreateQuickTextInput = {
  accountId: Scalars['ID'];
  /** text */
  text: Scalars['String'];
  /** title */
  title?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateQuickTextMutation */
export type CreateQuickTextMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateQuickTextInput;
};

/** Autogenerated return type of CreateQuickTextMutation. */
export type CreateQuickTextMutationPayload = {
  __typename?: 'CreateQuickTextMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  quickText?: Maybe<QuickText>;
};

/** Attributes to Create a Sale. */
export type CreateSaleInput = {
  /** description */
  description?: Maybe<Scalars['String']>;
  /** end_at */
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** estimated_price_enabled */
  estimatedPriceEnabled?: Maybe<Scalars['Boolean']>;
  /** external_event_rainworx_id */
  externalEventRainworxId?: Maybe<Scalars['Int']>;
  image?: Maybe<UploadImageInput>;
  /** name */
  name: Scalars['String'];
  /** start_at */
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** state */
  state?: Maybe<Scalars['String']>;
  /** type_of_sale */
  typeOfSale?: Maybe<Scalars['String']>;
  expertId: Scalars['ID'];
  vacationId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of CreateSaleMandatMutation */
export type CreateSaleMandatMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  saleId: Scalars['ID'];
};

/** Autogenerated return type of CreateSaleMandatMutation. */
export type CreateSaleMandatMutationPayload = {
  __typename?: 'CreateSaleMandatMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sale?: Maybe<Sale>;
};

/** Autogenerated input type of CreateSaleMutation */
export type CreateSaleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateSaleInput;
};

/** Autogenerated return type of CreateSaleMutation. */
export type CreateSaleMutationPayload = {
  __typename?: 'CreateSaleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sale?: Maybe<Sale>;
};

/** Attributes to create a SilverwareTableware. */
export type CreateSilverwareTablewareInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateSilverwareTablewareMutation */
export type CreateSilverwareTablewareMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateSilverwareTablewareInput;
};

/** Autogenerated return type of CreateSilverwareTablewareMutation. */
export type CreateSilverwareTablewareMutationPayload = {
  __typename?: 'CreateSilverwareTablewareMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  silverwareTableware?: Maybe<SilverwareTableware>;
};

/** Autogenerated input type of CreateStripeAccountSessionMutation */
export type CreateStripeAccountSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** ID du Vendor */
  vendorId: Scalars['ID'];
};

/** Autogenerated return type of CreateStripeAccountSessionMutation. */
export type CreateStripeAccountSessionMutationPayload = {
  __typename?: 'CreateStripeAccountSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Attributes to create a Tag. */
export type CreateTagInput = {
  /** name */
  name?: Maybe<Scalars['String']>;
};

/** Attributes to Create a ThirdParty Introducer. */
export type CreateThirdPartyIntroducerInput = {
  /** email */
  email: Scalars['String'];
  /** first_name */
  firstName: Scalars['String'];
  /** identity_document */
  identityDocument?: Maybe<UploadFileInput>;
  /** last_name */
  lastName: Scalars['String'];
  /** phone */
  phone?: Maybe<Scalars['String']>;
  /** id, required: true */
  projectId: Scalars['ID'];
  /** rib */
  rib?: Maybe<UploadFileInput>;
};

/** Autogenerated input type of CreateThirdPartyIntroducerMutation */
export type CreateThirdPartyIntroducerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateThirdPartyIntroducerInput;
};

/** Autogenerated return type of CreateThirdPartyIntroducerMutation. */
export type CreateThirdPartyIntroducerMutationPayload = {
  __typename?: 'CreateThirdPartyIntroducerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  thirdPartyIntroducer?: Maybe<ThirdPartyIntroducer>;
};

/** Attributes to create a ToyComicPopCulture. */
export type CreateToyComicPopCultureInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateToyComicPopCultureMutation */
export type CreateToyComicPopCultureMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateToyComicPopCultureInput;
};

/** Autogenerated return type of CreateToyComicPopCultureMutation. */
export type CreateToyComicPopCultureMutationPayload = {
  __typename?: 'CreateToyComicPopCultureMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  toyComicPopCulture?: Maybe<ToyComicPopCulture>;
};

/** Attributes to update a Import. */
export type CreateUnsoldItemsRainworxImportInput = {
  /** filename */
  accountId: Scalars['String'];
  /** filename */
  filename?: Maybe<Scalars['String']>;
  /** type */
  type?: Maybe<Scalars['String']>;
  unsoldItemsRainworxFiles: Array<UploadFileInput>;
};

/** Autogenerated input type of CreateUnsoldItemsRainworxImportMutation */
export type CreateUnsoldItemsRainworxImportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateUnsoldItemsRainworxImportInput;
};

/** Autogenerated return type of CreateUnsoldItemsRainworxImportMutation. */
export type CreateUnsoldItemsRainworxImportMutationPayload = {
  __typename?: 'CreateUnsoldItemsRainworxImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  import?: Maybe<Import>;
};

/** Attributes to Create a Vacation. */
export type CreateVacationInput = {
  /** description */
  description?: Maybe<Scalars['String']>;
  /** end_at */
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  image?: Maybe<UploadImageInput>;
  /** name */
  name: Scalars['String'];
  /** start_at */
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** state */
  state?: Maybe<Scalars['String']>;
  expertId: Scalars['ID'];
  projectId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of CreateVacationMutation */
export type CreateVacationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateVacationInput;
};

/** Autogenerated return type of CreateVacationMutation. */
export type CreateVacationMutationPayload = {
  __typename?: 'CreateVacationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  vacation?: Maybe<Vacation>;
};

/** Autogenerated input type of CreateVendorAddressMutation */
export type CreateVendorAddressMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Vendor address attributes */
  attributes: VendorAddressInput;
};

/** Autogenerated return type of CreateVendorAddressMutation. */
export type CreateVendorAddressMutationPayload = {
  __typename?: 'CreateVendorAddressMutationPayload';
  /** Created vendor address */
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Validation errors */
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to create a Watch. */
export type CreateWatchInput = {
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of CreateWatchMutation */
export type CreateWatchMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateWatchInput;
};

/** Autogenerated return type of CreateWatchMutation. */
export type CreateWatchMutationPayload = {
  __typename?: 'CreateWatchMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  watch?: Maybe<Watch>;
};

/** Attributes to update a Writer. */
export type CreateWriterInput = {
  /** The account id */
  accountId?: Maybe<Scalars['Int']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
};

/** Custom File Type */
export type CustomFile = {
  __typename?: 'CustomFile';
  blobId?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CustomSignIn. */
export type CustomSignInPayload = {
  __typename?: 'CustomSignInPayload';
  errors: Array<Error>;
  sessionToken?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** Autogenerated return type of CustomSignUp. */
export type CustomSignUpPayload = {
  __typename?: 'CustomSignUpPayload';
  errors: Array<Error>;
  sessionToken?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** Autogenerated input type of CustomUpdateAccountMutation */
export type CustomUpdateAccountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateAccountInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of CustomUpdateAccountMutation. */
export type CustomUpdateAccountMutationPayload = {
  __typename?: 'CustomUpdateAccountMutationPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** An Customer */
export type Customer = Node & {
  __typename?: 'Customer';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLine3?: Maybe<Scalars['String']>;
  buyer?: Maybe<Buyer>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  desires?: Maybe<DesireConnection>;
  /** Date de vérification des desiderata par un admin (admin uniquement) */
  desiresReviewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Admin qui a vérifié les desiderata (admin uniquement) */
  desiresReviewedBy?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  /** État de l'email (admin uniquement) */
  emailState?: Maybe<Scalars['String']>;
  expert: Expert;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  import?: Maybe<Import>;
  itemCategories?: Maybe<CustomerItemCategoryConnection>;
  itemSubCategories?: Maybe<CustomerItemSubCategoryConnection>;
  lastName?: Maybe<Scalars['String']>;
  /** Imports ayant créé ce contact (admin uniquement) */
  origins?: Maybe<Array<CustomerOrigin>>;
  phone1?: Maybe<Scalars['String']>;
  phone2?: Maybe<Scalars['String']>;
  /** Statistiques du contact (admin uniquement) */
  stats?: Maybe<CustomerStats>;
  /** Abonné (admin uniquement) */
  subscribed?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<TagConnection>;
  /** Types d'envoi dont le contact s'est désabonné (admin uniquement) */
  unsubscriptions?: Maybe<Array<CustomerUnsubscription>>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendor: Vendor;
  zip?: Maybe<Scalars['String']>;
};


/** An Customer */
export type CustomerDesiresArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Customer */
export type CustomerItemCategoriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Customer */
export type CustomerItemSubCategoriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Customer */
export type CustomerTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Customer. */
export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Customer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Contact joignable par email ou non (état de l'email) */
export enum CustomerContactStatusEnum {
  /** Email valide : le contact reçoit les newsletters */
  Sendable = 'SENDABLE',
  /** Email en hard-bounce, spam ou désabonné */
  Blocked = 'BLOCKED'
}

/** Chiffres clés des contacts (customers dédupliqués par email) */
export type CustomerContactsSummary = {
  __typename?: 'CustomerContactsSummary';
  /** Hard-bounce, spam ou désabonnés */
  blockedCount: Scalars['Int'];
  /** Joignables, jamais acheté, au moins N newsletters reçues */
  dormantCount: Scalars['Int'];
  emailStates: Array<EmailStateCount>;
  /** Joignables qui ouvrent nos newsletters mais n'ont jamais acheté */
  engagedNeverBoughtCount: Scalars['Int'];
  /** subscribed = false mais encore joignables par la newsletter */
  flaggedUnsubscribedCount: Scalars['Int'];
  /** Joignables ayant reçu au moins N newsletters sans en ouvrir aucune */
  neverOpenedCount: Scalars['Int'];
  /** Adresses désabonnées des newsletters de ventes */
  salesUnsubscribedCount: Scalars['Int'];
  sendableCount: Scalars['Int'];
  sendableNeverBoughtCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  /** Adresses désabonnées du mail du dimanche */
  weeklyUnsubscribedCount: Scalars['Int'];
  /** Contacts avec au moins un desiderata actif */
  withDesiresCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CustomerEdge = {
  __typename?: 'CustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Customer>;
};

/** Contact ayant déjà ouvert une newsletter ou jamais */
export enum CustomerEngagementEnum {
  /** Au moins une newsletter ouverte */
  Opened = 'OPENED',
  /** Aucune newsletter ouverte */
  NeverOpened = 'NEVER_OPENED'
}

export type CustomerFilter = {
  OR?: Maybe<Array<CustomerFilter>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
};

/** A Customer Item Category */
export type CustomerItemCategory = Node & {
  __typename?: 'CustomerItemCategory';
  customerItemSubCategories: CustomerItemSubCategoryConnection;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
};


/** A Customer Item Category */
export type CustomerItemCategoryCustomerItemSubCategoriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for CustomerItemCategory. */
export type CustomerItemCategoryConnection = {
  __typename?: 'CustomerItemCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerItemCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CustomerItemCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CustomerItemCategoryEdge = {
  __typename?: 'CustomerItemCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CustomerItemCategory>;
};

/** An Customer Sub Item Category */
export type CustomerItemSubCategory = Node & {
  __typename?: 'CustomerItemSubCategory';
  id: Scalars['ID'];
  itemCategory?: Maybe<CustomerItemCategory>;
  name?: Maybe<Scalars['String']>;
};

/** The connection type for CustomerItemSubCategory. */
export type CustomerItemSubCategoryConnection = {
  __typename?: 'CustomerItemSubCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerItemSubCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CustomerItemSubCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CustomerItemSubCategoryEdge = {
  __typename?: 'CustomerItemSubCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CustomerItemSubCategory>;
};

/** Origine d'un enregistrement customer (import) */
export type CustomerOrigin = {
  __typename?: 'CustomerOrigin';
  createdAt: Scalars['ISO8601DateTime'];
  importFilename?: Maybe<Scalars['String']>;
};

/** Statistiques d'un contact (tous les enregistrements ayant le même email) */
export type CustomerStats = {
  __typename?: 'CustomerStats';
  activeDesiresCount: Scalars['Int'];
  desiresCount: Scalars['Int'];
  lastClickedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastNewsletterAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastOpenedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Acheteur correspondant (lien direct ou même email) */
  matchedBuyer?: Maybe<Buyer>;
  /** Newsletters dont un lien a été cliqué */
  newslettersClickedCount: Scalars['Int'];
  /** Newsletters ouvertes */
  newslettersOpenedCount: Scalars['Int'];
  newslettersReceivedCount: Scalars['Int'];
  /** Commandes payées de l'acheteur correspondant */
  ordersCount: Scalars['Int'];
  /** Nombre d'enregistrements customer avec cet email */
  recordsCount: Scalars['Int'];
  totalSpent: Scalars['Float'];
};

/** Désabonnement d'un contact à un type d'envoi */
export type CustomerUnsubscription = {
  __typename?: 'CustomerUnsubscription';
  createdAt: Scalars['ISO8601DateTime'];
  kind: CustomerUnsubscriptionKindEnum;
  /** link (lien du mail) ou backfill (reprise de l'existant) */
  source: Scalars['String'];
};

/** Type d'envoi dont une personne peut se désabonner */
export enum CustomerUnsubscriptionKindEnum {
  /** Newsletters de ventes (début de vente, clôture imminente) */
  SalesNewsletter = 'SALES_NEWSLETTER',
  /** Mail du dimanche (ventes de la semaine) */
  WeeklyCalendar = 'WEEKLY_CALENDAR'
}

/** Pickup hours configured for one weekday */
export type Day = {
  __typename?: 'Day';
  /** Configured weekday */
  day: WeekdayEnum;
  /** Configured pickup time ranges */
  timeRanges: Array<TimeRange>;
};

/** Pickup hours configured for one weekday */
export type DayInput = {
  /** Configured weekday */
  day: WeekdayEnum;
  /** Time ranges configured for this weekday */
  timeRanges: Array<TimeRangeInput>;
};

/** Attributes to delete an Artist. */
export type DeleteArtistInput = {
  /** id */
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteUser */
export type DeleteUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** A DepositSlip */
export type DepositSlip = Node & {
  __typename?: 'DepositSlip';
  createdAt: Scalars['ISO8601DateTime'];
  document?: Maybe<CustomFile>;
  id: Scalars['ID'];
  items?: Maybe<ItemConnection>;
  nbItems?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendor?: Maybe<Vendor>;
};


/** A DepositSlip */
export type DepositSlipItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for DepositSlip. */
export type DepositSlipConnection = {
  __typename?: 'DepositSlipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DepositSlipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DepositSlip>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DepositSlipEdge = {
  __typename?: 'DepositSlipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DepositSlip>;
};

export type DepositSlipFilter = {
  OR?: Maybe<Array<DepositSlipFilter>>;
  id?: Maybe<OperatorIdFilter>;
  meta?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  vendor?: Maybe<VendorFilter>;
};

/** A Desire */
export type Desire = Node & {
  __typename?: 'Desire';
  active: Scalars['Boolean'];
  /** Alertes envoyées (hors mode test), plus récentes en premier (admin uniquement) */
  alerts?: Maybe<Array<DesireAlert>>;
  /** Nombre d'alertes réellement envoyées pour ce desiderata (hors mode test) */
  alertsSentCount: Scalars['Int'];
  buyer?: Maybe<Buyer>;
  createdAt: Scalars['ISO8601DateTime'];
  customer?: Maybe<Customer>;
  id: Scalars['ID'];
  /** Date de la dernière alerte envoyée (hors mode test) */
  lastAlertSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Mots retenus dans le titre pour chercher les objets (sans les mots vides ni génériques) */
  matchingWords: Array<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  searchArtistsEnabled: Scalars['Boolean'];
  searchDescriptionEnabled: Scalars['Boolean'];
  searchTagsEnabled: Scalars['Boolean'];
  searchTitleEnabled: Scalars['Boolean'];
  tags?: Maybe<TagConnection>;
  title: Scalars['String'];
  /**
   * Pourquoi ce désidérata ne pourra jamais déclencher d'alerte (nil s'il est
   * exploitable) : no_words, generic_only ou too_short
   */
  unusableReason?: Maybe<Scalars['String']>;
  /** Explication en français de unusable_reason */
  unusableReasonLabel?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  /** Faux si le titre ne permet aucune alerte (« non exploitable ») */
  usable: Scalars['Boolean'];
  validated: Scalars['Boolean'];
};


/** A Desire */
export type DesireTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Une alerte desiderata envoyée pour une vente */
export type DesireAlert = {
  __typename?: 'DesireAlert';
  clicksCount: Scalars['Int'];
  /** Premier clic */
  firstClickedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  itemCount: Scalars['Int'];
  /** Objets proposés dans cette alerte */
  items: Array<AlertItem>;
  /** Première ouverture */
  openedAt?: Maybe<Scalars['ISO8601DateTime']>;
  opensCount: Scalars['Int'];
  sale?: Maybe<Sale>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** sent, soft_bounce, hard_bounce, rejected, spam, unsub */
  state: Scalars['String'];
};

/** Les alertes desiderata envoyées en production pour une vente, avec leurs totaux */
export type DesireAlertSale = {
  __typename?: 'DesireAlertSale';
  /** Desiderata alertés (un mail par desiderata) */
  desiresCount: Scalars['Int'];
  firstSentAt: Scalars['ISO8601DateTime'];
  /** Objets proposés, tous mails confondus */
  itemsCount: Scalars['Int'];
  sale?: Maybe<Sale>;
  stats: NewsletterStats;
};

/** Totaux des alertes desiderata envoyées en production sur une période */
export type DesireAlertSummary = {
  __typename?: 'DesireAlertSummary';
  /** Desiderata différents alertés */
  desiresCount: Scalars['Int'];
  /** Objets proposés, tous mails confondus */
  itemsCount: Scalars['Int'];
  /** Ventes concernées */
  salesCount: Scalars['Int'];
  stats: NewsletterStats;
};

/** The connection type for Desire. */
export type DesireConnection = {
  __typename?: 'DesireConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DesireEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Desire>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DesireEdge = {
  __typename?: 'DesireEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Desire>;
};

export type DesireFilter = {
  OR?: Maybe<Array<DesireFilter>>;
  meta?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  validated?: Maybe<OperatorBooleanFilter>;
};

/** Autogenerated input type of DestroyCustomerMutation */
export type DestroyCustomerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyCustomerMutation. */
export type DestroyCustomerMutationPayload = {
  __typename?: 'DestroyCustomerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<ValidationErrors>;
};

/** Autogenerated input type of DestroyDesireMutation */
export type DestroyDesireMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyDesireMutation. */
export type DestroyDesireMutationPayload = {
  __typename?: 'DestroyDesireMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  desire?: Maybe<Desire>;
  errors?: Maybe<ValidationErrors>;
};

/** Autogenerated input type of DestroyItemCategoryMutation */
export type DestroyItemCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyItemCategoryMutation. */
export type DestroyItemCategoryMutationPayload = {
  __typename?: 'DestroyItemCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of DestroyItemMutation */
export type DestroyItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyItemMutation. */
export type DestroyItemMutationPayload = {
  __typename?: 'DestroyItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  item?: Maybe<Item>;
};

/** Autogenerated input type of DestroyItemSubCategoryMutation */
export type DestroyItemSubCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyItemSubCategoryMutation. */
export type DestroyItemSubCategoryMutationPayload = {
  __typename?: 'DestroyItemSubCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of DestroyProjectFeeMutation */
export type DestroyProjectFeeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyProjectFeeMutation. */
export type DestroyProjectFeeMutationPayload = {
  __typename?: 'DestroyProjectFeeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  projectFee?: Maybe<ProjectFee>;
};

/** Autogenerated input type of DestroyQuickTextMutation */
export type DestroyQuickTextMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyQuickTextMutation. */
export type DestroyQuickTextMutationPayload = {
  __typename?: 'DestroyQuickTextMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  quickText?: Maybe<QuickText>;
};

/** Autogenerated input type of DestroySaleMutation */
export type DestroySaleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroySaleMutation. */
export type DestroySaleMutationPayload = {
  __typename?: 'DestroySaleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sale?: Maybe<Sale>;
};

/** Autogenerated input type of DestroyTagMutation */
export type DestroyTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyTagMutation. */
export type DestroyTagMutationPayload = {
  __typename?: 'DestroyTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  tag?: Maybe<Tag>;
};

/** Autogenerated input type of DestroyVacationMutation */
export type DestroyVacationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyVacationMutation. */
export type DestroyVacationMutationPayload = {
  __typename?: 'DestroyVacationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  vacation?: Maybe<Vacation>;
};

/** Autogenerated input type of DestroyVendorAddressMutation */
export type DestroyVendorAddressMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Vendor address identifier */
  id: Scalars['ID'];
};

/** Autogenerated return type of DestroyVendorAddressMutation. */
export type DestroyVendorAddressMutationPayload = {
  __typename?: 'DestroyVendorAddressMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Identifier of the deleted vendor address */
  deletedAddressId?: Maybe<Scalars['ID']>;
  /** Validation errors */
  errors?: Maybe<ValidationErrors>;
};

export type DocumentsByActor = {
  __typename?: 'DocumentsByActor';
  businessIntroducer?: Maybe<Array<CustomFile>>;
  thirdPartyIntroducer?: Maybe<Array<CustomFile>>;
  vendor?: Maybe<Array<CustomFile>>;
};

/** A DodecadeStatementPayment */
export type DodecadeStatementPayment = Node & {
  __typename?: 'DodecadeStatementPayment';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  monthlyVendorPayment?: Maybe<MonthlyVendorPayment>;
  paid: Scalars['Boolean'];
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  periodEndAt?: Maybe<Scalars['ISO8601DateTime']>;
  periodStartAt?: Maybe<Scalars['ISO8601DateTime']>;
  stripePaidOutAt?: Maybe<Scalars['ISO8601DateTime']>;
  stripePayoutId?: Maybe<Scalars['String']>;
  stripePayoutMode?: Maybe<Scalars['String']>;
  stripePayoutStatus?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalPlatformFee?: Maybe<Scalars['Float']>;
  totalVendorAmount?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendorStatementPayments?: Maybe<VendorStatementPaymentConnection>;
};


/** A DodecadeStatementPayment */
export type DodecadeStatementPaymentVendorStatementPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for DodecadeStatementPayment. */
export type DodecadeStatementPaymentConnection = {
  __typename?: 'DodecadeStatementPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DodecadeStatementPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DodecadeStatementPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DodecadeStatementPaymentEdge = {
  __typename?: 'DodecadeStatementPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DodecadeStatementPayment>;
};

export type DodecadeStatementPaymentFilter = {
  OR?: Maybe<Array<DodecadeStatementPaymentFilter>>;
  paid?: Maybe<Scalars['Boolean']>;
  stripePayoutStatus?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DuplicateItemMutation */
export type DuplicateItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DuplicateItemMutation. */
export type DuplicateItemMutationPayload = {
  __typename?: 'DuplicateItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  item: Item;
};

export type EmailStateCount = {
  __typename?: 'EmailStateCount';
  count: Scalars['Int'];
  state: Scalars['String'];
};

/** Deliverability state of an email address */
export enum EmailStateEnum {
  Valid = 'VALID',
  SoftBounce = 'SOFT_BOUNCE',
  HardBounce = 'HARD_BOUNCE',
  Spam = 'SPAM',
  Unsubscribed = 'UNSUBSCRIBED'
}

/** A Engraving */
export type Engraving = Node & {
  __typename?: 'Engraving';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Form error */
export type Error = {
  __typename?: 'Error';
  /** Error details */
  details?: Maybe<Scalars['JSON']>;
  /** Field of the error */
  field: Scalars['String'];
  /** Error message */
  message: Scalars['String'];
};

export type ExcludedOrderInfo = {
  __typename?: 'ExcludedOrderInfo';
  id: Scalars['ID'];
  orderNumber: Scalars['String'];
  removedItemsCount: Scalars['Int'];
  returnedItemsCount: Scalars['Int'];
  state: Scalars['String'];
  totalAmount: Scalars['Float'];
};

export type ExcludedOrdersStats = {
  __typename?: 'ExcludedOrdersStats';
  count: Scalars['Int'];
  orders: Array<ExcludedOrderInfo>;
  totalAmount: Scalars['Float'];
};

/** An Expert */
export type Expert = Node & {
  __typename?: 'Expert';
  account: Account;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  externalRainworxId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<ItemConnection>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** An Expert */
export type ExpertItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Expert. */
export type ExpertConnection = {
  __typename?: 'ExpertConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ExpertEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Expert>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ExpertEdge = {
  __typename?: 'ExpertEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Expert>;
};

export type ExpertFilter = {
  OR?: Maybe<Array<ExpertFilter>>;
  account?: Maybe<AccountFilter>;
  description?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
};

/** A ExpertPayment */
export type ExpertPayment = Node & {
  __typename?: 'ExpertPayment';
  createdAt: Scalars['ISO8601DateTime'];
  endAt: Scalars['ISO8601DateTime'];
  expert?: Maybe<Expert>;
  expertPaymentLines?: Maybe<ExpertPaymentLineConnection>;
  expertStatementPayment?: Maybe<ExpertStatementPayment>;
  /** ID of the object. */
  id: Scalars['ID'];
  invoices?: Maybe<Array<CustomFile>>;
  lockedAt?: Maybe<Scalars['ISO8601DateTime']>;
  orderItems?: Maybe<OrderItemConnection>;
  paid?: Maybe<Scalars['Boolean']>;
  sale?: Maybe<Sale>;
  startAt: Scalars['ISO8601DateTime'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A ExpertPayment */
export type ExpertPaymentExpertPaymentLinesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A ExpertPayment */
export type ExpertPaymentOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ExpertPayment. */
export type ExpertPaymentConnection = {
  __typename?: 'ExpertPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ExpertPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ExpertPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ExpertPaymentEdge = {
  __typename?: 'ExpertPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ExpertPayment>;
};

export type ExpertPaymentFilter = {
  OR?: Maybe<Array<ExpertPaymentFilter>>;
  meta?: Maybe<Scalars['String']>;
  paid?: Maybe<OperatorBooleanFilter>;
  expertStatementPaymentId?: Maybe<OperatorIdFilter>;
  id?: Maybe<Scalars['ID']>;
};

/** A ExpertPaymentLine */
export type ExpertPaymentLine = Node & {
  __typename?: 'ExpertPaymentLine';
  amount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['ISO8601DateTime'];
  /** ID of the object. */
  id: Scalars['ID'];
  orderItems?: Maybe<OrderItemConnection>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A ExpertPaymentLine */
export type ExpertPaymentLineOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ExpertPaymentLine. */
export type ExpertPaymentLineConnection = {
  __typename?: 'ExpertPaymentLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ExpertPaymentLineEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ExpertPaymentLine>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ExpertPaymentLineEdge = {
  __typename?: 'ExpertPaymentLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ExpertPaymentLine>;
};

/** A ExpertStatementPayment */
export type ExpertStatementPayment = Node & {
  __typename?: 'ExpertStatementPayment';
  createdAt: Scalars['ISO8601DateTime'];
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  expert?: Maybe<Expert>;
  expertPayments?: Maybe<ExpertPaymentConnection>;
  id: Scalars['ID'];
  invoices?: Maybe<Array<CustomFile>>;
  paid: Scalars['Boolean'];
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  totalAmount: Scalars['Float'];
  totalLinesCount: Scalars['Int'];
  totalSalesCount: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A ExpertStatementPayment */
export type ExpertStatementPaymentExpertPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ExpertStatementPayment. */
export type ExpertStatementPaymentConnection = {
  __typename?: 'ExpertStatementPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ExpertStatementPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ExpertStatementPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ExpertStatementPaymentEdge = {
  __typename?: 'ExpertStatementPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ExpertStatementPayment>;
};

export type ExpertStatementPaymentFilter = {
  OR?: Maybe<Array<ExpertStatementPaymentFilter>>;
  id?: Maybe<Scalars['ID']>;
  meta?: Maybe<Scalars['String']>;
  paid?: Maybe<OperatorBooleanFilter>;
  expertId?: Maybe<Scalars['ID']>;
};

/** A FashionLuxuryAccessory */
export type FashionLuxuryAccessory = Node & {
  __typename?: 'FashionLuxuryAccessory';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A Favorite */
export type Favorite = Node & {
  __typename?: 'Favorite';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  /** L'acheteur a acheté (et payé) cet objet */
  purchased: Scalars['Boolean'];
};

/** The connection type for Favorite. */
export type FavoriteConnection = {
  __typename?: 'FavoriteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FavoriteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Favorite>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type FavoriteEdge = {
  __typename?: 'FavoriteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Favorite>;
};

/** Autogenerated return type of ForgotPassword. */
export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  errors: Array<Error>;
  success: Scalars['Boolean'];
  valid: Scalars['Boolean'];
};

/** A Furniture */
export type Furniture = Node & {
  __typename?: 'Furniture';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of GenerateVendorAccountingExportMutation */
export type GenerateVendorAccountingExportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dateBasis?: Maybe<VendorAccountingExportDateBasisEnum>;
  email?: Maybe<Scalars['String']>;
  endDate: Scalars['ISO8601DateTime'];
  startDate: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of GenerateVendorAccountingExportMutation. */
export type GenerateVendorAccountingExportPayload = {
  __typename?: 'GenerateVendorAccountingExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  enqueued: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
};

/** A GeographicMap */
export type GeographicMap = Node & {
  __typename?: 'GeographicMap';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type GraphqlAuth = {
  forgotPassword?: Maybe<ForgotPasswordPayload>;
  lockAccount?: Maybe<LockAccountPayload>;
  resendConfirmationInstructions?: Maybe<ResendConfirmationInstructionsPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  signIn?: Maybe<SignInPayload>;
  signUp?: Maybe<SignUpPayload>;
  unlockAccount?: Maybe<UnlockAccountPayload>;
  updateAccount?: Maybe<UpdateAccountPayload>;
  validateToken?: Maybe<ValidateTokenPayload>;
};


export type GraphqlAuthForgotPasswordArgs = {
  email: Scalars['String'];
};


export type GraphqlAuthLockAccountArgs = {
  id: Scalars['ID'];
};


export type GraphqlAuthResendConfirmationInstructionsArgs = {
  email: Scalars['String'];
};


export type GraphqlAuthResetPasswordArgs = {
  resetPasswordToken: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type GraphqlAuthSignInArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  rememberMe?: Maybe<Scalars['Boolean']>;
};


export type GraphqlAuthSignUpArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type GraphqlAuthUnlockAccountArgs = {
  id: Scalars['ID'];
};


export type GraphqlAuthUpdateAccountArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};



/** Image Type */
export type Image = {
  __typename?: 'Image';
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  rotation?: Maybe<Scalars['Int']>;
};

/** A Import of Volume */
export type Import = Node & {
  __typename?: 'Import';
  createdAt: Scalars['ISO8601DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Import. */
export type ImportConnection = {
  __typename?: 'ImportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ImportEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Import>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ImportEdge = {
  __typename?: 'ImportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Import>;
};

export type ImportFilter = {
  OR?: Maybe<Array<ImportFilter>>;
  filename?: Maybe<Scalars['String']>;
};

/** A ImportPayment */
export type ImportPayment = Node & {
  __typename?: 'ImportPayment';
  account?: Maybe<Account>;
  createdAt: Scalars['ISO8601DateTime'];
  endAt: Scalars['ISO8601DateTime'];
  /** ID of the object. */
  id: Scalars['ID'];
  import?: Maybe<Import>;
  importPaymentLines?: Maybe<ImportPaymentLineConnection>;
  importStatementPayment?: Maybe<ImportStatementPayment>;
  lockedAt?: Maybe<Scalars['ISO8601DateTime']>;
  orderItems?: Maybe<OrderItemConnection>;
  paid?: Maybe<Scalars['Boolean']>;
  sale?: Maybe<Sale>;
  startAt: Scalars['ISO8601DateTime'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A ImportPayment */
export type ImportPaymentImportPaymentLinesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A ImportPayment */
export type ImportPaymentOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ImportPayment. */
export type ImportPaymentConnection = {
  __typename?: 'ImportPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ImportPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ImportPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ImportPaymentEdge = {
  __typename?: 'ImportPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ImportPayment>;
};

export type ImportPaymentFilter = {
  OR?: Maybe<Array<ImportPaymentFilter>>;
  meta?: Maybe<Scalars['String']>;
  paid?: Maybe<OperatorBooleanFilter>;
  importStatementPaymentId?: Maybe<OperatorIdFilter>;
  id?: Maybe<Scalars['ID']>;
};

export type ImportPaymentLine = Node & {
  __typename?: 'ImportPaymentLine';
  amount?: Maybe<Scalars['Float']>;
  buyer?: Maybe<Buyer>;
  createdAt: Scalars['ISO8601DateTime'];
  feePercentage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  importPayment?: Maybe<ImportPayment>;
  orderItems?: Maybe<OrderItemConnection>;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type ImportPaymentLineOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ImportPaymentLine. */
export type ImportPaymentLineConnection = {
  __typename?: 'ImportPaymentLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ImportPaymentLineEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ImportPaymentLine>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ImportPaymentLineEdge = {
  __typename?: 'ImportPaymentLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ImportPaymentLine>;
};

/** A ImportStatementPayment */
export type ImportStatementPayment = Node & {
  __typename?: 'ImportStatementPayment';
  account?: Maybe<Account>;
  createdAt: Scalars['ISO8601DateTime'];
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  importPayments?: Maybe<ImportPaymentConnection>;
  invoices?: Maybe<Array<CustomFile>>;
  paid: Scalars['Boolean'];
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  totalAmount: Scalars['Float'];
  totalLinesCount: Scalars['Int'];
  totalSalesCount: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A ImportStatementPayment */
export type ImportStatementPaymentImportPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ImportStatementPayment. */
export type ImportStatementPaymentConnection = {
  __typename?: 'ImportStatementPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ImportStatementPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ImportStatementPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ImportStatementPaymentEdge = {
  __typename?: 'ImportStatementPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ImportStatementPayment>;
};

export type ImportStatementPaymentFilter = {
  OR?: Maybe<Array<ImportStatementPaymentFilter>>;
  accountId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  meta?: Maybe<Scalars['String']>;
  paid?: Maybe<OperatorBooleanFilter>;
};

/** An Item */
export type Item = Node & {
  __typename?: 'Item';
  artistCollectif?: Maybe<Scalars['Boolean']>;
  artistKnownButNotMentioned?: Maybe<Scalars['Boolean']>;
  artistUnknown?: Maybe<Scalars['Boolean']>;
  artists?: Maybe<ArtistConnection>;
  authenticityDocuments?: Maybe<Array<CustomFile>>;
  auto?: Maybe<Scalars['Boolean']>;
  autoDescription?: Maybe<Scalars['String']>;
  autoTags?: Maybe<TagConnection>;
  canBeRelisted: Scalars['Boolean'];
  catchPhrase?: Maybe<Scalars['String']>;
  catchPhraseEnabled?: Maybe<Scalars['Boolean']>;
  conditionAccepted?: Maybe<Scalars['Boolean']>;
  conditionsComment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  customDescription?: Maybe<Scalars['String']>;
  /** Enable the custom description */
  customDescriptionEnabled?: Maybe<Scalars['Boolean']>;
  /** first part of the sku, the second is generated automatically */
  customSkuPart?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateOption?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  depositSlip?: Maybe<DepositSlipConnection>;
  description?: Maybe<Scalars['String']>;
  descriptionFooter?: Maybe<Scalars['String']>;
  descriptionHeader?: Maybe<Scalars['String']>;
  descriptionSource?: Maybe<Scalars['String']>;
  descriptionSuggestion?: Maybe<Scalars['String']>;
  descriptionSuggestionGeneratedAt?: Maybe<Scalars['ISO8601DateTime']>;
  dodecadeItemRef?: Maybe<Scalars['Int']>;
  expert?: Maybe<Expert>;
  /** id of rainworx lot, we are using it to create the newsletter's item url  */
  externalRainworxId?: Maybe<Scalars['Int']>;
  finalPrice?: Maybe<Scalars['Float']>;
  firstImage?: Maybe<Image>;
  generationError?: Maybe<Scalars['String']>;
  generationStatus?: Maybe<Scalars['String']>;
  globalComment?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  highEstimatedPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  images?: Maybe<Array<Image>>;
  initialReservedPrice?: Maybe<Scalars['Float']>;
  initialStartingPrice?: Maybe<Scalars['Float']>;
  invoices?: Maybe<Array<CustomFile>>;
  /** is_library_fund_item */
  isLibraryFundItem?: Maybe<Scalars['Boolean']>;
  itemCategory?: Maybe<ItemCategory>;
  itemOrderHistories?: Maybe<Array<ItemOrderHistory>>;
  itemSaleHistories?: Maybe<Array<ItemSaleHistory>>;
  itemSteps?: Maybe<ItemStepConnection>;
  itemSubCategory?: Maybe<ItemSubCategory>;
  lastSaleEndedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastStartingPrice?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  locationKnownButNotMentioned?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Scalars['String']>;
  lot?: Maybe<Lot>;
  lowEstimatedPrice?: Maybe<Scalars['Float']>;
  mode: Scalars['String'];
  nextEligibleDate?: Maybe<Scalars['ISO8601DateTime']>;
  orderItem?: Maybe<OrderItem>;
  otherComment?: Maybe<Scalars['String']>;
  /** Vente CP pour laquelle l'objet est en préparation */
  plannedSale?: Maybe<Sale>;
  project?: Maybe<Project>;
  projectCounter?: Maybe<Scalars['Int']>;
  refusedAt?: Maybe<Scalars['ISO8601DateTime']>;
  resaleInfo?: Maybe<ItemResaleInfo>;
  resaleStatus?: Maybe<Scalars['String']>;
  reservedPrice?: Maybe<Scalars['Float']>;
  sale?: Maybe<Sale>;
  saleMandat?: Maybe<SaleMandatConnection>;
  salePassages: Array<ItemSalePassage>;
  /** Position manuelle du lot dans la vente */
  salePosition?: Maybe<Scalars['Int']>;
  saleTitle?: Maybe<Scalars['String']>;
  /** complete sku */
  sku?: Maybe<Scalars['String']>;
  soldAt?: Maybe<Scalars['ISO8601DateTime']>;
  startingPrice?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tags?: Maybe<TagConnection>;
  template: Template;
  templateId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  /** Weight of the whole item in kg: weight of one article x unit count */
  totalWeight?: Maybe<Scalars['Float']>;
  /** Number of identical articles the weight applies to (0 = not filled in) */
  unitCount: Scalars['Int'];
  unsoldCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  vacation?: Maybe<Vacation>;
  vendor?: Maybe<Vendor>;
  vendorActionDeadline?: Maybe<Scalars['ISO8601DateTime']>;
  vendorDecision?: Maybe<Scalars['String']>;
  vendorDecisionAt?: Maybe<Scalars['ISO8601DateTime']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  writer?: Maybe<Writer>;
  writerCommission?: Maybe<Scalars['Float']>;
};


/** An Item */
export type ItemArtistsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};


/** An Item */
export type ItemAutoTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Item */
export type ItemDepositSlipArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Item */
export type ItemImagesArgs = {
  first?: Maybe<Scalars['Int']>;
};


/** An Item */
export type ItemItemStepsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Item */
export type ItemSaleMandatArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Item */
export type ItemTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** An Item Category */
export type ItemCategory = Node & {
  __typename?: 'ItemCategory';
  aiGenerationAvailable: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  externalRainworxId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  itemSubCategories: ItemSubCategoryConnection;
  itemsCount: Scalars['Int'];
  maxImages: Scalars['Int'];
  minImages: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
};


/** An Item Category */
export type ItemCategoryItemSubCategoriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ItemCategory. */
export type ItemCategoryConnection = {
  __typename?: 'ItemCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ItemCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ItemCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ItemCategoryEdge = {
  __typename?: 'ItemCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ItemCategory>;
};

export type ItemCategoryFilter = {
  OR?: Maybe<Array<ItemCategoryFilter>>;
  archived?: Maybe<OperatorBooleanFilter>;
  id?: Maybe<OperatorIdFilter>;
  name?: Maybe<OperatorStringFilter>;
  templateType?: Maybe<OperatorStringFilter>;
  meta?: Maybe<Scalars['String']>;
};

/** The connection type for Item. */
export type ItemConnection = {
  __typename?: 'ItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Item>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ItemEdge = {
  __typename?: 'ItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Item>;
};

export type ItemFilter = {
  OR?: Maybe<Array<ItemFilter>>;
  acceptedAt?: Maybe<OperatorDateFilter>;
  artists?: Maybe<ArtistFilter>;
  autoDescription?: Maybe<OperatorStringFilter>;
  createdAt?: Maybe<OperatorDateFilter>;
  expert?: Maybe<ExpertFilter>;
  finalPrice?: Maybe<OperatorNumberFilter>;
  firstArtistLastName?: Maybe<OperatorStringFilter>;
  highEstimatedPrice?: Maybe<OperatorNumberFilter>;
  id?: Maybe<OperatorIdFilter>;
  initialStartingPrice?: Maybe<OperatorNumberFilter>;
  itemCategory?: Maybe<ItemCategoryFilter>;
  lastSaleEndedAt?: Maybe<OperatorDateFilter>;
  meta?: Maybe<Scalars['String']>;
  nextEligibleDate?: Maybe<OperatorDateFilter>;
  plannedSaleId?: Maybe<OperatorIdFilter>;
  project?: Maybe<ProjectFilter>;
  projectCounter?: Maybe<OperatorStringFilter>;
  projectId?: Maybe<OperatorIdFilter>;
  resaleStatus?: Maybe<Array<Scalars['String']>>;
  reservedPrice?: Maybe<OperatorNumberFilter>;
  saleId?: Maybe<OperatorIdFilter>;
  salePosition?: Maybe<OperatorNumberFilter>;
  sku?: Maybe<OperatorStringFilter>;
  startingPrice?: Maybe<OperatorNumberFilter>;
  state?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<OperatorStringFilter>;
  unsoldCount?: Maybe<OperatorNumberFilter>;
  vacationId?: Maybe<OperatorIdFilter>;
  vendor?: Maybe<VendorFilter>;
  vendorActionDeadline?: Maybe<OperatorDateFilter>;
  vendorDecision?: Maybe<OperatorStringFilter>;
  writer?: Maybe<WriterFilter>;
  writerId?: Maybe<OperatorIdFilter>;
};

export type ItemMovement = Node & {
  __typename?: 'ItemMovement';
  account?: Maybe<Account>;
  accountId: Scalars['ID'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  executedAt?: Maybe<Scalars['ISO8601DateTime']>;
  fromLocation: Scalars['String'];
  id: Scalars['ID'];
  itemMovementEntries?: Maybe<ItemMovementEntryConnection>;
  toLocation: Scalars['String'];
};


export type ItemMovementItemMovementEntriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ItemMovement. */
export type ItemMovementConnection = {
  __typename?: 'ItemMovementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ItemMovementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ItemMovement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ItemMovementEdge = {
  __typename?: 'ItemMovementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ItemMovement>;
};

export type ItemMovementEntry = Node & {
  __typename?: 'ItemMovementEntry';
  id: Scalars['ID'];
  item?: Maybe<Item>;
  itemId: Scalars['ID'];
  newSku: Scalars['String'];
  oldSku: Scalars['String'];
};

/** The connection type for ItemMovementEntry. */
export type ItemMovementEntryConnection = {
  __typename?: 'ItemMovementEntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ItemMovementEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ItemMovementEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ItemMovementEntryEdge = {
  __typename?: 'ItemMovementEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ItemMovementEntry>;
};

export type ItemMovementFilter = {
  OR?: Maybe<Array<ItemMovementFilter>>;
  fromLocation?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  toLocation?: Maybe<Scalars['String']>;
};

export type ItemOrderHistory = {
  __typename?: 'ItemOrderHistory';
  eventType: Scalars['String'];
  finalPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['ISO8601DateTime']>;
  orderId: Scalars['ID'];
  orderItemId: Scalars['ID'];
  saleId?: Maybe<Scalars['ID']>;
  startingPriceAtEvent?: Maybe<Scalars['Float']>;
  stateAtEvent?: Maybe<Scalars['String']>;
};

export type ItemOrderType = {
  /** The attribute you want to order by. */
  attribute: Scalars['String'];
  /** Set a direction with "asc" or "desc". */
  direction: Scalars['String'];
  nested?: Maybe<Array<ItemOrderType>>;
};

export type ItemResaleInfo = {
  __typename?: 'ItemResaleInfo';
  canRelist: Scalars['Boolean'];
  daysUntilEligible?: Maybe<Scalars['Int']>;
  discountPercentage?: Maybe<Scalars['Int']>;
  nextEligibleDate?: Maybe<Scalars['ISO8601DateTime']>;
  nextPrice?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  unsoldCount: Scalars['Int'];
};

export type ItemSaleHistory = {
  __typename?: 'ItemSaleHistory';
  attemptNumber: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  discountPercentage?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  eventType: Scalars['String'];
  externalRainworxId?: Maybe<Scalars['Int']>;
  finalPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  listedAt?: Maybe<Scalars['ISO8601DateTime']>;
  newState?: Maybe<Scalars['String']>;
  nextPrice?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  previousState?: Maybe<Scalars['String']>;
  sale?: Maybe<Sale>;
  saleExternalEventId?: Maybe<Scalars['Int']>;
  saleType?: Maybe<Scalars['String']>;
  startingPriceUsed?: Maybe<Scalars['Float']>;
  triggeredBy?: Maybe<Scalars['String']>;
  triggeredByUserId?: Maybe<Scalars['Int']>;
  triggeredByUserName?: Maybe<Scalars['String']>;
};

export type ItemSalePassage = {
  __typename?: 'ItemSalePassage';
  finalPrice?: Maybe<Scalars['Float']>;
  number: Scalars['Int'];
  result: Scalars['String'];
  sale?: Maybe<Sale>;
  startingPrice?: Maybe<Scalars['Float']>;
};

/** Item Steps */
export type ItemStep = Node & {
  __typename?: 'ItemStep';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item?: Maybe<Item>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ItemStep. */
export type ItemStepConnection = {
  __typename?: 'ItemStepConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ItemStepEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ItemStep>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ItemStepEdge = {
  __typename?: 'ItemStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ItemStep>;
};

/** An Sub Item Category */
export type ItemSubCategory = Node & {
  __typename?: 'ItemSubCategory';
  archived: Scalars['Boolean'];
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  externalRainworxId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  itemCategory?: Maybe<ItemCategory>;
  itemsCount: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

/** The connection type for ItemSubCategory. */
export type ItemSubCategoryConnection = {
  __typename?: 'ItemSubCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ItemSubCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ItemSubCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ItemSubCategoryEdge = {
  __typename?: 'ItemSubCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ItemSubCategory>;
};

export type ItemSubCategoryFilter = {
  OR?: Maybe<Array<ItemSubCategoryFilter>>;
  name?: Maybe<Scalars['String']>;
  templateType?: Maybe<Scalars['String']>;
  archived?: Maybe<OperatorBooleanFilter>;
  itemCategoryId?: Maybe<Scalars['String']>;
};

export type ItemsStats = {
  __typename?: 'ItemsStats';
  /** Prix remisé éligibles (admin) */
  adminDiscountedEligible: Scalars['Int'];
  /** Fond de bibliothèque éligibles (admin) */
  adminLibraryFundEligible: Scalars['Int'];
  /** Non éligibles (admin) */
  adminNotEligible: Scalars['Int'];
  /** Impayés éligibles (admin) */
  adminUnpaidEligible: Scalars['Int'];
  /** En cours de traitement */
  inProcessing: Scalars['Int'];
  /** En vente */
  onSale: Scalars['Int'];
  /** En vacances */
  onVacation: Scalars['Int'];
  /** Refusés */
  refused: Scalars['Int'];
  /** Supprimés */
  removed: Scalars['Int'];
  /** Actions requises */
  requiringVendorAction: Scalars['Int'];
  /** Restitués */
  returned: Scalars['Int'];
  /** Vendus */
  sold: Scalars['Int'];
  /** Total des items non archivés */
  total: Scalars['Int'];
  /** Impayés */
  unpaid: Scalars['Int'];
  /** Invendus */
  unsold: Scalars['Int'];
};


/** A Jewelry */
export type Jewelry = Node & {
  __typename?: 'Jewelry';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A Label */
export type Label = Node & {
  __typename?: 'Label';
  carrierName?: Maybe<Scalars['String']>;
  cn23Document?: Maybe<CustomFile>;
  cn23Explanation?: Maybe<Scalars['String']>;
  cn23Url?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  externalLabelUrl?: Maybe<Scalars['String']>;
  /** ID of the object. */
  id: Scalars['ID'];
  item: Item;
  labelDocument?: Maybe<CustomFile>;
  lastAttemptAt?: Maybe<Scalars['ISO8601DateTime']>;
  orderItems?: Maybe<Array<OrderItem>>;
  status?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  undeplusRef?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
  weight?: Maybe<Scalars['String']>;
};

/** The connection type for Label. */
export type LabelConnection = {
  __typename?: 'LabelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LabelEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Label>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type LabelEdge = {
  __typename?: 'LabelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Label>;
};

export type LabelFilter = {
  OR?: Maybe<Array<LabelFilter>>;
  meta?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<OperatorStringFilter>;
};

export type LinkInput = {
  id?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of LockAccount. */
export type LockAccountPayload = {
  __typename?: 'LockAccountPayload';
  errors: Array<Error>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** A Lot */
export type Lot = Node & {
  __typename?: 'Lot';
  createdAt: Scalars['ISO8601DateTime'];
  expert?: Maybe<Expert>;
  id: Scalars['ID'];
  items?: Maybe<ItemConnection>;
  updatedAt: Scalars['ISO8601DateTime'];
  vacation?: Maybe<Vacation>;
  vendor: Vendor;
};


/** A Lot */
export type LotItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Lot. */
export type LotConnection = {
  __typename?: 'LotConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LotEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Lot>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type LotEdge = {
  __typename?: 'LotEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Lot>;
};

/** A Manuscript */
export type Manuscript = Node & {
  __typename?: 'Manuscript';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of MarkDesiresReviewedMutation */
export type MarkDesiresReviewedMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  buyerId?: Maybe<Scalars['ID']>;
  customerId?: Maybe<Scalars['ID']>;
  reviewed?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of MarkDesiresReviewedMutation. */
export type MarkDesiresReviewedMutationPayload = {
  __typename?: 'MarkDesiresReviewedMutationPayload';
  buyer?: Maybe<Buyer>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  errors: Array<Scalars['String']>;
};

/** Attributes to update a Tag. */
export type MergeTagInput = {
  /** merge the id tag to the tagToId */
  tagToId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of MergeTagMutation */
export type MergeTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: MergeTagInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of MergeTagMutation. */
export type MergeTagMutationPayload = {
  __typename?: 'MergeTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  tag?: Maybe<Tag>;
};

/** Analytics metrics that can be requested by the frontend. */
export enum MetricNameEnum {
  /** Gross merchandise value: SUM(order_items.total_price). */
  Gmv = 'GMV',
  /** Count of order items grouped by order_items.state. */
  CountByState = 'COUNT_BY_STATE',
  /** Dodécade margin from prorated buyer fees and vendor fee percentages. */
  DodecadeMargin = 'DODECADE_MARGIN',
  /** Revenue decomposition into items total, buyer fee, shipping, and insurance. */
  RevenueBreakdown = 'REVENUE_BREAKDOWN',
  /** Dodécade margin divided by GMV, expressed as a percentage. */
  TakeRate = 'TAKE_RATE',
  /** Average order_items.total_price. */
  AvgSalePrice = 'AVG_SALE_PRICE',
  /** Shipping and insurance collected, with a placeholder for actual cost. */
  ShippingInsuranceCollected = 'SHIPPING_INSURANCE_COLLECTED',
  /** Top vendors ordered by GMV, with concentration, commission rate, and generated margin. */
  TopVendors = 'TOP_VENDORS',
  /** Revenue grouped by item category. */
  RevenueByCategory = 'REVENUE_BY_CATEGORY',
  /**
   * Percentage of auctions concluded in the period (sold + unsold) that ended
   * unsold. Only available since the state history exists.
   */
  UnsoldRate = 'UNSOLD_RATE',
  /**
   * Percentage of order lines placed in the period that ended definitively unpaid
   * (canceled for non-payment or unpaid after 60 days).
   */
  UnpaidRate = 'UNPAID_RATE',
  /**
   * Percentage of auctions concluded in the period (sold + unsold) that ended
   * sold. Only available since the state history exists.
   */
  SaleRate = 'SALE_RATE',
  /** Average realized price versus estimation midpoint ratio (in percent). */
  PriceVsEstimation = 'PRICE_VS_ESTIMATION',
  /** Average realized price versus starting price ratio (in percent). */
  StartingVsRealized = 'STARTING_VS_REALIZED',
  /** Average estimation low/high, starting, realized, and estimation ratio grouped by category. */
  PriceDetailByCategory = 'PRICE_DETAIL_BY_CATEGORY',
  /** Category leaderboard with GMV and sale rate, sorted by sale rate then GMV. */
  BestCategory = 'BEST_CATEGORY',
  /** Dodécade margin scoped to vendor performance analytics. */
  VendorMargin = 'VENDOR_MARGIN',
  /** Top 10 vendor comparison leaderboard with GMV, sale rate, estimation ratio, and margin. */
  VendorComparison = 'VENDOR_COMPARISON',
  /** Funnel counts and stage-to-stage rates from waitingExpertise to sold downstream states. */
  Funnel = 'FUNNEL',
  /** Average delays (in days) across funnel transitions: waiting->accepted, accepted->onSale, onSale->sold. */
  StageDelays = 'STAGE_DELAYS',
  /** Average end-to-end delay in days from waitingExpertise to paid date for sold items. */
  EndToEndDelay = 'END_TO_END_DELAY',
  /** Refusal rate at expertise decision stage (refused over refused+accepted path). */
  RefusalRate = 'REFUSAL_RATE',
  /** Acceptance rate at expertise decision stage (accepted path over refused+accepted path). */
  AcceptanceRate = 'ACCEPTANCE_RATE',
  /** Nombre d'items ayant atteint une décision d'expertise sur la période. */
  ExpertVolume = 'EXPERT_VOLUME',
  /** Délai moyen de traitement expertise en jours entre waiting_expertise_at et accepted_at. */
  AvgProcessingDelay = 'AVG_PROCESSING_DELAY',
  /** Taux de refus par expert sur les items arrivés à une décision d'expertise. */
  ExpertRefusalRate = 'EXPERT_REFUSAL_RATE',
  /** Taux d'acceptation par expert sur les items arrivés à une décision d'expertise. */
  ExpertAcceptanceRate = 'EXPERT_ACCEPTANCE_RATE',
  /** Charge actuelle instantanée par expert sur les items underExpertise et needUpdate, avec moyenne d'équipe. */
  ExpertCurrentLoad = 'EXPERT_CURRENT_LOAD',
  /** Taux de vente aval des items acceptés par l'expert. */
  ExpertQualityLoop = 'EXPERT_QUALITY_LOOP',
  /** Volume rédacteur avec délai moyen de rédaction exploitable et taux de renvoi en needUpdate. */
  WriterVolume = 'WRITER_VOLUME',
  /** Performance aval des fiches d'un rédacteur: sale rate, GMV, prix moyen et ratio marteau/estimation. */
  WriterDownstream = 'WRITER_DOWNSTREAM',
  /**
   * Conversion des items dont la vente est terminée (vendus, invendus, impayés,
   * retournés) vers un état vendu; les items encore onSale sont exclus.
   */
  OnsaleToSoldRate = 'ONSALE_TO_SOLD_RATE',
  /** Taux de vente par tentative (items.unsold_count), sur les items dont la vente est terminée uniquement. */
  SaleRateByAttempt = 'SALE_RATE_BY_ATTEMPT',
  /** Distribution of items by unsold_count buckets 0/1/2/3/>3. */
  UnsoldCountDistribution = 'UNSOLD_COUNT_DISTRIBUTION',
  /** Distribution of items by resale_status. */
  ResaleBreakdown = 'RESALE_BREAKDOWN'
}

/** Result for a single requested analytics metric. */
export type MetricResult = {
  __typename?: 'MetricResult';
  /** Optional grouped result when the breakdown argument is provided. */
  breakdown?: Maybe<Array<BreakdownResult>>;
  /** Optional previous-period or previous-year comparison when compareTo is not NONE. */
  comparison?: Maybe<Comparison>;
  /** Stable metric identifier, for example gmv or count_by_state. */
  name: Scalars['String'];
  /** Optional chronological result when the timeSeries argument is provided. */
  timeSeries?: Maybe<Array<TimeSeriesPoint>>;
  /** Main aggregated metric value. It can be a number for GMV or an object for grouped state counts. */
  value?: Maybe<Scalars['JSON']>;
};

/** A Militaria */
export type Militaria = Node & {
  __typename?: 'Militaria';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A MonthlyVendorPayment */
export type MonthlyVendorPayment = Node & {
  __typename?: 'MonthlyVendorPayment';
  createdAt: Scalars['ISO8601DateTime'];
  /** Montant du litige */
  disputeAmount?: Maybe<Scalars['Float']>;
  /** Indique si le paiement est en litige */
  disputed: Scalars['Boolean'];
  endAt: Scalars['ISO8601DateTime'];
  /** ID of the object. */
  id: Scalars['ID'];
  invoices?: Maybe<Array<CustomFile>>;
  lockedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Montant net à payer au vendeur */
  netAmount?: Maybe<Scalars['Float']>;
  orderItems?: Maybe<OrderItemConnection>;
  paid?: Maybe<Scalars['Boolean']>;
  /** Statistiques contextuelles de ce paiement */
  paymentStats?: Maybe<VendorPaymentStats>;
  sale?: Maybe<Sale>;
  startAt: Scalars['ISO8601DateTime'];
  /** Message d'erreur du transfert Stripe en cas d'échec */
  stripeTransferError?: Maybe<Scalars['String']>;
  /** ID du transfert Stripe associé (paiement manuel sans VSP) */
  stripeTransferId?: Maybe<Scalars['String']>;
  /** Mode du transfert Stripe (standard, express, manual) */
  stripeTransferMode?: Maybe<Scalars['String']>;
  /** Statut du transfert Stripe (pending, succeeded, failed) */
  stripeTransferStatus?: Maybe<Scalars['String']>;
  /** Date du transfert Stripe */
  stripeTransferredAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Total des déductions TTC */
  totalFees?: Maybe<Scalars['Float']>;
  /** Total des ventes */
  totalSales?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendor?: Maybe<Vendor>;
  /** Détail des déductions (fees) */
  vendorPaymentFees?: Maybe<VendorPaymentFeeConnection>;
  vendorPaymentLines?: Maybe<VendorPaymentLineConnection>;
  vendorStatementPayment?: Maybe<VendorStatementPayment>;
  vendorStatements?: Maybe<VendorStatementConnection>;
};


/** A MonthlyVendorPayment */
export type MonthlyVendorPaymentOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A MonthlyVendorPayment */
export type MonthlyVendorPaymentVendorPaymentFeesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A MonthlyVendorPayment */
export type MonthlyVendorPaymentVendorPaymentLinesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A MonthlyVendorPayment */
export type MonthlyVendorPaymentVendorStatementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for MonthlyVendorPayment. */
export type MonthlyVendorPaymentConnection = {
  __typename?: 'MonthlyVendorPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MonthlyVendorPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MonthlyVendorPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MonthlyVendorPaymentEdge = {
  __typename?: 'MonthlyVendorPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MonthlyVendorPayment>;
};

export type MonthlyVendorPaymentFilter = {
  OR?: Maybe<Array<MonthlyVendorPaymentFilter>>;
  meta?: Maybe<Scalars['String']>;
  paid?: Maybe<OperatorBooleanFilter>;
  id?: Maybe<Scalars['ID']>;
  vendorStatementPaymentId?: Maybe<OperatorIdFilter>;
};

/** Autogenerated input type of MoveItemsToVacationMutation */
export type MoveItemsToVacationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  itemIds: Array<Scalars['ID']>;
  saleId: Scalars['ID'];
  vacationId: Scalars['ID'];
};

/** Autogenerated return type of MoveItemsToVacationMutation. */
export type MoveItemsToVacationMutationPayload = {
  __typename?: 'MoveItemsToVacationMutationPayload';
  blockingItems: Array<Item>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  movedCount: Scalars['Int'];
  sale?: Maybe<Sale>;
  vacation?: Maybe<Vacation>;
};

export type Mutation = GraphqlAuth & {
  __typename?: 'Mutation';
  /** Archive an ItemCategory */
  archiveItemCategory?: Maybe<ArchiveItemCategoryMutationPayload>;
  /** Archive an ItemSubCategory */
  archiveItemSubCategory?: Maybe<ArchiveItemSubCategoryMutationPayload>;
  /** Bulk mark ExpertPayments as paid */
  bulkMarkExpertPaymentsAsPaid?: Maybe<BulkMarkExpertPaymentsAsPaidPayload>;
  /** Bulk mark ExpertStatementPayments as paid */
  bulkMarkExpertStatementPaymentsAsPaid?: Maybe<BulkMarkExpertStatementPaymentsAsPaidPayload>;
  /** Bulk mark ImportPayments as paid */
  bulkMarkImportPaymentsAsPaid?: Maybe<BulkMarkImportPaymentsAsPaidPayload>;
  /** Bulk mark ImportStatementPayments as paid */
  bulkMarkImportStatementPaymentsAsPaid?: Maybe<BulkMarkImportStatementPaymentsAsPaidPayload>;
  /** Bulk mark MonthlyVendorPayments as paid */
  bulkMarkMonthlyVendorPaymentsAsPaid?: Maybe<BulkMarkMonthlyVendorPaymentsAsPaidPayload>;
  /** Bulk mark ProjectIntroducerPayments as paid */
  bulkMarkProjectIntroducerPaymentsAsPaid?: Maybe<BulkMarkProjectIntroducerPaymentsAsPaidPayload>;
  /** Bulk mark VendorStatementPayments as paid */
  bulkMarkVendorStatementPaymentsAsPaid?: Maybe<BulkMarkVendorStatementPaymentsAsPaidPayload>;
  /** Bulk mark WriterPayments as paid */
  bulkMarkWriterPaymentsAsPaid?: Maybe<BulkMarkWriterPaymentsAsPaidPayload>;
  /** Bulk mark WriterStatementPayments as paid */
  bulkMarkWriterStatementPaymentsAsPaid?: Maybe<BulkMarkWriterStatementPaymentsAsPaidPayload>;
  bulkRelistItems?: Maybe<BulkRelistItemsMutationPayload>;
  bulkRemoveReturnedItems?: Maybe<BulkRemoveReturnedItemsMutationPayload>;
  bulkReturnItems?: Maybe<BulkReturnItemsMutationPayload>;
  /** Met à jour en masse les sale_position de plusieurs items */
  bulkUpdateSalePositions?: Maybe<BulkUpdateSalePositionsMutationPayload>;
  /** Create Account */
  createAccount?: Maybe<CreateAccountMutationPayload>;
  /** Create BankInformation */
  createBankInformation?: Maybe<CreateBankInformationMutationPayload>;
  /** Create A book */
  createBook?: Maybe<CreateBookMutationPayload>;
  /** Create Business Introducer */
  createBusinessIntroducer?: Maybe<CreateBusinessIntroducerMutationPayload>;
  /** Create A CarpetTextile */
  createCarpetTextile?: Maybe<CreateCarpetTextileMutationPayload>;
  /** Create A Ceramic */
  createCeramic?: Maybe<CreateCeramicMutationPayload>;
  /** Create CoinsMedalsStamps */
  createCoinsMedalsStamps?: Maybe<CreateCoinsMedalsStampsMutationPayload>;
  /** Create CP Import */
  createCpImport?: Maybe<CreateCpImportMutationPayload>;
  /** Create A Customer */
  createCustomer?: Maybe<CreateCustomerMutationPayload>;
  /** Create Desire */
  createDesire?: Maybe<CreateDesireMutationPayload>;
  /** Create Desires Import */
  createDesiresRainworxImport?: Maybe<CreateDesiresRainworxImportMutationPayload>;
  /** Create the drouot csv from the items */
  createDrouotExportCsv?: Maybe<CreateDrouotExportCsvMutationPayload>;
  /** Create Drouot Import */
  createDrouotImport?: Maybe<CreateDrouotImportMutationPayload>;
  /** Create A Engraving */
  createEngraving?: Maybe<CreateEngravingMutationPayload>;
  /** Create A FashionLuxuryAccessory */
  createFashionLuxuryAccessory?: Maybe<CreateFashionLuxuryAccessoryMutationPayload>;
  /** Create Favorites Import */
  createFavoritesRainworxImport?: Maybe<CreateFavoritesRainworxImportMutationPayload>;
  /** Create A Furniture */
  createFurniture?: Maybe<CreateFurnitureMutationPayload>;
  /** Create A GeographicMap */
  createGeographicMap?: Maybe<CreateGeographicMapMutationPayload>;
  /** Create A Import */
  createImport?: Maybe<CreateImportMutationPayload>;
  createItem?: Maybe<CreateItemMutationPayload>;
  /** Create an ItemCategory */
  createItemCategory?: Maybe<CreateItemCategoryMutationPayload>;
  createItemMovement?: Maybe<CreateItemMovementMutationPayload>;
  /** Create an ItemSubCategory */
  createItemSubCategory?: Maybe<CreateItemSubCategoryMutationPayload>;
  /** Create A Jewelry */
  createJewelry?: Maybe<CreateJewelryMutationPayload>;
  /** Create lot urls Import */
  createLotUrlsRainworxImport?: Maybe<CreateLotUrlsRainworxImportMutationPayload>;
  /** Create A Manuscript */
  createManuscript?: Maybe<CreateManuscriptMutationPayload>;
  /** Create A Militaria */
  createMilitaria?: Maybe<CreateMilitariaMutationPayload>;
  /** Import Desires from a MyAlerts CSV */
  createMyAlertsDesiresImport?: Maybe<CreateMyAlertsDesiresImportMutationPayload>;
  /** Create NewsLetter */
  createNewsLetter?: Maybe<CreateNewsLetterMutationPayload>;
  /** Create A PaintingSculpture */
  createPaintingSculpture?: Maybe<CreatePaintingSculptureMutationPayload>;
  /** Create A Photography */
  createPhotography?: Maybe<CreatePhotographyMutationPayload>;
  /** Update a Pickup Request */
  createPickupRequest?: Maybe<CreatePickupRequestMutationPayload>;
  /** Create Project */
  createProject?: Maybe<CreateProjectMutationPayload>;
  /** Create ProjectFee */
  createProjectFee?: Maybe<CreateProjectFeeMutationPayload>;
  /** Create QuickText */
  createQuickText?: Maybe<CreateQuickTextMutationPayload>;
  /** Create Sale */
  createSale?: Maybe<CreateSaleMutationPayload>;
  /** Create all sale mandat for the sale */
  createSaleMandats?: Maybe<CreateSaleMandatMutationPayload>;
  /** Create A SilverwareTableware */
  createSilverwareTableware?: Maybe<CreateSilverwareTablewareMutationPayload>;
  /** Create a Stripe Connect Account Session for embedded onboarding */
  createStripeAccountSession?: Maybe<CreateStripeAccountSessionMutationPayload>;
  /** Create ThirdPartys Introducer */
  createThirdPartyIntroducer?: Maybe<CreateThirdPartyIntroducerMutationPayload>;
  /** Create A ToyComicPopCulture */
  createToyComicPopCulture?: Maybe<CreateToyComicPopCultureMutationPayload>;
  /** Create unsold items Import */
  createUnsoldItemsRainworxImport?: Maybe<CreateUnsoldItemsRainworxImportMutationPayload>;
  /** Create Vacation */
  createVacation?: Maybe<CreateVacationMutationPayload>;
  /** Create an address for the current vendor */
  createVendorAddress?: Maybe<CreateVendorAddressMutationPayload>;
  /** Create A Watch */
  createWatch?: Maybe<CreateWatchMutationPayload>;
  customSignIn?: Maybe<CustomSignInPayload>;
  customSignUp?: Maybe<CustomSignUpPayload>;
  /** Update Account */
  customUpdateAccount?: Maybe<CustomUpdateAccountMutationPayload>;
  /** Deletes an user as an admin. */
  deleteUser?: Maybe<Scalars['Boolean']>;
  /** Destroy Customer */
  destroyCustomer?: Maybe<DestroyCustomerMutationPayload>;
  /** Destroy Desire */
  destroyDesire?: Maybe<DestroyDesireMutationPayload>;
  destroyItem?: Maybe<DestroyItemMutationPayload>;
  /** Destroy an ItemCategory */
  destroyItemCategory?: Maybe<DestroyItemCategoryMutationPayload>;
  /** Destroy an ItemSubCategory */
  destroyItemSubCategory?: Maybe<DestroyItemSubCategoryMutationPayload>;
  /** Destroy ProjectFee */
  destroyProjectFee?: Maybe<DestroyProjectFeeMutationPayload>;
  /** Destroy QuickText */
  destroyQuickText?: Maybe<DestroyQuickTextMutationPayload>;
  /** Destroy Sale */
  destroySale?: Maybe<DestroySaleMutationPayload>;
  /** Destroy Tag */
  destroyTag?: Maybe<DestroyTagMutationPayload>;
  /** Destroy Vacation */
  destroyVacation?: Maybe<DestroyVacationMutationPayload>;
  /** Delete an address belonging to the current vendor */
  destroyVendorAddress?: Maybe<DestroyVendorAddressMutationPayload>;
  duplicateItem?: Maybe<DuplicateItemMutationPayload>;
  forgotPassword?: Maybe<ForgotPasswordPayload>;
  /** Génère un export comptable vendeur au format XLSX */
  generateVendorAccountingExport?: Maybe<GenerateVendorAccountingExportPayload>;
  lockAccount?: Maybe<LockAccountPayload>;
  /** Mark the desires of a buyer or a contact as checked by an admin */
  markDesiresReviewed?: Maybe<MarkDesiresReviewedMutationPayload>;
  /** Merge 2 Tags */
  mergeTag?: Maybe<MergeTagMutationPayload>;
  /** Move items of a sale to a vacation and remove them from the sale */
  moveSaleItemsToVacation?: Maybe<MoveItemsToVacationMutationPayload>;
  /** Regenerate a failed shipping label */
  regenerateLabel?: Maybe<RegenerateLabelMutationPayload>;
  resendConfirmationInstructions?: Maybe<ResendConfirmationInstructionsPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  /** Rotate an image of an item, identified by its id (Image.id) */
  rotateImage?: Maybe<RotateImageMutationPayload>;
  /** Send late orders reminder email to vendor */
  sendLateOrdersReminder?: Maybe<SendLateOrdersReminderMutationPayload>;
  /** Send late pickups reminder email to vendor */
  sendLatePickupsReminder?: Maybe<SendLatePickupsReminderMutationPayload>;
  /** Remind a buyer to collect his paid pickup lots at a vendor */
  sendPickupReminderToBuyer?: Maybe<SendPickupReminderToBuyerMutationPayload>;
  /** Set a default address for the current vendor */
  setVendorDefaultAddress?: Maybe<SetVendorDefaultAddressMutationPayload>;
  /** Update writer project roles */
  setWriterProjectRole?: Maybe<SetWriterProjectRoleMutationPayload>;
  signIn?: Maybe<SignInPayload>;
  signUp?: Maybe<SignUpPayload>;
  /** Split a Desire into multiple desires */
  splitDesire?: Maybe<SplitDesireMutationPayload>;
  startItemDescriptionGeneration?: Maybe<StartItemDescriptionGenerationMutationPayload>;
  startItemWatchDescriptionGeneration?: Maybe<StartItemWatchDescriptionGenerationMutationPayload>;
  /** Trigger a Stripe payout for a DodecadeStatementPayment */
  triggerDodecadePayout?: Maybe<TriggerDodecadePayoutMutationPayload>;
  /** Trigger a Stripe transfer for a MonthlyVendorPayment (manual individual payment) */
  triggerMonthlyVendorPaymentTransfer?: Maybe<TriggerMonthlyVendorPaymentTransferMutationPayload>;
  /** Déclenche les paiements pour une vente (Dodécade classique ou Projet) */
  triggerSalePayment?: Maybe<TriggerSalePaymentPayload>;
  /** Trigger a Stripe transfer for a VendorStatementPayment */
  triggerStripeTransfer?: Maybe<TriggerStripeTransferMutationPayload>;
  /** Unarchive an ItemCategory */
  unarchiveItemCategory?: Maybe<UnarchiveItemCategoryMutationPayload>;
  /** Unarchive an ItemSubCategory */
  unarchiveItemSubCategory?: Maybe<UnarchiveItemSubCategoryMutationPayload>;
  unlockAccount?: Maybe<UnlockAccountPayload>;
  updateAccount?: Maybe<UpdateAccountPayload>;
  /** Update Addresses */
  updateAddress?: Maybe<UpdateAddressMutationPayload>;
  /** Update BankInformation */
  updateBankInformation?: Maybe<UpdateBankInformationMutationPayload>;
  /** Update A book */
  updateBook?: Maybe<UpdateBookMutationPayload>;
  /** Update Business Introducer */
  updateBusinessIntroducer?: Maybe<UpdateBusinessIntroducerMutationPayload>;
  /** Update A CarpetTextile */
  updateCarpetTextile?: Maybe<UpdateCarpetTextileMutationPayload>;
  /** Update A Ceramic */
  updateCeramic?: Maybe<UpdateCeramicMutationPayload>;
  /** Update CoinsMedalsStamps */
  updateCoinsMedalsStamps?: Maybe<UpdateCoinsMedalsStampsMutationPayload>;
  /** Update A Customer */
  updateCustomer?: Maybe<UpdateCustomerMutationPayload>;
  /** Update Desire */
  updateDesire?: Maybe<UpdateDesireMutationPayload>;
  /** Update A Engraving */
  updateEngraving?: Maybe<UpdateEngravingMutationPayload>;
  /** Update ExpertPayments */
  updateExpertPayment?: Maybe<UpdateExpertPaymentMutationPayload>;
  updateExpertStatementPayment?: Maybe<UpdateExpertStatementPaymentMutationPayload>;
  /** Update A FashionLuxuryAccessory */
  updateFashionLuxuryAccessory?: Maybe<UpdateFashionLuxuryAccessoryMutationPayload>;
  /** Update A Furniture */
  updateFurniture?: Maybe<UpdateFurnitureMutationPayload>;
  /** Update A GeographicMap */
  updateGeographicMap?: Maybe<UpdateGeographicMapMutationPayload>;
  /** Update ImportPayment */
  updateImportPayment?: Maybe<UpdateImportPaymentMutationPayload>;
  updateImportStatementPayment?: Maybe<UpdateImportStatementPaymentMutationPayload>;
  updateItem?: Maybe<UpdateItemMutationPayload>;
  /** Update an ItemCategory */
  updateItemCategory?: Maybe<UpdateItemCategoryMutationPayload>;
  updateItemExpert?: Maybe<UpdateItemExpertMutationPayload>;
  updateItemMovement?: Maybe<UpdateItemMovementMutationPayload>;
  /** Update item step */
  updateItemStep?: Maybe<UpdateItemStepMutationPayload>;
  /** Update an ItemSubCategory */
  updateItemSubCategory?: Maybe<UpdateItemSubCategoryMutationPayload>;
  /** Update A Jewelry */
  updateJewelry?: Maybe<UpdateJewelryMutationPayload>;
  /** Update A Manuscript */
  updateManuscript?: Maybe<UpdateManuscriptMutationPayload>;
  /** Update A Militaria */
  updateMilitaria?: Maybe<UpdateMilitariaMutationPayload>;
  /** Update MonthlyVendorPayments */
  updateMonthlyVendorPayment?: Maybe<UpdateMonthlyVendorPaymentMutationPayload>;
  /** Update Order */
  updateOrder?: Maybe<UpdateOrderMutationPayload>;
  /** Update Order Item */
  updateOrderItem?: Maybe<UpdateOrderItemMutationPayload>;
  /** Update A PaintingSculpture */
  updatePaintingSculpture?: Maybe<UpdatePaintingSculptureMutationPayload>;
  /** Update A Photography */
  updatePhotography?: Maybe<UpdatePhotographyMutationPayload>;
  /** Update Projectes */
  updateProject?: Maybe<UpdateProjectMutationPayload>;
  /** Update ProjectFee */
  updateProjectFee?: Maybe<UpdateProjectFeeMutationPayload>;
  /** Update ProjectIntroducerPayment */
  updateProjectIntroducerPayment?: Maybe<UpdateProjectIntroducerPaymentMutationPayload>;
  /** Update QuickTextes */
  updateQuickText?: Maybe<UpdateQuickTextMutationPayload>;
  /** Update Salees */
  updateSale?: Maybe<UpdateSaleMutationPayload>;
  /** Update A SilverwareTableware */
  updateSilverwareTableware?: Maybe<UpdateSilverwareTablewareMutationPayload>;
  /** Update A Tag */
  updateTag?: Maybe<UpdateTagMutationPayload>;
  /** Update ThirdPartys Introducer */
  updateThirdPartyIntroducer?: Maybe<UpdateThirdPartyIntroducerMutationPayload>;
  /** Update A ToyComicPopCulture */
  updateToyComicPopCulture?: Maybe<UpdateToyComicPopCultureMutationPayload>;
  /** Updates an existing user */
  updateUser?: Maybe<User>;
  /** Updates the role for an user as an admin. */
  updateUserRole?: Maybe<Scalars['Boolean']>;
  /** Update Vacationes */
  updateVacation?: Maybe<UpdateVacationMutationPayload>;
  /** Update an address belonging to the current vendor */
  updateVendorAddress?: Maybe<UpdateVendorAddressMutationPayload>;
  /** Update pickup hours for the current vendor */
  updateVendorPickupHours?: Maybe<UpdateVendorPickupHoursMutationPayload>;
  /** Update vendor shipping methods for the current vendor */
  updateVendorShippingMethods?: Maybe<UpdateVendorShippingMethodsMutationPayload>;
  updateVendorStatementPayment?: Maybe<UpdateVendorStatementPaymentMutationPayload>;
  /** Update Volumes */
  updateVolumes?: Maybe<UpdateVolumeMutationPayload>;
  /** Update A Watch */
  updateWatch?: Maybe<UpdateWatchMutationPayload>;
  /** Update WriterPayments */
  updateWriterPayment?: Maybe<UpdateWriterPaymentMutationPayload>;
  updateWriterStatementPayment?: Maybe<UpdateWriterStatementPaymentMutationPayload>;
  /** Put all the items planned for a CP sale on that sale */
  validateSaleItems?: Maybe<ValidateSaleItemsMutationPayload>;
  validateToken?: Maybe<ValidateTokenPayload>;
};


export type MutationArchiveItemCategoryArgs = {
  input: ArchiveItemCategoryMutationInput;
};


export type MutationArchiveItemSubCategoryArgs = {
  input: ArchiveItemSubCategoryMutationInput;
};


export type MutationBulkMarkExpertPaymentsAsPaidArgs = {
  input: BulkMarkExpertPaymentsAsPaidInput;
};


export type MutationBulkMarkExpertStatementPaymentsAsPaidArgs = {
  input: BulkMarkExpertStatementPaymentsAsPaidInput;
};


export type MutationBulkMarkImportPaymentsAsPaidArgs = {
  input: BulkMarkImportPaymentsAsPaidInput;
};


export type MutationBulkMarkImportStatementPaymentsAsPaidArgs = {
  input: BulkMarkImportStatementPaymentsAsPaidInput;
};


export type MutationBulkMarkMonthlyVendorPaymentsAsPaidArgs = {
  input: BulkMarkMonthlyVendorPaymentsAsPaidInput;
};


export type MutationBulkMarkProjectIntroducerPaymentsAsPaidArgs = {
  input: BulkMarkProjectIntroducerPaymentsAsPaidInput;
};


export type MutationBulkMarkVendorStatementPaymentsAsPaidArgs = {
  input: BulkMarkVendorStatementPaymentsAsPaidInput;
};


export type MutationBulkMarkWriterPaymentsAsPaidArgs = {
  input: BulkMarkWriterPaymentsAsPaidInput;
};


export type MutationBulkMarkWriterStatementPaymentsAsPaidArgs = {
  input: BulkMarkWriterStatementPaymentsAsPaidInput;
};


export type MutationBulkRelistItemsArgs = {
  input: BulkRelistItemsMutationInput;
};


export type MutationBulkRemoveReturnedItemsArgs = {
  input: BulkRemoveReturnedItemsMutationInput;
};


export type MutationBulkReturnItemsArgs = {
  input: BulkReturnItemsMutationInput;
};


export type MutationBulkUpdateSalePositionsArgs = {
  input: BulkUpdateSalePositionsMutationInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountMutationInput;
};


export type MutationCreateBankInformationArgs = {
  input: CreateBankInformationMutationInput;
};


export type MutationCreateBookArgs = {
  input: CreateBookMutationInput;
};


export type MutationCreateBusinessIntroducerArgs = {
  input: CreateBusinessIntroducerMutationInput;
};


export type MutationCreateCarpetTextileArgs = {
  input: CreateCarpetTextileMutationInput;
};


export type MutationCreateCeramicArgs = {
  input: CreateCeramicMutationInput;
};


export type MutationCreateCoinsMedalsStampsArgs = {
  input: CreateCoinsMedalsStampsMutationInput;
};


export type MutationCreateCpImportArgs = {
  input: CreateCpImportMutationInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerMutationInput;
};


export type MutationCreateDesireArgs = {
  input: CreateDesireMutationInput;
};


export type MutationCreateDesiresRainworxImportArgs = {
  input: CreateDesiresRainworxImportMutationInput;
};


export type MutationCreateDrouotExportCsvArgs = {
  input: CreateDrouotExportCsvMutationInput;
};


export type MutationCreateDrouotImportArgs = {
  input: CreateDrouotImportMutationInput;
};


export type MutationCreateEngravingArgs = {
  input: CreateEngravingMutationInput;
};


export type MutationCreateFashionLuxuryAccessoryArgs = {
  input: CreateFashionLuxuryAccessoryMutationInput;
};


export type MutationCreateFavoritesRainworxImportArgs = {
  input: CreateFavoritesRainworxImportMutationInput;
};


export type MutationCreateFurnitureArgs = {
  input: CreateFurnitureMutationInput;
};


export type MutationCreateGeographicMapArgs = {
  input: CreateGeographicMapMutationInput;
};


export type MutationCreateImportArgs = {
  input: CreateImportMutationInput;
};


export type MutationCreateItemArgs = {
  input: CreateItemMutationInput;
};


export type MutationCreateItemCategoryArgs = {
  input: CreateItemCategoryMutationInput;
};


export type MutationCreateItemMovementArgs = {
  input: CreateItemMovementMutationInput;
};


export type MutationCreateItemSubCategoryArgs = {
  input: CreateItemSubCategoryMutationInput;
};


export type MutationCreateJewelryArgs = {
  input: CreateJewelryMutationInput;
};


export type MutationCreateLotUrlsRainworxImportArgs = {
  input: CreateLotUrlsRainworxImportMutationInput;
};


export type MutationCreateManuscriptArgs = {
  input: CreateManuscriptMutationInput;
};


export type MutationCreateMilitariaArgs = {
  input: CreateMilitariaMutationInput;
};


export type MutationCreateMyAlertsDesiresImportArgs = {
  input: CreateMyAlertsDesiresImportMutationInput;
};


export type MutationCreateNewsLetterArgs = {
  input: CreateNewsLetterMutationInput;
};


export type MutationCreatePaintingSculptureArgs = {
  input: CreatePaintingSculptureMutationInput;
};


export type MutationCreatePhotographyArgs = {
  input: CreatePhotographyMutationInput;
};


export type MutationCreatePickupRequestArgs = {
  input: CreatePickupRequestMutationInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectMutationInput;
};


export type MutationCreateProjectFeeArgs = {
  input: CreateProjectFeeMutationInput;
};


export type MutationCreateQuickTextArgs = {
  input: CreateQuickTextMutationInput;
};


export type MutationCreateSaleArgs = {
  input: CreateSaleMutationInput;
};


export type MutationCreateSaleMandatsArgs = {
  input: CreateSaleMandatMutationInput;
};


export type MutationCreateSilverwareTablewareArgs = {
  input: CreateSilverwareTablewareMutationInput;
};


export type MutationCreateStripeAccountSessionArgs = {
  input: CreateStripeAccountSessionMutationInput;
};


export type MutationCreateThirdPartyIntroducerArgs = {
  input: CreateThirdPartyIntroducerMutationInput;
};


export type MutationCreateToyComicPopCultureArgs = {
  input: CreateToyComicPopCultureMutationInput;
};


export type MutationCreateUnsoldItemsRainworxImportArgs = {
  input: CreateUnsoldItemsRainworxImportMutationInput;
};


export type MutationCreateVacationArgs = {
  input: CreateVacationMutationInput;
};


export type MutationCreateVendorAddressArgs = {
  input: CreateVendorAddressMutationInput;
};


export type MutationCreateWatchArgs = {
  input: CreateWatchMutationInput;
};


export type MutationCustomSignInArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  rememberMe?: Maybe<Scalars['Boolean']>;
};


export type MutationCustomSignUpArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  phone: Scalars['String'];
  role: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type MutationCustomUpdateAccountArgs = {
  input: CustomUpdateAccountMutationInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDestroyCustomerArgs = {
  input: DestroyCustomerMutationInput;
};


export type MutationDestroyDesireArgs = {
  input: DestroyDesireMutationInput;
};


export type MutationDestroyItemArgs = {
  input: DestroyItemMutationInput;
};


export type MutationDestroyItemCategoryArgs = {
  input: DestroyItemCategoryMutationInput;
};


export type MutationDestroyItemSubCategoryArgs = {
  input: DestroyItemSubCategoryMutationInput;
};


export type MutationDestroyProjectFeeArgs = {
  input: DestroyProjectFeeMutationInput;
};


export type MutationDestroyQuickTextArgs = {
  input: DestroyQuickTextMutationInput;
};


export type MutationDestroySaleArgs = {
  input: DestroySaleMutationInput;
};


export type MutationDestroyTagArgs = {
  input: DestroyTagMutationInput;
};


export type MutationDestroyVacationArgs = {
  input: DestroyVacationMutationInput;
};


export type MutationDestroyVendorAddressArgs = {
  input: DestroyVendorAddressMutationInput;
};


export type MutationDuplicateItemArgs = {
  input: DuplicateItemMutationInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationGenerateVendorAccountingExportArgs = {
  input: GenerateVendorAccountingExportMutationInput;
};


export type MutationLockAccountArgs = {
  id: Scalars['ID'];
};


export type MutationMarkDesiresReviewedArgs = {
  input: MarkDesiresReviewedMutationInput;
};


export type MutationMergeTagArgs = {
  input: MergeTagMutationInput;
};


export type MutationMoveSaleItemsToVacationArgs = {
  input: MoveItemsToVacationMutationInput;
};


export type MutationRegenerateLabelArgs = {
  input: RegenerateLabelMutationInput;
};


export type MutationResendConfirmationInstructionsArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  resetPasswordToken: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationRotateImageArgs = {
  input: RotateImageMutationInput;
};


export type MutationSendLateOrdersReminderArgs = {
  input: SendLateOrdersReminderMutationInput;
};


export type MutationSendLatePickupsReminderArgs = {
  input: SendLatePickupsReminderMutationInput;
};


export type MutationSendPickupReminderToBuyerArgs = {
  input: SendPickupReminderToBuyerMutationInput;
};


export type MutationSetVendorDefaultAddressArgs = {
  input: SetVendorDefaultAddressMutationInput;
};


export type MutationSetWriterProjectRoleArgs = {
  input: SetWriterProjectRoleMutationInput;
};


export type MutationSignInArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  rememberMe?: Maybe<Scalars['Boolean']>;
};


export type MutationSignUpArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationSplitDesireArgs = {
  input: SplitDesireMutationInput;
};


export type MutationStartItemDescriptionGenerationArgs = {
  input: StartItemDescriptionGenerationMutationInput;
};


export type MutationStartItemWatchDescriptionGenerationArgs = {
  input: StartItemWatchDescriptionGenerationMutationInput;
};


export type MutationTriggerDodecadePayoutArgs = {
  input: TriggerDodecadePayoutMutationInput;
};


export type MutationTriggerMonthlyVendorPaymentTransferArgs = {
  input: TriggerMonthlyVendorPaymentTransferMutationInput;
};


export type MutationTriggerSalePaymentArgs = {
  input: TriggerSalePaymentInput;
};


export type MutationTriggerStripeTransferArgs = {
  input: TriggerStripeTransferMutationInput;
};


export type MutationUnarchiveItemCategoryArgs = {
  input: UnarchiveItemCategoryMutationInput;
};


export type MutationUnarchiveItemSubCategoryArgs = {
  input: UnarchiveItemSubCategoryMutationInput;
};


export type MutationUnlockAccountArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAccountArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressMutationInput;
};


export type MutationUpdateBankInformationArgs = {
  input: UpdateBankInformationMutationInput;
};


export type MutationUpdateBookArgs = {
  input: UpdateBookMutationInput;
};


export type MutationUpdateBusinessIntroducerArgs = {
  input: UpdateBusinessIntroducerMutationInput;
};


export type MutationUpdateCarpetTextileArgs = {
  input: UpdateCarpetTextileMutationInput;
};


export type MutationUpdateCeramicArgs = {
  input: UpdateCeramicMutationInput;
};


export type MutationUpdateCoinsMedalsStampsArgs = {
  input: UpdateCoinsMedalsStampsMutationInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerMutationInput;
};


export type MutationUpdateDesireArgs = {
  input: UpdateDesireMutationInput;
};


export type MutationUpdateEngravingArgs = {
  input: UpdateEngravingMutationInput;
};


export type MutationUpdateExpertPaymentArgs = {
  input: UpdateExpertPaymentMutationInput;
};


export type MutationUpdateExpertStatementPaymentArgs = {
  input: UpdateExpertStatementPaymentMutationInput;
};


export type MutationUpdateFashionLuxuryAccessoryArgs = {
  input: UpdateFashionLuxuryAccessoryMutationInput;
};


export type MutationUpdateFurnitureArgs = {
  input: UpdateFurnitureMutationInput;
};


export type MutationUpdateGeographicMapArgs = {
  input: UpdateGeographicMapMutationInput;
};


export type MutationUpdateImportPaymentArgs = {
  input: UpdateImportPaymentMutationInput;
};


export type MutationUpdateImportStatementPaymentArgs = {
  input: UpdateImportStatementPaymentMutationInput;
};


export type MutationUpdateItemArgs = {
  input: UpdateItemMutationInput;
};


export type MutationUpdateItemCategoryArgs = {
  input: UpdateItemCategoryMutationInput;
};


export type MutationUpdateItemExpertArgs = {
  input: UpdateItemExpertMutationInput;
};


export type MutationUpdateItemMovementArgs = {
  input: UpdateItemMovementMutationInput;
};


export type MutationUpdateItemStepArgs = {
  input: UpdateItemStepMutationInput;
};


export type MutationUpdateItemSubCategoryArgs = {
  input: UpdateItemSubCategoryMutationInput;
};


export type MutationUpdateJewelryArgs = {
  input: UpdateJewelryMutationInput;
};


export type MutationUpdateManuscriptArgs = {
  input: UpdateManuscriptMutationInput;
};


export type MutationUpdateMilitariaArgs = {
  input: UpdateMilitariaMutationInput;
};


export type MutationUpdateMonthlyVendorPaymentArgs = {
  input: UpdateMonthlyVendorPaymentMutationInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderMutationInput;
};


export type MutationUpdateOrderItemArgs = {
  input: UpdateOrderItemMutationInput;
};


export type MutationUpdatePaintingSculptureArgs = {
  input: UpdatePaintingSculptureMutationInput;
};


export type MutationUpdatePhotographyArgs = {
  input: UpdatePhotographyMutationInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectMutationInput;
};


export type MutationUpdateProjectFeeArgs = {
  input: UpdateProjectFeeMutationInput;
};


export type MutationUpdateProjectIntroducerPaymentArgs = {
  input: UpdateProjectIntroducerPaymentMutationInput;
};


export type MutationUpdateQuickTextArgs = {
  input: UpdateQuickTextMutationInput;
};


export type MutationUpdateSaleArgs = {
  input: UpdateSaleMutationInput;
};


export type MutationUpdateSilverwareTablewareArgs = {
  input: UpdateSilverwareTablewareMutationInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagMutationInput;
};


export type MutationUpdateThirdPartyIntroducerArgs = {
  input: UpdateThirdPartyIntroducerMutationInput;
};


export type MutationUpdateToyComicPopCultureArgs = {
  input: UpdateToyComicPopCultureMutationInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};


export type MutationUpdateVacationArgs = {
  input: UpdateVacationMutationInput;
};


export type MutationUpdateVendorAddressArgs = {
  input: UpdateVendorAddressMutationInput;
};


export type MutationUpdateVendorPickupHoursArgs = {
  input: UpdateVendorPickupHoursMutationInput;
};


export type MutationUpdateVendorShippingMethodsArgs = {
  input: UpdateVendorShippingMethodsMutationInput;
};


export type MutationUpdateVendorStatementPaymentArgs = {
  input: UpdateVendorStatementPaymentMutationInput;
};


export type MutationUpdateVolumesArgs = {
  input: UpdateVolumeMutationInput;
};


export type MutationUpdateWatchArgs = {
  input: UpdateWatchMutationInput;
};


export type MutationUpdateWriterPaymentArgs = {
  input: UpdateWriterPaymentMutationInput;
};


export type MutationUpdateWriterStatementPaymentArgs = {
  input: UpdateWriterStatementPaymentMutationInput;
};


export type MutationValidateSaleItemsArgs = {
  input: ValidateSaleItemsMutationInput;
};

export type NestedArtistInput = {
  createAndLink?: Maybe<Array<CreateArtistInput>>;
  deleteLink?: Maybe<Array<DeleteArtistInput>>;
  link?: Maybe<Array<LinkInput>>;
  update?: Maybe<UpdateArtistInput>;
};

export type NestedItemCategoryInput = {
  link?: Maybe<Array<LinkInput>>;
};

export type NestedItemInput = {
  createAndLink?: Maybe<Array<CreateItemInput>>;
  link?: Maybe<Array<LinkInput>>;
  update?: Maybe<UpdateItemInput>;
};

export type NestedItemSubCategoryInput = {
  link?: Maybe<Array<LinkInput>>;
};

export type NestedTagInput = {
  createAndLink?: Maybe<Array<CreateTagInput>>;
  deleteLink?: Maybe<Array<DeleteArtistInput>>;
};

export type NestedWriterInput = {
  createAndLink?: Maybe<Array<CreateWriterInput>>;
  link?: Maybe<Array<LinkInput>>;
  update?: Maybe<UpdateWriterInput>;
};

/** A NewsLetter */
export type NewsLetter = Node & {
  __typename?: 'NewsLetter';
  buyer?: Maybe<Buyer>;
  createdAt: Scalars['ISO8601DateTime'];
  customer?: Maybe<Customer>;
  emailFrom?: Maybe<Scalars['String']>;
  emailTo?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isGeneral: Scalars['Boolean'];
  nbItems?: Maybe<Scalars['Int']>;
  sale: Sale;
  subject?: Maybe<Scalars['String']>;
  test: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for NewsLetter. */
export type NewsLetterConnection = {
  __typename?: 'NewsLetterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NewsLetterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NewsLetter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type NewsLetterEdge = {
  __typename?: 'NewsLetterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<NewsLetter>;
};

export type NewsLetterFilter = {
  OR?: Maybe<Array<NewsLetterFilter>>;
  isGeneral?: Maybe<OperatorBooleanFilter>;
  sale?: Maybe<SaleFilter>;
  test?: Maybe<OperatorBooleanFilter>;
};

/** Une campagne de newsletter envoyée en production (une vente, un type de newsletter) */
export type NewsletterCampaign = {
  __typename?: 'NewsletterCampaign';
  /** Premier envoi */
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** start, ending_soon... */
  newsletterType: Scalars['String'];
  sale?: Maybe<Sale>;
  stats: NewsletterStats;
  subject?: Maybe<Scalars['String']>;
};

/** Envois, ouvertures et clics de newsletters sur une heure */
export type NewsletterHourlyStat = {
  __typename?: 'NewsletterHourlyStat';
  /** Premiers clics enregistrés dans cette heure */
  clicked: Scalars['Int'];
  hour: Scalars['ISO8601DateTime'];
  /** Premières ouvertures enregistrées dans cette heure */
  opened: Scalars['Int'];
  /** Newsletters envoyées dans cette heure */
  sent: Scalars['Int'];
};

/** Totaux d'envoi, d'ouverture et de clic d'une campagne de newsletter */
export type NewsletterStats = {
  __typename?: 'NewsletterStats';
  /** Rebonds (hard, soft) et rejets */
  bounced: Scalars['Int'];
  /** Part des envois dont un lien a été cliqué (0 à 1) */
  clickRate: Scalars['Float'];
  clicked: Scalars['Int'];
  /** Part des envois ouverts (0 à 1) */
  openRate: Scalars['Float'];
  opened: Scalars['Int'];
  sent: Scalars['Int'];
  /** Plaintes spam */
  spam: Scalars['Int'];
  /** Désabonnements */
  unsub: Scalars['Int'];
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID'];
};

export type OperatorBooleanFilter = {
  equalTo?: Maybe<Scalars['Boolean']>;
};

export type OperatorDateFilter = {
  equalTo?: Maybe<Scalars['ISO8601DateTime']>;
  greaterThan?: Maybe<Scalars['ISO8601DateTime']>;
  greaterThanOrEqualTo?: Maybe<Scalars['ISO8601DateTime']>;
  isBlank?: Maybe<Scalars['Boolean']>;
  isPresent?: Maybe<Scalars['Boolean']>;
  lessThan?: Maybe<Scalars['ISO8601DateTime']>;
  lessThanOrEqualTo?: Maybe<Scalars['ISO8601DateTime']>;
};

export type OperatorIdFilter = {
  contain?: Maybe<Scalars['ID']>;
  equalTo?: Maybe<Scalars['ID']>;
  isBlank?: Maybe<Scalars['Boolean']>;
  isNotEqualTo?: Maybe<Scalars['ID']>;
  isPresent?: Maybe<Scalars['Boolean']>;
};

export type OperatorNumberFilter = {
  equalTo?: Maybe<Scalars['Float']>;
  greaterThan?: Maybe<Scalars['Float']>;
  greaterThanOrEqualTo?: Maybe<Scalars['Float']>;
  isBlank?: Maybe<Scalars['Boolean']>;
  isNotEqualTo?: Maybe<Scalars['Float']>;
  isPresent?: Maybe<Scalars['Boolean']>;
  lessThan?: Maybe<Scalars['Float']>;
  lessThanOrEqualTo?: Maybe<Scalars['Float']>;
};

export type OperatorStringFilter = {
  contain?: Maybe<Scalars['String']>;
  equalTo?: Maybe<Scalars['String']>;
  isBlank?: Maybe<Scalars['Boolean']>;
  isIn?: Maybe<Array<Scalars['String']>>;
  isNotEqualTo?: Maybe<Scalars['ID']>;
  isPresent?: Maybe<Scalars['Boolean']>;
};

/** A Order */
export type Order = Node & {
  __typename?: 'Order';
  buyer?: Maybe<Buyer>;
  buyerFee?: Maybe<Scalars['Float']>;
  buyerFeeTax?: Maybe<Scalars['Float']>;
  buyerFeeTaxIncluded?: Maybe<Scalars['Float']>;
  carrierName?: Maybe<Scalars['String']>;
  carrierServiceName?: Maybe<Scalars['String']>;
  /** Customer comment */
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** Dodécade invoice reference number */
  dodecadeInvoiceRef?: Maybe<Scalars['Int']>;
  /** Dodécade external order reference (used as stable identifier for Stripe webhooks) */
  dodecadeOrderRef?: Maybe<Scalars['String']>;
  histories?: Maybe<Array<OrderHistory>>;
  id: Scalars['ID'];
  insurancePrice?: Maybe<Scalars['Float']>;
  insurancePriceTaxIncluded?: Maybe<Scalars['Float']>;
  insuranceTax?: Maybe<Scalars['Float']>;
  labelUrls?: Maybe<Array<Scalars['String']>>;
  labels: LabelConnection;
  orderItems: OrderItemConnection;
  originState?: Maybe<Scalars['String']>;
  /** Date de paiement confirmé (set par webhook Stripe) */
  paidAt?: Maybe<Scalars['ISO8601DateTime']>;
  sale?: Maybe<Sale>;
  saleEndAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Seller invoice IDs received from Stripe webhook metadata */
  sellerInvoiceIds?: Maybe<Array<Scalars['String']>>;
  shippedAt?: Maybe<Scalars['ISO8601DateTime']>;
  shippingAddress?: Maybe<Address>;
  shippingPrice?: Maybe<Scalars['Float']>;
  shippingPriceTaxIncluded?: Maybe<Scalars['Float']>;
  shippingTax?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['String']>;
  sourceRef?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  /** Stripe PaymentIntent ID (set when payment is confirmed via webhook) */
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentLink?: Maybe<Scalars['String']>;
  totalItemsPrice?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalPriceTaxIncluded?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
  trackingNumbers?: Maybe<Array<Scalars['String']>>;
  trackingUrls?: Maybe<Array<Scalars['String']>>;
  undeplusRef?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendorComment?: Maybe<Scalars['String']>;
  vendors?: Maybe<Array<Vendor>>;
};


/** A Order */
export type OrderLabelsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A Order */
export type OrderOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export type OrderFilterType = {
  OR?: Maybe<Array<OrderFilterType>>;
  meta?: Maybe<Scalars['String']>;
  buyer?: Maybe<BuyerFilter>;
  carrierName?: Maybe<OperatorStringFilter>;
  createdAt?: Maybe<OperatorDateFilter>;
  dodecadeInvoiceRef?: Maybe<OperatorStringFilter>;
  dodecadeOrderRef?: Maybe<OperatorStringFilter>;
  id?: Maybe<OperatorIdFilter>;
  labels?: Maybe<LabelFilter>;
  orderItems?: Maybe<OrderItemFilter>;
  paidAt?: Maybe<OperatorDateFilter>;
  sale?: Maybe<SaleFilter>;
  saleId?: Maybe<OperatorIdFilter>;
  state?: Maybe<OperatorStringFilter>;
  totalPriceTaxIncluded?: Maybe<OperatorNumberFilter>;
  vendors?: Maybe<VendorFilter>;
};

export type OrderHistory = {
  __typename?: 'OrderHistory';
  createdAt: Scalars['ISO8601DateTime'];
  event: Scalars['String'];
  id: Scalars['ID'];
  objectChanges?: Maybe<Scalars['JSON']>;
  whodunnit?: Maybe<Scalars['String']>;
};

/** A OrderItem */
export type OrderItem = Node & {
  __typename?: 'OrderItem';
  carrierName?: Maybe<Scalars['String']>;
  /** Commission TTC calculée pour cet item */
  commissionTtc?: Maybe<Scalars['Float']>;
  /** ID of the object. */
  id: Scalars['ID'];
  item: Item;
  label?: Maybe<Label>;
  order?: Maybe<Order>;
  state?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['Float']>;
  undeplusRef?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
};

/** The connection type for OrderItem. */
export type OrderItemConnection = {
  __typename?: 'OrderItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrderItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OrderItemEdge = {
  __typename?: 'OrderItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OrderItem>;
};

export type OrderItemFilter = {
  OR?: Maybe<Array<OrderItemFilter>>;
  meta?: Maybe<Scalars['String']>;
  carrierName?: Maybe<OperatorStringFilter>;
  item?: Maybe<ItemFilter>;
  state?: Maybe<OperatorStringFilter>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaidPendingPaymentStats = {
  __typename?: 'PaidPendingPaymentStats';
  count: Scalars['Int'];
  orders: Array<PendingPaymentOrderInfo>;
  totalAmount: Scalars['Float'];
};

/** A PaidSlip */
export type PaidSlip = Node & {
  __typename?: 'PaidSlip';
  buyer?: Maybe<Buyer>;
  createdAt: Scalars['ISO8601DateTime'];
  document?: Maybe<CustomFile>;
  id: Scalars['ID'];
  items?: Maybe<ItemConnection>;
  nbItems?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  sale?: Maybe<Sale>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A PaidSlip */
export type PaidSlipItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for PaidSlip. */
export type PaidSlipConnection = {
  __typename?: 'PaidSlipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaidSlipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PaidSlip>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PaidSlipEdge = {
  __typename?: 'PaidSlipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PaidSlip>;
};

export type PaidSlipFilter = {
  OR?: Maybe<Array<PaidSlipFilter>>;
  id?: Maybe<OperatorIdFilter>;
  meta?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  sale?: Maybe<SaleFilter>;
  vendor?: Maybe<VendorFilter>;
};

export type PaidWithinDelayStats = {
  __typename?: 'PaidWithinDelayStats';
  count: Scalars['Int'];
  remainingDays: Scalars['Int'];
  totalAmount: Scalars['Float'];
};

/** A PaintingSculpture */
export type PaintingSculpture = Node & {
  __typename?: 'PaintingSculpture';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A Part of Volume */
export type Part = Node & {
  __typename?: 'Part';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
  volume: Volume;
};

/** The connection type for Part. */
export type PartConnection = {
  __typename?: 'PartConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Part>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PartEdge = {
  __typename?: 'PartEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Part>;
};

export type PendingPaymentOrderInfo = {
  __typename?: 'PendingPaymentOrderInfo';
  daysSincePaid: Scalars['Int'];
  id: Scalars['ID'];
  orderNumber: Scalars['String'];
  paidAt: Scalars['ISO8601DateTime'];
  paidItemsCount: Scalars['Int'];
  pendingItemsCount: Scalars['Int'];
  totalAmount: Scalars['Float'];
  vendorPaymentStatus: Scalars['String'];
};

/** A Photography */
export type Photography = Node & {
  __typename?: 'Photography';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A pickup reminder email already sent to a buyer (one entry per email) */
export type PickupReminderEntry = {
  __typename?: 'PickupReminderEntry';
  batchId: Scalars['ID'];
  /** auto_1, auto_2, auto_3 (automatic, 14 / 30 / 60 days after payment) or manual */
  kind: Scalars['String'];
  ordersCount: Scalars['Int'];
  sentAt: Scalars['ISO8601DateTime'];
  /** Who sent it, for a manual reminder */
  sentByName?: Maybe<Scalars['String']>;
};

/** A vendor pickup request */
export type PickupRequest = Node & {
  __typename?: 'PickupRequest';
  /** When the request was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Dispatch number returned by 12plus */
  dispatchNumber?: Maybe<Scalars['String']>;
  /** Request failure or confirmation error code */
  errorCode?: Maybe<Scalars['String']>;
  /** Explanation of the request error */
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Instructions for the carrier */
  instructions?: Maybe<Scalars['String']>;
  /** Address snapshot saved when the request was created */
  pickupAddress: Scalars['JSON'];
  /** Where the carrier should collect the parcels */
  pickupLocation?: Maybe<Scalars['String']>;
  /** Closing time in HH:MM format */
  pickupLocationCloseTime: Scalars['String'];
  /** Requested parcels and their individual results */
  pickupRequestLabels: Array<PickupRequestLabel>;
  /** Requested pickup date and start time */
  pickupTimestamp: Scalars['ISO8601DateTime'];
  /** Request status: pending, confirmed or failed */
  status: Scalars['String'];
  /** When the request was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Vendor who requested the pickup */
  vendor: Vendor;
};

/** The connection type for PickupRequest. */
export type PickupRequestConnection = {
  __typename?: 'PickupRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PickupRequestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PickupRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PickupRequestEdge = {
  __typename?: 'PickupRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PickupRequest>;
};

/** Filters for pickup requests */
export type PickupRequestFilter = {
  /** Alternative filter groups */
  OR?: Maybe<Array<PickupRequestFilter>>;
  /** Filter by pickup location */
  pickupLocation?: Maybe<Scalars['String']>;
  /** Filter by request status */
  status?: Maybe<Scalars['String']>;
};

/** Parcel result for a pickup request */
export type PickupRequestLabel = {
  __typename?: 'PickupRequestLabel';
  /** Parcel rejection code */
  errorCode?: Maybe<Scalars['String']>;
  /** Reason the parcel was rejected */
  errorMessage?: Maybe<Scalars['String']>;
  /** Parcel submitted for pickup */
  label: Label;
  /** Parcel status: pending, accepted or rejected */
  status: Scalars['String'];
};

/** A buyer who paid pickup lots that are still waiting to be collected at a vendor */
export type PickupWaitingBuyer = {
  __typename?: 'PickupWaitingBuyer';
  buyerEmail?: Maybe<Scalars['String']>;
  buyerId: Scalars['ID'];
  buyerName?: Maybe<Scalars['String']>;
  /** False when a reminder was already sent too recently (anti-spam) */
  canRemind: Scalars['Boolean'];
  itemsCount: Scalars['Int'];
  lastReminderAt?: Maybe<Scalars['ISO8601DateTime']>;
  nextReminderAvailableAt?: Maybe<Scalars['ISO8601DateTime']>;
  oldestPaidAt: Scalars['ISO8601DateTime'];
  ordersCount: Scalars['Int'];
  /** Reminders already sent, newest first */
  reminders: Array<PickupReminderEntry>;
  waitingOrderItems: Array<OrderItem>;
};

/** A Project */
export type Project = Node & {
  __typename?: 'Project';
  auctioneerNumber?: Maybe<Scalars['String']>;
  businessIntroducer?: Maybe<BusinessIntroducer>;
  businessIntroducerSharePercentage?: Maybe<Scalars['Float']>;
  buyerFeePercentage?: Maybe<Scalars['Float']>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  documentsByActor: DocumentsByActor;
  dodecadeSharePercentage?: Maybe<Scalars['Float']>;
  exclusif?: Maybe<Scalars['Boolean']>;
  expertiseFeePercentage?: Maybe<Scalars['Float']>;
  expertiseFirmSharePercentage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isClassicSale?: Maybe<Scalars['Boolean']>;
  itemNumberStart?: Maybe<Scalars['String']>;
  items?: Maybe<ItemConnection>;
  manualDepositSlip?: Maybe<CustomFile>;
  nbItems?: Maybe<Scalars['Int']>;
  nbItemsToExpertise?: Maybe<Scalars['Int']>;
  nbItemsToModify?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  owner?: Maybe<Vendor>;
  /** Objets vendus dans une vente (admin) */
  paymentSaleItems: Array<ProjectSaleItem>;
  paymentSummary?: Maybe<ProjectPaymentSummary>;
  projectFees?: Maybe<ProjectFeeConnection>;
  sharingProfit?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  thirdPartyIntroducer?: Maybe<ThirdPartyIntroducer>;
  thirdPartyIntroducerSharePercentage?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  totalFeesByActor: Scalars['JSON'];
  totalItemsSoldAmount: Scalars['Float'];
  totalProjectFeesAmount: Scalars['Float'];
  updatedAt: Scalars['ISO8601DateTime'];
  vacations?: Maybe<VacationConnection>;
  vendor?: Maybe<Vendor>;
  vendorFeePercentage?: Maybe<Scalars['Float']>;
  writerFeePercentage?: Maybe<Scalars['Float']>;
  writerFixFees?: Maybe<Scalars['Float']>;
  writers?: Maybe<WriterConnection>;
};


/** A Project */
export type ProjectItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A Project */
export type ProjectPaymentSaleItemsArgs = {
  saleId: Scalars['ID'];
};


/** A Project */
export type ProjectProjectFeesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A Project */
export type ProjectVacationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A Project */
export type ProjectWritersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Project. */
export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Project>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Project>;
};

/** A Project Fee */
export type ProjectFee = Node & {
  __typename?: 'ProjectFee';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  updatedAt: Scalars['ISO8601DateTime'];
  value?: Maybe<Scalars['Float']>;
};

/** The connection type for ProjectFee. */
export type ProjectFeeConnection = {
  __typename?: 'ProjectFeeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectFeeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectFee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProjectFeeEdge = {
  __typename?: 'ProjectFeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectFee>;
};

export type ProjectFilter = {
  OR?: Maybe<Array<ProjectFilter>>;
  id?: Maybe<OperatorIdFilter>;
  meta?: Maybe<Scalars['String']>;
  number?: Maybe<OperatorStringFilter>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<OperatorStringFilter>;
  writers?: Maybe<WriterFilter>;
};

/** A ProjectIntroducerPayment */
export type ProjectIntroducerPayment = Node & {
  __typename?: 'ProjectIntroducerPayment';
  createdAt: Scalars['ISO8601DateTime'];
  endAt: Scalars['ISO8601DateTime'];
  /** ID of the object. */
  id: Scalars['ID'];
  invoices?: Maybe<Array<CustomFile>>;
  lockedAt?: Maybe<Scalars['ISO8601DateTime']>;
  orderItems?: Maybe<OrderItemConnection>;
  paid?: Maybe<Scalars['Boolean']>;
  payableId?: Maybe<Scalars['ID']>;
  /** Nom du tiers (BusinessIntroducer, ExpertiseFirm, ou ThirdParty) */
  payableName?: Maybe<Scalars['String']>;
  payableType?: Maybe<Scalars['String']>;
  projectIntroducerPaymentLines?: Maybe<ProjectIntroducerPaymentLineConnection>;
  sale?: Maybe<Sale>;
  startAt: Scalars['ISO8601DateTime'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A ProjectIntroducerPayment */
export type ProjectIntroducerPaymentOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A ProjectIntroducerPayment */
export type ProjectIntroducerPaymentProjectIntroducerPaymentLinesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ProjectIntroducerPayment. */
export type ProjectIntroducerPaymentConnection = {
  __typename?: 'ProjectIntroducerPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectIntroducerPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectIntroducerPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProjectIntroducerPaymentEdge = {
  __typename?: 'ProjectIntroducerPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectIntroducerPayment>;
};

export type ProjectIntroducerPaymentFilter = {
  OR?: Maybe<Array<ProjectIntroducerPaymentFilter>>;
  meta?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  paid?: Maybe<Scalars['Boolean']>;
};

/** Ligne de paiement apporteur de clientèle projet */
export type ProjectIntroducerPaymentLine = Node & {
  __typename?: 'ProjectIntroducerPaymentLine';
  /** Montant à payer */
  amount: Scalars['Float'];
  createdAt: Scalars['ISO8601DateTime'];
  /** Pourcentage de commission */
  feePercentage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  orderItems?: Maybe<OrderItemConnection>;
  project: Project;
  projectIntroducerPayment: ProjectIntroducerPayment;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Ligne de paiement apporteur de clientèle projet */
export type ProjectIntroducerPaymentLineOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ProjectIntroducerPaymentLine. */
export type ProjectIntroducerPaymentLineConnection = {
  __typename?: 'ProjectIntroducerPaymentLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectIntroducerPaymentLineEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectIntroducerPaymentLine>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProjectIntroducerPaymentLineEdge = {
  __typename?: 'ProjectIntroducerPaymentLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectIntroducerPaymentLine>;
};

export type ProjectPaymentSummary = {
  __typename?: 'ProjectPaymentSummary';
  awaitingBuyerAmountHt: Scalars['Float'];
  awaitingBuyerCount: Scalars['Int'];
  dueAmountHt: Scalars['Float'];
  dueCount: Scalars['Int'];
  generatedAmountHt: Scalars['Float'];
  generatedCount: Scalars['Int'];
  inProgressAmountHt: Scalars['Float'];
  inProgressCount: Scalars['Int'];
  project?: Maybe<Project>;
  sales?: Maybe<Array<ProjectSalePaymentSummary>>;
  salesCount: Scalars['Int'];
  soldAmountHt: Scalars['Float'];
  soldCount: Scalars['Int'];
  svvAmountHt: Scalars['Float'];
  svvCount: Scalars['Int'];
  toPayAmountHt: Scalars['Float'];
  toPayCount: Scalars['Int'];
  transferredAmountHt: Scalars['Float'];
  transferredCount: Scalars['Int'];
  unpaidByBuyerAmountHt: Scalars['Float'];
  unpaidByBuyerCount: Scalars['Int'];
};

/** Objet vendu dans une vente d'un dossier, avec ses montants et frais */
export type ProjectSaleItem = {
  __typename?: 'ProjectSaleItem';
  /** Statut de paiement : transferred, generated, to_pay, in_progress, awaiting_buyer, unpaid_by_buyer ou svv */
  bucket: Scalars['String'];
  /** Frais acheteur TTC de la commande */
  buyerFeeTaxIncluded?: Maybe<Scalars['Float']>;
  /** Commission (vendeur + rédacteur) TTC, si un paiement vendeur existe */
  commissionTtc?: Maybe<Scalars['Float']>;
  /** Frais fixes et part des frais de dossier TTC, si un paiement existe */
  fixedFeesTtc?: Maybe<Scalars['Float']>;
  /** Prix d'adjudication (ou prix de la ligne de commande) */
  hammerPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** Assurance TTC de la commande */
  insurancePriceTaxIncluded?: Maybe<Scalars['Float']>;
  item: Item;
  /** Net versé au vendeur, si un paiement vendeur existe */
  netAmount?: Maybe<Scalars['Float']>;
  orderId: Scalars['ID'];
  orderRef?: Maybe<Scalars['String']>;
  orderState?: Maybe<Scalars['String']>;
  /** Transport TTC de la commande */
  shippingPriceTaxIncluded?: Maybe<Scalars['Float']>;
  vendorPaymentId?: Maybe<Scalars['ID']>;
  vendorPaymentPaid?: Maybe<Scalars['Boolean']>;
};

export type ProjectSalePaymentSummary = {
  __typename?: 'ProjectSalePaymentSummary';
  awaitingBuyerAmountHt: Scalars['Float'];
  awaitingBuyerCount: Scalars['Int'];
  dueAmountHt: Scalars['Float'];
  dueCount: Scalars['Int'];
  generatedAmountHt: Scalars['Float'];
  generatedCount: Scalars['Int'];
  inProgressAmountHt: Scalars['Float'];
  inProgressCount: Scalars['Int'];
  sale?: Maybe<Sale>;
  soldAmountHt: Scalars['Float'];
  soldCount: Scalars['Int'];
  svvAmountHt: Scalars['Float'];
  svvCount: Scalars['Int'];
  toPayAmountHt: Scalars['Float'];
  toPayCount: Scalars['Int'];
  transferredAmountHt: Scalars['Float'];
  transferredCount: Scalars['Int'];
  unpaidByBuyerAmountHt: Scalars['Float'];
  unpaidByBuyerCount: Scalars['Int'];
  vendorPayments: Array<MonthlyVendorPayment>;
};

/** A PurchaseSlip */
export type PurchaseSlip = Node & {
  __typename?: 'PurchaseSlip';
  buyer?: Maybe<Buyer>;
  createdAt: Scalars['ISO8601DateTime'];
  document?: Maybe<CustomFile>;
  id: Scalars['ID'];
  items?: Maybe<ItemConnection>;
  nbItems?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  sale?: Maybe<Sale>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A PurchaseSlip */
export type PurchaseSlipItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for PurchaseSlip. */
export type PurchaseSlipConnection = {
  __typename?: 'PurchaseSlipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PurchaseSlipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PurchaseSlip>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PurchaseSlipEdge = {
  __typename?: 'PurchaseSlipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PurchaseSlip>;
};

export type PurchaseSlipFilter = {
  OR?: Maybe<Array<PurchaseSlipFilter>>;
  buyer?: Maybe<BuyerFilter>;
  id?: Maybe<OperatorIdFilter>;
  meta?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  sale?: Maybe<SaleFilter>;
};

/** The query root of this schema */
export type Query = {
  __typename?: 'Query';
  /** Returns the Account for a requested id */
  account?: Maybe<Account>;
  /** Returns the Address for a requested id */
  address?: Maybe<Address>;
  /** Recognized ISO country code, or null */
  addressCountryCode?: Maybe<Scalars['String']>;
  /** Addresses query */
  addresses: AddressConnection;
  /** Analytics metrics query */
  analytics: Analytics;
  /** Artists query */
  artists: ArtistConnection;
  /** Available parcels for a vendor pickup */
  availablePickupLabels: LabelConnection;
  /** Returns the BankInformation for a requested id */
  bankInformation?: Maybe<BankInformation>;
  /** Returns the Book for a requested id */
  book?: Maybe<Book>;
  /** Returns the Business Introducer for a requested id */
  businessIntroducer?: Maybe<BusinessIntroducer>;
  /** Business Introducers query */
  businessIntroducers: BusinessIntroducerConnection;
  /** Returns the buyer for a requested id */
  buyer?: Maybe<Buyer>;
  /** Buyers query */
  buyers: BuyerConnection;
  /** Returns the Customer for a requested id */
  customer?: Maybe<Customer>;
  /** Customers dédupliqués par email, avec filtres et tris (admin) */
  customerContacts: CustomerConnection;
  /** Chiffres clés des contacts (admin) */
  customerContactsSummary?: Maybe<CustomerContactsSummary>;
  /** Customers query */
  customers: CustomerConnection;
  /** DepositSlips query */
  depositSlips: DepositSlipConnection;
  /** Returns the Desire for a desire id */
  desire?: Maybe<Desire>;
  /** Alertes desiderata envoyées, ouvertes et cliquées par heure (admin) */
  desireAlertHourlyStats: Array<NewsletterHourlyStat>;
  /** Alertes desiderata envoyées, par vente (admin) */
  desireAlertSales: Array<DesireAlertSale>;
  /** Totaux des alertes desiderata sur une période (admin) */
  desireAlertSummary?: Maybe<DesireAlertSummary>;
  /** Desires query */
  desires: DesireConnection;
  /** Returns the DodecadeStatementPayment for a requested id */
  dodecadeStatementPayment?: Maybe<DodecadeStatementPayment>;
  /** DodecadeStatementPayments query */
  dodecadeStatementPayments: DodecadeStatementPaymentConnection;
  /** Returns the expert for a requested id */
  expert?: Maybe<Expert>;
  /** ExpertPayment query */
  expertPayment?: Maybe<ExpertPayment>;
  /** ExpertPayments query */
  expertPayments: ExpertPaymentConnection;
  /** ExpertStatementPayment query */
  expertStatementPayment?: Maybe<ExpertStatementPayment>;
  /** ExpertStatementPayments query */
  expertStatementPayments: ExpertStatementPaymentConnection;
  /** Experts query */
  experts: ExpertConnection;
  /** Returns the Import for a requested id */
  import?: Maybe<Import>;
  /** ImportPayment query */
  importPayment?: Maybe<ImportPayment>;
  /** ImportPayments query */
  importPayments: ImportPaymentConnection;
  /** ImportStatementPayment query */
  importStatementPayment?: Maybe<ImportStatementPayment>;
  /** ImportStatementPayments query */
  importStatementPayments: ImportStatementPaymentConnection;
  /** Imports query */
  imports: ImportConnection;
  /** Returns the item for a requested id */
  item?: Maybe<Item>;
  /** Items Categories query */
  itemCategories: ItemCategoryConnection;
  /** Returns the item_movement for a requested id */
  itemMovement?: Maybe<ItemMovement>;
  /** item_movements query */
  itemMovements: ItemMovementConnection;
  /** Items Sub Categories query */
  itemSubCategories: ItemSubCategoryConnection;
  /** Items query */
  items: ItemConnection;
  itemsStats: ItemsStats;
  /** MonthlyVendorPayment query */
  monthlyVendorPayment?: Maybe<MonthlyVendorPayment>;
  /** MonthlyVendorPayments query */
  monthlyVendorPayments: MonthlyVendorPaymentConnection;
  /** NewsLetters query */
  newsLetters: NewsLetterConnection;
  /** Campagnes de newsletter (admin) */
  newsletterCampaigns: Array<NewsletterCampaign>;
  /** Envois, ouvertures et clics de newsletters par heure (admin) */
  newsletterHourlyStats: Array<NewsletterHourlyStat>;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  /** Returns the Order for a requested id */
  order?: Maybe<Order>;
  /** Order Items query */
  orderItems: OrderItemConnection;
  /** Orders query */
  orders: OrderConnection;
  /** PaidSlips query */
  paidSlips: PaidSlipConnection;
  /** Returns the PickupRequest for a requested id */
  pickupRequest?: Maybe<PickupRequest>;
  /** PickupRequests query */
  pickupRequests: PickupRequestConnection;
  /** Buyers with paid pickup lots still to collect at a vendor, with their reminders */
  pickupWaitingBuyers: Array<PickupWaitingBuyer>;
  /** Returns the Project for a requested id */
  project?: Maybe<Project>;
  /** ProjectIntroducerPayment query */
  projectIntroducerPayment?: Maybe<ProjectIntroducerPayment>;
  /** ProjectIntroducerPayments query */
  projectIntroducerPayments: ProjectIntroducerPaymentConnection;
  /** Project payments query */
  projectPayments: Array<ProjectPaymentSummary>;
  /** Projects query */
  projects: ProjectConnection;
  /** PurchaseSlips query */
  purchaseSlips: PurchaseSlipConnection;
  /** Returns the QuickText for a requested id */
  quickText?: Maybe<QuickText>;
  /** QuickTexts query */
  quickTexts: QuickTextConnection;
  resaleStats: ResaleStats;
  /** Returns the Sale for a requested id */
  sale?: Maybe<Sale>;
  /** SaleMandats query */
  saleMandats: SaleMandatConnection;
  salePaymentStats?: Maybe<SalePaymentStats>;
  /** Sales query */
  sales: SaleConnection;
  /** Stripe platform balance snapshot */
  stripeBalanceSnapshot: StripeBalanceSnapshot;
  /** Tag query */
  tag?: Maybe<Tag>;
  /** Tags query */
  tags: TagConnection;
  /** Returns the ThirdPartyIntroducer for a requested id */
  thirdPartyIntroducer?: Maybe<ThirdPartyIntroducer>;
  /** ThirdPartyIntroducers  query */
  thirdPartyIntroducers: ThirdPartyIntroducerConnection;
  /** Returns the user for a requested id */
  user?: Maybe<User>;
  /** Users query */
  users: UserConnection;
  /** Returns the Vacation for a requested id */
  vacation?: Maybe<Vacation>;
  /** Vacations query */
  vacations: VacationConnection;
  /** Returns the vendor for a requested id */
  vendor?: Maybe<Vendor>;
  /** Late pickup data for one vendor */
  vendorLatePickups?: Maybe<VendorLatePickups>;
  /** Rapport de rémunération rédacteurs pour le vendeur connecté */
  vendorRemunerationReport: VendorRemunerationReport;
  /** VendorStatementPayment query */
  vendorStatementPayment?: Maybe<VendorStatementPayment>;
  /** VendorStatementPayments query */
  vendorStatementPayments: VendorStatementPaymentConnection;
  /** VendorStatements query */
  vendorStatements: VendorStatementConnection;
  /** Vendors query */
  vendors: VendorConnection;
  /** Vendors with late orders */
  vendorsLateOrders: Array<VendorLateOrders>;
  /** Vendors with late pickup orders */
  vendorsLatePickups: Array<VendorLatePickups>;
  /** Returns the current user */
  viewer?: Maybe<User>;
  /** Returns the Writer for a requested id */
  writer?: Maybe<Writer>;
  /** WriterPayment query */
  writerPayment?: Maybe<WriterPayment>;
  /** WriterPayments query */
  writerPayments: WriterPaymentConnection;
  /** WriterStatementPayment query */
  writerStatementPayment?: Maybe<WriterStatementPayment>;
  /** WriterStatementPayments query */
  writerStatementPayments: WriterStatementPaymentConnection;
  /** Rapport de statistiques rédacteurs pour le vendeur connecté */
  writerStatsReport: WriterStatsReport;
  /** Rapport hebdomadaire des rédacteurs pour le vendeur connecté */
  writerWeeklyFollowUp: WriterWeeklyFollowUp;
  /** Writers query */
  writers: WriterConnection;
};


/** The query root of this schema */
export type QueryAccountArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryAddressArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryAddressCountryCodeArgs = {
  country: Scalars['String'];
};


/** The query root of this schema */
export type QueryAddressesArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<AddressFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryAnalyticsArgs = {
  breakdown?: Maybe<BreakdownInput>;
  compareTo?: Maybe<CompareToEnum>;
  metrics: Array<MetricNameEnum>;
  scope: ScopeInput;
  timeSeries?: Maybe<TimeSeriesInput>;
};


/** The query root of this schema */
export type QueryArtistsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ArtistFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryAvailablePickupLabelsArgs = {
  search?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryBankInformationArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryBookArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryBusinessIntroducerArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryBusinessIntroducersArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<BusinessIntroducerFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryBuyerArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryBuyersArgs = {
  orderBy?: Maybe<ItemOrderType>;
  purchaseStatus?: Maybe<BuyerPurchaseStatusEnum>;
  desireStatus?: Maybe<BuyerDesireStatusEnum>;
  desireReview?: Maybe<BuyerDesireReviewEnum>;
  engagement?: Maybe<CustomerEngagementEnum>;
  where?: Maybe<BuyerFilter>;
  search?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryCustomerContactsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  contactStatus?: Maybe<CustomerContactStatusEnum>;
  emailState?: Maybe<Scalars['String']>;
  purchaseStatus?: Maybe<BuyerPurchaseStatusEnum>;
  desireStatus?: Maybe<BuyerDesireStatusEnum>;
  desireReview?: Maybe<BuyerDesireReviewEnum>;
  engagement?: Maybe<CustomerEngagementEnum>;
  unsubscribedFrom?: Maybe<CustomerUnsubscriptionKindEnum>;
  minNewsletters?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryCustomerContactsSummaryArgs = {
  dormantMinNewsletters?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryCustomersArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<CustomerFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryDepositSlipsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<DepositSlipFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryDesireArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryDesireAlertHourlyStatsArgs = {
  hours?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryDesireAlertSalesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryDesireAlertSummaryArgs = {
  days?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryDesiresArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<DesireFilter>;
  unusable?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryDodecadeStatementPaymentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryDodecadeStatementPaymentsArgs = {
  where?: Maybe<DodecadeStatementPaymentFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryExpertArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryExpertPaymentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryExpertPaymentsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ExpertPaymentFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryExpertStatementPaymentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryExpertStatementPaymentsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ExpertStatementPaymentFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryExpertsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ExpertFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryImportArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryImportPaymentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryImportPaymentsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ImportPaymentFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryImportStatementPaymentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryImportStatementPaymentsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ImportStatementPaymentFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryImportsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ImportFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryItemArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryItemCategoriesArgs = {
  archived?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ItemCategoryFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryItemMovementArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryItemMovementsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ItemMovementFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryItemSubCategoriesArgs = {
  archived?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ItemSubCategoryFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryItemsArgs = {
  orderBy?: Maybe<Array<ItemOrderType>>;
  where?: Maybe<ItemFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryItemsStatsArgs = {
  vendorId?: Maybe<Scalars['ID']>;
};


/** The query root of this schema */
export type QueryMonthlyVendorPaymentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryMonthlyVendorPaymentsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<MonthlyVendorPaymentFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryNewsLettersArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<NewsLetterFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryNewsletterCampaignsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryNewsletterHourlyStatsArgs = {
  hours?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryNodeArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryNodesArgs = {
  ids: Array<Scalars['ID']>;
};


/** The query root of this schema */
export type QueryOrderArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryOrderItemsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<OrderItemFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryOrdersArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<OrderFilterType>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryPaidSlipsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<PaidSlipFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryPickupRequestArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryPickupRequestsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<PickupRequestFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryPickupWaitingBuyersArgs = {
  vendorId: Scalars['ID'];
};


/** The query root of this schema */
export type QueryProjectArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryProjectIntroducerPaymentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryProjectIntroducerPaymentsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ProjectIntroducerPaymentFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryProjectPaymentsArgs = {
  onlyDue?: Maybe<Scalars['Boolean']>;
  vendorId?: Maybe<Scalars['ID']>;
};


/** The query root of this schema */
export type QueryProjectsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ProjectFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryPurchaseSlipsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<PurchaseSlipFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryQuickTextArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryQuickTextsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<QuickTextFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QuerySaleArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QuerySaleMandatsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<SaleMandatFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QuerySalePaymentStatsArgs = {
  saleId: Scalars['ID'];
};


/** The query root of this schema */
export type QuerySalesArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<SaleFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryTagArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryTagsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<TagFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryThirdPartyIntroducerArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryThirdPartyIntroducersArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<ThirdPartyIntroducerFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryUserArgs = {
  accountableType?: Maybe<Scalars['String']>;
};


/** The query root of this schema */
export type QueryUsersArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<UserFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryVacationArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryVacationsArgs = {
  orderBy?: Maybe<Array<ItemOrderType>>;
  where?: Maybe<VacationFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryVendorArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryVendorLatePickupsArgs = {
  vendorId: Scalars['ID'];
};


/** The query root of this schema */
export type QueryVendorRemunerationReportArgs = {
  endDate?: Maybe<Scalars['ISO8601Date']>;
  month?: Maybe<Scalars['ISO8601Date']>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
};


/** The query root of this schema */
export type QueryVendorStatementPaymentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryVendorStatementPaymentsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<VendorStatementPaymentFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryVendorStatementsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<VendorStatementFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryVendorsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<VendorFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryViewerArgs = {
  accountableType?: Maybe<Scalars['String']>;
};


/** The query root of this schema */
export type QueryWriterArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryWriterPaymentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryWriterPaymentsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<WriterPaymentFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryWriterStatementPaymentArgs = {
  id: Scalars['ID'];
};


/** The query root of this schema */
export type QueryWriterStatementPaymentsArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<WriterStatementPaymentFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of this schema */
export type QueryWriterStatsReportArgs = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};


/** The query root of this schema */
export type QueryWriterWeeklyFollowUpArgs = {
  endDate?: Maybe<Scalars['ISO8601Date']>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
};


/** The query root of this schema */
export type QueryWritersArgs = {
  orderBy?: Maybe<ItemOrderType>;
  where?: Maybe<WriterFilter>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** A QuickText */
export type QuickText = Node & {
  __typename?: 'QuickText';
  account: Account;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for QuickText. */
export type QuickTextConnection = {
  __typename?: 'QuickTextConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<QuickTextEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<QuickText>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QuickTextEdge = {
  __typename?: 'QuickTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<QuickText>;
};

export type QuickTextFilter = {
  OR?: Maybe<Array<QuickTextFilter>>;
  meta?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ReadyToPayStats = {
  __typename?: 'ReadyToPayStats';
  count: Scalars['Int'];
  totalAmount: Scalars['Float'];
};

/** Autogenerated input type of RegenerateLabelMutation */
export type RegenerateLabelMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

/** Autogenerated return type of RegenerateLabelMutation. */
export type RegenerateLabelMutationPayload = {
  __typename?: 'RegenerateLabelMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  label?: Maybe<Label>;
};

export type ResaleStats = {
  __typename?: 'ResaleStats';
  awaitingVendorAction: Scalars['Int'];
  byResaleTier: ResaleTierStats;
  newItemsCount: Scalars['Int'];
  totalOnSale: Scalars['Int'];
  unpaidItemsCount: Scalars['Int'];
  unsoldItemsCount: Scalars['Int'];
};

export type ResaleTierStats = {
  __typename?: 'ResaleTierStats';
  /** Items actuellement sur le palier déstockage (1€) */
  clearance: Scalars['Int'];
  initial: Scalars['Int'];
  /** Items actuellement sur le palier 'fond de bibliothèque' (5€) */
  libraryFund: Scalars['Int'];
  minusFifty: Scalars['Int'];
  minusTwenty: Scalars['Int'];
};

/** Autogenerated return type of ResendConfirmationInstructions. */
export type ResendConfirmationInstructionsPayload = {
  __typename?: 'ResendConfirmationInstructionsPayload';
  errors: Array<Error>;
  success: Scalars['Boolean'];
  valid: Scalars['Boolean'];
};

/** Autogenerated return type of ResetPassword. */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  errors: Array<Error>;
  success: Scalars['Boolean'];
};

/** A User */
export type Role = Node & {
  __typename?: 'Role';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RotateImageMutation */
export type RotateImageMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  itemId: Scalars['ID'];
  imageId: Scalars['ID'];
  rotation: Scalars['Int'];
};

/** Autogenerated return type of RotateImageMutation. */
export type RotateImageMutationPayload = {
  __typename?: 'RotateImageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  item?: Maybe<Item>;
};

/** A Sale */
export type Sale = Node & {
  __typename?: 'Sale';
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  drouotCsv?: Maybe<CustomFile>;
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  estimatedPriceEnabled: Scalars['Boolean'];
  expert?: Maybe<Expert>;
  externalEventRainworxId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  imagesZip?: Maybe<CustomFile>;
  items?: Maybe<ItemConnection>;
  name?: Maybe<Scalars['String']>;
  nbItems?: Maybe<Scalars['Int']>;
  nbTemporaryFileToGenerate?: Maybe<Scalars['Int']>;
  newsletterHeaderHtml?: Maybe<Scalars['String']>;
  /** Paiements de la vente */
  payments?: Maybe<SalePayments>;
  /** Items planned for this CP sale that still have to be validated */
  pendingPlannedItemsCount: Scalars['Int'];
  projectIds?: Maybe<Scalars['String']>;
  projects?: Maybe<ProjectConnection>;
  /** False while a CP sale still has planned items to validate (exports are blocked) */
  readyForExport: Scalars['Boolean'];
  saleMandats?: Maybe<SaleMandatConnection>;
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  state?: Maybe<Scalars['String']>;
  /** Statistiques de la vente */
  stats?: Maybe<SaleStats>;
  subject?: Maybe<Scalars['String']>;
  subjectEndingSoon?: Maybe<Scalars['String']>;
  temporaryDrouotCsvs?: Maybe<Array<CustomFile>>;
  temporaryImagesZips?: Maybe<Array<CustomFile>>;
  typeOfSale?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  writers?: Maybe<Array<Writer>>;
};


/** A Sale */
export type SaleItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A Sale */
export type SaleProjectsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A Sale */
export type SaleSaleMandatsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Sale. */
export type SaleConnection = {
  __typename?: 'SaleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SaleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Sale>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SaleEdge = {
  __typename?: 'SaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Sale>;
};

export type SaleFilter = {
  OR?: Maybe<Array<SaleFilter>>;
  externalEventRainworxId?: Maybe<OperatorIdFilter>;
  id?: Maybe<OperatorIdFilter>;
  meta?: Maybe<Scalars['String']>;
  name?: Maybe<OperatorStringFilter>;
  state?: Maybe<Array<Scalars['String']>>;
  typeOfSale?: Maybe<Scalars['String']>;
};

/** A SaleMandat */
export type SaleMandat = Node & {
  __typename?: 'SaleMandat';
  createdAt: Scalars['ISO8601DateTime'];
  document?: Maybe<CustomFile>;
  id: Scalars['ID'];
  items?: Maybe<ItemConnection>;
  nbItems?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  sale?: Maybe<Sale>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendor?: Maybe<Vendor>;
};


/** A SaleMandat */
export type SaleMandatItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for SaleMandat. */
export type SaleMandatConnection = {
  __typename?: 'SaleMandatConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SaleMandatEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SaleMandat>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SaleMandatEdge = {
  __typename?: 'SaleMandatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SaleMandat>;
};

export type SaleMandatFilter = {
  OR?: Maybe<Array<SaleMandatFilter>>;
  number?: Maybe<Scalars['String']>;
  id?: Maybe<OperatorIdFilter>;
  sale?: Maybe<SaleFilter>;
  vendor?: Maybe<VendorFilter>;
};

export type SalePaymentStats = {
  __typename?: 'SalePaymentStats';
  alreadyPaid: AlreadyPaidStats;
  excludedOrders: ExcludedOrdersStats;
  paidPendingPayment: PaidPendingPaymentStats;
  paidWithinDelay: PaidWithinDelayStats;
  readyToPay: ReadyToPayStats;
  unpaidOrders: UnpaidOrdersStats;
};

/** Paiements générés pour une vente */
export type SalePayments = {
  __typename?: 'SalePayments';
  /** Paiements experts */
  expertPayments: ExpertPaymentConnection;
  /** Paiements apporteurs */
  introducerPayments: ProjectIntroducerPaymentConnection;
  /** Paiements vendeurs */
  vendorPayments: MonthlyVendorPaymentConnection;
  /** Paiements rédacteurs */
  writerPayments: WriterPaymentConnection;
};


/** Paiements générés pour une vente */
export type SalePaymentsExpertPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Paiements générés pour une vente */
export type SalePaymentsIntroducerPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Paiements générés pour une vente */
export type SalePaymentsVendorPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Paiements générés pour une vente */
export type SalePaymentsWriterPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Input pour mettre à jour la position d'un item dans une vente */
export type SalePositionUpdateInput = {
  id: Scalars['ID'];
  salePosition?: Maybe<Scalars['Int']>;
};

/** Statistiques d'une vente */
export type SaleStats = {
  __typename?: 'SaleStats';
  /** Montant HT des objets vendus et payés */
  paidSoldAmountHt: Scalars['Float'];
  /** Nombre d'objets vendus ET payés aux vendeurs */
  paidSoldCount: Scalars['Int'];
  /** Montant HT des objets repris */
  returnedAmountHt: Scalars['Float'];
  /** Nombre d'objets repris par le vendeur */
  returnedCount: Scalars['Int'];
  /** Montant total HT des commandes */
  totalAmountHt: Scalars['Float'];
  /** Montant total TTC des commandes */
  totalAmountTtc: Scalars['Float'];
  /** Nombre total de commandes */
  totalOrders: Scalars['Int'];
  /** CA total des objets vendus (payés + impayés) */
  totalSoldAmountHt: Scalars['Float'];
  /** Montant HT des objets impayés */
  unpaidByBuyerAmountHt: Scalars['Float'];
  /** Nombre d'objets impayés par l'acheteur */
  unpaidByBuyerCount: Scalars['Int'];
  /** Montant HT à récupérer prochainement */
  unpaidSoldAmountHt: Scalars['Float'];
  /** Nombre d'objets vendus mais pas encore payés (< 20 jours) */
  unpaidSoldCount: Scalars['Int'];
  /** Nombre de commandes en attente de paiement vendeur */
  unpaidSoldOrdersCount: Scalars['Int'];
  /** Montant HT des objets invendus */
  unsoldAmountHt: Scalars['Float'];
  /** Nombre d'objets invendus */
  unsoldCount: Scalars['Int'];
};

/** Common analytics scope. The date range always filters orders.paid_at. */
export type ScopeInput = {
  /** Optional item category ID used to restrict metrics to items in one category. */
  categoryId?: Maybe<Scalars['ID']>;
  /** Optional expert ID used to restrict metrics to items assigned to one expert. */
  expertId?: Maybe<Scalars['ID']>;
  /** Inclusive start of the financial period, applied to orders.paid_at. */
  from: Scalars['ISO8601DateTime'];
  /** Optional sale ID used to restrict metrics to orders from one sale. */
  saleId?: Maybe<Scalars['ID']>;
  /** Inclusive end of the financial period, applied to orders.paid_at. */
  to: Scalars['ISO8601DateTime'];
  /** Optional vendor ID used to restrict metrics to one vendor. */
  vendorId?: Maybe<Scalars['ID']>;
  /** Optional writer ID used to restrict metrics to items assigned to one writer. */
  writerId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of SendLateOrdersReminderMutation */
export type SendLateOrdersReminderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  minDays?: Maybe<Scalars['Int']>;
  vendorId: Scalars['ID'];
};

/** Autogenerated return type of SendLateOrdersReminderMutation. */
export type SendLateOrdersReminderMutationPayload = {
  __typename?: 'SendLateOrdersReminderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SendLatePickupsReminderMutation */
export type SendLatePickupsReminderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  minDays?: Maybe<Scalars['Int']>;
  vendorId: Scalars['ID'];
};

/** Autogenerated return type of SendLatePickupsReminderMutation. */
export type SendLatePickupsReminderMutationPayload = {
  __typename?: 'SendLatePickupsReminderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SendPickupReminderToBuyerMutation */
export type SendPickupReminderToBuyerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  buyerId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

/** Autogenerated return type of SendPickupReminderToBuyerMutation. */
export type SendPickupReminderToBuyerMutationPayload = {
  __typename?: 'SendPickupReminderToBuyerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SetVendorDefaultAddressMutation */
export type SetVendorDefaultAddressMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Use of the default address */
  purpose: VendorAddressPurposeEnum;
  /** Vendor address identifier, or null to clear the default */
  addressId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of SetVendorDefaultAddressMutation. */
export type SetVendorDefaultAddressMutationPayload = {
  __typename?: 'SetVendorDefaultAddressMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Validation errors */
  errors?: Maybe<ValidationErrors>;
  /** Updated vendor */
  vendor?: Maybe<Vendor>;
};

/** Autogenerated input type of SetWriterProjectRoleMutation */
export type SetWriterProjectRoleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  projectId: Scalars['ID'];
  role: Scalars['String'];
  writerId: Scalars['ID'];
};

/** Autogenerated return type of SetWriterProjectRoleMutation. */
export type SetWriterProjectRoleMutationPayload = {
  __typename?: 'SetWriterProjectRoleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  writer?: Maybe<Writer>;
};

/** A shipping option available to vendors */
export enum ShippingOptionEnum {
  Dhl = 'Dhl',
  Laposte = 'Laposte',
  MondialRelay = 'MondialRelay',
  Pickup = 'pickup'
}

/** Autogenerated return type of SignIn. */
export type SignInPayload = {
  __typename?: 'SignInPayload';
  errors: Array<Error>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** Autogenerated return type of SignUp. */
export type SignUpPayload = {
  __typename?: 'SignUpPayload';
  errors: Array<Error>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** A SilverwareTableware */
export type SilverwareTableware = Node & {
  __typename?: 'SilverwareTableware';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of SplitDesireMutation */
export type SplitDesireMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  titles: Array<Scalars['String']>;
};

/** Autogenerated return type of SplitDesireMutation. */
export type SplitDesireMutationPayload = {
  __typename?: 'SplitDesireMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  desires?: Maybe<Array<Desire>>;
  errors: Array<Scalars['String']>;
};

/** Autogenerated input type of StartItemDescriptionGenerationMutation */
export type StartItemDescriptionGenerationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of StartItemDescriptionGenerationMutation. */
export type StartItemDescriptionGenerationMutationPayload = {
  __typename?: 'StartItemDescriptionGenerationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  item: Item;
};

/** Autogenerated input type of StartItemWatchDescriptionGenerationMutation */
export type StartItemWatchDescriptionGenerationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of StartItemWatchDescriptionGenerationMutation. */
export type StartItemWatchDescriptionGenerationMutationPayload = {
  __typename?: 'StartItemWatchDescriptionGenerationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  item: Item;
};

/** Snapshot of the Stripe platform balance */
export type StripeBalanceSnapshot = {
  __typename?: 'StripeBalanceSnapshot';
  /** Real available Stripe balance in EUR */
  actualStripeBalance: Scalars['Float'];
  /** Amount pending payout to Dodécade */
  belongsToDodecade: Scalars['Float'];
  /** Amount pending transfer to vendors */
  belongsToVendors: Scalars['Float'];
  /** Gap between theoretical and real balance */
  discrepancy: Scalars['Float'];
  /** Total amount of disputed VSPs */
  openDisputesAmount: Scalars['Float'];
  /** Number of VSPs with open disputes */
  openDisputesCount: Scalars['Int'];
  /** Total received minus transferred and paid out (calculated from DB) */
  theoreticalBalance: Scalars['Float'];
};

/** A Tag of Volume */
export type Tag = Node & {
  __typename?: 'Tag';
  account?: Maybe<Account>;
  auto?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Tag. */
export type TagConnection = {
  __typename?: 'TagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TagEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Tag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TagEdge = {
  __typename?: 'TagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Tag>;
};

export type TagFilter = {
  OR?: Maybe<Array<TagFilter>>;
  meta?: Maybe<Scalars['String']>;
  tagName?: Maybe<Scalars['String']>;
};

/** Objects which may belongs_to an item */
export type Template = Book | CarpetTextile | Ceramic | CoinsMedalsStamps | Engraving | FashionLuxuryAccessory | Furniture | GeographicMap | Jewelry | Manuscript | Militaria | PaintingSculpture | Photography | SilverwareTableware | ToyComicPopCulture | Watch;

/** A ThirdPartyIntroducer */
export type ThirdPartyIntroducer = Node & {
  __typename?: 'ThirdPartyIntroducer';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identityDocument?: Maybe<CustomFile>;
  lastName?: Maybe<Scalars['String']>;
  rib?: Maybe<CustomFile>;
};

/** The connection type for ThirdPartyIntroducer. */
export type ThirdPartyIntroducerConnection = {
  __typename?: 'ThirdPartyIntroducerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ThirdPartyIntroducerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ThirdPartyIntroducer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ThirdPartyIntroducerEdge = {
  __typename?: 'ThirdPartyIntroducerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ThirdPartyIntroducer>;
};

export type ThirdPartyIntroducerFilter = {
  OR?: Maybe<Array<ThirdPartyIntroducerFilter>>;
  email?: Maybe<OperatorStringFilter>;
  firstName?: Maybe<OperatorStringFilter>;
  id?: Maybe<OperatorIdFilter>;
  lastName?: Maybe<OperatorStringFilter>;
};

/** Time buckets available for analytics time series. */
export enum TimeGranularityEnum {
  /** Monthly buckets based on DATE_TRUNC('month', orders.paid_at). */
  Month = 'MONTH'
}

/** A configured pickup time range */
export type TimeRange = {
  __typename?: 'TimeRange';
  /** Configured weekday */
  day: WeekdayEnum;
  /** End time in HH:MM format */
  endTime: Scalars['String'];
  /** Start time in HH:MM format */
  startTime: Scalars['String'];
};

/** A pickup time range */
export type TimeRangeInput = {
  /** End time in HH:MM format */
  endTime: Scalars['String'];
  /** Start time in HH:MM format */
  startTime: Scalars['String'];
};

/** Optional time-series configuration for analytics metrics. */
export type TimeSeriesInput = {
  /** Time bucket size for the SQL date truncation. Currently only MONTH is supported. */
  granularity?: Maybe<TimeGranularityEnum>;
};

/** One chronological bucket for an analytics metric. */
export type TimeSeriesPoint = {
  __typename?: 'TimeSeriesPoint';
  /** Start timestamp of the bucket, for example the first day of the month. */
  period: Scalars['ISO8601DateTime'];
  /** Aggregated metric value for this period. Shape depends on the metric. */
  value?: Maybe<Scalars['JSON']>;
};

/** A ToyComicPopCulture */
export type ToyComicPopCulture = Node & {
  __typename?: 'ToyComicPopCulture';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of TriggerDodecadePayoutMutation */
export type TriggerDodecadePayoutMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** ID du DodecadeStatementPayment */
  id: Scalars['ID'];
};

/** Autogenerated return type of TriggerDodecadePayoutMutation. */
export type TriggerDodecadePayoutMutationPayload = {
  __typename?: 'TriggerDodecadePayoutMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dodecadeStatementPayment?: Maybe<DodecadeStatementPayment>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of TriggerMonthlyVendorPaymentTransferMutation */
export type TriggerMonthlyVendorPaymentTransferMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** ID du MonthlyVendorPayment */
  id: Scalars['ID'];
};

/** Autogenerated return type of TriggerMonthlyVendorPaymentTransferMutation. */
export type TriggerMonthlyVendorPaymentTransferMutationPayload = {
  __typename?: 'TriggerMonthlyVendorPaymentTransferMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  monthlyVendorPayment?: Maybe<MonthlyVendorPayment>;
};

/** Autogenerated input type of TriggerSalePayment */
export type TriggerSalePaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Force le traitement même si délai de 20 jours non écoulé */
  force?: Maybe<Scalars['Boolean']>;
  /** ID de la vente */
  saleId: Scalars['ID'];
};

/** Autogenerated return type of TriggerSalePayment. */
export type TriggerSalePaymentPayload = {
  __typename?: 'TriggerSalePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  jobId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of TriggerStripeTransferMutation */
export type TriggerStripeTransferMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** ID du VendorStatementPayment */
  id: Scalars['ID'];
};

/** Autogenerated return type of TriggerStripeTransferMutation. */
export type TriggerStripeTransferMutationPayload = {
  __typename?: 'TriggerStripeTransferMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  vendorStatementPayment?: Maybe<VendorStatementPayment>;
};

/** Autogenerated input type of UnarchiveItemCategoryMutation */
export type UnarchiveItemCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UnarchiveItemCategoryMutation. */
export type UnarchiveItemCategoryMutationPayload = {
  __typename?: 'UnarchiveItemCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  itemCategory?: Maybe<ItemCategory>;
};

/** Autogenerated input type of UnarchiveItemSubCategoryMutation */
export type UnarchiveItemSubCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UnarchiveItemSubCategoryMutation. */
export type UnarchiveItemSubCategoryMutationPayload = {
  __typename?: 'UnarchiveItemSubCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  itemSubCategory?: Maybe<ItemSubCategory>;
};

/** Autogenerated return type of UnlockAccount. */
export type UnlockAccountPayload = {
  __typename?: 'UnlockAccountPayload';
  errors: Array<Error>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

export type UnpaidOrderInfo = {
  __typename?: 'UnpaidOrderInfo';
  buyerEmail: Scalars['String'];
  buyerName: Scalars['String'];
  buyerPhone?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  daysSinceCreation: Scalars['Int'];
  id: Scalars['ID'];
  orderNumber: Scalars['String'];
  totalAmount: Scalars['Float'];
};

export type UnpaidOrdersStats = {
  __typename?: 'UnpaidOrdersStats';
  count: Scalars['Int'];
  orders: Array<UnpaidOrderInfo>;
  totalAmount: Scalars['Float'];
};

/** Attributes to update a Account. */
export type UpdateAccountInput = {
  /** birth_date */
  birthDate?: Maybe<Scalars['String']>;
  /** civility */
  civility?: Maybe<Scalars['String']>;
  /** company_name */
  companyName?: Maybe<Scalars['String']>;
  /** corporate_form */
  corporateForm?: Maybe<Scalars['String']>;
  /** email */
  email?: Maybe<Scalars['String']>;
  /** email_state (admin only) */
  emailState?: Maybe<EmailStateEnum>;
  /** first_name */
  firstName?: Maybe<Scalars['String']>;
  /** import_condition_accepted */
  importConditionAccepted?: Maybe<Scalars['Boolean']>;
  /** is_professional */
  isProfessional?: Maybe<Scalars['String']>;
  /** last_name */
  lastName?: Maybe<Scalars['String']>;
  /** phone */
  phone?: Maybe<Scalars['String']>;
  /** siret */
  siret?: Maybe<Scalars['String']>;
  /** tva_number */
  tvaNumber?: Maybe<Scalars['String']>;
  /** Vendor kind (vendor accounts) */
  vendorKind?: Maybe<VendorKindEnum>;
  /** writer_fix_fees */
  writerFixFees?: Maybe<Scalars['Float']>;
  /** writer_pourcentage_fees */
  writerPourcentageFees?: Maybe<Scalars['Float']>;
  /** writerType */
  writerType?: Maybe<Scalars['String']>;
  /** state */
  state?: Maybe<AccountStateEnum>;
  identityDocuments?: Maybe<Array<UploadFileInput>>;
  ribDocuments?: Maybe<Array<UploadFileInput>>;
};

/** Autogenerated return type of UpdateAccount. */
export type UpdateAccountPayload = {
  __typename?: 'UpdateAccountPayload';
  errors: Array<Error>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** Attributes to update a Address. */
export type UpdateAddressInput = {
  /** lang */
  addressLine1?: Maybe<Scalars['String']>;
  /** lang */
  addressLine2?: Maybe<Scalars['String']>;
  /** lang */
  addressLine3?: Maybe<Scalars['String']>;
  /** lang */
  number?: Maybe<Scalars['String']>;
  /** lang */
  companyName?: Maybe<Scalars['String']>;
  /** lang */
  email?: Maybe<Scalars['String']>;
  /** lang */
  firstName?: Maybe<Scalars['String']>;
  /** lang */
  lastName?: Maybe<Scalars['String']>;
  /** lang */
  phone1?: Maybe<Scalars['String']>;
  /** lang */
  phone2?: Maybe<Scalars['String']>;
  /** lang */
  city?: Maybe<Scalars['String']>;
  /** lang */
  country?: Maybe<Scalars['String']>;
  /** lang */
  state?: Maybe<Scalars['String']>;
  /** lang */
  zip?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateAddressMutation */
export type UpdateAddressMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateAddressInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateAddressMutation. */
export type UpdateAddressMutationPayload = {
  __typename?: 'UpdateAddressMutationPayload';
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a Artist. */
export type UpdateArtistInput = {
  /** first_name */
  firstName?: Maybe<Scalars['String']>;
  /** is_group */
  isGroup?: Maybe<Scalars['String']>;
  /** last_name */
  lastName: Scalars['String'];
  /** tag */
  tag?: Maybe<Scalars['String']>;
};

/** Attributes to update a BankInformation. */
export type UpdateBankInformationInput = {
  /** lang */
  bic?: Maybe<Scalars['String']>;
  /** lang */
  fullName?: Maybe<Scalars['String']>;
  /** lang */
  iban?: Maybe<Scalars['String']>;
  /** lang */
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateBankInformationMutation */
export type UpdateBankInformationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateBankInformationInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateBankInformationMutation. */
export type UpdateBankInformationMutationPayload = {
  __typename?: 'UpdateBankInformationMutationPayload';
  bankInformation?: Maybe<BankInformation>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a book. */
export type UpdateBookInput = {
  /** lang */
  lang?: Maybe<Scalars['String']>;
  /** assembly_specification */
  assemblySpecification?: Maybe<Scalars['String']>;
  /** assembly_type */
  assemblyType?: Maybe<Scalars['String']>;
  /** binding_color */
  bindingColor?: Maybe<Scalars['String']>;
  /** binding_format */
  bindingFormat?: Maybe<Scalars['String']>;
  /** binding_format_details */
  bindingFormatDetails?: Maybe<Scalars['String']>;
  /** binding_material */
  bindingMaterial?: Maybe<Scalars['String']>;
  /** binding_style */
  bindingStyle?: Maybe<Scalars['String']>;
  /** binding_type */
  bindingType?: Maybe<Scalars['String']>;
  /** book_spine_material */
  bookSpineMaterial?: Maybe<Scalars['String']>;
  /** book_spine_ornament */
  bookSpineOrnament1?: Maybe<Scalars['String']>;
  /** book_spine_ornament */
  bookSpineOrnament1Option?: Maybe<Scalars['String']>;
  /** book_spine_type */
  bookSpineType?: Maybe<Scalars['String']>;
  /** date_from */
  dateFrom?: Maybe<Scalars['String']>;
  /** date_option */
  dateOption?: Maybe<Scalars['String']>;
  /** date_to */
  dateTo?: Maybe<Scalars['String']>;
  /** editing_attribute */
  editingAttribute?: Maybe<Scalars['String']>;
  /** editing_attribute_details */
  editingAttributeDetails?: Maybe<Scalars['String']>;
  /** is_binding_signed */
  isBindingSigned?: Maybe<Scalars['Boolean']>;
  item?: Maybe<NestedItemInput>;
  /** paperback_type */
  paperbackType?: Maybe<Scalars['String']>;
  /** publisher_known_but_not_mentioned */
  publisherKnownButNotMentioned?: Maybe<Scalars['Boolean']>;
  /** publishers */
  publishers?: Maybe<Scalars['String']>;
  /** book_spine_ornament */
  bookSpineOrnament2?: Maybe<Scalars['String']>;
  /** book_spine_ornament */
  bookSpineOrnament2Option?: Maybe<Scalars['String']>;
  /** book_spine_ornament */
  bookSpineOrnamentOption?: Maybe<Scalars['String']>;
  /** cover_material */
  coverMaterial?: Maybe<Scalars['String']>;
  /** cover_ornament */
  coverOrnament1?: Maybe<Scalars['String']>;
  /** cover_ornament */
  coverOrnament1Option?: Maybe<Scalars['String']>;
  /** cover_ornament2 */
  coverOrnament2?: Maybe<Scalars['String']>;
  /** cover_ornament */
  coverOrnament2Option?: Maybe<Scalars['String']>;
  /** cover_ornament_option */
  coverOrnamentOption?: Maybe<Scalars['String']>;
  /** cover_color */
  coverColor?: Maybe<Scalars['String']>;
  /** cover_quality */
  coverQuality?: Maybe<Scalars['String']>;
  /** binding_format */
  coverType?: Maybe<Scalars['String']>;
  /** edge_color */
  edgeColor?: Maybe<Scalars['String']>;
  /** edge_style */
  edgeStyle?: Maybe<Scalars['String']>;
  /** edge_type */
  edgeType?: Maybe<Scalars['String']>;
  bibliographyComment?: Maybe<Scalars['String']>;
  collationComment?: Maybe<Scalars['String']>;
  illustrationComment?: Maybe<Scalars['String']>;
  isApproximatelyPaginating?: Maybe<Scalars['Boolean']>;
  isPaginating?: Maybe<Scalars['Boolean']>;
  paginationInfo?: Maybe<Scalars['String']>;
  /** binding_format */
  bindingAdditionalOptions?: Maybe<Scalars['String']>;
  /** binding_format */
  bindingAge?: Maybe<Scalars['String']>;
  /** binding_format */
  bindingMaterialOptions?: Maybe<Scalars['String']>;
  /** binding_format */
  bindingTypeOptions?: Maybe<Scalars['String']>;
  /** binding_format */
  bookBinder?: Maybe<Scalars['String']>;
  /** casing_type */
  casingType?: Maybe<Scalars['String']>;
  /** dumb_spine */
  dumbSpine?: Maybe<Scalars['Boolean']>;
  /** is_oblong */
  isOblong?: Maybe<Scalars['Boolean']>;
  /** binding_format */
  size?: Maybe<Scalars['String']>;
  /** with_folder */
  withFolder?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateBookMutation */
export type UpdateBookMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateBookInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateBookMutation. */
export type UpdateBookMutationPayload = {
  __typename?: 'UpdateBookMutationPayload';
  book?: Maybe<Book>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a Business Introducer. */
export type UpdateBusinessIntroducerInput = {
  /** email */
  email?: Maybe<Scalars['String']>;
  /** first_name */
  firstName?: Maybe<Scalars['String']>;
  /** identity_document */
  identityDocument?: Maybe<UploadFileInput>;
  /** last_name */
  lastName?: Maybe<Scalars['String']>;
  /** phone */
  phone?: Maybe<Scalars['String']>;
  /** rib */
  rib?: Maybe<UploadFileInput>;
};

/** Autogenerated input type of UpdateBusinessIntroducerMutation */
export type UpdateBusinessIntroducerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateBusinessIntroducerInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateBusinessIntroducerMutation. */
export type UpdateBusinessIntroducerMutationPayload = {
  __typename?: 'UpdateBusinessIntroducerMutationPayload';
  businessIntroducer?: Maybe<BusinessIntroducer>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a CarpetTextile. */
export type UpdateCarpetTextileInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCarpetTextileMutation */
export type UpdateCarpetTextileMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateCarpetTextileInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateCarpetTextileMutation. */
export type UpdateCarpetTextileMutationPayload = {
  __typename?: 'UpdateCarpetTextileMutationPayload';
  carpetTextile?: Maybe<CarpetTextile>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a Ceramic. */
export type UpdateCeramicInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCeramicMutation */
export type UpdateCeramicMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateCeramicInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateCeramicMutation. */
export type UpdateCeramicMutationPayload = {
  __typename?: 'UpdateCeramicMutationPayload';
  ceramic?: Maybe<Ceramic>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a CoinsMedalsStamps. */
export type UpdateCoinsMedalsStampsInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCoinsMedalsStampsMutation */
export type UpdateCoinsMedalsStampsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateCoinsMedalsStampsInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateCoinsMedalsStampsMutation. */
export type UpdateCoinsMedalsStampsMutationPayload = {
  __typename?: 'UpdateCoinsMedalsStampsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  coinsMedalsStamps?: Maybe<CoinsMedalsStamps>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a Customer. */
export type UpdateCustomerInput = {
  /** Description */
  addressLine1?: Maybe<Scalars['String']>;
  /** Description */
  addressLine2?: Maybe<Scalars['String']>;
  /** Description */
  addressLine3?: Maybe<Scalars['String']>;
  /** Description */
  city?: Maybe<Scalars['String']>;
  /** Description */
  country?: Maybe<Scalars['String']>;
  /** desires */
  desires?: Maybe<Scalars['String']>;
  /** Description */
  email: Scalars['String'];
  /** email_state (admin only) */
  emailState?: Maybe<EmailStateEnum>;
  /** Description */
  firstName?: Maybe<Scalars['String']>;
  /** Description */
  fullName?: Maybe<Scalars['String']>;
  /** Description */
  lastName?: Maybe<Scalars['String']>;
  /** Description */
  phone1?: Maybe<Scalars['String']>;
  /** Description */
  phone2?: Maybe<Scalars['String']>;
  /** Description */
  zip?: Maybe<Scalars['String']>;
  itemCategories?: Maybe<NestedItemCategoryInput>;
  itemSubCategories?: Maybe<NestedItemSubCategoryInput>;
  tags?: Maybe<NestedTagInput>;
};

/** Autogenerated input type of UpdateCustomerMutation */
export type UpdateCustomerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateCustomerInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateCustomerMutation. */
export type UpdateCustomerMutationPayload = {
  __typename?: 'UpdateCustomerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a Desire. */
export type UpdateDesireInput = {
  searchArtistsEnabled?: Maybe<Scalars['Boolean']>;
  searchDescriptionEnabled?: Maybe<Scalars['Boolean']>;
  searchTagsEnabled?: Maybe<Scalars['Boolean']>;
  searchTitleEnabled?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<NestedTagInput>;
  /** name */
  title?: Maybe<Scalars['String']>;
  validated?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateDesireMutation */
export type UpdateDesireMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateDesireInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateDesireMutation. */
export type UpdateDesireMutationPayload = {
  __typename?: 'UpdateDesireMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  desire?: Maybe<Desire>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a Engraving. */
export type UpdateEngravingInput = {
  /** lang */
  lang?: Maybe<Scalars['String']>;
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of UpdateEngravingMutation */
export type UpdateEngravingMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateEngravingInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateEngravingMutation. */
export type UpdateEngravingMutationPayload = {
  __typename?: 'UpdateEngravingMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  engraving?: Maybe<Engraving>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a ExpertPayment. */
export type UpdateExpertPaymentInput = {
  invoices?: Maybe<Array<UploadFileInput>>;
  /** paid */
  paid?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateExpertPaymentMutation */
export type UpdateExpertPaymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateExpertPaymentInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateExpertPaymentMutation. */
export type UpdateExpertPaymentMutationPayload = {
  __typename?: 'UpdateExpertPaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  expertPayment?: Maybe<ExpertPayment>;
};

/** Attributes to update a ExpertStatementPayment. */
export type UpdateExpertStatementPaymentInput = {
  invoices?: Maybe<Array<UploadFileInput>>;
  /** paid */
  paid?: Maybe<Scalars['Boolean']>;
  /** payment_date */
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  purgeBlobIds?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of UpdateExpertStatementPaymentMutation */
export type UpdateExpertStatementPaymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateExpertStatementPaymentInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateExpertStatementPaymentMutation. */
export type UpdateExpertStatementPaymentMutationPayload = {
  __typename?: 'UpdateExpertStatementPaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  expertStatementPayment?: Maybe<ExpertStatementPayment>;
};

/** Attributes to update a FashionLuxuryAccessory. */
export type UpdateFashionLuxuryAccessoryInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateFashionLuxuryAccessoryMutation */
export type UpdateFashionLuxuryAccessoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateFashionLuxuryAccessoryInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateFashionLuxuryAccessoryMutation. */
export type UpdateFashionLuxuryAccessoryMutationPayload = {
  __typename?: 'UpdateFashionLuxuryAccessoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  fashionLuxuryAccessory?: Maybe<FashionLuxuryAccessory>;
};

/** Attributes to update a Furniture. */
export type UpdateFurnitureInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateFurnitureMutation */
export type UpdateFurnitureMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateFurnitureInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateFurnitureMutation. */
export type UpdateFurnitureMutationPayload = {
  __typename?: 'UpdateFurnitureMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  furniture?: Maybe<Furniture>;
};

/** Attributes to update a GeographicMap. */
export type UpdateGeographicMapInput = {
  /** lang */
  lang?: Maybe<Scalars['String']>;
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of UpdateGeographicMapMutation */
export type UpdateGeographicMapMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateGeographicMapInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateGeographicMapMutation. */
export type UpdateGeographicMapMutationPayload = {
  __typename?: 'UpdateGeographicMapMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  geographicMap?: Maybe<GeographicMap>;
};

export type UpdateImportPaymentInput = {
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  paid?: Maybe<Scalars['Boolean']>;
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of UpdateImportPaymentMutation */
export type UpdateImportPaymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateImportPaymentInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateImportPaymentMutation. */
export type UpdateImportPaymentMutationPayload = {
  __typename?: 'UpdateImportPaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  importPayment?: Maybe<ImportPayment>;
};

/** Attributes to update a ImportStatementPayment. */
export type UpdateImportStatementPaymentInput = {
  invoices?: Maybe<Array<UploadFileInput>>;
  /** paid */
  paid?: Maybe<Scalars['Boolean']>;
  /** payment_date */
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  purgeBlobIds?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of UpdateImportStatementPaymentMutation */
export type UpdateImportStatementPaymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateImportStatementPaymentInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateImportStatementPaymentMutation. */
export type UpdateImportStatementPaymentMutationPayload = {
  __typename?: 'UpdateImportStatementPaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  importStatementPayment?: Maybe<ImportStatementPayment>;
};

/** Autogenerated input type of UpdateItemCategoryMutation */
export type UpdateItemCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  externalRainworxId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateItemCategoryMutation. */
export type UpdateItemCategoryMutationPayload = {
  __typename?: 'UpdateItemCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  itemCategory?: Maybe<ItemCategory>;
};

/** Autogenerated input type of UpdateItemExpertMutation */
export type UpdateItemExpertMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  expertId: Scalars['ID'];
};

/** Autogenerated return type of UpdateItemExpertMutation. */
export type UpdateItemExpertMutationPayload = {
  __typename?: 'UpdateItemExpertMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  item?: Maybe<Item>;
};

/** Attributes to update a user. */
export type UpdateItemInput = {
  artistCollectif?: Maybe<Scalars['Boolean']>;
  artistKnownButNotMentioned?: Maybe<Scalars['Boolean']>;
  artistUnknown?: Maybe<Scalars['Boolean']>;
  artists?: Maybe<NestedArtistInput>;
  authenticityDocuments?: Maybe<Array<UploadFileInput>>;
  catchPhrase?: Maybe<Scalars['String']>;
  catchPhraseEnabled?: Maybe<Scalars['Boolean']>;
  conditionAccepted?: Maybe<Scalars['Boolean']>;
  conditionsComment?: Maybe<Scalars['String']>;
  customDescription?: Maybe<Scalars['String']>;
  customDescriptionEnabled?: Maybe<Scalars['Boolean']>;
  autoDescription?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateOption?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
  highEstimatedPrice?: Maybe<Scalars['Float']>;
  lowEstimatedPrice?: Maybe<Scalars['Float']>;
  expertId?: Maybe<Scalars['ID']>;
  globalComment?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  images?: Maybe<Array<UploadImageInput>>;
  /** Ids (Image.id) des images à supprimer */
  imageIdsToDelete?: Maybe<Array<Scalars['ID']>>;
  /** Ordre complet souhaité des images, par id (Image.id). Les positions sont renumérotées 0..N-1 */
  imageOrder?: Maybe<Array<Scalars['ID']>>;
  invoices?: Maybe<Array<UploadFileInput>>;
  itemCategoryId?: Maybe<Scalars['String']>;
  itemSubCategoryId?: Maybe<Scalars['String']>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Float']>;
  locationKnownButNotMentioned?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Scalars['String']>;
  lotId?: Maybe<Scalars['Int']>;
  otherComment?: Maybe<Scalars['String']>;
  reservedPrice?: Maybe<Scalars['Float']>;
  customSkuPart?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  startingPrice?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tags?: Maybe<NestedTagInput>;
  /** The template id */
  templateId?: Maybe<Scalars['Int']>;
  /** saleTitle */
  saleTitle?: Maybe<Scalars['String']>;
  /** Title */
  title?: Maybe<Scalars['String']>;
  saleId?: Maybe<Scalars['ID']>;
  /** Vente CP pour laquelle l'objet est préparé (sans effet sur son statut) */
  plannedSaleId?: Maybe<Scalars['ID']>;
  /** Position manuelle du lot dans la vente */
  salePosition?: Maybe<Scalars['Int']>;
  vacationId?: Maybe<Scalars['ID']>;
  vendorId?: Maybe<Scalars['ID']>;
  writerId?: Maybe<Scalars['ID']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  /** Number of identical articles the weight applies to */
  unitCount?: Maybe<Scalars['Int']>;
  /** Title */
  descriptionFooter?: Maybe<Scalars['String']>;
  /** Title */
  descriptionHeader?: Maybe<Scalars['String']>;
  /** Title */
  descriptionSource?: Maybe<Scalars['String']>;
  /** Title */
  descriptionSuggestion?: Maybe<Scalars['String']>;
  /** Title */
  descriptionSuggestionGeneratedAt?: Maybe<Scalars['String']>;
  /** Title */
  generationError?: Maybe<Scalars['String']>;
  /** Title */
  generationStatus?: Maybe<Scalars['String']>;
  /** mode */
  mode?: Maybe<Scalars['String']>;
};

/** Attributes to update a user. */
export type UpdateItemMovementInput = {
  accountId?: Maybe<Scalars['ID']>;
  locationFrom?: Maybe<Scalars['String']>;
  locationTo?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateItemMovementMutation */
export type UpdateItemMovementMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateItemMovementInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateItemMovementMutation. */
export type UpdateItemMovementMutationPayload = {
  __typename?: 'UpdateItemMovementMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  itemMovement?: Maybe<ItemMovement>;
};

/** Autogenerated input type of UpdateItemMutation */
export type UpdateItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateItemInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateItemMutation. */
export type UpdateItemMutationPayload = {
  __typename?: 'UpdateItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  item: Item;
};

/** Attributes to update an item step. */
export type UpdateItemStepInput = {
  /** comment */
  comment?: Maybe<Scalars['String']>;
  /** number */
  number?: Maybe<Scalars['Int']>;
  /** state */
  state?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateItemStepMutation */
export type UpdateItemStepMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateItemStepInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateItemStepMutation. */
export type UpdateItemStepMutationPayload = {
  __typename?: 'UpdateItemStepMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  itemStep?: Maybe<ItemStep>;
};

/** Autogenerated input type of UpdateItemSubCategoryMutation */
export type UpdateItemSubCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  externalRainworxId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  itemCategoryId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateItemSubCategoryMutation. */
export type UpdateItemSubCategoryMutationPayload = {
  __typename?: 'UpdateItemSubCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  itemSubCategory?: Maybe<ItemSubCategory>;
};

/** Attributes to update a Jewelry. */
export type UpdateJewelryInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateJewelryMutation */
export type UpdateJewelryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateJewelryInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateJewelryMutation. */
export type UpdateJewelryMutationPayload = {
  __typename?: 'UpdateJewelryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  jewelry?: Maybe<Jewelry>;
};

/** Attributes to update a Manuscript. */
export type UpdateManuscriptInput = {
  /** lang */
  lang?: Maybe<Scalars['String']>;
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of UpdateManuscriptMutation */
export type UpdateManuscriptMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateManuscriptInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateManuscriptMutation. */
export type UpdateManuscriptMutationPayload = {
  __typename?: 'UpdateManuscriptMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  manuscript?: Maybe<Manuscript>;
};

/** Attributes to update a Militaria. */
export type UpdateMilitariaInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateMilitariaMutation */
export type UpdateMilitariaMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateMilitariaInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateMilitariaMutation. */
export type UpdateMilitariaMutationPayload = {
  __typename?: 'UpdateMilitariaMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  militaria?: Maybe<Militaria>;
};

/** Attributes to update a MonthlyVendorPayment. */
export type UpdateMonthlyVendorPaymentInput = {
  invoices?: Maybe<Array<UploadFileInput>>;
  /** paid */
  paid?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateMonthlyVendorPaymentMutation */
export type UpdateMonthlyVendorPaymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateMonthlyVendorPaymentInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateMonthlyVendorPaymentMutation. */
export type UpdateMonthlyVendorPaymentMutationPayload = {
  __typename?: 'UpdateMonthlyVendorPaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  monthlyVendorPayment?: Maybe<MonthlyVendorPayment>;
};

/** Attributes to update a OrderItem. */
export type UpdateOrderInput = {
  /** comment */
  comment?: Maybe<Scalars['String']>;
  /** state */
  state?: Maybe<Scalars['String']>;
  /** Vendor comment about pickup location */
  vendorComment?: Maybe<Scalars['String']>;
};

/** Attributes to update a OrderItem. */
export type UpdateOrderItemInput = {
  /** state */
  state?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateOrderItemMutation */
export type UpdateOrderItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateOrderItemInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateOrderItemMutation. */
export type UpdateOrderItemMutationPayload = {
  __typename?: 'UpdateOrderItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  orderItem?: Maybe<OrderItem>;
};

/** Autogenerated input type of UpdateOrderMutation */
export type UpdateOrderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateOrderInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateOrderMutation. */
export type UpdateOrderMutationPayload = {
  __typename?: 'UpdateOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  order?: Maybe<Order>;
};

/** Attributes to update a PaintingSculpture. */
export type UpdatePaintingSculptureInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdatePaintingSculptureMutation */
export type UpdatePaintingSculptureMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdatePaintingSculptureInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdatePaintingSculptureMutation. */
export type UpdatePaintingSculptureMutationPayload = {
  __typename?: 'UpdatePaintingSculptureMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  paintingSculpture?: Maybe<PaintingSculpture>;
};

/** Attributes to update a Photography. */
export type UpdatePhotographyInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdatePhotographyMutation */
export type UpdatePhotographyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdatePhotographyInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdatePhotographyMutation. */
export type UpdatePhotographyMutationPayload = {
  __typename?: 'UpdatePhotographyMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  photography?: Maybe<Photography>;
};

/** Attributes to update a Project Fee. */
export type UpdateProjectFeeInput = {
  /** title */
  name: Scalars['String'];
  /** title */
  value: Scalars['Float'];
  projectId: Scalars['ID'];
};

/** Autogenerated input type of UpdateProjectFeeMutation */
export type UpdateProjectFeeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateProjectFeeInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateProjectFeeMutation. */
export type UpdateProjectFeeMutationPayload = {
  __typename?: 'UpdateProjectFeeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  projectFee?: Maybe<ProjectFee>;
};

/** Attributes to update a Project. */
export type UpdateProjectInput = {
  /** exclusif */
  exclusif?: Maybe<Scalars['Boolean']>;
  /** is_classic_sale */
  isClassicSale?: Maybe<Scalars['Boolean']>;
  /** item_number_start */
  itemNumberStart?: Maybe<Scalars['String']>;
  /** number */
  number?: Maybe<Scalars['String']>;
  /** sharing_profit */
  sharingProfit?: Maybe<Scalars['Boolean']>;
  /** title */
  title?: Maybe<Scalars['String']>;
  /** auctioneer_number */
  auctioneerNumber?: Maybe<Scalars['String']>;
  /** business_introducer_id */
  businessIntroducerId?: Maybe<Scalars['ID']>;
  /** business_introducer_share_percentage */
  businessIntroducerSharePercentage?: Maybe<Scalars['Float']>;
  buyerFeePercentage?: Maybe<Scalars['Float']>;
  /** comment */
  comment?: Maybe<Scalars['String']>;
  /** dodecade_share_percentage */
  dodecadeSharePercentage?: Maybe<Scalars['Float']>;
  expertiseFeePercentage?: Maybe<Scalars['Float']>;
  /** expertise_firm_share_percentage */
  expertiseFirmSharePercentage?: Maybe<Scalars['Float']>;
  /** manual_deposit_slip_url */
  manualDepositSlipUrl?: Maybe<UploadFileInput>;
  thirdPartyIntroducerId?: Maybe<Scalars['ID']>;
  thirdPartyIntroducerSharePercentage?: Maybe<Scalars['Float']>;
  vendorFeePercentage?: Maybe<Scalars['Float']>;
  writerFeePercentage?: Maybe<Scalars['Float']>;
  writerFixFees?: Maybe<Scalars['Float']>;
  vendorId?: Maybe<Scalars['ID']>;
  items?: Maybe<NestedItemInput>;
  state?: Maybe<Scalars['String']>;
  writers?: Maybe<NestedWriterInput>;
};

/** Attributes to update a ProjectIntroducerPayment. */
export type UpdateProjectIntroducerPaymentInput = {
  invoices?: Maybe<Array<UploadFileInput>>;
  /** paid */
  paid?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateProjectIntroducerPaymentMutation */
export type UpdateProjectIntroducerPaymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateProjectIntroducerPaymentInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateProjectIntroducerPaymentMutation. */
export type UpdateProjectIntroducerPaymentMutationPayload = {
  __typename?: 'UpdateProjectIntroducerPaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  projectIntroducerPayment?: Maybe<ProjectIntroducerPayment>;
};

/** Autogenerated input type of UpdateProjectMutation */
export type UpdateProjectMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateProjectInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateProjectMutation. */
export type UpdateProjectMutationPayload = {
  __typename?: 'UpdateProjectMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  project?: Maybe<Project>;
};

/** Attributes to update a QuickText. */
export type UpdateQuickTextInput = {
  accountId?: Maybe<Scalars['ID']>;
  /** text */
  text?: Maybe<Scalars['String']>;
  /** title */
  title?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateQuickTextMutation */
export type UpdateQuickTextMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateQuickTextInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateQuickTextMutation. */
export type UpdateQuickTextMutationPayload = {
  __typename?: 'UpdateQuickTextMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  quickText?: Maybe<QuickText>;
};

/** Attributes to update a Sale. */
export type UpdateSaleInput = {
  /** description */
  description?: Maybe<Scalars['String']>;
  /** blob_id_to_remove */
  drouotCsvBlobIdToRemove?: Maybe<Scalars['String']>;
  /** blob_id_to_remove */
  drouotImageBlobIdToRemove?: Maybe<Scalars['String']>;
  /** end_at */
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** estimated_price_enabled */
  estimatedPriceEnabled?: Maybe<Scalars['Boolean']>;
  /** external_event_rainworx_id */
  externalEventRainworxId?: Maybe<Scalars['Int']>;
  image?: Maybe<UploadImageInput>;
  /** name */
  name?: Maybe<Scalars['String']>;
  /** HTML header for the newsletter */
  newsletterHeaderHtml?: Maybe<Scalars['String']>;
  /** start_at */
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** state */
  state?: Maybe<Scalars['String']>;
  /** Subject for the newsletter */
  subject?: Maybe<Scalars['String']>;
  /** Subject for the newsletter when the sale, is ending soon */
  subjectEndingSoon?: Maybe<Scalars['String']>;
  /** type_of_sale */
  typeOfSale?: Maybe<Scalars['String']>;
  expertId?: Maybe<Scalars['ID']>;
  /** Replaces the writers assigned to the sale */
  writerIds?: Maybe<Array<Scalars['ID']>>;
  items?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of UpdateSaleMutation */
export type UpdateSaleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateSaleInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateSaleMutation. */
export type UpdateSaleMutationPayload = {
  __typename?: 'UpdateSaleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sale?: Maybe<Sale>;
};

/** Attributes to update a SilverwareTableware. */
export type UpdateSilverwareTablewareInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateSilverwareTablewareMutation */
export type UpdateSilverwareTablewareMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateSilverwareTablewareInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateSilverwareTablewareMutation. */
export type UpdateSilverwareTablewareMutationPayload = {
  __typename?: 'UpdateSilverwareTablewareMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  silverwareTableware?: Maybe<SilverwareTableware>;
};

/** Attributes to update a Tag. */
export type UpdateTagInput = {
  /** name */
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateTagMutation */
export type UpdateTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateTagInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateTagMutation. */
export type UpdateTagMutationPayload = {
  __typename?: 'UpdateTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  tag?: Maybe<Tag>;
};

/** Attributes to update a ThirdParty Introducer. */
export type UpdateThirdPartyIntroducerInput = {
  /** email */
  email?: Maybe<Scalars['String']>;
  /** first_name */
  firstName?: Maybe<Scalars['String']>;
  /** identity_document */
  identityDocument?: Maybe<UploadFileInput>;
  /** last_name */
  lastName?: Maybe<Scalars['String']>;
  /** phone */
  phone?: Maybe<Scalars['String']>;
  /** rib */
  rib?: Maybe<UploadFileInput>;
};

/** Autogenerated input type of UpdateThirdPartyIntroducerMutation */
export type UpdateThirdPartyIntroducerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateThirdPartyIntroducerInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateThirdPartyIntroducerMutation. */
export type UpdateThirdPartyIntroducerMutationPayload = {
  __typename?: 'UpdateThirdPartyIntroducerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  thirdPartyIntroducer?: Maybe<ThirdPartyIntroducer>;
};

/** Attributes to update a ToyComicPopCulture. */
export type UpdateToyComicPopCultureInput = {
  /** Nested item attributes */
  item?: Maybe<NestedItemInput>;
  /** lang */
  lang?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateToyComicPopCultureMutation */
export type UpdateToyComicPopCultureMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateToyComicPopCultureInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateToyComicPopCultureMutation. */
export type UpdateToyComicPopCultureMutationPayload = {
  __typename?: 'UpdateToyComicPopCultureMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  toyComicPopCulture?: Maybe<ToyComicPopCulture>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UserUpdateInput;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateUserRole */
export type UpdateUserRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** "user" or "admin" or "expert" or "vendor" */
  role: Scalars['String'];
};

/** Attributes to update a Vacation. */
export type UpdateVacationInput = {
  /** description */
  description?: Maybe<Scalars['String']>;
  /** end_at */
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  image?: Maybe<UploadImageInput>;
  /** name */
  name?: Maybe<Scalars['String']>;
  /** start_at */
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** state */
  state?: Maybe<Scalars['String']>;
  expertId?: Maybe<Scalars['ID']>;
  items?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of UpdateVacationMutation */
export type UpdateVacationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateVacationInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateVacationMutation. */
export type UpdateVacationMutationPayload = {
  __typename?: 'UpdateVacationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  vacation?: Maybe<Vacation>;
};

/** Autogenerated input type of UpdateVendorAddressMutation */
export type UpdateVendorAddressMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Vendor address identifier */
  id: Scalars['ID'];
  /** Updated vendor address attributes */
  attributes: VendorAddressInput;
};

/** Autogenerated return type of UpdateVendorAddressMutation. */
export type UpdateVendorAddressMutationPayload = {
  __typename?: 'UpdateVendorAddressMutationPayload';
  /** Updated vendor address */
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Validation errors */
  errors?: Maybe<ValidationErrors>;
};

/** Autogenerated input type of UpdateVendorPickupHoursMutation */
export type UpdateVendorPickupHoursMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether pickup should also be activated */
  activatePickup?: Maybe<Scalars['Boolean']>;
  /** Pickup hours grouped by weekday */
  pickupHours: Array<DayInput>;
};

/** Autogenerated return type of UpdateVendorPickupHoursMutation. */
export type UpdateVendorPickupHoursMutationPayload = {
  __typename?: 'UpdateVendorPickupHoursMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Validation errors */
  errors?: Maybe<ValidationErrors>;
  /** Updated vendor pickup time ranges */
  vendorPickupTimeRanges?: Maybe<Array<TimeRange>>;
};

/** Autogenerated input type of UpdateVendorShippingMethodsMutation */
export type UpdateVendorShippingMethodsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Shipping options to enable for the current vendor */
  shippingOptions: Array<ShippingOptionEnum>;
};

/** Autogenerated return type of UpdateVendorShippingMethodsMutation. */
export type UpdateVendorShippingMethodsMutationPayload = {
  __typename?: 'UpdateVendorShippingMethodsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Validation errors */
  errors?: Maybe<ValidationErrors>;
  /** Updated vendor shipping methods */
  shippingMethods: Array<VendorShippingMethod>;
};

/** Attributes to update a VendorStatementPayment. */
export type UpdateVendorStatementPaymentInput = {
  /** paid */
  paid?: Maybe<Scalars['Boolean']>;
  /** payment_date */
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of UpdateVendorStatementPaymentMutation */
export type UpdateVendorStatementPaymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateVendorStatementPaymentInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateVendorStatementPaymentMutation. */
export type UpdateVendorStatementPaymentMutationPayload = {
  __typename?: 'UpdateVendorStatementPaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  vendorStatementPayment?: Maybe<VendorStatementPayment>;
};

/** Attributes to update some Volumes and parts. */
export type UpdateVolumeInput = {
  /** book_id */
  bookId: Scalars['String'];
  /** nb_parts */
  nbParts: Scalars['Int'];
  /** nb_volumes */
  nbVolumes: Scalars['Int'];
};

/** Autogenerated input type of UpdateVolumeMutation */
export type UpdateVolumeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateVolumeInput;
};

/** Autogenerated return type of UpdateVolumeMutation. */
export type UpdateVolumeMutationPayload = {
  __typename?: 'UpdateVolumeMutationPayload';
  book?: Maybe<Book>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
};

/** Attributes to update a Watch. */
export type UpdateWatchInput = {
  /** lang */
  lang?: Maybe<Scalars['String']>;
  item?: Maybe<NestedItemInput>;
};

/** Autogenerated input type of UpdateWatchMutation */
export type UpdateWatchMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateWatchInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateWatchMutation. */
export type UpdateWatchMutationPayload = {
  __typename?: 'UpdateWatchMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  watch?: Maybe<Watch>;
};

/** Attributes to update a Writer. */
export type UpdateWriterInput = {
  /** The account id */
  accountId?: Maybe<Scalars['Int']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
};

/** Attributes to update a WriterPayment. */
export type UpdateWriterPaymentInput = {
  invoices?: Maybe<Array<UploadFileInput>>;
  /** paid */
  paid?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateWriterPaymentMutation */
export type UpdateWriterPaymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateWriterPaymentInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateWriterPaymentMutation. */
export type UpdateWriterPaymentMutationPayload = {
  __typename?: 'UpdateWriterPaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  writerPayment?: Maybe<WriterPayment>;
};

/** Attributes to update a WriterStatementPayment. */
export type UpdateWriterStatementPaymentInput = {
  invoices?: Maybe<Array<UploadFileInput>>;
  /** paid */
  paid?: Maybe<Scalars['Boolean']>;
  /** payment_date */
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  purgeBlobIds?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of UpdateWriterStatementPaymentMutation */
export type UpdateWriterStatementPaymentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateWriterStatementPaymentInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateWriterStatementPaymentMutation. */
export type UpdateWriterStatementPaymentMutationPayload = {
  __typename?: 'UpdateWriterStatementPaymentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  writerStatementPayment?: Maybe<WriterStatementPayment>;
};


export type UploadFileInput = {
  file: Scalars['Upload'];
};

export type UploadImageInput = {
  image: Scalars['Upload'];
};

/** A User */
export type User = Node & {
  __typename?: 'User';
  accountTypes?: Maybe<Array<Scalars['String']>>;
  accounts: AccountConnection;
  createdAt: Scalars['ISO8601DateTime'];
  currentRole: Role;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  lastAccountTypeUsed?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendorLink?: Maybe<Vendor>;
};


/** A User */
export type UserAccountsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  accountableType?: Maybe<Scalars['String']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserFilter = {
  OR?: Maybe<Array<UserFilter>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

/** Attributes to update a user. */
export type UserUpdateInput = {
  /** Email of user */
  email?: Maybe<Scalars['String']>;
  /** Firstname of user */
  firstName?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['Upload']>;
  /** Lastname of user */
  lastName?: Maybe<Scalars['String']>;
  /** Password of user */
  password?: Maybe<Scalars['String']>;
};

/** A Vacation */
export type Vacation = Node & {
  __typename?: 'Vacation';
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  expert?: Maybe<Expert>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  items?: Maybe<ItemConnection>;
  lots?: Maybe<LotConnection>;
  name?: Maybe<Scalars['String']>;
  nbItems?: Maybe<Scalars['Int']>;
  nbUnpaidEligible?: Maybe<Scalars['Int']>;
  nbUnsoldEligible?: Maybe<Scalars['Int']>;
  project?: Maybe<Project>;
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  vacation?: Maybe<Vacation>;
};


/** A Vacation */
export type VacationItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A Vacation */
export type VacationLotsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Vacation. */
export type VacationConnection = {
  __typename?: 'VacationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VacationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Vacation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VacationEdge = {
  __typename?: 'VacationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Vacation>;
};

export type VacationFilter = {
  OR?: Maybe<Array<VacationFilter>>;
  meta?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  projectId?: Maybe<OperatorIdFilter>;
  state?: Maybe<Scalars['String']>;
  vacationName?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ValidateSaleItemsMutation */
export type ValidateSaleItemsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  saleId: Scalars['ID'];
};

/** Autogenerated return type of ValidateSaleItemsMutation. */
export type ValidateSaleItemsMutationPayload = {
  __typename?: 'ValidateSaleItemsMutationPayload';
  blockingItems: Array<Item>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  sale?: Maybe<Sale>;
  validatedCount: Scalars['Int'];
};

/** Autogenerated return type of ValidateToken. */
export type ValidateTokenPayload = {
  __typename?: 'ValidateTokenPayload';
  errors: Array<Error>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
  valid: Scalars['Boolean'];
};

export type ValidationErrors = {
  __typename?: 'ValidationErrors';
  details: Scalars['String'];
  fullMessages: Array<Scalars['String']>;
};

/** An Vendor */
export type Vendor = Node & {
  __typename?: 'Vendor';
  account: Account;
  /** Paginated vendor address book */
  addresses: AddressConnection;
  createdAt: Scalars['ISO8601DateTime'];
  /** Default vendor billing address */
  defaultBillingAddress?: Maybe<Address>;
  /** Default address used for pickups */
  defaultPickupAddress?: Maybe<Address>;
  /** Default address displayed on the vendor profile */
  defaultProfileAddress?: Maybe<Address>;
  /** Default address used as sender for vendor shipments */
  defaultShippingAddress?: Maybe<Address>;
  description?: Maybe<Scalars['String']>;
  externalRainworxId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  items?: Maybe<ItemConnection>;
  /** Type de vendeur */
  kind: VendorKindEnum;
  /** Commandes payées depuis 3 à 5 jours non expédiées */
  lateOrders3DaysCount: Scalars['Int'];
  /** Commandes payées depuis > 5 jours non expédiées */
  lateOrders5DaysCount: Scalars['Int'];
  /** Commandes pickup payées depuis 3 à 5 jours non récupérées */
  latePickups3DaysCount: Scalars['Int'];
  /** Commandes pickup payées depuis > 5 jours non récupérées */
  latePickups5DaysCount: Scalars['Int'];
  /** Nombre de commandes payées en attente de retrait en magasin */
  ordersToPickupCount: Scalars['Int'];
  /** Nombre de commandes payées à expédier (hors retrait) */
  ordersToShipCount: Scalars['Int'];
  /** Pickup hours grouped by weekday */
  pickupHours: Array<Day>;
  /** Shipping options configured for the vendor */
  shippingOptions: Array<ShippingOptionEnum>;
  stripeConnectAccountId?: Maybe<Scalars['String']>;
  stripeConnectOnboardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt: Scalars['ISO8601DateTime'];
  /** Statistiques financières agrégées du vendor */
  vendorFinancialStats: VendorFinancialStats;
  vendorPlan?: Maybe<VendorPlan>;
};


/** An Vendor */
export type VendorAddressesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};


/** An Vendor */
export type VendorItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export enum VendorAccountingExportDateBasisEnum {
  /** Date de paiement vendeur */
  PaymentDate = 'PAYMENT_DATE',
  /** Date de vente */
  SaleDate = 'SALE_DATE'
}

/** Attributes of a vendor address */
export type VendorAddressInput = {
  /** Optional address name */
  name?: Maybe<Scalars['String']>;
  /** Contact first name */
  firstName: Scalars['String'];
  /** Contact last name */
  lastName: Scalars['String'];
  /** Company name */
  companyName?: Maybe<Scalars['String']>;
  /** Main address line */
  addressLine1: Scalars['String'];
  /** Additional address line */
  addressLine2?: Maybe<Scalars['String']>;
  /** Additional address line */
  addressLine3?: Maybe<Scalars['String']>;
  /** City */
  city: Scalars['String'];
  /** State or region */
  state?: Maybe<Scalars['String']>;
  /** Postal code */
  zip: Scalars['String'];
  /** Country code */
  country: Scalars['String'];
  /** Primary phone number */
  phone1: Scalars['String'];
  /** Secondary phone number */
  phone2?: Maybe<Scalars['String']>;
  /** Contact email address */
  email: Scalars['String'];
};

/** Possible uses for a vendor default address */
export enum VendorAddressPurposeEnum {
  /** Default address displayed on the vendor profile */
  Profile = 'PROFILE',
  /** Default vendor billing address */
  Billing = 'BILLING',
  /** Default address used for pickups */
  Pickup = 'PICKUP',
  /** Default address used as sender for vendor shipments */
  Shipping = 'SHIPPING'
}

/** The connection type for Vendor. */
export type VendorConnection = {
  __typename?: 'VendorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VendorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Vendor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VendorEdge = {
  __typename?: 'VendorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Vendor>;
};

export type VendorFilter = {
  OR?: Maybe<Array<VendorFilter>>;
  account?: Maybe<AccountFilter>;
  description?: Maybe<OperatorStringFilter>;
  id?: Maybe<OperatorIdFilter>;
  kind?: Maybe<VendorKindOperatorFilter>;
  meta?: Maybe<Scalars['String']>;
};

/** Statistiques financières agrégées d'un vendor */
export type VendorFinancialStats = {
  __typename?: 'VendorFinancialStats';
  /** Somme des net_amount des MonthlyVendorPayment créés ce mois */
  currentMonthNetAmount: Scalars['Float'];
  /** Somme des net_amount des MonthlyVendorPayment créés le mois dernier */
  lastMonthNetAmount: Scalars['Float'];
  /** Nombre total de commandes créées ce mois pour ce vendor */
  ordersThisMonthCount: Scalars['Int'];
  /** Nombre de commandes créées ce mois en retrait (carrier_name = 'pickup') */
  ordersThisMonthPickupCount: Scalars['Int'];
  /** Nombre de commandes créées ce mois en livraison (carrier_name != 'pickup') */
  ordersThisMonthShippingCount: Scalars['Int'];
  /** Somme des net_amount des MonthlyVendorPayment non payés */
  pendingPaymentAmount: Scalars['Float'];
  /** Nombre de MonthlyVendorPayment non payés */
  pendingPaymentCount: Scalars['Int'];
  /** Somme totale des net_amount de tous les MonthlyVendorPayment payés */
  totalEarnedAllTime: Scalars['Float'];
};

/** Type de vendeur */
export enum VendorKindEnum {
  /** Vend ses objets directement chez nous */
  B2B = 'B2B',
  /** Créé uniquement pour être rattaché à des dossiers */
  ProjectOnly = 'PROJECT_ONLY',
  /** Non classé, à trancher par un expert */
  Unclassified = 'UNCLASSIFIED'
}

export type VendorKindOperatorFilter = {
  equalTo?: Maybe<VendorKindEnum>;
  isIn?: Maybe<Array<VendorKindEnum>>;
  isNotEqualTo?: Maybe<VendorKindEnum>;
};

export type VendorLateOrders = {
  __typename?: 'VendorLateOrders';
  lateOrderItems3Days: Array<OrderItem>;
  lateOrderItems5Days: Array<OrderItem>;
  vendorEmail: Scalars['String'];
  vendorId: Scalars['ID'];
  vendorName: Scalars['String'];
  vendorPhone?: Maybe<Scalars['String']>;
};

/** A vendor with late pickup orders */
export type VendorLatePickups = {
  __typename?: 'VendorLatePickups';
  latePickupItems3Days: Array<OrderItem>;
  latePickupItems5Days: Array<OrderItem>;
  vendorEmail?: Maybe<Scalars['String']>;
  vendorId: Scalars['ID'];
  vendorName?: Maybe<Scalars['String']>;
  vendorPhone?: Maybe<Scalars['String']>;
};

/** Détail d'une déduction sur un paiement vendeur */
export type VendorPaymentFee = Node & {
  __typename?: 'VendorPaymentFee';
  createdAt: Scalars['ISO8601DateTime'];
  /** Montant HT */
  feeAmountHt: Scalars['Float'];
  /** Montant TTC */
  feeAmountTtc: Scalars['Float'];
  /** Pourcentage HT */
  feePercentageHt?: Maybe<Scalars['Float']>;
  /** Pourcentage TTC */
  feePercentageTtc?: Maybe<Scalars['Float']>;
  /** Montant TVA */
  feeTva: Scalars['Float'];
  /** Taux de TVA (%) */
  feeTvaRate: Scalars['Float'];
  /** Type de frais (vendor_fee, writer_fee, fixed_fee, project_fee) */
  feeType: Scalars['String'];
  /** Montant par fiche (pour fixed_fee) */
  fixedFeePerItem?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** Nombre de fiches (pour fixed_fee) */
  itemsCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for VendorPaymentFee. */
export type VendorPaymentFeeConnection = {
  __typename?: 'VendorPaymentFeeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VendorPaymentFeeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VendorPaymentFee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VendorPaymentFeeEdge = {
  __typename?: 'VendorPaymentFeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VendorPaymentFee>;
};

/** A VendorPaymentLine */
export type VendorPaymentLine = Node & {
  __typename?: 'VendorPaymentLine';
  /** Montant (deprecated, utiliser amount_ttc) */
  amount?: Maybe<Scalars['Float']>;
  /** Montant net HT */
  amountHt?: Maybe<Scalars['Float']>;
  /** Montant net TTC à payer */
  amountTtc: Scalars['Float'];
  /** TVA */
  amountTva?: Maybe<Scalars['Float']>;
  createdAt: Scalars['ISO8601DateTime'];
  /** Montant (deprecated, utiliser vendor payment fees) */
  feeAmount?: Maybe<Scalars['Float']>;
  /** Montant (deprecated, utiliser vendor payment fees) */
  feePercentage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  orderItems?: Maybe<OrderItemConnection>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A VendorPaymentLine */
export type VendorPaymentLineOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for VendorPaymentLine. */
export type VendorPaymentLineConnection = {
  __typename?: 'VendorPaymentLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VendorPaymentLineEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VendorPaymentLine>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VendorPaymentLineEdge = {
  __typename?: 'VendorPaymentLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VendorPaymentLine>;
};

/** Statistiques contextuelles d'un paiement vendeur */
export type VendorPaymentStats = {
  __typename?: 'VendorPaymentStats';
  /** Montant de ce paiement (HT) */
  currentPaymentAmountHt: Scalars['Float'];
  /** Nombre d'objets dans ce paiement */
  currentPaymentCount: Scalars['Int'];
  /** Total déductions TTC */
  currentPaymentFeesTtc: Scalars['Float'];
  /** Net à payer TTC */
  currentPaymentNetTtc: Scalars['Float'];
  /** Vente totalement clôturée ? */
  isSaleFullyPaid: Scalars['Boolean'];
  /** % payé après ce paiement */
  percentagePaidAfter: Scalars['Float'];
  /** Nombre de paiements précédents */
  previousPaymentsCount: Scalars['Int'];
  /** Montant déjà payé avant ce paiement (HT) */
  previouslyPaidAmountHt: Scalars['Float'];
  /** Nombre d'objets déjà payés avant */
  previouslyPaidCount: Scalars['Int'];
  /** Reste à payer après ce paiement (HT) */
  remainingToPayAmountHt: Scalars['Float'];
  /** Objets restant à payer */
  remainingToPayCount: Scalars['Int'];
  /** CA total vendus de la vente (HT) */
  saleTotalSoldAmountHt: Scalars['Float'];
  /** Nombre total d'objets vendus */
  saleTotalSoldCount: Scalars['Int'];
};

/** An Vendor */
export type VendorPlan = Node & {
  __typename?: 'VendorPlan';
  createdAt: Scalars['ISO8601DateTime'];
  expertiseFirmEnabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  items?: Maybe<ItemConnection>;
  name?: Maybe<Scalars['String']>;
  projectsEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendor?: Maybe<Vendor>;
};


/** An Vendor */
export type VendorPlanItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Point journalier des montants création et commission */
export type VendorRemunerationDailyPoint = {
  __typename?: 'VendorRemunerationDailyPoint';
  /** Montant commission du jour */
  commissionAmount: Scalars['Float'];
  /** Montant création du jour */
  creationAmount: Scalars['Float'];
  /** Date du point journalier */
  date: Scalars['ISO8601Date'];
  /** Montant total du jour */
  total: Scalars['Float'];
};

/** Détail de rémunération par rédacteur pour un mois donné */
export type VendorRemunerationDetail = {
  __typename?: 'VendorRemunerationDetail';
  /** CA ventes sur la période */
  caVentes: Scalars['Float'];
  /** Montant de commission */
  commissionAmount: Scalars['Float'];
  /** Montant lié à la création de fiches */
  creationAmount: Scalars['Float'];
  /** Nombre de fiches acceptées */
  fichesCount: Scalars['Int'];
  /** Tarif unitaire par fiche */
  perFicheRate: Scalars['Float'];
  /** Taux de commission appliqué */
  taux: Scalars['Float'];
  /** Total rémunération (création + commission) */
  total: Scalars['Float'];
  /** Identifiant du rédacteur */
  writerId: Scalars['ID'];
  /** Nom du rédacteur */
  writerName?: Maybe<Scalars['String']>;
};

/** Rapport de rémunération mensuel des rédacteurs pour un vendeur */
export type VendorRemunerationReport = {
  __typename?: 'VendorRemunerationReport';
  /** Données journalières pour le graphique */
  dailySeries: Array<VendorRemunerationDailyPoint>;
  /** Détail par rédacteur */
  details: Array<VendorRemunerationDetail>;
  /** Totaux globaux */
  summary: VendorRemunerationSummary;
};

/** Totaux globaux de rémunération des rédacteurs */
export type VendorRemunerationSummary = {
  __typename?: 'VendorRemunerationSummary';
  /** Total général */
  total: Scalars['Float'];
  /** Total des commissions */
  totalCommission: Scalars['Float'];
  /** Total création de fiches */
  totalCreation: Scalars['Float'];
};

/** A shipping method configured for a vendor */
export type VendorShippingMethod = {
  __typename?: 'VendorShippingMethod';
  /** Configured shipping option */
  shippingOption: ShippingOptionEnum;
};

/** A VendorStatement */
export type VendorStatement = Node & {
  __typename?: 'VendorStatement';
  createdAt: Scalars['ISO8601DateTime'];
  document?: Maybe<CustomFile>;
  id: Scalars['ID'];
  nbItems?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  orderItems?: Maybe<OrderItemConnection>;
  sale?: Maybe<Sale>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendor?: Maybe<Vendor>;
};


/** A VendorStatement */
export type VendorStatementOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for VendorStatement. */
export type VendorStatementConnection = {
  __typename?: 'VendorStatementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VendorStatementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VendorStatement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VendorStatementEdge = {
  __typename?: 'VendorStatementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VendorStatement>;
};

export type VendorStatementFilter = {
  OR?: Maybe<Array<VendorStatementFilter>>;
  number?: Maybe<Scalars['String']>;
  id?: Maybe<OperatorIdFilter>;
  sale?: Maybe<SaleFilter>;
  vendor?: Maybe<VendorFilter>;
};

/** A VendorStatementPayment */
export type VendorStatementPayment = Node & {
  __typename?: 'VendorStatementPayment';
  /** End date of the latest MVP in this statement */
  coveredEndAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Start date of the earliest MVP in this statement */
  coveredStartAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  disputeAmount?: Maybe<Scalars['Float']>;
  disputed: Scalars['Boolean'];
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  monthlyVendorPayments?: Maybe<MonthlyVendorPaymentConnection>;
  paid: Scalars['Boolean'];
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Message d'erreur du transfert Stripe en cas d'échec */
  stripeTransferError?: Maybe<Scalars['String']>;
  stripeTransferId?: Maybe<Scalars['String']>;
  stripeTransferMode?: Maybe<Scalars['String']>;
  stripeTransferStatus?: Maybe<Scalars['String']>;
  stripeTransferredAt?: Maybe<Scalars['ISO8601DateTime']>;
  totalAmount: Scalars['Float'];
  totalLinesCount: Scalars['Int'];
  totalSalesCount: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  vendor?: Maybe<Vendor>;
  vendorStatements?: Maybe<VendorStatementConnection>;
};


/** A VendorStatementPayment */
export type VendorStatementPaymentMonthlyVendorPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A VendorStatementPayment */
export type VendorStatementPaymentVendorStatementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for VendorStatementPayment. */
export type VendorStatementPaymentConnection = {
  __typename?: 'VendorStatementPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VendorStatementPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VendorStatementPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VendorStatementPaymentEdge = {
  __typename?: 'VendorStatementPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VendorStatementPayment>;
};

export type VendorStatementPaymentFilter = {
  OR?: Maybe<Array<VendorStatementPaymentFilter>>;
  id?: Maybe<Scalars['ID']>;
  meta?: Maybe<Scalars['String']>;
  paid?: Maybe<OperatorBooleanFilter>;
  vendorId?: Maybe<Scalars['ID']>;
};

/** A Volume */
export type Volume = Node & {
  __typename?: 'Volume';
  book: Book;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  parts?: Maybe<PartConnection>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A Volume */
export type VolumePartsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Volume. */
export type VolumeConnection = {
  __typename?: 'VolumeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VolumeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Volume>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VolumeEdge = {
  __typename?: 'VolumeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Volume>;
};

/** A Watch */
export type Watch = Node & {
  __typename?: 'Watch';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item: Item;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A weekday available for pickup */
export enum WeekdayEnum {
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY'
}

/** An Writer */
export type Writer = Node & {
  __typename?: 'Writer';
  account: Account;
  adminProjectsIds?: Maybe<Array<Scalars['ID']>>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  financialStats: WriterFinancialStats;
  id: Scalars['ID'];
  itemsOnSale?: Maybe<ItemConnection>;
  itemsSold?: Maybe<ItemConnection>;
  kpis?: Maybe<WriterKpis>;
  /** Monthly earnings from Dodecade (10% on sales) */
  monthlyEarningsDodecade: Array<WriterMonthlyEarnings>;
  /** Monthly earnings from vendor (3€ per accepted item) */
  monthlyEarningsVendor: Array<WriterMonthlyEarnings>;
  nbItemsAfterAccepted?: Maybe<WriterKpiCreated>;
  nbItemsAfterShipped?: Maybe<WriterKpiCreated>;
  nbItemsCreated?: Maybe<WriterKpiCreated>;
  updatedAt: Scalars['ISO8601DateTime'];
  vendor: Vendor;
  writerPayments?: Maybe<WriterPaymentConnection>;
};


/** An Writer */
export type WriterItemsOnSaleArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Writer */
export type WriterItemsSoldArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Writer */
export type WriterMonthlyEarningsDodecadeArgs = {
  months?: Maybe<Scalars['Int']>;
};


/** An Writer */
export type WriterMonthlyEarningsVendorArgs = {
  months?: Maybe<Scalars['Int']>;
};


/** An Writer */
export type WriterWriterPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Writer. */
export type WriterConnection = {
  __typename?: 'WriterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WriterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Writer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Point journalier pour les graphiques rédacteurs */
export type WriterDailyPoint = {
  __typename?: 'WriterDailyPoint';
  avgPhotos?: Maybe<Scalars['Float']>;
  createdCount?: Maybe<Scalars['Int']>;
  date: Scalars['ISO8601Date'];
  revenue?: Maybe<Scalars['Float']>;
  soldCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WriterEdge = {
  __typename?: 'WriterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Writer>;
};

export type WriterFilter = {
  OR?: Maybe<Array<WriterFilter>>;
  account?: Maybe<AccountFilter>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<OperatorIdFilter>;
  meta?: Maybe<Scalars['String']>;
  projects?: Maybe<ProjectFilter>;
};

/** Financial statistics for a writer */
export type WriterFinancialStats = {
  __typename?: 'WriterFinancialStats';
  /** Cutoff date for 5% to 10% change */
  cutoffDate: Scalars['ISO8601DateTime'];
  /** Total from fixed fees (3€ per item) */
  fixedFeesTotal: Scalars['Float'];
  /** Number of items currently on sale */
  itemsOnSaleCount: Scalars['Int'];
  /** Number of items sold */
  itemsSoldCount: Scalars['Int'];
  /** Estimated next payment date */
  nextPaymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Total from percentage fees (10%) */
  percentageFeesTotal: Scalars['Float'];
  /** Total amount already paid to the writer */
  totalPaid: Scalars['Float'];
  /** Total amount pending payment */
  totalPending: Scalars['Float'];
  /** Total pending amount excluding already scheduled payments */
  totalPendingWithoutPayment: Scalars['Float'];
  /** Total amount of sales for sold items */
  totalSalesAmount: Scalars['Float'];
};

/** Writer KPIS states */
export type WriterItemStates = {
  __typename?: 'WriterItemStates';
  accepted?: Maybe<Scalars['Int']>;
  draft?: Maybe<Scalars['Int']>;
  needUpdate?: Maybe<Scalars['Int']>;
  refused?: Maybe<Scalars['Int']>;
  underExpertise?: Maybe<Scalars['Int']>;
  waitingExpertise?: Maybe<Scalars['Int']>;
};

/** An Writer */
export type WriterKpiCreated = {
  __typename?: 'WriterKpiCreated';
  currentMonth?: Maybe<Scalars['Int']>;
  lastMonth?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  totalAmountCurrentMonth?: Maybe<Scalars['Float']>;
  totalAmountLastMonth?: Maybe<Scalars['Float']>;
};

/** Writer KPIS */
export type WriterKpis = {
  __typename?: 'WriterKpis';
  itemAcceptedPercentage?: Maybe<Scalars['Int']>;
  itemPercentageStates?: Maybe<WriterItemStates>;
  totalFromBeginning?: Maybe<Scalars['Int']>;
};

/** Monthly earnings data for a writer */
export type WriterMonthlyEarnings = {
  __typename?: 'WriterMonthlyEarnings';
  /** Total earnings for this month */
  amount: Scalars['Float'];
  /** Month label (e.g., 'Jan 2025') */
  month: Scalars['String'];
  /** Month number (1-12) */
  monthNumber: Scalars['Int'];
  /** Year */
  year: Scalars['Int'];
};

/** A WriterPayment */
export type WriterPayment = Node & {
  __typename?: 'WriterPayment';
  createdAt: Scalars['ISO8601DateTime'];
  endAt: Scalars['ISO8601DateTime'];
  /** ID of the object. */
  id: Scalars['ID'];
  invoices?: Maybe<Array<CustomFile>>;
  lockedAt?: Maybe<Scalars['ISO8601DateTime']>;
  orderItems?: Maybe<OrderItemConnection>;
  paid?: Maybe<Scalars['Boolean']>;
  sale?: Maybe<Sale>;
  startAt: Scalars['ISO8601DateTime'];
  updatedAt: Scalars['ISO8601DateTime'];
  writer?: Maybe<Writer>;
  writerPaymentLines?: Maybe<WriterPaymentLineConnection>;
  writerStatementPayment?: Maybe<WriterStatementPayment>;
};


/** A WriterPayment */
export type WriterPaymentOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A WriterPayment */
export type WriterPaymentWriterPaymentLinesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for WriterPayment. */
export type WriterPaymentConnection = {
  __typename?: 'WriterPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WriterPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WriterPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WriterPaymentEdge = {
  __typename?: 'WriterPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<WriterPayment>;
};

export type WriterPaymentFilter = {
  OR?: Maybe<Array<WriterPaymentFilter>>;
  meta?: Maybe<Scalars['String']>;
  paid?: Maybe<OperatorBooleanFilter>;
  writerStatementPaymentId?: Maybe<OperatorIdFilter>;
  id?: Maybe<Scalars['ID']>;
};

/** A WriterPaymentLine */
export type WriterPaymentLine = Node & {
  __typename?: 'WriterPaymentLine';
  amount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['ISO8601DateTime'];
  /** ID of the object. */
  id: Scalars['ID'];
  orderItems?: Maybe<OrderItemConnection>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A WriterPaymentLine */
export type WriterPaymentLineOrderItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for WriterPaymentLine. */
export type WriterPaymentLineConnection = {
  __typename?: 'WriterPaymentLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WriterPaymentLineEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WriterPaymentLine>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WriterPaymentLineEdge = {
  __typename?: 'WriterPaymentLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<WriterPaymentLine>;
};

/** Statistiques d'un rédacteur sur une période */
export type WriterStat = {
  __typename?: 'WriterStat';
  avgPhotos: Scalars['Float'];
  createdCount: Scalars['Int'];
  inProgressCount: Scalars['Int'];
  revenuePerDay: Scalars['Float'];
  saleRate: Scalars['Float'];
  soldCount: Scalars['Int'];
  totalRevenue: Scalars['Float'];
  unsoldCount: Scalars['Int'];
  writerId: Scalars['ID'];
  writerName?: Maybe<Scalars['String']>;
  /** freelance ou employee */
  writerType?: Maybe<Scalars['String']>;
};

/** A WriterStatementPayment */
export type WriterStatementPayment = Node & {
  __typename?: 'WriterStatementPayment';
  createdAt: Scalars['ISO8601DateTime'];
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  invoices?: Maybe<Array<CustomFile>>;
  paid: Scalars['Boolean'];
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  totalAmount: Scalars['Float'];
  totalLinesCount: Scalars['Int'];
  totalSalesCount: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  writer?: Maybe<Writer>;
  writerPayments?: Maybe<WriterPaymentConnection>;
};


/** A WriterStatementPayment */
export type WriterStatementPaymentWriterPaymentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for WriterStatementPayment. */
export type WriterStatementPaymentConnection = {
  __typename?: 'WriterStatementPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WriterStatementPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WriterStatementPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WriterStatementPaymentEdge = {
  __typename?: 'WriterStatementPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<WriterStatementPayment>;
};

export type WriterStatementPaymentFilter = {
  OR?: Maybe<Array<WriterStatementPaymentFilter>>;
  id?: Maybe<Scalars['ID']>;
  meta?: Maybe<Scalars['String']>;
  paid?: Maybe<OperatorBooleanFilter>;
  writerId?: Maybe<Scalars['ID']>;
};

/** Rapport complet de statistiques rédacteurs pour un vendeur */
export type WriterStatsReport = {
  __typename?: 'WriterStatsReport';
  dailyProduction: Array<WriterDailyPoint>;
  dailyRevenue: Array<WriterDailyPoint>;
  rankings: Array<WriterStat>;
  summary: WriterStatsSummary;
};

/** Résumé KPI global des rédacteurs sur une période */
export type WriterStatsSummary = {
  __typename?: 'WriterStatsSummary';
  averagePrice: Scalars['Float'];
  inProgress: Scalars['Int'];
  saleRate: Scalars['Float'];
  sold: Scalars['Int'];
  totalCreated: Scalars['Int'];
  totalRevenue: Scalars['Float'];
  unsold: Scalars['Int'];
};

/** Résumé d'un rédacteur pour les rapports */
export type WriterSummary = {
  __typename?: 'WriterSummary';
  /** Identifiant du rédacteur */
  writerId: Scalars['ID'];
  /** Nom du rédacteur */
  writerName?: Maybe<Scalars['String']>;
};

/** Point journalier du suivi hebdomadaire des rédacteurs */
export type WriterWeeklyDailyPoint = {
  __typename?: 'WriterWeeklyDailyPoint';
  /** Date du point journalier */
  date: Scalars['ISO8601Date'];
  /** Valeurs par rédacteur */
  entries: Array<WriterWeeklyFollowUpEntry>;
};

/** Rapport de suivi hebdomadaire des rédacteurs pour un vendeur */
export type WriterWeeklyFollowUp = {
  __typename?: 'WriterWeeklyFollowUp';
  /** Production quotidienne par rédacteur */
  dailyProduction: Array<WriterWeeklyDailyPoint>;
  /** CA quotidien par rédacteur */
  dailyRevenue: Array<WriterWeeklyDailyPoint>;
  /** Liste des rédacteurs */
  writers: Array<WriterSummary>;
};

/** Valeur journalière d'un rédacteur pour le suivi hebdomadaire */
export type WriterWeeklyFollowUpEntry = {
  __typename?: 'WriterWeeklyFollowUpEntry';
  /** Nombre de fiches créées par le rédacteur */
  createdCount?: Maybe<Scalars['Int']>;
  /** Nombre de fiches créées encore en brouillon */
  draftCount?: Maybe<Scalars['Int']>;
  /** Chiffre d'affaires généré par le rédacteur */
  revenue?: Maybe<Scalars['Float']>;
  /** Identifiant du rédacteur */
  writerId: Scalars['ID'];
};

export type AddressCountryCodeQueryVariables = Exact<{
  country: Scalars['String'];
}>;


export type AddressCountryCodeQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'addressCountryCode'>
);

export type CommonViewerWithAccountQueryVariables = Exact<{
  accountableType: Scalars['String'];
}>;


export type CommonViewerWithAccountQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'email' | 'firstName' | 'lastName' | 'imageUrl' | 'accountTypes' | 'lastAccountTypeUsed'>
    & { currentRole: (
      { __typename?: 'Role' }
      & Pick<Role, 'name'>
    ), vendorLink?: Maybe<(
      { __typename?: 'Vendor' }
      & Pick<Vendor, 'id'>
    )>, accounts: (
      { __typename?: 'AccountConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'AccountEdge' }
        & { node?: Maybe<(
          { __typename?: 'Account' }
          & Pick<Account, 'id' | 'importConditionAccepted' | 'state' | 'firstName' | 'lastName' | 'completed' | 'nbItems'>
          & { accountable: (
            { __typename: 'Buyer' }
            & Pick<Buyer, 'id'>
          ) | (
            { __typename: 'Expert' }
            & Pick<Expert, 'id'>
          ) | (
            { __typename: 'Vendor' }
            & Pick<Vendor, 'id' | 'stripeConnectAccountId' | 'stripeConnectOnboardedAt'>
            & { vendorPlan?: Maybe<(
              { __typename?: 'VendorPlan' }
              & VendorPlanFragment
            )> }
          ) | (
            { __typename: 'Writer' }
            & Pick<Writer, 'id' | 'adminProjectsIds'>
            & { vendor: (
              { __typename?: 'Vendor' }
              & Pick<Vendor, 'id'>
              & { vendorPlan?: Maybe<(
                { __typename?: 'VendorPlan' }
                & VendorPlanFragment
              )> }
            ) }
          ) }
        )> }
      )>>> }
    ) }
  )> }
);

export type VendorPlanFragment = (
  { __typename?: 'VendorPlan' }
  & Pick<VendorPlan, 'name' | 'expertiseFirmEnabled' | 'projectsEnabled'>
);

export type CommonViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type CommonViewerQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'lastAccountTypeUsed' | 'email' | 'firstName' | 'lastName' | 'imageUrl'>
    & { currentRole: (
      { __typename?: 'Role' }
      & Pick<Role, 'name'>
    ) }
  )> }
);

export type RotateImageMutationVariables = Exact<{
  itemId: Scalars['ID'];
  imageId: Scalars['ID'];
  rotation: Scalars['Int'];
}>;


export type RotateImageMutation = (
  { __typename?: 'Mutation' }
  & { rotateImage?: Maybe<(
    { __typename?: 'RotateImageMutationPayload' }
    & Pick<RotateImageMutationPayload, 'errors'>
    & { item?: Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id'>
      & { images?: Maybe<Array<(
        { __typename?: 'Image' }
        & Pick<Image, 'id' | 'position' | 'imageUrl' | 'rotation'>
      )>> }
    )> }
  )> }
);

export type AnalyticsRevenueAndMarginChartCardFragment = (
  { __typename?: 'TimeSeriesPoint' }
  & Pick<TimeSeriesPoint, 'period' | 'value'>
);

export type AnalyticsVolumeAndDelayChartCardFragment = (
  { __typename?: 'TimeSeriesPoint' }
  & Pick<TimeSeriesPoint, 'period' | 'value'>
);

export type BusinessIntroducerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BusinessIntroducerQuery = (
  { __typename?: 'Query' }
  & { businessIntroducer?: Maybe<(
    { __typename?: 'BusinessIntroducer' }
    & BusinessIntroducerFragment
  )> }
);

export type ThirdPartyIntroducerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ThirdPartyIntroducerQuery = (
  { __typename?: 'Query' }
  & { thirdPartyIntroducer?: Maybe<(
    { __typename?: 'ThirdPartyIntroducer' }
    & ThirdPartyIntroducerFragment
  )> }
);

export type VendorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VendorQuery = (
  { __typename?: 'Query' }
  & { vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & VendorFragment
  )> }
);

export type BuyerDesireAlertsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BuyerDesireAlertsQuery = (
  { __typename?: 'Query' }
  & { desire?: Maybe<(
    { __typename?: 'Desire' }
    & Pick<Desire, 'id'>
    & { alerts?: Maybe<Array<(
      { __typename?: 'DesireAlert' }
      & Pick<DesireAlert, 'id' | 'sentAt' | 'itemCount'>
      & { sale?: Maybe<(
        { __typename?: 'Sale' }
        & Pick<Sale, 'id' | 'name'>
      )>, items: Array<(
        { __typename?: 'AlertItem' }
        & Pick<AlertItem, 'score'>
        & { item: (
          { __typename?: 'Item' }
          & Pick<Item, 'id' | 'title' | 'state' | 'startingPrice'>
          & { firstImage?: Maybe<(
            { __typename?: 'Image' }
            & Pick<Image, 'imageUrl'>
          )> }
        ) }
      )> }
    )>> }
  )> }
);

export type BuyersTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  purchaseStatus?: Maybe<BuyerPurchaseStatusEnum>;
  desireStatus?: Maybe<BuyerDesireStatusEnum>;
  desireReview?: Maybe<BuyerDesireReviewEnum>;
  engagement?: Maybe<CustomerEngagementEnum>;
  orderBy?: Maybe<ItemOrderType>;
}>;


export type BuyersTableQuery = (
  { __typename?: 'Query' }
  & { buyers: (
    { __typename?: 'BuyerConnection' }
    & Pick<BuyerConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'BuyerEdge' }
      & Pick<BuyerEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Buyer' }
        & BuyerTableFragment
      )> }
    )>>> }
  ) }
);

export type BuyerTableFragment = (
  { __typename?: 'Buyer' }
  & Pick<Buyer, 'id' | 'createdAt' | 'desiresReviewedAt'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'firstName' | 'lastName' | 'companyName' | 'email' | 'phone'>
  ), unsubscriptions?: Maybe<Array<(
    { __typename?: 'CustomerUnsubscription' }
    & Pick<CustomerUnsubscription, 'kind'>
  )>>, stats?: Maybe<(
    { __typename?: 'BuyerStats' }
    & Pick<BuyerStats, 'ordersCount' | 'totalSpent' | 'lastOrderAt' | 'activeDesiresCount' | 'favoritesCount' | 'newslettersOpenedCount' | 'lastOpenedAt'>
  )> }
);

export type CategorySelectFieldFragment = (
  { __typename?: 'ItemCategory' }
  & Pick<ItemCategory, 'id' | 'name'>
);

export type GetCategoriesQueryVariables = Exact<{
  where?: Maybe<ItemCategoryFilter>;
}>;


export type GetCategoriesQuery = (
  { __typename?: 'Query' }
  & { itemCategories: (
    { __typename?: 'ItemCategoryConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemCategoryEdge' }
      & { node?: Maybe<(
        { __typename?: 'ItemCategory' }
        & CategorySelectFieldFragment
      )> }
    )>>> }
  ) }
);

export type ChangePasswordMutationVariables = Exact<{
  id: Scalars['ID'];
  password?: Maybe<Scalars['String']>;
}>;


export type ChangePasswordMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
  )> }
);

export type UpdateAccountStateMutationVariables = Exact<{
  id: Scalars['ID'];
  state: AccountStateEnum;
}>;


export type UpdateAccountStateMutation = (
  { __typename?: 'Mutation' }
  & { customUpdateAccount?: Maybe<(
    { __typename?: 'CustomUpdateAccountMutationPayload' }
    & { account?: Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'state'>
    )> }
  )> }
);

export type ContactsTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  contactStatus?: Maybe<CustomerContactStatusEnum>;
  emailState?: Maybe<Scalars['String']>;
  purchaseStatus?: Maybe<BuyerPurchaseStatusEnum>;
  desireStatus?: Maybe<BuyerDesireStatusEnum>;
  desireReview?: Maybe<BuyerDesireReviewEnum>;
  minNewsletters?: Maybe<Scalars['Int']>;
  engagement?: Maybe<CustomerEngagementEnum>;
  unsubscribedFrom?: Maybe<CustomerUnsubscriptionKindEnum>;
  orderBy?: Maybe<ItemOrderType>;
}>;


export type ContactsTableQuery = (
  { __typename?: 'Query' }
  & { customerContacts: (
    { __typename?: 'CustomerConnection' }
    & Pick<CustomerConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'CustomerEdge' }
      & Pick<CustomerEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Customer' }
        & ContactTableFragment
      )> }
    )>>> }
  ) }
);

export type ContactTableFragment = (
  { __typename?: 'Customer' }
  & Pick<Customer, 'id' | 'createdAt' | 'email' | 'firstName' | 'lastName' | 'fullName' | 'phone1' | 'emailState' | 'subscribed' | 'desiresReviewedAt'>
  & { unsubscriptions?: Maybe<Array<(
    { __typename?: 'CustomerUnsubscription' }
    & Pick<CustomerUnsubscription, 'kind'>
  )>>, stats?: Maybe<(
    { __typename?: 'CustomerStats' }
    & Pick<CustomerStats, 'recordsCount' | 'newslettersReceivedCount' | 'lastNewsletterAt' | 'newslettersOpenedCount' | 'lastOpenedAt' | 'activeDesiresCount' | 'ordersCount'>
  )> }
);

export type CustomersQueryVariables = Exact<{
  where?: Maybe<CustomerFilter>;
}>;


export type CustomersQuery = (
  { __typename?: 'Query' }
  & { customers: (
    { __typename?: 'CustomerConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'CustomerEdge' }
      & { node?: Maybe<(
        { __typename?: 'Customer' }
        & CustomerTableFragment
      )> }
    )>>> }
  ) }
);

export type CustomerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerQuery = (
  { __typename?: 'Query' }
  & { customer?: Maybe<(
    { __typename?: 'Customer' }
    & CustomerFragment
  )> }
);

export type CustomerEdgesFragment = (
  { __typename?: 'CustomerConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'CustomerEdge' }
    & CustomerNodeFragment
  )>>> }
);

export type CustomerNodeFragment = (
  { __typename?: 'CustomerEdge' }
  & { node?: Maybe<(
    { __typename?: 'Customer' }
    & CustomerFragment
  )> }
);

export type ItemSubCategoryFragment = (
  { __typename?: 'ItemSubCategory' }
  & Pick<ItemSubCategory, 'id' | 'name'>
);

export type CustomerTableFragment = (
  { __typename?: 'Customer' }
  & Pick<Customer, 'id' | 'lastName' | 'firstName' | 'email'>
  & { tags?: Maybe<(
    { __typename?: 'TagConnection' }
    & TagEdgesFragment
  )> }
);

export type CustomerFragment = (
  { __typename?: 'Customer' }
  & Pick<Customer, 'id' | 'lastName' | 'firstName' | 'email' | 'addressLine1' | 'addressLine2' | 'addressLine3' | 'city' | 'zip' | 'country' | 'phone1' | 'phone2'>
  & { itemCategories?: Maybe<(
    { __typename?: 'CustomerItemCategoryConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'CustomerItemCategoryEdge' }
      & { node?: Maybe<(
        { __typename?: 'CustomerItemCategory' }
        & Pick<CustomerItemCategory, 'id' | 'name'>
      )> }
    )>>> }
  )>, itemSubCategories?: Maybe<(
    { __typename?: 'CustomerItemSubCategoryConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'CustomerItemSubCategoryEdge' }
      & { node?: Maybe<(
        { __typename?: 'CustomerItemSubCategory' }
        & Pick<CustomerItemSubCategory, 'id' | 'name'>
      )> }
    )>>> }
  )>, desires?: Maybe<(
    { __typename?: 'DesireConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'DesireEdge' }
      & { node?: Maybe<(
        { __typename?: 'Desire' }
        & Pick<Desire, 'id' | 'title'>
      )> }
    )>>> }
  )>, tags?: Maybe<(
    { __typename?: 'TagConnection' }
    & TagEdgesFragment
  )> }
);

export type TagEdgesFragment = (
  { __typename?: 'TagConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'TagEdge' }
    & TagNodeFragment
  )>>> }
);

export type TagNodeFragment = (
  { __typename?: 'TagEdge' }
  & { node?: Maybe<(
    { __typename?: 'Tag' }
    & TagFragment
  )> }
);

export type TagFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name'>
);

export type UpdateCustomerMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = (
  { __typename?: 'Mutation' }
  & { updateCustomer?: Maybe<(
    { __typename?: 'UpdateCustomerMutationPayload' }
    & Pick<UpdateCustomerMutationPayload, 'clientMutationId'>
    & { customer?: Maybe<(
      { __typename?: 'Customer' }
      & Pick<Customer, 'id'>
    )> }
  )> }
);

export type DestroyCustomerMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyCustomerMutation = (
  { __typename?: 'Mutation' }
  & { destroyCustomer?: Maybe<(
    { __typename?: 'DestroyCustomerMutationPayload' }
    & { customer?: Maybe<(
      { __typename?: 'Customer' }
      & Pick<Customer, 'id'>
    )> }
  )> }
);

export type DepositSlipsQueryVariables = Exact<{
  where?: Maybe<DepositSlipFilter>;
}>;


export type DepositSlipsQuery = (
  { __typename?: 'Query' }
  & { depositSlips: (
    { __typename?: 'DepositSlipConnection' }
    & DepositSlipEdgesFragment
  ) }
);

export type DepositSlipEdgesFragment = (
  { __typename?: 'DepositSlipConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'DepositSlipEdge' }
    & DepositSlipNodeFragment
  )>>> }
);

export type DepositSlipNodeFragment = (
  { __typename?: 'DepositSlipEdge' }
  & { node?: Maybe<(
    { __typename?: 'DepositSlip' }
    & DepositSlipFragment
  )> }
);

export type DepositSlipFragment = (
  { __typename?: 'DepositSlip' }
  & Pick<DepositSlip, 'id' | 'createdAt' | 'nbItems' | 'number'>
  & { document?: Maybe<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>, vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id'>
  )> }
);

export type UpdateDesireMutationVariables = Exact<{
  input: UpdateDesireMutationInput;
}>;


export type UpdateDesireMutation = (
  { __typename?: 'Mutation' }
  & { updateDesire?: Maybe<(
    { __typename?: 'UpdateDesireMutationPayload' }
    & { desire?: Maybe<(
      { __typename?: 'Desire' }
      & Pick<Desire, 'id' | 'title' | 'validated' | 'searchTitleEnabled' | 'searchDescriptionEnabled' | 'searchArtistsEnabled' | 'searchTagsEnabled'>
    )> }
  )> }
);

export type CreateDesireMutationVariables = Exact<{
  input: CreateDesireMutationInput;
}>;


export type CreateDesireMutation = (
  { __typename?: 'Mutation' }
  & { createDesire?: Maybe<(
    { __typename?: 'CreateDesireMutationPayload' }
    & { desire?: Maybe<(
      { __typename?: 'Desire' }
      & Pick<Desire, 'id'>
    )> }
  )> }
);

export type DestroyDesireMutationVariables = Exact<{
  input: DestroyDesireMutationInput;
}>;


export type DestroyDesireMutation = (
  { __typename?: 'Mutation' }
  & { destroyDesire?: Maybe<(
    { __typename?: 'DestroyDesireMutationPayload' }
    & { desire?: Maybe<(
      { __typename?: 'Desire' }
      & Pick<Desire, 'id'>
    )> }
  )> }
);

export type DesireQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DesireQuery = (
  { __typename?: 'Query' }
  & { desire?: Maybe<(
    { __typename?: 'Desire' }
    & DesireFragment
  )> }
);

export type DesiresQueryVariables = Exact<{
  where?: Maybe<DesireFilter>;
  unusable?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type DesiresQuery = (
  { __typename?: 'Query' }
  & { desires: (
    { __typename?: 'DesireConnection' }
    & DesireEdgesFragment
  ) }
);

export type DesireEdgesFragment = (
  { __typename?: 'DesireConnection' }
  & Pick<DesireConnection, 'totalCount'>
  & { pageInfo: (
    { __typename?: 'PageInfo' }
    & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
  ), edges?: Maybe<Array<Maybe<(
    { __typename?: 'DesireEdge' }
    & Pick<DesireEdge, 'cursor'>
    & DesireNodeFragment
  )>>> }
);

export type DesireNodeFragment = (
  { __typename?: 'DesireEdge' }
  & { node?: Maybe<(
    { __typename?: 'Desire' }
    & DesireFragment
  )> }
);

export type DesireFragment = (
  { __typename?: 'Desire' }
  & Pick<Desire, 'id' | 'title' | 'originalTitle' | 'validated' | 'usable' | 'unusableReasonLabel' | 'matchingWords' | 'searchTitleEnabled' | 'searchDescriptionEnabled' | 'searchArtistsEnabled' | 'searchTagsEnabled' | 'createdAt' | 'updatedAt'>
  & { buyer?: Maybe<(
    { __typename?: 'Buyer' }
    & BuyerFragment
  )>, customer?: Maybe<(
    { __typename?: 'Customer' }
    & CustomerFragment
  )>, tags?: Maybe<(
    { __typename?: 'TagConnection' }
    & TagEdgesFragment
  )> }
);

export type BuyerFragment = (
  { __typename?: 'Buyer' }
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'email'>
  ) }
);

export type SplitDesireMutationVariables = Exact<{
  input: SplitDesireMutationInput;
}>;


export type SplitDesireMutation = (
  { __typename?: 'Mutation' }
  & { splitDesire?: Maybe<(
    { __typename?: 'SplitDesireMutationPayload' }
    & Pick<SplitDesireMutationPayload, 'errors'>
    & { desires?: Maybe<Array<(
      { __typename?: 'Desire' }
      & Pick<Desire, 'id' | 'title'>
    )>> }
  )> }
);

export type MarkDesiresReviewedMutationVariables = Exact<{
  buyerId?: Maybe<Scalars['ID']>;
  customerId?: Maybe<Scalars['ID']>;
  reviewed?: Maybe<Scalars['Boolean']>;
}>;


export type MarkDesiresReviewedMutation = (
  { __typename?: 'Mutation' }
  & { markDesiresReviewed?: Maybe<(
    { __typename?: 'MarkDesiresReviewedMutationPayload' }
    & Pick<MarkDesiresReviewedMutationPayload, 'errors'>
    & { buyer?: Maybe<(
      { __typename?: 'Buyer' }
      & Pick<Buyer, 'id' | 'desiresReviewedAt' | 'desiresReviewedBy'>
    )>, customer?: Maybe<(
      { __typename?: 'Customer' }
      & Pick<Customer, 'id' | 'desiresReviewedAt' | 'desiresReviewedBy'>
    )> }
  )> }
);

export type MoveSaleItemsToVacationMutationVariables = Exact<{
  saleId: Scalars['ID'];
  vacationId: Scalars['ID'];
  itemIds: Array<Scalars['ID']>;
}>;


export type MoveSaleItemsToVacationMutation = (
  { __typename?: 'Mutation' }
  & { moveSaleItemsToVacation?: Maybe<(
    { __typename?: 'MoveItemsToVacationMutationPayload' }
    & Pick<MoveItemsToVacationMutationPayload, 'movedCount' | 'errors'>
    & { blockingItems: Array<(
      { __typename?: 'Item' }
      & Pick<Item, 'id'>
    )>, vacation?: Maybe<(
      { __typename?: 'Vacation' }
      & Pick<Vacation, 'id' | 'name'>
    )> }
  )> }
);

export type UploadImageInItemMutationVariables = Exact<{
  id: Scalars['ID'];
  images?: Maybe<Array<UploadImageInput>>;
}>;


export type UploadImageInItemMutation = (
  { __typename?: 'Mutation' }
  & { updateItem?: Maybe<(
    { __typename?: 'UpdateItemMutationPayload' }
    & Pick<UpdateItemMutationPayload, 'clientMutationId'>
    & { item: (
      { __typename?: 'Item' }
      & Pick<Item, 'title'>
      & { images?: Maybe<Array<(
        { __typename?: 'Image' }
        & Pick<Image, 'id' | 'imageUrl' | 'position'>
      )>> }
    ) }
  )> }
);

export type UploadInvoiceInItemMutationVariables = Exact<{
  id: Scalars['ID'];
  files?: Maybe<Array<UploadFileInput>>;
}>;


export type UploadInvoiceInItemMutation = (
  { __typename?: 'Mutation' }
  & { updateItem?: Maybe<(
    { __typename?: 'UpdateItemMutationPayload' }
    & Pick<UpdateItemMutationPayload, 'clientMutationId'>
    & { item: (
      { __typename?: 'Item' }
      & Pick<Item, 'title'>
      & { invoices?: Maybe<Array<(
        { __typename?: 'CustomFile' }
        & Pick<CustomFile, 'imageUrl'>
      )>> }
    ) }
  )> }
);

export type UploadAuthenticityDocumentInItemMutationVariables = Exact<{
  id: Scalars['ID'];
  files?: Maybe<Array<UploadFileInput>>;
}>;


export type UploadAuthenticityDocumentInItemMutation = (
  { __typename?: 'Mutation' }
  & { updateItem?: Maybe<(
    { __typename?: 'UpdateItemMutationPayload' }
    & Pick<UpdateItemMutationPayload, 'clientMutationId'>
    & { item: (
      { __typename?: 'Item' }
      & Pick<Item, 'title'>
      & { authenticityDocuments?: Maybe<Array<(
        { __typename?: 'CustomFile' }
        & Pick<CustomFile, 'imageUrl'>
      )>> }
    ) }
  )> }
);

export type UpdateAccountEmailStateMutationVariables = Exact<{
  id: Scalars['ID'];
  emailState: EmailStateEnum;
}>;


export type UpdateAccountEmailStateMutation = (
  { __typename?: 'Mutation' }
  & { customUpdateAccount?: Maybe<(
    { __typename?: 'CustomUpdateAccountMutationPayload' }
    & { errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )>, account?: Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'emailState'>
    )> }
  )> }
);

export type UpdateCustomerEmailStateMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
  emailState: EmailStateEnum;
}>;


export type UpdateCustomerEmailStateMutation = (
  { __typename?: 'Mutation' }
  & { updateCustomer?: Maybe<(
    { __typename?: 'UpdateCustomerMutationPayload' }
    & { errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )>, customer?: Maybe<(
      { __typename?: 'Customer' }
      & Pick<Customer, 'id' | 'emailState'>
    )> }
  )> }
);

export type UpdateItemStepMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateItemStepInput;
}>;


export type UpdateItemStepMutation = (
  { __typename?: 'Mutation' }
  & { updateItemStep?: Maybe<(
    { __typename?: 'UpdateItemStepMutationPayload' }
    & Pick<UpdateItemStepMutationPayload, 'clientMutationId'>
    & { itemStep?: Maybe<(
      { __typename?: 'ItemStep' }
      & Pick<ItemStep, 'id'>
    )> }
  )> }
);

export type UpdateExpertAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateAccountInput;
}>;


export type UpdateExpertAccountMutation = (
  { __typename?: 'Mutation' }
  & { customUpdateAccount?: Maybe<(
    { __typename?: 'CustomUpdateAccountMutationPayload' }
    & Pick<CustomUpdateAccountMutationPayload, 'clientMutationId'>
    & { account?: Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName' | 'email' | 'state'>
      & { accountable: (
        { __typename: 'Buyer' }
        & Pick<Buyer, 'id'>
      ) | (
        { __typename: 'Expert' }
        & Pick<Expert, 'id'>
      ) | (
        { __typename: 'Vendor' }
        & Pick<Vendor, 'id'>
      ) | (
        { __typename: 'Writer' }
        & Pick<Writer, 'id'>
      ) }
    )> }
  )> }
);

export type ExpertOnboardingChecklistQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type ExpertOnboardingChecklistQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & OnboardingAccountFragment
  )> }
);

export type ExpertPaymentTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<ExpertPaymentFilter>;
}>;


export type ExpertPaymentTableQuery = (
  { __typename?: 'Query' }
  & { expertPayments: (
    { __typename?: 'ExpertPaymentConnection' }
    & Pick<ExpertPaymentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'ExpertPaymentEdge' }
      & Pick<ExpertPaymentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ExpertPayment' }
        & ExpertPaymentTableFragment
      )> }
    )>>> }
  ) }
);

export type ExpertPaymentTableFragment = (
  { __typename?: 'ExpertPayment' }
  & Pick<ExpertPayment, 'id' | 'createdAt' | 'paid' | 'lockedAt'>
  & { expertPaymentLines?: Maybe<(
    { __typename?: 'ExpertPaymentLineConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ExpertPaymentLineEdge' }
      & { node?: Maybe<(
        { __typename?: 'ExpertPaymentLine' }
        & Pick<ExpertPaymentLine, 'id' | 'amount'>
      )> }
    )>>> }
  )>, expert?: Maybe<(
    { __typename?: 'Expert' }
    & Pick<Expert, 'id'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName'>
    ) }
  )>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name'>
  )>, invoices?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>> }
);

export type ExpertSelectFieldFragment = (
  { __typename?: 'Expert' }
  & Pick<Expert, 'id'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'firstName' | 'lastName'>
  ) }
);

export type GetExpertsQueryVariables = Exact<{
  where?: Maybe<ExpertFilter>;
}>;


export type GetExpertsQuery = (
  { __typename?: 'Query' }
  & { experts: (
    { __typename?: 'ExpertConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ExpertEdge' }
      & { node?: Maybe<(
        { __typename?: 'Expert' }
        & ExpertSelectFieldFragment
      )> }
    )>>> }
  ) }
);

export type ExpertStatementPaymentTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<ExpertStatementPaymentFilter>;
}>;


export type ExpertStatementPaymentTableQuery = (
  { __typename?: 'Query' }
  & { expertStatementPayments: (
    { __typename?: 'ExpertStatementPaymentConnection' }
    & Pick<ExpertStatementPaymentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'ExpertStatementPaymentEdge' }
      & Pick<ExpertStatementPaymentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ExpertStatementPayment' }
        & ExpertStatementPaymentTableFragment
      )> }
    )>>> }
  ) }
);

export type ExpertStatementPaymentTableFragment = (
  { __typename?: 'ExpertStatementPayment' }
  & Pick<ExpertStatementPayment, 'id' | 'createdAt' | 'paid' | 'totalAmount' | 'totalSalesCount'>
  & { expert?: Maybe<(
    { __typename?: 'Expert' }
    & Pick<Expert, 'id'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName'>
    ) }
  )>, invoices?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>>, expertPayments?: Maybe<(
    { __typename?: 'ExpertPaymentConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ExpertPaymentEdge' }
      & { node?: Maybe<(
        { __typename?: 'ExpertPayment' }
        & Pick<ExpertPayment, 'id' | 'createdAt' | 'paid' | 'lockedAt'>
        & { expertPaymentLines?: Maybe<(
          { __typename?: 'ExpertPaymentLineConnection' }
          & { edges?: Maybe<Array<Maybe<(
            { __typename?: 'ExpertPaymentLineEdge' }
            & { node?: Maybe<(
              { __typename?: 'ExpertPaymentLine' }
              & Pick<ExpertPaymentLine, 'id' | 'amount'>
            )> }
          )>>> }
        )>, expert?: Maybe<(
          { __typename?: 'Expert' }
          & Pick<Expert, 'id'>
          & { account: (
            { __typename?: 'Account' }
            & Pick<Account, 'id' | 'firstName' | 'lastName'>
          ) }
        )>, sale?: Maybe<(
          { __typename?: 'Sale' }
          & Pick<Sale, 'id' | 'name'>
        )>, invoices?: Maybe<Array<(
          { __typename?: 'CustomFile' }
          & Pick<CustomFile, 'imageUrl' | 'filename'>
        )>> }
      )> }
    )>>> }
  )> }
);

export type ExpertsTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<ExpertFilter>;
}>;


export type ExpertsTableQuery = (
  { __typename?: 'Query' }
  & { experts: (
    { __typename?: 'ExpertConnection' }
    & Pick<ExpertConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'ExpertEdge' }
      & Pick<ExpertEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Expert' }
        & ExpertTableFragment
      )> }
    )>>> }
  ) }
);

export type ExpertTableFragment = (
  { __typename?: 'Expert' }
  & Pick<Expert, 'id'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'firstName' | 'lastName' | 'email' | 'state' | 'createdAt'>
  ) }
);

export type FreshdeskWidgetAccountQueryVariables = Exact<{
  accountableType: Scalars['String'];
}>;


export type FreshdeskWidgetAccountQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { accounts: (
      { __typename?: 'AccountConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'AccountEdge' }
        & { node?: Maybe<(
          { __typename?: 'Account' }
          & Pick<Account, 'id' | 'freshdeskWidgetToken'>
        )> }
      )>>> }
    ) }
  )> }
);

export type ImportPaymentTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<ImportPaymentFilter>;
}>;


export type ImportPaymentTableQuery = (
  { __typename?: 'Query' }
  & { importPayments: (
    { __typename?: 'ImportPaymentConnection' }
    & Pick<ImportPaymentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'ImportPaymentEdge' }
      & Pick<ImportPaymentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ImportPayment' }
        & ImportPaymentTableFragment
      )> }
    )>>> }
  ) }
);

export type ImportPaymentTableFragment = (
  { __typename?: 'ImportPayment' }
  & Pick<ImportPayment, 'id' | 'createdAt' | 'paid' | 'lockedAt'>
  & { importPaymentLines?: Maybe<(
    { __typename?: 'ImportPaymentLineConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ImportPaymentLineEdge' }
      & { node?: Maybe<(
        { __typename?: 'ImportPaymentLine' }
        & Pick<ImportPaymentLine, 'id' | 'amount'>
      )> }
    )>>> }
  )>, account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'firstName' | 'lastName'>
  )>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name'>
  )> }
);

export type ImportStatementPaymentTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<ImportStatementPaymentFilter>;
}>;


export type ImportStatementPaymentTableQuery = (
  { __typename?: 'Query' }
  & { importStatementPayments: (
    { __typename?: 'ImportStatementPaymentConnection' }
    & Pick<ImportStatementPaymentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'ImportStatementPaymentEdge' }
      & Pick<ImportStatementPaymentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ImportStatementPayment' }
        & ImportStatementPaymentTableFragment
      )> }
    )>>> }
  ) }
);

export type ImportStatementPaymentTableFragment = (
  { __typename?: 'ImportStatementPayment' }
  & Pick<ImportStatementPayment, 'id' | 'createdAt' | 'paid' | 'totalAmount' | 'totalSalesCount'>
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'firstName' | 'lastName'>
  )>, invoices?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>>, importPayments?: Maybe<(
    { __typename?: 'ImportPaymentConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ImportPaymentEdge' }
      & { node?: Maybe<(
        { __typename?: 'ImportPayment' }
        & Pick<ImportPayment, 'id' | 'createdAt' | 'paid' | 'lockedAt'>
        & { importPaymentLines?: Maybe<(
          { __typename?: 'ImportPaymentLineConnection' }
          & { edges?: Maybe<Array<Maybe<(
            { __typename?: 'ImportPaymentLineEdge' }
            & { node?: Maybe<(
              { __typename?: 'ImportPaymentLine' }
              & Pick<ImportPaymentLine, 'id' | 'amount'>
            )> }
          )>>> }
        )>, account?: Maybe<(
          { __typename?: 'Account' }
          & Pick<Account, 'id' | 'firstName' | 'lastName'>
        )>, sale?: Maybe<(
          { __typename?: 'Sale' }
          & Pick<Sale, 'id' | 'name'>
        )> }
      )> }
    )>>> }
  )> }
);

export type ItemExpertFragment = (
  { __typename?: 'Expert' }
  & Pick<Expert, 'id'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'firstName' | 'lastName' | 'companyName' | 'email'>
  ) }
);

export type ItemChangeExpertListQueryVariables = Exact<{
  meta?: Maybe<Scalars['String']>;
}>;


export type ItemChangeExpertListQuery = (
  { __typename?: 'Query' }
  & { experts: (
    { __typename?: 'ExpertConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ExpertEdge' }
      & { node?: Maybe<(
        { __typename?: 'Expert' }
        & ItemExpertFragment
      )> }
    )>>> }
  ) }
);

export type UpdateItemExpertMutationVariables = Exact<{
  id: Scalars['ID'];
  expertId: Scalars['ID'];
}>;


export type UpdateItemExpertMutation = (
  { __typename?: 'Mutation' }
  & { updateItemExpert?: Maybe<(
    { __typename?: 'UpdateItemExpertMutationPayload' }
    & Pick<UpdateItemExpertMutationPayload, 'errors'>
    & { item?: Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id'>
      & { expert?: Maybe<(
        { __typename?: 'Expert' }
        & ItemExpertFragment
      )> }
    )> }
  )> }
);

export type ArtistQueryVariables = Exact<{
  where?: Maybe<ArtistFilter>;
}>;


export type ArtistQuery = (
  { __typename?: 'Query' }
  & { artists: (
    { __typename?: 'ArtistConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ArtistEdge' }
      & { node?: Maybe<(
        { __typename?: 'Artist' }
        & Pick<Artist, 'id' | 'firstName' | 'lastName' | 'tag' | 'itemCategoryId'>
      )> }
    )>>> }
  ) }
);

export type UpdateItemArtistsMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateItemInput;
}>;


export type UpdateItemArtistsMutation = (
  { __typename?: 'Mutation' }
  & { updateItem?: Maybe<(
    { __typename?: 'UpdateItemMutationPayload' }
    & Pick<UpdateItemMutationPayload, 'clientMutationId'>
    & { item: (
      { __typename?: 'Item' }
      & Pick<Item, 'title'>
      & { artists?: Maybe<(
        { __typename?: 'ArtistConnection' }
        & { edges?: Maybe<Array<Maybe<(
          { __typename?: 'ArtistEdge' }
          & { node?: Maybe<(
            { __typename?: 'Artist' }
            & Pick<Artist, 'id' | 'firstName' | 'lastName' | 'tag' | 'itemCategoryId'>
          )> }
        )>>> }
      )> }
    ) }
  )> }
);

export type ItemCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemCategoriesQuery = (
  { __typename?: 'Query' }
  & { itemCategories: (
    { __typename?: 'ItemCategoryConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemCategoryEdge' }
      & { node?: Maybe<(
        { __typename?: 'ItemCategory' }
        & Pick<ItemCategory, 'id' | 'name' | 'templateType' | 'archived' | 'aiGenerationAvailable'>
      )> }
    )>>> }
  ) }
);

export type ItemSubCategoriesQueryVariables = Exact<{
  where?: Maybe<ItemSubCategoryFilter>;
}>;


export type ItemSubCategoriesQuery = (
  { __typename?: 'Query' }
  & { itemSubCategories: (
    { __typename?: 'ItemSubCategoryConnection' }
    & ItemSubCategoryEdgesFragment
  ) }
);

export type ItemSubCategoryEdgesFragment = (
  { __typename?: 'ItemSubCategoryConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'ItemSubCategoryEdge' }
    & ItemSubCategoryNodeFragment
  )>>> }
);

export type ItemSubCategoryNodeFragment = (
  { __typename?: 'ItemSubCategoryEdge' }
  & { node?: Maybe<(
    { __typename?: 'ItemSubCategory' }
    & Pick<ItemSubCategory, 'id' | 'name' | 'archived'>
  )> }
);

export type CreateBookMutationVariables = Exact<{
  input: CreateBookMutationInput;
}>;


export type CreateBookMutation = (
  { __typename?: 'Mutation' }
  & { createBook?: Maybe<(
    { __typename?: 'CreateBookMutationPayload' }
    & { book?: Maybe<(
      { __typename?: 'Book' }
      & Pick<Book, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateEngravingMutationVariables = Exact<{
  input: CreateEngravingMutationInput;
}>;


export type CreateEngravingMutation = (
  { __typename?: 'Mutation' }
  & { createEngraving?: Maybe<(
    { __typename?: 'CreateEngravingMutationPayload' }
    & { engraving?: Maybe<(
      { __typename?: 'Engraving' }
      & Pick<Engraving, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateManuscriptMutationVariables = Exact<{
  input: CreateManuscriptMutationInput;
}>;


export type CreateManuscriptMutation = (
  { __typename?: 'Mutation' }
  & { createManuscript?: Maybe<(
    { __typename?: 'CreateManuscriptMutationPayload' }
    & { manuscript?: Maybe<(
      { __typename?: 'Manuscript' }
      & Pick<Manuscript, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateWatchMutationVariables = Exact<{
  input: CreateWatchMutationInput;
}>;


export type CreateWatchMutation = (
  { __typename?: 'Mutation' }
  & { createWatch?: Maybe<(
    { __typename?: 'CreateWatchMutationPayload' }
    & { watch?: Maybe<(
      { __typename?: 'Watch' }
      & Pick<Watch, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateGeographicMapMutationVariables = Exact<{
  input: CreateGeographicMapMutationInput;
}>;


export type CreateGeographicMapMutation = (
  { __typename?: 'Mutation' }
  & { createGeographicMap?: Maybe<(
    { __typename?: 'CreateGeographicMapMutationPayload' }
    & { geographicMap?: Maybe<(
      { __typename?: 'GeographicMap' }
      & Pick<GeographicMap, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateJewelryMutationVariables = Exact<{
  input: CreateJewelryMutationInput;
}>;


export type CreateJewelryMutation = (
  { __typename?: 'Mutation' }
  & { createJewelry?: Maybe<(
    { __typename?: 'CreateJewelryMutationPayload' }
    & { jewelry?: Maybe<(
      { __typename?: 'Jewelry' }
      & Pick<Jewelry, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateCeramicMutationVariables = Exact<{
  input: CreateCeramicMutationInput;
}>;


export type CreateCeramicMutation = (
  { __typename?: 'Mutation' }
  & { createCeramic?: Maybe<(
    { __typename?: 'CreateCeramicMutationPayload' }
    & { ceramic?: Maybe<(
      { __typename?: 'Ceramic' }
      & Pick<Ceramic, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateFurnitureMutationVariables = Exact<{
  input: CreateFurnitureMutationInput;
}>;


export type CreateFurnitureMutation = (
  { __typename?: 'Mutation' }
  & { createFurniture?: Maybe<(
    { __typename?: 'CreateFurnitureMutationPayload' }
    & { furniture?: Maybe<(
      { __typename?: 'Furniture' }
      & Pick<Furniture, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateCarpetTextileMutationVariables = Exact<{
  input: CreateCarpetTextileMutationInput;
}>;


export type CreateCarpetTextileMutation = (
  { __typename?: 'Mutation' }
  & { createCarpetTextile?: Maybe<(
    { __typename?: 'CreateCarpetTextileMutationPayload' }
    & { carpetTextile?: Maybe<(
      { __typename?: 'CarpetTextile' }
      & Pick<CarpetTextile, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreatePaintingSculptureMutationVariables = Exact<{
  input: CreatePaintingSculptureMutationInput;
}>;


export type CreatePaintingSculptureMutation = (
  { __typename?: 'Mutation' }
  & { createPaintingSculpture?: Maybe<(
    { __typename?: 'CreatePaintingSculptureMutationPayload' }
    & { paintingSculpture?: Maybe<(
      { __typename?: 'PaintingSculpture' }
      & Pick<PaintingSculpture, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreatePhotographyMutationVariables = Exact<{
  input: CreatePhotographyMutationInput;
}>;


export type CreatePhotographyMutation = (
  { __typename?: 'Mutation' }
  & { createPhotography?: Maybe<(
    { __typename?: 'CreatePhotographyMutationPayload' }
    & { photography?: Maybe<(
      { __typename?: 'Photography' }
      & Pick<Photography, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateCoinsMedalsStampsMutationVariables = Exact<{
  input: CreateCoinsMedalsStampsMutationInput;
}>;


export type CreateCoinsMedalsStampsMutation = (
  { __typename?: 'Mutation' }
  & { createCoinsMedalsStamps?: Maybe<(
    { __typename?: 'CreateCoinsMedalsStampsMutationPayload' }
    & { coinsMedalsStamps?: Maybe<(
      { __typename?: 'CoinsMedalsStamps' }
      & Pick<CoinsMedalsStamps, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateMilitariaMutationVariables = Exact<{
  input: CreateMilitariaMutationInput;
}>;


export type CreateMilitariaMutation = (
  { __typename?: 'Mutation' }
  & { createMilitaria?: Maybe<(
    { __typename?: 'CreateMilitariaMutationPayload' }
    & { militaria?: Maybe<(
      { __typename?: 'Militaria' }
      & Pick<Militaria, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateSilverwareTablewareMutationVariables = Exact<{
  input: CreateSilverwareTablewareMutationInput;
}>;


export type CreateSilverwareTablewareMutation = (
  { __typename?: 'Mutation' }
  & { createSilverwareTableware?: Maybe<(
    { __typename?: 'CreateSilverwareTablewareMutationPayload' }
    & { silverwareTableware?: Maybe<(
      { __typename?: 'SilverwareTableware' }
      & Pick<SilverwareTableware, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateFashionLuxuryAccessoryMutationVariables = Exact<{
  input: CreateFashionLuxuryAccessoryMutationInput;
}>;


export type CreateFashionLuxuryAccessoryMutation = (
  { __typename?: 'Mutation' }
  & { createFashionLuxuryAccessory?: Maybe<(
    { __typename?: 'CreateFashionLuxuryAccessoryMutationPayload' }
    & { fashionLuxuryAccessory?: Maybe<(
      { __typename?: 'FashionLuxuryAccessory' }
      & Pick<FashionLuxuryAccessory, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type CreateToyComicPopCultureMutationVariables = Exact<{
  input: CreateToyComicPopCultureMutationInput;
}>;


export type CreateToyComicPopCultureMutation = (
  { __typename?: 'Mutation' }
  & { createToyComicPopCulture?: Maybe<(
    { __typename?: 'CreateToyComicPopCultureMutationPayload' }
    & { toyComicPopCulture?: Maybe<(
      { __typename?: 'ToyComicPopCulture' }
      & Pick<ToyComicPopCulture, 'id'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'description'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'name'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'id' | 'name'>
        )> }
      ) }
    )> }
  )> }
);

export type UpdateVolumeMutationVariables = Exact<{
  attributes: UpdateVolumeInput;
}>;


export type UpdateVolumeMutation = (
  { __typename?: 'Mutation' }
  & { updateVolumes?: Maybe<(
    { __typename?: 'UpdateVolumeMutationPayload' }
    & Pick<UpdateVolumeMutationPayload, 'clientMutationId'>
    & { errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'details' | 'fullMessages'>
    )> }
  )> }
);

export type GetItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetItemQuery = (
  { __typename?: 'Query' }
  & { item?: Maybe<(
    { __typename?: 'Item' }
    & ItemFragment
  )> }
);

export type ItemFragment = (
  { __typename?: 'Item' }
  & Pick<Item, 'createdAt' | 'descriptionHeader' | 'description' | 'descriptionFooter' | 'conditionsComment' | 'globalComment' | 'height' | 'width' | 'length' | 'weight' | 'otherComment' | 'id' | 'sku' | 'customSkuPart' | 'conditionAccepted' | 'dateFrom' | 'dateTo' | 'dateOption' | 'catchPhrase' | 'catchPhraseEnabled' | 'customDescription' | 'customDescriptionEnabled' | 'autoDescription' | 'state' | 'locations' | 'locationKnownButNotMentioned' | 'artistUnknown' | 'artistCollectif' | 'artistKnownButNotMentioned' | 'mode' | 'descriptionSuggestion' | 'descriptionSuggestionGeneratedAt' | 'generationStatus' | 'salePosition' | 'updatedAt'>
  & { project?: Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'id' | 'title'>
  )>, images?: Maybe<Array<(
    { __typename?: 'Image' }
    & Pick<Image, 'imageUrl' | 'position'>
  )>>, invoices?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>>, authenticityDocuments?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>>, resaleInfo?: Maybe<(
    { __typename?: 'ItemResaleInfo' }
    & Pick<ItemResaleInfo, 'nextPrice' | 'discountPercentage' | 'unsoldCount' | 'canRelist' | 'status'>
  )>, expert?: Maybe<(
    { __typename?: 'Expert' }
    & ExpertFragment
  )>, vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & VendorFragment
  )>, writer?: Maybe<(
    { __typename?: 'Writer' }
    & WriterFragment
  )>, vacation?: Maybe<(
    { __typename?: 'Vacation' }
    & VacationFragment
  )>, template: (
    { __typename: 'Book' }
    & BookFragment
  ) | { __typename: 'CarpetTextile' } | { __typename: 'Ceramic' } | { __typename: 'CoinsMedalsStamps' } | (
    { __typename: 'Engraving' }
    & EngravingFragment
  ) | { __typename: 'FashionLuxuryAccessory' } | { __typename: 'Furniture' } | { __typename: 'GeographicMap' } | { __typename: 'Jewelry' } | (
    { __typename: 'Manuscript' }
    & ManuscriptFragment
  ) | { __typename: 'Militaria' } | { __typename: 'PaintingSculpture' } | { __typename: 'Photography' } | { __typename: 'SilverwareTableware' } | { __typename: 'ToyComicPopCulture' } | (
    { __typename: 'Watch' }
    & WatchFragment
  ) }
  & ItemStepsFragment
  & ItemCategoryFragment
  & ItemTitlesFragment
  & ItemPriceFragment
  & ItemArtistsFragment
  & TagsFragment
  & AutoTagsFragment
);

export type ManuscriptFragment = (
  { __typename?: 'Manuscript' }
  & Pick<Manuscript, 'id'>
);

export type EngravingFragment = (
  { __typename?: 'Engraving' }
  & Pick<Engraving, 'id'>
);

export type WatchFragment = (
  { __typename?: 'Watch' }
  & Pick<Watch, 'id'>
);

export type ExpertFragment = (
  { __typename?: 'Expert' }
  & Pick<Expert, 'id' | 'externalRainworxId'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'firstName' | 'lastName' | 'state'>
  ) }
);

export type VendorFragment = (
  { __typename?: 'Vendor' }
  & Pick<Vendor, 'id' | 'externalRainworxId'>
  & { account: (
    { __typename?: 'Account' }
    & VendorAccountFragment
  ) }
);

export type VendorAccountFragment = (
  { __typename?: 'Account' }
  & Pick<Account, 'id' | 'firstName' | 'lastName' | 'email' | 'state' | 'isProfessional'>
);

export type FileFragment = (
  { __typename?: 'CustomFile' }
  & Pick<CustomFile, 'imageUrl' | 'filename' | 'extension' | 'blobId'>
);

export type AutoTagsFragment = (
  { __typename?: 'Item' }
  & { autoTags?: Maybe<(
    { __typename?: 'TagConnection' }
    & TagEdgesFragment
  )> }
);

export type TagsFragment = (
  { __typename?: 'Item' }
  & { tags?: Maybe<(
    { __typename?: 'TagConnection' }
    & TagEdgesFragment
  )> }
);

export type ItemStepsFragment = (
  { __typename?: 'Item' }
  & { itemSteps?: Maybe<(
    { __typename?: 'ItemStepConnection' }
    & ItemStepEdgesFragment
  )> }
);

export type ItemStepEdgesFragment = (
  { __typename?: 'ItemStepConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'ItemStepEdge' }
    & ItemStepNodeFragment
  )>>> }
);

export type ItemStepNodeFragment = (
  { __typename?: 'ItemStepEdge' }
  & { node?: Maybe<(
    { __typename?: 'ItemStep' }
    & ItemStepFragment
  )> }
);

export type ItemStepFragment = (
  { __typename?: 'ItemStep' }
  & Pick<ItemStep, 'id' | 'number' | 'comment' | 'state' | 'name'>
);

export type ItemArtistsFragment = (
  { __typename?: 'Item' }
  & { artists?: Maybe<(
    { __typename?: 'ArtistConnection' }
    & ItemArtistEdgesFragment
  )> }
);

export type ItemArtistEdgesFragment = (
  { __typename?: 'ArtistConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistEdge' }
    & ItemArtistNodeFragment
  )>>> }
);

export type ItemArtistNodeFragment = (
  { __typename?: 'ArtistEdge' }
  & { node?: Maybe<(
    { __typename?: 'Artist' }
    & ArtistFragment
  )> }
);

export type ArtistFragment = (
  { __typename?: 'Artist' }
  & Pick<Artist, 'id' | 'firstName' | 'lastName' | 'isGroup' | 'tag' | 'itemCategoryId'>
);

export type ItemCategoryFragment = (
  { __typename?: 'Item' }
  & { itemCategory?: Maybe<(
    { __typename?: 'ItemCategory' }
    & Pick<ItemCategory, 'id' | 'name' | 'templateType' | 'externalRainworxId'>
  )>, itemSubCategory?: Maybe<(
    { __typename?: 'ItemSubCategory' }
    & Pick<ItemSubCategory, 'id' | 'name' | 'externalRainworxId'>
  )> }
);

export type VacationFragment = (
  { __typename?: 'Vacation' }
  & Pick<Vacation, 'id' | 'name' | 'description' | 'state' | 'startAt' | 'endAt'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'imageUrl'>
  )>, expert?: Maybe<(
    { __typename?: 'Expert' }
    & Pick<Expert, 'id'>
  )> }
);

export type ItemPriceFragment = (
  { __typename?: 'Item' }
  & Pick<Item, 'lowEstimatedPrice' | 'highEstimatedPrice' | 'reservedPrice' | 'startingPrice'>
);

export type ItemTitlesFragment = (
  { __typename?: 'Item' }
  & Pick<Item, 'title' | 'saleTitle' | 'subtitle' | 'state'>
);

export type GetBookQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBookQuery = (
  { __typename?: 'Query' }
  & { book?: Maybe<(
    { __typename?: 'Book' }
    & BookFragment
  )> }
);

export type BookFragment = (
  { __typename?: 'Book' }
  & Pick<Book, 'createdAt' | 'id' | 'updatedAt' | 'publishers' | 'bibliographyComment' | 'illustrationComment' | 'collationComment' | 'assemblySpecification' | 'assemblyType' | 'bindingColor' | 'bindingFormat' | 'bindingStyle' | 'bindingMaterial' | 'bindingFormatDetails' | 'bindingType' | 'bindingTypeOptions' | 'bookSpineMaterial' | 'bookSpineOrnament1' | 'bookSpineOrnament1Option' | 'bookSpineOrnament2' | 'bookSpineOrnament2Option' | 'bookSpineOrnamentOption' | 'bookSpineType' | 'bindingAge' | 'bindingMaterialOptions' | 'bindingAdditionalOptions' | 'bookBinder' | 'size' | 'coverType' | 'coverQuality' | 'coverColor' | 'coverMaterial' | 'coverOrnament1' | 'coverOrnament1Option' | 'coverOrnament2' | 'coverOrnament2Option' | 'coverOrnamentOption' | 'edgeColor' | 'edgeStyle' | 'edgeType' | 'isOblong' | 'dumbSpine' | 'isBindingSigned' | 'paperbackType' | 'isApproximatelyPaginating' | 'isPaginating' | 'paginationInfo' | 'withFolder' | 'casingType'>
  & { volumes?: Maybe<(
    { __typename?: 'VolumeConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'VolumeEdge' }
      & { node?: Maybe<(
        { __typename?: 'Volume' }
        & Pick<Volume, 'id'>
        & { parts?: Maybe<(
          { __typename?: 'PartConnection' }
          & { edges?: Maybe<Array<Maybe<(
            { __typename?: 'PartEdge' }
            & { node?: Maybe<(
              { __typename?: 'Part' }
              & Pick<Part, 'id'>
            )> }
          )>>> }
        )> }
      )> }
    )>>> }
  )>, item: (
    { __typename?: 'Item' }
    & Pick<Item, 'id' | 'state'>
  ) }
  & PublishingBookFragment
);

export type PublishingBookFragment = (
  { __typename?: 'Book' }
  & Pick<Book, 'id' | 'publishers' | 'publisherKnownButNotMentioned' | 'editingAttribute' | 'editingAttributeDetails'>
  & { item: (
    { __typename?: 'Item' }
    & Pick<Item, 'id' | 'locations' | 'locationKnownButNotMentioned' | 'dateFrom' | 'dateTo' | 'dateOption'>
  ) }
);

export type UpdateItemMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateItemInput;
}>;


export type UpdateItemMutation = (
  { __typename?: 'Mutation' }
  & { updateItem?: Maybe<(
    { __typename?: 'UpdateItemMutationPayload' }
    & Pick<UpdateItemMutationPayload, 'clientMutationId' | 'errors'>
    & { item: (
      { __typename?: 'Item' }
      & Pick<Item, 'id'>
    ) }
  )> }
);

export type DuplicateItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DuplicateItemMutation = (
  { __typename?: 'Mutation' }
  & { duplicateItem?: Maybe<(
    { __typename?: 'DuplicateItemMutationPayload' }
    & Pick<DuplicateItemMutationPayload, 'clientMutationId'>
    & { item: (
      { __typename?: 'Item' }
      & Pick<Item, 'id'>
    ) }
  )> }
);

export type DestroyItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyItemMutation = (
  { __typename?: 'Mutation' }
  & { destroyItem?: Maybe<(
    { __typename?: 'DestroyItemMutationPayload' }
    & { item?: Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id'>
    )> }
  )> }
);

export type UpdateBookMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateBookInput;
}>;


export type UpdateBookMutation = (
  { __typename?: 'Mutation' }
  & { updateBook?: Maybe<(
    { __typename?: 'UpdateBookMutationPayload' }
    & { book?: Maybe<(
      { __typename?: 'Book' }
      & Pick<Book, 'id'>
    )> }
  )> }
);

export type ItemMovementQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ItemMovementQuery = (
  { __typename?: 'Query' }
  & { itemMovement?: Maybe<(
    { __typename?: 'ItemMovement' }
    & ItemMovementFragment
  )> }
);

export type ItemMovementsQueryVariables = Exact<{
  where?: Maybe<ItemMovementFilter>;
  first?: Maybe<Scalars['Int']>;
}>;


export type ItemMovementsQuery = (
  { __typename?: 'Query' }
  & { itemMovements: (
    { __typename?: 'ItemMovementConnection' }
    & ItemMovementEdgesFragment
  ) }
);

export type ItemMovementEdgesFragment = (
  { __typename?: 'ItemMovementConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'ItemMovementEdge' }
    & ItemMovementNodeFragment
  )>>> }
);

export type ItemMovementNodeFragment = (
  { __typename?: 'ItemMovementEdge' }
  & { node?: Maybe<(
    { __typename?: 'ItemMovement' }
    & ItemMovementFragment
  )> }
);

export type ItemMovementFragment = (
  { __typename?: 'ItemMovement' }
  & Pick<ItemMovement, 'id' | 'createdAt' | 'fromLocation' | 'toLocation'>
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'email' | 'firstName' | 'lastName'>
  )>, itemMovementEntries?: Maybe<(
    { __typename?: 'ItemMovementEntryConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemMovementEntryEdge' }
      & { node?: Maybe<(
        { __typename?: 'ItemMovementEntry' }
        & Pick<ItemMovementEntry, 'id' | 'oldSku' | 'newSku'>
      )> }
    )>>> }
  )> }
);

export type UpdateItemMovementMutationVariables = Exact<{
  input: UpdateItemMovementMutationInput;
}>;


export type UpdateItemMovementMutation = (
  { __typename?: 'Mutation' }
  & { updateItemMovement?: Maybe<(
    { __typename?: 'UpdateItemMovementMutationPayload' }
    & { itemMovement?: Maybe<(
      { __typename?: 'ItemMovement' }
      & Pick<ItemMovement, 'id'>
    )> }
  )> }
);

export type CreateItemMovementMutationVariables = Exact<{
  input: CreateItemMovementMutationInput;
}>;


export type CreateItemMovementMutation = (
  { __typename?: 'Mutation' }
  & { createItemMovement?: Maybe<(
    { __typename?: 'CreateItemMovementMutationPayload' }
    & { itemMovement?: Maybe<(
      { __typename?: 'ItemMovement' }
      & Pick<ItemMovement, 'id'>
    )> }
  )> }
);

export type ItemsQueryQueryVariables = Exact<{
  where?: Maybe<ItemFilter>;
  orderByAttribute?: Maybe<Array<ItemOrderType>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type ItemsQueryQuery = (
  { __typename?: 'Query' }
  & { items: (
    { __typename?: 'ItemConnection' }
    & Pick<ItemConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemEdge' }
      & Pick<ItemEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Item' }
        & ItemTableFragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type ItemsWithImagesQueryQueryVariables = Exact<{
  where?: Maybe<ItemFilter>;
  orderByAttribute?: Maybe<Array<ItemOrderType>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type ItemsWithImagesQueryQuery = (
  { __typename?: 'Query' }
  & { items: (
    { __typename?: 'ItemConnection' }
    & Pick<ItemConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemEdge' }
      & Pick<ItemEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Item' }
        & ItemTableFragment
        & ItemFragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type ItemsWithImagesForDodecadeExportQueryQueryVariables = Exact<{
  where?: Maybe<ItemFilter>;
  orderByAttribute?: Maybe<Array<ItemOrderType>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type ItemsWithImagesForDodecadeExportQueryQuery = (
  { __typename?: 'Query' }
  & { items: (
    { __typename?: 'ItemConnection' }
    & Pick<ItemConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemEdge' }
      & Pick<ItemEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Item' }
        & Pick<Item, 'createdAt' | 'updatedAt' | 'title' | 'saleTitle' | 'subtitle' | 'customDescription' | 'description' | 'descriptionHeader' | 'descriptionFooter' | 'mode' | 'finalPrice' | 'autoDescription' | 'startingPrice' | 'reservedPrice' | 'resaleStatus' | 'highEstimatedPrice' | 'lowEstimatedPrice' | 'state' | 'unsoldCount' | 'initialStartingPrice' | 'initialReservedPrice' | 'lastSaleEndedAt' | 'nextEligibleDate' | 'vendorActionDeadline' | 'projectCounter' | 'width' | 'weight' | 'totalWeight' | 'length' | 'height' | 'id' | 'salePosition'>
        & { itemCategory?: Maybe<(
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'externalRainworxId'>
        )>, itemSubCategory?: Maybe<(
          { __typename?: 'ItemSubCategory' }
          & Pick<ItemSubCategory, 'externalRainworxId'>
        )>, resaleInfo?: Maybe<(
          { __typename?: 'ItemResaleInfo' }
          & Pick<ItemResaleInfo, 'nextPrice' | 'discountPercentage' | 'unsoldCount' | 'canRelist' | 'status'>
        )>, project?: Maybe<(
          { __typename?: 'Project' }
          & Pick<Project, 'id' | 'number'>
        )>, vacation?: Maybe<(
          { __typename?: 'Vacation' }
          & Pick<Vacation, 'id' | 'name'>
        )>, images?: Maybe<Array<(
          { __typename?: 'Image' }
          & Pick<Image, 'position' | 'imageUrl'>
        )>>, template: { __typename: 'Book' } | { __typename: 'CarpetTextile' } | { __typename: 'Ceramic' } | { __typename: 'CoinsMedalsStamps' } | { __typename: 'Engraving' } | { __typename: 'FashionLuxuryAccessory' } | { __typename: 'Furniture' } | { __typename: 'GeographicMap' } | { __typename: 'Jewelry' } | { __typename: 'Manuscript' } | { __typename: 'Militaria' } | { __typename: 'PaintingSculpture' } | { __typename: 'Photography' } | { __typename: 'SilverwareTableware' } | { __typename: 'ToyComicPopCulture' } | { __typename: 'Watch' }, vendor?: Maybe<(
          { __typename?: 'Vendor' }
          & Pick<Vendor, 'id' | 'shippingOptions'>
          & { defaultPickupAddress?: Maybe<(
            { __typename?: 'Address' }
            & VendorAddressFragment
          )>, defaultProfileAddress?: Maybe<(
            { __typename?: 'Address' }
            & VendorAddressFragment
          )> }
        )> }
        & ItemFragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type SaleReviewItemsQueryQueryVariables = Exact<{
  where?: Maybe<ItemFilter>;
  orderByAttribute?: Maybe<Array<ItemOrderType>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type SaleReviewItemsQueryQuery = (
  { __typename?: 'Query' }
  & { items: (
    { __typename?: 'ItemConnection' }
    & Pick<ItemConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemEdge' }
      & Pick<ItemEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'salePosition' | 'title' | 'sku' | 'updatedAt' | 'customDescription' | 'autoDescription' | 'lowEstimatedPrice' | 'highEstimatedPrice' | 'startingPrice' | 'reservedPrice' | 'projectCounter'>
        & { project?: Maybe<(
          { __typename?: 'Project' }
          & Pick<Project, 'id' | 'number'>
        )>, vacation?: Maybe<(
          { __typename?: 'Vacation' }
          & Pick<Vacation, 'id' | 'name'>
        )>, firstImage?: Maybe<(
          { __typename?: 'Image' }
          & Pick<Image, 'imageUrl' | 'position'>
        )> }
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type CreateDrouotExportCsvMutationVariables = Exact<{
  saleId: Scalars['ID'];
  itemIds: Array<Scalars['ID']>;
}>;


export type CreateDrouotExportCsvMutation = (
  { __typename?: 'Mutation' }
  & { createDrouotExportCsv?: Maybe<(
    { __typename?: 'CreateDrouotExportCsvMutationPayload' }
    & Pick<CreateDrouotExportCsvMutationPayload, 'clientMutationId'>
    & { sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id'>
    )> }
  )> }
);

export type BulkUpdateSalePositionsMutationVariables = Exact<{
  input: BulkUpdateSalePositionsMutationInput;
}>;


export type BulkUpdateSalePositionsMutation = (
  { __typename?: 'Mutation' }
  & { bulkUpdateSalePositions?: Maybe<(
    { __typename?: 'BulkUpdateSalePositionsMutationPayload' }
    & Pick<BulkUpdateSalePositionsMutationPayload, 'errors'>
    & { items?: Maybe<Array<(
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'salePosition'>
    )>> }
  )> }
);

export type ExpertsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpertsQuery = (
  { __typename?: 'Query' }
  & { experts: (
    { __typename?: 'ExpertConnection' }
    & ExpertEdgesFragment
  ) }
);

export type ExpertEdgesFragment = (
  { __typename?: 'ExpertConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'ExpertEdge' }
    & ExpertNodeFragment
  )>>> }
);

export type ExpertNodeFragment = (
  { __typename?: 'ExpertEdge' }
  & { node?: Maybe<(
    { __typename?: 'Expert' }
    & ExpertFragment
  )> }
);

export type ItemEdgesFragment = (
  { __typename?: 'ItemConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'ItemEdge' }
    & ItemNodeFragment
  )>>> }
);

export type ItemNodeFragment = (
  { __typename?: 'ItemEdge' }
  & { node?: Maybe<(
    { __typename?: 'Item' }
    & ItemFragment
  )> }
);

export type ItemTableFragment = (
  { __typename?: 'Item' }
  & Pick<Item, 'id' | 'artistUnknown' | 'artistCollectif' | 'title' | 'state' | 'highEstimatedPrice' | 'salePosition' | 'finalPrice' | 'projectCounter' | 'sku' | 'createdAt' | 'refusedAt' | 'startingPrice' | 'unsoldCount' | 'lastSaleEndedAt' | 'nextEligibleDate' | 'isLibraryFundItem' | 'reservedPrice' | 'resaleStatus' | 'vendorDecision' | 'vendorDecisionAt' | 'vendorActionDeadline' | 'initialStartingPrice'>
  & { firstImage?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'imageUrl' | 'position'>
  )>, expert?: Maybe<(
    { __typename?: 'Expert' }
    & ItemExpertFragment
  )>, vacation?: Maybe<(
    { __typename?: 'Vacation' }
    & Pick<Vacation, 'id' | 'name'>
  )>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id'>
  )>, project?: Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'id' | 'title'>
  )>, vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'firstName' | 'lastName'>
    ) }
  )>, writer?: Maybe<(
    { __typename?: 'Writer' }
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'firstName' | 'lastName'>
    ) }
  )>, resaleInfo?: Maybe<(
    { __typename?: 'ItemResaleInfo' }
    & Pick<ItemResaleInfo, 'canRelist' | 'status' | 'nextPrice' | 'nextEligibleDate' | 'unsoldCount' | 'daysUntilEligible' | 'discountPercentage'>
  )> }
  & ItemCategoryFragment
  & ItemArtistsFragment
);

export type NewsLettersQueryVariables = Exact<{
  where?: Maybe<NewsLetterFilter>;
  direction?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type NewsLettersQuery = (
  { __typename?: 'Query' }
  & { newsLetters: (
    { __typename?: 'NewsLetterConnection' }
    & NewsLetterEdgesFragment
  ) }
);

export type NewsLetterEdgesFragment = (
  { __typename?: 'NewsLetterConnection' }
  & Pick<NewsLetterConnection, 'totalCount'>
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'NewsLetterEdge' }
    & NewsLetterNodeFragment
  )>>>, pageInfo: (
    { __typename?: 'PageInfo' }
    & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
  ) }
);

export type NewsLetterNodeFragment = (
  { __typename?: 'NewsLetterEdge' }
  & { node?: Maybe<(
    { __typename?: 'NewsLetter' }
    & NewsLetterFragment
  )> }
);

export type NewsLetterFragment = (
  { __typename?: 'NewsLetter' }
  & Pick<NewsLetter, 'id' | 'htmlContent' | 'test' | 'emailFrom' | 'emailTo' | 'subject' | 'isGeneral' | 'createdAt' | 'nbItems'>
  & { buyer?: Maybe<(
    { __typename?: 'Buyer' }
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'firstName' | 'lastName' | 'email'>
    ), autoTags?: Maybe<(
      { __typename?: 'TagConnection' }
      & TagEdgesFragment
    )>, expertTags?: Maybe<(
      { __typename?: 'TagConnection' }
      & TagEdgesFragment
    )>, importTags?: Maybe<(
      { __typename?: 'TagConnection' }
      & TagEdgesFragment
    )>, bookmarkTags?: Maybe<(
      { __typename?: 'TagConnection' }
      & TagEdgesFragment
    )>, tags?: Maybe<(
      { __typename?: 'TagConnection' }
      & TagEdgesFragment
    )> }
  )>, customer?: Maybe<(
    { __typename?: 'Customer' }
    & Pick<Customer, 'firstName' | 'lastName' | 'email'>
    & { tags?: Maybe<(
      { __typename?: 'TagConnection' }
      & TagEdgesFragment
    )> }
  )>, sale: (
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name'>
  ) }
);

export type CreateNewsLetterMutationVariables = Exact<{
  input: CreateNewsLetterMutationInput;
}>;


export type CreateNewsLetterMutation = (
  { __typename?: 'Mutation' }
  & { createNewsLetter?: Maybe<(
    { __typename?: 'CreateNewsLetterMutationPayload' }
    & { sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id' | 'name'>
    )> }
  )> }
);

export type OnboardingAccountFragment = (
  { __typename?: 'Account' }
  & Pick<Account, 'id' | 'isProfessional' | 'firstName' | 'lastName' | 'phone' | 'companyName' | 'siret' | 'tvaNumber'>
  & { shippingAddress?: Maybe<(
    { __typename?: 'Address' }
    & Pick<Address, 'id' | 'lastName' | 'phone1' | 'email' | 'addressLine1' | 'city' | 'zip' | 'country'>
  )> }
);

export type OrdersQueryVariables = Exact<{
  where?: Maybe<OrderFilterType>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  orderBy?: Maybe<ItemOrderType>;
}>;


export type OrdersQuery = (
  { __typename?: 'Query' }
  & { orders: (
    { __typename?: 'OrderConnection' }
    & Pick<OrderConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'OrderEdge' }
      & { node?: Maybe<(
        { __typename?: 'Order' }
        & OrderTableFragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type OrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderQuery = (
  { __typename?: 'Query' }
  & { order?: Maybe<(
    { __typename?: 'Order' }
    & OrderFragment
  )> }
);

export type OrderFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'totalPrice' | 'totalPriceTaxIncluded' | 'totalTax' | 'totalItemsPrice' | 'shippingPrice' | 'shippingPriceTaxIncluded' | 'shippingTax' | 'insurancePrice' | 'insurancePriceTaxIncluded' | 'insuranceTax' | 'buyerFee' | 'buyerFeeTaxIncluded' | 'buyerFeeTax' | 'carrierName' | 'state' | 'createdAt' | 'paidAt' | 'saleEndAt' | 'comment' | 'vendorComment' | 'dodecadeInvoiceRef' | 'dodecadeOrderRef'>
  & { shippingAddress?: Maybe<(
    { __typename?: 'Address' }
    & Pick<Address, 'id' | 'addressLine1' | 'addressLine2' | 'city' | 'zip' | 'state' | 'country' | 'email' | 'firstName' | 'lastName' | 'companyName' | 'phone1' | 'phone2'>
  )>, histories?: Maybe<Array<(
    { __typename?: 'OrderHistory' }
    & Pick<OrderHistory, 'id' | 'event' | 'whodunnit' | 'objectChanges' | 'createdAt'>
  )>>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name'>
  )>, orderItems: (
    { __typename?: 'OrderItemConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'OrderItemEdge' }
      & { node?: Maybe<(
        { __typename?: 'OrderItem' }
        & Pick<OrderItem, 'id' | 'state' | 'carrierName'>
        & { vendor?: Maybe<(
          { __typename?: 'Vendor' }
          & Pick<Vendor, 'id'>
        )>, item: (
          { __typename?: 'Item' }
          & Pick<Item, 'id' | 'title' | 'sku' | 'finalPrice' | 'dodecadeItemRef' | 'weight'>
          & { images?: Maybe<Array<(
            { __typename?: 'Image' }
            & Pick<Image, 'imageUrl' | 'position'>
          )>> }
        ) }
      )> }
    )>>> }
  ), labels: (
    { __typename?: 'LabelConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'LabelEdge' }
      & { node?: Maybe<(
        { __typename?: 'Label' }
        & Pick<Label, 'id' | 'trackingNumber' | 'undeplusRef' | 'carrierName' | 'externalLabelUrl' | 'trackingUrl' | 'cn23Explanation' | 'status' | 'errorMessage' | 'weight'>
        & { labelDocument?: Maybe<(
          { __typename?: 'CustomFile' }
          & Pick<CustomFile, 'imageUrl'>
        )>, cn23Document?: Maybe<(
          { __typename?: 'CustomFile' }
          & Pick<CustomFile, 'imageUrl'>
        )>, vendor?: Maybe<(
          { __typename?: 'Vendor' }
          & Pick<Vendor, 'id'>
        )> }
      )> }
    )>>> }
  ) }
);

export type OrderTableFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'undeplusRef' | 'dodecadeInvoiceRef' | 'dodecadeOrderRef' | 'totalPrice' | 'totalPriceTaxIncluded' | 'state' | 'stripePaymentLink' | 'totalItemsPrice' | 'trackingUrls' | 'labelUrls' | 'trackingNumbers' | 'carrierName' | 'createdAt' | 'paidAt' | 'saleEndAt'>
  & { buyer?: Maybe<(
    { __typename?: 'Buyer' }
    & Pick<Buyer, 'id'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'firstName' | 'lastName' | 'companyName'>
    ) }
  )>, vendors?: Maybe<Array<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'firstName' | 'lastName' | 'companyName'>
    ) }
  )>>, orderItems: (
    { __typename?: 'OrderItemConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'OrderItemEdge' }
      & { node?: Maybe<(
        { __typename?: 'OrderItem' }
        & Pick<OrderItem, 'id' | 'state' | 'carrierName'>
        & { vendor?: Maybe<(
          { __typename?: 'Vendor' }
          & Pick<Vendor, 'id'>
        )>, item: (
          { __typename?: 'Item' }
          & Pick<Item, 'title' | 'sku' | 'finalPrice'>
        ) }
      )> }
    )>>> }
  ), labels: (
    { __typename?: 'LabelConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'LabelEdge' }
      & { node?: Maybe<(
        { __typename?: 'Label' }
        & Pick<Label, 'trackingNumber' | 'undeplusRef' | 'externalLabelUrl' | 'trackingUrl'>
        & { labelDocument?: Maybe<(
          { __typename?: 'CustomFile' }
          & Pick<CustomFile, 'imageUrl'>
        )>, vendor?: Maybe<(
          { __typename?: 'Vendor' }
          & Pick<Vendor, 'id'>
        )> }
      )> }
    )>>> }
  ), sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name'>
  )> }
);

export type UpdateOrderItemMutationVariables = Exact<{
  input: UpdateOrderItemMutationInput;
}>;


export type UpdateOrderItemMutation = (
  { __typename?: 'Mutation' }
  & { updateOrderItem?: Maybe<(
    { __typename?: 'UpdateOrderItemMutationPayload' }
    & { orderItem?: Maybe<(
      { __typename?: 'OrderItem' }
      & Pick<OrderItem, 'id'>
    )> }
  )> }
);

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderMutationInput;
}>;


export type UpdateOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateOrder?: Maybe<(
    { __typename?: 'UpdateOrderMutationPayload' }
    & { order?: Maybe<(
      { __typename?: 'Order' }
      & Pick<Order, 'id'>
    )> }
  )> }
);

export type RegenerateLabelMutationVariables = Exact<{
  input: RegenerateLabelMutationInput;
}>;


export type RegenerateLabelMutation = (
  { __typename?: 'Mutation' }
  & { regenerateLabel?: Maybe<(
    { __typename?: 'RegenerateLabelMutationPayload' }
    & Pick<RegenerateLabelMutationPayload, 'errors'>
    & { label?: Maybe<(
      { __typename?: 'Label' }
      & Pick<Label, 'id' | 'status' | 'errorMessage'>
    )> }
  )> }
);

export type PaidSlipsQueryVariables = Exact<{
  where?: Maybe<PaidSlipFilter>;
}>;


export type PaidSlipsQuery = (
  { __typename?: 'Query' }
  & { paidSlips: (
    { __typename?: 'PaidSlipConnection' }
    & PaidSlipEdgesFragment
  ) }
);

export type PaidSlipEdgesFragment = (
  { __typename?: 'PaidSlipConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'PaidSlipEdge' }
    & PaidSlipNodeFragment
  )>>> }
);

export type PaidSlipNodeFragment = (
  { __typename?: 'PaidSlipEdge' }
  & { node?: Maybe<(
    { __typename?: 'PaidSlip' }
    & PaidSlipFragment
  )> }
);

export type PaidSlipFragment = (
  { __typename?: 'PaidSlip' }
  & Pick<PaidSlip, 'id' | 'createdAt' | 'nbItems' | 'number'>
  & { document?: Maybe<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>, buyer?: Maybe<(
    { __typename?: 'Buyer' }
    & Pick<Buyer, 'id'>
  )>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id'>
  )> }
);

export type BulkMarkExpertStatementPaymentsAsPaidMutationVariables = Exact<{
  input: BulkMarkExpertStatementPaymentsAsPaidInput;
}>;


export type BulkMarkExpertStatementPaymentsAsPaidMutation = (
  { __typename?: 'Mutation' }
  & { bulkMarkExpertStatementPaymentsAsPaid?: Maybe<(
    { __typename?: 'BulkMarkExpertStatementPaymentsAsPaidPayload' }
    & Pick<BulkMarkExpertStatementPaymentsAsPaidPayload, 'updatedCount' | 'errors'>
  )> }
);

export type BulkMarkExpertPaymentsAsPaidMutationVariables = Exact<{
  input: BulkMarkExpertPaymentsAsPaidInput;
}>;


export type BulkMarkExpertPaymentsAsPaidMutation = (
  { __typename?: 'Mutation' }
  & { bulkMarkExpertPaymentsAsPaid?: Maybe<(
    { __typename?: 'BulkMarkExpertPaymentsAsPaidPayload' }
    & Pick<BulkMarkExpertPaymentsAsPaidPayload, 'updatedCount' | 'errors'>
  )> }
);

export type BulkMarkWriterPaymentsAsPaidMutationVariables = Exact<{
  input: BulkMarkWriterPaymentsAsPaidInput;
}>;


export type BulkMarkWriterPaymentsAsPaidMutation = (
  { __typename?: 'Mutation' }
  & { bulkMarkWriterPaymentsAsPaid?: Maybe<(
    { __typename?: 'BulkMarkWriterPaymentsAsPaidPayload' }
    & Pick<BulkMarkWriterPaymentsAsPaidPayload, 'updatedCount' | 'errors'>
  )> }
);

export type BulkMarkWriterStatementPaymentsAsPaidMutationVariables = Exact<{
  input: BulkMarkWriterStatementPaymentsAsPaidInput;
}>;


export type BulkMarkWriterStatementPaymentsAsPaidMutation = (
  { __typename?: 'Mutation' }
  & { bulkMarkWriterStatementPaymentsAsPaid?: Maybe<(
    { __typename?: 'BulkMarkWriterStatementPaymentsAsPaidPayload' }
    & Pick<BulkMarkWriterStatementPaymentsAsPaidPayload, 'updatedCount' | 'errors'>
  )> }
);

export type BulkMarkImportPaymentsAsPaidMutationVariables = Exact<{
  input: BulkMarkImportPaymentsAsPaidInput;
}>;


export type BulkMarkImportPaymentsAsPaidMutation = (
  { __typename?: 'Mutation' }
  & { bulkMarkImportPaymentsAsPaid?: Maybe<(
    { __typename?: 'BulkMarkImportPaymentsAsPaidPayload' }
    & Pick<BulkMarkImportPaymentsAsPaidPayload, 'updatedCount' | 'errors'>
  )> }
);

export type BulkMarkImportStatementPaymentsAsPaidMutationVariables = Exact<{
  input: BulkMarkImportStatementPaymentsAsPaidInput;
}>;


export type BulkMarkImportStatementPaymentsAsPaidMutation = (
  { __typename?: 'Mutation' }
  & { bulkMarkImportStatementPaymentsAsPaid?: Maybe<(
    { __typename?: 'BulkMarkImportStatementPaymentsAsPaidPayload' }
    & Pick<BulkMarkImportStatementPaymentsAsPaidPayload, 'updatedCount' | 'errors'>
  )> }
);

export type BulkMarkMonthlyVendorPaymentsAsPaidMutationVariables = Exact<{
  input: BulkMarkMonthlyVendorPaymentsAsPaidInput;
}>;


export type BulkMarkMonthlyVendorPaymentsAsPaidMutation = (
  { __typename?: 'Mutation' }
  & { bulkMarkMonthlyVendorPaymentsAsPaid?: Maybe<(
    { __typename?: 'BulkMarkMonthlyVendorPaymentsAsPaidPayload' }
    & Pick<BulkMarkMonthlyVendorPaymentsAsPaidPayload, 'updatedCount' | 'errors'>
  )> }
);

export type BulkMarkVendorStatementPaymentsAsPaidMutationVariables = Exact<{
  input: BulkMarkVendorStatementPaymentsAsPaidInput;
}>;


export type BulkMarkVendorStatementPaymentsAsPaidMutation = (
  { __typename?: 'Mutation' }
  & { bulkMarkVendorStatementPaymentsAsPaid?: Maybe<(
    { __typename?: 'BulkMarkVendorStatementPaymentsAsPaidPayload' }
    & Pick<BulkMarkVendorStatementPaymentsAsPaidPayload, 'updatedCount' | 'errors'>
  )> }
);

export type UpdateUserPersonalInformationsMutationVariables = Exact<{
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
}>;


export type UpdateUserPersonalInformationsMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  )> }
);

export type CreatePickupRequestMutationVariables = Exact<{
  input: CreatePickupRequestMutationInput;
}>;


export type CreatePickupRequestMutation = (
  { __typename?: 'Mutation' }
  & { createPickupRequest?: Maybe<(
    { __typename?: 'CreatePickupRequestMutationPayload' }
    & { pickupRequest?: Maybe<(
      { __typename?: 'PickupRequest' }
      & PickupRequestFragment
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type AvailablePickupLabelsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type AvailablePickupLabelsQuery = (
  { __typename?: 'Query' }
  & { availablePickupLabels: (
    { __typename?: 'LabelConnection' }
    & Pick<LabelConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Label' }
      & PickupParcelFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
    ) }
  ) }
);

export type PickupRequestQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PickupRequestQuery = (
  { __typename?: 'Query' }
  & { pickupRequest?: Maybe<(
    { __typename?: 'PickupRequest' }
    & PickupRequestFragment
  )> }
);

export type PickupRequestsQueryVariables = Exact<{
  where?: Maybe<PickupRequestFilter>;
  orderBy?: Maybe<ItemOrderType>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type PickupRequestsQuery = (
  { __typename?: 'Query' }
  & { pickupRequests: (
    { __typename?: 'PickupRequestConnection' }
    & Pick<PickupRequestConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'PickupRequest' }
      & PickupRequestFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
    ) }
  ) }
);

export type PickupParcelFragment = (
  { __typename?: 'Label' }
  & Pick<Label, 'id' | 'trackingNumber'>
  & { orderItems?: Maybe<Array<(
    { __typename?: 'OrderItem' }
    & Pick<OrderItem, 'id'>
    & { item: (
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'title'>
    ), order?: Maybe<(
      { __typename?: 'Order' }
      & Pick<Order, 'id'>
    )> }
  )>> }
);

export type PickupRequestFragment = (
  { __typename?: 'PickupRequest' }
  & Pick<PickupRequest, 'id' | 'status' | 'dispatchNumber' | 'errorCode' | 'errorMessage' | 'pickupAddress' | 'pickupLocationCloseTime' | 'instructions' | 'pickupLocation' | 'createdAt' | 'pickupTimestamp'>
  & { pickupRequestLabels: Array<(
    { __typename?: 'PickupRequestLabel' }
    & Pick<PickupRequestLabel, 'status' | 'errorCode' | 'errorMessage'>
    & { label: (
      { __typename?: 'Label' }
      & PickupParcelFragment
    ) }
  )> }
);

export type GetAddressesProfileQueryVariables = Exact<{
  where?: Maybe<AddressFilter>;
}>;


export type GetAddressesProfileQuery = (
  { __typename?: 'Query' }
  & { addresses: (
    { __typename?: 'AddressConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'AddressEdge' }
      & { node?: Maybe<(
        { __typename?: 'Address' }
        & AddressProfileFragment
      )> }
    )>>> }
  ) }
);

export type AddressProfileFragment = (
  { __typename?: 'Address' }
  & Pick<Address, 'id' | 'createdAt' | 'updatedAt' | 'number' | 'addressLine1' | 'addressLine2' | 'addressLine3' | 'zip' | 'city' | 'country' | 'type'>
);

export type UpdateAddressMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateAddressInput;
}>;


export type UpdateAddressMutation = (
  { __typename?: 'Mutation' }
  & { updateAddress?: Maybe<(
    { __typename?: 'UpdateAddressMutationPayload' }
    & Pick<UpdateAddressMutationPayload, 'clientMutationId'>
    & { address?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'id'>
    )> }
  )> }
);

export type GetBankInformationProfileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBankInformationProfileQuery = (
  { __typename?: 'Query' }
  & { bankInformation?: Maybe<(
    { __typename?: 'BankInformation' }
    & BankInformationProfileFragment
  )> }
);

export type BankInformationProfileFragment = (
  { __typename?: 'BankInformation' }
  & Pick<BankInformation, 'id' | 'createdAt' | 'updatedAt' | 'iban' | 'bic' | 'fullName' | 'name'>
);

export type UpdateBankInformationMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateBankInformationInput;
}>;


export type UpdateBankInformationMutation = (
  { __typename?: 'Mutation' }
  & { updateBankInformation?: Maybe<(
    { __typename?: 'UpdateBankInformationMutationPayload' }
    & Pick<UpdateBankInformationMutationPayload, 'clientMutationId'>
    & { bankInformation?: Maybe<(
      { __typename?: 'BankInformation' }
      & Pick<BankInformation, 'id'>
    )> }
  )> }
);

export type GetAccountProfileQueryVariables = Exact<{
  id: Scalars['ID'];
  includeLegacyShippingAddress?: Maybe<Scalars['Boolean']>;
}>;


export type GetAccountProfileQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & AccountProfileFragment
  )> }
);

export type AccountProfileFragment = (
  { __typename?: 'Account' }
  & Pick<Account, 'id' | 'createdAt' | 'updatedAt' | 'firstName' | 'lastName' | 'civility' | 'birthDate' | 'corporateForm' | 'phone' | 'companyName' | 'email' | 'siret' | 'tvaNumber' | 'isProfessional'>
  & { bankInformation?: Maybe<(
    { __typename?: 'BankInformation' }
    & BankInformationProfileFragment
  )>, identityDocuments?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>>, ribDocuments?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>>, shippingAddress?: Maybe<(
    { __typename?: 'Address' }
    & Pick<Address, 'id' | 'addressLine1' | 'addressLine2' | 'addressLine3' | 'city' | 'companyName' | 'country' | 'email' | 'firstName' | 'lastName' | 'phone1' | 'phone2' | 'zip'>
  )>, accountable: { __typename: 'Buyer' } | { __typename: 'Expert' } | (
    { __typename: 'Vendor' }
    & Pick<Vendor, 'id' | 'stripeConnectAccountId' | 'shippingOptions'>
    & VendorPickupHoursFragment
    & VendorDefaultAddressesFragment
  ) | { __typename: 'Writer' } }
);

export type UpdateAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateAccountInput;
}>;


export type UpdateAccountMutation = (
  { __typename?: 'Mutation' }
  & { customUpdateAccount?: Maybe<(
    { __typename?: 'CustomUpdateAccountMutationPayload' }
    & Pick<CustomUpdateAccountMutationPayload, 'clientMutationId'>
    & { account?: Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id'>
    )> }
  )> }
);

export type VendorPickupHoursFragment = (
  { __typename?: 'Vendor' }
  & { pickupHours: Array<(
    { __typename?: 'Day' }
    & Pick<Day, 'day'>
    & { timeRanges: Array<(
      { __typename?: 'TimeRange' }
      & Pick<TimeRange, 'startTime' | 'endTime'>
    )> }
  )> }
);

export type UpdateVendorPickupHoursMutationVariables = Exact<{
  pickupHours: Array<DayInput>;
  activatePickup?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateVendorPickupHoursMutation = (
  { __typename?: 'Mutation' }
  & { updateVendorPickupHours?: Maybe<(
    { __typename?: 'UpdateVendorPickupHoursMutationPayload' }
    & { vendorPickupTimeRanges?: Maybe<Array<(
      { __typename?: 'TimeRange' }
      & Pick<TimeRange, 'day' | 'startTime' | 'endTime'>
    )>>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type UploadIdentityDocumentInAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  files?: Maybe<Array<UploadFileInput>>;
}>;


export type UploadIdentityDocumentInAccountMutation = (
  { __typename?: 'Mutation' }
  & { customUpdateAccount?: Maybe<(
    { __typename?: 'CustomUpdateAccountMutationPayload' }
    & Pick<CustomUpdateAccountMutationPayload, 'clientMutationId'>
    & { account?: Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id'>
      & { identityDocuments?: Maybe<Array<(
        { __typename?: 'CustomFile' }
        & Pick<CustomFile, 'imageUrl'>
      )>> }
    )> }
  )> }
);

export type UploadRibDocumentInAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  files?: Maybe<Array<UploadFileInput>>;
}>;


export type UploadRibDocumentInAccountMutation = (
  { __typename?: 'Mutation' }
  & { customUpdateAccount?: Maybe<(
    { __typename?: 'CustomUpdateAccountMutationPayload' }
    & Pick<CustomUpdateAccountMutationPayload, 'clientMutationId'>
    & { account?: Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id'>
      & { identityDocuments?: Maybe<Array<(
        { __typename?: 'CustomFile' }
        & Pick<CustomFile, 'imageUrl'>
      )>> }
    )> }
  )> }
);

export type UpdateVendorShippingMethodsMutationVariables = Exact<{
  shippingOptions: Array<ShippingOptionEnum>;
}>;


export type UpdateVendorShippingMethodsMutation = (
  { __typename?: 'Mutation' }
  & { updateVendorShippingMethods?: Maybe<(
    { __typename?: 'UpdateVendorShippingMethodsMutationPayload' }
    & { shippingMethods: Array<(
      { __typename?: 'VendorShippingMethod' }
      & Pick<VendorShippingMethod, 'shippingOption'>
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type CreateProjectFeeMutationVariables = Exact<{
  input: CreateProjectFeeMutationInput;
}>;


export type CreateProjectFeeMutation = (
  { __typename?: 'Mutation' }
  & { createProjectFee?: Maybe<(
    { __typename?: 'CreateProjectFeeMutationPayload' }
    & { projectFee?: Maybe<(
      { __typename?: 'ProjectFee' }
      & Pick<ProjectFee, 'id'>
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'details'>
    )> }
  )> }
);

export type UpdateProjectFeeMutationVariables = Exact<{
  input: UpdateProjectFeeMutationInput;
}>;


export type UpdateProjectFeeMutation = (
  { __typename?: 'Mutation' }
  & { updateProjectFee?: Maybe<(
    { __typename?: 'UpdateProjectFeeMutationPayload' }
    & { projectFee?: Maybe<(
      { __typename?: 'ProjectFee' }
      & Pick<ProjectFee, 'id'>
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'details'>
    )> }
  )> }
);

export type DestroyProjectFeeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyProjectFeeMutation = (
  { __typename?: 'Mutation' }
  & { destroyProjectFee?: Maybe<(
    { __typename?: 'DestroyProjectFeeMutationPayload' }
    & { projectFee?: Maybe<(
      { __typename?: 'ProjectFee' }
      & Pick<ProjectFee, 'id'>
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'details'>
    )> }
  )> }
);

export type ProjectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectQuery = (
  { __typename?: 'Query' }
  & { project?: Maybe<(
    { __typename?: 'Project' }
    & { vendor?: Maybe<(
      { __typename?: 'Vendor' }
      & { account: (
        { __typename?: 'Account' }
        & { bankInformation?: Maybe<(
          { __typename?: 'BankInformation' }
          & Pick<BankInformation, 'iban' | 'bic'>
        )> }
        & VendorAccountFragment
      ) }
      & VendorFragment
    )> }
    & ProjectFragment
  )> }
);

export type ProjectsQueryVariables = Exact<{
  where?: Maybe<ProjectFilter>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type ProjectsQuery = (
  { __typename?: 'Query' }
  & { projects: (
    { __typename?: 'ProjectConnection' }
    & Pick<ProjectConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ProjectEdge' }
      & { node?: Maybe<(
        { __typename?: 'Project' }
        & ProjectRowFragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type ProjectRowFragment = (
  { __typename?: 'Project' }
  & Pick<Project, 'id' | 'title' | 'number' | 'state' | 'nbItems' | 'nbItemsToExpertise' | 'nbItemsToModify'>
  & { vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName'>
    ) }
  )>, writers?: Maybe<(
    { __typename?: 'WriterConnection' }
    & WriterEdgesFragment
  )> }
);

export type ProjectEdgesFragment = (
  { __typename?: 'ProjectConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'ProjectEdge' }
    & ProjectNodeFragment
  )>>> }
);

export type ProjectNodeFragment = (
  { __typename?: 'ProjectEdge' }
  & { node?: Maybe<(
    { __typename?: 'Project' }
    & ProjectFragment
  )> }
);

export type ProjectFragment = (
  { __typename?: 'Project' }
  & Pick<Project, 'id' | 'state' | 'nbItems' | 'nbItemsToExpertise' | 'nbItemsToModify' | 'createdAt' | 'title' | 'number' | 'itemNumberStart' | 'exclusif' | 'isClassicSale' | 'sharingProfit' | 'dodecadeSharePercentage' | 'expertiseFirmSharePercentage' | 'businessIntroducerSharePercentage' | 'thirdPartyIntroducerSharePercentage' | 'buyerFeePercentage' | 'comment' | 'auctioneerNumber' | 'totalItemsSoldAmount' | 'totalProjectFeesAmount' | 'totalFeesByActor' | 'vendorFeePercentage' | 'writerFeePercentage' | 'writerFixFees' | 'expertiseFeePercentage'>
  & { vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id'>
    & VendorFragment
  )>, owner?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id'>
    & VendorFragment
  )>, writers?: Maybe<(
    { __typename?: 'WriterConnection' }
    & WriterEdgesFragment
  )>, businessIntroducer?: Maybe<(
    { __typename?: 'BusinessIntroducer' }
    & Pick<BusinessIntroducer, 'id'>
    & MinimizeBusinessIntroducerFragment
  )>, thirdPartyIntroducer?: Maybe<(
    { __typename?: 'ThirdPartyIntroducer' }
    & Pick<ThirdPartyIntroducer, 'id'>
    & MinimizeThirdPartyIntroducerFragment
  )>, projectFees?: Maybe<(
    { __typename?: 'ProjectFeeConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ProjectFeeEdge' }
      & { node?: Maybe<(
        { __typename?: 'ProjectFee' }
        & Pick<ProjectFee, 'id' | 'name' | 'value'>
      )> }
    )>>> }
  )>, manualDepositSlip?: Maybe<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>, documentsByActor: (
    { __typename?: 'DocumentsByActor' }
    & { vendor?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & FileFragment
    )>>, businessIntroducer?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & FileFragment
    )>>, thirdPartyIntroducer?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & FileFragment
    )>> }
  ) }
);

export type MinimizeThirdPartyIntroducerFragment = (
  { __typename?: 'ThirdPartyIntroducer' }
  & Pick<ThirdPartyIntroducer, 'firstName' | 'lastName'>
);

export type MinimizeBusinessIntroducerFragment = (
  { __typename?: 'BusinessIntroducer' }
  & Pick<BusinessIntroducer, 'firstName' | 'lastName'>
);

export type WriterEdgesFragment = (
  { __typename?: 'WriterConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'WriterEdge' }
    & WriterNodeFragment
  )>>> }
);

export type WriterNodeFragment = (
  { __typename?: 'WriterEdge' }
  & { node?: Maybe<(
    { __typename?: 'Writer' }
    & MinimizeWriterFragment
  )> }
);

export type MinimizeWriterFragment = (
  { __typename?: 'Writer' }
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'firstName' | 'lastName'>
  ) }
);

export type VendorPaymentLineEdgesFragment = (
  { __typename?: 'VendorPaymentLineConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'VendorPaymentLineEdge' }
    & VendorPaymentLineNodeFragment
  )>>> }
);

export type VendorPaymentLineNodeFragment = (
  { __typename?: 'VendorPaymentLineEdge' }
  & { node?: Maybe<(
    { __typename?: 'VendorPaymentLine' }
    & VendorPaymentLineFragment
  )> }
);

export type VendorPaymentLineFragment = (
  { __typename?: 'VendorPaymentLine' }
  & Pick<VendorPaymentLine, 'amount' | 'feePercentage' | 'feeAmount'>
);

export type OrderItemEdgesFragment = (
  { __typename?: 'OrderItemConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'OrderItemEdge' }
    & OrderItemNodeFragment
  )>>> }
);

export type OrderItemNodeFragment = (
  { __typename?: 'OrderItemEdge' }
  & { node?: Maybe<(
    { __typename?: 'OrderItem' }
    & OrderItemFragment
  )> }
);

export type OrderItemFragment = (
  { __typename?: 'OrderItem' }
  & Pick<OrderItem, 'id' | 'totalPrice' | 'undeplusRef'>
  & { item: (
    { __typename?: 'Item' }
    & Pick<Item, 'id'>
  ) }
);

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectMutationInput;
}>;


export type UpdateProjectMutation = (
  { __typename?: 'Mutation' }
  & { updateProject?: Maybe<(
    { __typename?: 'UpdateProjectMutationPayload' }
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'id'>
    )> }
  )> }
);

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectMutationInput;
}>;


export type CreateProjectMutation = (
  { __typename?: 'Mutation' }
  & { createProject?: Maybe<(
    { __typename?: 'CreateProjectMutationPayload' }
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'id'>
    )> }
  )> }
);

export type VendorsQueryVariables = Exact<{
  where?: Maybe<VendorFilter>;
  first?: Maybe<Scalars['Int']>;
}>;


export type VendorsQuery = (
  { __typename?: 'Query' }
  & { vendors: (
    { __typename?: 'VendorConnection' }
    & VendorEdgesFragment
  ) }
);

export type VendorEdgesFragment = (
  { __typename?: 'VendorConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'VendorEdge' }
    & VendorNodeFragment
  )>>> }
);

export type VendorNodeFragment = (
  { __typename?: 'VendorEdge' }
  & { node?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id'>
    & VendorFragment
  )> }
);

export type PurchaseSlipsQueryVariables = Exact<{
  where?: Maybe<PurchaseSlipFilter>;
}>;


export type PurchaseSlipsQuery = (
  { __typename?: 'Query' }
  & { purchaseSlips: (
    { __typename?: 'PurchaseSlipConnection' }
    & PurchaseSlipEdgesFragment
  ) }
);

export type PurchaseSlipEdgesFragment = (
  { __typename?: 'PurchaseSlipConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'PurchaseSlipEdge' }
    & PurchaseSlipNodeFragment
  )>>> }
);

export type PurchaseSlipNodeFragment = (
  { __typename?: 'PurchaseSlipEdge' }
  & { node?: Maybe<(
    { __typename?: 'PurchaseSlip' }
    & PurchaseSlipFragment
  )> }
);

export type PurchaseSlipFragment = (
  { __typename?: 'PurchaseSlip' }
  & Pick<PurchaseSlip, 'id' | 'createdAt' | 'nbItems' | 'number'>
  & { document?: Maybe<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>, buyer?: Maybe<(
    { __typename?: 'Buyer' }
    & Pick<Buyer, 'id'>
  )>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id'>
  )> }
);

export type QuickTextQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QuickTextQuery = (
  { __typename?: 'Query' }
  & { quickText?: Maybe<(
    { __typename?: 'QuickText' }
    & QuickTextFragment
  )> }
);

export type QuickTextsQueryVariables = Exact<{
  where?: Maybe<QuickTextFilter>;
  first?: Maybe<Scalars['Int']>;
}>;


export type QuickTextsQuery = (
  { __typename?: 'Query' }
  & { quickTexts: (
    { __typename?: 'QuickTextConnection' }
    & QuickTextEdgesFragment
  ) }
);

export type QuickTextEdgesFragment = (
  { __typename?: 'QuickTextConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'QuickTextEdge' }
    & QuickTextNodeFragment
  )>>> }
);

export type QuickTextNodeFragment = (
  { __typename?: 'QuickTextEdge' }
  & { node?: Maybe<(
    { __typename?: 'QuickText' }
    & QuickTextFragment
  )> }
);

export type QuickTextFragment = (
  { __typename?: 'QuickText' }
  & Pick<QuickText, 'id' | 'title' | 'text' | 'number' | 'createdAt'>
);

export type CreateQuickTextMutationVariables = Exact<{
  input: CreateQuickTextMutationInput;
}>;


export type CreateQuickTextMutation = (
  { __typename?: 'Mutation' }
  & { createQuickText?: Maybe<(
    { __typename?: 'CreateQuickTextMutationPayload' }
    & { quickText?: Maybe<(
      { __typename?: 'QuickText' }
      & Pick<QuickText, 'id'>
    )> }
  )> }
);

export type UpdateQuickTextMutationVariables = Exact<{
  input: UpdateQuickTextMutationInput;
}>;


export type UpdateQuickTextMutation = (
  { __typename?: 'Mutation' }
  & { updateQuickText?: Maybe<(
    { __typename?: 'UpdateQuickTextMutationPayload' }
    & { quickText?: Maybe<(
      { __typename?: 'QuickText' }
      & Pick<QuickText, 'id'>
    )> }
  )> }
);

export type DestroyQuickTextMutationVariables = Exact<{
  input: DestroyQuickTextMutationInput;
}>;


export type DestroyQuickTextMutation = (
  { __typename?: 'Mutation' }
  & { destroyQuickText?: Maybe<(
    { __typename?: 'DestroyQuickTextMutationPayload' }
    & { quickText?: Maybe<(
      { __typename?: 'QuickText' }
      & Pick<QuickText, 'id'>
    )> }
  )> }
);

export type CreateLotUrlsRainworxImportMutationVariables = Exact<{
  attributes: CreateLotUrlRainworxImportInput;
}>;


export type CreateLotUrlsRainworxImportMutation = (
  { __typename?: 'Mutation' }
  & { createLotUrlsRainworxImport?: Maybe<(
    { __typename?: 'CreateLotUrlsRainworxImportMutationPayload' }
    & Pick<CreateLotUrlsRainworxImportMutationPayload, 'clientMutationId'>
    & { import?: Maybe<(
      { __typename?: 'Import' }
      & Pick<Import, 'id'>
    )> }
  )> }
);

export type CreateUnsoldItemsRainworxImportMutationVariables = Exact<{
  attributes: CreateUnsoldItemsRainworxImportInput;
}>;


export type CreateUnsoldItemsRainworxImportMutation = (
  { __typename?: 'Mutation' }
  & { createUnsoldItemsRainworxImport?: Maybe<(
    { __typename?: 'CreateUnsoldItemsRainworxImportMutationPayload' }
    & Pick<CreateUnsoldItemsRainworxImportMutationPayload, 'clientMutationId'>
    & { import?: Maybe<(
      { __typename?: 'Import' }
      & Pick<Import, 'id'>
    )> }
  )> }
);

export type TriggerSalePaymentMutationVariables = Exact<{
  saleId: Scalars['ID'];
  force?: Maybe<Scalars['Boolean']>;
}>;


export type TriggerSalePaymentMutation = (
  { __typename?: 'Mutation' }
  & { triggerSalePayment?: Maybe<(
    { __typename?: 'TriggerSalePaymentPayload' }
    & Pick<TriggerSalePaymentPayload, 'success' | 'message' | 'jobId' | 'errors'>
  )> }
);

export type GetSaleStatsAndPaymentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSaleStatsAndPaymentsQuery = (
  { __typename?: 'Query' }
  & { sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name' | 'startAt' | 'endAt' | 'createdAt'>
    & { stats?: Maybe<(
      { __typename?: 'SaleStats' }
      & Pick<SaleStats, 'totalOrders' | 'totalAmountHt' | 'totalAmountTtc' | 'totalSoldAmountHt' | 'paidSoldCount' | 'paidSoldAmountHt' | 'unpaidSoldCount' | 'unpaidSoldAmountHt' | 'unpaidSoldOrdersCount' | 'unsoldCount' | 'unsoldAmountHt' | 'unpaidByBuyerCount' | 'unpaidByBuyerAmountHt' | 'returnedCount' | 'returnedAmountHt'>
    )>, payments?: Maybe<(
      { __typename?: 'SalePayments' }
      & { vendorPayments: (
        { __typename?: 'MonthlyVendorPaymentConnection' }
        & { edges?: Maybe<Array<Maybe<(
          { __typename?: 'MonthlyVendorPaymentEdge' }
          & { node?: Maybe<(
            { __typename?: 'MonthlyVendorPayment' }
            & Pick<MonthlyVendorPayment, 'id' | 'totalSales' | 'totalFees' | 'netAmount' | 'paid' | 'startAt' | 'endAt' | 'createdAt' | 'lockedAt' | 'stripeTransferId' | 'stripeTransferStatus' | 'stripeTransferError' | 'stripeTransferredAt' | 'disputed' | 'disputeAmount'>
            & { vendorStatementPayment?: Maybe<(
              { __typename?: 'VendorStatementPayment' }
              & Pick<VendorStatementPayment, 'id'>
            )>, vendor?: Maybe<(
              { __typename?: 'Vendor' }
              & Pick<Vendor, 'id' | 'stripeConnectAccountId'>
              & { account: (
                { __typename?: 'Account' }
                & Pick<Account, 'firstName' | 'lastName' | 'email'>
              ) }
            )>, vendorPaymentFees?: Maybe<(
              { __typename?: 'VendorPaymentFeeConnection' }
              & { edges?: Maybe<Array<Maybe<(
                { __typename?: 'VendorPaymentFeeEdge' }
                & { node?: Maybe<(
                  { __typename?: 'VendorPaymentFee' }
                  & Pick<VendorPaymentFee, 'id' | 'feeType' | 'feePercentageHt' | 'feePercentageTtc' | 'feeAmountHt' | 'feeTva' | 'feeTvaRate' | 'feeAmountTtc' | 'itemsCount'>
                )> }
              )>>> }
            )> }
          )> }
        )>>> }
      ), writerPayments: (
        { __typename?: 'WriterPaymentConnection' }
        & { edges?: Maybe<Array<Maybe<(
          { __typename?: 'WriterPaymentEdge' }
          & { node?: Maybe<(
            { __typename?: 'WriterPayment' }
            & Pick<WriterPayment, 'id' | 'paid'>
            & { writer?: Maybe<(
              { __typename?: 'Writer' }
              & Pick<Writer, 'id'>
              & { account: (
                { __typename?: 'Account' }
                & Pick<Account, 'firstName' | 'lastName'>
              ) }
            )>, writerPaymentLines?: Maybe<(
              { __typename?: 'WriterPaymentLineConnection' }
              & { edges?: Maybe<Array<Maybe<(
                { __typename?: 'WriterPaymentLineEdge' }
                & { node?: Maybe<(
                  { __typename?: 'WriterPaymentLine' }
                  & Pick<WriterPaymentLine, 'id' | 'amount'>
                )> }
              )>>> }
            )> }
          )> }
        )>>> }
      ), expertPayments: (
        { __typename?: 'ExpertPaymentConnection' }
        & { edges?: Maybe<Array<Maybe<(
          { __typename?: 'ExpertPaymentEdge' }
          & { node?: Maybe<(
            { __typename?: 'ExpertPayment' }
            & Pick<ExpertPayment, 'id' | 'paid'>
            & { expert?: Maybe<(
              { __typename?: 'Expert' }
              & Pick<Expert, 'id'>
              & { account: (
                { __typename?: 'Account' }
                & Pick<Account, 'firstName' | 'lastName'>
              ) }
            )> }
          )> }
        )>>> }
      ), introducerPayments: (
        { __typename?: 'ProjectIntroducerPaymentConnection' }
        & { edges?: Maybe<Array<Maybe<(
          { __typename?: 'ProjectIntroducerPaymentEdge' }
          & { node?: Maybe<(
            { __typename?: 'ProjectIntroducerPayment' }
            & Pick<ProjectIntroducerPayment, 'id' | 'paid' | 'payableType'>
          )> }
        )>>> }
      ) }
    )> }
  )> }
);

export type SaleMandatsQueryVariables = Exact<{
  where?: Maybe<SaleMandatFilter>;
}>;


export type SaleMandatsQuery = (
  { __typename?: 'Query' }
  & { saleMandats: (
    { __typename?: 'SaleMandatConnection' }
    & SaleMandatEdgesFragment
  ) }
);

export type SaleMandatEdgesFragment = (
  { __typename?: 'SaleMandatConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'SaleMandatEdge' }
    & SaleMandatNodeFragment
  )>>> }
);

export type SaleMandatNodeFragment = (
  { __typename?: 'SaleMandatEdge' }
  & { node?: Maybe<(
    { __typename?: 'SaleMandat' }
    & SaleMandatFragment
  )> }
);

export type SaleMandatFragment = (
  { __typename?: 'SaleMandat' }
  & Pick<SaleMandat, 'id' | 'createdAt' | 'nbItems' | 'number'>
  & { document?: Maybe<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>, vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id'>
  )>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id'>
  )> }
);

export type CreateSaleMandatsMutationVariables = Exact<{
  saleId: Scalars['ID'];
}>;


export type CreateSaleMandatsMutation = (
  { __typename?: 'Mutation' }
  & { createSaleMandats?: Maybe<(
    { __typename?: 'CreateSaleMandatMutationPayload' }
    & Pick<CreateSaleMandatMutationPayload, 'clientMutationId'>
    & { sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id'>
    )> }
  )> }
);

export type TriggerMonthlyVendorPaymentTransferMutationVariables = Exact<{
  input: TriggerMonthlyVendorPaymentTransferMutationInput;
}>;


export type TriggerMonthlyVendorPaymentTransferMutation = (
  { __typename?: 'Mutation' }
  & { triggerMonthlyVendorPaymentTransfer?: Maybe<(
    { __typename?: 'TriggerMonthlyVendorPaymentTransferMutationPayload' }
    & Pick<TriggerMonthlyVendorPaymentTransferMutationPayload, 'errors'>
    & { monthlyVendorPayment?: Maybe<(
      { __typename?: 'MonthlyVendorPayment' }
      & Pick<MonthlyVendorPayment, 'id' | 'stripeTransferId' | 'stripeTransferStatus' | 'stripeTransferError' | 'stripeTransferredAt'>
    )> }
  )> }
);

export type SaleProjectChipsQueryVariables = Exact<{
  where?: Maybe<ItemFilter>;
}>;


export type SaleProjectChipsQuery = (
  { __typename?: 'Query' }
  & { items: (
    { __typename?: 'ItemConnection' }
    & Pick<ItemConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemEdge' }
      & { node?: Maybe<(
        { __typename?: 'Item' }
        & Pick<Item, 'id'>
        & { project?: Maybe<(
          { __typename?: 'Project' }
          & Pick<Project, 'id' | 'title' | 'number'>
        )> }
      )> }
    )>>> }
  ) }
);

export type SaleRateChartCardFragment = (
  { __typename?: 'TimeSeriesPoint' }
  & Pick<TimeSeriesPoint, 'period' | 'value'>
);

export type SalePaymentStatsQueryVariables = Exact<{
  saleId: Scalars['ID'];
}>;


export type SalePaymentStatsQuery = (
  { __typename?: 'Query' }
  & { salePaymentStats?: Maybe<(
    { __typename?: 'SalePaymentStats' }
    & { unpaidOrders: (
      { __typename?: 'UnpaidOrdersStats' }
      & Pick<UnpaidOrdersStats, 'count' | 'totalAmount'>
      & { orders: Array<(
        { __typename?: 'UnpaidOrderInfo' }
        & Pick<UnpaidOrderInfo, 'id' | 'orderNumber' | 'buyerEmail' | 'buyerPhone' | 'buyerName' | 'totalAmount' | 'createdAt' | 'daysSinceCreation'>
      )> }
    ), paidWithinDelay: (
      { __typename?: 'PaidWithinDelayStats' }
      & Pick<PaidWithinDelayStats, 'count' | 'totalAmount' | 'remainingDays'>
    ), paidPendingPayment: (
      { __typename?: 'PaidPendingPaymentStats' }
      & Pick<PaidPendingPaymentStats, 'count' | 'totalAmount'>
      & { orders: Array<(
        { __typename?: 'PendingPaymentOrderInfo' }
        & Pick<PendingPaymentOrderInfo, 'id' | 'orderNumber' | 'totalAmount' | 'paidAt' | 'daysSincePaid' | 'vendorPaymentStatus' | 'pendingItemsCount' | 'paidItemsCount'>
      )> }
    ), readyToPay: (
      { __typename?: 'ReadyToPayStats' }
      & Pick<ReadyToPayStats, 'count' | 'totalAmount'>
    ), alreadyPaid: (
      { __typename?: 'AlreadyPaidStats' }
      & Pick<AlreadyPaidStats, 'count' | 'totalAmount'>
    ), excludedOrders: (
      { __typename?: 'ExcludedOrdersStats' }
      & Pick<ExcludedOrdersStats, 'count' | 'totalAmount'>
      & { orders: Array<(
        { __typename?: 'ExcludedOrderInfo' }
        & Pick<ExcludedOrderInfo, 'id' | 'orderNumber' | 'totalAmount' | 'removedItemsCount' | 'returnedItemsCount' | 'state'>
      )> }
    ) }
  )> }
);

export type SaleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SaleQuery = (
  { __typename?: 'Query' }
  & { sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'pendingPlannedItemsCount' | 'readyForExport'>
    & SaleFragment
  )> }
);

export type SalesQueryVariables = Exact<{
  where?: Maybe<SaleFilter>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type SalesQuery = (
  { __typename?: 'Query' }
  & { sales: (
    { __typename?: 'SaleConnection' }
    & Pick<SaleConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
    & SaleEdgesFragment
  ) }
);

export type SaleEdgesFragment = (
  { __typename?: 'SaleConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'SaleEdge' }
    & SaleNodeFragment
  )>>> }
);

export type SaleNodeFragment = (
  { __typename?: 'SaleEdge' }
  & { node?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'nbItems'>
    & SaleTableFragment
  )> }
);

export type SaleTableFragment = (
  { __typename?: 'Sale' }
  & Pick<Sale, 'id' | 'name' | 'description' | 'state' | 'startAt' | 'endAt' | 'typeOfSale' | 'externalEventRainworxId'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'imageUrl'>
  )> }
);

export type SaleFragment = (
  { __typename?: 'Sale' }
  & Pick<Sale, 'id' | 'name' | 'description' | 'state' | 'startAt' | 'endAt' | 'typeOfSale' | 'estimatedPriceEnabled' | 'externalEventRainworxId' | 'nbTemporaryFileToGenerate' | 'nbItems' | 'newsletterHeaderHtml' | 'subject' | 'subjectEndingSoon' | 'projectIds'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'imageUrl'>
  )>, expert?: Maybe<(
    { __typename?: 'Expert' }
    & Pick<Expert, 'id'>
  )>, writers?: Maybe<Array<(
    { __typename?: 'Writer' }
    & WriterSelectFieldFragment
  )>>, saleMandats?: Maybe<(
    { __typename?: 'SaleMandatConnection' }
    & SaleMandatEdgesFragment
  )>, drouotCsv?: Maybe<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>, imagesZip?: Maybe<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>, temporaryDrouotCsvs?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>>, temporaryImagesZips?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>>, projects?: Maybe<(
    { __typename?: 'ProjectConnection' }
    & ProjectEdgesFragment
  )> }
);

export type CreateSaleMutationVariables = Exact<{
  input: CreateSaleMutationInput;
}>;


export type CreateSaleMutation = (
  { __typename?: 'Mutation' }
  & { createSale?: Maybe<(
    { __typename?: 'CreateSaleMutationPayload' }
    & { sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id' | 'name'>
    )> }
  )> }
);

export type UpdateSaleMutationVariables = Exact<{
  input: UpdateSaleMutationInput;
}>;


export type UpdateSaleMutation = (
  { __typename?: 'Mutation' }
  & { updateSale?: Maybe<(
    { __typename?: 'UpdateSaleMutationPayload' }
    & { sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id' | 'name'>
    )> }
  )> }
);

export type DestroySaleMutationVariables = Exact<{
  input: DestroySaleMutationInput;
}>;


export type DestroySaleMutation = (
  { __typename?: 'Mutation' }
  & { destroySale?: Maybe<(
    { __typename?: 'DestroySaleMutationPayload' }
    & { sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id' | 'name'>
    )> }
  )> }
);

export type ItemsCountByStateQueryVariables = Exact<{
  vendorId?: Maybe<Scalars['ID']>;
}>;


export type ItemsCountByStateQuery = (
  { __typename?: 'Query' }
  & { itemsStats: (
    { __typename?: 'ItemsStats' }
    & Pick<ItemsStats, 'total' | 'inProcessing' | 'requiringVendorAction' | 'unsold' | 'onVacation' | 'unpaid' | 'returned' | 'removed' | 'refused' | 'onSale' | 'sold' | 'adminLibraryFundEligible' | 'adminDiscountedEligible' | 'adminUnpaidEligible' | 'adminNotEligible'>
  ) }
);

export type TagsQueryVariables = Exact<{
  where?: Maybe<TagFilter>;
  direction?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type TagsQuery = (
  { __typename?: 'Query' }
  & { tags: (
    { __typename?: 'TagConnection' }
    & Pick<TagConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'TagEdge' }
      & Pick<TagEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Tag' }
        & TagTableFragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  ) }
);

export type TagQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TagQuery = (
  { __typename?: 'Query' }
  & { tag?: Maybe<(
    { __typename?: 'Tag' }
    & TagTableFragment
  )> }
);

export type TagTableFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'createdAt' | 'auto'>
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'lastName' | 'firstName'>
  )> }
);

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateTagInput;
}>;


export type UpdateTagMutation = (
  { __typename?: 'Mutation' }
  & { updateTag?: Maybe<(
    { __typename?: 'UpdateTagMutationPayload' }
    & Pick<UpdateTagMutationPayload, 'clientMutationId'>
    & { tag?: Maybe<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id'>
    )> }
  )> }
);

export type MergeTagMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: MergeTagInput;
}>;


export type MergeTagMutation = (
  { __typename?: 'Mutation' }
  & { mergeTag?: Maybe<(
    { __typename?: 'MergeTagMutationPayload' }
    & Pick<MergeTagMutationPayload, 'clientMutationId'>
    & { tag?: Maybe<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id'>
    )> }
  )> }
);

export type DestroyTagMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyTagMutation = (
  { __typename?: 'Mutation' }
  & { destroyTag?: Maybe<(
    { __typename?: 'DestroyTagMutationPayload' }
    & { tag?: Maybe<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id'>
    )> }
  )> }
);

export type CreateThirdPartyIntroducerMutationVariables = Exact<{
  input: CreateThirdPartyIntroducerMutationInput;
}>;


export type CreateThirdPartyIntroducerMutation = (
  { __typename?: 'Mutation' }
  & { createThirdPartyIntroducer?: Maybe<(
    { __typename?: 'CreateThirdPartyIntroducerMutationPayload' }
    & { thirdPartyIntroducer?: Maybe<(
      { __typename?: 'ThirdPartyIntroducer' }
      & Pick<ThirdPartyIntroducer, 'id'>
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'details'>
    )> }
  )> }
);

export type UpdateThirdPartyIntroducerMutationVariables = Exact<{
  input: UpdateThirdPartyIntroducerMutationInput;
}>;


export type UpdateThirdPartyIntroducerMutation = (
  { __typename?: 'Mutation' }
  & { updateThirdPartyIntroducer?: Maybe<(
    { __typename?: 'UpdateThirdPartyIntroducerMutationPayload' }
    & { thirdPartyIntroducer?: Maybe<(
      { __typename?: 'ThirdPartyIntroducer' }
      & Pick<ThirdPartyIntroducer, 'id'>
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'details'>
    )> }
  )> }
);

export type VacationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VacationQuery = (
  { __typename?: 'Query' }
  & { vacation?: Maybe<(
    { __typename?: 'Vacation' }
    & VacationFragment
  )> }
);

export type VacationsQueryVariables = Exact<{
  where?: Maybe<VacationFilter>;
  orderByAttribute?: Maybe<Array<ItemOrderType>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type VacationsQuery = (
  { __typename?: 'Query' }
  & { vacations: (
    { __typename?: 'VacationConnection' }
    & VacationEdgesFragment
  ) }
);

export type VacationEdgesFragment = (
  { __typename?: 'VacationConnection' }
  & Pick<VacationConnection, 'totalCount'>
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'VacationEdge' }
    & Pick<VacationEdge, 'cursor'>
    & VacationNodeFragment
  )>>>, pageInfo: (
    { __typename?: 'PageInfo' }
    & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
  ) }
);

export type VacationNodeFragment = (
  { __typename?: 'VacationEdge' }
  & { node?: Maybe<(
    { __typename?: 'Vacation' }
    & Pick<Vacation, 'nbItems' | 'nbUnsoldEligible' | 'nbUnpaidEligible'>
    & VacationFragment
  )> }
);

export type CreateVacationMutationVariables = Exact<{
  input: CreateVacationMutationInput;
}>;


export type CreateVacationMutation = (
  { __typename?: 'Mutation' }
  & { createVacation?: Maybe<(
    { __typename?: 'CreateVacationMutationPayload' }
    & { vacation?: Maybe<(
      { __typename?: 'Vacation' }
      & Pick<Vacation, 'id' | 'name'>
    )> }
  )> }
);

export type UpdateVacationMutationVariables = Exact<{
  input: UpdateVacationMutationInput;
}>;


export type UpdateVacationMutation = (
  { __typename?: 'Mutation' }
  & { updateVacation?: Maybe<(
    { __typename?: 'UpdateVacationMutationPayload' }
    & { vacation?: Maybe<(
      { __typename?: 'Vacation' }
      & Pick<Vacation, 'id' | 'name'>
    )> }
  )> }
);

export type DestroyVacationMutationVariables = Exact<{
  input: DestroyVacationMutationInput;
}>;


export type DestroyVacationMutation = (
  { __typename?: 'Mutation' }
  & { destroyVacation?: Maybe<(
    { __typename?: 'DestroyVacationMutationPayload' }
    & { vacation?: Maybe<(
      { __typename?: 'Vacation' }
      & Pick<Vacation, 'id' | 'name'>
    )> }
  )> }
);

export type VendorAddressFragment = (
  { __typename?: 'Address' }
  & Pick<Address, 'id' | 'name' | 'firstName' | 'lastName' | 'companyName' | 'addressLine1' | 'addressLine2' | 'addressLine3' | 'city' | 'state' | 'zip' | 'country' | 'phone1' | 'phone2' | 'email'>
);

export type VendorDefaultAddressesFragment = (
  { __typename?: 'Vendor' }
  & { defaultProfileAddress?: Maybe<(
    { __typename?: 'Address' }
    & VendorAddressFragment
  )>, defaultBillingAddress?: Maybe<(
    { __typename?: 'Address' }
    & VendorAddressFragment
  )>, defaultPickupAddress?: Maybe<(
    { __typename?: 'Address' }
    & VendorAddressFragment
  )>, defaultShippingAddress?: Maybe<(
    { __typename?: 'Address' }
    & VendorAddressFragment
  )> }
);

export type CreateVendorAddressMutationVariables = Exact<{
  attributes: VendorAddressInput;
}>;


export type CreateVendorAddressMutation = (
  { __typename?: 'Mutation' }
  & { createVendorAddress?: Maybe<(
    { __typename?: 'CreateVendorAddressMutationPayload' }
    & { address?: Maybe<(
      { __typename?: 'Address' }
      & VendorAddressFragment
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type UpdateVendorAddressMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: VendorAddressInput;
}>;


export type UpdateVendorAddressMutation = (
  { __typename?: 'Mutation' }
  & { updateVendorAddress?: Maybe<(
    { __typename?: 'UpdateVendorAddressMutationPayload' }
    & { address?: Maybe<(
      { __typename?: 'Address' }
      & VendorAddressFragment
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type DestroyVendorAddressMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyVendorAddressMutation = (
  { __typename?: 'Mutation' }
  & { destroyVendorAddress?: Maybe<(
    { __typename?: 'DestroyVendorAddressMutationPayload' }
    & Pick<DestroyVendorAddressMutationPayload, 'deletedAddressId'>
    & { errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type SetVendorDefaultAddressMutationVariables = Exact<{
  purpose: VendorAddressPurposeEnum;
  addressId?: Maybe<Scalars['ID']>;
}>;


export type SetVendorDefaultAddressMutation = (
  { __typename?: 'Mutation' }
  & { setVendorDefaultAddress?: Maybe<(
    { __typename?: 'SetVendorDefaultAddressMutationPayload' }
    & { vendor?: Maybe<(
      { __typename?: 'Vendor' }
      & Pick<Vendor, 'id'>
      & VendorDefaultAddressesFragment
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type GetVendorAddressesQueryVariables = Exact<{
  id: Scalars['ID'];
  after?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}>;


export type GetVendorAddressesQuery = (
  { __typename?: 'Query' }
  & { vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName' | 'companyName' | 'phone' | 'email'>
    ), addresses: (
      { __typename?: 'AddressConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Address' }
        & VendorAddressFragment
      )>>>, pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
      ) }
    ) }
    & VendorDefaultAddressesFragment
  )> }
);

export type UpdateVendorAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: UpdateAccountInput;
}>;


export type UpdateVendorAccountMutation = (
  { __typename?: 'Mutation' }
  & { customUpdateAccount?: Maybe<(
    { __typename?: 'CustomUpdateAccountMutationPayload' }
    & Pick<CustomUpdateAccountMutationPayload, 'clientMutationId'>
    & { account?: Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'state'>
      & { accountable: (
        { __typename: 'Buyer' }
        & Pick<Buyer, 'id'>
      ) | (
        { __typename: 'Expert' }
        & Pick<Expert, 'id'>
      ) | (
        { __typename: 'Vendor' }
        & Pick<Vendor, 'id'>
      ) | (
        { __typename: 'Writer' }
        & Pick<Writer, 'id'>
      ) }
    )> }
  )> }
);

export type VendorOnboardingChecklistQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type VendorOnboardingChecklistQuery = (
  { __typename?: 'Query' }
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & { accountable: { __typename: 'Buyer' } | { __typename: 'Expert' } | (
      { __typename: 'Vendor' }
      & Pick<Vendor, 'id' | 'stripeConnectOnboardedAt' | 'shippingOptions'>
      & { pickupHours: Array<(
        { __typename?: 'Day' }
        & Pick<Day, 'day'>
      )> }
    ) | { __typename: 'Writer' } }
    & OnboardingAccountFragment
  )>, customers: (
    { __typename?: 'CustomerConnection' }
    & Pick<CustomerConnection, 'totalCount'>
  ), writers: (
    { __typename?: 'WriterConnection' }
    & Pick<WriterConnection, 'totalCount'>
  ) }
);

export type VendorPaymentTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<MonthlyVendorPaymentFilter>;
}>;


export type VendorPaymentTableQuery = (
  { __typename?: 'Query' }
  & { monthlyVendorPayments: (
    { __typename?: 'MonthlyVendorPaymentConnection' }
    & Pick<MonthlyVendorPaymentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'MonthlyVendorPaymentEdge' }
      & Pick<MonthlyVendorPaymentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'MonthlyVendorPayment' }
        & VendorPaymentTableFragment
      )> }
    )>>> }
  ) }
);

export type VendorPaymentTableFragment = (
  { __typename?: 'MonthlyVendorPayment' }
  & Pick<MonthlyVendorPayment, 'id' | 'startAt' | 'endAt' | 'paid' | 'createdAt' | 'stripeTransferStatus' | 'stripeTransferError' | 'stripeTransferMode' | 'stripeTransferredAt' | 'disputed' | 'disputeAmount'>
  & { vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id' | 'stripeConnectAccountId'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'firstName' | 'lastName'>
    ) }
  )>, vendorPaymentLines?: Maybe<(
    { __typename?: 'VendorPaymentLineConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'VendorPaymentLineEdge' }
      & { node?: Maybe<(
        { __typename?: 'VendorPaymentLine' }
        & Pick<VendorPaymentLine, 'id' | 'amount'>
      )> }
    )>>> }
  )> }
);

export type VendorSelectFieldFragment = (
  { __typename?: 'Vendor' }
  & Pick<Vendor, 'id'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'firstName' | 'lastName' | 'companyName'>
  ) }
);

export type GetVendorsQueryVariables = Exact<{
  where?: Maybe<VendorFilter>;
}>;


export type GetVendorsQuery = (
  { __typename?: 'Query' }
  & { vendors: (
    { __typename?: 'VendorConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'VendorEdge' }
      & { node?: Maybe<(
        { __typename?: 'Vendor' }
        & VendorSelectFieldFragment
      )> }
    )>>> }
  ) }
);

export type VendorStatementPaymentTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<VendorStatementPaymentFilter>;
}>;


export type VendorStatementPaymentTableQuery = (
  { __typename?: 'Query' }
  & { vendorStatementPayments: (
    { __typename?: 'VendorStatementPaymentConnection' }
    & Pick<VendorStatementPaymentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'VendorStatementPaymentEdge' }
      & Pick<VendorStatementPaymentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'VendorStatementPayment' }
        & VendorStatementPaymentTableFragment
      )> }
    )>>> }
  ) }
);

export type VendorStatementPaymentTableFragment = (
  { __typename?: 'VendorStatementPayment' }
  & Pick<VendorStatementPayment, 'id' | 'startAt' | 'endAt' | 'totalAmount' | 'totalSalesCount' | 'paid' | 'createdAt' | 'stripeTransferStatus' | 'stripeTransferError' | 'stripeTransferMode' | 'stripeTransferredAt' | 'disputed' | 'disputeAmount'>
  & { vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id' | 'stripeConnectAccountId'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'firstName' | 'lastName'>
    ) }
  )>, monthlyVendorPayments?: Maybe<(
    { __typename?: 'MonthlyVendorPaymentConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'MonthlyVendorPaymentEdge' }
      & { node?: Maybe<(
        { __typename?: 'MonthlyVendorPayment' }
        & Pick<MonthlyVendorPayment, 'id' | 'createdAt' | 'startAt' | 'endAt' | 'paid' | 'stripeTransferStatus' | 'stripeTransferError' | 'stripeTransferMode' | 'stripeTransferredAt' | 'disputed' | 'disputeAmount'>
        & { vendor?: Maybe<(
          { __typename?: 'Vendor' }
          & Pick<Vendor, 'id' | 'stripeConnectAccountId'>
          & { account: (
            { __typename?: 'Account' }
            & Pick<Account, 'firstName' | 'lastName'>
          ) }
        )>, vendorPaymentLines?: Maybe<(
          { __typename?: 'VendorPaymentLineConnection' }
          & { edges?: Maybe<Array<Maybe<(
            { __typename?: 'VendorPaymentLineEdge' }
            & { node?: Maybe<(
              { __typename?: 'VendorPaymentLine' }
              & Pick<VendorPaymentLine, 'id' | 'amount'>
            )> }
          )>>> }
        )> }
      )> }
    )>>> }
  )> }
);

export type VendorStatementsQueryVariables = Exact<{
  where?: Maybe<VendorStatementFilter>;
}>;


export type VendorStatementsQuery = (
  { __typename?: 'Query' }
  & { vendorStatements: (
    { __typename?: 'VendorStatementConnection' }
    & VendorStatementEdgesFragment
  ) }
);

export type VendorStatementEdgesFragment = (
  { __typename?: 'VendorStatementConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'VendorStatementEdge' }
    & VendorStatementNodeFragment
  )>>> }
);

export type VendorStatementNodeFragment = (
  { __typename?: 'VendorStatementEdge' }
  & { node?: Maybe<(
    { __typename?: 'VendorStatement' }
    & VendorStatementFragment
  )> }
);

export type VendorStatementFragment = (
  { __typename?: 'VendorStatement' }
  & Pick<VendorStatement, 'id' | 'createdAt' | 'nbItems' | 'number'>
  & { document?: Maybe<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>, vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id'>
  )>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id'>
  )> }
);

export type VendorsTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<VendorFilter>;
}>;


export type VendorsTableQuery = (
  { __typename?: 'Query' }
  & { vendors: (
    { __typename?: 'VendorConnection' }
    & Pick<VendorConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'VendorEdge' }
      & Pick<VendorEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Vendor' }
        & VendorTableFragment
      )> }
    )>>> }
  ) }
);

export type VendorTableFragment = (
  { __typename?: 'Vendor' }
  & Pick<Vendor, 'id' | 'kind'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'firstName' | 'lastName' | 'email' | 'state' | 'createdAt'>
  ) }
);

export type GetWriterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWriterQuery = (
  { __typename?: 'Query' }
  & { writer?: Maybe<(
    { __typename?: 'Writer' }
    & WriterFragment
  )> }
);

export type WriterFragment = (
  { __typename?: 'Writer' }
  & Pick<Writer, 'id'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'firstName' | 'lastName' | 'email' | 'state' | 'createdAt' | 'writerType' | 'writerPourcentageFees' | 'writerFixFees'>
  ), nbItemsCreated?: Maybe<(
    { __typename?: 'WriterKpiCreated' }
    & Pick<WriterKpiCreated, 'currentMonth' | 'lastMonth' | 'total' | 'totalAmountCurrentMonth' | 'totalAmountLastMonth'>
  )>, nbItemsAfterAccepted?: Maybe<(
    { __typename?: 'WriterKpiCreated' }
    & Pick<WriterKpiCreated, 'currentMonth' | 'lastMonth' | 'total' | 'totalAmountCurrentMonth' | 'totalAmountLastMonth'>
  )>, nbItemsAfterShipped?: Maybe<(
    { __typename?: 'WriterKpiCreated' }
    & Pick<WriterKpiCreated, 'currentMonth' | 'lastMonth' | 'total' | 'totalAmountCurrentMonth' | 'totalAmountLastMonth'>
  )>, kpis?: Maybe<(
    { __typename?: 'WriterKpis' }
    & Pick<WriterKpis, 'totalFromBeginning' | 'itemAcceptedPercentage'>
    & { itemPercentageStates?: Maybe<(
      { __typename?: 'WriterItemStates' }
      & Pick<WriterItemStates, 'draft' | 'accepted' | 'refused' | 'needUpdate' | 'waitingExpertise' | 'underExpertise'>
    )> }
  )> }
);

export type WriterPaymentTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<WriterPaymentFilter>;
}>;


export type WriterPaymentTableQuery = (
  { __typename?: 'Query' }
  & { writerPayments: (
    { __typename?: 'WriterPaymentConnection' }
    & Pick<WriterPaymentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'WriterPaymentEdge' }
      & Pick<WriterPaymentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'WriterPayment' }
        & WriterPaymentTableFragment
      )> }
    )>>> }
  ) }
);

export type WriterPaymentTableFragment = (
  { __typename?: 'WriterPayment' }
  & Pick<WriterPayment, 'id' | 'createdAt' | 'paid' | 'lockedAt' | 'startAt' | 'endAt'>
  & { writerPaymentLines?: Maybe<(
    { __typename?: 'WriterPaymentLineConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'WriterPaymentLineEdge' }
      & { node?: Maybe<(
        { __typename?: 'WriterPaymentLine' }
        & Pick<WriterPaymentLine, 'id' | 'amount'>
      )> }
    )>>> }
  )>, writer?: Maybe<(
    { __typename?: 'Writer' }
    & Pick<Writer, 'id'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName'>
    ) }
  )>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name'>
  )>, invoices?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>> }
);

export type WriterSelectFieldFragment = (
  { __typename?: 'Writer' }
  & Pick<Writer, 'id'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'id' | 'firstName' | 'lastName' | 'email'>
  ) }
);

export type GetWritersQueryVariables = Exact<{
  where?: Maybe<WriterFilter>;
}>;


export type GetWritersQuery = (
  { __typename?: 'Query' }
  & { writers: (
    { __typename?: 'WriterConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'WriterEdge' }
      & { node?: Maybe<(
        { __typename?: 'Writer' }
        & WriterSelectFieldFragment
      )> }
    )>>> }
  ) }
);

export type WriterStatementPaymentTableQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<WriterStatementPaymentFilter>;
}>;


export type WriterStatementPaymentTableQuery = (
  { __typename?: 'Query' }
  & { writerStatementPayments: (
    { __typename?: 'WriterStatementPaymentConnection' }
    & Pick<WriterStatementPaymentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'WriterStatementPaymentEdge' }
      & Pick<WriterStatementPaymentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'WriterStatementPayment' }
        & WriterStatementPaymentTableFragment
      )> }
    )>>> }
  ) }
);

export type WriterStatementPaymentTableFragment = (
  { __typename?: 'WriterStatementPayment' }
  & Pick<WriterStatementPayment, 'id' | 'createdAt' | 'paid' | 'totalAmount' | 'startAt' | 'endAt' | 'totalSalesCount'>
  & { writer?: Maybe<(
    { __typename?: 'Writer' }
    & Pick<Writer, 'id'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName'>
    ) }
  )>, invoices?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>>, writerPayments?: Maybe<(
    { __typename?: 'WriterPaymentConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'WriterPaymentEdge' }
      & { node?: Maybe<(
        { __typename?: 'WriterPayment' }
        & Pick<WriterPayment, 'id' | 'createdAt' | 'paid' | 'lockedAt' | 'startAt' | 'endAt'>
        & { writerPaymentLines?: Maybe<(
          { __typename?: 'WriterPaymentLineConnection' }
          & { edges?: Maybe<Array<Maybe<(
            { __typename?: 'WriterPaymentLineEdge' }
            & { node?: Maybe<(
              { __typename?: 'WriterPaymentLine' }
              & Pick<WriterPaymentLine, 'id' | 'amount'>
            )> }
          )>>> }
        )>, writer?: Maybe<(
          { __typename?: 'Writer' }
          & Pick<Writer, 'id'>
          & { account: (
            { __typename?: 'Account' }
            & Pick<Account, 'id' | 'firstName' | 'lastName'>
          ) }
        )>, sale?: Maybe<(
          { __typename?: 'Sale' }
          & Pick<Sale, 'id' | 'name'>
        )>, invoices?: Maybe<Array<(
          { __typename?: 'CustomFile' }
          & Pick<CustomFile, 'imageUrl' | 'filename'>
        )>> }
      )> }
    )>>> }
  )> }
);

export type WriterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WriterQuery = (
  { __typename?: 'Query' }
  & { writer?: Maybe<(
    { __typename?: 'Writer' }
    & { nbItemsCreated?: Maybe<(
      { __typename?: 'WriterKpiCreated' }
      & Pick<WriterKpiCreated, 'currentMonth' | 'lastMonth' | 'total' | 'totalAmountCurrentMonth' | 'totalAmountLastMonth'>
    )>, nbItemsAfterAccepted?: Maybe<(
      { __typename?: 'WriterKpiCreated' }
      & Pick<WriterKpiCreated, 'currentMonth' | 'lastMonth' | 'total' | 'totalAmountCurrentMonth' | 'totalAmountLastMonth'>
    )>, kpis?: Maybe<(
      { __typename?: 'WriterKpis' }
      & Pick<WriterKpis, 'totalFromBeginning' | 'itemAcceptedPercentage'>
      & { itemPercentageStates?: Maybe<(
        { __typename?: 'WriterItemStates' }
        & Pick<WriterItemStates, 'draft' | 'accepted' | 'refused' | 'needUpdate' | 'waitingExpertise' | 'underExpertise'>
      )> }
    )>, financialStats: (
      { __typename?: 'WriterFinancialStats' }
      & Pick<WriterFinancialStats, 'totalPaid' | 'totalPending' | 'nextPaymentDate' | 'fixedFeesTotal' | 'percentageFeesTotal' | 'itemsSoldCount' | 'itemsOnSaleCount' | 'totalSalesAmount' | 'totalPendingWithoutPayment' | 'cutoffDate'>
    ), monthlyEarningsVendor: Array<(
      { __typename?: 'WriterMonthlyEarnings' }
      & Pick<WriterMonthlyEarnings, 'month' | 'amount' | 'year' | 'monthNumber'>
    )>, monthlyEarningsDodecade: Array<(
      { __typename?: 'WriterMonthlyEarnings' }
      & Pick<WriterMonthlyEarnings, 'month' | 'amount' | 'year' | 'monthNumber'>
    )>, itemsOnSale?: Maybe<(
      { __typename?: 'ItemConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'ItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'Item' }
          & Pick<Item, 'id' | 'title' | 'finalPrice' | 'writerCommission' | 'highEstimatedPrice' | 'state'>
          & { sale?: Maybe<(
            { __typename?: 'Sale' }
            & Pick<Sale, 'id' | 'endAt'>
          )> }
        )> }
      )>>> }
    )>, itemsSold?: Maybe<(
      { __typename?: 'ItemConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'ItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'Item' }
          & Pick<Item, 'id' | 'title' | 'finalPrice' | 'writerCommission' | 'highEstimatedPrice' | 'state' | 'soldAt'>
        )> }
      )>>> }
    )>, writerPayments?: Maybe<(
      { __typename?: 'WriterPaymentConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'WriterPaymentEdge' }
        & { node?: Maybe<(
          { __typename?: 'WriterPayment' }
          & Pick<WriterPayment, 'id' | 'paid' | 'startAt' | 'endAt'>
          & { writerPaymentLines?: Maybe<(
            { __typename?: 'WriterPaymentLineConnection' }
            & { edges?: Maybe<Array<Maybe<(
              { __typename?: 'WriterPaymentLineEdge' }
              & { node?: Maybe<(
                { __typename?: 'WriterPaymentLine' }
                & Pick<WriterPaymentLine, 'id' | 'amount'>
              )> }
            )>>> }
          )> }
        )> }
      )>>> }
    )> }
    & WriterTableFragment
  )> }
);

export type WritersQueryVariables = Exact<{
  where?: Maybe<WriterFilter>;
}>;


export type WritersQuery = (
  { __typename?: 'Query' }
  & { writers: (
    { __typename?: 'WriterConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'WriterEdge' }
      & { node?: Maybe<(
        { __typename?: 'Writer' }
        & WriterTableFragment
      )> }
    )>>> }
  ) }
);

export type WriterTableFragment = (
  { __typename?: 'Writer' }
  & Pick<Writer, 'id' | 'adminProjectsIds'>
  & { account: (
    { __typename?: 'Account' }
    & Pick<Account, 'firstName' | 'lastName' | 'email' | 'state' | 'createdAt' | 'writerType' | 'writerPourcentageFees'>
  ), nbItemsCreated?: Maybe<(
    { __typename?: 'WriterKpiCreated' }
    & Pick<WriterKpiCreated, 'currentMonth' | 'lastMonth' | 'total'>
  )>, nbItemsAfterAccepted?: Maybe<(
    { __typename?: 'WriterKpiCreated' }
    & Pick<WriterKpiCreated, 'currentMonth' | 'lastMonth' | 'total'>
  )> }
);

export type SetWriterProjectRoleMutationVariables = Exact<{
  input: SetWriterProjectRoleMutationInput;
}>;


export type SetWriterProjectRoleMutation = (
  { __typename?: 'Mutation' }
  & { setWriterProjectRole?: Maybe<(
    { __typename?: 'SetWriterProjectRoleMutationPayload' }
    & { writer?: Maybe<(
      { __typename?: 'Writer' }
      & Pick<Writer, 'id' | 'adminProjectsIds'>
    )> }
  )> }
);

export type AdminItemCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminItemCategoriesQuery = (
  { __typename?: 'Query' }
  & { itemCategories: (
    { __typename?: 'ItemCategoryConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemCategoryEdge' }
      & { node?: Maybe<(
        { __typename?: 'ItemCategory' }
        & Pick<ItemCategory, 'id' | 'name' | 'externalRainworxId' | 'itemsCount' | 'archived' | 'archivedAt'>
        & { itemSubCategories: (
          { __typename?: 'ItemSubCategoryConnection' }
          & { edges?: Maybe<Array<Maybe<(
            { __typename?: 'ItemSubCategoryEdge' }
            & { node?: Maybe<(
              { __typename?: 'ItemSubCategory' }
              & Pick<ItemSubCategory, 'id' | 'name' | 'externalRainworxId' | 'itemsCount' | 'archived' | 'archivedAt'>
            )> }
          )>>> }
        ) }
      )> }
    )>>> }
  ) }
);

export type CreateItemCategoryMutationVariables = Exact<{
  name: Scalars['String'];
  externalRainworxId?: Maybe<Scalars['Int']>;
}>;


export type CreateItemCategoryMutation = (
  { __typename?: 'Mutation' }
  & { createItemCategory?: Maybe<(
    { __typename?: 'CreateItemCategoryMutationPayload' }
    & Pick<CreateItemCategoryMutationPayload, 'errors'>
    & { itemCategory?: Maybe<(
      { __typename?: 'ItemCategory' }
      & Pick<ItemCategory, 'id' | 'name' | 'externalRainworxId' | 'itemsCount'>
      & { itemSubCategories: (
        { __typename?: 'ItemSubCategoryConnection' }
        & { edges?: Maybe<Array<Maybe<(
          { __typename?: 'ItemSubCategoryEdge' }
          & { node?: Maybe<(
            { __typename?: 'ItemSubCategory' }
            & Pick<ItemSubCategory, 'id' | 'name' | 'externalRainworxId' | 'itemsCount'>
          )> }
        )>>> }
      ) }
    )> }
  )> }
);

export type UpdateItemCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  externalRainworxId?: Maybe<Scalars['Int']>;
}>;


export type UpdateItemCategoryMutation = (
  { __typename?: 'Mutation' }
  & { updateItemCategory?: Maybe<(
    { __typename?: 'UpdateItemCategoryMutationPayload' }
    & Pick<UpdateItemCategoryMutationPayload, 'errors'>
    & { itemCategory?: Maybe<(
      { __typename?: 'ItemCategory' }
      & Pick<ItemCategory, 'id' | 'name' | 'externalRainworxId' | 'itemsCount'>
    )> }
  )> }
);

export type DestroyItemCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyItemCategoryMutation = (
  { __typename?: 'Mutation' }
  & { destroyItemCategory?: Maybe<(
    { __typename?: 'DestroyItemCategoryMutationPayload' }
    & Pick<DestroyItemCategoryMutationPayload, 'success' | 'errors'>
  )> }
);

export type CreateItemSubCategoryMutationVariables = Exact<{
  name: Scalars['String'];
  itemCategoryId: Scalars['ID'];
  externalRainworxId?: Maybe<Scalars['Int']>;
}>;


export type CreateItemSubCategoryMutation = (
  { __typename?: 'Mutation' }
  & { createItemSubCategory?: Maybe<(
    { __typename?: 'CreateItemSubCategoryMutationPayload' }
    & Pick<CreateItemSubCategoryMutationPayload, 'errors'>
    & { itemSubCategory?: Maybe<(
      { __typename?: 'ItemSubCategory' }
      & Pick<ItemSubCategory, 'id' | 'name' | 'externalRainworxId' | 'itemsCount'>
    )> }
  )> }
);

export type UpdateItemSubCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  externalRainworxId?: Maybe<Scalars['Int']>;
}>;


export type UpdateItemSubCategoryMutation = (
  { __typename?: 'Mutation' }
  & { updateItemSubCategory?: Maybe<(
    { __typename?: 'UpdateItemSubCategoryMutationPayload' }
    & Pick<UpdateItemSubCategoryMutationPayload, 'errors'>
    & { itemSubCategory?: Maybe<(
      { __typename?: 'ItemSubCategory' }
      & Pick<ItemSubCategory, 'id' | 'name' | 'externalRainworxId' | 'itemsCount'>
    )> }
  )> }
);

export type DestroyItemSubCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyItemSubCategoryMutation = (
  { __typename?: 'Mutation' }
  & { destroyItemSubCategory?: Maybe<(
    { __typename?: 'DestroyItemSubCategoryMutationPayload' }
    & Pick<DestroyItemSubCategoryMutationPayload, 'success' | 'errors'>
  )> }
);

export type ArchiveItemCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveItemCategoryMutation = (
  { __typename?: 'Mutation' }
  & { archiveItemCategory?: Maybe<(
    { __typename?: 'ArchiveItemCategoryMutationPayload' }
    & Pick<ArchiveItemCategoryMutationPayload, 'errors'>
    & { itemCategory?: Maybe<(
      { __typename?: 'ItemCategory' }
      & Pick<ItemCategory, 'id' | 'archived' | 'archivedAt'>
    )> }
  )> }
);

export type UnarchiveItemCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnarchiveItemCategoryMutation = (
  { __typename?: 'Mutation' }
  & { unarchiveItemCategory?: Maybe<(
    { __typename?: 'UnarchiveItemCategoryMutationPayload' }
    & Pick<UnarchiveItemCategoryMutationPayload, 'errors'>
    & { itemCategory?: Maybe<(
      { __typename?: 'ItemCategory' }
      & Pick<ItemCategory, 'id' | 'archived' | 'archivedAt'>
    )> }
  )> }
);

export type ArchiveItemSubCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveItemSubCategoryMutation = (
  { __typename?: 'Mutation' }
  & { archiveItemSubCategory?: Maybe<(
    { __typename?: 'ArchiveItemSubCategoryMutationPayload' }
    & Pick<ArchiveItemSubCategoryMutationPayload, 'errors'>
    & { itemSubCategory?: Maybe<(
      { __typename?: 'ItemSubCategory' }
      & Pick<ItemSubCategory, 'id' | 'archived' | 'archivedAt'>
    )> }
  )> }
);

export type UnarchiveItemSubCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnarchiveItemSubCategoryMutation = (
  { __typename?: 'Mutation' }
  & { unarchiveItemSubCategory?: Maybe<(
    { __typename?: 'UnarchiveItemSubCategoryMutationPayload' }
    & Pick<UnarchiveItemSubCategoryMutationPayload, 'errors'>
    & { itemSubCategory?: Maybe<(
      { __typename?: 'ItemSubCategory' }
      & Pick<ItemSubCategory, 'id' | 'archived' | 'archivedAt'>
    )> }
  )> }
);

export type VendorsLateOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorsLateOrdersQuery = (
  { __typename?: 'Query' }
  & { vendorsLateOrders: Array<(
    { __typename?: 'VendorLateOrders' }
    & Pick<VendorLateOrders, 'vendorId' | 'vendorName' | 'vendorEmail' | 'vendorPhone'>
    & { lateOrderItems3Days: Array<(
      { __typename?: 'OrderItem' }
      & Pick<OrderItem, 'id' | 'state'>
      & { order?: Maybe<(
        { __typename?: 'Order' }
        & Pick<Order, 'id' | 'dodecadeOrderRef' | 'paidAt' | 'totalPrice'>
      )> }
    )>, lateOrderItems5Days: Array<(
      { __typename?: 'OrderItem' }
      & Pick<OrderItem, 'id' | 'state'>
      & { order?: Maybe<(
        { __typename?: 'Order' }
        & Pick<Order, 'id' | 'dodecadeOrderRef' | 'paidAt' | 'totalPrice'>
      )> }
    )> }
  )> }
);

export type SendLateOrdersReminderMutationVariables = Exact<{
  input: SendLateOrdersReminderMutationInput;
}>;


export type SendLateOrdersReminderMutation = (
  { __typename?: 'Mutation' }
  & { sendLateOrdersReminder?: Maybe<(
    { __typename?: 'SendLateOrdersReminderMutationPayload' }
    & Pick<SendLateOrdersReminderMutationPayload, 'success' | 'errors' | 'message'>
  )> }
);

export type VendorsLatePickupsQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorsLatePickupsQuery = (
  { __typename?: 'Query' }
  & { vendorsLatePickups: Array<(
    { __typename?: 'VendorLatePickups' }
    & Pick<VendorLatePickups, 'vendorId' | 'vendorName' | 'vendorEmail' | 'vendorPhone'>
    & { latePickupItems3Days: Array<(
      { __typename?: 'OrderItem' }
      & Pick<OrderItem, 'id' | 'state'>
      & { order?: Maybe<(
        { __typename?: 'Order' }
        & Pick<Order, 'id' | 'dodecadeOrderRef' | 'paidAt' | 'totalPrice' | 'carrierName'>
      )> }
    )>, latePickupItems5Days: Array<(
      { __typename?: 'OrderItem' }
      & Pick<OrderItem, 'id' | 'state'>
      & { order?: Maybe<(
        { __typename?: 'Order' }
        & Pick<Order, 'id' | 'dodecadeOrderRef' | 'paidAt' | 'totalPrice' | 'carrierName'>
      )> }
    )> }
  )> }
);

export type SendLatePickupsReminderMutationVariables = Exact<{
  input: SendLatePickupsReminderMutationInput;
}>;


export type SendLatePickupsReminderMutation = (
  { __typename?: 'Mutation' }
  & { sendLatePickupsReminder?: Maybe<(
    { __typename?: 'SendLatePickupsReminderMutationPayload' }
    & Pick<SendLatePickupsReminderMutationPayload, 'success' | 'errors' | 'message'>
  )> }
);

export type BuyerDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BuyerDetailQuery = (
  { __typename?: 'Query' }
  & { buyer?: Maybe<(
    { __typename?: 'Buyer' }
    & Pick<Buyer, 'id' | 'createdAt' | 'desiresReviewedAt' | 'desiresReviewedBy'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'civility' | 'firstName' | 'lastName' | 'companyName' | 'isProfessional' | 'email' | 'emailState' | 'phone' | 'createdAt'>
    ), unsubscriptions?: Maybe<Array<(
      { __typename?: 'CustomerUnsubscription' }
      & Pick<CustomerUnsubscription, 'kind'>
    )>>, stats?: Maybe<(
      { __typename?: 'BuyerStats' }
      & Pick<BuyerStats, 'ordersCount' | 'totalSpent' | 'averageBasket' | 'purchasesCount' | 'firstOrderAt' | 'lastOrderAt' | 'desiresCount' | 'activeDesiresCount' | 'favoritesCount' | 'newslettersReceivedCount' | 'newslettersOpenedCount' | 'newslettersClickedCount' | 'lastOpenedAt'>
    )>, topTags?: Maybe<Array<(
      { __typename?: 'BuyerTopTag' }
      & Pick<BuyerTopTag, 'purchasesCount'>
      & { tag: (
        { __typename?: 'Tag' }
        & Pick<Tag, 'id' | 'name'>
      ) }
    )>>, desires?: Maybe<(
      { __typename?: 'DesireConnection' }
      & Pick<DesireConnection, 'totalCount'>
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Desire' }
        & Pick<Desire, 'id' | 'title' | 'active' | 'validated' | 'usable' | 'unusableReasonLabel' | 'matchingWords' | 'alertsSentCount' | 'lastAlertSentAt' | 'createdAt'>
        & { tags?: Maybe<(
          { __typename?: 'TagConnection' }
          & { nodes?: Maybe<Array<Maybe<(
            { __typename?: 'Tag' }
            & Pick<Tag, 'id' | 'name'>
          )>>> }
        )> }
      )>>> }
    )> }
  )> }
);

export type BuyerPurchasesQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type BuyerPurchasesQuery = (
  { __typename?: 'Query' }
  & { buyer?: Maybe<(
    { __typename?: 'Buyer' }
    & Pick<Buyer, 'id'>
    & { purchases?: Maybe<(
      { __typename?: 'OrderItemConnection' }
      & Pick<OrderItemConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
      ), nodes?: Maybe<Array<Maybe<(
        { __typename?: 'OrderItem' }
        & BuyerPurchaseFragment
      )>>> }
    )> }
  )> }
);

export type BuyerPurchaseFragment = (
  { __typename?: 'OrderItem' }
  & Pick<OrderItem, 'id' | 'state' | 'totalPrice'>
  & { order?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'paidAt' | 'createdAt'>
  )>, item: (
    { __typename?: 'Item' }
    & Pick<Item, 'id' | 'title' | 'sku'>
    & { firstImage?: Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'imageUrl'>
    )>, tags?: Maybe<(
      { __typename?: 'TagConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'id' | 'name'>
      )>>> }
    )> }
  ) }
);

export type BuyerFavoritesQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type BuyerFavoritesQuery = (
  { __typename?: 'Query' }
  & { buyer?: Maybe<(
    { __typename?: 'Buyer' }
    & Pick<Buyer, 'id'>
    & { favorites?: Maybe<(
      { __typename?: 'FavoriteConnection' }
      & Pick<FavoriteConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
      ), nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Favorite' }
        & BuyerFavoriteFragment
      )>>> }
    )> }
  )> }
);

export type BuyerFavoriteFragment = (
  { __typename?: 'Favorite' }
  & Pick<Favorite, 'id' | 'createdAt' | 'purchased'>
  & { item: (
    { __typename?: 'Item' }
    & Pick<Item, 'id' | 'title' | 'state' | 'startingPrice'>
    & { firstImage?: Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'imageUrl'>
    )>, tags?: Maybe<(
      { __typename?: 'TagConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'id' | 'name'>
      )>>> }
    )> }
  ) }
);

export type ContactDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContactDetailQuery = (
  { __typename?: 'Query' }
  & { customer?: Maybe<(
    { __typename?: 'Customer' }
    & Pick<Customer, 'id' | 'createdAt' | 'email' | 'firstName' | 'lastName' | 'fullName' | 'phone1' | 'phone2' | 'addressLine1' | 'addressLine2' | 'zip' | 'city' | 'country' | 'emailState' | 'subscribed' | 'desiresReviewedAt' | 'desiresReviewedBy'>
    & { unsubscriptions?: Maybe<Array<(
      { __typename?: 'CustomerUnsubscription' }
      & Pick<CustomerUnsubscription, 'kind' | 'createdAt' | 'source'>
    )>>, stats?: Maybe<(
      { __typename?: 'CustomerStats' }
      & Pick<CustomerStats, 'recordsCount' | 'newslettersReceivedCount' | 'lastNewsletterAt' | 'newslettersOpenedCount' | 'lastOpenedAt' | 'newslettersClickedCount' | 'desiresCount' | 'activeDesiresCount' | 'ordersCount' | 'totalSpent'>
      & { matchedBuyer?: Maybe<(
        { __typename?: 'Buyer' }
        & Pick<Buyer, 'id'>
      )> }
    )>, origins?: Maybe<Array<(
      { __typename?: 'CustomerOrigin' }
      & Pick<CustomerOrigin, 'createdAt' | 'importFilename'>
    )>>, itemCategories?: Maybe<(
      { __typename?: 'CustomerItemCategoryConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'CustomerItemCategory' }
        & Pick<CustomerItemCategory, 'id' | 'name'>
      )>>> }
    )>, itemSubCategories?: Maybe<(
      { __typename?: 'CustomerItemSubCategoryConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'CustomerItemSubCategory' }
        & Pick<CustomerItemSubCategory, 'id' | 'name'>
      )>>> }
    )>, tags?: Maybe<(
      { __typename?: 'TagConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'id' | 'name'>
      )>>> }
    )>, desires?: Maybe<(
      { __typename?: 'DesireConnection' }
      & Pick<DesireConnection, 'totalCount'>
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Desire' }
        & Pick<Desire, 'id' | 'title' | 'active' | 'validated' | 'usable' | 'unusableReasonLabel' | 'matchingWords' | 'alertsSentCount' | 'lastAlertSentAt' | 'createdAt'>
        & { tags?: Maybe<(
          { __typename?: 'TagConnection' }
          & { nodes?: Maybe<Array<Maybe<(
            { __typename?: 'Tag' }
            & Pick<Tag, 'id' | 'name'>
          )>>> }
        )> }
      )>>> }
    )> }
  )> }
);

export type ContactsSummaryQueryVariables = Exact<{
  dormantMinNewsletters?: Maybe<Scalars['Int']>;
}>;


export type ContactsSummaryQuery = (
  { __typename?: 'Query' }
  & { customerContactsSummary?: Maybe<(
    { __typename?: 'CustomerContactsSummary' }
    & Pick<CustomerContactsSummary, 'totalCount' | 'sendableCount' | 'blockedCount' | 'flaggedUnsubscribedCount' | 'sendableNeverBoughtCount' | 'dormantCount' | 'withDesiresCount' | 'engagedNeverBoughtCount' | 'neverOpenedCount' | 'salesUnsubscribedCount' | 'weeklyUnsubscribedCount'>
    & { emailStates: Array<(
      { __typename?: 'EmailStateCount' }
      & Pick<EmailStateCount, 'state' | 'count'>
    )> }
  )> }
);

export type CreateCpImportMutationVariables = Exact<{
  attributes: CreateCpImportInput;
}>;


export type CreateCpImportMutation = (
  { __typename?: 'Mutation' }
  & { createCpImport?: Maybe<(
    { __typename?: 'CreateCpImportMutationPayload' }
    & Pick<CreateCpImportMutationPayload, 'clientMutationId'>
    & { import?: Maybe<(
      { __typename?: 'Import' }
      & Pick<Import, 'id'>
    )> }
  )> }
);

export type CreateItemFromSaleQueryVariables = Exact<{
  saleId: Scalars['ID'];
}>;


export type CreateItemFromSaleQuery = (
  { __typename?: 'Query' }
  & { sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name' | 'typeOfSale'>
  )>, projects: (
    { __typename?: 'ProjectConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ProjectEdge' }
      & { node?: Maybe<(
        { __typename?: 'Project' }
        & Pick<Project, 'id' | 'title' | 'number'>
      )> }
    )>>> }
  ), plannedItems: (
    { __typename?: 'ItemConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemEdge' }
      & { node?: Maybe<(
        { __typename?: 'Item' }
        & Pick<Item, 'id'>
        & { project?: Maybe<(
          { __typename?: 'Project' }
          & Pick<Project, 'id'>
        )> }
      )> }
    )>>> }
  ), saleItems: (
    { __typename?: 'ItemConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'ItemEdge' }
      & { node?: Maybe<(
        { __typename?: 'Item' }
        & Pick<Item, 'id'>
        & { project?: Maybe<(
          { __typename?: 'Project' }
          & Pick<Project, 'id'>
        )> }
      )> }
    )>>> }
  ) }
);

export type DesireAlertStatsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['Int']>;
  days?: Maybe<Scalars['Int']>;
}>;


export type DesireAlertStatsQuery = (
  { __typename?: 'Query' }
  & { desireAlertSummary?: Maybe<(
    { __typename?: 'DesireAlertSummary' }
    & Pick<DesireAlertSummary, 'desiresCount' | 'itemsCount' | 'salesCount'>
    & { stats: (
      { __typename?: 'NewsletterStats' }
      & Pick<NewsletterStats, 'sent' | 'opened' | 'clicked' | 'bounced' | 'spam' | 'unsub' | 'openRate' | 'clickRate'>
    ) }
  )>, desireAlertSales: Array<(
    { __typename?: 'DesireAlertSale' }
    & Pick<DesireAlertSale, 'firstSentAt' | 'desiresCount' | 'itemsCount'>
    & { sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id' | 'name'>
    )>, stats: (
      { __typename?: 'NewsletterStats' }
      & Pick<NewsletterStats, 'sent' | 'opened' | 'clicked' | 'bounced' | 'spam' | 'unsub' | 'openRate' | 'clickRate'>
    ) }
  )>, desireAlertHourlyStats: Array<(
    { __typename?: 'NewsletterHourlyStat' }
    & Pick<NewsletterHourlyStat, 'hour' | 'sent' | 'opened' | 'clicked'>
  )> }
);

export type CreateDesireImportMutationVariables = Exact<{
  attributes: CreateDesiresRainworxImportInput;
}>;


export type CreateDesireImportMutation = (
  { __typename?: 'Mutation' }
  & { createDesiresRainworxImport?: Maybe<(
    { __typename?: 'CreateDesiresRainworxImportMutationPayload' }
    & Pick<CreateDesiresRainworxImportMutationPayload, 'clientMutationId'>
    & { import?: Maybe<(
      { __typename?: 'Import' }
      & Pick<Import, 'id'>
    )> }
  )> }
);

export type CreateImportMutationVariables = Exact<{
  attributes: CreateImportInput;
}>;


export type CreateImportMutation = (
  { __typename?: 'Mutation' }
  & { createImport?: Maybe<(
    { __typename?: 'CreateImportMutationPayload' }
    & Pick<CreateImportMutationPayload, 'clientMutationId'>
    & { import?: Maybe<(
      { __typename?: 'Import' }
      & Pick<Import, 'id'>
    )> }
  )> }
);

export type DodecadeStatementPaymentsQueryVariables = Exact<{
  where?: Maybe<DodecadeStatementPaymentFilter>;
}>;


export type DodecadeStatementPaymentsQuery = (
  { __typename?: 'Query' }
  & { dodecadeStatementPayments: (
    { __typename?: 'DodecadeStatementPaymentConnection' }
    & Pick<DodecadeStatementPaymentConnection, 'totalCount'>
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'DodecadeStatementPayment' }
      & Pick<DodecadeStatementPayment, 'id' | 'totalAmount' | 'totalVendorAmount' | 'totalPlatformFee' | 'stripePayoutId' | 'stripePayoutStatus' | 'stripePayoutMode' | 'stripePaidOutAt' | 'periodStartAt' | 'periodEndAt' | 'paid' | 'paymentDate' | 'createdAt'>
      & { vendorStatementPayments?: Maybe<(
        { __typename?: 'VendorStatementPaymentConnection' }
        & { edges?: Maybe<Array<Maybe<(
          { __typename?: 'VendorStatementPaymentEdge' }
          & { node?: Maybe<(
            { __typename?: 'VendorStatementPayment' }
            & Pick<VendorStatementPayment, 'id' | 'totalAmount' | 'stripeTransferStatus'>
            & { vendor?: Maybe<(
              { __typename?: 'Vendor' }
              & Pick<Vendor, 'id'>
              & { account: (
                { __typename?: 'Account' }
                & Pick<Account, 'firstName' | 'lastName'>
              ) }
            )> }
          )> }
        )>>> }
      )> }
    )>>> }
  ) }
);

export type DodecadeStatementPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DodecadeStatementPaymentQuery = (
  { __typename?: 'Query' }
  & { dodecadeStatementPayment?: Maybe<(
    { __typename?: 'DodecadeStatementPayment' }
    & Pick<DodecadeStatementPayment, 'id' | 'totalAmount' | 'totalVendorAmount' | 'totalPlatformFee' | 'stripePayoutId' | 'stripePayoutStatus' | 'stripePayoutMode' | 'stripePaidOutAt' | 'periodStartAt' | 'periodEndAt' | 'paid' | 'paymentDate' | 'createdAt'>
    & { vendorStatementPayments?: Maybe<(
      { __typename?: 'VendorStatementPaymentConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'VendorStatementPaymentEdge' }
        & { node?: Maybe<(
          { __typename?: 'VendorStatementPayment' }
          & Pick<VendorStatementPayment, 'id' | 'totalAmount' | 'paid' | 'stripeTransferId' | 'stripeTransferStatus' | 'stripeTransferError' | 'stripeTransferredAt'>
          & { vendor?: Maybe<(
            { __typename?: 'Vendor' }
            & Pick<Vendor, 'id' | 'stripeConnectAccountId'>
            & { account: (
              { __typename?: 'Account' }
              & Pick<Account, 'firstName' | 'lastName'>
              & { bankInformation?: Maybe<(
                { __typename?: 'BankInformation' }
                & Pick<BankInformation, 'iban' | 'bic'>
              )> }
            ) }
          )> }
        )> }
      )>>> }
    )> }
  )> }
);

export type TriggerDodecadePayoutMutationVariables = Exact<{
  input: TriggerDodecadePayoutMutationInput;
}>;


export type TriggerDodecadePayoutMutation = (
  { __typename?: 'Mutation' }
  & { triggerDodecadePayout?: Maybe<(
    { __typename?: 'TriggerDodecadePayoutMutationPayload' }
    & Pick<TriggerDodecadePayoutMutationPayload, 'errors'>
    & { dodecadeStatementPayment?: Maybe<(
      { __typename?: 'DodecadeStatementPayment' }
      & Pick<DodecadeStatementPayment, 'id' | 'stripePayoutId' | 'stripePayoutStatus' | 'stripePaidOutAt'>
    )> }
  )> }
);

export type CreateDrouotImportMutationVariables = Exact<{
  attributes: CreateDrouotImportInput;
}>;


export type CreateDrouotImportMutation = (
  { __typename?: 'Mutation' }
  & { createDrouotImport?: Maybe<(
    { __typename?: 'CreateDrouotImportMutationPayload' }
    & Pick<CreateDrouotImportMutationPayload, 'clientMutationId'>
    & { import?: Maybe<(
      { __typename?: 'Import' }
      & Pick<Import, 'id'>
    )> }
  )> }
);

export type ExpertDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpertDashboardQuery = (
  { __typename?: 'Query' }
  & { waitingExpertise: (
    { __typename?: 'ItemConnection' }
    & Pick<ItemConnection, 'totalCount'>
  ), needUpdate: (
    { __typename?: 'ItemConnection' }
    & Pick<ItemConnection, 'totalCount'>
  ), accepted: (
    { __typename?: 'ItemConnection' }
    & Pick<ItemConnection, 'totalCount'>
  ), itemsStats: (
    { __typename?: 'ItemsStats' }
    & Pick<ItemsStats, 'onSale' | 'onVacation' | 'adminLibraryFundEligible' | 'adminDiscountedEligible' | 'adminUnpaidEligible'>
  ), sales: (
    { __typename?: 'SaleConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'SaleEdge' }
      & { node?: Maybe<(
        { __typename?: 'Sale' }
        & Pick<Sale, 'id' | 'name' | 'state' | 'startAt' | 'endAt' | 'nbItems' | 'typeOfSale'>
      )> }
    )>>> }
  ) }
);

export type ExpertDashboardAdminQueryVariables = Exact<{
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
}>;


export type ExpertDashboardAdminQuery = (
  { __typename?: 'Query' }
  & { kpis: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
      & { comparison?: Maybe<(
        { __typename?: 'Comparison' }
        & Pick<Comparison, 'previousValue' | 'deltaPercentage'>
      )> }
    )> }
  ), vendorsLateOrders: Array<(
    { __typename?: 'VendorLateOrders' }
    & Pick<VendorLateOrders, 'vendorId'>
  )>, vendorsLatePickups: Array<(
    { __typename?: 'VendorLatePickups' }
    & Pick<VendorLatePickups, 'vendorId'>
  )> }
);

export type GetExpertQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetExpertQuery = (
  { __typename?: 'Query' }
  & { expert?: Maybe<(
    { __typename?: 'Expert' }
    & Pick<Expert, 'id'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'state' | 'firstName' | 'lastName' | 'email'>
    ) }
  )> }
);

export type UpdateExpertPaymentMutationVariables = Exact<{
  input: UpdateExpertPaymentMutationInput;
}>;


export type UpdateExpertPaymentMutation = (
  { __typename?: 'Mutation' }
  & { updateExpertPayment?: Maybe<(
    { __typename?: 'UpdateExpertPaymentMutationPayload' }
    & { expertPayment?: Maybe<(
      { __typename?: 'ExpertPayment' }
      & Pick<ExpertPayment, 'id'>
    )> }
  )> }
);

export type ExpertPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExpertPaymentQuery = (
  { __typename?: 'Query' }
  & { expertPayment?: Maybe<(
    { __typename?: 'ExpertPayment' }
    & Pick<ExpertPayment, 'id' | 'paid' | 'startAt' | 'endAt'>
    & { orderItems?: Maybe<(
      { __typename?: 'OrderItemConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'OrderItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'OrderItem' }
          & Pick<OrderItem, 'id' | 'totalPrice'>
          & { order?: Maybe<(
            { __typename?: 'Order' }
            & Pick<Order, 'id'>
            & { sale?: Maybe<(
              { __typename?: 'Sale' }
              & Pick<Sale, 'id' | 'name'>
            )> }
          )> }
        )> }
      )>>> }
    )>, expertPaymentLines?: Maybe<(
      { __typename?: 'ExpertPaymentLineConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'ExpertPaymentLineEdge' }
        & { node?: Maybe<(
          { __typename?: 'ExpertPaymentLine' }
          & Pick<ExpertPaymentLine, 'id' | 'amount'>
        )> }
      )>>> }
    )>, invoices?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & FileFragment
    )>>, expert?: Maybe<(
      { __typename?: 'Expert' }
      & Pick<Expert, 'id'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'id' | 'lastName' | 'firstName'>
        & { bankInformation?: Maybe<(
          { __typename?: 'BankInformation' }
          & Pick<BankInformation, 'iban' | 'bic'>
        )> }
      ) }
    )> }
  )> }
);

export type ExpertPaymentListQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpertPaymentListQuery = (
  { __typename?: 'Query' }
  & { unpaidExpertPayments: (
    { __typename?: 'ExpertPaymentConnection' }
    & Pick<ExpertPaymentConnection, 'totalCount'>
  ), unpaidExpertStatementPayments: (
    { __typename?: 'ExpertStatementPaymentConnection' }
    & Pick<ExpertStatementPaymentConnection, 'totalCount'>
  ), allExpertPayments: (
    { __typename?: 'ExpertPaymentConnection' }
    & Pick<ExpertPaymentConnection, 'totalCount'>
  ) }
);

export type ExpertStatementPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExpertStatementPaymentQuery = (
  { __typename?: 'Query' }
  & { expertStatementPayment?: Maybe<(
    { __typename?: 'ExpertStatementPayment' }
    & Pick<ExpertStatementPayment, 'id' | 'startAt' | 'endAt' | 'paymentDate' | 'paid' | 'totalAmount' | 'totalLinesCount' | 'totalSalesCount' | 'createdAt' | 'updatedAt'>
    & { expert?: Maybe<(
      { __typename?: 'Expert' }
      & Pick<Expert, 'id'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'firstName' | 'lastName'>
        & { bankInformation?: Maybe<(
          { __typename?: 'BankInformation' }
          & Pick<BankInformation, 'iban' | 'bic'>
        )> }
      ) }
    )>, invoices?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & Pick<CustomFile, 'imageUrl' | 'filename' | 'blobId'>
    )>>, expertPayments?: Maybe<(
      { __typename?: 'ExpertPaymentConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'ExpertPaymentEdge' }
        & { node?: Maybe<(
          { __typename?: 'ExpertPayment' }
          & Pick<ExpertPayment, 'id' | 'createdAt'>
          & { sale?: Maybe<(
            { __typename?: 'Sale' }
            & Pick<Sale, 'id' | 'name'>
          )>, expertPaymentLines?: Maybe<(
            { __typename?: 'ExpertPaymentLineConnection' }
            & { edges?: Maybe<Array<Maybe<(
              { __typename?: 'ExpertPaymentLineEdge' }
              & { node?: Maybe<(
                { __typename?: 'ExpertPaymentLine' }
                & Pick<ExpertPaymentLine, 'amount'>
              )> }
            )>>> }
          )>, orderItems?: Maybe<(
            { __typename?: 'OrderItemConnection' }
            & { edges?: Maybe<Array<Maybe<(
              { __typename?: 'OrderItemEdge' }
              & { node?: Maybe<(
                { __typename?: 'OrderItem' }
                & Pick<OrderItem, 'id' | 'totalPrice'>
                & { order?: Maybe<(
                  { __typename?: 'Order' }
                  & Pick<Order, 'createdAt'>
                )>, item: (
                  { __typename?: 'Item' }
                  & Pick<Item, 'id' | 'title' | 'finalPrice' | 'lowEstimatedPrice' | 'highEstimatedPrice'>
                  & { firstImage?: Maybe<(
                    { __typename?: 'Image' }
                    & Pick<Image, 'imageUrl'>
                  )> }
                ) }
              )> }
            )>>> }
          )> }
        )> }
      )>>> }
    )> }
  )> }
);

export type UpdateExpertStatementPaymentMutationVariables = Exact<{
  input: UpdateExpertStatementPaymentMutationInput;
}>;


export type UpdateExpertStatementPaymentMutation = (
  { __typename?: 'Mutation' }
  & { updateExpertStatementPayment?: Maybe<(
    { __typename?: 'UpdateExpertStatementPaymentMutationPayload' }
    & { expertStatementPayment?: Maybe<(
      { __typename?: 'ExpertStatementPayment' }
      & Pick<ExpertStatementPayment, 'id' | 'paid' | 'paymentDate'>
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type GetExpertsPerfAnalyticsQueryVariables = Exact<{
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
  compareTo: CompareToEnum;
  expertId?: Maybe<Scalars['ID']>;
  categoryId?: Maybe<Scalars['ID']>;
}>;


export type GetExpertsPerfAnalyticsQuery = (
  { __typename?: 'Query' }
  & { kpis: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
      & { comparison?: Maybe<(
        { __typename?: 'Comparison' }
        & Pick<Comparison, 'previousValue' | 'delta' | 'deltaPercentage'>
      )> }
    )> }
  ), byExperts: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { breakdown?: Maybe<Array<(
        { __typename?: 'BreakdownResult' }
        & Pick<BreakdownResult, 'name' | 'dimensionId' | 'value'>
      )>> }
    )> }
  ), volume: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { timeSeries?: Maybe<Array<(
        { __typename?: 'TimeSeriesPoint' }
        & AnalyticsVolumeAndDelayChartCardFragment
      )>> }
    )> }
  ), delay: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { timeSeries?: Maybe<Array<(
        { __typename?: 'TimeSeriesPoint' }
        & AnalyticsVolumeAndDelayChartCardFragment
      )>> }
    )> }
  ) }
);

export type CreateFavoriteImportMutationVariables = Exact<{
  attributes: CreateFavoritesRainworxImportInput;
}>;


export type CreateFavoriteImportMutation = (
  { __typename?: 'Mutation' }
  & { createFavoritesRainworxImport?: Maybe<(
    { __typename?: 'CreateFavoritesRainworxImportMutationPayload' }
    & Pick<CreateFavoritesRainworxImportMutationPayload, 'clientMutationId'>
    & { import?: Maybe<(
      { __typename?: 'Import' }
      & Pick<Import, 'id'>
    )> }
  )> }
);

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = (
  { __typename?: 'Mutation' }
  & { forgotPassword?: Maybe<(
    { __typename?: 'ForgotPasswordPayload' }
    & Pick<ForgotPasswordPayload, 'success'>
    & { errors: Array<(
      { __typename?: 'Error' }
      & Pick<Error, 'details' | 'message'>
    )> }
  )> }
);

export type GetFunnelPerfAnalyticsQueryVariables = Exact<{
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
  compareTo: CompareToEnum;
  vendorId?: Maybe<Scalars['ID']>;
  categoryId?: Maybe<Scalars['ID']>;
}>;


export type GetFunnelPerfAnalyticsQuery = (
  { __typename?: 'Query' }
  & { kpis: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
      & { comparison?: Maybe<(
        { __typename?: 'Comparison' }
        & Pick<Comparison, 'previousValue' | 'delta' | 'deltaPercentage'>
      )> }
    )> }
  ), funnelStates: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
    )> }
  ), saleRateByAttempt: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
    )> }
  ), unsoldFunnel: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
    )> }
  ) }
);

export type ImportPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ImportPaymentQuery = (
  { __typename?: 'Query' }
  & { importPayment?: Maybe<(
    { __typename?: 'ImportPayment' }
    & { account?: Maybe<(
      { __typename?: 'Account' }
      & { bankInformation?: Maybe<(
        { __typename?: 'BankInformation' }
        & Pick<BankInformation, 'iban' | 'bic'>
      )> }
      & ImportAccountFragment
    )> }
    & ImportPaymentFragment
  )> }
);

export type ImportAccountFragment = (
  { __typename?: 'Account' }
  & Pick<Account, 'firstName' | 'lastName' | 'state' | 'isProfessional'>
);

export type ImportPaymentFragment = (
  { __typename?: 'ImportPayment' }
  & Pick<ImportPayment, 'id' | 'lockedAt' | 'paid' | 'createdAt' | 'startAt' | 'endAt'>
  & { account?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'firstName' | 'lastName'>
  )>, importStatementPayment?: Maybe<(
    { __typename?: 'ImportStatementPayment' }
    & Pick<ImportStatementPayment, 'id'>
  )>, orderItems?: Maybe<(
    { __typename?: 'OrderItemConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'OrderItemEdge' }
      & { node?: Maybe<(
        { __typename?: 'OrderItem' }
        & Pick<OrderItem, 'id' | 'totalPrice'>
        & { order?: Maybe<(
          { __typename?: 'Order' }
          & Pick<Order, 'id'>
          & { sale?: Maybe<(
            { __typename?: 'Sale' }
            & Pick<Sale, 'id' | 'name'>
          )> }
        )> }
      )> }
    )>>> }
  )>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name'>
  )>, importPaymentLines?: Maybe<(
    { __typename?: 'ImportPaymentLineConnection' }
    & ImportPaymentLineEdgesFragment
  )> }
);

export type ImportPaymentLineEdgesFragment = (
  { __typename?: 'ImportPaymentLineConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'ImportPaymentLineEdge' }
    & ImportPaymentLineNodeFragment
  )>>> }
);

export type ImportPaymentLineNodeFragment = (
  { __typename?: 'ImportPaymentLineEdge' }
  & { node?: Maybe<(
    { __typename?: 'ImportPaymentLine' }
    & ImportPaymentLineFragment
  )> }
);

export type ImportPaymentLineFragment = (
  { __typename?: 'ImportPaymentLine' }
  & Pick<ImportPaymentLine, 'amount' | 'feePercentage'>
);

export type UpdateImportPaymentMutationVariables = Exact<{
  input: UpdateImportPaymentMutationInput;
}>;


export type UpdateImportPaymentMutation = (
  { __typename?: 'Mutation' }
  & { updateImportPayment?: Maybe<(
    { __typename?: 'UpdateImportPaymentMutationPayload' }
    & { importPayment?: Maybe<(
      { __typename?: 'ImportPayment' }
      & Pick<ImportPayment, 'id'>
    )> }
  )> }
);

export type ImportPaymentListQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportPaymentListQuery = (
  { __typename?: 'Query' }
  & { unpaidImportPayments: (
    { __typename?: 'ImportPaymentConnection' }
    & Pick<ImportPaymentConnection, 'totalCount'>
  ), unpaidImportStatementPayments: (
    { __typename?: 'ImportStatementPaymentConnection' }
    & Pick<ImportStatementPaymentConnection, 'totalCount'>
  ), allImportPayments: (
    { __typename?: 'ImportPaymentConnection' }
    & Pick<ImportPaymentConnection, 'totalCount'>
  ) }
);

export type ImportStatementPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ImportStatementPaymentQuery = (
  { __typename?: 'Query' }
  & { importStatementPayment?: Maybe<(
    { __typename?: 'ImportStatementPayment' }
    & Pick<ImportStatementPayment, 'id' | 'startAt' | 'endAt' | 'paymentDate' | 'paid' | 'totalAmount' | 'totalLinesCount' | 'totalSalesCount' | 'createdAt' | 'updatedAt'>
    & { account?: Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'firstName' | 'lastName'>
    )>, invoices?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & Pick<CustomFile, 'imageUrl' | 'filename' | 'blobId'>
    )>>, importPayments?: Maybe<(
      { __typename?: 'ImportPaymentConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'ImportPaymentEdge' }
        & { node?: Maybe<(
          { __typename?: 'ImportPayment' }
          & Pick<ImportPayment, 'id' | 'createdAt'>
          & { sale?: Maybe<(
            { __typename?: 'Sale' }
            & Pick<Sale, 'id' | 'name'>
          )>, importPaymentLines?: Maybe<(
            { __typename?: 'ImportPaymentLineConnection' }
            & { edges?: Maybe<Array<Maybe<(
              { __typename?: 'ImportPaymentLineEdge' }
              & { node?: Maybe<(
                { __typename?: 'ImportPaymentLine' }
                & Pick<ImportPaymentLine, 'amount' | 'feePercentage'>
              )> }
            )>>> }
          )>, orderItems?: Maybe<(
            { __typename?: 'OrderItemConnection' }
            & { edges?: Maybe<Array<Maybe<(
              { __typename?: 'OrderItemEdge' }
              & { node?: Maybe<(
                { __typename?: 'OrderItem' }
                & Pick<OrderItem, 'id' | 'totalPrice'>
                & { order?: Maybe<(
                  { __typename?: 'Order' }
                  & Pick<Order, 'createdAt'>
                )>, item: (
                  { __typename?: 'Item' }
                  & Pick<Item, 'id' | 'title' | 'finalPrice' | 'lowEstimatedPrice' | 'highEstimatedPrice'>
                  & { firstImage?: Maybe<(
                    { __typename?: 'Image' }
                    & Pick<Image, 'imageUrl'>
                  )> }
                ) }
              )> }
            )>>> }
          )> }
        )> }
      )>>> }
    )> }
  )> }
);

export type UpdateImportStatementPaymentMutationVariables = Exact<{
  input: UpdateImportStatementPaymentMutationInput;
}>;


export type UpdateImportStatementPaymentMutation = (
  { __typename?: 'Mutation' }
  & { updateImportStatementPayment?: Maybe<(
    { __typename?: 'UpdateImportStatementPaymentMutationPayload' }
    & { importStatementPayment?: Maybe<(
      { __typename?: 'ImportStatementPayment' }
      & Pick<ImportStatementPayment, 'id' | 'paid' | 'paymentDate'>
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type ItemHistorySaleFragment = (
  { __typename?: 'Sale' }
  & Pick<Sale, 'id' | 'name' | 'startAt' | 'endAt'>
);

export type ItemHistoryPassageFragment = (
  { __typename?: 'ItemSalePassage' }
  & Pick<ItemSalePassage, 'number' | 'result' | 'startingPrice' | 'finalPrice'>
  & { sale?: Maybe<(
    { __typename?: 'Sale' }
    & ItemHistorySaleFragment
  )> }
);

export type ItemHistorySaleEventFragment = (
  { __typename?: 'ItemSaleHistory' }
  & Pick<ItemSaleHistory, 'id' | 'eventType' | 'triggeredBy' | 'triggeredByUserName' | 'previousState' | 'newState' | 'notes' | 'startingPriceUsed' | 'nextPrice' | 'discountPercentage' | 'createdAt'>
  & { sale?: Maybe<(
    { __typename?: 'Sale' }
    & ItemHistorySaleFragment
  )> }
);

export type ItemHistoryOrderEventFragment = (
  { __typename?: 'ItemOrderHistory' }
  & Pick<ItemOrderHistory, 'id' | 'orderId' | 'eventType' | 'finalPrice' | 'occurredAt'>
);

export type ItemHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ItemHistoryQuery = (
  { __typename?: 'Query' }
  & { item?: Maybe<(
    { __typename?: 'Item' }
    & Pick<Item, 'id'>
    & { salePassages: Array<(
      { __typename?: 'ItemSalePassage' }
      & ItemHistoryPassageFragment
    )>, itemSaleHistories?: Maybe<Array<(
      { __typename?: 'ItemSaleHistory' }
      & ItemHistorySaleEventFragment
    )>>, itemOrderHistories?: Maybe<Array<(
      { __typename?: 'ItemOrderHistory' }
      & ItemHistoryOrderEventFragment
    )>> }
  )> }
);

export type LogInMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LogInMutation = (
  { __typename?: 'Mutation' }
  & { customSignIn?: Maybe<(
    { __typename?: 'CustomSignInPayload' }
    & Pick<CustomSignInPayload, 'success' | 'sessionToken'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email' | 'firstName' | 'lastName' | 'lastAccountTypeUsed'>
      & { accounts: (
        { __typename?: 'AccountConnection' }
        & { edges?: Maybe<Array<Maybe<(
          { __typename?: 'AccountEdge' }
          & { node?: Maybe<(
            { __typename?: 'Account' }
            & Pick<Account, 'id'>
            & { accountable: { __typename: 'Buyer' } | (
              { __typename: 'Expert' }
              & Pick<Expert, 'id'>
            ) | (
              { __typename: 'Vendor' }
              & Pick<Vendor, 'id'>
            ) | { __typename: 'Writer' } }
          )> }
        )>>> }
      ) }
    )> }
  )> }
);

export type GetMarginAndGmvAnalyticsQueryVariables = Exact<{
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
  fromN1: Scalars['ISO8601DateTime'];
  toN1: Scalars['ISO8601DateTime'];
  compareTo: CompareToEnum;
  vendorId?: Maybe<Scalars['ID']>;
  categoryId?: Maybe<Scalars['ID']>;
}>;


export type GetMarginAndGmvAnalyticsQuery = (
  { __typename?: 'Query' }
  & { kpis: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
      & { comparison?: Maybe<(
        { __typename?: 'Comparison' }
        & Pick<Comparison, 'previousValue' | 'delta' | 'deltaPercentage'>
      )> }
    )> }
  ), gmv: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { timeSeries?: Maybe<Array<(
        { __typename?: 'TimeSeriesPoint' }
        & AnalyticsRevenueAndMarginChartCardFragment
      )>> }
    )> }
  ), margin: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { timeSeries?: Maybe<Array<(
        { __typename?: 'TimeSeriesPoint' }
        & AnalyticsRevenueAndMarginChartCardFragment
      )>> }
    )> }
  ), gmvN1: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { timeSeries?: Maybe<Array<(
        { __typename?: 'TimeSeriesPoint' }
        & AnalyticsRevenueAndMarginChartCardFragment
      )>> }
    )> }
  ), topVendors: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { breakdown?: Maybe<Array<(
        { __typename?: 'BreakdownResult' }
        & Pick<BreakdownResult, 'dimensionId' | 'name' | 'value'>
      )>> }
    )> }
  ), unpaidRate: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
      & { breakdown?: Maybe<Array<(
        { __typename?: 'BreakdownResult' }
        & Pick<BreakdownResult, 'dimensionId' | 'name' | 'value'>
      )>> }
    )> }
  ), unsoldRate: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
      & { breakdown?: Maybe<Array<(
        { __typename?: 'BreakdownResult' }
        & Pick<BreakdownResult, 'dimensionId' | 'name' | 'value'>
      )>> }
    )> }
  ), revenueBreakdown: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
    )> }
  ) }
);

export type CreateMyAlertsDesireImportMutationVariables = Exact<{
  attributes: CreateMyAlertsDesiresImportInput;
}>;


export type CreateMyAlertsDesireImportMutation = (
  { __typename?: 'Mutation' }
  & { createMyAlertsDesiresImport?: Maybe<(
    { __typename?: 'CreateMyAlertsDesiresImportMutationPayload' }
    & Pick<CreateMyAlertsDesiresImportMutationPayload, 'clientMutationId'>
    & { import?: Maybe<(
      { __typename?: 'Import' }
      & Pick<Import, 'id'>
    )> }
  )> }
);

export type NewsletterStatsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['Int']>;
}>;


export type NewsletterStatsQuery = (
  { __typename?: 'Query' }
  & { newsletterCampaigns: Array<(
    { __typename?: 'NewsletterCampaign' }
    & Pick<NewsletterCampaign, 'id' | 'createdAt' | 'newsletterType' | 'subject'>
    & { sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id' | 'name'>
    )>, stats: (
      { __typename?: 'NewsletterStats' }
      & Pick<NewsletterStats, 'sent' | 'opened' | 'clicked' | 'bounced' | 'spam' | 'unsub' | 'openRate' | 'clickRate'>
    ) }
  )>, newsletterHourlyStats: Array<(
    { __typename?: 'NewsletterHourlyStat' }
    & Pick<NewsletterHourlyStat, 'hour' | 'sent' | 'opened' | 'clicked'>
  )> }
);

export type UpdateUserOnBoardingMutationVariables = Exact<{
  userId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type UpdateUserOnBoardingMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName'>
  )> }
);

export type CreateAccountMutationVariables = Exact<{
  attributes: CreateAccountInput;
}>;


export type CreateAccountMutation = (
  { __typename?: 'Mutation' }
  & { createAccount?: Maybe<(
    { __typename?: 'CreateAccountMutationPayload' }
    & { account?: Maybe<(
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName' | 'email'>
      & { accountable: (
        { __typename: 'Buyer' }
        & Pick<Buyer, 'id'>
      ) | (
        { __typename: 'Expert' }
        & Pick<Expert, 'id'>
      ) | (
        { __typename: 'Vendor' }
        & Pick<Vendor, 'id'>
      ) | (
        { __typename: 'Writer' }
        & Pick<Writer, 'id'>
      ) }
    )> }
  )> }
);

export type PickupRequestContextQueryVariables = Exact<{ [key: string]: never; }>;


export type PickupRequestContextQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { accounts: (
      { __typename?: 'AccountConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'AccountEdge' }
        & { node?: Maybe<(
          { __typename?: 'Account' }
          & Pick<Account, 'id'>
          & { accountable: { __typename?: 'Buyer' } | { __typename?: 'Expert' } | (
            { __typename?: 'Vendor' }
            & Pick<Vendor, 'id' | 'shippingOptions'>
            & VendorDefaultAddressesFragment
          ) | { __typename?: 'Writer' } }
        )> }
      )>>> }
    ) }
  )>, availablePickupLabels: (
    { __typename?: 'LabelConnection' }
    & Pick<LabelConnection, 'totalCount'>
  ) }
);

export type CreateStripeAccountSessionMutationVariables = Exact<{
  input: CreateStripeAccountSessionMutationInput;
}>;


export type CreateStripeAccountSessionMutation = (
  { __typename?: 'Mutation' }
  & { createStripeAccountSession?: Maybe<(
    { __typename?: 'CreateStripeAccountSessionMutationPayload' }
    & Pick<CreateStripeAccountSessionMutationPayload, 'clientSecret' | 'errors'>
  )> }
);

export type BusinessIntroducersQueryVariables = Exact<{
  where?: Maybe<BusinessIntroducerFilter>;
  first?: Maybe<Scalars['Int']>;
}>;


export type BusinessIntroducersQuery = (
  { __typename?: 'Query' }
  & { businessIntroducers: (
    { __typename?: 'BusinessIntroducerConnection' }
    & BusinessIntroducerEdgesFragment
  ) }
);

export type BusinessIntroducerEdgesFragment = (
  { __typename?: 'BusinessIntroducerConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'BusinessIntroducerEdge' }
    & BusinessIntroducerNodeFragment
  )>>> }
);

export type BusinessIntroducerNodeFragment = (
  { __typename?: 'BusinessIntroducerEdge' }
  & { node?: Maybe<(
    { __typename?: 'BusinessIntroducer' }
    & Pick<BusinessIntroducer, 'id'>
    & BusinessIntroducerFragment
  )> }
);

export type BusinessIntroducerFragment = (
  { __typename?: 'BusinessIntroducer' }
  & Pick<BusinessIntroducer, 'id' | 'firstName' | 'lastName' | 'email' | 'phone'>
  & { rib?: Maybe<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>, identityDocument?: Maybe<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )> }
);

export type CreateBusinessIntroducerMutationVariables = Exact<{
  input: CreateBusinessIntroducerMutationInput;
}>;


export type CreateBusinessIntroducerMutation = (
  { __typename?: 'Mutation' }
  & { createBusinessIntroducer?: Maybe<(
    { __typename?: 'CreateBusinessIntroducerMutationPayload' }
    & { businessIntroducer?: Maybe<(
      { __typename?: 'BusinessIntroducer' }
      & BusinessIntroducerFragment
    )> }
  )> }
);

export type UpdateBusinessIntroducerMutationVariables = Exact<{
  input: UpdateBusinessIntroducerMutationInput;
}>;


export type UpdateBusinessIntroducerMutation = (
  { __typename?: 'Mutation' }
  & { updateBusinessIntroducer?: Maybe<(
    { __typename?: 'UpdateBusinessIntroducerMutationPayload' }
    & { businessIntroducer?: Maybe<(
      { __typename?: 'BusinessIntroducer' }
      & BusinessIntroducerFragment
    )> }
  )> }
);

export type ThirdPartyIntroducersQueryVariables = Exact<{
  where?: Maybe<ThirdPartyIntroducerFilter>;
  first?: Maybe<Scalars['Int']>;
}>;


export type ThirdPartyIntroducersQuery = (
  { __typename?: 'Query' }
  & { thirdPartyIntroducers: (
    { __typename?: 'ThirdPartyIntroducerConnection' }
    & Pick<ThirdPartyIntroducerConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
    & ThirdPartyIntroducerEdgesFragment
  ) }
);

export type ThirdPartyIntroducerEdgesFragment = (
  { __typename?: 'ThirdPartyIntroducerConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'ThirdPartyIntroducerEdge' }
    & ThirdPartyIntroducerNodeFragment
  )>>> }
);

export type ThirdPartyIntroducerNodeFragment = (
  { __typename?: 'ThirdPartyIntroducerEdge' }
  & { node?: Maybe<(
    { __typename?: 'ThirdPartyIntroducer' }
    & Pick<ThirdPartyIntroducer, 'id'>
    & ThirdPartyIntroducerFragment
  )> }
);

export type ThirdPartyIntroducerFragment = (
  { __typename?: 'ThirdPartyIntroducer' }
  & Pick<ThirdPartyIntroducer, 'id' | 'firstName' | 'lastName' | 'email'>
  & { rib?: Maybe<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )>, identityDocument?: Maybe<(
    { __typename?: 'CustomFile' }
    & FileFragment
  )> }
);

export type ProjectIntroducerPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectIntroducerPaymentQuery = (
  { __typename?: 'Query' }
  & { projectIntroducerPayment?: Maybe<(
    { __typename?: 'ProjectIntroducerPayment' }
    & Pick<ProjectIntroducerPayment, 'id' | 'startAt' | 'endAt' | 'paid' | 'lockedAt' | 'createdAt' | 'updatedAt' | 'payableId' | 'payableType' | 'payableName'>
    & { sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id' | 'name'>
    )>, invoices?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & Pick<CustomFile, 'filename' | 'imageUrl'>
    )>>, projectIntroducerPaymentLines?: Maybe<(
      { __typename?: 'ProjectIntroducerPaymentLineConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'ProjectIntroducerPaymentLineEdge' }
        & { node?: Maybe<(
          { __typename?: 'ProjectIntroducerPaymentLine' }
          & Pick<ProjectIntroducerPaymentLine, 'id' | 'amount' | 'createdAt' | 'updatedAt'>
          & { orderItems?: Maybe<(
            { __typename?: 'OrderItemConnection' }
            & { edges?: Maybe<Array<Maybe<(
              { __typename?: 'OrderItemEdge' }
              & { node?: Maybe<(
                { __typename?: 'OrderItem' }
                & Pick<OrderItem, 'id' | 'totalPrice'>
                & { order?: Maybe<(
                  { __typename?: 'Order' }
                  & Pick<Order, 'id'>
                  & { sale?: Maybe<(
                    { __typename?: 'Sale' }
                    & Pick<Sale, 'id' | 'name'>
                  )> }
                )> }
              )> }
            )>>> }
          )> }
        )> }
      )>>> }
    )>, orderItems?: Maybe<(
      { __typename?: 'OrderItemConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'OrderItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'OrderItem' }
          & Pick<OrderItem, 'id' | 'totalPrice'>
          & { order?: Maybe<(
            { __typename?: 'Order' }
            & Pick<Order, 'id'>
            & { sale?: Maybe<(
              { __typename?: 'Sale' }
              & Pick<Sale, 'id' | 'name'>
            )> }
          )> }
        )> }
      )>>> }
    )> }
  )> }
);

export type ProjectIntroducerPaymentsQueryVariables = Exact<{
  where?: Maybe<ProjectIntroducerPaymentFilter>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type ProjectIntroducerPaymentsQuery = (
  { __typename?: 'Query' }
  & { projectIntroducerPayments: (
    { __typename?: 'ProjectIntroducerPaymentConnection' }
    & Pick<ProjectIntroducerPaymentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), edges?: Maybe<Array<Maybe<(
      { __typename?: 'ProjectIntroducerPaymentEdge' }
      & Pick<ProjectIntroducerPaymentEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'ProjectIntroducerPayment' }
        & Pick<ProjectIntroducerPayment, 'id' | 'startAt' | 'endAt' | 'paid' | 'lockedAt' | 'createdAt' | 'updatedAt' | 'payableId' | 'payableType' | 'payableName'>
        & { invoices?: Maybe<Array<(
          { __typename?: 'CustomFile' }
          & Pick<CustomFile, 'filename' | 'imageUrl'>
        )>>, sale?: Maybe<(
          { __typename?: 'Sale' }
          & Pick<Sale, 'id' | 'name'>
        )>, projectIntroducerPaymentLines?: Maybe<(
          { __typename?: 'ProjectIntroducerPaymentLineConnection' }
          & { edges?: Maybe<Array<Maybe<(
            { __typename?: 'ProjectIntroducerPaymentLineEdge' }
            & { node?: Maybe<(
              { __typename?: 'ProjectIntroducerPaymentLine' }
              & Pick<ProjectIntroducerPaymentLine, 'id' | 'amount' | 'createdAt' | 'updatedAt'>
            )> }
          )>>> }
        )> }
      )> }
    )>>> }
  ) }
);

export type UpdateProjectIntroducerPaymentMutationVariables = Exact<{
  input: UpdateProjectIntroducerPaymentMutationInput;
}>;


export type UpdateProjectIntroducerPaymentMutation = (
  { __typename?: 'Mutation' }
  & { updateProjectIntroducerPayment?: Maybe<(
    { __typename?: 'UpdateProjectIntroducerPaymentMutationPayload' }
    & { projectIntroducerPayment?: Maybe<(
      { __typename?: 'ProjectIntroducerPayment' }
      & Pick<ProjectIntroducerPayment, 'id' | 'paid'>
      & { invoices?: Maybe<Array<(
        { __typename?: 'CustomFile' }
        & Pick<CustomFile, 'filename' | 'imageUrl'>
      )>> }
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'details' | 'fullMessages'>
    )> }
  )> }
);

export type BulkMarkProjectIntroducerPaymentsAsPaidMutationVariables = Exact<{
  input: BulkMarkProjectIntroducerPaymentsAsPaidInput;
}>;


export type BulkMarkProjectIntroducerPaymentsAsPaidMutation = (
  { __typename?: 'Mutation' }
  & { bulkMarkProjectIntroducerPaymentsAsPaid?: Maybe<(
    { __typename?: 'BulkMarkProjectIntroducerPaymentsAsPaidPayload' }
    & Pick<BulkMarkProjectIntroducerPaymentsAsPaidPayload, 'updatedCount' | 'errors'>
  )> }
);

export type ProjectPaymentListQueryVariables = Exact<{
  vendorId?: Maybe<Scalars['ID']>;
  onlyDue?: Maybe<Scalars['Boolean']>;
}>;


export type ProjectPaymentListQuery = (
  { __typename?: 'Query' }
  & { projectPayments: Array<(
    { __typename?: 'ProjectPaymentSummary' }
    & Pick<ProjectPaymentSummary, 'salesCount' | 'soldAmountHt' | 'transferredAmountHt' | 'generatedAmountHt' | 'toPayAmountHt' | 'dueAmountHt' | 'inProgressAmountHt' | 'awaitingBuyerAmountHt'>
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'id' | 'title'>
      & { vendor?: Maybe<(
        { __typename?: 'Vendor' }
        & VendorSelectFieldFragment
      )> }
    )> }
  )> }
);

export type ProjectPaymentAmountsFragment = (
  { __typename?: 'ProjectPaymentSummary' }
  & Pick<ProjectPaymentSummary, 'soldCount' | 'soldAmountHt' | 'transferredCount' | 'transferredAmountHt' | 'generatedCount' | 'generatedAmountHt' | 'toPayCount' | 'toPayAmountHt' | 'inProgressCount' | 'inProgressAmountHt' | 'dueCount' | 'dueAmountHt' | 'awaitingBuyerCount' | 'awaitingBuyerAmountHt' | 'unpaidByBuyerCount' | 'unpaidByBuyerAmountHt' | 'svvCount' | 'svvAmountHt'>
);

export type ProjectPaymentSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectPaymentSummaryQuery = (
  { __typename?: 'Query' }
  & { project?: Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'id'>
    & { paymentSummary?: Maybe<(
      { __typename?: 'ProjectPaymentSummary' }
      & { sales?: Maybe<Array<(
        { __typename?: 'ProjectSalePaymentSummary' }
        & Pick<ProjectSalePaymentSummary, 'soldCount' | 'soldAmountHt' | 'transferredAmountHt' | 'generatedAmountHt' | 'toPayAmountHt' | 'inProgressAmountHt' | 'dueAmountHt' | 'awaitingBuyerAmountHt' | 'unpaidByBuyerAmountHt' | 'svvAmountHt'>
        & { sale?: Maybe<(
          { __typename?: 'Sale' }
          & Pick<Sale, 'id' | 'name' | 'startAt'>
        )>, vendorPayments: Array<(
          { __typename?: 'MonthlyVendorPayment' }
          & Pick<MonthlyVendorPayment, 'id' | 'paid' | 'netAmount'>
        )> }
      )>> }
      & ProjectPaymentAmountsFragment
    )> }
  )> }
);

export type ProjectPaymentSaleItemsQueryVariables = Exact<{
  id: Scalars['ID'];
  saleId: Scalars['ID'];
}>;


export type ProjectPaymentSaleItemsQuery = (
  { __typename?: 'Query' }
  & { project?: Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'id'>
    & { paymentSaleItems: Array<(
      { __typename?: 'ProjectSaleItem' }
      & Pick<ProjectSaleItem, 'id' | 'bucket' | 'hammerPrice' | 'orderId' | 'orderRef' | 'orderState' | 'shippingPriceTaxIncluded' | 'insurancePriceTaxIncluded' | 'buyerFeeTaxIncluded' | 'commissionTtc' | 'fixedFeesTtc' | 'netAmount' | 'vendorPaymentId' | 'vendorPaymentPaid'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'title' | 'sku'>
        & { firstImage?: Maybe<(
          { __typename?: 'Image' }
          & Pick<Image, 'id' | 'imageUrl'>
        )> }
      ) }
    )> }
  )> }
);

export type BulkRemoveReturnedItemsMutationVariables = Exact<{
  itemIds: Array<Scalars['ID']>;
}>;


export type BulkRemoveReturnedItemsMutation = (
  { __typename?: 'Mutation' }
  & { bulkRemoveReturnedItems?: Maybe<(
    { __typename?: 'BulkRemoveReturnedItemsMutationPayload' }
    & Pick<BulkRemoveReturnedItemsMutationPayload, 'success' | 'errors' | 'message'>
  )> }
);

export type SalePlannedItemsQueryVariables = Exact<{
  saleId: Scalars['ID'];
}>;


export type SalePlannedItemsQuery = (
  { __typename?: 'Query' }
  & { sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name' | 'typeOfSale' | 'pendingPlannedItemsCount' | 'readyForExport'>
  )>, items: (
    { __typename?: 'ItemConnection' }
    & Pick<ItemConnection, 'totalCount'>
  ) }
);

export type ValidateSaleItemsMutationVariables = Exact<{
  input: ValidateSaleItemsMutationInput;
}>;


export type ValidateSaleItemsMutation = (
  { __typename?: 'Mutation' }
  & { validateSaleItems?: Maybe<(
    { __typename?: 'ValidateSaleItemsMutationPayload' }
    & Pick<ValidateSaleItemsMutationPayload, 'validatedCount' | 'errors'>
    & { blockingItems: Array<(
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'sku' | 'title' | 'state'>
    )>, sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id' | 'pendingPlannedItemsCount' | 'readyForExport'>
    )> }
  )> }
);

export type SaleReadyForExportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SaleReadyForExportQuery = (
  { __typename?: 'Query' }
  & { sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'typeOfSale' | 'readyForExport'>
  )> }
);

export type SignUpMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  role: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
}>;


export type SignUpMutation = (
  { __typename?: 'Mutation' }
  & { customSignUp?: Maybe<(
    { __typename?: 'CustomSignUpPayload' }
    & Pick<CustomSignUpPayload, 'sessionToken' | 'success'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email' | 'firstName' | 'lastName'>
      & { accounts: (
        { __typename?: 'AccountConnection' }
        & { edges?: Maybe<Array<Maybe<(
          { __typename?: 'AccountEdge' }
          & { node?: Maybe<(
            { __typename?: 'Account' }
            & Pick<Account, 'id'>
            & { accountable: { __typename: 'Buyer' } | (
              { __typename: 'Expert' }
              & Pick<Expert, 'id'>
            ) | (
              { __typename: 'Vendor' }
              & Pick<Vendor, 'id'>
            ) | { __typename: 'Writer' } }
          )> }
        )>>> }
      ) }
    )> }
  )> }
);

export type SingleItemFormCategoryFragment = (
  { __typename?: 'ItemCategory' }
  & Pick<ItemCategory, 'id' | 'name' | 'templateType' | 'archived' | 'aiGenerationAvailable' | 'minImages' | 'maxImages'>
);

export type SingleItemFormSubCategoryFragment = (
  { __typename?: 'ItemSubCategory' }
  & Pick<ItemSubCategory, 'id' | 'name' | 'archived'>
);

export type SingleItemFormArtistFragment = (
  { __typename?: 'Artist' }
  & Pick<Artist, 'id' | 'firstName' | 'lastName' | 'tag' | 'itemCategoryId'>
);

export type SingleItemFormStepFragment = (
  { __typename?: 'ItemStep' }
  & Pick<ItemStep, 'id' | 'number' | 'name' | 'comment' | 'state'>
);

export type SingleItemFormImageFragment = (
  { __typename?: 'Image' }
  & Pick<Image, 'id' | 'imageUrl' | 'position' | 'rotation'>
);

export type SingleItemFormDocumentFragment = (
  { __typename?: 'CustomFile' }
  & Pick<CustomFile, 'imageUrl' | 'filename' | 'extension' | 'blobId'>
);

export type SingleItemFormItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SingleItemFormItemQuery = (
  { __typename?: 'Query' }
  & { item?: Maybe<(
    { __typename?: 'Item' }
    & Pick<Item, 'id' | 'title' | 'saleTitle' | 'subtitle' | 'autoDescription' | 'descriptionHeader' | 'description' | 'descriptionFooter' | 'descriptionSuggestion' | 'descriptionSuggestionGeneratedAt' | 'generationStatus' | 'customDescription' | 'customDescriptionEnabled' | 'state' | 'mode' | 'customSkuPart' | 'sku' | 'lowEstimatedPrice' | 'highEstimatedPrice' | 'startingPrice' | 'reservedPrice' | 'unitCount' | 'weight' | 'length' | 'width' | 'height' | 'otherComment' | 'conditionAccepted' | 'artistUnknown' | 'artistCollectif' | 'artistKnownButNotMentioned' | 'globalComment'>
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'id' | 'title'>
    )>, template: { __typename: 'Book' } | { __typename: 'CarpetTextile' } | { __typename: 'Ceramic' } | { __typename: 'CoinsMedalsStamps' } | { __typename: 'Engraving' } | { __typename: 'FashionLuxuryAccessory' } | { __typename: 'Furniture' } | { __typename: 'GeographicMap' } | { __typename: 'Jewelry' } | { __typename: 'Manuscript' } | { __typename: 'Militaria' } | { __typename: 'PaintingSculpture' } | { __typename: 'Photography' } | { __typename: 'SilverwareTableware' } | { __typename: 'ToyComicPopCulture' } | { __typename: 'Watch' }, itemCategory?: Maybe<(
      { __typename?: 'ItemCategory' }
      & SingleItemFormCategoryFragment
    )>, itemSubCategory?: Maybe<(
      { __typename?: 'ItemSubCategory' }
      & SingleItemFormSubCategoryFragment
    )>, artists?: Maybe<(
      { __typename?: 'ArtistConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'ArtistEdge' }
        & { node?: Maybe<(
          { __typename?: 'Artist' }
          & SingleItemFormArtistFragment
        )> }
      )>>> }
    )>, itemSteps?: Maybe<(
      { __typename?: 'ItemStepConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'ItemStepEdge' }
        & { node?: Maybe<(
          { __typename?: 'ItemStep' }
          & SingleItemFormStepFragment
        )> }
      )>>> }
    )>, images?: Maybe<Array<(
      { __typename?: 'Image' }
      & SingleItemFormImageFragment
    )>>, invoices?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & SingleItemFormDocumentFragment
    )>>, authenticityDocuments?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & SingleItemFormDocumentFragment
    )>>, vacation?: Maybe<(
      { __typename?: 'Vacation' }
      & Pick<Vacation, 'id' | 'name'>
    )>, tags?: Maybe<(
      { __typename?: 'TagConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'TagEdge' }
        & { node?: Maybe<(
          { __typename?: 'Tag' }
          & Pick<Tag, 'id' | 'name'>
        )> }
      )>>> }
    )>, autoTags?: Maybe<(
      { __typename?: 'TagConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'TagEdge' }
        & { node?: Maybe<(
          { __typename?: 'Tag' }
          & Pick<Tag, 'id' | 'name'>
        )> }
      )>>> }
    )>, orderItem?: Maybe<(
      { __typename?: 'OrderItem' }
      & Pick<OrderItem, 'id' | 'state' | 'totalPrice'>
      & { order?: Maybe<(
        { __typename?: 'Order' }
        & Pick<Order, 'id' | 'state' | 'totalPrice' | 'totalPriceTaxIncluded' | 'trackingNumbers'>
        & { buyer?: Maybe<(
          { __typename?: 'Buyer' }
          & { account: (
            { __typename?: 'Account' }
            & Pick<Account, 'firstName' | 'lastName' | 'email'>
          ) }
        )> }
      )> }
    )> }
  )> }
);

export type ItemAiSuggestionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ItemAiSuggestionQuery = (
  { __typename?: 'Query' }
  & { item?: Maybe<(
    { __typename?: 'Item' }
    & Pick<Item, 'id' | 'descriptionSuggestion' | 'descriptionSuggestionGeneratedAt' | 'generationStatus'>
  )> }
);

export type SingleItemFormHeaderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SingleItemFormHeaderQuery = (
  { __typename?: 'Query' }
  & { item?: Maybe<(
    { __typename?: 'Item' }
    & Pick<Item, 'id' | 'sku' | 'state' | 'saleTitle' | 'title' | 'createdAt'>
    & { sale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id' | 'name'>
    )>, plannedSale?: Maybe<(
      { __typename?: 'Sale' }
      & Pick<Sale, 'id' | 'name'>
    )>, expert?: Maybe<(
      { __typename?: 'Expert' }
      & ItemExpertFragment
    )>, vendor?: Maybe<(
      { __typename?: 'Vendor' }
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'firstName' | 'lastName'>
      ) }
    )>, writer?: Maybe<(
      { __typename?: 'Writer' }
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'firstName' | 'lastName'>
      ) }
    )> }
  )> }
);

export type StripeBalanceSnapshotQueryVariables = Exact<{ [key: string]: never; }>;


export type StripeBalanceSnapshotQuery = (
  { __typename?: 'Query' }
  & { stripeBalanceSnapshot: (
    { __typename?: 'StripeBalanceSnapshot' }
    & Pick<StripeBalanceSnapshot, 'theoreticalBalance' | 'belongsToVendors' | 'belongsToDodecade' | 'actualStripeBalance' | 'discrepancy' | 'openDisputesCount' | 'openDisputesAmount'>
  ) }
);

export type BulkRelistItemsMutationVariables = Exact<{
  itemIds: Array<Scalars['ID']>;
  saleId?: Maybe<Scalars['ID']>;
  forceLibraryFund?: Maybe<Scalars['Boolean']>;
}>;


export type BulkRelistItemsMutation = (
  { __typename?: 'Mutation' }
  & { bulkRelistItems?: Maybe<(
    { __typename?: 'BulkRelistItemsMutationPayload' }
    & Pick<BulkRelistItemsMutationPayload, 'success' | 'errors' | 'message'>
  )> }
);

export type BulkReturnItemsMutationVariables = Exact<{
  itemIds: Array<Scalars['ID']>;
}>;


export type BulkReturnItemsMutation = (
  { __typename?: 'Mutation' }
  & { bulkReturnItems?: Maybe<(
    { __typename?: 'BulkReturnItemsMutationPayload' }
    & Pick<BulkReturnItemsMutationPayload, 'success' | 'errors' | 'returnSlipId' | 'message'>
  )> }
);

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  resetPasswordToken: Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword?: Maybe<(
    { __typename?: 'ResetPasswordPayload' }
    & Pick<ResetPasswordPayload, 'success'>
    & { errors: Array<(
      { __typename?: 'Error' }
      & Pick<Error, 'details' | 'message'>
    )> }
  )> }
);

export type GenerateVendorAccountingExportMutationVariables = Exact<{
  input: GenerateVendorAccountingExportMutationInput;
}>;


export type GenerateVendorAccountingExportMutation = (
  { __typename?: 'Mutation' }
  & { generateVendorAccountingExport?: Maybe<(
    { __typename?: 'GenerateVendorAccountingExportPayload' }
    & Pick<GenerateVendorAccountingExportPayload, 'message' | 'errors'>
  )> }
);

export type VendorDashboardItemsStatsQueryVariables = Exact<{
  vendorId: Scalars['ID'];
}>;


export type VendorDashboardItemsStatsQuery = (
  { __typename?: 'Query' }
  & { itemsStats: (
    { __typename?: 'ItemsStats' }
    & Pick<ItemsStats, 'onSale' | 'sold' | 'unsold' | 'unpaid' | 'requiringVendorAction'>
  ) }
);

export type VendorDashboardQueryVariables = Exact<{
  vendorId: Scalars['ID'];
}>;


export type VendorDashboardQuery = (
  { __typename?: 'Query' }
  & { vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id' | 'ordersToShipCount' | 'ordersToPickupCount' | 'lateOrders3DaysCount' | 'lateOrders5DaysCount'>
    & { vendorFinancialStats: (
      { __typename?: 'VendorFinancialStats' }
      & Pick<VendorFinancialStats, 'currentMonthNetAmount' | 'lastMonthNetAmount' | 'pendingPaymentAmount' | 'pendingPaymentCount' | 'totalEarnedAllTime' | 'ordersThisMonthCount' | 'ordersThisMonthPickupCount' | 'ordersThisMonthShippingCount'>
    ) }
  )> }
);

export type GetVendorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetVendorQuery = (
  { __typename?: 'Query' }
  & { vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'id' | 'kind'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'state'>
      & { ribDocuments?: Maybe<Array<(
        { __typename?: 'CustomFile' }
        & Pick<CustomFile, 'filename' | 'imageUrl'>
      )>>, identityDocuments?: Maybe<Array<(
        { __typename?: 'CustomFile' }
        & Pick<CustomFile, 'filename' | 'imageUrl'>
      )>> }
    ) }
  )> }
);

export type VendorLatePickupsViewQueryVariables = Exact<{
  vendorId: Scalars['ID'];
}>;


export type VendorLatePickupsViewQuery = (
  { __typename?: 'Query' }
  & { vendorLatePickups?: Maybe<(
    { __typename?: 'VendorLatePickups' }
    & Pick<VendorLatePickups, 'vendorId'>
    & { latePickupItems3Days: Array<(
      { __typename?: 'OrderItem' }
      & Pick<OrderItem, 'id' | 'state'>
      & { order?: Maybe<(
        { __typename?: 'Order' }
        & Pick<Order, 'id' | 'dodecadeOrderRef' | 'paidAt' | 'totalPrice' | 'carrierName'>
      )> }
    )>, latePickupItems5Days: Array<(
      { __typename?: 'OrderItem' }
      & Pick<OrderItem, 'id' | 'state'>
      & { order?: Maybe<(
        { __typename?: 'Order' }
        & Pick<Order, 'id' | 'dodecadeOrderRef' | 'paidAt' | 'totalPrice' | 'carrierName'>
      )> }
    )> }
  )> }
);

export type MonthlyVendorPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MonthlyVendorPaymentQuery = (
  { __typename?: 'Query' }
  & { monthlyVendorPayment?: Maybe<(
    { __typename?: 'MonthlyVendorPayment' }
    & { paymentStats?: Maybe<(
      { __typename?: 'VendorPaymentStats' }
      & Pick<VendorPaymentStats, 'saleTotalSoldAmountHt' | 'saleTotalSoldCount' | 'previouslyPaidAmountHt' | 'previouslyPaidCount' | 'previousPaymentsCount' | 'currentPaymentAmountHt' | 'currentPaymentCount' | 'currentPaymentFeesTtc' | 'currentPaymentNetTtc' | 'remainingToPayAmountHt' | 'remainingToPayCount' | 'isSaleFullyPaid' | 'percentagePaidAfter'>
    )>, vendor?: Maybe<(
      { __typename?: 'Vendor' }
      & { account: (
        { __typename?: 'Account' }
        & { bankInformation?: Maybe<(
          { __typename?: 'BankInformation' }
          & Pick<BankInformation, 'iban' | 'bic'>
        )> }
        & VendorAccountFragment
      ) }
      & VendorFragment
    )> }
    & MonthlyVendorPaymentFragment
  )> }
);

export type MonthlyVendorPaymentFragment = (
  { __typename?: 'MonthlyVendorPayment' }
  & Pick<MonthlyVendorPayment, 'id' | 'lockedAt' | 'totalSales' | 'totalFees' | 'netAmount' | 'paid' | 'createdAt' | 'startAt' | 'endAt' | 'stripeTransferId' | 'stripeTransferStatus' | 'stripeTransferError' | 'stripeTransferMode' | 'stripeTransferredAt' | 'disputed' | 'disputeAmount'>
  & { vendor?: Maybe<(
    { __typename?: 'Vendor' }
    & Pick<Vendor, 'stripeConnectAccountId'>
    & VendorFragment
  )>, vendorStatements?: Maybe<(
    { __typename?: 'VendorStatementConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'VendorStatementEdge' }
      & { node?: Maybe<(
        { __typename?: 'VendorStatement' }
        & Pick<VendorStatement, 'id' | 'number'>
        & { document?: Maybe<(
          { __typename?: 'CustomFile' }
          & Pick<CustomFile, 'imageUrl' | 'filename'>
        )> }
      )> }
    )>>> }
  )>, vendorStatementPayment?: Maybe<(
    { __typename?: 'VendorStatementPayment' }
    & Pick<VendorStatementPayment, 'id'>
  )>, orderItems?: Maybe<(
    { __typename?: 'OrderItemConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'OrderItemEdge' }
      & { node?: Maybe<(
        { __typename?: 'OrderItem' }
        & Pick<OrderItem, 'id' | 'totalPrice'>
        & { order?: Maybe<(
          { __typename?: 'Order' }
          & Pick<Order, 'id'>
          & { sale?: Maybe<(
            { __typename?: 'Sale' }
            & Pick<Sale, 'id' | 'name'>
          )> }
        )> }
      )> }
    )>>> }
  )>, invoices?: Maybe<Array<(
    { __typename?: 'CustomFile' }
    & Pick<CustomFile, 'imageUrl' | 'filename'>
  )>>, sale?: Maybe<(
    { __typename?: 'Sale' }
    & Pick<Sale, 'id' | 'name'>
  )>, vendorPaymentLines?: Maybe<(
    { __typename?: 'VendorPaymentLineConnection' }
    & VendorPaymentLineEdgesFragment
  )>, vendorPaymentFees?: Maybe<(
    { __typename?: 'VendorPaymentFeeConnection' }
    & VendorPaymentFeeEdgesFragment
  )> }
);

export type VendorPaymentFeeEdgesFragment = (
  { __typename?: 'VendorPaymentFeeConnection' }
  & { edges?: Maybe<Array<Maybe<(
    { __typename?: 'VendorPaymentFeeEdge' }
    & VendorPaymentFeeNodeFragment
  )>>> }
);

export type VendorPaymentFeeNodeFragment = (
  { __typename?: 'VendorPaymentFeeEdge' }
  & { node?: Maybe<(
    { __typename?: 'VendorPaymentFee' }
    & VendorPaymentFeeFragment
  )> }
);

export type VendorPaymentFeeFragment = (
  { __typename?: 'VendorPaymentFee' }
  & Pick<VendorPaymentFee, 'id' | 'feeType' | 'feePercentageHt' | 'feePercentageTtc' | 'feeAmountHt' | 'feeTva' | 'feeTvaRate' | 'feeAmountTtc' | 'itemsCount' | 'fixedFeePerItem'>
);

export type UpdateMonthlyVendorPaymentMutationVariables = Exact<{
  input: UpdateMonthlyVendorPaymentMutationInput;
}>;


export type UpdateMonthlyVendorPaymentMutation = (
  { __typename?: 'Mutation' }
  & { updateMonthlyVendorPayment?: Maybe<(
    { __typename?: 'UpdateMonthlyVendorPaymentMutationPayload' }
    & { monthlyVendorPayment?: Maybe<(
      { __typename?: 'MonthlyVendorPayment' }
      & Pick<MonthlyVendorPayment, 'id'>
    )> }
  )> }
);

export type TriggerStripeTransferMutationVariables = Exact<{
  input: TriggerStripeTransferMutationInput;
}>;


export type TriggerStripeTransferMutation = (
  { __typename?: 'Mutation' }
  & { triggerStripeTransfer?: Maybe<(
    { __typename?: 'TriggerStripeTransferMutationPayload' }
    & Pick<TriggerStripeTransferMutationPayload, 'errors'>
    & { vendorStatementPayment?: Maybe<(
      { __typename?: 'VendorStatementPayment' }
      & Pick<VendorStatementPayment, 'id' | 'stripeTransferId' | 'stripeTransferStatus' | 'stripeTransferError' | 'stripeTransferredAt'>
    )> }
  )> }
);

export type VendorPaymentListQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorPaymentListQuery = (
  { __typename?: 'Query' }
  & { unpaidVendorPayments: (
    { __typename?: 'MonthlyVendorPaymentConnection' }
    & Pick<MonthlyVendorPaymentConnection, 'totalCount'>
  ), unpaidVendorStatementPayments: (
    { __typename?: 'VendorStatementPaymentConnection' }
    & Pick<VendorStatementPaymentConnection, 'totalCount'>
  ), allVendorPayments: (
    { __typename?: 'MonthlyVendorPaymentConnection' }
    & Pick<MonthlyVendorPaymentConnection, 'totalCount'>
  ) }
);

export type VendorPickupWaitingQueryVariables = Exact<{
  vendorId: Scalars['ID'];
}>;


export type VendorPickupWaitingQuery = (
  { __typename?: 'Query' }
  & { pickupWaitingBuyers: Array<(
    { __typename?: 'PickupWaitingBuyer' }
    & Pick<PickupWaitingBuyer, 'buyerId' | 'buyerName' | 'buyerEmail' | 'ordersCount' | 'itemsCount' | 'oldestPaidAt' | 'canRemind' | 'lastReminderAt' | 'nextReminderAvailableAt'>
    & { reminders: Array<(
      { __typename?: 'PickupReminderEntry' }
      & Pick<PickupReminderEntry, 'batchId' | 'kind' | 'ordersCount' | 'sentAt' | 'sentByName'>
    )>, waitingOrderItems: Array<(
      { __typename?: 'OrderItem' }
      & Pick<OrderItem, 'id'>
      & { order?: Maybe<(
        { __typename?: 'Order' }
        & Pick<Order, 'id' | 'dodecadeOrderRef' | 'paidAt'>
      )>, item: (
        { __typename?: 'Item' }
        & Pick<Item, 'title' | 'dodecadeItemRef'>
      ) }
    )> }
  )> }
);

export type SendPickupReminderToBuyerMutationVariables = Exact<{
  input: SendPickupReminderToBuyerMutationInput;
}>;


export type SendPickupReminderToBuyerMutation = (
  { __typename?: 'Mutation' }
  & { sendPickupReminderToBuyer?: Maybe<(
    { __typename?: 'SendPickupReminderToBuyerMutationPayload' }
    & Pick<SendPickupReminderToBuyerMutationPayload, 'success' | 'errors' | 'message'>
  )> }
);

export type VendorRemunerationReportQueryVariables = Exact<{
  month: Scalars['ISO8601Date'];
}>;


export type VendorRemunerationReportQuery = (
  { __typename?: 'Query' }
  & { vendorRemunerationReport: (
    { __typename?: 'VendorRemunerationReport' }
    & { summary: (
      { __typename?: 'VendorRemunerationSummary' }
      & Pick<VendorRemunerationSummary, 'totalCreation' | 'totalCommission' | 'total'>
    ), details: Array<(
      { __typename?: 'VendorRemunerationDetail' }
      & Pick<VendorRemunerationDetail, 'writerId' | 'writerName' | 'fichesCount' | 'perFicheRate' | 'creationAmount' | 'caVentes' | 'taux' | 'commissionAmount' | 'total'>
    )>, dailySeries: Array<(
      { __typename?: 'VendorRemunerationDailyPoint' }
      & Pick<VendorRemunerationDailyPoint, 'date' | 'creationAmount' | 'commissionAmount' | 'total'>
    )> }
  ) }
);

export type VendorStatementPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VendorStatementPaymentQuery = (
  { __typename?: 'Query' }
  & { vendorStatementPayment?: Maybe<(
    { __typename?: 'VendorStatementPayment' }
    & Pick<VendorStatementPayment, 'id' | 'startAt' | 'endAt' | 'paymentDate' | 'paid' | 'totalAmount' | 'totalLinesCount' | 'totalSalesCount' | 'stripeTransferId' | 'stripeTransferStatus' | 'stripeTransferError' | 'stripeTransferredAt' | 'createdAt' | 'updatedAt'>
    & { vendor?: Maybe<(
      { __typename?: 'Vendor' }
      & Pick<Vendor, 'id' | 'stripeConnectAccountId'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'firstName' | 'lastName'>
        & { bankInformation?: Maybe<(
          { __typename?: 'BankInformation' }
          & Pick<BankInformation, 'iban' | 'bic'>
        )> }
      ) }
    )>, vendorStatements?: Maybe<(
      { __typename?: 'VendorStatementConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'VendorStatementEdge' }
        & { node?: Maybe<(
          { __typename?: 'VendorStatement' }
          & Pick<VendorStatement, 'id'>
          & { document?: Maybe<(
            { __typename?: 'CustomFile' }
            & Pick<CustomFile, 'filename' | 'imageUrl'>
          )> }
        )> }
      )>>> }
    )>, monthlyVendorPayments?: Maybe<(
      { __typename?: 'MonthlyVendorPaymentConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'MonthlyVendorPaymentEdge' }
        & { node?: Maybe<(
          { __typename?: 'MonthlyVendorPayment' }
          & Pick<MonthlyVendorPayment, 'id' | 'netAmount' | 'totalSales' | 'totalFees' | 'createdAt'>
          & { sale?: Maybe<(
            { __typename?: 'Sale' }
            & Pick<Sale, 'id' | 'name' | 'endAt'>
          )>, vendorPaymentLines?: Maybe<(
            { __typename?: 'VendorPaymentLineConnection' }
            & { edges?: Maybe<Array<Maybe<(
              { __typename?: 'VendorPaymentLineEdge' }
              & { node?: Maybe<(
                { __typename?: 'VendorPaymentLine' }
                & Pick<VendorPaymentLine, 'amount' | 'feePercentage' | 'feeAmount'>
              )> }
            )>>> }
          )>, orderItems?: Maybe<(
            { __typename?: 'OrderItemConnection' }
            & { edges?: Maybe<Array<Maybe<(
              { __typename?: 'OrderItemEdge' }
              & { node?: Maybe<(
                { __typename?: 'OrderItem' }
                & Pick<OrderItem, 'id' | 'totalPrice' | 'commissionTtc'>
                & { order?: Maybe<(
                  { __typename?: 'Order' }
                  & Pick<Order, 'id' | 'createdAt'>
                )>, item: (
                  { __typename?: 'Item' }
                  & Pick<Item, 'id' | 'title' | 'finalPrice' | 'lowEstimatedPrice' | 'highEstimatedPrice'>
                  & { firstImage?: Maybe<(
                    { __typename?: 'Image' }
                    & Pick<Image, 'imageUrl'>
                  )> }
                ) }
              )> }
            )>>> }
          )> }
        )> }
      )>>> }
    )> }
  )> }
);

export type UpdateVendorStatementPaymentMutationVariables = Exact<{
  input: UpdateVendorStatementPaymentMutationInput;
}>;


export type UpdateVendorStatementPaymentMutation = (
  { __typename?: 'Mutation' }
  & { updateVendorStatementPayment?: Maybe<(
    { __typename?: 'UpdateVendorStatementPaymentMutationPayload' }
    & { vendorStatementPayment?: Maybe<(
      { __typename?: 'VendorStatementPayment' }
      & Pick<VendorStatementPayment, 'id' | 'paid' | 'paymentDate'>
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type TriggerStripeTransferVspMutationVariables = Exact<{
  input: TriggerStripeTransferMutationInput;
}>;


export type TriggerStripeTransferVspMutation = (
  { __typename?: 'Mutation' }
  & { triggerStripeTransfer?: Maybe<(
    { __typename?: 'TriggerStripeTransferMutationPayload' }
    & Pick<TriggerStripeTransferMutationPayload, 'errors'>
    & { vendorStatementPayment?: Maybe<(
      { __typename?: 'VendorStatementPayment' }
      & Pick<VendorStatementPayment, 'id' | 'stripeTransferId' | 'stripeTransferStatus' | 'stripeTransferError' | 'stripeTransferredAt'>
    )> }
  )> }
);

export type GetVendorsPerfAnalyticsQueryVariables = Exact<{
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
  fromN1: Scalars['ISO8601DateTime'];
  toN1: Scalars['ISO8601DateTime'];
  compareTo: CompareToEnum;
  vendorId?: Maybe<Scalars['ID']>;
  categoryId?: Maybe<Scalars['ID']>;
}>;


export type GetVendorsPerfAnalyticsQuery = (
  { __typename?: 'Query' }
  & { topVendors: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { breakdown?: Maybe<Array<(
        { __typename?: 'BreakdownResult' }
        & Pick<BreakdownResult, 'dimensionId' | 'name' | 'value'>
      )>> }
    )> }
  ), kpis: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
      & { comparison?: Maybe<(
        { __typename?: 'Comparison' }
        & Pick<Comparison, 'previousValue' | 'delta' | 'deltaPercentage'>
      )> }
    )> }
  ), priceDetailByCategory: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { breakdown?: Maybe<Array<(
        { __typename?: 'BreakdownResult' }
        & Pick<BreakdownResult, 'dimensionId' | 'name' | 'value'>
      )>> }
    )> }
  ), saleRate: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { timeSeries?: Maybe<Array<(
        { __typename?: 'TimeSeriesPoint' }
        & Pick<TimeSeriesPoint, 'period' | 'value'>
      )>> }
    )> }
  ), saleRateN1: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { timeSeries?: Maybe<Array<(
        { __typename?: 'TimeSeriesPoint' }
        & Pick<TimeSeriesPoint, 'period' | 'value'>
      )>> }
    )> }
  ) }
);

export type WriterItemsWriterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WriterItemsWriterQuery = (
  { __typename?: 'Query' }
  & { writer?: Maybe<(
    { __typename?: 'Writer' }
    & Pick<Writer, 'id'>
    & { account: (
      { __typename?: 'Account' }
      & Pick<Account, 'id' | 'firstName' | 'lastName'>
    ) }
  )> }
);

export type WriterPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WriterPaymentQuery = (
  { __typename?: 'Query' }
  & { writerPayment?: Maybe<(
    { __typename?: 'WriterPayment' }
    & Pick<WriterPayment, 'id' | 'paid' | 'startAt' | 'endAt'>
    & { orderItems?: Maybe<(
      { __typename?: 'OrderItemConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'OrderItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'OrderItem' }
          & Pick<OrderItem, 'id' | 'totalPrice'>
          & { order?: Maybe<(
            { __typename?: 'Order' }
            & Pick<Order, 'id'>
            & { sale?: Maybe<(
              { __typename?: 'Sale' }
              & Pick<Sale, 'id' | 'name'>
            )> }
          )> }
        )> }
      )>>> }
    )>, writerPaymentLines?: Maybe<(
      { __typename?: 'WriterPaymentLineConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'WriterPaymentLineEdge' }
        & { node?: Maybe<(
          { __typename?: 'WriterPaymentLine' }
          & Pick<WriterPaymentLine, 'id' | 'amount'>
        )> }
      )>>> }
    )>, invoices?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & FileFragment
    )>>, writer?: Maybe<(
      { __typename?: 'Writer' }
      & Pick<Writer, 'id'>
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'id' | 'lastName' | 'firstName'>
        & { bankInformation?: Maybe<(
          { __typename?: 'BankInformation' }
          & Pick<BankInformation, 'iban' | 'bic'>
        )> }
      ) }
    )> }
  )> }
);

export type UpdateWriterStatementPaymentMutationVariables = Exact<{
  input: UpdateWriterStatementPaymentMutationInput;
}>;


export type UpdateWriterStatementPaymentMutation = (
  { __typename?: 'Mutation' }
  & { updateWriterStatementPayment?: Maybe<(
    { __typename?: 'UpdateWriterStatementPaymentMutationPayload' }
    & { writerStatementPayment?: Maybe<(
      { __typename?: 'WriterStatementPayment' }
      & Pick<WriterStatementPayment, 'id' | 'paid' | 'paymentDate'>
    )>, errors?: Maybe<(
      { __typename?: 'ValidationErrors' }
      & Pick<ValidationErrors, 'fullMessages'>
    )> }
  )> }
);

export type UpdateWriterPaymentMutationVariables = Exact<{
  input: UpdateWriterPaymentMutationInput;
}>;


export type UpdateWriterPaymentMutation = (
  { __typename?: 'Mutation' }
  & { updateWriterPayment?: Maybe<(
    { __typename?: 'UpdateWriterPaymentMutationPayload' }
    & { writerPayment?: Maybe<(
      { __typename?: 'WriterPayment' }
      & Pick<WriterPayment, 'id'>
    )> }
  )> }
);

export type WriterPaymentListQueryVariables = Exact<{ [key: string]: never; }>;


export type WriterPaymentListQuery = (
  { __typename?: 'Query' }
  & { unpaidWriterPayments: (
    { __typename?: 'WriterPaymentConnection' }
    & Pick<WriterPaymentConnection, 'totalCount'>
  ), unpaidWriterStatementPayments: (
    { __typename?: 'WriterStatementPaymentConnection' }
    & Pick<WriterStatementPaymentConnection, 'totalCount'>
  ), allWriterPayments: (
    { __typename?: 'WriterPaymentConnection' }
    & Pick<WriterPaymentConnection, 'totalCount'>
  ) }
);

export type WriterStatementPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WriterStatementPaymentQuery = (
  { __typename?: 'Query' }
  & { writerStatementPayment?: Maybe<(
    { __typename?: 'WriterStatementPayment' }
    & Pick<WriterStatementPayment, 'id' | 'totalAmount' | 'totalSalesCount' | 'paid' | 'startAt' | 'endAt'>
    & { writer?: Maybe<(
      { __typename?: 'Writer' }
      & { account: (
        { __typename?: 'Account' }
        & Pick<Account, 'id' | 'lastName' | 'firstName'>
        & { bankInformation?: Maybe<(
          { __typename?: 'BankInformation' }
          & Pick<BankInformation, 'iban' | 'bic'>
        )> }
      ) }
    )>, invoices?: Maybe<Array<(
      { __typename?: 'CustomFile' }
      & FileFragment
    )>>, writerPayments?: Maybe<(
      { __typename?: 'WriterPaymentConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename?: 'WriterPaymentEdge' }
        & { node?: Maybe<(
          { __typename?: 'WriterPayment' }
          & Pick<WriterPayment, 'id'>
          & { sale?: Maybe<(
            { __typename?: 'Sale' }
            & Pick<Sale, 'id' | 'name'>
          )>, orderItems?: Maybe<(
            { __typename?: 'OrderItemConnection' }
            & { edges?: Maybe<Array<Maybe<(
              { __typename?: 'OrderItemEdge' }
              & { node?: Maybe<(
                { __typename?: 'OrderItem' }
                & Pick<OrderItem, 'id' | 'totalPrice'>
                & { item: (
                  { __typename?: 'Item' }
                  & Pick<Item, 'id' | 'title' | 'lowEstimatedPrice' | 'highEstimatedPrice' | 'finalPrice' | 'writerCommission'>
                  & { firstImage?: Maybe<(
                    { __typename?: 'Image' }
                    & Pick<Image, 'imageUrl'>
                  )> }
                ) }
              )> }
            )>>> }
          )>, writerPaymentLines?: Maybe<(
            { __typename?: 'WriterPaymentLineConnection' }
            & { edges?: Maybe<Array<Maybe<(
              { __typename?: 'WriterPaymentLineEdge' }
              & { node?: Maybe<(
                { __typename?: 'WriterPaymentLine' }
                & Pick<WriterPaymentLine, 'id' | 'amount'>
              )> }
            )>>> }
          )> }
        )> }
      )>>> }
    )> }
  )> }
);

export type WriterStatsReportQueryVariables = Exact<{
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
}>;


export type WriterStatsReportQuery = (
  { __typename?: 'Query' }
  & { writerStatsReport: (
    { __typename?: 'WriterStatsReport' }
    & { summary: (
      { __typename?: 'WriterStatsSummary' }
      & Pick<WriterStatsSummary, 'totalCreated' | 'inProgress' | 'sold' | 'unsold' | 'saleRate' | 'totalRevenue' | 'averagePrice'>
    ), rankings: Array<(
      { __typename?: 'WriterStat' }
      & Pick<WriterStat, 'writerId' | 'writerName' | 'writerType' | 'inProgressCount' | 'createdCount' | 'soldCount' | 'saleRate' | 'totalRevenue' | 'revenuePerDay' | 'avgPhotos'>
    )>, dailyProduction: Array<(
      { __typename?: 'WriterDailyPoint' }
      & Pick<WriterDailyPoint, 'date' | 'createdCount' | 'avgPhotos'>
    )>, dailyRevenue: Array<(
      { __typename?: 'WriterDailyPoint' }
      & Pick<WriterDailyPoint, 'date' | 'revenue' | 'soldCount'>
    )> }
  ) }
);

export type WriterWeeklyFollowUpQueryVariables = Exact<{
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
}>;


export type WriterWeeklyFollowUpQuery = (
  { __typename?: 'Query' }
  & { writerWeeklyFollowUp: (
    { __typename?: 'WriterWeeklyFollowUp' }
    & { writers: Array<(
      { __typename?: 'WriterSummary' }
      & Pick<WriterSummary, 'writerId' | 'writerName'>
    )>, dailyProduction: Array<(
      { __typename?: 'WriterWeeklyDailyPoint' }
      & Pick<WriterWeeklyDailyPoint, 'date'>
      & { entries: Array<(
        { __typename?: 'WriterWeeklyFollowUpEntry' }
        & Pick<WriterWeeklyFollowUpEntry, 'writerId' | 'createdCount' | 'draftCount'>
      )> }
    )>, dailyRevenue: Array<(
      { __typename?: 'WriterWeeklyDailyPoint' }
      & Pick<WriterWeeklyDailyPoint, 'date'>
      & { entries: Array<(
        { __typename?: 'WriterWeeklyFollowUpEntry' }
        & Pick<WriterWeeklyFollowUpEntry, 'writerId' | 'revenue'>
      )> }
    )> }
  ) }
);

export type GetWritersPerfAnalyticsQueryVariables = Exact<{
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
  compareTo: CompareToEnum;
  writerId?: Maybe<Scalars['ID']>;
  categoryId?: Maybe<Scalars['ID']>;
}>;


export type GetWritersPerfAnalyticsQuery = (
  { __typename?: 'Query' }
  & { kpis: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name' | 'value'>
      & { comparison?: Maybe<(
        { __typename?: 'Comparison' }
        & Pick<Comparison, 'previousValue' | 'delta' | 'deltaPercentage'>
      )> }
    )> }
  ), byWriters: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { breakdown?: Maybe<Array<(
        { __typename?: 'BreakdownResult' }
        & Pick<BreakdownResult, 'name' | 'dimensionId' | 'value'>
      )>> }
    )> }
  ), volume: (
    { __typename?: 'Analytics' }
    & { metrics: Array<(
      { __typename?: 'MetricResult' }
      & Pick<MetricResult, 'name'>
      & { timeSeries?: Maybe<Array<(
        { __typename?: 'TimeSeriesPoint' }
        & AnalyticsVolumeAndDelayChartCardFragment
      )>> }
    )> }
  ) }
);

export type GetCustomerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCustomerQuery = (
  { __typename?: 'Query' }
  & { customer?: Maybe<(
    { __typename?: 'Customer' }
    & CustomerFragment
  )> }
);

export type CreateCustomerMutationVariables = Exact<{
  attributes: CreateCustomerInput;
}>;


export type CreateCustomerMutation = (
  { __typename?: 'Mutation' }
  & { createCustomer?: Maybe<(
    { __typename?: 'CreateCustomerMutationPayload' }
    & Pick<CreateCustomerMutationPayload, 'clientMutationId'>
    & { customer?: Maybe<(
      { __typename?: 'Customer' }
      & CustomerFragment
    )> }
  )> }
);

export type ItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ItemQuery = (
  { __typename?: 'Query' }
  & { item?: Maybe<(
    { __typename?: 'Item' }
    & Pick<Item, 'id' | 'customDescription' | 'autoDescription' | 'state' | 'mode' | 'customSkuPart' | 'sku'>
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'id'>
    )>, template: { __typename: 'Book' } | { __typename: 'CarpetTextile' } | { __typename: 'Ceramic' } | { __typename: 'CoinsMedalsStamps' } | { __typename: 'Engraving' } | { __typename: 'FashionLuxuryAccessory' } | { __typename: 'Furniture' } | { __typename: 'GeographicMap' } | { __typename: 'Jewelry' } | { __typename: 'Manuscript' } | { __typename: 'Militaria' } | { __typename: 'PaintingSculpture' } | { __typename: 'Photography' } | { __typename: 'SilverwareTableware' } | { __typename: 'ToyComicPopCulture' } | (
      { __typename: 'Watch' }
      & WatchFragment
    ) }
    & ItemStepsFragment
    & ItemImagesFragment
    & ItemCategoryFragment
  )> }
);

export type ItemImagesFragment = (
  { __typename?: 'Item' }
  & { images?: Maybe<Array<(
    { __typename?: 'Image' }
    & ItemImageFragment
  )>> }
);

export type ItemImageFragment = (
  { __typename?: 'Image' }
  & Pick<Image, 'imageUrl' | 'position' | 'rotation'>
);

export type UpdateImageOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  imageIds: Array<Scalars['ID']>;
}>;


export type UpdateImageOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateItem?: Maybe<(
    { __typename?: 'UpdateItemMutationPayload' }
    & Pick<UpdateItemMutationPayload, 'clientMutationId' | 'errors'>
  )> }
);

export type RemoveImagesMutationVariables = Exact<{
  id: Scalars['ID'];
  imageIds: Array<Scalars['ID']>;
}>;


export type RemoveImagesMutation = (
  { __typename?: 'Mutation' }
  & { updateItem?: Maybe<(
    { __typename?: 'UpdateItemMutationPayload' }
    & Pick<UpdateItemMutationPayload, 'clientMutationId' | 'errors'>
  )> }
);

export type StartItemDescriptionGenerationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StartItemDescriptionGenerationMutation = (
  { __typename?: 'Mutation' }
  & { startItemDescriptionGeneration?: Maybe<(
    { __typename?: 'StartItemDescriptionGenerationMutationPayload' }
    & { item: (
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'mode' | 'generationStatus' | 'generationError' | 'descriptionSuggestion' | 'descriptionSuggestionGeneratedAt'>
    ) }
  )> }
);

export type StartItemWatchDescriptionGenerationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StartItemWatchDescriptionGenerationMutation = (
  { __typename?: 'Mutation' }
  & { startItemWatchDescriptionGeneration?: Maybe<(
    { __typename?: 'StartItemWatchDescriptionGenerationMutationPayload' }
    & { item: (
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'mode' | 'generationStatus' | 'generationError' | 'descriptionSuggestion' | 'descriptionSuggestionGeneratedAt'>
    ) }
  )> }
);

export const VendorPlanFragmentDoc = gql`
    fragment VendorPlan on VendorPlan {
  name
  expertiseFirmEnabled
  projectsEnabled
}
    `;
export const AnalyticsRevenueAndMarginChartCardFragmentDoc = gql`
    fragment AnalyticsRevenueAndMarginChartCard on TimeSeriesPoint {
  period
  value
}
    `;
export const AnalyticsVolumeAndDelayChartCardFragmentDoc = gql`
    fragment AnalyticsVolumeAndDelayChartCard on TimeSeriesPoint {
  period
  value
}
    `;
export const BuyerTableFragmentDoc = gql`
    fragment BuyerTable on Buyer {
  id
  createdAt
  account {
    id
    firstName
    lastName
    companyName
    email
    phone
  }
  desiresReviewedAt
  unsubscriptions {
    kind
  }
  stats {
    ordersCount
    totalSpent
    lastOrderAt
    activeDesiresCount
    favoritesCount
    newslettersOpenedCount
    lastOpenedAt
  }
}
    `;
export const CategorySelectFieldFragmentDoc = gql`
    fragment CategorySelectField on ItemCategory {
  id
  name
}
    `;
export const ContactTableFragmentDoc = gql`
    fragment ContactTable on Customer {
  id
  createdAt
  email
  firstName
  lastName
  fullName
  phone1
  emailState
  subscribed
  desiresReviewedAt
  unsubscriptions {
    kind
  }
  stats {
    recordsCount
    newslettersReceivedCount
    lastNewsletterAt
    newslettersOpenedCount
    lastOpenedAt
    activeDesiresCount
    ordersCount
  }
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  id
  name
}
    `;
export const TagNodeFragmentDoc = gql`
    fragment TagNode on TagEdge {
  node {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export const TagEdgesFragmentDoc = gql`
    fragment TagEdges on TagConnection {
  edges {
    ...TagNode
  }
}
    ${TagNodeFragmentDoc}`;
export const CustomerFragmentDoc = gql`
    fragment Customer on Customer {
  id
  lastName
  firstName
  email
  addressLine1
  addressLine2
  addressLine3
  city
  zip
  country
  phone1
  phone2
  itemCategories {
    edges {
      node {
        id
        name
      }
    }
  }
  itemSubCategories {
    edges {
      node {
        id
        name
      }
    }
  }
  desires {
    edges {
      node {
        id
        title
      }
    }
  }
  tags {
    ...TagEdges
  }
}
    ${TagEdgesFragmentDoc}`;
export const CustomerNodeFragmentDoc = gql`
    fragment CustomerNode on CustomerEdge {
  node {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export const CustomerEdgesFragmentDoc = gql`
    fragment CustomerEdges on CustomerConnection {
  edges {
    ...CustomerNode
  }
}
    ${CustomerNodeFragmentDoc}`;
export const ItemSubCategoryFragmentDoc = gql`
    fragment ItemSubCategory on ItemSubCategory {
  id
  name
}
    `;
export const CustomerTableFragmentDoc = gql`
    fragment CustomerTable on Customer {
  id
  lastName
  firstName
  email
  tags {
    ...TagEdges
  }
}
    ${TagEdgesFragmentDoc}`;
export const DepositSlipFragmentDoc = gql`
    fragment DepositSlip on DepositSlip {
  id
  createdAt
  document {
    imageUrl
    filename
  }
  nbItems
  vendor {
    id
  }
  number
}
    `;
export const DepositSlipNodeFragmentDoc = gql`
    fragment DepositSlipNode on DepositSlipEdge {
  node {
    ...DepositSlip
  }
}
    ${DepositSlipFragmentDoc}`;
export const DepositSlipEdgesFragmentDoc = gql`
    fragment DepositSlipEdges on DepositSlipConnection {
  edges {
    ...DepositSlipNode
  }
}
    ${DepositSlipNodeFragmentDoc}`;
export const BuyerFragmentDoc = gql`
    fragment Buyer on Buyer {
  account {
    id
    email
  }
}
    `;
export const DesireFragmentDoc = gql`
    fragment Desire on Desire {
  id
  buyer {
    ...Buyer
  }
  customer {
    ...Customer
  }
  title
  originalTitle
  validated
  usable
  unusableReasonLabel
  matchingWords
  searchTitleEnabled
  searchDescriptionEnabled
  searchArtistsEnabled
  searchTagsEnabled
  tags {
    ...TagEdges
  }
  createdAt
  updatedAt
}
    ${BuyerFragmentDoc}
${CustomerFragmentDoc}
${TagEdgesFragmentDoc}`;
export const DesireNodeFragmentDoc = gql`
    fragment DesireNode on DesireEdge {
  node {
    ...Desire
  }
}
    ${DesireFragmentDoc}`;
export const DesireEdgesFragmentDoc = gql`
    fragment DesireEdges on DesireConnection {
  totalCount
  pageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
  edges {
    cursor
    ...DesireNode
  }
}
    ${DesireNodeFragmentDoc}`;
export const ExpertPaymentTableFragmentDoc = gql`
    fragment ExpertPaymentTable on ExpertPayment {
  id
  createdAt
  paid
  lockedAt
  expertPaymentLines {
    edges {
      node {
        id
        amount
      }
    }
  }
  expert {
    id
    account {
      id
      firstName
      lastName
    }
  }
  sale {
    id
    name
  }
  invoices {
    imageUrl
    filename
  }
}
    `;
export const ExpertSelectFieldFragmentDoc = gql`
    fragment ExpertSelectField on Expert {
  id
  account {
    id
    firstName
    lastName
  }
}
    `;
export const ExpertStatementPaymentTableFragmentDoc = gql`
    fragment ExpertStatementPaymentTable on ExpertStatementPayment {
  id
  createdAt
  paid
  totalAmount
  expert {
    id
    account {
      id
      firstName
      lastName
    }
  }
  totalSalesCount
  invoices {
    imageUrl
    filename
  }
  expertPayments {
    edges {
      node {
        id
        createdAt
        paid
        lockedAt
        expertPaymentLines {
          edges {
            node {
              id
              amount
            }
          }
        }
        expert {
          id
          account {
            id
            firstName
            lastName
          }
        }
        sale {
          id
          name
        }
        invoices {
          imageUrl
          filename
        }
      }
    }
  }
}
    `;
export const ExpertTableFragmentDoc = gql`
    fragment ExpertTable on Expert {
  id
  account {
    id
    firstName
    lastName
    email
    state
    createdAt
  }
}
    `;
export const ImportPaymentTableFragmentDoc = gql`
    fragment ImportPaymentTable on ImportPayment {
  id
  createdAt
  paid
  lockedAt
  importPaymentLines {
    edges {
      node {
        id
        amount
      }
    }
  }
  account {
    id
    firstName
    lastName
  }
  sale {
    id
    name
  }
  importPaymentLines {
    edges {
      node {
        id
        amount
      }
    }
  }
}
    `;
export const ImportStatementPaymentTableFragmentDoc = gql`
    fragment ImportStatementPaymentTable on ImportStatementPayment {
  id
  createdAt
  paid
  totalAmount
  account {
    firstName
    lastName
  }
  totalSalesCount
  invoices {
    imageUrl
    filename
  }
  importPayments {
    edges {
      node {
        id
        createdAt
        paid
        lockedAt
        importPaymentLines {
          edges {
            node {
              id
              amount
            }
          }
        }
        account {
          id
          firstName
          lastName
        }
        sale {
          id
          name
        }
      }
    }
  }
}
    `;
export const ItemSubCategoryNodeFragmentDoc = gql`
    fragment ItemSubCategoryNode on ItemSubCategoryEdge {
  node {
    id
    name
    archived
  }
}
    `;
export const ItemSubCategoryEdgesFragmentDoc = gql`
    fragment ItemSubCategoryEdges on ItemSubCategoryConnection {
  edges {
    ...ItemSubCategoryNode
  }
}
    ${ItemSubCategoryNodeFragmentDoc}`;
export const ItemMovementFragmentDoc = gql`
    fragment ItemMovement on ItemMovement {
  id
  account {
    id
    email
    firstName
    lastName
  }
  createdAt
  fromLocation
  toLocation
  itemMovementEntries {
    edges {
      node {
        id
        oldSku
        newSku
      }
    }
  }
}
    `;
export const ItemMovementNodeFragmentDoc = gql`
    fragment ItemMovementNode on ItemMovementEdge {
  node {
    ...ItemMovement
  }
}
    ${ItemMovementFragmentDoc}`;
export const ItemMovementEdgesFragmentDoc = gql`
    fragment ItemMovementEdges on ItemMovementConnection {
  edges {
    ...ItemMovementNode
  }
}
    ${ItemMovementNodeFragmentDoc}`;
export const ExpertFragmentDoc = gql`
    fragment Expert on Expert {
  id
  account {
    id
    firstName
    lastName
    state
  }
  externalRainworxId
}
    `;
export const ExpertNodeFragmentDoc = gql`
    fragment ExpertNode on ExpertEdge {
  node {
    ...Expert
  }
}
    ${ExpertFragmentDoc}`;
export const ExpertEdgesFragmentDoc = gql`
    fragment ExpertEdges on ExpertConnection {
  edges {
    ...ExpertNode
  }
}
    ${ExpertNodeFragmentDoc}`;
export const FileFragmentDoc = gql`
    fragment File on CustomFile {
  imageUrl
  filename
  extension
  blobId
}
    `;
export const ItemStepFragmentDoc = gql`
    fragment ItemStep on ItemStep {
  id
  number
  comment
  state
  name
}
    `;
export const ItemStepNodeFragmentDoc = gql`
    fragment ItemStepNode on ItemStepEdge {
  node {
    ...ItemStep
  }
}
    ${ItemStepFragmentDoc}`;
export const ItemStepEdgesFragmentDoc = gql`
    fragment ItemStepEdges on ItemStepConnection {
  edges {
    ...ItemStepNode
  }
}
    ${ItemStepNodeFragmentDoc}`;
export const ItemStepsFragmentDoc = gql`
    fragment ItemSteps on Item {
  itemSteps {
    ...ItemStepEdges
  }
}
    ${ItemStepEdgesFragmentDoc}`;
export const VendorAccountFragmentDoc = gql`
    fragment VendorAccount on Account {
  id
  firstName
  lastName
  email
  state
  isProfessional
}
    `;
export const VendorFragmentDoc = gql`
    fragment Vendor on Vendor {
  id
  account {
    ...VendorAccount
  }
  externalRainworxId
}
    ${VendorAccountFragmentDoc}`;
export const WriterFragmentDoc = gql`
    fragment Writer on Writer {
  id
  account {
    id
    firstName
    lastName
    email
    state
    createdAt
    writerType
    writerPourcentageFees
    writerFixFees
  }
  nbItemsCreated {
    currentMonth
    lastMonth
    total
    totalAmountCurrentMonth
    totalAmountLastMonth
  }
  nbItemsAfterAccepted {
    currentMonth
    lastMonth
    total
    totalAmountCurrentMonth
    totalAmountLastMonth
  }
  nbItemsAfterShipped {
    currentMonth
    lastMonth
    total
    totalAmountCurrentMonth
    totalAmountLastMonth
  }
  kpis {
    totalFromBeginning
    itemAcceptedPercentage
    itemPercentageStates {
      draft
      accepted
      refused
      needUpdate
      waitingExpertise
      underExpertise
    }
  }
}
    `;
export const ItemCategoryFragmentDoc = gql`
    fragment ItemCategory on Item {
  itemCategory {
    id
    name
    templateType
    externalRainworxId
  }
  itemSubCategory {
    id
    name
    externalRainworxId
  }
}
    `;
export const ItemTitlesFragmentDoc = gql`
    fragment ItemTitles on Item {
  title
  saleTitle
  subtitle
  state
}
    `;
export const ItemPriceFragmentDoc = gql`
    fragment ItemPrice on Item {
  lowEstimatedPrice
  highEstimatedPrice
  reservedPrice
  startingPrice
}
    `;
export const ArtistFragmentDoc = gql`
    fragment Artist on Artist {
  id
  firstName
  lastName
  isGroup
  tag
  itemCategoryId
}
    `;
export const ItemArtistNodeFragmentDoc = gql`
    fragment ItemArtistNode on ArtistEdge {
  node {
    ...Artist
  }
}
    ${ArtistFragmentDoc}`;
export const ItemArtistEdgesFragmentDoc = gql`
    fragment ItemArtistEdges on ArtistConnection {
  edges {
    ...ItemArtistNode
  }
}
    ${ItemArtistNodeFragmentDoc}`;
export const ItemArtistsFragmentDoc = gql`
    fragment ItemArtists on Item {
  artists {
    ...ItemArtistEdges
  }
}
    ${ItemArtistEdgesFragmentDoc}`;
export const VacationFragmentDoc = gql`
    fragment Vacation on Vacation {
  id
  name
  description
  state
  startAt
  endAt
  image {
    imageUrl
  }
  expert {
    id
  }
}
    `;
export const PublishingBookFragmentDoc = gql`
    fragment PublishingBook on Book {
  id
  publishers
  publisherKnownButNotMentioned
  editingAttribute
  editingAttributeDetails
  item {
    id
    locations
    locationKnownButNotMentioned
    dateFrom
    dateTo
    dateOption
  }
}
    `;
export const BookFragmentDoc = gql`
    fragment Book on Book {
  createdAt
  id
  updatedAt
  publishers
  bibliographyComment
  illustrationComment
  collationComment
  assemblySpecification
  assemblyType
  bindingColor
  bindingFormat
  bindingStyle
  bindingMaterial
  bindingFormatDetails
  bindingType
  bindingTypeOptions
  bookSpineMaterial
  bookSpineOrnament1
  bookSpineOrnament1Option
  bookSpineOrnament2
  bookSpineOrnament2Option
  bookSpineOrnamentOption
  bookSpineType
  bindingAge
  bindingMaterialOptions
  bindingAdditionalOptions
  bookBinder
  size
  coverType
  coverQuality
  coverColor
  coverMaterial
  coverOrnament1
  coverOrnament1Option
  coverOrnament2
  coverOrnament2Option
  coverOrnamentOption
  edgeColor
  edgeStyle
  edgeType
  isOblong
  dumbSpine
  isBindingSigned
  paperbackType
  isApproximatelyPaginating
  isPaginating
  paginationInfo
  withFolder
  casingType
  volumes {
    edges {
      node {
        id
        parts {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
  ...PublishingBook
  item {
    id
    state
  }
}
    ${PublishingBookFragmentDoc}`;
export const ManuscriptFragmentDoc = gql`
    fragment Manuscript on Manuscript {
  id
}
    `;
export const EngravingFragmentDoc = gql`
    fragment Engraving on Engraving {
  id
}
    `;
export const WatchFragmentDoc = gql`
    fragment Watch on Watch {
  id
}
    `;
export const TagsFragmentDoc = gql`
    fragment Tags on Item {
  tags {
    ...TagEdges
  }
}
    ${TagEdgesFragmentDoc}`;
export const AutoTagsFragmentDoc = gql`
    fragment AutoTags on Item {
  autoTags {
    ...TagEdges
  }
}
    ${TagEdgesFragmentDoc}`;
export const ItemFragmentDoc = gql`
    fragment Item on Item {
  createdAt
  descriptionHeader
  description
  descriptionFooter
  conditionsComment
  globalComment
  height
  width
  length
  weight
  otherComment
  id
  sku
  project {
    id
    title
  }
  customSkuPart
  conditionAccepted
  images {
    imageUrl
    position
  }
  invoices {
    ...File
  }
  authenticityDocuments {
    ...File
  }
  ...ItemSteps
  dateFrom
  dateTo
  dateOption
  catchPhrase
  catchPhraseEnabled
  customDescription
  customDescriptionEnabled
  autoDescription
  state
  locations
  locationKnownButNotMentioned
  artistUnknown
  artistCollectif
  artistKnownButNotMentioned
  mode
  descriptionSuggestion
  descriptionSuggestionGeneratedAt
  generationStatus
  salePosition
  resaleInfo {
    nextPrice
    discountPercentage
    unsoldCount
    canRelist
    status
  }
  expert {
    ...Expert
  }
  vendor {
    ...Vendor
  }
  writer {
    ...Writer
  }
  updatedAt
  ...ItemCategory
  ...ItemTitles
  ...ItemPrice
  ...ItemArtists
  vacation {
    ...Vacation
  }
  template {
    __typename
    ... on Book {
      ...Book
    }
    ... on Manuscript {
      ...Manuscript
    }
    ... on Engraving {
      ...Engraving
    }
    ... on Watch {
      ...Watch
    }
  }
  ...Tags
  ...AutoTags
}
    ${FileFragmentDoc}
${ItemStepsFragmentDoc}
${ExpertFragmentDoc}
${VendorFragmentDoc}
${WriterFragmentDoc}
${ItemCategoryFragmentDoc}
${ItemTitlesFragmentDoc}
${ItemPriceFragmentDoc}
${ItemArtistsFragmentDoc}
${VacationFragmentDoc}
${BookFragmentDoc}
${ManuscriptFragmentDoc}
${EngravingFragmentDoc}
${WatchFragmentDoc}
${TagsFragmentDoc}
${AutoTagsFragmentDoc}`;
export const ItemNodeFragmentDoc = gql`
    fragment ItemNode on ItemEdge {
  node {
    ...Item
  }
}
    ${ItemFragmentDoc}`;
export const ItemEdgesFragmentDoc = gql`
    fragment ItemEdges on ItemConnection {
  edges {
    ...ItemNode
  }
}
    ${ItemNodeFragmentDoc}`;
export const ItemExpertFragmentDoc = gql`
    fragment ItemExpert on Expert {
  id
  account {
    firstName
    lastName
    companyName
    email
  }
}
    `;
export const ItemTableFragmentDoc = gql`
    fragment ItemTable on Item {
  id
  artistUnknown
  artistCollectif
  title
  state
  highEstimatedPrice
  salePosition
  ...ItemCategory
  firstImage {
    imageUrl
    position
  }
  ...ItemArtists
  expert {
    ...ItemExpert
  }
  finalPrice
  projectCounter
  vacation {
    id
    name
  }
  sale {
    id
  }
  project {
    id
    title
  }
  vendor {
    account {
      firstName
      lastName
    }
  }
  writer {
    account {
      firstName
      lastName
    }
  }
  sku
  createdAt
  refusedAt
  startingPrice
  unsoldCount
  lastSaleEndedAt
  nextEligibleDate
  isLibraryFundItem
  reservedPrice
  resaleStatus
  vendorDecision
  vendorDecisionAt
  vendorActionDeadline
  initialStartingPrice
  resaleInfo {
    canRelist
    status
    nextPrice
    nextEligibleDate
    unsoldCount
    daysUntilEligible
    discountPercentage
  }
}
    ${ItemCategoryFragmentDoc}
${ItemArtistsFragmentDoc}
${ItemExpertFragmentDoc}`;
export const NewsLetterFragmentDoc = gql`
    fragment NewsLetter on NewsLetter {
  id
  htmlContent
  test
  emailFrom
  emailTo
  subject
  isGeneral
  createdAt
  buyer {
    account {
      firstName
      lastName
      email
    }
    autoTags {
      ...TagEdges
    }
    expertTags {
      ...TagEdges
    }
    importTags {
      ...TagEdges
    }
    bookmarkTags {
      ...TagEdges
    }
    tags {
      ...TagEdges
    }
  }
  customer {
    firstName
    lastName
    email
    tags {
      ...TagEdges
    }
  }
  sale {
    id
    name
  }
  nbItems
}
    ${TagEdgesFragmentDoc}`;
export const NewsLetterNodeFragmentDoc = gql`
    fragment NewsLetterNode on NewsLetterEdge {
  node {
    ...NewsLetter
  }
}
    ${NewsLetterFragmentDoc}`;
export const NewsLetterEdgesFragmentDoc = gql`
    fragment NewsLetterEdges on NewsLetterConnection {
  edges {
    ...NewsLetterNode
  }
  totalCount
  pageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
}
    ${NewsLetterNodeFragmentDoc}`;
export const OnboardingAccountFragmentDoc = gql`
    fragment OnboardingAccount on Account {
  id
  isProfessional
  firstName
  lastName
  phone
  companyName
  siret
  tvaNumber
  shippingAddress {
    id
    lastName
    phone1
    email
    addressLine1
    city
    zip
    country
  }
}
    `;
export const OrderFragmentDoc = gql`
    fragment Order on Order {
  id
  shippingAddress {
    id
    addressLine1
    addressLine2
    addressLine2
    city
    zip
    state
    country
    email
    firstName
    lastName
    companyName
    phone1
    phone2
  }
  totalPrice
  totalPriceTaxIncluded
  totalTax
  totalItemsPrice
  shippingPrice
  shippingPriceTaxIncluded
  shippingTax
  insurancePrice
  insurancePriceTaxIncluded
  insuranceTax
  buyerFee
  buyerFeeTaxIncluded
  buyerFeeTax
  carrierName
  state
  createdAt
  paidAt
  histories {
    id
    event
    whodunnit
    objectChanges
    createdAt
  }
  saleEndAt
  comment
  vendorComment
  dodecadeInvoiceRef
  dodecadeOrderRef
  sale {
    id
    name
  }
  orderItems {
    edges {
      node {
        id
        state
        carrierName
        vendor {
          id
        }
        item {
          id
          title
          sku
          finalPrice
          dodecadeItemRef
          weight
          images(first: 1) {
            imageUrl
            position
          }
        }
      }
    }
  }
  labels {
    edges {
      node {
        id
        trackingNumber
        undeplusRef
        carrierName
        externalLabelUrl
        labelDocument {
          imageUrl
        }
        cn23Document {
          imageUrl
        }
        trackingUrl
        cn23Explanation
        status
        errorMessage
        weight
        vendor {
          id
        }
      }
    }
  }
}
    `;
export const OrderTableFragmentDoc = gql`
    fragment OrderTable on Order {
  id
  undeplusRef
  dodecadeInvoiceRef
  dodecadeOrderRef
  totalPrice
  totalPriceTaxIncluded
  state
  stripePaymentLink
  totalItemsPrice
  trackingUrls
  labelUrls
  trackingNumbers
  carrierName
  createdAt
  paidAt
  saleEndAt
  buyer {
    id
    account {
      firstName
      lastName
      companyName
    }
  }
  vendors {
    id
    account {
      firstName
      lastName
      companyName
    }
  }
  orderItems {
    edges {
      node {
        id
        state
        carrierName
        vendor {
          id
        }
        item {
          title
          sku
          finalPrice
        }
      }
    }
  }
  labels {
    edges {
      node {
        trackingNumber
        undeplusRef
        externalLabelUrl
        labelDocument {
          imageUrl
        }
        trackingUrl
        vendor {
          id
        }
      }
    }
  }
  sale {
    id
    name
  }
}
    `;
export const PaidSlipFragmentDoc = gql`
    fragment PaidSlip on PaidSlip {
  id
  createdAt
  document {
    imageUrl
    filename
  }
  nbItems
  buyer {
    id
  }
  sale {
    id
  }
  number
}
    `;
export const PaidSlipNodeFragmentDoc = gql`
    fragment PaidSlipNode on PaidSlipEdge {
  node {
    ...PaidSlip
  }
}
    ${PaidSlipFragmentDoc}`;
export const PaidSlipEdgesFragmentDoc = gql`
    fragment PaidSlipEdges on PaidSlipConnection {
  edges {
    ...PaidSlipNode
  }
}
    ${PaidSlipNodeFragmentDoc}`;
export const PickupParcelFragmentDoc = gql`
    fragment PickupParcel on Label {
  id
  trackingNumber
  orderItems {
    id
    item {
      id
      title
    }
    order {
      id
    }
  }
}
    `;
export const PickupRequestFragmentDoc = gql`
    fragment PickupRequest on PickupRequest {
  id
  status
  dispatchNumber
  errorCode
  errorMessage
  pickupAddress
  pickupLocationCloseTime
  instructions
  pickupLocation
  createdAt
  pickupTimestamp
  pickupRequestLabels {
    status
    errorCode
    errorMessage
    label {
      ...PickupParcel
    }
  }
}
    ${PickupParcelFragmentDoc}`;
export const AddressProfileFragmentDoc = gql`
    fragment AddressProfile on Address {
  id
  createdAt
  updatedAt
  number
  addressLine1
  addressLine2
  addressLine3
  zip
  city
  country
  type
}
    `;
export const BankInformationProfileFragmentDoc = gql`
    fragment BankInformationProfile on BankInformation {
  id
  createdAt
  updatedAt
  iban
  bic
  fullName
  name
}
    `;
export const VendorPickupHoursFragmentDoc = gql`
    fragment VendorPickupHours on Vendor {
  pickupHours {
    day
    timeRanges {
      startTime
      endTime
    }
  }
}
    `;
export const VendorAddressFragmentDoc = gql`
    fragment VendorAddress on Address {
  id
  name
  firstName
  lastName
  companyName
  addressLine1
  addressLine2
  addressLine3
  city
  state
  zip
  country
  phone1
  phone2
  email
}
    `;
export const VendorDefaultAddressesFragmentDoc = gql`
    fragment VendorDefaultAddresses on Vendor {
  defaultProfileAddress {
    ...VendorAddress
  }
  defaultBillingAddress {
    ...VendorAddress
  }
  defaultPickupAddress {
    ...VendorAddress
  }
  defaultShippingAddress {
    ...VendorAddress
  }
}
    ${VendorAddressFragmentDoc}`;
export const AccountProfileFragmentDoc = gql`
    fragment AccountProfile on Account {
  id
  createdAt
  updatedAt
  firstName
  lastName
  civility
  birthDate
  corporateForm
  phone
  companyName
  email
  siret
  tvaNumber
  isProfessional
  bankInformation {
    ...BankInformationProfile
  }
  identityDocuments {
    ...File
  }
  ribDocuments {
    ...File
  }
  shippingAddress @include(if: $includeLegacyShippingAddress) {
    id
    addressLine1
    addressLine2
    addressLine3
    city
    companyName
    country
    email
    firstName
    lastName
    phone1
    phone2
    zip
  }
  accountable {
    __typename
    ... on Vendor {
      id
      stripeConnectAccountId
      shippingOptions
      ...VendorPickupHours
      ...VendorDefaultAddresses
    }
  }
}
    ${BankInformationProfileFragmentDoc}
${FileFragmentDoc}
${VendorPickupHoursFragmentDoc}
${VendorDefaultAddressesFragmentDoc}`;
export const MinimizeWriterFragmentDoc = gql`
    fragment MinimizeWriter on Writer {
  account {
    firstName
    lastName
  }
}
    `;
export const WriterNodeFragmentDoc = gql`
    fragment WriterNode on WriterEdge {
  node {
    ...MinimizeWriter
  }
}
    ${MinimizeWriterFragmentDoc}`;
export const WriterEdgesFragmentDoc = gql`
    fragment WriterEdges on WriterConnection {
  edges {
    ...WriterNode
  }
}
    ${WriterNodeFragmentDoc}`;
export const ProjectRowFragmentDoc = gql`
    fragment ProjectRow on Project {
  id
  title
  number
  state
  nbItems
  nbItemsToExpertise
  nbItemsToModify
  vendor {
    id
    account {
      id
      firstName
      lastName
    }
  }
  writers {
    ...WriterEdges
  }
}
    ${WriterEdgesFragmentDoc}`;
export const OrderItemFragmentDoc = gql`
    fragment OrderItem on OrderItem {
  id
  totalPrice
  undeplusRef
  item {
    id
  }
}
    `;
export const OrderItemNodeFragmentDoc = gql`
    fragment OrderItemNode on OrderItemEdge {
  node {
    ...OrderItem
  }
}
    ${OrderItemFragmentDoc}`;
export const OrderItemEdgesFragmentDoc = gql`
    fragment OrderItemEdges on OrderItemConnection {
  edges {
    ...OrderItemNode
  }
}
    ${OrderItemNodeFragmentDoc}`;
export const VendorNodeFragmentDoc = gql`
    fragment VendorNode on VendorEdge {
  node {
    id
    ...Vendor
  }
}
    ${VendorFragmentDoc}`;
export const VendorEdgesFragmentDoc = gql`
    fragment VendorEdges on VendorConnection {
  edges {
    ...VendorNode
  }
}
    ${VendorNodeFragmentDoc}`;
export const PurchaseSlipFragmentDoc = gql`
    fragment PurchaseSlip on PurchaseSlip {
  id
  createdAt
  document {
    imageUrl
    filename
  }
  nbItems
  buyer {
    id
  }
  sale {
    id
  }
  number
}
    `;
export const PurchaseSlipNodeFragmentDoc = gql`
    fragment PurchaseSlipNode on PurchaseSlipEdge {
  node {
    ...PurchaseSlip
  }
}
    ${PurchaseSlipFragmentDoc}`;
export const PurchaseSlipEdgesFragmentDoc = gql`
    fragment PurchaseSlipEdges on PurchaseSlipConnection {
  edges {
    ...PurchaseSlipNode
  }
}
    ${PurchaseSlipNodeFragmentDoc}`;
export const QuickTextFragmentDoc = gql`
    fragment QuickText on QuickText {
  id
  title
  text
  number
  createdAt
}
    `;
export const QuickTextNodeFragmentDoc = gql`
    fragment QuickTextNode on QuickTextEdge {
  node {
    ...QuickText
  }
}
    ${QuickTextFragmentDoc}`;
export const QuickTextEdgesFragmentDoc = gql`
    fragment QuickTextEdges on QuickTextConnection {
  edges {
    ...QuickTextNode
  }
}
    ${QuickTextNodeFragmentDoc}`;
export const SaleRateChartCardFragmentDoc = gql`
    fragment SaleRateChartCard on TimeSeriesPoint {
  period
  value
}
    `;
export const SaleTableFragmentDoc = gql`
    fragment SaleTable on Sale {
  id
  name
  description
  state
  startAt
  endAt
  typeOfSale
  externalEventRainworxId
  image {
    imageUrl
  }
}
    `;
export const SaleNodeFragmentDoc = gql`
    fragment SaleNode on SaleEdge {
  node {
    ...SaleTable
    nbItems
  }
}
    ${SaleTableFragmentDoc}`;
export const SaleEdgesFragmentDoc = gql`
    fragment SaleEdges on SaleConnection {
  edges {
    ...SaleNode
  }
}
    ${SaleNodeFragmentDoc}`;
export const WriterSelectFieldFragmentDoc = gql`
    fragment WriterSelectField on Writer {
  id
  account {
    id
    firstName
    lastName
    email
  }
}
    `;
export const SaleMandatFragmentDoc = gql`
    fragment SaleMandat on SaleMandat {
  id
  createdAt
  document {
    imageUrl
    filename
  }
  nbItems
  vendor {
    id
  }
  sale {
    id
  }
  number
}
    `;
export const SaleMandatNodeFragmentDoc = gql`
    fragment SaleMandatNode on SaleMandatEdge {
  node {
    ...SaleMandat
  }
}
    ${SaleMandatFragmentDoc}`;
export const SaleMandatEdgesFragmentDoc = gql`
    fragment SaleMandatEdges on SaleMandatConnection {
  edges {
    ...SaleMandatNode
  }
}
    ${SaleMandatNodeFragmentDoc}`;
export const MinimizeBusinessIntroducerFragmentDoc = gql`
    fragment MinimizeBusinessIntroducer on BusinessIntroducer {
  firstName
  lastName
}
    `;
export const MinimizeThirdPartyIntroducerFragmentDoc = gql`
    fragment MinimizeThirdPartyIntroducer on ThirdPartyIntroducer {
  firstName
  lastName
}
    `;
export const ProjectFragmentDoc = gql`
    fragment Project on Project {
  id
  vendor {
    id
    ...Vendor
  }
  owner {
    id
    ...Vendor
  }
  writers {
    ...WriterEdges
  }
  state
  nbItems
  nbItemsToExpertise
  nbItemsToModify
  createdAt
  title
  number
  itemNumberStart
  exclusif
  isClassicSale
  sharingProfit
  dodecadeSharePercentage
  expertiseFirmSharePercentage
  businessIntroducer {
    id
    ...MinimizeBusinessIntroducer
  }
  thirdPartyIntroducer {
    id
    ...MinimizeThirdPartyIntroducer
  }
  businessIntroducerSharePercentage
  thirdPartyIntroducerSharePercentage
  buyerFeePercentage
  comment
  auctioneerNumber
  projectFees {
    edges {
      node {
        id
        name
        value
      }
    }
  }
  manualDepositSlip {
    ...File
  }
  documentsByActor {
    vendor {
      ...File
    }
    businessIntroducer {
      ...File
    }
    thirdPartyIntroducer {
      ...File
    }
  }
  totalItemsSoldAmount
  totalProjectFeesAmount
  totalFeesByActor
  vendorFeePercentage
  writerFeePercentage
  writerFixFees
  expertiseFeePercentage
}
    ${VendorFragmentDoc}
${WriterEdgesFragmentDoc}
${MinimizeBusinessIntroducerFragmentDoc}
${MinimizeThirdPartyIntroducerFragmentDoc}
${FileFragmentDoc}`;
export const ProjectNodeFragmentDoc = gql`
    fragment ProjectNode on ProjectEdge {
  node {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;
export const ProjectEdgesFragmentDoc = gql`
    fragment ProjectEdges on ProjectConnection {
  edges {
    ...ProjectNode
  }
}
    ${ProjectNodeFragmentDoc}`;
export const SaleFragmentDoc = gql`
    fragment Sale on Sale {
  id
  name
  description
  state
  startAt
  endAt
  typeOfSale
  estimatedPriceEnabled
  externalEventRainworxId
  image {
    imageUrl
  }
  expert {
    id
  }
  writers {
    ...WriterSelectField
  }
  saleMandats {
    ...SaleMandatEdges
  }
  drouotCsv {
    ...File
  }
  imagesZip {
    ...File
  }
  temporaryDrouotCsvs {
    ...File
  }
  temporaryImagesZips {
    ...File
  }
  nbTemporaryFileToGenerate
  nbItems
  newsletterHeaderHtml
  subject
  subjectEndingSoon
  projectIds
  projects {
    ...ProjectEdges
  }
}
    ${WriterSelectFieldFragmentDoc}
${SaleMandatEdgesFragmentDoc}
${FileFragmentDoc}
${ProjectEdgesFragmentDoc}`;
export const TagTableFragmentDoc = gql`
    fragment TagTable on Tag {
  id
  name
  createdAt
  auto
  account {
    lastName
    firstName
  }
}
    `;
export const VacationNodeFragmentDoc = gql`
    fragment VacationNode on VacationEdge {
  node {
    ...Vacation
    nbItems
    nbUnsoldEligible
    nbUnpaidEligible
  }
}
    ${VacationFragmentDoc}`;
export const VacationEdgesFragmentDoc = gql`
    fragment VacationEdges on VacationConnection {
  edges {
    cursor
    ...VacationNode
  }
  totalCount
  pageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
}
    ${VacationNodeFragmentDoc}`;
export const VendorPaymentTableFragmentDoc = gql`
    fragment VendorPaymentTable on MonthlyVendorPayment {
  id
  vendor {
    id
    stripeConnectAccountId
    account {
      firstName
      lastName
    }
  }
  startAt
  endAt
  paid
  createdAt
  stripeTransferStatus
  stripeTransferError
  stripeTransferMode
  stripeTransferredAt
  disputed
  disputeAmount
  vendorPaymentLines {
    edges {
      node {
        id
        amount
      }
    }
  }
}
    `;
export const VendorSelectFieldFragmentDoc = gql`
    fragment VendorSelectField on Vendor {
  id
  account {
    id
    firstName
    lastName
    companyName
  }
}
    `;
export const VendorStatementPaymentTableFragmentDoc = gql`
    fragment VendorStatementPaymentTable on VendorStatementPayment {
  id
  vendor {
    id
    stripeConnectAccountId
    account {
      firstName
      lastName
    }
  }
  startAt
  endAt
  totalAmount
  totalSalesCount
  paid
  createdAt
  stripeTransferStatus
  stripeTransferError
  stripeTransferMode
  stripeTransferredAt
  disputed
  disputeAmount
  monthlyVendorPayments {
    edges {
      node {
        id
        createdAt
        vendor {
          id
          stripeConnectAccountId
          account {
            firstName
            lastName
          }
        }
        vendorPaymentLines {
          edges {
            node {
              id
              amount
            }
          }
        }
        startAt
        endAt
        paid
        stripeTransferStatus
        stripeTransferError
        stripeTransferMode
        stripeTransferredAt
        disputed
        disputeAmount
      }
    }
  }
}
    `;
export const VendorStatementFragmentDoc = gql`
    fragment VendorStatement on VendorStatement {
  id
  createdAt
  document {
    imageUrl
    filename
  }
  nbItems
  vendor {
    id
  }
  sale {
    id
  }
  number
}
    `;
export const VendorStatementNodeFragmentDoc = gql`
    fragment VendorStatementNode on VendorStatementEdge {
  node {
    ...VendorStatement
  }
}
    ${VendorStatementFragmentDoc}`;
export const VendorStatementEdgesFragmentDoc = gql`
    fragment VendorStatementEdges on VendorStatementConnection {
  edges {
    ...VendorStatementNode
  }
}
    ${VendorStatementNodeFragmentDoc}`;
export const VendorTableFragmentDoc = gql`
    fragment VendorTable on Vendor {
  id
  kind
  account {
    id
    firstName
    lastName
    email
    state
    createdAt
  }
}
    `;
export const WriterPaymentTableFragmentDoc = gql`
    fragment WriterPaymentTable on WriterPayment {
  id
  createdAt
  paid
  lockedAt
  startAt
  endAt
  writerPaymentLines {
    edges {
      node {
        id
        amount
      }
    }
  }
  writer {
    id
    account {
      id
      firstName
      lastName
    }
  }
  sale {
    id
    name
  }
  invoices {
    imageUrl
    filename
  }
}
    `;
export const WriterStatementPaymentTableFragmentDoc = gql`
    fragment WriterStatementPaymentTable on WriterStatementPayment {
  id
  createdAt
  paid
  totalAmount
  startAt
  endAt
  writer {
    id
    account {
      id
      firstName
      lastName
    }
  }
  totalSalesCount
  invoices {
    imageUrl
    filename
  }
  writerPayments {
    edges {
      node {
        id
        createdAt
        paid
        lockedAt
        startAt
        endAt
        writerPaymentLines {
          edges {
            node {
              id
              amount
            }
          }
        }
        writer {
          id
          account {
            id
            firstName
            lastName
          }
        }
        sale {
          id
          name
        }
        invoices {
          imageUrl
          filename
        }
      }
    }
  }
}
    `;
export const WriterTableFragmentDoc = gql`
    fragment WriterTable on Writer {
  id
  adminProjectsIds
  account {
    firstName
    lastName
    email
    state
    createdAt
    writerType
    writerPourcentageFees
  }
  nbItemsCreated {
    currentMonth
    lastMonth
    total
  }
  nbItemsAfterAccepted {
    currentMonth
    lastMonth
    total
  }
}
    `;
export const BuyerPurchaseFragmentDoc = gql`
    fragment BuyerPurchase on OrderItem {
  id
  state
  totalPrice
  order {
    id
    paidAt
    createdAt
  }
  item {
    id
    title
    sku
    firstImage {
      imageUrl
    }
    tags(first: 50) {
      nodes {
        id
        name
      }
    }
  }
}
    `;
export const BuyerFavoriteFragmentDoc = gql`
    fragment BuyerFavorite on Favorite {
  id
  createdAt
  purchased
  item {
    id
    title
    state
    startingPrice
    firstImage {
      imageUrl
    }
    tags(first: 50) {
      nodes {
        id
        name
      }
    }
  }
}
    `;
export const ImportAccountFragmentDoc = gql`
    fragment ImportAccount on Account {
  firstName
  lastName
  state
  isProfessional
}
    `;
export const ImportPaymentLineFragmentDoc = gql`
    fragment ImportPaymentLine on ImportPaymentLine {
  amount
  feePercentage
}
    `;
export const ImportPaymentLineNodeFragmentDoc = gql`
    fragment ImportPaymentLineNode on ImportPaymentLineEdge {
  node {
    ...ImportPaymentLine
  }
}
    ${ImportPaymentLineFragmentDoc}`;
export const ImportPaymentLineEdgesFragmentDoc = gql`
    fragment ImportPaymentLineEdges on ImportPaymentLineConnection {
  edges {
    ...ImportPaymentLineNode
  }
}
    ${ImportPaymentLineNodeFragmentDoc}`;
export const ImportPaymentFragmentDoc = gql`
    fragment ImportPayment on ImportPayment {
  id
  account {
    firstName
    lastName
  }
  importStatementPayment {
    id
  }
  lockedAt
  orderItems {
    edges {
      node {
        id
        totalPrice
        order {
          id
          sale {
            id
            name
          }
        }
      }
    }
  }
  sale {
    id
    name
  }
  paid
  createdAt
  startAt
  endAt
  importPaymentLines {
    ...ImportPaymentLineEdges
  }
}
    ${ImportPaymentLineEdgesFragmentDoc}`;
export const ItemHistorySaleFragmentDoc = gql`
    fragment ItemHistorySale on Sale {
  id
  name
  startAt
  endAt
}
    `;
export const ItemHistoryPassageFragmentDoc = gql`
    fragment ItemHistoryPassage on ItemSalePassage {
  number
  result
  startingPrice
  finalPrice
  sale {
    ...ItemHistorySale
  }
}
    ${ItemHistorySaleFragmentDoc}`;
export const ItemHistorySaleEventFragmentDoc = gql`
    fragment ItemHistorySaleEvent on ItemSaleHistory {
  id
  eventType
  triggeredBy
  triggeredByUserName
  previousState
  newState
  notes
  startingPriceUsed
  nextPrice
  discountPercentage
  createdAt
  sale {
    ...ItemHistorySale
  }
}
    ${ItemHistorySaleFragmentDoc}`;
export const ItemHistoryOrderEventFragmentDoc = gql`
    fragment ItemHistoryOrderEvent on ItemOrderHistory {
  id
  orderId
  eventType
  finalPrice
  occurredAt
}
    `;
export const BusinessIntroducerFragmentDoc = gql`
    fragment BusinessIntroducer on BusinessIntroducer {
  id
  firstName
  lastName
  email
  phone
  rib {
    ...File
  }
  identityDocument {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const BusinessIntroducerNodeFragmentDoc = gql`
    fragment BusinessIntroducerNode on BusinessIntroducerEdge {
  node {
    id
    ...BusinessIntroducer
  }
}
    ${BusinessIntroducerFragmentDoc}`;
export const BusinessIntroducerEdgesFragmentDoc = gql`
    fragment BusinessIntroducerEdges on BusinessIntroducerConnection {
  edges {
    ...BusinessIntroducerNode
  }
}
    ${BusinessIntroducerNodeFragmentDoc}`;
export const ThirdPartyIntroducerFragmentDoc = gql`
    fragment ThirdPartyIntroducer on ThirdPartyIntroducer {
  id
  firstName
  lastName
  email
  rib {
    ...File
  }
  identityDocument {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const ThirdPartyIntroducerNodeFragmentDoc = gql`
    fragment ThirdPartyIntroducerNode on ThirdPartyIntroducerEdge {
  node {
    id
    ...ThirdPartyIntroducer
  }
}
    ${ThirdPartyIntroducerFragmentDoc}`;
export const ThirdPartyIntroducerEdgesFragmentDoc = gql`
    fragment ThirdPartyIntroducerEdges on ThirdPartyIntroducerConnection {
  edges {
    ...ThirdPartyIntroducerNode
  }
}
    ${ThirdPartyIntroducerNodeFragmentDoc}`;
export const ProjectPaymentAmountsFragmentDoc = gql`
    fragment ProjectPaymentAmounts on ProjectPaymentSummary {
  soldCount
  soldAmountHt
  transferredCount
  transferredAmountHt
  generatedCount
  generatedAmountHt
  toPayCount
  toPayAmountHt
  inProgressCount
  inProgressAmountHt
  dueCount
  dueAmountHt
  awaitingBuyerCount
  awaitingBuyerAmountHt
  unpaidByBuyerCount
  unpaidByBuyerAmountHt
  svvCount
  svvAmountHt
}
    `;
export const SingleItemFormCategoryFragmentDoc = gql`
    fragment SingleItemFormCategory on ItemCategory {
  id
  name
  templateType
  archived
  aiGenerationAvailable
  minImages
  maxImages
}
    `;
export const SingleItemFormSubCategoryFragmentDoc = gql`
    fragment SingleItemFormSubCategory on ItemSubCategory {
  id
  name
  archived
}
    `;
export const SingleItemFormArtistFragmentDoc = gql`
    fragment SingleItemFormArtist on Artist {
  id
  firstName
  lastName
  tag
  itemCategoryId
}
    `;
export const SingleItemFormStepFragmentDoc = gql`
    fragment SingleItemFormStep on ItemStep {
  id
  number
  name
  comment
  state
}
    `;
export const SingleItemFormImageFragmentDoc = gql`
    fragment SingleItemFormImage on Image {
  id
  imageUrl
  position
  rotation
}
    `;
export const SingleItemFormDocumentFragmentDoc = gql`
    fragment SingleItemFormDocument on CustomFile {
  imageUrl
  filename
  extension
  blobId
}
    `;
export const VendorPaymentLineFragmentDoc = gql`
    fragment VendorPaymentLine on VendorPaymentLine {
  amount
  feePercentage
  feeAmount
}
    `;
export const VendorPaymentLineNodeFragmentDoc = gql`
    fragment VendorPaymentLineNode on VendorPaymentLineEdge {
  node {
    ...VendorPaymentLine
  }
}
    ${VendorPaymentLineFragmentDoc}`;
export const VendorPaymentLineEdgesFragmentDoc = gql`
    fragment VendorPaymentLineEdges on VendorPaymentLineConnection {
  edges {
    ...VendorPaymentLineNode
  }
}
    ${VendorPaymentLineNodeFragmentDoc}`;
export const VendorPaymentFeeFragmentDoc = gql`
    fragment VendorPaymentFee on VendorPaymentFee {
  id
  feeType
  feePercentageHt
  feePercentageTtc
  feeAmountHt
  feeTva
  feeTvaRate
  feeAmountTtc
  itemsCount
  fixedFeePerItem
}
    `;
export const VendorPaymentFeeNodeFragmentDoc = gql`
    fragment VendorPaymentFeeNode on VendorPaymentFeeEdge {
  node {
    ...VendorPaymentFee
  }
}
    ${VendorPaymentFeeFragmentDoc}`;
export const VendorPaymentFeeEdgesFragmentDoc = gql`
    fragment VendorPaymentFeeEdges on VendorPaymentFeeConnection {
  edges {
    ...VendorPaymentFeeNode
  }
}
    ${VendorPaymentFeeNodeFragmentDoc}`;
export const MonthlyVendorPaymentFragmentDoc = gql`
    fragment MonthlyVendorPayment on MonthlyVendorPayment {
  id
  vendor {
    ...Vendor
    stripeConnectAccountId
  }
  vendorStatements {
    edges {
      node {
        id
        number
        document {
          imageUrl
          filename
        }
      }
    }
  }
  lockedAt
  vendorStatementPayment {
    id
  }
  orderItems {
    edges {
      node {
        id
        totalPrice
        order {
          id
          sale {
            id
            name
          }
        }
      }
    }
  }
  totalSales
  totalFees
  netAmount
  invoices {
    imageUrl
    filename
  }
  sale {
    id
    name
  }
  paid
  createdAt
  startAt
  endAt
  stripeTransferId
  stripeTransferStatus
  stripeTransferError
  stripeTransferMode
  stripeTransferredAt
  disputed
  disputeAmount
  vendorPaymentLines {
    ...VendorPaymentLineEdges
  }
  vendorPaymentFees {
    ...VendorPaymentFeeEdges
  }
}
    ${VendorFragmentDoc}
${VendorPaymentLineEdgesFragmentDoc}
${VendorPaymentFeeEdgesFragmentDoc}`;
export const ItemImageFragmentDoc = gql`
    fragment ItemImage on Image {
  imageUrl
  position
  rotation
}
    `;
export const ItemImagesFragmentDoc = gql`
    fragment ItemImages on Item {
  images {
    ...ItemImage
  }
}
    ${ItemImageFragmentDoc}`;
export const AddressCountryCodeDocument = gql`
    query AddressCountryCode($country: String!) {
  addressCountryCode(country: $country)
}
    `;

/**
 * __useAddressCountryCodeQuery__
 *
 * To run a query within a React component, call `useAddressCountryCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressCountryCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressCountryCodeQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useAddressCountryCodeQuery(baseOptions: Apollo.QueryHookOptions<AddressCountryCodeQuery, AddressCountryCodeQueryVariables>) {
        return Apollo.useQuery<AddressCountryCodeQuery, AddressCountryCodeQueryVariables>(AddressCountryCodeDocument, baseOptions);
      }
export function useAddressCountryCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressCountryCodeQuery, AddressCountryCodeQueryVariables>) {
          return Apollo.useLazyQuery<AddressCountryCodeQuery, AddressCountryCodeQueryVariables>(AddressCountryCodeDocument, baseOptions);
        }
export type AddressCountryCodeQueryHookResult = ReturnType<typeof useAddressCountryCodeQuery>;
export type AddressCountryCodeLazyQueryHookResult = ReturnType<typeof useAddressCountryCodeLazyQuery>;
export type AddressCountryCodeQueryResult = Apollo.QueryResult<AddressCountryCodeQuery, AddressCountryCodeQueryVariables>;
export const CommonViewerWithAccountDocument = gql`
    query CommonViewerWithAccount($accountableType: String!) {
  viewer(accountableType: $accountableType) {
    id
    email
    firstName
    lastName
    imageUrl
    currentRole {
      name
    }
    vendorLink {
      id
    }
    accountTypes
    lastAccountTypeUsed
    accounts(accountableType: $accountableType) {
      edges {
        node {
          id
          importConditionAccepted
          state
          firstName
          lastName
          completed
          nbItems
          accountable {
            ... on Expert {
              id
            }
            ... on Vendor {
              id
              stripeConnectAccountId
              stripeConnectOnboardedAt
              vendorPlan {
                ...VendorPlan
              }
            }
            ... on Buyer {
              id
            }
            ... on Writer {
              id
              adminProjectsIds
              vendor {
                id
                vendorPlan {
                  ...VendorPlan
                }
              }
            }
            __typename
          }
        }
      }
    }
  }
}
    ${VendorPlanFragmentDoc}`;

/**
 * __useCommonViewerWithAccountQuery__
 *
 * To run a query within a React component, call `useCommonViewerWithAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonViewerWithAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonViewerWithAccountQuery({
 *   variables: {
 *      accountableType: // value for 'accountableType'
 *   },
 * });
 */
export function useCommonViewerWithAccountQuery(baseOptions: Apollo.QueryHookOptions<CommonViewerWithAccountQuery, CommonViewerWithAccountQueryVariables>) {
        return Apollo.useQuery<CommonViewerWithAccountQuery, CommonViewerWithAccountQueryVariables>(CommonViewerWithAccountDocument, baseOptions);
      }
export function useCommonViewerWithAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommonViewerWithAccountQuery, CommonViewerWithAccountQueryVariables>) {
          return Apollo.useLazyQuery<CommonViewerWithAccountQuery, CommonViewerWithAccountQueryVariables>(CommonViewerWithAccountDocument, baseOptions);
        }
export type CommonViewerWithAccountQueryHookResult = ReturnType<typeof useCommonViewerWithAccountQuery>;
export type CommonViewerWithAccountLazyQueryHookResult = ReturnType<typeof useCommonViewerWithAccountLazyQuery>;
export type CommonViewerWithAccountQueryResult = Apollo.QueryResult<CommonViewerWithAccountQuery, CommonViewerWithAccountQueryVariables>;
export const CommonViewerDocument = gql`
    query CommonViewer {
  viewer {
    id
    currentRole {
      name
    }
    lastAccountTypeUsed
    email
    firstName
    lastName
    imageUrl
  }
}
    `;

/**
 * __useCommonViewerQuery__
 *
 * To run a query within a React component, call `useCommonViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonViewerQuery(baseOptions?: Apollo.QueryHookOptions<CommonViewerQuery, CommonViewerQueryVariables>) {
        return Apollo.useQuery<CommonViewerQuery, CommonViewerQueryVariables>(CommonViewerDocument, baseOptions);
      }
export function useCommonViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommonViewerQuery, CommonViewerQueryVariables>) {
          return Apollo.useLazyQuery<CommonViewerQuery, CommonViewerQueryVariables>(CommonViewerDocument, baseOptions);
        }
export type CommonViewerQueryHookResult = ReturnType<typeof useCommonViewerQuery>;
export type CommonViewerLazyQueryHookResult = ReturnType<typeof useCommonViewerLazyQuery>;
export type CommonViewerQueryResult = Apollo.QueryResult<CommonViewerQuery, CommonViewerQueryVariables>;
export const RotateImageDocument = gql`
    mutation RotateImage($itemId: ID!, $imageId: ID!, $rotation: Int!) {
  rotateImage(input: {itemId: $itemId, imageId: $imageId, rotation: $rotation}) {
    errors
    item {
      id
      images {
        id
        position
        imageUrl
        rotation
      }
    }
  }
}
    `;
export type RotateImageMutationFn = Apollo.MutationFunction<RotateImageMutation, RotateImageMutationVariables>;

/**
 * __useRotateImageMutation__
 *
 * To run a mutation, you first call `useRotateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateImageMutation, { data, loading, error }] = useRotateImageMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      imageId: // value for 'imageId'
 *      rotation: // value for 'rotation'
 *   },
 * });
 */
export function useRotateImageMutation(baseOptions?: Apollo.MutationHookOptions<RotateImageMutation, RotateImageMutationVariables>) {
        return Apollo.useMutation<RotateImageMutation, RotateImageMutationVariables>(RotateImageDocument, baseOptions);
      }
export type RotateImageMutationHookResult = ReturnType<typeof useRotateImageMutation>;
export type RotateImageMutationResult = Apollo.MutationResult<RotateImageMutation>;
export type RotateImageMutationOptions = Apollo.BaseMutationOptions<RotateImageMutation, RotateImageMutationVariables>;
export const BusinessIntroducerDocument = gql`
    query BusinessIntroducer($id: ID!) {
  businessIntroducer(id: $id) {
    ...BusinessIntroducer
  }
}
    ${BusinessIntroducerFragmentDoc}`;

/**
 * __useBusinessIntroducerQuery__
 *
 * To run a query within a React component, call `useBusinessIntroducerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessIntroducerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessIntroducerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessIntroducerQuery(baseOptions: Apollo.QueryHookOptions<BusinessIntroducerQuery, BusinessIntroducerQueryVariables>) {
        return Apollo.useQuery<BusinessIntroducerQuery, BusinessIntroducerQueryVariables>(BusinessIntroducerDocument, baseOptions);
      }
export function useBusinessIntroducerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessIntroducerQuery, BusinessIntroducerQueryVariables>) {
          return Apollo.useLazyQuery<BusinessIntroducerQuery, BusinessIntroducerQueryVariables>(BusinessIntroducerDocument, baseOptions);
        }
export type BusinessIntroducerQueryHookResult = ReturnType<typeof useBusinessIntroducerQuery>;
export type BusinessIntroducerLazyQueryHookResult = ReturnType<typeof useBusinessIntroducerLazyQuery>;
export type BusinessIntroducerQueryResult = Apollo.QueryResult<BusinessIntroducerQuery, BusinessIntroducerQueryVariables>;
export const ThirdPartyIntroducerDocument = gql`
    query ThirdPartyIntroducer($id: ID!) {
  thirdPartyIntroducer(id: $id) {
    ...ThirdPartyIntroducer
  }
}
    ${ThirdPartyIntroducerFragmentDoc}`;

/**
 * __useThirdPartyIntroducerQuery__
 *
 * To run a query within a React component, call `useThirdPartyIntroducerQuery` and pass it any options that fit your needs.
 * When your component renders, `useThirdPartyIntroducerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThirdPartyIntroducerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThirdPartyIntroducerQuery(baseOptions: Apollo.QueryHookOptions<ThirdPartyIntroducerQuery, ThirdPartyIntroducerQueryVariables>) {
        return Apollo.useQuery<ThirdPartyIntroducerQuery, ThirdPartyIntroducerQueryVariables>(ThirdPartyIntroducerDocument, baseOptions);
      }
export function useThirdPartyIntroducerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThirdPartyIntroducerQuery, ThirdPartyIntroducerQueryVariables>) {
          return Apollo.useLazyQuery<ThirdPartyIntroducerQuery, ThirdPartyIntroducerQueryVariables>(ThirdPartyIntroducerDocument, baseOptions);
        }
export type ThirdPartyIntroducerQueryHookResult = ReturnType<typeof useThirdPartyIntroducerQuery>;
export type ThirdPartyIntroducerLazyQueryHookResult = ReturnType<typeof useThirdPartyIntroducerLazyQuery>;
export type ThirdPartyIntroducerQueryResult = Apollo.QueryResult<ThirdPartyIntroducerQuery, ThirdPartyIntroducerQueryVariables>;
export const VendorDocument = gql`
    query Vendor($id: ID!) {
  vendor(id: $id) {
    ...Vendor
  }
}
    ${VendorFragmentDoc}`;

/**
 * __useVendorQuery__
 *
 * To run a query within a React component, call `useVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVendorQuery(baseOptions: Apollo.QueryHookOptions<VendorQuery, VendorQueryVariables>) {
        return Apollo.useQuery<VendorQuery, VendorQueryVariables>(VendorDocument, baseOptions);
      }
export function useVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorQuery, VendorQueryVariables>) {
          return Apollo.useLazyQuery<VendorQuery, VendorQueryVariables>(VendorDocument, baseOptions);
        }
export type VendorQueryHookResult = ReturnType<typeof useVendorQuery>;
export type VendorLazyQueryHookResult = ReturnType<typeof useVendorLazyQuery>;
export type VendorQueryResult = Apollo.QueryResult<VendorQuery, VendorQueryVariables>;
export const BuyerDesireAlertsDocument = gql`
    query BuyerDesireAlerts($id: ID!) {
  desire(id: $id) {
    id
    alerts {
      id
      sentAt
      itemCount
      sale {
        id
        name
      }
      items {
        score
        item {
          id
          title
          state
          startingPrice
          firstImage {
            imageUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBuyerDesireAlertsQuery__
 *
 * To run a query within a React component, call `useBuyerDesireAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerDesireAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerDesireAlertsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuyerDesireAlertsQuery(baseOptions: Apollo.QueryHookOptions<BuyerDesireAlertsQuery, BuyerDesireAlertsQueryVariables>) {
        return Apollo.useQuery<BuyerDesireAlertsQuery, BuyerDesireAlertsQueryVariables>(BuyerDesireAlertsDocument, baseOptions);
      }
export function useBuyerDesireAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerDesireAlertsQuery, BuyerDesireAlertsQueryVariables>) {
          return Apollo.useLazyQuery<BuyerDesireAlertsQuery, BuyerDesireAlertsQueryVariables>(BuyerDesireAlertsDocument, baseOptions);
        }
export type BuyerDesireAlertsQueryHookResult = ReturnType<typeof useBuyerDesireAlertsQuery>;
export type BuyerDesireAlertsLazyQueryHookResult = ReturnType<typeof useBuyerDesireAlertsLazyQuery>;
export type BuyerDesireAlertsQueryResult = Apollo.QueryResult<BuyerDesireAlertsQuery, BuyerDesireAlertsQueryVariables>;
export const BuyersTableDocument = gql`
    query BuyersTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $search: String = null, $purchaseStatus: BuyerPurchaseStatusEnum = null, $desireStatus: BuyerDesireStatusEnum = null, $desireReview: BuyerDesireReviewEnum = null, $engagement: CustomerEngagementEnum = null, $orderBy: ItemOrderType = {attribute: "createdAt", direction: "desc"}) {
  buyers(
    first: $first
    last: $last
    after: $after
    before: $before
    search: $search
    purchaseStatus: $purchaseStatus
    desireStatus: $desireStatus
    desireReview: $desireReview
    engagement: $engagement
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...BuyerTable
      }
    }
  }
}
    ${BuyerTableFragmentDoc}`;

/**
 * __useBuyersTableQuery__
 *
 * To run a query within a React component, call `useBuyersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyersTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      purchaseStatus: // value for 'purchaseStatus'
 *      desireStatus: // value for 'desireStatus'
 *      desireReview: // value for 'desireReview'
 *      engagement: // value for 'engagement'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useBuyersTableQuery(baseOptions?: Apollo.QueryHookOptions<BuyersTableQuery, BuyersTableQueryVariables>) {
        return Apollo.useQuery<BuyersTableQuery, BuyersTableQueryVariables>(BuyersTableDocument, baseOptions);
      }
export function useBuyersTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyersTableQuery, BuyersTableQueryVariables>) {
          return Apollo.useLazyQuery<BuyersTableQuery, BuyersTableQueryVariables>(BuyersTableDocument, baseOptions);
        }
export type BuyersTableQueryHookResult = ReturnType<typeof useBuyersTableQuery>;
export type BuyersTableLazyQueryHookResult = ReturnType<typeof useBuyersTableLazyQuery>;
export type BuyersTableQueryResult = Apollo.QueryResult<BuyersTableQuery, BuyersTableQueryVariables>;
export const GetCategoriesDocument = gql`
    query getCategories($where: ItemCategoryFilter) {
  itemCategories(where: $where) {
    edges {
      node {
        ...CategorySelectField
      }
    }
  }
}
    ${CategorySelectFieldFragmentDoc}`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, baseOptions);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, baseOptions);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($id: ID!, $password: String) {
  updateUser(input: {id: $id, attributes: {password: $password}}) {
    id
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, baseOptions);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const UpdateAccountStateDocument = gql`
    mutation updateAccountState($id: ID!, $state: AccountStateEnum!) {
  customUpdateAccount(input: {id: $id, attributes: {state: $state}}) {
    account {
      id
      state
    }
  }
}
    `;
export type UpdateAccountStateMutationFn = Apollo.MutationFunction<UpdateAccountStateMutation, UpdateAccountStateMutationVariables>;

/**
 * __useUpdateAccountStateMutation__
 *
 * To run a mutation, you first call `useUpdateAccountStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountStateMutation, { data, loading, error }] = useUpdateAccountStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateAccountStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountStateMutation, UpdateAccountStateMutationVariables>) {
        return Apollo.useMutation<UpdateAccountStateMutation, UpdateAccountStateMutationVariables>(UpdateAccountStateDocument, baseOptions);
      }
export type UpdateAccountStateMutationHookResult = ReturnType<typeof useUpdateAccountStateMutation>;
export type UpdateAccountStateMutationResult = Apollo.MutationResult<UpdateAccountStateMutation>;
export type UpdateAccountStateMutationOptions = Apollo.BaseMutationOptions<UpdateAccountStateMutation, UpdateAccountStateMutationVariables>;
export const ContactsTableDocument = gql`
    query ContactsTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $search: String = null, $contactStatus: CustomerContactStatusEnum = null, $emailState: String = null, $purchaseStatus: BuyerPurchaseStatusEnum = null, $desireStatus: BuyerDesireStatusEnum = null, $desireReview: BuyerDesireReviewEnum = null, $minNewsletters: Int = null, $engagement: CustomerEngagementEnum = null, $unsubscribedFrom: CustomerUnsubscriptionKindEnum = null, $orderBy: ItemOrderType = {attribute: "createdAt", direction: "desc"}) {
  customerContacts(
    first: $first
    last: $last
    after: $after
    before: $before
    search: $search
    contactStatus: $contactStatus
    emailState: $emailState
    purchaseStatus: $purchaseStatus
    desireStatus: $desireStatus
    desireReview: $desireReview
    minNewsletters: $minNewsletters
    engagement: $engagement
    unsubscribedFrom: $unsubscribedFrom
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...ContactTable
      }
    }
  }
}
    ${ContactTableFragmentDoc}`;

/**
 * __useContactsTableQuery__
 *
 * To run a query within a React component, call `useContactsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      contactStatus: // value for 'contactStatus'
 *      emailState: // value for 'emailState'
 *      purchaseStatus: // value for 'purchaseStatus'
 *      desireStatus: // value for 'desireStatus'
 *      desireReview: // value for 'desireReview'
 *      minNewsletters: // value for 'minNewsletters'
 *      engagement: // value for 'engagement'
 *      unsubscribedFrom: // value for 'unsubscribedFrom'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useContactsTableQuery(baseOptions?: Apollo.QueryHookOptions<ContactsTableQuery, ContactsTableQueryVariables>) {
        return Apollo.useQuery<ContactsTableQuery, ContactsTableQueryVariables>(ContactsTableDocument, baseOptions);
      }
export function useContactsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsTableQuery, ContactsTableQueryVariables>) {
          return Apollo.useLazyQuery<ContactsTableQuery, ContactsTableQueryVariables>(ContactsTableDocument, baseOptions);
        }
export type ContactsTableQueryHookResult = ReturnType<typeof useContactsTableQuery>;
export type ContactsTableLazyQueryHookResult = ReturnType<typeof useContactsTableLazyQuery>;
export type ContactsTableQueryResult = Apollo.QueryResult<ContactsTableQuery, ContactsTableQueryVariables>;
export const CustomersDocument = gql`
    query Customers($where: CustomerFilter) {
  customers(where: $where, orderBy: {attribute: "updatedAt", direction: "desc"}) {
    edges {
      node {
        ...CustomerTable
      }
    }
  }
}
    ${CustomerTableFragmentDoc}`;

/**
 * __useCustomersQuery__
 *
 * To run a query within a React component, call `useCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCustomersQuery(baseOptions?: Apollo.QueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
        return Apollo.useQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, baseOptions);
      }
export function useCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
          return Apollo.useLazyQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, baseOptions);
        }
export type CustomersQueryHookResult = ReturnType<typeof useCustomersQuery>;
export type CustomersLazyQueryHookResult = ReturnType<typeof useCustomersLazyQuery>;
export type CustomersQueryResult = Apollo.QueryResult<CustomersQuery, CustomersQueryVariables>;
export const CustomerDocument = gql`
    query Customer($id: ID!) {
  customer(id: $id) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, baseOptions);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, baseOptions);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($id: ID!, $attributes: UpdateCustomerInput!) {
  updateCustomer(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    customer {
      id
    }
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, baseOptions);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const DestroyCustomerDocument = gql`
    mutation DestroyCustomer($id: ID!) {
  destroyCustomer(input: {id: $id}) {
    customer {
      id
    }
  }
}
    `;
export type DestroyCustomerMutationFn = Apollo.MutationFunction<DestroyCustomerMutation, DestroyCustomerMutationVariables>;

/**
 * __useDestroyCustomerMutation__
 *
 * To run a mutation, you first call `useDestroyCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyCustomerMutation, { data, loading, error }] = useDestroyCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DestroyCustomerMutation, DestroyCustomerMutationVariables>) {
        return Apollo.useMutation<DestroyCustomerMutation, DestroyCustomerMutationVariables>(DestroyCustomerDocument, baseOptions);
      }
export type DestroyCustomerMutationHookResult = ReturnType<typeof useDestroyCustomerMutation>;
export type DestroyCustomerMutationResult = Apollo.MutationResult<DestroyCustomerMutation>;
export type DestroyCustomerMutationOptions = Apollo.BaseMutationOptions<DestroyCustomerMutation, DestroyCustomerMutationVariables>;
export const DepositSlipsDocument = gql`
    query DepositSlips($where: DepositSlipFilter) {
  depositSlips(
    where: $where
    orderBy: {attribute: "updatedAt", direction: "desc"}
  ) {
    ...DepositSlipEdges
  }
}
    ${DepositSlipEdgesFragmentDoc}`;

/**
 * __useDepositSlipsQuery__
 *
 * To run a query within a React component, call `useDepositSlipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepositSlipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepositSlipsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDepositSlipsQuery(baseOptions?: Apollo.QueryHookOptions<DepositSlipsQuery, DepositSlipsQueryVariables>) {
        return Apollo.useQuery<DepositSlipsQuery, DepositSlipsQueryVariables>(DepositSlipsDocument, baseOptions);
      }
export function useDepositSlipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepositSlipsQuery, DepositSlipsQueryVariables>) {
          return Apollo.useLazyQuery<DepositSlipsQuery, DepositSlipsQueryVariables>(DepositSlipsDocument, baseOptions);
        }
export type DepositSlipsQueryHookResult = ReturnType<typeof useDepositSlipsQuery>;
export type DepositSlipsLazyQueryHookResult = ReturnType<typeof useDepositSlipsLazyQuery>;
export type DepositSlipsQueryResult = Apollo.QueryResult<DepositSlipsQuery, DepositSlipsQueryVariables>;
export const UpdateDesireDocument = gql`
    mutation UpdateDesire($input: UpdateDesireMutationInput!) {
  updateDesire(input: $input) {
    desire {
      id
      title
      validated
      searchTitleEnabled
      searchDescriptionEnabled
      searchArtistsEnabled
      searchTagsEnabled
    }
  }
}
    `;
export type UpdateDesireMutationFn = Apollo.MutationFunction<UpdateDesireMutation, UpdateDesireMutationVariables>;

/**
 * __useUpdateDesireMutation__
 *
 * To run a mutation, you first call `useUpdateDesireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDesireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDesireMutation, { data, loading, error }] = useUpdateDesireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDesireMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDesireMutation, UpdateDesireMutationVariables>) {
        return Apollo.useMutation<UpdateDesireMutation, UpdateDesireMutationVariables>(UpdateDesireDocument, baseOptions);
      }
export type UpdateDesireMutationHookResult = ReturnType<typeof useUpdateDesireMutation>;
export type UpdateDesireMutationResult = Apollo.MutationResult<UpdateDesireMutation>;
export type UpdateDesireMutationOptions = Apollo.BaseMutationOptions<UpdateDesireMutation, UpdateDesireMutationVariables>;
export const CreateDesireDocument = gql`
    mutation CreateDesire($input: CreateDesireMutationInput!) {
  createDesire(input: $input) {
    desire {
      id
    }
  }
}
    `;
export type CreateDesireMutationFn = Apollo.MutationFunction<CreateDesireMutation, CreateDesireMutationVariables>;

/**
 * __useCreateDesireMutation__
 *
 * To run a mutation, you first call `useCreateDesireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDesireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDesireMutation, { data, loading, error }] = useCreateDesireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDesireMutation(baseOptions?: Apollo.MutationHookOptions<CreateDesireMutation, CreateDesireMutationVariables>) {
        return Apollo.useMutation<CreateDesireMutation, CreateDesireMutationVariables>(CreateDesireDocument, baseOptions);
      }
export type CreateDesireMutationHookResult = ReturnType<typeof useCreateDesireMutation>;
export type CreateDesireMutationResult = Apollo.MutationResult<CreateDesireMutation>;
export type CreateDesireMutationOptions = Apollo.BaseMutationOptions<CreateDesireMutation, CreateDesireMutationVariables>;
export const DestroyDesireDocument = gql`
    mutation DestroyDesire($input: DestroyDesireMutationInput!) {
  destroyDesire(input: $input) {
    desire {
      id
    }
  }
}
    `;
export type DestroyDesireMutationFn = Apollo.MutationFunction<DestroyDesireMutation, DestroyDesireMutationVariables>;

/**
 * __useDestroyDesireMutation__
 *
 * To run a mutation, you first call `useDestroyDesireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyDesireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyDesireMutation, { data, loading, error }] = useDestroyDesireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyDesireMutation(baseOptions?: Apollo.MutationHookOptions<DestroyDesireMutation, DestroyDesireMutationVariables>) {
        return Apollo.useMutation<DestroyDesireMutation, DestroyDesireMutationVariables>(DestroyDesireDocument, baseOptions);
      }
export type DestroyDesireMutationHookResult = ReturnType<typeof useDestroyDesireMutation>;
export type DestroyDesireMutationResult = Apollo.MutationResult<DestroyDesireMutation>;
export type DestroyDesireMutationOptions = Apollo.BaseMutationOptions<DestroyDesireMutation, DestroyDesireMutationVariables>;
export const DesireDocument = gql`
    query Desire($id: ID!) {
  desire(id: $id) {
    ...Desire
  }
}
    ${DesireFragmentDoc}`;

/**
 * __useDesireQuery__
 *
 * To run a query within a React component, call `useDesireQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesireQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDesireQuery(baseOptions: Apollo.QueryHookOptions<DesireQuery, DesireQueryVariables>) {
        return Apollo.useQuery<DesireQuery, DesireQueryVariables>(DesireDocument, baseOptions);
      }
export function useDesireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesireQuery, DesireQueryVariables>) {
          return Apollo.useLazyQuery<DesireQuery, DesireQueryVariables>(DesireDocument, baseOptions);
        }
export type DesireQueryHookResult = ReturnType<typeof useDesireQuery>;
export type DesireLazyQueryHookResult = ReturnType<typeof useDesireLazyQuery>;
export type DesireQueryResult = Apollo.QueryResult<DesireQuery, DesireQueryVariables>;
export const DesiresDocument = gql`
    query Desires($where: DesireFilter, $unusable: Boolean = null, $first: Int = 20, $last: Int = null, $after: String = null, $before: String = null) {
  desires(
    where: $where
    unusable: $unusable
    orderBy: {attribute: "updatedAt", direction: "desc"}
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    ...DesireEdges
  }
}
    ${DesireEdgesFragmentDoc}`;

/**
 * __useDesiresQuery__
 *
 * To run a query within a React component, call `useDesiresQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesiresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesiresQuery({
 *   variables: {
 *      where: // value for 'where'
 *      unusable: // value for 'unusable'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useDesiresQuery(baseOptions?: Apollo.QueryHookOptions<DesiresQuery, DesiresQueryVariables>) {
        return Apollo.useQuery<DesiresQuery, DesiresQueryVariables>(DesiresDocument, baseOptions);
      }
export function useDesiresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesiresQuery, DesiresQueryVariables>) {
          return Apollo.useLazyQuery<DesiresQuery, DesiresQueryVariables>(DesiresDocument, baseOptions);
        }
export type DesiresQueryHookResult = ReturnType<typeof useDesiresQuery>;
export type DesiresLazyQueryHookResult = ReturnType<typeof useDesiresLazyQuery>;
export type DesiresQueryResult = Apollo.QueryResult<DesiresQuery, DesiresQueryVariables>;
export const SplitDesireDocument = gql`
    mutation SplitDesire($input: SplitDesireMutationInput!) {
  splitDesire(input: $input) {
    desires {
      id
      title
    }
    errors
  }
}
    `;
export type SplitDesireMutationFn = Apollo.MutationFunction<SplitDesireMutation, SplitDesireMutationVariables>;

/**
 * __useSplitDesireMutation__
 *
 * To run a mutation, you first call `useSplitDesireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitDesireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitDesireMutation, { data, loading, error }] = useSplitDesireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSplitDesireMutation(baseOptions?: Apollo.MutationHookOptions<SplitDesireMutation, SplitDesireMutationVariables>) {
        return Apollo.useMutation<SplitDesireMutation, SplitDesireMutationVariables>(SplitDesireDocument, baseOptions);
      }
export type SplitDesireMutationHookResult = ReturnType<typeof useSplitDesireMutation>;
export type SplitDesireMutationResult = Apollo.MutationResult<SplitDesireMutation>;
export type SplitDesireMutationOptions = Apollo.BaseMutationOptions<SplitDesireMutation, SplitDesireMutationVariables>;
export const MarkDesiresReviewedDocument = gql`
    mutation MarkDesiresReviewed($buyerId: ID, $customerId: ID, $reviewed: Boolean = true) {
  markDesiresReviewed(
    input: {buyerId: $buyerId, customerId: $customerId, reviewed: $reviewed}
  ) {
    errors
    buyer {
      id
      desiresReviewedAt
      desiresReviewedBy
    }
    customer {
      id
      desiresReviewedAt
      desiresReviewedBy
    }
  }
}
    `;
export type MarkDesiresReviewedMutationFn = Apollo.MutationFunction<MarkDesiresReviewedMutation, MarkDesiresReviewedMutationVariables>;

/**
 * __useMarkDesiresReviewedMutation__
 *
 * To run a mutation, you first call `useMarkDesiresReviewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDesiresReviewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDesiresReviewedMutation, { data, loading, error }] = useMarkDesiresReviewedMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      customerId: // value for 'customerId'
 *      reviewed: // value for 'reviewed'
 *   },
 * });
 */
export function useMarkDesiresReviewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkDesiresReviewedMutation, MarkDesiresReviewedMutationVariables>) {
        return Apollo.useMutation<MarkDesiresReviewedMutation, MarkDesiresReviewedMutationVariables>(MarkDesiresReviewedDocument, baseOptions);
      }
export type MarkDesiresReviewedMutationHookResult = ReturnType<typeof useMarkDesiresReviewedMutation>;
export type MarkDesiresReviewedMutationResult = Apollo.MutationResult<MarkDesiresReviewedMutation>;
export type MarkDesiresReviewedMutationOptions = Apollo.BaseMutationOptions<MarkDesiresReviewedMutation, MarkDesiresReviewedMutationVariables>;
export const MoveSaleItemsToVacationDocument = gql`
    mutation MoveSaleItemsToVacation($saleId: ID!, $vacationId: ID!, $itemIds: [ID!]!) {
  moveSaleItemsToVacation(
    input: {saleId: $saleId, vacationId: $vacationId, itemIds: $itemIds}
  ) {
    movedCount
    errors
    blockingItems {
      id
    }
    vacation {
      id
      name
    }
  }
}
    `;
export type MoveSaleItemsToVacationMutationFn = Apollo.MutationFunction<MoveSaleItemsToVacationMutation, MoveSaleItemsToVacationMutationVariables>;

/**
 * __useMoveSaleItemsToVacationMutation__
 *
 * To run a mutation, you first call `useMoveSaleItemsToVacationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveSaleItemsToVacationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveSaleItemsToVacationMutation, { data, loading, error }] = useMoveSaleItemsToVacationMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      vacationId: // value for 'vacationId'
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function useMoveSaleItemsToVacationMutation(baseOptions?: Apollo.MutationHookOptions<MoveSaleItemsToVacationMutation, MoveSaleItemsToVacationMutationVariables>) {
        return Apollo.useMutation<MoveSaleItemsToVacationMutation, MoveSaleItemsToVacationMutationVariables>(MoveSaleItemsToVacationDocument, baseOptions);
      }
export type MoveSaleItemsToVacationMutationHookResult = ReturnType<typeof useMoveSaleItemsToVacationMutation>;
export type MoveSaleItemsToVacationMutationResult = Apollo.MutationResult<MoveSaleItemsToVacationMutation>;
export type MoveSaleItemsToVacationMutationOptions = Apollo.BaseMutationOptions<MoveSaleItemsToVacationMutation, MoveSaleItemsToVacationMutationVariables>;
export const UploadImageInItemDocument = gql`
    mutation UploadImageInItem($id: ID!, $images: [UploadImageInput!]) {
  updateItem(input: {id: $id, attributes: {images: $images}}) {
    clientMutationId
    item {
      title
      images {
        id
        imageUrl
        position
      }
    }
  }
}
    `;
export type UploadImageInItemMutationFn = Apollo.MutationFunction<UploadImageInItemMutation, UploadImageInItemMutationVariables>;

/**
 * __useUploadImageInItemMutation__
 *
 * To run a mutation, you first call `useUploadImageInItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageInItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageInItemMutation, { data, loading, error }] = useUploadImageInItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useUploadImageInItemMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageInItemMutation, UploadImageInItemMutationVariables>) {
        return Apollo.useMutation<UploadImageInItemMutation, UploadImageInItemMutationVariables>(UploadImageInItemDocument, baseOptions);
      }
export type UploadImageInItemMutationHookResult = ReturnType<typeof useUploadImageInItemMutation>;
export type UploadImageInItemMutationResult = Apollo.MutationResult<UploadImageInItemMutation>;
export type UploadImageInItemMutationOptions = Apollo.BaseMutationOptions<UploadImageInItemMutation, UploadImageInItemMutationVariables>;
export const UploadInvoiceInItemDocument = gql`
    mutation UploadInvoiceInItem($id: ID!, $files: [UploadFileInput!]) {
  updateItem(input: {id: $id, attributes: {invoices: $files}}) {
    clientMutationId
    item {
      title
      invoices {
        imageUrl
      }
    }
  }
}
    `;
export type UploadInvoiceInItemMutationFn = Apollo.MutationFunction<UploadInvoiceInItemMutation, UploadInvoiceInItemMutationVariables>;

/**
 * __useUploadInvoiceInItemMutation__
 *
 * To run a mutation, you first call `useUploadInvoiceInItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInvoiceInItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInvoiceInItemMutation, { data, loading, error }] = useUploadInvoiceInItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadInvoiceInItemMutation(baseOptions?: Apollo.MutationHookOptions<UploadInvoiceInItemMutation, UploadInvoiceInItemMutationVariables>) {
        return Apollo.useMutation<UploadInvoiceInItemMutation, UploadInvoiceInItemMutationVariables>(UploadInvoiceInItemDocument, baseOptions);
      }
export type UploadInvoiceInItemMutationHookResult = ReturnType<typeof useUploadInvoiceInItemMutation>;
export type UploadInvoiceInItemMutationResult = Apollo.MutationResult<UploadInvoiceInItemMutation>;
export type UploadInvoiceInItemMutationOptions = Apollo.BaseMutationOptions<UploadInvoiceInItemMutation, UploadInvoiceInItemMutationVariables>;
export const UploadAuthenticityDocumentInItemDocument = gql`
    mutation UploadAuthenticityDocumentInItem($id: ID!, $files: [UploadFileInput!]) {
  updateItem(input: {id: $id, attributes: {authenticityDocuments: $files}}) {
    clientMutationId
    item {
      title
      authenticityDocuments {
        imageUrl
      }
    }
  }
}
    `;
export type UploadAuthenticityDocumentInItemMutationFn = Apollo.MutationFunction<UploadAuthenticityDocumentInItemMutation, UploadAuthenticityDocumentInItemMutationVariables>;

/**
 * __useUploadAuthenticityDocumentInItemMutation__
 *
 * To run a mutation, you first call `useUploadAuthenticityDocumentInItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAuthenticityDocumentInItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAuthenticityDocumentInItemMutation, { data, loading, error }] = useUploadAuthenticityDocumentInItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadAuthenticityDocumentInItemMutation(baseOptions?: Apollo.MutationHookOptions<UploadAuthenticityDocumentInItemMutation, UploadAuthenticityDocumentInItemMutationVariables>) {
        return Apollo.useMutation<UploadAuthenticityDocumentInItemMutation, UploadAuthenticityDocumentInItemMutationVariables>(UploadAuthenticityDocumentInItemDocument, baseOptions);
      }
export type UploadAuthenticityDocumentInItemMutationHookResult = ReturnType<typeof useUploadAuthenticityDocumentInItemMutation>;
export type UploadAuthenticityDocumentInItemMutationResult = Apollo.MutationResult<UploadAuthenticityDocumentInItemMutation>;
export type UploadAuthenticityDocumentInItemMutationOptions = Apollo.BaseMutationOptions<UploadAuthenticityDocumentInItemMutation, UploadAuthenticityDocumentInItemMutationVariables>;
export const UpdateAccountEmailStateDocument = gql`
    mutation UpdateAccountEmailState($id: ID!, $emailState: EmailStateEnum!) {
  customUpdateAccount(input: {id: $id, attributes: {emailState: $emailState}}) {
    errors {
      fullMessages
    }
    account {
      id
      emailState
    }
  }
}
    `;
export type UpdateAccountEmailStateMutationFn = Apollo.MutationFunction<UpdateAccountEmailStateMutation, UpdateAccountEmailStateMutationVariables>;

/**
 * __useUpdateAccountEmailStateMutation__
 *
 * To run a mutation, you first call `useUpdateAccountEmailStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountEmailStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountEmailStateMutation, { data, loading, error }] = useUpdateAccountEmailStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emailState: // value for 'emailState'
 *   },
 * });
 */
export function useUpdateAccountEmailStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountEmailStateMutation, UpdateAccountEmailStateMutationVariables>) {
        return Apollo.useMutation<UpdateAccountEmailStateMutation, UpdateAccountEmailStateMutationVariables>(UpdateAccountEmailStateDocument, baseOptions);
      }
export type UpdateAccountEmailStateMutationHookResult = ReturnType<typeof useUpdateAccountEmailStateMutation>;
export type UpdateAccountEmailStateMutationResult = Apollo.MutationResult<UpdateAccountEmailStateMutation>;
export type UpdateAccountEmailStateMutationOptions = Apollo.BaseMutationOptions<UpdateAccountEmailStateMutation, UpdateAccountEmailStateMutationVariables>;
export const UpdateCustomerEmailStateDocument = gql`
    mutation UpdateCustomerEmailState($id: ID!, $email: String!, $emailState: EmailStateEnum!) {
  updateCustomer(
    input: {id: $id, attributes: {email: $email, emailState: $emailState}}
  ) {
    errors {
      fullMessages
    }
    customer {
      id
      emailState
    }
  }
}
    `;
export type UpdateCustomerEmailStateMutationFn = Apollo.MutationFunction<UpdateCustomerEmailStateMutation, UpdateCustomerEmailStateMutationVariables>;

/**
 * __useUpdateCustomerEmailStateMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerEmailStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerEmailStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerEmailStateMutation, { data, loading, error }] = useUpdateCustomerEmailStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      emailState: // value for 'emailState'
 *   },
 * });
 */
export function useUpdateCustomerEmailStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerEmailStateMutation, UpdateCustomerEmailStateMutationVariables>) {
        return Apollo.useMutation<UpdateCustomerEmailStateMutation, UpdateCustomerEmailStateMutationVariables>(UpdateCustomerEmailStateDocument, baseOptions);
      }
export type UpdateCustomerEmailStateMutationHookResult = ReturnType<typeof useUpdateCustomerEmailStateMutation>;
export type UpdateCustomerEmailStateMutationResult = Apollo.MutationResult<UpdateCustomerEmailStateMutation>;
export type UpdateCustomerEmailStateMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerEmailStateMutation, UpdateCustomerEmailStateMutationVariables>;
export const UpdateItemStepDocument = gql`
    mutation UpdateItemStep($id: ID!, $attributes: UpdateItemStepInput!) {
  updateItemStep(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    itemStep {
      id
    }
  }
}
    `;
export type UpdateItemStepMutationFn = Apollo.MutationFunction<UpdateItemStepMutation, UpdateItemStepMutationVariables>;

/**
 * __useUpdateItemStepMutation__
 *
 * To run a mutation, you first call `useUpdateItemStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemStepMutation, { data, loading, error }] = useUpdateItemStepMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateItemStepMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemStepMutation, UpdateItemStepMutationVariables>) {
        return Apollo.useMutation<UpdateItemStepMutation, UpdateItemStepMutationVariables>(UpdateItemStepDocument, baseOptions);
      }
export type UpdateItemStepMutationHookResult = ReturnType<typeof useUpdateItemStepMutation>;
export type UpdateItemStepMutationResult = Apollo.MutationResult<UpdateItemStepMutation>;
export type UpdateItemStepMutationOptions = Apollo.BaseMutationOptions<UpdateItemStepMutation, UpdateItemStepMutationVariables>;
export const UpdateExpertAccountDocument = gql`
    mutation UpdateExpertAccount($id: ID!, $attributes: UpdateAccountInput!) {
  customUpdateAccount(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    account {
      id
      firstName
      lastName
      email
      state
      accountable {
        ... on Expert {
          id
        }
        ... on Vendor {
          id
        }
        ... on Buyer {
          id
        }
        ... on Writer {
          id
        }
        __typename
      }
    }
  }
}
    `;
export type UpdateExpertAccountMutationFn = Apollo.MutationFunction<UpdateExpertAccountMutation, UpdateExpertAccountMutationVariables>;

/**
 * __useUpdateExpertAccountMutation__
 *
 * To run a mutation, you first call `useUpdateExpertAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpertAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpertAccountMutation, { data, loading, error }] = useUpdateExpertAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateExpertAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpertAccountMutation, UpdateExpertAccountMutationVariables>) {
        return Apollo.useMutation<UpdateExpertAccountMutation, UpdateExpertAccountMutationVariables>(UpdateExpertAccountDocument, baseOptions);
      }
export type UpdateExpertAccountMutationHookResult = ReturnType<typeof useUpdateExpertAccountMutation>;
export type UpdateExpertAccountMutationResult = Apollo.MutationResult<UpdateExpertAccountMutation>;
export type UpdateExpertAccountMutationOptions = Apollo.BaseMutationOptions<UpdateExpertAccountMutation, UpdateExpertAccountMutationVariables>;
export const ExpertOnboardingChecklistDocument = gql`
    query ExpertOnboardingChecklist($accountId: ID!) {
  account(id: $accountId) {
    ...OnboardingAccount
  }
}
    ${OnboardingAccountFragmentDoc}`;

/**
 * __useExpertOnboardingChecklistQuery__
 *
 * To run a query within a React component, call `useExpertOnboardingChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertOnboardingChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertOnboardingChecklistQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useExpertOnboardingChecklistQuery(baseOptions: Apollo.QueryHookOptions<ExpertOnboardingChecklistQuery, ExpertOnboardingChecklistQueryVariables>) {
        return Apollo.useQuery<ExpertOnboardingChecklistQuery, ExpertOnboardingChecklistQueryVariables>(ExpertOnboardingChecklistDocument, baseOptions);
      }
export function useExpertOnboardingChecklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertOnboardingChecklistQuery, ExpertOnboardingChecklistQueryVariables>) {
          return Apollo.useLazyQuery<ExpertOnboardingChecklistQuery, ExpertOnboardingChecklistQueryVariables>(ExpertOnboardingChecklistDocument, baseOptions);
        }
export type ExpertOnboardingChecklistQueryHookResult = ReturnType<typeof useExpertOnboardingChecklistQuery>;
export type ExpertOnboardingChecklistLazyQueryHookResult = ReturnType<typeof useExpertOnboardingChecklistLazyQuery>;
export type ExpertOnboardingChecklistQueryResult = Apollo.QueryResult<ExpertOnboardingChecklistQuery, ExpertOnboardingChecklistQueryVariables>;
export const ExpertPaymentTableDocument = gql`
    query ExpertPaymentTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $where: ExpertPaymentFilter) {
  expertPayments(
    first: $first
    last: $last
    after: $after
    before: $before
    where: $where
    orderBy: {attribute: "createdAt", direction: "desc"}
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...ExpertPaymentTable
      }
    }
  }
}
    ${ExpertPaymentTableFragmentDoc}`;

/**
 * __useExpertPaymentTableQuery__
 *
 * To run a query within a React component, call `useExpertPaymentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertPaymentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertPaymentTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExpertPaymentTableQuery(baseOptions?: Apollo.QueryHookOptions<ExpertPaymentTableQuery, ExpertPaymentTableQueryVariables>) {
        return Apollo.useQuery<ExpertPaymentTableQuery, ExpertPaymentTableQueryVariables>(ExpertPaymentTableDocument, baseOptions);
      }
export function useExpertPaymentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertPaymentTableQuery, ExpertPaymentTableQueryVariables>) {
          return Apollo.useLazyQuery<ExpertPaymentTableQuery, ExpertPaymentTableQueryVariables>(ExpertPaymentTableDocument, baseOptions);
        }
export type ExpertPaymentTableQueryHookResult = ReturnType<typeof useExpertPaymentTableQuery>;
export type ExpertPaymentTableLazyQueryHookResult = ReturnType<typeof useExpertPaymentTableLazyQuery>;
export type ExpertPaymentTableQueryResult = Apollo.QueryResult<ExpertPaymentTableQuery, ExpertPaymentTableQueryVariables>;
export const GetExpertsDocument = gql`
    query getExperts($where: ExpertFilter) {
  experts(where: $where) {
    edges {
      node {
        ...ExpertSelectField
      }
    }
  }
}
    ${ExpertSelectFieldFragmentDoc}`;

/**
 * __useGetExpertsQuery__
 *
 * To run a query within a React component, call `useGetExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpertsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetExpertsQuery(baseOptions?: Apollo.QueryHookOptions<GetExpertsQuery, GetExpertsQueryVariables>) {
        return Apollo.useQuery<GetExpertsQuery, GetExpertsQueryVariables>(GetExpertsDocument, baseOptions);
      }
export function useGetExpertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpertsQuery, GetExpertsQueryVariables>) {
          return Apollo.useLazyQuery<GetExpertsQuery, GetExpertsQueryVariables>(GetExpertsDocument, baseOptions);
        }
export type GetExpertsQueryHookResult = ReturnType<typeof useGetExpertsQuery>;
export type GetExpertsLazyQueryHookResult = ReturnType<typeof useGetExpertsLazyQuery>;
export type GetExpertsQueryResult = Apollo.QueryResult<GetExpertsQuery, GetExpertsQueryVariables>;
export const ExpertStatementPaymentTableDocument = gql`
    query ExpertStatementPaymentTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $where: ExpertStatementPaymentFilter) {
  expertStatementPayments(
    first: $first
    last: $last
    after: $after
    before: $before
    where: $where
    orderBy: {attribute: "createdAt", direction: "desc"}
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...ExpertStatementPaymentTable
      }
    }
  }
}
    ${ExpertStatementPaymentTableFragmentDoc}`;

/**
 * __useExpertStatementPaymentTableQuery__
 *
 * To run a query within a React component, call `useExpertStatementPaymentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertStatementPaymentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertStatementPaymentTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExpertStatementPaymentTableQuery(baseOptions?: Apollo.QueryHookOptions<ExpertStatementPaymentTableQuery, ExpertStatementPaymentTableQueryVariables>) {
        return Apollo.useQuery<ExpertStatementPaymentTableQuery, ExpertStatementPaymentTableQueryVariables>(ExpertStatementPaymentTableDocument, baseOptions);
      }
export function useExpertStatementPaymentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertStatementPaymentTableQuery, ExpertStatementPaymentTableQueryVariables>) {
          return Apollo.useLazyQuery<ExpertStatementPaymentTableQuery, ExpertStatementPaymentTableQueryVariables>(ExpertStatementPaymentTableDocument, baseOptions);
        }
export type ExpertStatementPaymentTableQueryHookResult = ReturnType<typeof useExpertStatementPaymentTableQuery>;
export type ExpertStatementPaymentTableLazyQueryHookResult = ReturnType<typeof useExpertStatementPaymentTableLazyQuery>;
export type ExpertStatementPaymentTableQueryResult = Apollo.QueryResult<ExpertStatementPaymentTableQuery, ExpertStatementPaymentTableQueryVariables>;
export const ExpertsTableDocument = gql`
    query ExpertsTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $where: ExpertFilter) {
  experts(
    first: $first
    last: $last
    after: $after
    before: $before
    where: $where
    orderBy: {attribute: "updatedAt", direction: "desc"}
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...ExpertTable
      }
    }
  }
}
    ${ExpertTableFragmentDoc}`;

/**
 * __useExpertsTableQuery__
 *
 * To run a query within a React component, call `useExpertsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertsTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExpertsTableQuery(baseOptions?: Apollo.QueryHookOptions<ExpertsTableQuery, ExpertsTableQueryVariables>) {
        return Apollo.useQuery<ExpertsTableQuery, ExpertsTableQueryVariables>(ExpertsTableDocument, baseOptions);
      }
export function useExpertsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertsTableQuery, ExpertsTableQueryVariables>) {
          return Apollo.useLazyQuery<ExpertsTableQuery, ExpertsTableQueryVariables>(ExpertsTableDocument, baseOptions);
        }
export type ExpertsTableQueryHookResult = ReturnType<typeof useExpertsTableQuery>;
export type ExpertsTableLazyQueryHookResult = ReturnType<typeof useExpertsTableLazyQuery>;
export type ExpertsTableQueryResult = Apollo.QueryResult<ExpertsTableQuery, ExpertsTableQueryVariables>;
export const FreshdeskWidgetAccountDocument = gql`
    query FreshdeskWidgetAccount($accountableType: String!) {
  viewer(accountableType: $accountableType) {
    id
    accounts(accountableType: $accountableType) {
      edges {
        node {
          id
          freshdeskWidgetToken
        }
      }
    }
  }
}
    `;

/**
 * __useFreshdeskWidgetAccountQuery__
 *
 * To run a query within a React component, call `useFreshdeskWidgetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFreshdeskWidgetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFreshdeskWidgetAccountQuery({
 *   variables: {
 *      accountableType: // value for 'accountableType'
 *   },
 * });
 */
export function useFreshdeskWidgetAccountQuery(baseOptions: Apollo.QueryHookOptions<FreshdeskWidgetAccountQuery, FreshdeskWidgetAccountQueryVariables>) {
        return Apollo.useQuery<FreshdeskWidgetAccountQuery, FreshdeskWidgetAccountQueryVariables>(FreshdeskWidgetAccountDocument, baseOptions);
      }
export function useFreshdeskWidgetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FreshdeskWidgetAccountQuery, FreshdeskWidgetAccountQueryVariables>) {
          return Apollo.useLazyQuery<FreshdeskWidgetAccountQuery, FreshdeskWidgetAccountQueryVariables>(FreshdeskWidgetAccountDocument, baseOptions);
        }
export type FreshdeskWidgetAccountQueryHookResult = ReturnType<typeof useFreshdeskWidgetAccountQuery>;
export type FreshdeskWidgetAccountLazyQueryHookResult = ReturnType<typeof useFreshdeskWidgetAccountLazyQuery>;
export type FreshdeskWidgetAccountQueryResult = Apollo.QueryResult<FreshdeskWidgetAccountQuery, FreshdeskWidgetAccountQueryVariables>;
export const ImportPaymentTableDocument = gql`
    query ImportPaymentTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $where: ImportPaymentFilter) {
  importPayments(
    first: $first
    last: $last
    after: $after
    before: $before
    where: $where
    orderBy: {attribute: "createdAt", direction: "desc"}
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...ImportPaymentTable
      }
    }
  }
}
    ${ImportPaymentTableFragmentDoc}`;

/**
 * __useImportPaymentTableQuery__
 *
 * To run a query within a React component, call `useImportPaymentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportPaymentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportPaymentTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useImportPaymentTableQuery(baseOptions?: Apollo.QueryHookOptions<ImportPaymentTableQuery, ImportPaymentTableQueryVariables>) {
        return Apollo.useQuery<ImportPaymentTableQuery, ImportPaymentTableQueryVariables>(ImportPaymentTableDocument, baseOptions);
      }
export function useImportPaymentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportPaymentTableQuery, ImportPaymentTableQueryVariables>) {
          return Apollo.useLazyQuery<ImportPaymentTableQuery, ImportPaymentTableQueryVariables>(ImportPaymentTableDocument, baseOptions);
        }
export type ImportPaymentTableQueryHookResult = ReturnType<typeof useImportPaymentTableQuery>;
export type ImportPaymentTableLazyQueryHookResult = ReturnType<typeof useImportPaymentTableLazyQuery>;
export type ImportPaymentTableQueryResult = Apollo.QueryResult<ImportPaymentTableQuery, ImportPaymentTableQueryVariables>;
export const ImportStatementPaymentTableDocument = gql`
    query ImportStatementPaymentTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $where: ImportStatementPaymentFilter) {
  importStatementPayments(
    first: $first
    last: $last
    after: $after
    before: $before
    where: $where
    orderBy: {attribute: "createdAt", direction: "desc"}
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...ImportStatementPaymentTable
      }
    }
  }
}
    ${ImportStatementPaymentTableFragmentDoc}`;

/**
 * __useImportStatementPaymentTableQuery__
 *
 * To run a query within a React component, call `useImportStatementPaymentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportStatementPaymentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportStatementPaymentTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useImportStatementPaymentTableQuery(baseOptions?: Apollo.QueryHookOptions<ImportStatementPaymentTableQuery, ImportStatementPaymentTableQueryVariables>) {
        return Apollo.useQuery<ImportStatementPaymentTableQuery, ImportStatementPaymentTableQueryVariables>(ImportStatementPaymentTableDocument, baseOptions);
      }
export function useImportStatementPaymentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportStatementPaymentTableQuery, ImportStatementPaymentTableQueryVariables>) {
          return Apollo.useLazyQuery<ImportStatementPaymentTableQuery, ImportStatementPaymentTableQueryVariables>(ImportStatementPaymentTableDocument, baseOptions);
        }
export type ImportStatementPaymentTableQueryHookResult = ReturnType<typeof useImportStatementPaymentTableQuery>;
export type ImportStatementPaymentTableLazyQueryHookResult = ReturnType<typeof useImportStatementPaymentTableLazyQuery>;
export type ImportStatementPaymentTableQueryResult = Apollo.QueryResult<ImportStatementPaymentTableQuery, ImportStatementPaymentTableQueryVariables>;
export const ItemChangeExpertListDocument = gql`
    query ItemChangeExpertList($meta: String) {
  experts(
    first: 20
    where: {meta: $meta}
    orderBy: {attribute: "updatedAt", direction: "desc"}
  ) {
    edges {
      node {
        ...ItemExpert
      }
    }
  }
}
    ${ItemExpertFragmentDoc}`;

/**
 * __useItemChangeExpertListQuery__
 *
 * To run a query within a React component, call `useItemChangeExpertListQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemChangeExpertListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemChangeExpertListQuery({
 *   variables: {
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useItemChangeExpertListQuery(baseOptions?: Apollo.QueryHookOptions<ItemChangeExpertListQuery, ItemChangeExpertListQueryVariables>) {
        return Apollo.useQuery<ItemChangeExpertListQuery, ItemChangeExpertListQueryVariables>(ItemChangeExpertListDocument, baseOptions);
      }
export function useItemChangeExpertListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemChangeExpertListQuery, ItemChangeExpertListQueryVariables>) {
          return Apollo.useLazyQuery<ItemChangeExpertListQuery, ItemChangeExpertListQueryVariables>(ItemChangeExpertListDocument, baseOptions);
        }
export type ItemChangeExpertListQueryHookResult = ReturnType<typeof useItemChangeExpertListQuery>;
export type ItemChangeExpertListLazyQueryHookResult = ReturnType<typeof useItemChangeExpertListLazyQuery>;
export type ItemChangeExpertListQueryResult = Apollo.QueryResult<ItemChangeExpertListQuery, ItemChangeExpertListQueryVariables>;
export const UpdateItemExpertDocument = gql`
    mutation UpdateItemExpert($id: ID!, $expertId: ID!) {
  updateItemExpert(input: {id: $id, expertId: $expertId}) {
    item {
      id
      expert {
        ...ItemExpert
      }
    }
    errors
  }
}
    ${ItemExpertFragmentDoc}`;
export type UpdateItemExpertMutationFn = Apollo.MutationFunction<UpdateItemExpertMutation, UpdateItemExpertMutationVariables>;

/**
 * __useUpdateItemExpertMutation__
 *
 * To run a mutation, you first call `useUpdateItemExpertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemExpertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemExpertMutation, { data, loading, error }] = useUpdateItemExpertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      expertId: // value for 'expertId'
 *   },
 * });
 */
export function useUpdateItemExpertMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemExpertMutation, UpdateItemExpertMutationVariables>) {
        return Apollo.useMutation<UpdateItemExpertMutation, UpdateItemExpertMutationVariables>(UpdateItemExpertDocument, baseOptions);
      }
export type UpdateItemExpertMutationHookResult = ReturnType<typeof useUpdateItemExpertMutation>;
export type UpdateItemExpertMutationResult = Apollo.MutationResult<UpdateItemExpertMutation>;
export type UpdateItemExpertMutationOptions = Apollo.BaseMutationOptions<UpdateItemExpertMutation, UpdateItemExpertMutationVariables>;
export const ArtistDocument = gql`
    query Artist($where: ArtistFilter) {
  artists(where: $where) {
    edges {
      node {
        id
        firstName
        lastName
        tag
        itemCategoryId
      }
    }
  }
}
    `;

/**
 * __useArtistQuery__
 *
 * To run a query within a React component, call `useArtistQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtistQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useArtistQuery(baseOptions?: Apollo.QueryHookOptions<ArtistQuery, ArtistQueryVariables>) {
        return Apollo.useQuery<ArtistQuery, ArtistQueryVariables>(ArtistDocument, baseOptions);
      }
export function useArtistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArtistQuery, ArtistQueryVariables>) {
          return Apollo.useLazyQuery<ArtistQuery, ArtistQueryVariables>(ArtistDocument, baseOptions);
        }
export type ArtistQueryHookResult = ReturnType<typeof useArtistQuery>;
export type ArtistLazyQueryHookResult = ReturnType<typeof useArtistLazyQuery>;
export type ArtistQueryResult = Apollo.QueryResult<ArtistQuery, ArtistQueryVariables>;
export const UpdateItemArtistsDocument = gql`
    mutation UpdateItemArtists($id: ID!, $attributes: UpdateItemInput!) {
  updateItem(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    item {
      title
      artists {
        edges {
          node {
            id
            firstName
            lastName
            tag
            itemCategoryId
          }
        }
      }
    }
  }
}
    `;
export type UpdateItemArtistsMutationFn = Apollo.MutationFunction<UpdateItemArtistsMutation, UpdateItemArtistsMutationVariables>;

/**
 * __useUpdateItemArtistsMutation__
 *
 * To run a mutation, you first call `useUpdateItemArtistsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemArtistsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemArtistsMutation, { data, loading, error }] = useUpdateItemArtistsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateItemArtistsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemArtistsMutation, UpdateItemArtistsMutationVariables>) {
        return Apollo.useMutation<UpdateItemArtistsMutation, UpdateItemArtistsMutationVariables>(UpdateItemArtistsDocument, baseOptions);
      }
export type UpdateItemArtistsMutationHookResult = ReturnType<typeof useUpdateItemArtistsMutation>;
export type UpdateItemArtistsMutationResult = Apollo.MutationResult<UpdateItemArtistsMutation>;
export type UpdateItemArtistsMutationOptions = Apollo.BaseMutationOptions<UpdateItemArtistsMutation, UpdateItemArtistsMutationVariables>;
export const ItemCategoriesDocument = gql`
    query ItemCategories {
  itemCategories(where: {archived: {equalTo: false}}) {
    edges {
      node {
        id
        name
        templateType
        archived
        aiGenerationAvailable
      }
    }
  }
}
    `;

/**
 * __useItemCategoriesQuery__
 *
 * To run a query within a React component, call `useItemCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ItemCategoriesQuery, ItemCategoriesQueryVariables>) {
        return Apollo.useQuery<ItemCategoriesQuery, ItemCategoriesQueryVariables>(ItemCategoriesDocument, baseOptions);
      }
export function useItemCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCategoriesQuery, ItemCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<ItemCategoriesQuery, ItemCategoriesQueryVariables>(ItemCategoriesDocument, baseOptions);
        }
export type ItemCategoriesQueryHookResult = ReturnType<typeof useItemCategoriesQuery>;
export type ItemCategoriesLazyQueryHookResult = ReturnType<typeof useItemCategoriesLazyQuery>;
export type ItemCategoriesQueryResult = Apollo.QueryResult<ItemCategoriesQuery, ItemCategoriesQueryVariables>;
export const ItemSubCategoriesDocument = gql`
    query ItemSubCategories($where: ItemSubCategoryFilter) {
  itemSubCategories(where: $where) {
    ...ItemSubCategoryEdges
  }
}
    ${ItemSubCategoryEdgesFragmentDoc}`;

/**
 * __useItemSubCategoriesQuery__
 *
 * To run a query within a React component, call `useItemSubCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemSubCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemSubCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useItemSubCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ItemSubCategoriesQuery, ItemSubCategoriesQueryVariables>) {
        return Apollo.useQuery<ItemSubCategoriesQuery, ItemSubCategoriesQueryVariables>(ItemSubCategoriesDocument, baseOptions);
      }
export function useItemSubCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemSubCategoriesQuery, ItemSubCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<ItemSubCategoriesQuery, ItemSubCategoriesQueryVariables>(ItemSubCategoriesDocument, baseOptions);
        }
export type ItemSubCategoriesQueryHookResult = ReturnType<typeof useItemSubCategoriesQuery>;
export type ItemSubCategoriesLazyQueryHookResult = ReturnType<typeof useItemSubCategoriesLazyQuery>;
export type ItemSubCategoriesQueryResult = Apollo.QueryResult<ItemSubCategoriesQuery, ItemSubCategoriesQueryVariables>;
export const CreateBookDocument = gql`
    mutation CreateBook($input: CreateBookMutationInput!) {
  createBook(input: $input) {
    book {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateBookMutationFn = Apollo.MutationFunction<CreateBookMutation, CreateBookMutationVariables>;

/**
 * __useCreateBookMutation__
 *
 * To run a mutation, you first call `useCreateBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookMutation, { data, loading, error }] = useCreateBookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookMutation, CreateBookMutationVariables>) {
        return Apollo.useMutation<CreateBookMutation, CreateBookMutationVariables>(CreateBookDocument, baseOptions);
      }
export type CreateBookMutationHookResult = ReturnType<typeof useCreateBookMutation>;
export type CreateBookMutationResult = Apollo.MutationResult<CreateBookMutation>;
export type CreateBookMutationOptions = Apollo.BaseMutationOptions<CreateBookMutation, CreateBookMutationVariables>;
export const CreateEngravingDocument = gql`
    mutation CreateEngraving($input: CreateEngravingMutationInput!) {
  createEngraving(input: $input) {
    engraving {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateEngravingMutationFn = Apollo.MutationFunction<CreateEngravingMutation, CreateEngravingMutationVariables>;

/**
 * __useCreateEngravingMutation__
 *
 * To run a mutation, you first call `useCreateEngravingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEngravingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEngravingMutation, { data, loading, error }] = useCreateEngravingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEngravingMutation(baseOptions?: Apollo.MutationHookOptions<CreateEngravingMutation, CreateEngravingMutationVariables>) {
        return Apollo.useMutation<CreateEngravingMutation, CreateEngravingMutationVariables>(CreateEngravingDocument, baseOptions);
      }
export type CreateEngravingMutationHookResult = ReturnType<typeof useCreateEngravingMutation>;
export type CreateEngravingMutationResult = Apollo.MutationResult<CreateEngravingMutation>;
export type CreateEngravingMutationOptions = Apollo.BaseMutationOptions<CreateEngravingMutation, CreateEngravingMutationVariables>;
export const CreateManuscriptDocument = gql`
    mutation CreateManuscript($input: CreateManuscriptMutationInput!) {
  createManuscript(input: $input) {
    manuscript {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateManuscriptMutationFn = Apollo.MutationFunction<CreateManuscriptMutation, CreateManuscriptMutationVariables>;

/**
 * __useCreateManuscriptMutation__
 *
 * To run a mutation, you first call `useCreateManuscriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManuscriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManuscriptMutation, { data, loading, error }] = useCreateManuscriptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManuscriptMutation(baseOptions?: Apollo.MutationHookOptions<CreateManuscriptMutation, CreateManuscriptMutationVariables>) {
        return Apollo.useMutation<CreateManuscriptMutation, CreateManuscriptMutationVariables>(CreateManuscriptDocument, baseOptions);
      }
export type CreateManuscriptMutationHookResult = ReturnType<typeof useCreateManuscriptMutation>;
export type CreateManuscriptMutationResult = Apollo.MutationResult<CreateManuscriptMutation>;
export type CreateManuscriptMutationOptions = Apollo.BaseMutationOptions<CreateManuscriptMutation, CreateManuscriptMutationVariables>;
export const CreateWatchDocument = gql`
    mutation CreateWatch($input: CreateWatchMutationInput!) {
  createWatch(input: $input) {
    watch {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateWatchMutationFn = Apollo.MutationFunction<CreateWatchMutation, CreateWatchMutationVariables>;

/**
 * __useCreateWatchMutation__
 *
 * To run a mutation, you first call `useCreateWatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWatchMutation, { data, loading, error }] = useCreateWatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWatchMutation(baseOptions?: Apollo.MutationHookOptions<CreateWatchMutation, CreateWatchMutationVariables>) {
        return Apollo.useMutation<CreateWatchMutation, CreateWatchMutationVariables>(CreateWatchDocument, baseOptions);
      }
export type CreateWatchMutationHookResult = ReturnType<typeof useCreateWatchMutation>;
export type CreateWatchMutationResult = Apollo.MutationResult<CreateWatchMutation>;
export type CreateWatchMutationOptions = Apollo.BaseMutationOptions<CreateWatchMutation, CreateWatchMutationVariables>;
export const CreateGeographicMapDocument = gql`
    mutation CreateGeographicMap($input: CreateGeographicMapMutationInput!) {
  createGeographicMap(input: $input) {
    geographicMap {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateGeographicMapMutationFn = Apollo.MutationFunction<CreateGeographicMapMutation, CreateGeographicMapMutationVariables>;

/**
 * __useCreateGeographicMapMutation__
 *
 * To run a mutation, you first call `useCreateGeographicMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGeographicMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGeographicMapMutation, { data, loading, error }] = useCreateGeographicMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGeographicMapMutation(baseOptions?: Apollo.MutationHookOptions<CreateGeographicMapMutation, CreateGeographicMapMutationVariables>) {
        return Apollo.useMutation<CreateGeographicMapMutation, CreateGeographicMapMutationVariables>(CreateGeographicMapDocument, baseOptions);
      }
export type CreateGeographicMapMutationHookResult = ReturnType<typeof useCreateGeographicMapMutation>;
export type CreateGeographicMapMutationResult = Apollo.MutationResult<CreateGeographicMapMutation>;
export type CreateGeographicMapMutationOptions = Apollo.BaseMutationOptions<CreateGeographicMapMutation, CreateGeographicMapMutationVariables>;
export const CreateJewelryDocument = gql`
    mutation CreateJewelry($input: CreateJewelryMutationInput!) {
  createJewelry(input: $input) {
    jewelry {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateJewelryMutationFn = Apollo.MutationFunction<CreateJewelryMutation, CreateJewelryMutationVariables>;

/**
 * __useCreateJewelryMutation__
 *
 * To run a mutation, you first call `useCreateJewelryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJewelryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJewelryMutation, { data, loading, error }] = useCreateJewelryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJewelryMutation(baseOptions?: Apollo.MutationHookOptions<CreateJewelryMutation, CreateJewelryMutationVariables>) {
        return Apollo.useMutation<CreateJewelryMutation, CreateJewelryMutationVariables>(CreateJewelryDocument, baseOptions);
      }
export type CreateJewelryMutationHookResult = ReturnType<typeof useCreateJewelryMutation>;
export type CreateJewelryMutationResult = Apollo.MutationResult<CreateJewelryMutation>;
export type CreateJewelryMutationOptions = Apollo.BaseMutationOptions<CreateJewelryMutation, CreateJewelryMutationVariables>;
export const CreateCeramicDocument = gql`
    mutation CreateCeramic($input: CreateCeramicMutationInput!) {
  createCeramic(input: $input) {
    ceramic {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateCeramicMutationFn = Apollo.MutationFunction<CreateCeramicMutation, CreateCeramicMutationVariables>;

/**
 * __useCreateCeramicMutation__
 *
 * To run a mutation, you first call `useCreateCeramicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCeramicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCeramicMutation, { data, loading, error }] = useCreateCeramicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCeramicMutation(baseOptions?: Apollo.MutationHookOptions<CreateCeramicMutation, CreateCeramicMutationVariables>) {
        return Apollo.useMutation<CreateCeramicMutation, CreateCeramicMutationVariables>(CreateCeramicDocument, baseOptions);
      }
export type CreateCeramicMutationHookResult = ReturnType<typeof useCreateCeramicMutation>;
export type CreateCeramicMutationResult = Apollo.MutationResult<CreateCeramicMutation>;
export type CreateCeramicMutationOptions = Apollo.BaseMutationOptions<CreateCeramicMutation, CreateCeramicMutationVariables>;
export const CreateFurnitureDocument = gql`
    mutation CreateFurniture($input: CreateFurnitureMutationInput!) {
  createFurniture(input: $input) {
    furniture {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateFurnitureMutationFn = Apollo.MutationFunction<CreateFurnitureMutation, CreateFurnitureMutationVariables>;

/**
 * __useCreateFurnitureMutation__
 *
 * To run a mutation, you first call `useCreateFurnitureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFurnitureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFurnitureMutation, { data, loading, error }] = useCreateFurnitureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFurnitureMutation(baseOptions?: Apollo.MutationHookOptions<CreateFurnitureMutation, CreateFurnitureMutationVariables>) {
        return Apollo.useMutation<CreateFurnitureMutation, CreateFurnitureMutationVariables>(CreateFurnitureDocument, baseOptions);
      }
export type CreateFurnitureMutationHookResult = ReturnType<typeof useCreateFurnitureMutation>;
export type CreateFurnitureMutationResult = Apollo.MutationResult<CreateFurnitureMutation>;
export type CreateFurnitureMutationOptions = Apollo.BaseMutationOptions<CreateFurnitureMutation, CreateFurnitureMutationVariables>;
export const CreateCarpetTextileDocument = gql`
    mutation CreateCarpetTextile($input: CreateCarpetTextileMutationInput!) {
  createCarpetTextile(input: $input) {
    carpetTextile {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateCarpetTextileMutationFn = Apollo.MutationFunction<CreateCarpetTextileMutation, CreateCarpetTextileMutationVariables>;

/**
 * __useCreateCarpetTextileMutation__
 *
 * To run a mutation, you first call `useCreateCarpetTextileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarpetTextileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarpetTextileMutation, { data, loading, error }] = useCreateCarpetTextileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCarpetTextileMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarpetTextileMutation, CreateCarpetTextileMutationVariables>) {
        return Apollo.useMutation<CreateCarpetTextileMutation, CreateCarpetTextileMutationVariables>(CreateCarpetTextileDocument, baseOptions);
      }
export type CreateCarpetTextileMutationHookResult = ReturnType<typeof useCreateCarpetTextileMutation>;
export type CreateCarpetTextileMutationResult = Apollo.MutationResult<CreateCarpetTextileMutation>;
export type CreateCarpetTextileMutationOptions = Apollo.BaseMutationOptions<CreateCarpetTextileMutation, CreateCarpetTextileMutationVariables>;
export const CreatePaintingSculptureDocument = gql`
    mutation CreatePaintingSculpture($input: CreatePaintingSculptureMutationInput!) {
  createPaintingSculpture(input: $input) {
    paintingSculpture {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreatePaintingSculptureMutationFn = Apollo.MutationFunction<CreatePaintingSculptureMutation, CreatePaintingSculptureMutationVariables>;

/**
 * __useCreatePaintingSculptureMutation__
 *
 * To run a mutation, you first call `useCreatePaintingSculptureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaintingSculptureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaintingSculptureMutation, { data, loading, error }] = useCreatePaintingSculptureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaintingSculptureMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaintingSculptureMutation, CreatePaintingSculptureMutationVariables>) {
        return Apollo.useMutation<CreatePaintingSculptureMutation, CreatePaintingSculptureMutationVariables>(CreatePaintingSculptureDocument, baseOptions);
      }
export type CreatePaintingSculptureMutationHookResult = ReturnType<typeof useCreatePaintingSculptureMutation>;
export type CreatePaintingSculptureMutationResult = Apollo.MutationResult<CreatePaintingSculptureMutation>;
export type CreatePaintingSculptureMutationOptions = Apollo.BaseMutationOptions<CreatePaintingSculptureMutation, CreatePaintingSculptureMutationVariables>;
export const CreatePhotographyDocument = gql`
    mutation CreatePhotography($input: CreatePhotographyMutationInput!) {
  createPhotography(input: $input) {
    photography {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreatePhotographyMutationFn = Apollo.MutationFunction<CreatePhotographyMutation, CreatePhotographyMutationVariables>;

/**
 * __useCreatePhotographyMutation__
 *
 * To run a mutation, you first call `useCreatePhotographyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhotographyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhotographyMutation, { data, loading, error }] = useCreatePhotographyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePhotographyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhotographyMutation, CreatePhotographyMutationVariables>) {
        return Apollo.useMutation<CreatePhotographyMutation, CreatePhotographyMutationVariables>(CreatePhotographyDocument, baseOptions);
      }
export type CreatePhotographyMutationHookResult = ReturnType<typeof useCreatePhotographyMutation>;
export type CreatePhotographyMutationResult = Apollo.MutationResult<CreatePhotographyMutation>;
export type CreatePhotographyMutationOptions = Apollo.BaseMutationOptions<CreatePhotographyMutation, CreatePhotographyMutationVariables>;
export const CreateCoinsMedalsStampsDocument = gql`
    mutation CreateCoinsMedalsStamps($input: CreateCoinsMedalsStampsMutationInput!) {
  createCoinsMedalsStamps(input: $input) {
    coinsMedalsStamps {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateCoinsMedalsStampsMutationFn = Apollo.MutationFunction<CreateCoinsMedalsStampsMutation, CreateCoinsMedalsStampsMutationVariables>;

/**
 * __useCreateCoinsMedalsStampsMutation__
 *
 * To run a mutation, you first call `useCreateCoinsMedalsStampsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoinsMedalsStampsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoinsMedalsStampsMutation, { data, loading, error }] = useCreateCoinsMedalsStampsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoinsMedalsStampsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoinsMedalsStampsMutation, CreateCoinsMedalsStampsMutationVariables>) {
        return Apollo.useMutation<CreateCoinsMedalsStampsMutation, CreateCoinsMedalsStampsMutationVariables>(CreateCoinsMedalsStampsDocument, baseOptions);
      }
export type CreateCoinsMedalsStampsMutationHookResult = ReturnType<typeof useCreateCoinsMedalsStampsMutation>;
export type CreateCoinsMedalsStampsMutationResult = Apollo.MutationResult<CreateCoinsMedalsStampsMutation>;
export type CreateCoinsMedalsStampsMutationOptions = Apollo.BaseMutationOptions<CreateCoinsMedalsStampsMutation, CreateCoinsMedalsStampsMutationVariables>;
export const CreateMilitariaDocument = gql`
    mutation CreateMilitaria($input: CreateMilitariaMutationInput!) {
  createMilitaria(input: $input) {
    militaria {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateMilitariaMutationFn = Apollo.MutationFunction<CreateMilitariaMutation, CreateMilitariaMutationVariables>;

/**
 * __useCreateMilitariaMutation__
 *
 * To run a mutation, you first call `useCreateMilitariaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMilitariaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMilitariaMutation, { data, loading, error }] = useCreateMilitariaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMilitariaMutation(baseOptions?: Apollo.MutationHookOptions<CreateMilitariaMutation, CreateMilitariaMutationVariables>) {
        return Apollo.useMutation<CreateMilitariaMutation, CreateMilitariaMutationVariables>(CreateMilitariaDocument, baseOptions);
      }
export type CreateMilitariaMutationHookResult = ReturnType<typeof useCreateMilitariaMutation>;
export type CreateMilitariaMutationResult = Apollo.MutationResult<CreateMilitariaMutation>;
export type CreateMilitariaMutationOptions = Apollo.BaseMutationOptions<CreateMilitariaMutation, CreateMilitariaMutationVariables>;
export const CreateSilverwareTablewareDocument = gql`
    mutation CreateSilverwareTableware($input: CreateSilverwareTablewareMutationInput!) {
  createSilverwareTableware(input: $input) {
    silverwareTableware {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateSilverwareTablewareMutationFn = Apollo.MutationFunction<CreateSilverwareTablewareMutation, CreateSilverwareTablewareMutationVariables>;

/**
 * __useCreateSilverwareTablewareMutation__
 *
 * To run a mutation, you first call `useCreateSilverwareTablewareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSilverwareTablewareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSilverwareTablewareMutation, { data, loading, error }] = useCreateSilverwareTablewareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSilverwareTablewareMutation(baseOptions?: Apollo.MutationHookOptions<CreateSilverwareTablewareMutation, CreateSilverwareTablewareMutationVariables>) {
        return Apollo.useMutation<CreateSilverwareTablewareMutation, CreateSilverwareTablewareMutationVariables>(CreateSilverwareTablewareDocument, baseOptions);
      }
export type CreateSilverwareTablewareMutationHookResult = ReturnType<typeof useCreateSilverwareTablewareMutation>;
export type CreateSilverwareTablewareMutationResult = Apollo.MutationResult<CreateSilverwareTablewareMutation>;
export type CreateSilverwareTablewareMutationOptions = Apollo.BaseMutationOptions<CreateSilverwareTablewareMutation, CreateSilverwareTablewareMutationVariables>;
export const CreateFashionLuxuryAccessoryDocument = gql`
    mutation CreateFashionLuxuryAccessory($input: CreateFashionLuxuryAccessoryMutationInput!) {
  createFashionLuxuryAccessory(input: $input) {
    fashionLuxuryAccessory {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateFashionLuxuryAccessoryMutationFn = Apollo.MutationFunction<CreateFashionLuxuryAccessoryMutation, CreateFashionLuxuryAccessoryMutationVariables>;

/**
 * __useCreateFashionLuxuryAccessoryMutation__
 *
 * To run a mutation, you first call `useCreateFashionLuxuryAccessoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFashionLuxuryAccessoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFashionLuxuryAccessoryMutation, { data, loading, error }] = useCreateFashionLuxuryAccessoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFashionLuxuryAccessoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateFashionLuxuryAccessoryMutation, CreateFashionLuxuryAccessoryMutationVariables>) {
        return Apollo.useMutation<CreateFashionLuxuryAccessoryMutation, CreateFashionLuxuryAccessoryMutationVariables>(CreateFashionLuxuryAccessoryDocument, baseOptions);
      }
export type CreateFashionLuxuryAccessoryMutationHookResult = ReturnType<typeof useCreateFashionLuxuryAccessoryMutation>;
export type CreateFashionLuxuryAccessoryMutationResult = Apollo.MutationResult<CreateFashionLuxuryAccessoryMutation>;
export type CreateFashionLuxuryAccessoryMutationOptions = Apollo.BaseMutationOptions<CreateFashionLuxuryAccessoryMutation, CreateFashionLuxuryAccessoryMutationVariables>;
export const CreateToyComicPopCultureDocument = gql`
    mutation CreateToyComicPopCulture($input: CreateToyComicPopCultureMutationInput!) {
  createToyComicPopCulture(input: $input) {
    toyComicPopCulture {
      id
      item {
        id
        title
        description
        itemCategory {
          id
          name
        }
        itemSubCategory {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateToyComicPopCultureMutationFn = Apollo.MutationFunction<CreateToyComicPopCultureMutation, CreateToyComicPopCultureMutationVariables>;

/**
 * __useCreateToyComicPopCultureMutation__
 *
 * To run a mutation, you first call `useCreateToyComicPopCultureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateToyComicPopCultureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createToyComicPopCultureMutation, { data, loading, error }] = useCreateToyComicPopCultureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateToyComicPopCultureMutation(baseOptions?: Apollo.MutationHookOptions<CreateToyComicPopCultureMutation, CreateToyComicPopCultureMutationVariables>) {
        return Apollo.useMutation<CreateToyComicPopCultureMutation, CreateToyComicPopCultureMutationVariables>(CreateToyComicPopCultureDocument, baseOptions);
      }
export type CreateToyComicPopCultureMutationHookResult = ReturnType<typeof useCreateToyComicPopCultureMutation>;
export type CreateToyComicPopCultureMutationResult = Apollo.MutationResult<CreateToyComicPopCultureMutation>;
export type CreateToyComicPopCultureMutationOptions = Apollo.BaseMutationOptions<CreateToyComicPopCultureMutation, CreateToyComicPopCultureMutationVariables>;
export const UpdateVolumeDocument = gql`
    mutation UpdateVolume($attributes: UpdateVolumeInput!) {
  updateVolumes(input: {attributes: $attributes}) {
    clientMutationId
    errors {
      details
      fullMessages
    }
  }
}
    `;
export type UpdateVolumeMutationFn = Apollo.MutationFunction<UpdateVolumeMutation, UpdateVolumeMutationVariables>;

/**
 * __useUpdateVolumeMutation__
 *
 * To run a mutation, you first call `useUpdateVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVolumeMutation, { data, loading, error }] = useUpdateVolumeMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateVolumeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVolumeMutation, UpdateVolumeMutationVariables>) {
        return Apollo.useMutation<UpdateVolumeMutation, UpdateVolumeMutationVariables>(UpdateVolumeDocument, baseOptions);
      }
export type UpdateVolumeMutationHookResult = ReturnType<typeof useUpdateVolumeMutation>;
export type UpdateVolumeMutationResult = Apollo.MutationResult<UpdateVolumeMutation>;
export type UpdateVolumeMutationOptions = Apollo.BaseMutationOptions<UpdateVolumeMutation, UpdateVolumeMutationVariables>;
export const GetItemDocument = gql`
    query GetItem($id: ID!) {
  item(id: $id) {
    ...Item
  }
}
    ${ItemFragmentDoc}`;

/**
 * __useGetItemQuery__
 *
 * To run a query within a React component, call `useGetItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItemQuery(baseOptions: Apollo.QueryHookOptions<GetItemQuery, GetItemQueryVariables>) {
        return Apollo.useQuery<GetItemQuery, GetItemQueryVariables>(GetItemDocument, baseOptions);
      }
export function useGetItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemQuery, GetItemQueryVariables>) {
          return Apollo.useLazyQuery<GetItemQuery, GetItemQueryVariables>(GetItemDocument, baseOptions);
        }
export type GetItemQueryHookResult = ReturnType<typeof useGetItemQuery>;
export type GetItemLazyQueryHookResult = ReturnType<typeof useGetItemLazyQuery>;
export type GetItemQueryResult = Apollo.QueryResult<GetItemQuery, GetItemQueryVariables>;
export const GetBookDocument = gql`
    query GetBook($id: ID!) {
  book(id: $id) {
    ...Book
  }
}
    ${BookFragmentDoc}`;

/**
 * __useGetBookQuery__
 *
 * To run a query within a React component, call `useGetBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookQuery(baseOptions: Apollo.QueryHookOptions<GetBookQuery, GetBookQueryVariables>) {
        return Apollo.useQuery<GetBookQuery, GetBookQueryVariables>(GetBookDocument, baseOptions);
      }
export function useGetBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookQuery, GetBookQueryVariables>) {
          return Apollo.useLazyQuery<GetBookQuery, GetBookQueryVariables>(GetBookDocument, baseOptions);
        }
export type GetBookQueryHookResult = ReturnType<typeof useGetBookQuery>;
export type GetBookLazyQueryHookResult = ReturnType<typeof useGetBookLazyQuery>;
export type GetBookQueryResult = Apollo.QueryResult<GetBookQuery, GetBookQueryVariables>;
export const UpdateItemDocument = gql`
    mutation UpdateItem($id: ID!, $attributes: UpdateItemInput!) {
  updateItem(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    item {
      id
    }
    errors
  }
}
    `;
export type UpdateItemMutationFn = Apollo.MutationFunction<UpdateItemMutation, UpdateItemMutationVariables>;

/**
 * __useUpdateItemMutation__
 *
 * To run a mutation, you first call `useUpdateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemMutation, { data, loading, error }] = useUpdateItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemMutation, UpdateItemMutationVariables>) {
        return Apollo.useMutation<UpdateItemMutation, UpdateItemMutationVariables>(UpdateItemDocument, baseOptions);
      }
export type UpdateItemMutationHookResult = ReturnType<typeof useUpdateItemMutation>;
export type UpdateItemMutationResult = Apollo.MutationResult<UpdateItemMutation>;
export type UpdateItemMutationOptions = Apollo.BaseMutationOptions<UpdateItemMutation, UpdateItemMutationVariables>;
export const DuplicateItemDocument = gql`
    mutation DuplicateItem($id: ID!) {
  duplicateItem(input: {id: $id}) {
    clientMutationId
    item {
      id
    }
  }
}
    `;
export type DuplicateItemMutationFn = Apollo.MutationFunction<DuplicateItemMutation, DuplicateItemMutationVariables>;

/**
 * __useDuplicateItemMutation__
 *
 * To run a mutation, you first call `useDuplicateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateItemMutation, { data, loading, error }] = useDuplicateItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateItemMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateItemMutation, DuplicateItemMutationVariables>) {
        return Apollo.useMutation<DuplicateItemMutation, DuplicateItemMutationVariables>(DuplicateItemDocument, baseOptions);
      }
export type DuplicateItemMutationHookResult = ReturnType<typeof useDuplicateItemMutation>;
export type DuplicateItemMutationResult = Apollo.MutationResult<DuplicateItemMutation>;
export type DuplicateItemMutationOptions = Apollo.BaseMutationOptions<DuplicateItemMutation, DuplicateItemMutationVariables>;
export const DestroyItemDocument = gql`
    mutation DestroyItem($id: ID!) {
  destroyItem(input: {id: $id}) {
    item {
      id
    }
  }
}
    `;
export type DestroyItemMutationFn = Apollo.MutationFunction<DestroyItemMutation, DestroyItemMutationVariables>;

/**
 * __useDestroyItemMutation__
 *
 * To run a mutation, you first call `useDestroyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyItemMutation, { data, loading, error }] = useDestroyItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyItemMutation(baseOptions?: Apollo.MutationHookOptions<DestroyItemMutation, DestroyItemMutationVariables>) {
        return Apollo.useMutation<DestroyItemMutation, DestroyItemMutationVariables>(DestroyItemDocument, baseOptions);
      }
export type DestroyItemMutationHookResult = ReturnType<typeof useDestroyItemMutation>;
export type DestroyItemMutationResult = Apollo.MutationResult<DestroyItemMutation>;
export type DestroyItemMutationOptions = Apollo.BaseMutationOptions<DestroyItemMutation, DestroyItemMutationVariables>;
export const UpdateBookDocument = gql`
    mutation UpdateBook($id: ID!, $attributes: UpdateBookInput!) {
  updateBook(input: {id: $id, attributes: $attributes}) {
    book {
      id
    }
  }
}
    `;
export type UpdateBookMutationFn = Apollo.MutationFunction<UpdateBookMutation, UpdateBookMutationVariables>;

/**
 * __useUpdateBookMutation__
 *
 * To run a mutation, you first call `useUpdateBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookMutation, { data, loading, error }] = useUpdateBookMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateBookMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookMutation, UpdateBookMutationVariables>) {
        return Apollo.useMutation<UpdateBookMutation, UpdateBookMutationVariables>(UpdateBookDocument, baseOptions);
      }
export type UpdateBookMutationHookResult = ReturnType<typeof useUpdateBookMutation>;
export type UpdateBookMutationResult = Apollo.MutationResult<UpdateBookMutation>;
export type UpdateBookMutationOptions = Apollo.BaseMutationOptions<UpdateBookMutation, UpdateBookMutationVariables>;
export const ItemMovementDocument = gql`
    query ItemMovement($id: ID!) {
  itemMovement(id: $id) {
    ...ItemMovement
  }
}
    ${ItemMovementFragmentDoc}`;

/**
 * __useItemMovementQuery__
 *
 * To run a query within a React component, call `useItemMovementQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemMovementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemMovementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useItemMovementQuery(baseOptions: Apollo.QueryHookOptions<ItemMovementQuery, ItemMovementQueryVariables>) {
        return Apollo.useQuery<ItemMovementQuery, ItemMovementQueryVariables>(ItemMovementDocument, baseOptions);
      }
export function useItemMovementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemMovementQuery, ItemMovementQueryVariables>) {
          return Apollo.useLazyQuery<ItemMovementQuery, ItemMovementQueryVariables>(ItemMovementDocument, baseOptions);
        }
export type ItemMovementQueryHookResult = ReturnType<typeof useItemMovementQuery>;
export type ItemMovementLazyQueryHookResult = ReturnType<typeof useItemMovementLazyQuery>;
export type ItemMovementQueryResult = Apollo.QueryResult<ItemMovementQuery, ItemMovementQueryVariables>;
export const ItemMovementsDocument = gql`
    query ItemMovements($where: ItemMovementFilter, $first: Int = 10) {
  itemMovements(
    where: $where
    orderBy: {attribute: "createdAt", direction: "asc"}
    first: $first
  ) {
    ...ItemMovementEdges
  }
}
    ${ItemMovementEdgesFragmentDoc}`;

/**
 * __useItemMovementsQuery__
 *
 * To run a query within a React component, call `useItemMovementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemMovementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemMovementsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useItemMovementsQuery(baseOptions?: Apollo.QueryHookOptions<ItemMovementsQuery, ItemMovementsQueryVariables>) {
        return Apollo.useQuery<ItemMovementsQuery, ItemMovementsQueryVariables>(ItemMovementsDocument, baseOptions);
      }
export function useItemMovementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemMovementsQuery, ItemMovementsQueryVariables>) {
          return Apollo.useLazyQuery<ItemMovementsQuery, ItemMovementsQueryVariables>(ItemMovementsDocument, baseOptions);
        }
export type ItemMovementsQueryHookResult = ReturnType<typeof useItemMovementsQuery>;
export type ItemMovementsLazyQueryHookResult = ReturnType<typeof useItemMovementsLazyQuery>;
export type ItemMovementsQueryResult = Apollo.QueryResult<ItemMovementsQuery, ItemMovementsQueryVariables>;
export const UpdateItemMovementDocument = gql`
    mutation UpdateItemMovement($input: UpdateItemMovementMutationInput!) {
  updateItemMovement(input: $input) {
    itemMovement {
      id
    }
  }
}
    `;
export type UpdateItemMovementMutationFn = Apollo.MutationFunction<UpdateItemMovementMutation, UpdateItemMovementMutationVariables>;

/**
 * __useUpdateItemMovementMutation__
 *
 * To run a mutation, you first call `useUpdateItemMovementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemMovementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemMovementMutation, { data, loading, error }] = useUpdateItemMovementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItemMovementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemMovementMutation, UpdateItemMovementMutationVariables>) {
        return Apollo.useMutation<UpdateItemMovementMutation, UpdateItemMovementMutationVariables>(UpdateItemMovementDocument, baseOptions);
      }
export type UpdateItemMovementMutationHookResult = ReturnType<typeof useUpdateItemMovementMutation>;
export type UpdateItemMovementMutationResult = Apollo.MutationResult<UpdateItemMovementMutation>;
export type UpdateItemMovementMutationOptions = Apollo.BaseMutationOptions<UpdateItemMovementMutation, UpdateItemMovementMutationVariables>;
export const CreateItemMovementDocument = gql`
    mutation CreateItemMovement($input: CreateItemMovementMutationInput!) {
  createItemMovement(input: $input) {
    itemMovement {
      id
    }
  }
}
    `;
export type CreateItemMovementMutationFn = Apollo.MutationFunction<CreateItemMovementMutation, CreateItemMovementMutationVariables>;

/**
 * __useCreateItemMovementMutation__
 *
 * To run a mutation, you first call `useCreateItemMovementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemMovementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemMovementMutation, { data, loading, error }] = useCreateItemMovementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateItemMovementMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemMovementMutation, CreateItemMovementMutationVariables>) {
        return Apollo.useMutation<CreateItemMovementMutation, CreateItemMovementMutationVariables>(CreateItemMovementDocument, baseOptions);
      }
export type CreateItemMovementMutationHookResult = ReturnType<typeof useCreateItemMovementMutation>;
export type CreateItemMovementMutationResult = Apollo.MutationResult<CreateItemMovementMutation>;
export type CreateItemMovementMutationOptions = Apollo.BaseMutationOptions<CreateItemMovementMutation, CreateItemMovementMutationVariables>;
export const ItemsQueryDocument = gql`
    query ItemsQuery($where: ItemFilter, $orderByAttribute: [ItemOrderType!] = [{attribute: "createdAt", direction: "desc"}], $first: Int, $last: Int = null, $after: String = null, $before: String = null) {
  items(
    where: $where
    orderBy: $orderByAttribute
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      cursor
      node {
        ...ItemTable
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${ItemTableFragmentDoc}`;

/**
 * __useItemsQueryQuery__
 *
 * To run a query within a React component, call `useItemsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsQueryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByAttribute: // value for 'orderByAttribute'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useItemsQueryQuery(baseOptions?: Apollo.QueryHookOptions<ItemsQueryQuery, ItemsQueryQueryVariables>) {
        return Apollo.useQuery<ItemsQueryQuery, ItemsQueryQueryVariables>(ItemsQueryDocument, baseOptions);
      }
export function useItemsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsQueryQuery, ItemsQueryQueryVariables>) {
          return Apollo.useLazyQuery<ItemsQueryQuery, ItemsQueryQueryVariables>(ItemsQueryDocument, baseOptions);
        }
export type ItemsQueryQueryHookResult = ReturnType<typeof useItemsQueryQuery>;
export type ItemsQueryLazyQueryHookResult = ReturnType<typeof useItemsQueryLazyQuery>;
export type ItemsQueryQueryResult = Apollo.QueryResult<ItemsQueryQuery, ItemsQueryQueryVariables>;
export const ItemsWithImagesQueryDocument = gql`
    query ItemsWithImagesQuery($where: ItemFilter, $orderByAttribute: [ItemOrderType!] = [{attribute: "createdAt", direction: "desc"}], $first: Int, $last: Int = null, $after: String = null, $before: String = null) {
  items(
    where: $where
    orderBy: $orderByAttribute
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      cursor
      node {
        ...ItemTable
        ...Item
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${ItemTableFragmentDoc}
${ItemFragmentDoc}`;

/**
 * __useItemsWithImagesQueryQuery__
 *
 * To run a query within a React component, call `useItemsWithImagesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsWithImagesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsWithImagesQueryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByAttribute: // value for 'orderByAttribute'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useItemsWithImagesQueryQuery(baseOptions?: Apollo.QueryHookOptions<ItemsWithImagesQueryQuery, ItemsWithImagesQueryQueryVariables>) {
        return Apollo.useQuery<ItemsWithImagesQueryQuery, ItemsWithImagesQueryQueryVariables>(ItemsWithImagesQueryDocument, baseOptions);
      }
export function useItemsWithImagesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsWithImagesQueryQuery, ItemsWithImagesQueryQueryVariables>) {
          return Apollo.useLazyQuery<ItemsWithImagesQueryQuery, ItemsWithImagesQueryQueryVariables>(ItemsWithImagesQueryDocument, baseOptions);
        }
export type ItemsWithImagesQueryQueryHookResult = ReturnType<typeof useItemsWithImagesQueryQuery>;
export type ItemsWithImagesQueryLazyQueryHookResult = ReturnType<typeof useItemsWithImagesQueryLazyQuery>;
export type ItemsWithImagesQueryQueryResult = Apollo.QueryResult<ItemsWithImagesQueryQuery, ItemsWithImagesQueryQueryVariables>;
export const ItemsWithImagesForDodecadeExportQueryDocument = gql`
    query ItemsWithImagesForDodecadeExportQuery($where: ItemFilter, $orderByAttribute: [ItemOrderType!] = [{attribute: "createdAt", direction: "desc"}], $first: Int, $last: Int = null, $after: String = null, $before: String = null) {
  items(
    where: $where
    orderBy: $orderByAttribute
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      cursor
      node {
        ...Item
        createdAt
        updatedAt
        itemCategory {
          externalRainworxId
        }
        itemSubCategory {
          externalRainworxId
        }
        title
        saleTitle
        subtitle
        customDescription
        description
        descriptionHeader
        descriptionFooter
        mode
        finalPrice
        autoDescription
        startingPrice
        reservedPrice
        resaleStatus
        highEstimatedPrice
        lowEstimatedPrice
        state
        unsoldCount
        initialStartingPrice
        initialReservedPrice
        startingPrice
        lastSaleEndedAt
        nextEligibleDate
        vendorActionDeadline
        resaleInfo {
          nextPrice
          discountPercentage
          unsoldCount
          canRelist
          status
        }
        project {
          id
          number
        }
        projectCounter
        vacation {
          id
          name
        }
        width
        weight
        totalWeight
        length
        height
        id
        salePosition
        images {
          position
          imageUrl
        }
        template {
          __typename
        }
        vendor {
          id
          shippingOptions
          defaultPickupAddress {
            ...VendorAddress
          }
          defaultProfileAddress {
            ...VendorAddress
          }
        }
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${ItemFragmentDoc}
${VendorAddressFragmentDoc}`;

/**
 * __useItemsWithImagesForDodecadeExportQueryQuery__
 *
 * To run a query within a React component, call `useItemsWithImagesForDodecadeExportQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsWithImagesForDodecadeExportQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsWithImagesForDodecadeExportQueryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByAttribute: // value for 'orderByAttribute'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useItemsWithImagesForDodecadeExportQueryQuery(baseOptions?: Apollo.QueryHookOptions<ItemsWithImagesForDodecadeExportQueryQuery, ItemsWithImagesForDodecadeExportQueryQueryVariables>) {
        return Apollo.useQuery<ItemsWithImagesForDodecadeExportQueryQuery, ItemsWithImagesForDodecadeExportQueryQueryVariables>(ItemsWithImagesForDodecadeExportQueryDocument, baseOptions);
      }
export function useItemsWithImagesForDodecadeExportQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsWithImagesForDodecadeExportQueryQuery, ItemsWithImagesForDodecadeExportQueryQueryVariables>) {
          return Apollo.useLazyQuery<ItemsWithImagesForDodecadeExportQueryQuery, ItemsWithImagesForDodecadeExportQueryQueryVariables>(ItemsWithImagesForDodecadeExportQueryDocument, baseOptions);
        }
export type ItemsWithImagesForDodecadeExportQueryQueryHookResult = ReturnType<typeof useItemsWithImagesForDodecadeExportQueryQuery>;
export type ItemsWithImagesForDodecadeExportQueryLazyQueryHookResult = ReturnType<typeof useItemsWithImagesForDodecadeExportQueryLazyQuery>;
export type ItemsWithImagesForDodecadeExportQueryQueryResult = Apollo.QueryResult<ItemsWithImagesForDodecadeExportQueryQuery, ItemsWithImagesForDodecadeExportQueryQueryVariables>;
export const SaleReviewItemsQueryDocument = gql`
    query SaleReviewItemsQuery($where: ItemFilter, $orderByAttribute: [ItemOrderType!] = [{attribute: "createdAt", direction: "desc"}], $first: Int, $last: Int = null, $after: String = null, $before: String = null) {
  items(
    where: $where
    orderBy: $orderByAttribute
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      cursor
      node {
        id
        salePosition
        title
        sku
        updatedAt
        customDescription
        autoDescription
        lowEstimatedPrice
        highEstimatedPrice
        startingPrice
        reservedPrice
        projectCounter
        project {
          id
          number
        }
        vacation {
          id
          name
        }
        firstImage {
          imageUrl
          position
        }
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useSaleReviewItemsQueryQuery__
 *
 * To run a query within a React component, call `useSaleReviewItemsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleReviewItemsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleReviewItemsQueryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByAttribute: // value for 'orderByAttribute'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useSaleReviewItemsQueryQuery(baseOptions?: Apollo.QueryHookOptions<SaleReviewItemsQueryQuery, SaleReviewItemsQueryQueryVariables>) {
        return Apollo.useQuery<SaleReviewItemsQueryQuery, SaleReviewItemsQueryQueryVariables>(SaleReviewItemsQueryDocument, baseOptions);
      }
export function useSaleReviewItemsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleReviewItemsQueryQuery, SaleReviewItemsQueryQueryVariables>) {
          return Apollo.useLazyQuery<SaleReviewItemsQueryQuery, SaleReviewItemsQueryQueryVariables>(SaleReviewItemsQueryDocument, baseOptions);
        }
export type SaleReviewItemsQueryQueryHookResult = ReturnType<typeof useSaleReviewItemsQueryQuery>;
export type SaleReviewItemsQueryLazyQueryHookResult = ReturnType<typeof useSaleReviewItemsQueryLazyQuery>;
export type SaleReviewItemsQueryQueryResult = Apollo.QueryResult<SaleReviewItemsQueryQuery, SaleReviewItemsQueryQueryVariables>;
export const CreateDrouotExportCsvDocument = gql`
    mutation CreateDrouotExportCsv($saleId: ID!, $itemIds: [ID!]!) {
  createDrouotExportCsv(input: {saleId: $saleId, itemIds: $itemIds}) {
    clientMutationId
    sale {
      id
    }
  }
}
    `;
export type CreateDrouotExportCsvMutationFn = Apollo.MutationFunction<CreateDrouotExportCsvMutation, CreateDrouotExportCsvMutationVariables>;

/**
 * __useCreateDrouotExportCsvMutation__
 *
 * To run a mutation, you first call `useCreateDrouotExportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDrouotExportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDrouotExportCsvMutation, { data, loading, error }] = useCreateDrouotExportCsvMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function useCreateDrouotExportCsvMutation(baseOptions?: Apollo.MutationHookOptions<CreateDrouotExportCsvMutation, CreateDrouotExportCsvMutationVariables>) {
        return Apollo.useMutation<CreateDrouotExportCsvMutation, CreateDrouotExportCsvMutationVariables>(CreateDrouotExportCsvDocument, baseOptions);
      }
export type CreateDrouotExportCsvMutationHookResult = ReturnType<typeof useCreateDrouotExportCsvMutation>;
export type CreateDrouotExportCsvMutationResult = Apollo.MutationResult<CreateDrouotExportCsvMutation>;
export type CreateDrouotExportCsvMutationOptions = Apollo.BaseMutationOptions<CreateDrouotExportCsvMutation, CreateDrouotExportCsvMutationVariables>;
export const BulkUpdateSalePositionsDocument = gql`
    mutation BulkUpdateSalePositions($input: BulkUpdateSalePositionsMutationInput!) {
  bulkUpdateSalePositions(input: $input) {
    items {
      id
      salePosition
    }
    errors
  }
}
    `;
export type BulkUpdateSalePositionsMutationFn = Apollo.MutationFunction<BulkUpdateSalePositionsMutation, BulkUpdateSalePositionsMutationVariables>;

/**
 * __useBulkUpdateSalePositionsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateSalePositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateSalePositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateSalePositionsMutation, { data, loading, error }] = useBulkUpdateSalePositionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateSalePositionsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateSalePositionsMutation, BulkUpdateSalePositionsMutationVariables>) {
        return Apollo.useMutation<BulkUpdateSalePositionsMutation, BulkUpdateSalePositionsMutationVariables>(BulkUpdateSalePositionsDocument, baseOptions);
      }
export type BulkUpdateSalePositionsMutationHookResult = ReturnType<typeof useBulkUpdateSalePositionsMutation>;
export type BulkUpdateSalePositionsMutationResult = Apollo.MutationResult<BulkUpdateSalePositionsMutation>;
export type BulkUpdateSalePositionsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateSalePositionsMutation, BulkUpdateSalePositionsMutationVariables>;
export const ExpertsDocument = gql`
    query Experts {
  experts(orderBy: {attribute: "createdAt", direction: "desc"}) {
    ...ExpertEdges
  }
}
    ${ExpertEdgesFragmentDoc}`;

/**
 * __useExpertsQuery__
 *
 * To run a query within a React component, call `useExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpertsQuery(baseOptions?: Apollo.QueryHookOptions<ExpertsQuery, ExpertsQueryVariables>) {
        return Apollo.useQuery<ExpertsQuery, ExpertsQueryVariables>(ExpertsDocument, baseOptions);
      }
export function useExpertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertsQuery, ExpertsQueryVariables>) {
          return Apollo.useLazyQuery<ExpertsQuery, ExpertsQueryVariables>(ExpertsDocument, baseOptions);
        }
export type ExpertsQueryHookResult = ReturnType<typeof useExpertsQuery>;
export type ExpertsLazyQueryHookResult = ReturnType<typeof useExpertsLazyQuery>;
export type ExpertsQueryResult = Apollo.QueryResult<ExpertsQuery, ExpertsQueryVariables>;
export const NewsLettersDocument = gql`
    query NewsLetters($where: NewsLetterFilter, $direction: String = "asc", $first: Int = 50, $last: Int = null, $after: String = null, $before: String = null) {
  newsLetters(
    where: $where
    orderBy: {attribute: "createdAt", direction: $direction}
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    ...NewsLetterEdges
  }
}
    ${NewsLetterEdgesFragmentDoc}`;

/**
 * __useNewsLettersQuery__
 *
 * To run a query within a React component, call `useNewsLettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsLettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsLettersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      direction: // value for 'direction'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useNewsLettersQuery(baseOptions?: Apollo.QueryHookOptions<NewsLettersQuery, NewsLettersQueryVariables>) {
        return Apollo.useQuery<NewsLettersQuery, NewsLettersQueryVariables>(NewsLettersDocument, baseOptions);
      }
export function useNewsLettersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsLettersQuery, NewsLettersQueryVariables>) {
          return Apollo.useLazyQuery<NewsLettersQuery, NewsLettersQueryVariables>(NewsLettersDocument, baseOptions);
        }
export type NewsLettersQueryHookResult = ReturnType<typeof useNewsLettersQuery>;
export type NewsLettersLazyQueryHookResult = ReturnType<typeof useNewsLettersLazyQuery>;
export type NewsLettersQueryResult = Apollo.QueryResult<NewsLettersQuery, NewsLettersQueryVariables>;
export const CreateNewsLetterDocument = gql`
    mutation CreateNewsLetter($input: CreateNewsLetterMutationInput!) {
  createNewsLetter(input: $input) {
    sale {
      id
      name
    }
  }
}
    `;
export type CreateNewsLetterMutationFn = Apollo.MutationFunction<CreateNewsLetterMutation, CreateNewsLetterMutationVariables>;

/**
 * __useCreateNewsLetterMutation__
 *
 * To run a mutation, you first call `useCreateNewsLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsLetterMutation, { data, loading, error }] = useCreateNewsLetterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewsLetterMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsLetterMutation, CreateNewsLetterMutationVariables>) {
        return Apollo.useMutation<CreateNewsLetterMutation, CreateNewsLetterMutationVariables>(CreateNewsLetterDocument, baseOptions);
      }
export type CreateNewsLetterMutationHookResult = ReturnType<typeof useCreateNewsLetterMutation>;
export type CreateNewsLetterMutationResult = Apollo.MutationResult<CreateNewsLetterMutation>;
export type CreateNewsLetterMutationOptions = Apollo.BaseMutationOptions<CreateNewsLetterMutation, CreateNewsLetterMutationVariables>;
export const OrdersDocument = gql`
    query Orders($where: OrderFilterType, $first: Int, $last: Int, $after: String, $before: String, $orderBy: ItemOrderType) {
  orders(
    where: $where
    first: $first
    last: $last
    after: $after
    before: $before
    orderBy: $orderBy
  ) {
    edges {
      node {
        ...OrderTable
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${OrderTableFragmentDoc}`;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, baseOptions);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, baseOptions);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const OrderDocument = gql`
    query Order($id: ID!) {
  order(id: $id) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, baseOptions);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, baseOptions);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const UpdateOrderItemDocument = gql`
    mutation UpdateOrderItem($input: UpdateOrderItemMutationInput!) {
  updateOrderItem(input: $input) {
    orderItem {
      id
    }
  }
}
    `;
export type UpdateOrderItemMutationFn = Apollo.MutationFunction<UpdateOrderItemMutation, UpdateOrderItemMutationVariables>;

/**
 * __useUpdateOrderItemMutation__
 *
 * To run a mutation, you first call `useUpdateOrderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderItemMutation, { data, loading, error }] = useUpdateOrderItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderItemMutation, UpdateOrderItemMutationVariables>) {
        return Apollo.useMutation<UpdateOrderItemMutation, UpdateOrderItemMutationVariables>(UpdateOrderItemDocument, baseOptions);
      }
export type UpdateOrderItemMutationHookResult = ReturnType<typeof useUpdateOrderItemMutation>;
export type UpdateOrderItemMutationResult = Apollo.MutationResult<UpdateOrderItemMutation>;
export type UpdateOrderItemMutationOptions = Apollo.BaseMutationOptions<UpdateOrderItemMutation, UpdateOrderItemMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($input: UpdateOrderMutationInput!) {
  updateOrder(input: $input) {
    order {
      id
    }
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, baseOptions);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const RegenerateLabelDocument = gql`
    mutation RegenerateLabel($input: RegenerateLabelMutationInput!) {
  regenerateLabel(input: $input) {
    label {
      id
      status
      errorMessage
    }
    errors
  }
}
    `;
export type RegenerateLabelMutationFn = Apollo.MutationFunction<RegenerateLabelMutation, RegenerateLabelMutationVariables>;

/**
 * __useRegenerateLabelMutation__
 *
 * To run a mutation, you first call `useRegenerateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateLabelMutation, { data, loading, error }] = useRegenerateLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegenerateLabelMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateLabelMutation, RegenerateLabelMutationVariables>) {
        return Apollo.useMutation<RegenerateLabelMutation, RegenerateLabelMutationVariables>(RegenerateLabelDocument, baseOptions);
      }
export type RegenerateLabelMutationHookResult = ReturnType<typeof useRegenerateLabelMutation>;
export type RegenerateLabelMutationResult = Apollo.MutationResult<RegenerateLabelMutation>;
export type RegenerateLabelMutationOptions = Apollo.BaseMutationOptions<RegenerateLabelMutation, RegenerateLabelMutationVariables>;
export const PaidSlipsDocument = gql`
    query PaidSlips($where: PaidSlipFilter) {
  paidSlips(where: $where, orderBy: {attribute: "updatedAt", direction: "desc"}) {
    ...PaidSlipEdges
  }
}
    ${PaidSlipEdgesFragmentDoc}`;

/**
 * __usePaidSlipsQuery__
 *
 * To run a query within a React component, call `usePaidSlipsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaidSlipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaidSlipsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePaidSlipsQuery(baseOptions?: Apollo.QueryHookOptions<PaidSlipsQuery, PaidSlipsQueryVariables>) {
        return Apollo.useQuery<PaidSlipsQuery, PaidSlipsQueryVariables>(PaidSlipsDocument, baseOptions);
      }
export function usePaidSlipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaidSlipsQuery, PaidSlipsQueryVariables>) {
          return Apollo.useLazyQuery<PaidSlipsQuery, PaidSlipsQueryVariables>(PaidSlipsDocument, baseOptions);
        }
export type PaidSlipsQueryHookResult = ReturnType<typeof usePaidSlipsQuery>;
export type PaidSlipsLazyQueryHookResult = ReturnType<typeof usePaidSlipsLazyQuery>;
export type PaidSlipsQueryResult = Apollo.QueryResult<PaidSlipsQuery, PaidSlipsQueryVariables>;
export const BulkMarkExpertStatementPaymentsAsPaidDocument = gql`
    mutation BulkMarkExpertStatementPaymentsAsPaid($input: BulkMarkExpertStatementPaymentsAsPaidInput!) {
  bulkMarkExpertStatementPaymentsAsPaid(input: $input) {
    updatedCount
    errors
  }
}
    `;
export type BulkMarkExpertStatementPaymentsAsPaidMutationFn = Apollo.MutationFunction<BulkMarkExpertStatementPaymentsAsPaidMutation, BulkMarkExpertStatementPaymentsAsPaidMutationVariables>;

/**
 * __useBulkMarkExpertStatementPaymentsAsPaidMutation__
 *
 * To run a mutation, you first call `useBulkMarkExpertStatementPaymentsAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkExpertStatementPaymentsAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkExpertStatementPaymentsAsPaidMutation, { data, loading, error }] = useBulkMarkExpertStatementPaymentsAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMarkExpertStatementPaymentsAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkExpertStatementPaymentsAsPaidMutation, BulkMarkExpertStatementPaymentsAsPaidMutationVariables>) {
        return Apollo.useMutation<BulkMarkExpertStatementPaymentsAsPaidMutation, BulkMarkExpertStatementPaymentsAsPaidMutationVariables>(BulkMarkExpertStatementPaymentsAsPaidDocument, baseOptions);
      }
export type BulkMarkExpertStatementPaymentsAsPaidMutationHookResult = ReturnType<typeof useBulkMarkExpertStatementPaymentsAsPaidMutation>;
export type BulkMarkExpertStatementPaymentsAsPaidMutationResult = Apollo.MutationResult<BulkMarkExpertStatementPaymentsAsPaidMutation>;
export type BulkMarkExpertStatementPaymentsAsPaidMutationOptions = Apollo.BaseMutationOptions<BulkMarkExpertStatementPaymentsAsPaidMutation, BulkMarkExpertStatementPaymentsAsPaidMutationVariables>;
export const BulkMarkExpertPaymentsAsPaidDocument = gql`
    mutation BulkMarkExpertPaymentsAsPaid($input: BulkMarkExpertPaymentsAsPaidInput!) {
  bulkMarkExpertPaymentsAsPaid(input: $input) {
    updatedCount
    errors
  }
}
    `;
export type BulkMarkExpertPaymentsAsPaidMutationFn = Apollo.MutationFunction<BulkMarkExpertPaymentsAsPaidMutation, BulkMarkExpertPaymentsAsPaidMutationVariables>;

/**
 * __useBulkMarkExpertPaymentsAsPaidMutation__
 *
 * To run a mutation, you first call `useBulkMarkExpertPaymentsAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkExpertPaymentsAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkExpertPaymentsAsPaidMutation, { data, loading, error }] = useBulkMarkExpertPaymentsAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMarkExpertPaymentsAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkExpertPaymentsAsPaidMutation, BulkMarkExpertPaymentsAsPaidMutationVariables>) {
        return Apollo.useMutation<BulkMarkExpertPaymentsAsPaidMutation, BulkMarkExpertPaymentsAsPaidMutationVariables>(BulkMarkExpertPaymentsAsPaidDocument, baseOptions);
      }
export type BulkMarkExpertPaymentsAsPaidMutationHookResult = ReturnType<typeof useBulkMarkExpertPaymentsAsPaidMutation>;
export type BulkMarkExpertPaymentsAsPaidMutationResult = Apollo.MutationResult<BulkMarkExpertPaymentsAsPaidMutation>;
export type BulkMarkExpertPaymentsAsPaidMutationOptions = Apollo.BaseMutationOptions<BulkMarkExpertPaymentsAsPaidMutation, BulkMarkExpertPaymentsAsPaidMutationVariables>;
export const BulkMarkWriterPaymentsAsPaidDocument = gql`
    mutation BulkMarkWriterPaymentsAsPaid($input: BulkMarkWriterPaymentsAsPaidInput!) {
  bulkMarkWriterPaymentsAsPaid(input: $input) {
    updatedCount
    errors
  }
}
    `;
export type BulkMarkWriterPaymentsAsPaidMutationFn = Apollo.MutationFunction<BulkMarkWriterPaymentsAsPaidMutation, BulkMarkWriterPaymentsAsPaidMutationVariables>;

/**
 * __useBulkMarkWriterPaymentsAsPaidMutation__
 *
 * To run a mutation, you first call `useBulkMarkWriterPaymentsAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkWriterPaymentsAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkWriterPaymentsAsPaidMutation, { data, loading, error }] = useBulkMarkWriterPaymentsAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMarkWriterPaymentsAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkWriterPaymentsAsPaidMutation, BulkMarkWriterPaymentsAsPaidMutationVariables>) {
        return Apollo.useMutation<BulkMarkWriterPaymentsAsPaidMutation, BulkMarkWriterPaymentsAsPaidMutationVariables>(BulkMarkWriterPaymentsAsPaidDocument, baseOptions);
      }
export type BulkMarkWriterPaymentsAsPaidMutationHookResult = ReturnType<typeof useBulkMarkWriterPaymentsAsPaidMutation>;
export type BulkMarkWriterPaymentsAsPaidMutationResult = Apollo.MutationResult<BulkMarkWriterPaymentsAsPaidMutation>;
export type BulkMarkWriterPaymentsAsPaidMutationOptions = Apollo.BaseMutationOptions<BulkMarkWriterPaymentsAsPaidMutation, BulkMarkWriterPaymentsAsPaidMutationVariables>;
export const BulkMarkWriterStatementPaymentsAsPaidDocument = gql`
    mutation BulkMarkWriterStatementPaymentsAsPaid($input: BulkMarkWriterStatementPaymentsAsPaidInput!) {
  bulkMarkWriterStatementPaymentsAsPaid(input: $input) {
    updatedCount
    errors
  }
}
    `;
export type BulkMarkWriterStatementPaymentsAsPaidMutationFn = Apollo.MutationFunction<BulkMarkWriterStatementPaymentsAsPaidMutation, BulkMarkWriterStatementPaymentsAsPaidMutationVariables>;

/**
 * __useBulkMarkWriterStatementPaymentsAsPaidMutation__
 *
 * To run a mutation, you first call `useBulkMarkWriterStatementPaymentsAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkWriterStatementPaymentsAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkWriterStatementPaymentsAsPaidMutation, { data, loading, error }] = useBulkMarkWriterStatementPaymentsAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMarkWriterStatementPaymentsAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkWriterStatementPaymentsAsPaidMutation, BulkMarkWriterStatementPaymentsAsPaidMutationVariables>) {
        return Apollo.useMutation<BulkMarkWriterStatementPaymentsAsPaidMutation, BulkMarkWriterStatementPaymentsAsPaidMutationVariables>(BulkMarkWriterStatementPaymentsAsPaidDocument, baseOptions);
      }
export type BulkMarkWriterStatementPaymentsAsPaidMutationHookResult = ReturnType<typeof useBulkMarkWriterStatementPaymentsAsPaidMutation>;
export type BulkMarkWriterStatementPaymentsAsPaidMutationResult = Apollo.MutationResult<BulkMarkWriterStatementPaymentsAsPaidMutation>;
export type BulkMarkWriterStatementPaymentsAsPaidMutationOptions = Apollo.BaseMutationOptions<BulkMarkWriterStatementPaymentsAsPaidMutation, BulkMarkWriterStatementPaymentsAsPaidMutationVariables>;
export const BulkMarkImportPaymentsAsPaidDocument = gql`
    mutation BulkMarkImportPaymentsAsPaid($input: BulkMarkImportPaymentsAsPaidInput!) {
  bulkMarkImportPaymentsAsPaid(input: $input) {
    updatedCount
    errors
  }
}
    `;
export type BulkMarkImportPaymentsAsPaidMutationFn = Apollo.MutationFunction<BulkMarkImportPaymentsAsPaidMutation, BulkMarkImportPaymentsAsPaidMutationVariables>;

/**
 * __useBulkMarkImportPaymentsAsPaidMutation__
 *
 * To run a mutation, you first call `useBulkMarkImportPaymentsAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkImportPaymentsAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkImportPaymentsAsPaidMutation, { data, loading, error }] = useBulkMarkImportPaymentsAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMarkImportPaymentsAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkImportPaymentsAsPaidMutation, BulkMarkImportPaymentsAsPaidMutationVariables>) {
        return Apollo.useMutation<BulkMarkImportPaymentsAsPaidMutation, BulkMarkImportPaymentsAsPaidMutationVariables>(BulkMarkImportPaymentsAsPaidDocument, baseOptions);
      }
export type BulkMarkImportPaymentsAsPaidMutationHookResult = ReturnType<typeof useBulkMarkImportPaymentsAsPaidMutation>;
export type BulkMarkImportPaymentsAsPaidMutationResult = Apollo.MutationResult<BulkMarkImportPaymentsAsPaidMutation>;
export type BulkMarkImportPaymentsAsPaidMutationOptions = Apollo.BaseMutationOptions<BulkMarkImportPaymentsAsPaidMutation, BulkMarkImportPaymentsAsPaidMutationVariables>;
export const BulkMarkImportStatementPaymentsAsPaidDocument = gql`
    mutation BulkMarkImportStatementPaymentsAsPaid($input: BulkMarkImportStatementPaymentsAsPaidInput!) {
  bulkMarkImportStatementPaymentsAsPaid(input: $input) {
    updatedCount
    errors
  }
}
    `;
export type BulkMarkImportStatementPaymentsAsPaidMutationFn = Apollo.MutationFunction<BulkMarkImportStatementPaymentsAsPaidMutation, BulkMarkImportStatementPaymentsAsPaidMutationVariables>;

/**
 * __useBulkMarkImportStatementPaymentsAsPaidMutation__
 *
 * To run a mutation, you first call `useBulkMarkImportStatementPaymentsAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkImportStatementPaymentsAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkImportStatementPaymentsAsPaidMutation, { data, loading, error }] = useBulkMarkImportStatementPaymentsAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMarkImportStatementPaymentsAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkImportStatementPaymentsAsPaidMutation, BulkMarkImportStatementPaymentsAsPaidMutationVariables>) {
        return Apollo.useMutation<BulkMarkImportStatementPaymentsAsPaidMutation, BulkMarkImportStatementPaymentsAsPaidMutationVariables>(BulkMarkImportStatementPaymentsAsPaidDocument, baseOptions);
      }
export type BulkMarkImportStatementPaymentsAsPaidMutationHookResult = ReturnType<typeof useBulkMarkImportStatementPaymentsAsPaidMutation>;
export type BulkMarkImportStatementPaymentsAsPaidMutationResult = Apollo.MutationResult<BulkMarkImportStatementPaymentsAsPaidMutation>;
export type BulkMarkImportStatementPaymentsAsPaidMutationOptions = Apollo.BaseMutationOptions<BulkMarkImportStatementPaymentsAsPaidMutation, BulkMarkImportStatementPaymentsAsPaidMutationVariables>;
export const BulkMarkMonthlyVendorPaymentsAsPaidDocument = gql`
    mutation BulkMarkMonthlyVendorPaymentsAsPaid($input: BulkMarkMonthlyVendorPaymentsAsPaidInput!) {
  bulkMarkMonthlyVendorPaymentsAsPaid(input: $input) {
    updatedCount
    errors
  }
}
    `;
export type BulkMarkMonthlyVendorPaymentsAsPaidMutationFn = Apollo.MutationFunction<BulkMarkMonthlyVendorPaymentsAsPaidMutation, BulkMarkMonthlyVendorPaymentsAsPaidMutationVariables>;

/**
 * __useBulkMarkMonthlyVendorPaymentsAsPaidMutation__
 *
 * To run a mutation, you first call `useBulkMarkMonthlyVendorPaymentsAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkMonthlyVendorPaymentsAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkMonthlyVendorPaymentsAsPaidMutation, { data, loading, error }] = useBulkMarkMonthlyVendorPaymentsAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMarkMonthlyVendorPaymentsAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkMonthlyVendorPaymentsAsPaidMutation, BulkMarkMonthlyVendorPaymentsAsPaidMutationVariables>) {
        return Apollo.useMutation<BulkMarkMonthlyVendorPaymentsAsPaidMutation, BulkMarkMonthlyVendorPaymentsAsPaidMutationVariables>(BulkMarkMonthlyVendorPaymentsAsPaidDocument, baseOptions);
      }
export type BulkMarkMonthlyVendorPaymentsAsPaidMutationHookResult = ReturnType<typeof useBulkMarkMonthlyVendorPaymentsAsPaidMutation>;
export type BulkMarkMonthlyVendorPaymentsAsPaidMutationResult = Apollo.MutationResult<BulkMarkMonthlyVendorPaymentsAsPaidMutation>;
export type BulkMarkMonthlyVendorPaymentsAsPaidMutationOptions = Apollo.BaseMutationOptions<BulkMarkMonthlyVendorPaymentsAsPaidMutation, BulkMarkMonthlyVendorPaymentsAsPaidMutationVariables>;
export const BulkMarkVendorStatementPaymentsAsPaidDocument = gql`
    mutation BulkMarkVendorStatementPaymentsAsPaid($input: BulkMarkVendorStatementPaymentsAsPaidInput!) {
  bulkMarkVendorStatementPaymentsAsPaid(input: $input) {
    updatedCount
    errors
  }
}
    `;
export type BulkMarkVendorStatementPaymentsAsPaidMutationFn = Apollo.MutationFunction<BulkMarkVendorStatementPaymentsAsPaidMutation, BulkMarkVendorStatementPaymentsAsPaidMutationVariables>;

/**
 * __useBulkMarkVendorStatementPaymentsAsPaidMutation__
 *
 * To run a mutation, you first call `useBulkMarkVendorStatementPaymentsAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkVendorStatementPaymentsAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkVendorStatementPaymentsAsPaidMutation, { data, loading, error }] = useBulkMarkVendorStatementPaymentsAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMarkVendorStatementPaymentsAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkVendorStatementPaymentsAsPaidMutation, BulkMarkVendorStatementPaymentsAsPaidMutationVariables>) {
        return Apollo.useMutation<BulkMarkVendorStatementPaymentsAsPaidMutation, BulkMarkVendorStatementPaymentsAsPaidMutationVariables>(BulkMarkVendorStatementPaymentsAsPaidDocument, baseOptions);
      }
export type BulkMarkVendorStatementPaymentsAsPaidMutationHookResult = ReturnType<typeof useBulkMarkVendorStatementPaymentsAsPaidMutation>;
export type BulkMarkVendorStatementPaymentsAsPaidMutationResult = Apollo.MutationResult<BulkMarkVendorStatementPaymentsAsPaidMutation>;
export type BulkMarkVendorStatementPaymentsAsPaidMutationOptions = Apollo.BaseMutationOptions<BulkMarkVendorStatementPaymentsAsPaidMutation, BulkMarkVendorStatementPaymentsAsPaidMutationVariables>;
export const UpdateUserPersonalInformationsDocument = gql`
    mutation updateUserPersonalInformations($id: ID!, $firstName: String, $lastName: String) {
  updateUser(
    input: {id: $id, attributes: {firstName: $firstName, lastName: $lastName}}
  ) {
    id
    firstName
    lastName
  }
}
    `;
export type UpdateUserPersonalInformationsMutationFn = Apollo.MutationFunction<UpdateUserPersonalInformationsMutation, UpdateUserPersonalInformationsMutationVariables>;

/**
 * __useUpdateUserPersonalInformationsMutation__
 *
 * To run a mutation, you first call `useUpdateUserPersonalInformationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPersonalInformationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPersonalInformationsMutation, { data, loading, error }] = useUpdateUserPersonalInformationsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateUserPersonalInformationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPersonalInformationsMutation, UpdateUserPersonalInformationsMutationVariables>) {
        return Apollo.useMutation<UpdateUserPersonalInformationsMutation, UpdateUserPersonalInformationsMutationVariables>(UpdateUserPersonalInformationsDocument, baseOptions);
      }
export type UpdateUserPersonalInformationsMutationHookResult = ReturnType<typeof useUpdateUserPersonalInformationsMutation>;
export type UpdateUserPersonalInformationsMutationResult = Apollo.MutationResult<UpdateUserPersonalInformationsMutation>;
export type UpdateUserPersonalInformationsMutationOptions = Apollo.BaseMutationOptions<UpdateUserPersonalInformationsMutation, UpdateUserPersonalInformationsMutationVariables>;
export const CreatePickupRequestDocument = gql`
    mutation CreatePickupRequest($input: CreatePickupRequestMutationInput!) {
  createPickupRequest(input: $input) {
    pickupRequest {
      ...PickupRequest
    }
    errors {
      fullMessages
    }
  }
}
    ${PickupRequestFragmentDoc}`;
export type CreatePickupRequestMutationFn = Apollo.MutationFunction<CreatePickupRequestMutation, CreatePickupRequestMutationVariables>;

/**
 * __useCreatePickupRequestMutation__
 *
 * To run a mutation, you first call `useCreatePickupRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePickupRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPickupRequestMutation, { data, loading, error }] = useCreatePickupRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePickupRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePickupRequestMutation, CreatePickupRequestMutationVariables>) {
        return Apollo.useMutation<CreatePickupRequestMutation, CreatePickupRequestMutationVariables>(CreatePickupRequestDocument, baseOptions);
      }
export type CreatePickupRequestMutationHookResult = ReturnType<typeof useCreatePickupRequestMutation>;
export type CreatePickupRequestMutationResult = Apollo.MutationResult<CreatePickupRequestMutation>;
export type CreatePickupRequestMutationOptions = Apollo.BaseMutationOptions<CreatePickupRequestMutation, CreatePickupRequestMutationVariables>;
export const AvailablePickupLabelsDocument = gql`
    query AvailablePickupLabels($search: String, $after: String, $first: Int = 20) {
  availablePickupLabels(search: $search, after: $after, first: $first) {
    nodes {
      ...PickupParcel
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ${PickupParcelFragmentDoc}`;

/**
 * __useAvailablePickupLabelsQuery__
 *
 * To run a query within a React component, call `useAvailablePickupLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePickupLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePickupLabelsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAvailablePickupLabelsQuery(baseOptions?: Apollo.QueryHookOptions<AvailablePickupLabelsQuery, AvailablePickupLabelsQueryVariables>) {
        return Apollo.useQuery<AvailablePickupLabelsQuery, AvailablePickupLabelsQueryVariables>(AvailablePickupLabelsDocument, baseOptions);
      }
export function useAvailablePickupLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailablePickupLabelsQuery, AvailablePickupLabelsQueryVariables>) {
          return Apollo.useLazyQuery<AvailablePickupLabelsQuery, AvailablePickupLabelsQueryVariables>(AvailablePickupLabelsDocument, baseOptions);
        }
export type AvailablePickupLabelsQueryHookResult = ReturnType<typeof useAvailablePickupLabelsQuery>;
export type AvailablePickupLabelsLazyQueryHookResult = ReturnType<typeof useAvailablePickupLabelsLazyQuery>;
export type AvailablePickupLabelsQueryResult = Apollo.QueryResult<AvailablePickupLabelsQuery, AvailablePickupLabelsQueryVariables>;
export const PickupRequestDocument = gql`
    query PickupRequest($id: ID!) {
  pickupRequest(id: $id) {
    ...PickupRequest
  }
}
    ${PickupRequestFragmentDoc}`;

/**
 * __usePickupRequestQuery__
 *
 * To run a query within a React component, call `usePickupRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickupRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickupRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePickupRequestQuery(baseOptions: Apollo.QueryHookOptions<PickupRequestQuery, PickupRequestQueryVariables>) {
        return Apollo.useQuery<PickupRequestQuery, PickupRequestQueryVariables>(PickupRequestDocument, baseOptions);
      }
export function usePickupRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickupRequestQuery, PickupRequestQueryVariables>) {
          return Apollo.useLazyQuery<PickupRequestQuery, PickupRequestQueryVariables>(PickupRequestDocument, baseOptions);
        }
export type PickupRequestQueryHookResult = ReturnType<typeof usePickupRequestQuery>;
export type PickupRequestLazyQueryHookResult = ReturnType<typeof usePickupRequestLazyQuery>;
export type PickupRequestQueryResult = Apollo.QueryResult<PickupRequestQuery, PickupRequestQueryVariables>;
export const PickupRequestsDocument = gql`
    query PickupRequests($where: PickupRequestFilter, $orderBy: ItemOrderType, $first: Int = 20, $after: String) {
  pickupRequests(where: $where, orderBy: $orderBy, first: $first, after: $after) {
    nodes {
      ...PickupRequest
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ${PickupRequestFragmentDoc}`;

/**
 * __usePickupRequestsQuery__
 *
 * To run a query within a React component, call `usePickupRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickupRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickupRequestsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePickupRequestsQuery(baseOptions?: Apollo.QueryHookOptions<PickupRequestsQuery, PickupRequestsQueryVariables>) {
        return Apollo.useQuery<PickupRequestsQuery, PickupRequestsQueryVariables>(PickupRequestsDocument, baseOptions);
      }
export function usePickupRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickupRequestsQuery, PickupRequestsQueryVariables>) {
          return Apollo.useLazyQuery<PickupRequestsQuery, PickupRequestsQueryVariables>(PickupRequestsDocument, baseOptions);
        }
export type PickupRequestsQueryHookResult = ReturnType<typeof usePickupRequestsQuery>;
export type PickupRequestsLazyQueryHookResult = ReturnType<typeof usePickupRequestsLazyQuery>;
export type PickupRequestsQueryResult = Apollo.QueryResult<PickupRequestsQuery, PickupRequestsQueryVariables>;
export const GetAddressesProfileDocument = gql`
    query GetAddressesProfile($where: AddressFilter) {
  addresses(where: $where) {
    edges {
      node {
        ...AddressProfile
      }
    }
  }
}
    ${AddressProfileFragmentDoc}`;

/**
 * __useGetAddressesProfileQuery__
 *
 * To run a query within a React component, call `useGetAddressesProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressesProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressesProfileQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAddressesProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetAddressesProfileQuery, GetAddressesProfileQueryVariables>) {
        return Apollo.useQuery<GetAddressesProfileQuery, GetAddressesProfileQueryVariables>(GetAddressesProfileDocument, baseOptions);
      }
export function useGetAddressesProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressesProfileQuery, GetAddressesProfileQueryVariables>) {
          return Apollo.useLazyQuery<GetAddressesProfileQuery, GetAddressesProfileQueryVariables>(GetAddressesProfileDocument, baseOptions);
        }
export type GetAddressesProfileQueryHookResult = ReturnType<typeof useGetAddressesProfileQuery>;
export type GetAddressesProfileLazyQueryHookResult = ReturnType<typeof useGetAddressesProfileLazyQuery>;
export type GetAddressesProfileQueryResult = Apollo.QueryResult<GetAddressesProfileQuery, GetAddressesProfileQueryVariables>;
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($id: ID!, $attributes: UpdateAddressInput!) {
  updateAddress(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    address {
      id
    }
  }
}
    `;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, baseOptions);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const GetBankInformationProfileDocument = gql`
    query GetBankInformationProfile($id: ID!) {
  bankInformation(id: $id) {
    ...BankInformationProfile
  }
}
    ${BankInformationProfileFragmentDoc}`;

/**
 * __useGetBankInformationProfileQuery__
 *
 * To run a query within a React component, call `useGetBankInformationProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankInformationProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankInformationProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBankInformationProfileQuery(baseOptions: Apollo.QueryHookOptions<GetBankInformationProfileQuery, GetBankInformationProfileQueryVariables>) {
        return Apollo.useQuery<GetBankInformationProfileQuery, GetBankInformationProfileQueryVariables>(GetBankInformationProfileDocument, baseOptions);
      }
export function useGetBankInformationProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankInformationProfileQuery, GetBankInformationProfileQueryVariables>) {
          return Apollo.useLazyQuery<GetBankInformationProfileQuery, GetBankInformationProfileQueryVariables>(GetBankInformationProfileDocument, baseOptions);
        }
export type GetBankInformationProfileQueryHookResult = ReturnType<typeof useGetBankInformationProfileQuery>;
export type GetBankInformationProfileLazyQueryHookResult = ReturnType<typeof useGetBankInformationProfileLazyQuery>;
export type GetBankInformationProfileQueryResult = Apollo.QueryResult<GetBankInformationProfileQuery, GetBankInformationProfileQueryVariables>;
export const UpdateBankInformationDocument = gql`
    mutation UpdateBankInformation($id: ID!, $attributes: UpdateBankInformationInput!) {
  updateBankInformation(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    bankInformation {
      id
    }
  }
}
    `;
export type UpdateBankInformationMutationFn = Apollo.MutationFunction<UpdateBankInformationMutation, UpdateBankInformationMutationVariables>;

/**
 * __useUpdateBankInformationMutation__
 *
 * To run a mutation, you first call `useUpdateBankInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankInformationMutation, { data, loading, error }] = useUpdateBankInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateBankInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBankInformationMutation, UpdateBankInformationMutationVariables>) {
        return Apollo.useMutation<UpdateBankInformationMutation, UpdateBankInformationMutationVariables>(UpdateBankInformationDocument, baseOptions);
      }
export type UpdateBankInformationMutationHookResult = ReturnType<typeof useUpdateBankInformationMutation>;
export type UpdateBankInformationMutationResult = Apollo.MutationResult<UpdateBankInformationMutation>;
export type UpdateBankInformationMutationOptions = Apollo.BaseMutationOptions<UpdateBankInformationMutation, UpdateBankInformationMutationVariables>;
export const GetAccountProfileDocument = gql`
    query GetAccountProfile($id: ID!, $includeLegacyShippingAddress: Boolean = true) {
  account(id: $id) {
    ...AccountProfile
  }
}
    ${AccountProfileFragmentDoc}`;

/**
 * __useGetAccountProfileQuery__
 *
 * To run a query within a React component, call `useGetAccountProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeLegacyShippingAddress: // value for 'includeLegacyShippingAddress'
 *   },
 * });
 */
export function useGetAccountProfileQuery(baseOptions: Apollo.QueryHookOptions<GetAccountProfileQuery, GetAccountProfileQueryVariables>) {
        return Apollo.useQuery<GetAccountProfileQuery, GetAccountProfileQueryVariables>(GetAccountProfileDocument, baseOptions);
      }
export function useGetAccountProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountProfileQuery, GetAccountProfileQueryVariables>) {
          return Apollo.useLazyQuery<GetAccountProfileQuery, GetAccountProfileQueryVariables>(GetAccountProfileDocument, baseOptions);
        }
export type GetAccountProfileQueryHookResult = ReturnType<typeof useGetAccountProfileQuery>;
export type GetAccountProfileLazyQueryHookResult = ReturnType<typeof useGetAccountProfileLazyQuery>;
export type GetAccountProfileQueryResult = Apollo.QueryResult<GetAccountProfileQuery, GetAccountProfileQueryVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($id: ID!, $attributes: UpdateAccountInput!) {
  customUpdateAccount(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    account {
      id
    }
  }
}
    `;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, baseOptions);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UpdateVendorPickupHoursDocument = gql`
    mutation UpdateVendorPickupHours($pickupHours: [DayInput!]!, $activatePickup: Boolean) {
  updateVendorPickupHours(
    input: {pickupHours: $pickupHours, activatePickup: $activatePickup}
  ) {
    vendorPickupTimeRanges {
      day
      startTime
      endTime
    }
    errors {
      fullMessages
    }
  }
}
    `;
export type UpdateVendorPickupHoursMutationFn = Apollo.MutationFunction<UpdateVendorPickupHoursMutation, UpdateVendorPickupHoursMutationVariables>;

/**
 * __useUpdateVendorPickupHoursMutation__
 *
 * To run a mutation, you first call `useUpdateVendorPickupHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorPickupHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorPickupHoursMutation, { data, loading, error }] = useUpdateVendorPickupHoursMutation({
 *   variables: {
 *      pickupHours: // value for 'pickupHours'
 *      activatePickup: // value for 'activatePickup'
 *   },
 * });
 */
export function useUpdateVendorPickupHoursMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorPickupHoursMutation, UpdateVendorPickupHoursMutationVariables>) {
        return Apollo.useMutation<UpdateVendorPickupHoursMutation, UpdateVendorPickupHoursMutationVariables>(UpdateVendorPickupHoursDocument, baseOptions);
      }
export type UpdateVendorPickupHoursMutationHookResult = ReturnType<typeof useUpdateVendorPickupHoursMutation>;
export type UpdateVendorPickupHoursMutationResult = Apollo.MutationResult<UpdateVendorPickupHoursMutation>;
export type UpdateVendorPickupHoursMutationOptions = Apollo.BaseMutationOptions<UpdateVendorPickupHoursMutation, UpdateVendorPickupHoursMutationVariables>;
export const UploadIdentityDocumentInAccountDocument = gql`
    mutation UploadIdentityDocumentInAccount($id: ID!, $files: [UploadFileInput!]) {
  customUpdateAccount(input: {id: $id, attributes: {identityDocuments: $files}}) {
    clientMutationId
    account {
      id
      identityDocuments {
        imageUrl
      }
    }
  }
}
    `;
export type UploadIdentityDocumentInAccountMutationFn = Apollo.MutationFunction<UploadIdentityDocumentInAccountMutation, UploadIdentityDocumentInAccountMutationVariables>;

/**
 * __useUploadIdentityDocumentInAccountMutation__
 *
 * To run a mutation, you first call `useUploadIdentityDocumentInAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadIdentityDocumentInAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadIdentityDocumentInAccountMutation, { data, loading, error }] = useUploadIdentityDocumentInAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadIdentityDocumentInAccountMutation(baseOptions?: Apollo.MutationHookOptions<UploadIdentityDocumentInAccountMutation, UploadIdentityDocumentInAccountMutationVariables>) {
        return Apollo.useMutation<UploadIdentityDocumentInAccountMutation, UploadIdentityDocumentInAccountMutationVariables>(UploadIdentityDocumentInAccountDocument, baseOptions);
      }
export type UploadIdentityDocumentInAccountMutationHookResult = ReturnType<typeof useUploadIdentityDocumentInAccountMutation>;
export type UploadIdentityDocumentInAccountMutationResult = Apollo.MutationResult<UploadIdentityDocumentInAccountMutation>;
export type UploadIdentityDocumentInAccountMutationOptions = Apollo.BaseMutationOptions<UploadIdentityDocumentInAccountMutation, UploadIdentityDocumentInAccountMutationVariables>;
export const UploadRibDocumentInAccountDocument = gql`
    mutation UploadRibDocumentInAccount($id: ID!, $files: [UploadFileInput!]) {
  customUpdateAccount(input: {id: $id, attributes: {ribDocuments: $files}}) {
    clientMutationId
    account {
      id
      identityDocuments {
        imageUrl
      }
    }
  }
}
    `;
export type UploadRibDocumentInAccountMutationFn = Apollo.MutationFunction<UploadRibDocumentInAccountMutation, UploadRibDocumentInAccountMutationVariables>;

/**
 * __useUploadRibDocumentInAccountMutation__
 *
 * To run a mutation, you first call `useUploadRibDocumentInAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadRibDocumentInAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadRibDocumentInAccountMutation, { data, loading, error }] = useUploadRibDocumentInAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadRibDocumentInAccountMutation(baseOptions?: Apollo.MutationHookOptions<UploadRibDocumentInAccountMutation, UploadRibDocumentInAccountMutationVariables>) {
        return Apollo.useMutation<UploadRibDocumentInAccountMutation, UploadRibDocumentInAccountMutationVariables>(UploadRibDocumentInAccountDocument, baseOptions);
      }
export type UploadRibDocumentInAccountMutationHookResult = ReturnType<typeof useUploadRibDocumentInAccountMutation>;
export type UploadRibDocumentInAccountMutationResult = Apollo.MutationResult<UploadRibDocumentInAccountMutation>;
export type UploadRibDocumentInAccountMutationOptions = Apollo.BaseMutationOptions<UploadRibDocumentInAccountMutation, UploadRibDocumentInAccountMutationVariables>;
export const UpdateVendorShippingMethodsDocument = gql`
    mutation updateVendorShippingMethods($shippingOptions: [ShippingOptionEnum!]!) {
  updateVendorShippingMethods(input: {shippingOptions: $shippingOptions}) {
    shippingMethods {
      shippingOption
    }
    errors {
      fullMessages
    }
  }
}
    `;
export type UpdateVendorShippingMethodsMutationFn = Apollo.MutationFunction<UpdateVendorShippingMethodsMutation, UpdateVendorShippingMethodsMutationVariables>;

/**
 * __useUpdateVendorShippingMethodsMutation__
 *
 * To run a mutation, you first call `useUpdateVendorShippingMethodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorShippingMethodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorShippingMethodsMutation, { data, loading, error }] = useUpdateVendorShippingMethodsMutation({
 *   variables: {
 *      shippingOptions: // value for 'shippingOptions'
 *   },
 * });
 */
export function useUpdateVendorShippingMethodsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorShippingMethodsMutation, UpdateVendorShippingMethodsMutationVariables>) {
        return Apollo.useMutation<UpdateVendorShippingMethodsMutation, UpdateVendorShippingMethodsMutationVariables>(UpdateVendorShippingMethodsDocument, baseOptions);
      }
export type UpdateVendorShippingMethodsMutationHookResult = ReturnType<typeof useUpdateVendorShippingMethodsMutation>;
export type UpdateVendorShippingMethodsMutationResult = Apollo.MutationResult<UpdateVendorShippingMethodsMutation>;
export type UpdateVendorShippingMethodsMutationOptions = Apollo.BaseMutationOptions<UpdateVendorShippingMethodsMutation, UpdateVendorShippingMethodsMutationVariables>;
export const CreateProjectFeeDocument = gql`
    mutation CreateProjectFee($input: CreateProjectFeeMutationInput!) {
  createProjectFee(input: $input) {
    projectFee {
      id
    }
    errors {
      details
    }
  }
}
    `;
export type CreateProjectFeeMutationFn = Apollo.MutationFunction<CreateProjectFeeMutation, CreateProjectFeeMutationVariables>;

/**
 * __useCreateProjectFeeMutation__
 *
 * To run a mutation, you first call `useCreateProjectFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFeeMutation, { data, loading, error }] = useCreateProjectFeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectFeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectFeeMutation, CreateProjectFeeMutationVariables>) {
        return Apollo.useMutation<CreateProjectFeeMutation, CreateProjectFeeMutationVariables>(CreateProjectFeeDocument, baseOptions);
      }
export type CreateProjectFeeMutationHookResult = ReturnType<typeof useCreateProjectFeeMutation>;
export type CreateProjectFeeMutationResult = Apollo.MutationResult<CreateProjectFeeMutation>;
export type CreateProjectFeeMutationOptions = Apollo.BaseMutationOptions<CreateProjectFeeMutation, CreateProjectFeeMutationVariables>;
export const UpdateProjectFeeDocument = gql`
    mutation UpdateProjectFee($input: UpdateProjectFeeMutationInput!) {
  updateProjectFee(input: $input) {
    projectFee {
      id
    }
    errors {
      details
    }
  }
}
    `;
export type UpdateProjectFeeMutationFn = Apollo.MutationFunction<UpdateProjectFeeMutation, UpdateProjectFeeMutationVariables>;

/**
 * __useUpdateProjectFeeMutation__
 *
 * To run a mutation, you first call `useUpdateProjectFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectFeeMutation, { data, loading, error }] = useUpdateProjectFeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectFeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectFeeMutation, UpdateProjectFeeMutationVariables>) {
        return Apollo.useMutation<UpdateProjectFeeMutation, UpdateProjectFeeMutationVariables>(UpdateProjectFeeDocument, baseOptions);
      }
export type UpdateProjectFeeMutationHookResult = ReturnType<typeof useUpdateProjectFeeMutation>;
export type UpdateProjectFeeMutationResult = Apollo.MutationResult<UpdateProjectFeeMutation>;
export type UpdateProjectFeeMutationOptions = Apollo.BaseMutationOptions<UpdateProjectFeeMutation, UpdateProjectFeeMutationVariables>;
export const DestroyProjectFeeDocument = gql`
    mutation DestroyProjectFee($id: ID!) {
  destroyProjectFee(input: {id: $id}) {
    projectFee {
      id
    }
    errors {
      details
    }
  }
}
    `;
export type DestroyProjectFeeMutationFn = Apollo.MutationFunction<DestroyProjectFeeMutation, DestroyProjectFeeMutationVariables>;

/**
 * __useDestroyProjectFeeMutation__
 *
 * To run a mutation, you first call `useDestroyProjectFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyProjectFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyProjectFeeMutation, { data, loading, error }] = useDestroyProjectFeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyProjectFeeMutation(baseOptions?: Apollo.MutationHookOptions<DestroyProjectFeeMutation, DestroyProjectFeeMutationVariables>) {
        return Apollo.useMutation<DestroyProjectFeeMutation, DestroyProjectFeeMutationVariables>(DestroyProjectFeeDocument, baseOptions);
      }
export type DestroyProjectFeeMutationHookResult = ReturnType<typeof useDestroyProjectFeeMutation>;
export type DestroyProjectFeeMutationResult = Apollo.MutationResult<DestroyProjectFeeMutation>;
export type DestroyProjectFeeMutationOptions = Apollo.BaseMutationOptions<DestroyProjectFeeMutation, DestroyProjectFeeMutationVariables>;
export const ProjectDocument = gql`
    query Project($id: ID!) {
  project(id: $id) {
    ...Project
    vendor {
      ...Vendor
      account {
        ...VendorAccount
        bankInformation {
          iban
          bic
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}
${VendorFragmentDoc}
${VendorAccountFragmentDoc}`;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
        return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, baseOptions);
      }
export function useProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, baseOptions);
        }
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>;
export const ProjectsDocument = gql`
    query Projects($where: ProjectFilter, $first: Int, $last: Int, $after: String, $before: String) {
  projects(
    where: $where
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      node {
        ...ProjectRow
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${ProjectRowFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, baseOptions);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, baseOptions);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($input: UpdateProjectMutationInput!) {
  updateProject(input: $input) {
    project {
      id
    }
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, baseOptions);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($input: CreateProjectMutationInput!) {
  createProject(input: $input) {
    project {
      id
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, baseOptions);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const VendorsDocument = gql`
    query Vendors($where: VendorFilter, $first: Int = 50) {
  vendors(
    where: $where
    orderBy: {attribute: "createdAt", direction: "asc"}
    first: $first
  ) {
    ...VendorEdges
  }
}
    ${VendorEdgesFragmentDoc}`;

/**
 * __useVendorsQuery__
 *
 * To run a query within a React component, call `useVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useVendorsQuery(baseOptions?: Apollo.QueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
        return Apollo.useQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, baseOptions);
      }
export function useVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
          return Apollo.useLazyQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, baseOptions);
        }
export type VendorsQueryHookResult = ReturnType<typeof useVendorsQuery>;
export type VendorsLazyQueryHookResult = ReturnType<typeof useVendorsLazyQuery>;
export type VendorsQueryResult = Apollo.QueryResult<VendorsQuery, VendorsQueryVariables>;
export const PurchaseSlipsDocument = gql`
    query PurchaseSlips($where: PurchaseSlipFilter) {
  purchaseSlips(
    where: $where
    orderBy: {attribute: "updatedAt", direction: "desc"}
  ) {
    ...PurchaseSlipEdges
  }
}
    ${PurchaseSlipEdgesFragmentDoc}`;

/**
 * __usePurchaseSlipsQuery__
 *
 * To run a query within a React component, call `usePurchaseSlipsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSlipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseSlipsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePurchaseSlipsQuery(baseOptions?: Apollo.QueryHookOptions<PurchaseSlipsQuery, PurchaseSlipsQueryVariables>) {
        return Apollo.useQuery<PurchaseSlipsQuery, PurchaseSlipsQueryVariables>(PurchaseSlipsDocument, baseOptions);
      }
export function usePurchaseSlipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseSlipsQuery, PurchaseSlipsQueryVariables>) {
          return Apollo.useLazyQuery<PurchaseSlipsQuery, PurchaseSlipsQueryVariables>(PurchaseSlipsDocument, baseOptions);
        }
export type PurchaseSlipsQueryHookResult = ReturnType<typeof usePurchaseSlipsQuery>;
export type PurchaseSlipsLazyQueryHookResult = ReturnType<typeof usePurchaseSlipsLazyQuery>;
export type PurchaseSlipsQueryResult = Apollo.QueryResult<PurchaseSlipsQuery, PurchaseSlipsQueryVariables>;
export const QuickTextDocument = gql`
    query QuickText($id: ID!) {
  quickText(id: $id) {
    ...QuickText
  }
}
    ${QuickTextFragmentDoc}`;

/**
 * __useQuickTextQuery__
 *
 * To run a query within a React component, call `useQuickTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickTextQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuickTextQuery(baseOptions: Apollo.QueryHookOptions<QuickTextQuery, QuickTextQueryVariables>) {
        return Apollo.useQuery<QuickTextQuery, QuickTextQueryVariables>(QuickTextDocument, baseOptions);
      }
export function useQuickTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickTextQuery, QuickTextQueryVariables>) {
          return Apollo.useLazyQuery<QuickTextQuery, QuickTextQueryVariables>(QuickTextDocument, baseOptions);
        }
export type QuickTextQueryHookResult = ReturnType<typeof useQuickTextQuery>;
export type QuickTextLazyQueryHookResult = ReturnType<typeof useQuickTextLazyQuery>;
export type QuickTextQueryResult = Apollo.QueryResult<QuickTextQuery, QuickTextQueryVariables>;
export const QuickTextsDocument = gql`
    query QuickTexts($where: QuickTextFilter, $first: Int = 10) {
  quickTexts(
    where: $where
    orderBy: {attribute: "createdAt", direction: "asc"}
    first: $first
  ) {
    ...QuickTextEdges
  }
}
    ${QuickTextEdgesFragmentDoc}`;

/**
 * __useQuickTextsQuery__
 *
 * To run a query within a React component, call `useQuickTextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickTextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickTextsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useQuickTextsQuery(baseOptions?: Apollo.QueryHookOptions<QuickTextsQuery, QuickTextsQueryVariables>) {
        return Apollo.useQuery<QuickTextsQuery, QuickTextsQueryVariables>(QuickTextsDocument, baseOptions);
      }
export function useQuickTextsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickTextsQuery, QuickTextsQueryVariables>) {
          return Apollo.useLazyQuery<QuickTextsQuery, QuickTextsQueryVariables>(QuickTextsDocument, baseOptions);
        }
export type QuickTextsQueryHookResult = ReturnType<typeof useQuickTextsQuery>;
export type QuickTextsLazyQueryHookResult = ReturnType<typeof useQuickTextsLazyQuery>;
export type QuickTextsQueryResult = Apollo.QueryResult<QuickTextsQuery, QuickTextsQueryVariables>;
export const CreateQuickTextDocument = gql`
    mutation CreateQuickText($input: CreateQuickTextMutationInput!) {
  createQuickText(input: $input) {
    quickText {
      id
    }
  }
}
    `;
export type CreateQuickTextMutationFn = Apollo.MutationFunction<CreateQuickTextMutation, CreateQuickTextMutationVariables>;

/**
 * __useCreateQuickTextMutation__
 *
 * To run a mutation, you first call `useCreateQuickTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuickTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuickTextMutation, { data, loading, error }] = useCreateQuickTextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuickTextMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuickTextMutation, CreateQuickTextMutationVariables>) {
        return Apollo.useMutation<CreateQuickTextMutation, CreateQuickTextMutationVariables>(CreateQuickTextDocument, baseOptions);
      }
export type CreateQuickTextMutationHookResult = ReturnType<typeof useCreateQuickTextMutation>;
export type CreateQuickTextMutationResult = Apollo.MutationResult<CreateQuickTextMutation>;
export type CreateQuickTextMutationOptions = Apollo.BaseMutationOptions<CreateQuickTextMutation, CreateQuickTextMutationVariables>;
export const UpdateQuickTextDocument = gql`
    mutation UpdateQuickText($input: UpdateQuickTextMutationInput!) {
  updateQuickText(input: $input) {
    quickText {
      id
    }
  }
}
    `;
export type UpdateQuickTextMutationFn = Apollo.MutationFunction<UpdateQuickTextMutation, UpdateQuickTextMutationVariables>;

/**
 * __useUpdateQuickTextMutation__
 *
 * To run a mutation, you first call `useUpdateQuickTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuickTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuickTextMutation, { data, loading, error }] = useUpdateQuickTextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuickTextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuickTextMutation, UpdateQuickTextMutationVariables>) {
        return Apollo.useMutation<UpdateQuickTextMutation, UpdateQuickTextMutationVariables>(UpdateQuickTextDocument, baseOptions);
      }
export type UpdateQuickTextMutationHookResult = ReturnType<typeof useUpdateQuickTextMutation>;
export type UpdateQuickTextMutationResult = Apollo.MutationResult<UpdateQuickTextMutation>;
export type UpdateQuickTextMutationOptions = Apollo.BaseMutationOptions<UpdateQuickTextMutation, UpdateQuickTextMutationVariables>;
export const DestroyQuickTextDocument = gql`
    mutation DestroyQuickText($input: DestroyQuickTextMutationInput!) {
  destroyQuickText(input: $input) {
    quickText {
      id
    }
  }
}
    `;
export type DestroyQuickTextMutationFn = Apollo.MutationFunction<DestroyQuickTextMutation, DestroyQuickTextMutationVariables>;

/**
 * __useDestroyQuickTextMutation__
 *
 * To run a mutation, you first call `useDestroyQuickTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyQuickTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyQuickTextMutation, { data, loading, error }] = useDestroyQuickTextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyQuickTextMutation(baseOptions?: Apollo.MutationHookOptions<DestroyQuickTextMutation, DestroyQuickTextMutationVariables>) {
        return Apollo.useMutation<DestroyQuickTextMutation, DestroyQuickTextMutationVariables>(DestroyQuickTextDocument, baseOptions);
      }
export type DestroyQuickTextMutationHookResult = ReturnType<typeof useDestroyQuickTextMutation>;
export type DestroyQuickTextMutationResult = Apollo.MutationResult<DestroyQuickTextMutation>;
export type DestroyQuickTextMutationOptions = Apollo.BaseMutationOptions<DestroyQuickTextMutation, DestroyQuickTextMutationVariables>;
export const CreateLotUrlsRainworxImportDocument = gql`
    mutation CreateLotUrlsRainworxImport($attributes: CreateLotUrlRainworxImportInput!) {
  createLotUrlsRainworxImport(input: {attributes: $attributes}) {
    clientMutationId
    import {
      id
    }
  }
}
    `;
export type CreateLotUrlsRainworxImportMutationFn = Apollo.MutationFunction<CreateLotUrlsRainworxImportMutation, CreateLotUrlsRainworxImportMutationVariables>;

/**
 * __useCreateLotUrlsRainworxImportMutation__
 *
 * To run a mutation, you first call `useCreateLotUrlsRainworxImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLotUrlsRainworxImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLotUrlsRainworxImportMutation, { data, loading, error }] = useCreateLotUrlsRainworxImportMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateLotUrlsRainworxImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateLotUrlsRainworxImportMutation, CreateLotUrlsRainworxImportMutationVariables>) {
        return Apollo.useMutation<CreateLotUrlsRainworxImportMutation, CreateLotUrlsRainworxImportMutationVariables>(CreateLotUrlsRainworxImportDocument, baseOptions);
      }
export type CreateLotUrlsRainworxImportMutationHookResult = ReturnType<typeof useCreateLotUrlsRainworxImportMutation>;
export type CreateLotUrlsRainworxImportMutationResult = Apollo.MutationResult<CreateLotUrlsRainworxImportMutation>;
export type CreateLotUrlsRainworxImportMutationOptions = Apollo.BaseMutationOptions<CreateLotUrlsRainworxImportMutation, CreateLotUrlsRainworxImportMutationVariables>;
export const CreateUnsoldItemsRainworxImportDocument = gql`
    mutation CreateUnsoldItemsRainworxImport($attributes: CreateUnsoldItemsRainworxImportInput!) {
  createUnsoldItemsRainworxImport(input: {attributes: $attributes}) {
    clientMutationId
    import {
      id
    }
  }
}
    `;
export type CreateUnsoldItemsRainworxImportMutationFn = Apollo.MutationFunction<CreateUnsoldItemsRainworxImportMutation, CreateUnsoldItemsRainworxImportMutationVariables>;

/**
 * __useCreateUnsoldItemsRainworxImportMutation__
 *
 * To run a mutation, you first call `useCreateUnsoldItemsRainworxImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnsoldItemsRainworxImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnsoldItemsRainworxImportMutation, { data, loading, error }] = useCreateUnsoldItemsRainworxImportMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateUnsoldItemsRainworxImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateUnsoldItemsRainworxImportMutation, CreateUnsoldItemsRainworxImportMutationVariables>) {
        return Apollo.useMutation<CreateUnsoldItemsRainworxImportMutation, CreateUnsoldItemsRainworxImportMutationVariables>(CreateUnsoldItemsRainworxImportDocument, baseOptions);
      }
export type CreateUnsoldItemsRainworxImportMutationHookResult = ReturnType<typeof useCreateUnsoldItemsRainworxImportMutation>;
export type CreateUnsoldItemsRainworxImportMutationResult = Apollo.MutationResult<CreateUnsoldItemsRainworxImportMutation>;
export type CreateUnsoldItemsRainworxImportMutationOptions = Apollo.BaseMutationOptions<CreateUnsoldItemsRainworxImportMutation, CreateUnsoldItemsRainworxImportMutationVariables>;
export const TriggerSalePaymentDocument = gql`
    mutation TriggerSalePayment($saleId: ID!, $force: Boolean = false) {
  triggerSalePayment(input: {saleId: $saleId, force: $force}) {
    success
    message
    jobId
    errors
  }
}
    `;
export type TriggerSalePaymentMutationFn = Apollo.MutationFunction<TriggerSalePaymentMutation, TriggerSalePaymentMutationVariables>;

/**
 * __useTriggerSalePaymentMutation__
 *
 * To run a mutation, you first call `useTriggerSalePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerSalePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerSalePaymentMutation, { data, loading, error }] = useTriggerSalePaymentMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useTriggerSalePaymentMutation(baseOptions?: Apollo.MutationHookOptions<TriggerSalePaymentMutation, TriggerSalePaymentMutationVariables>) {
        return Apollo.useMutation<TriggerSalePaymentMutation, TriggerSalePaymentMutationVariables>(TriggerSalePaymentDocument, baseOptions);
      }
export type TriggerSalePaymentMutationHookResult = ReturnType<typeof useTriggerSalePaymentMutation>;
export type TriggerSalePaymentMutationResult = Apollo.MutationResult<TriggerSalePaymentMutation>;
export type TriggerSalePaymentMutationOptions = Apollo.BaseMutationOptions<TriggerSalePaymentMutation, TriggerSalePaymentMutationVariables>;
export const GetSaleStatsAndPaymentsDocument = gql`
    query GetSaleStatsAndPayments($id: ID!) {
  sale(id: $id) {
    id
    name
    startAt
    endAt
    createdAt
    stats {
      totalOrders
      totalAmountHt
      totalAmountTtc
      totalSoldAmountHt
      paidSoldCount
      paidSoldAmountHt
      unpaidSoldCount
      unpaidSoldAmountHt
      unpaidSoldOrdersCount
      unsoldCount
      unsoldAmountHt
      unpaidByBuyerCount
      unpaidByBuyerAmountHt
      returnedCount
      returnedAmountHt
    }
    payments {
      vendorPayments {
        edges {
          node {
            id
            totalSales
            totalFees
            netAmount
            paid
            startAt
            endAt
            createdAt
            lockedAt
            stripeTransferId
            stripeTransferStatus
            stripeTransferError
            stripeTransferredAt
            disputed
            disputeAmount
            vendorStatementPayment {
              id
            }
            vendor {
              id
              stripeConnectAccountId
              account {
                firstName
                lastName
                email
              }
            }
            vendorPaymentFees {
              edges {
                node {
                  id
                  feeType
                  feePercentageHt
                  feePercentageTtc
                  feeAmountHt
                  feeTva
                  feeTvaRate
                  feeAmountTtc
                  itemsCount
                }
              }
            }
          }
        }
      }
      writerPayments {
        edges {
          node {
            id
            paid
            writer {
              id
              account {
                firstName
                lastName
              }
            }
            writerPaymentLines {
              edges {
                node {
                  id
                  amount
                }
              }
            }
          }
        }
      }
      expertPayments {
        edges {
          node {
            id
            paid
            expert {
              id
              account {
                firstName
                lastName
              }
            }
          }
        }
      }
      introducerPayments {
        edges {
          node {
            id
            paid
            payableType
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSaleStatsAndPaymentsQuery__
 *
 * To run a query within a React component, call `useGetSaleStatsAndPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleStatsAndPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleStatsAndPaymentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSaleStatsAndPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetSaleStatsAndPaymentsQuery, GetSaleStatsAndPaymentsQueryVariables>) {
        return Apollo.useQuery<GetSaleStatsAndPaymentsQuery, GetSaleStatsAndPaymentsQueryVariables>(GetSaleStatsAndPaymentsDocument, baseOptions);
      }
export function useGetSaleStatsAndPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleStatsAndPaymentsQuery, GetSaleStatsAndPaymentsQueryVariables>) {
          return Apollo.useLazyQuery<GetSaleStatsAndPaymentsQuery, GetSaleStatsAndPaymentsQueryVariables>(GetSaleStatsAndPaymentsDocument, baseOptions);
        }
export type GetSaleStatsAndPaymentsQueryHookResult = ReturnType<typeof useGetSaleStatsAndPaymentsQuery>;
export type GetSaleStatsAndPaymentsLazyQueryHookResult = ReturnType<typeof useGetSaleStatsAndPaymentsLazyQuery>;
export type GetSaleStatsAndPaymentsQueryResult = Apollo.QueryResult<GetSaleStatsAndPaymentsQuery, GetSaleStatsAndPaymentsQueryVariables>;
export const SaleMandatsDocument = gql`
    query SaleMandats($where: SaleMandatFilter) {
  saleMandats(where: $where, orderBy: {attribute: "updatedAt", direction: "desc"}) {
    ...SaleMandatEdges
  }
}
    ${SaleMandatEdgesFragmentDoc}`;

/**
 * __useSaleMandatsQuery__
 *
 * To run a query within a React component, call `useSaleMandatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleMandatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleMandatsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSaleMandatsQuery(baseOptions?: Apollo.QueryHookOptions<SaleMandatsQuery, SaleMandatsQueryVariables>) {
        return Apollo.useQuery<SaleMandatsQuery, SaleMandatsQueryVariables>(SaleMandatsDocument, baseOptions);
      }
export function useSaleMandatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleMandatsQuery, SaleMandatsQueryVariables>) {
          return Apollo.useLazyQuery<SaleMandatsQuery, SaleMandatsQueryVariables>(SaleMandatsDocument, baseOptions);
        }
export type SaleMandatsQueryHookResult = ReturnType<typeof useSaleMandatsQuery>;
export type SaleMandatsLazyQueryHookResult = ReturnType<typeof useSaleMandatsLazyQuery>;
export type SaleMandatsQueryResult = Apollo.QueryResult<SaleMandatsQuery, SaleMandatsQueryVariables>;
export const CreateSaleMandatsDocument = gql`
    mutation CreateSaleMandats($saleId: ID!) {
  createSaleMandats(input: {saleId: $saleId}) {
    clientMutationId
    sale {
      id
    }
  }
}
    `;
export type CreateSaleMandatsMutationFn = Apollo.MutationFunction<CreateSaleMandatsMutation, CreateSaleMandatsMutationVariables>;

/**
 * __useCreateSaleMandatsMutation__
 *
 * To run a mutation, you first call `useCreateSaleMandatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSaleMandatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSaleMandatsMutation, { data, loading, error }] = useCreateSaleMandatsMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useCreateSaleMandatsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSaleMandatsMutation, CreateSaleMandatsMutationVariables>) {
        return Apollo.useMutation<CreateSaleMandatsMutation, CreateSaleMandatsMutationVariables>(CreateSaleMandatsDocument, baseOptions);
      }
export type CreateSaleMandatsMutationHookResult = ReturnType<typeof useCreateSaleMandatsMutation>;
export type CreateSaleMandatsMutationResult = Apollo.MutationResult<CreateSaleMandatsMutation>;
export type CreateSaleMandatsMutationOptions = Apollo.BaseMutationOptions<CreateSaleMandatsMutation, CreateSaleMandatsMutationVariables>;
export const TriggerMonthlyVendorPaymentTransferDocument = gql`
    mutation TriggerMonthlyVendorPaymentTransfer($input: TriggerMonthlyVendorPaymentTransferMutationInput!) {
  triggerMonthlyVendorPaymentTransfer(input: $input) {
    monthlyVendorPayment {
      id
      stripeTransferId
      stripeTransferStatus
      stripeTransferError
      stripeTransferredAt
    }
    errors
  }
}
    `;
export type TriggerMonthlyVendorPaymentTransferMutationFn = Apollo.MutationFunction<TriggerMonthlyVendorPaymentTransferMutation, TriggerMonthlyVendorPaymentTransferMutationVariables>;

/**
 * __useTriggerMonthlyVendorPaymentTransferMutation__
 *
 * To run a mutation, you first call `useTriggerMonthlyVendorPaymentTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerMonthlyVendorPaymentTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerMonthlyVendorPaymentTransferMutation, { data, loading, error }] = useTriggerMonthlyVendorPaymentTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerMonthlyVendorPaymentTransferMutation(baseOptions?: Apollo.MutationHookOptions<TriggerMonthlyVendorPaymentTransferMutation, TriggerMonthlyVendorPaymentTransferMutationVariables>) {
        return Apollo.useMutation<TriggerMonthlyVendorPaymentTransferMutation, TriggerMonthlyVendorPaymentTransferMutationVariables>(TriggerMonthlyVendorPaymentTransferDocument, baseOptions);
      }
export type TriggerMonthlyVendorPaymentTransferMutationHookResult = ReturnType<typeof useTriggerMonthlyVendorPaymentTransferMutation>;
export type TriggerMonthlyVendorPaymentTransferMutationResult = Apollo.MutationResult<TriggerMonthlyVendorPaymentTransferMutation>;
export type TriggerMonthlyVendorPaymentTransferMutationOptions = Apollo.BaseMutationOptions<TriggerMonthlyVendorPaymentTransferMutation, TriggerMonthlyVendorPaymentTransferMutationVariables>;
export const SaleProjectChipsDocument = gql`
    query SaleProjectChips($where: ItemFilter) {
  items(where: $where, first: 500) {
    totalCount
    edges {
      node {
        id
        project {
          id
          title
          number
        }
      }
    }
  }
}
    `;

/**
 * __useSaleProjectChipsQuery__
 *
 * To run a query within a React component, call `useSaleProjectChipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleProjectChipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleProjectChipsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSaleProjectChipsQuery(baseOptions?: Apollo.QueryHookOptions<SaleProjectChipsQuery, SaleProjectChipsQueryVariables>) {
        return Apollo.useQuery<SaleProjectChipsQuery, SaleProjectChipsQueryVariables>(SaleProjectChipsDocument, baseOptions);
      }
export function useSaleProjectChipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleProjectChipsQuery, SaleProjectChipsQueryVariables>) {
          return Apollo.useLazyQuery<SaleProjectChipsQuery, SaleProjectChipsQueryVariables>(SaleProjectChipsDocument, baseOptions);
        }
export type SaleProjectChipsQueryHookResult = ReturnType<typeof useSaleProjectChipsQuery>;
export type SaleProjectChipsLazyQueryHookResult = ReturnType<typeof useSaleProjectChipsLazyQuery>;
export type SaleProjectChipsQueryResult = Apollo.QueryResult<SaleProjectChipsQuery, SaleProjectChipsQueryVariables>;
export const SalePaymentStatsDocument = gql`
    query SalePaymentStats($saleId: ID!) {
  salePaymentStats(saleId: $saleId) {
    unpaidOrders {
      count
      totalAmount
      orders {
        id
        orderNumber
        buyerEmail
        buyerPhone
        buyerName
        totalAmount
        createdAt
        daysSinceCreation
      }
    }
    paidWithinDelay {
      count
      totalAmount
      remainingDays
    }
    paidPendingPayment {
      count
      totalAmount
      orders {
        id
        orderNumber
        totalAmount
        paidAt
        daysSincePaid
        vendorPaymentStatus
        pendingItemsCount
        paidItemsCount
      }
    }
    readyToPay {
      count
      totalAmount
    }
    alreadyPaid {
      count
      totalAmount
    }
    excludedOrders {
      count
      totalAmount
      orders {
        id
        orderNumber
        totalAmount
        removedItemsCount
        returnedItemsCount
        state
      }
    }
  }
}
    `;

/**
 * __useSalePaymentStatsQuery__
 *
 * To run a query within a React component, call `useSalePaymentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalePaymentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalePaymentStatsQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useSalePaymentStatsQuery(baseOptions: Apollo.QueryHookOptions<SalePaymentStatsQuery, SalePaymentStatsQueryVariables>) {
        return Apollo.useQuery<SalePaymentStatsQuery, SalePaymentStatsQueryVariables>(SalePaymentStatsDocument, baseOptions);
      }
export function useSalePaymentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalePaymentStatsQuery, SalePaymentStatsQueryVariables>) {
          return Apollo.useLazyQuery<SalePaymentStatsQuery, SalePaymentStatsQueryVariables>(SalePaymentStatsDocument, baseOptions);
        }
export type SalePaymentStatsQueryHookResult = ReturnType<typeof useSalePaymentStatsQuery>;
export type SalePaymentStatsLazyQueryHookResult = ReturnType<typeof useSalePaymentStatsLazyQuery>;
export type SalePaymentStatsQueryResult = Apollo.QueryResult<SalePaymentStatsQuery, SalePaymentStatsQueryVariables>;
export const SaleDocument = gql`
    query Sale($id: ID!) {
  sale(id: $id) {
    ...Sale
    pendingPlannedItemsCount
    readyForExport
  }
}
    ${SaleFragmentDoc}`;

/**
 * __useSaleQuery__
 *
 * To run a query within a React component, call `useSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaleQuery(baseOptions: Apollo.QueryHookOptions<SaleQuery, SaleQueryVariables>) {
        return Apollo.useQuery<SaleQuery, SaleQueryVariables>(SaleDocument, baseOptions);
      }
export function useSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleQuery, SaleQueryVariables>) {
          return Apollo.useLazyQuery<SaleQuery, SaleQueryVariables>(SaleDocument, baseOptions);
        }
export type SaleQueryHookResult = ReturnType<typeof useSaleQuery>;
export type SaleLazyQueryHookResult = ReturnType<typeof useSaleLazyQuery>;
export type SaleQueryResult = Apollo.QueryResult<SaleQuery, SaleQueryVariables>;
export const SalesDocument = gql`
    query Sales($where: SaleFilter, $first: Int = 50, $last: Int = null, $after: String = null, $before: String = null) {
  sales(
    where: $where
    orderBy: {attribute: "updatedAt", direction: "desc"}
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    ...SaleEdges
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${SaleEdgesFragmentDoc}`;

/**
 * __useSalesQuery__
 *
 * To run a query within a React component, call `useSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useSalesQuery(baseOptions?: Apollo.QueryHookOptions<SalesQuery, SalesQueryVariables>) {
        return Apollo.useQuery<SalesQuery, SalesQueryVariables>(SalesDocument, baseOptions);
      }
export function useSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesQuery, SalesQueryVariables>) {
          return Apollo.useLazyQuery<SalesQuery, SalesQueryVariables>(SalesDocument, baseOptions);
        }
export type SalesQueryHookResult = ReturnType<typeof useSalesQuery>;
export type SalesLazyQueryHookResult = ReturnType<typeof useSalesLazyQuery>;
export type SalesQueryResult = Apollo.QueryResult<SalesQuery, SalesQueryVariables>;
export const CreateSaleDocument = gql`
    mutation CreateSale($input: CreateSaleMutationInput!) {
  createSale(input: $input) {
    sale {
      id
      name
    }
  }
}
    `;
export type CreateSaleMutationFn = Apollo.MutationFunction<CreateSaleMutation, CreateSaleMutationVariables>;

/**
 * __useCreateSaleMutation__
 *
 * To run a mutation, you first call `useCreateSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSaleMutation, { data, loading, error }] = useCreateSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSaleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSaleMutation, CreateSaleMutationVariables>) {
        return Apollo.useMutation<CreateSaleMutation, CreateSaleMutationVariables>(CreateSaleDocument, baseOptions);
      }
export type CreateSaleMutationHookResult = ReturnType<typeof useCreateSaleMutation>;
export type CreateSaleMutationResult = Apollo.MutationResult<CreateSaleMutation>;
export type CreateSaleMutationOptions = Apollo.BaseMutationOptions<CreateSaleMutation, CreateSaleMutationVariables>;
export const UpdateSaleDocument = gql`
    mutation UpdateSale($input: UpdateSaleMutationInput!) {
  updateSale(input: $input) {
    sale {
      id
      name
    }
  }
}
    `;
export type UpdateSaleMutationFn = Apollo.MutationFunction<UpdateSaleMutation, UpdateSaleMutationVariables>;

/**
 * __useUpdateSaleMutation__
 *
 * To run a mutation, you first call `useUpdateSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaleMutation, { data, loading, error }] = useUpdateSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSaleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSaleMutation, UpdateSaleMutationVariables>) {
        return Apollo.useMutation<UpdateSaleMutation, UpdateSaleMutationVariables>(UpdateSaleDocument, baseOptions);
      }
export type UpdateSaleMutationHookResult = ReturnType<typeof useUpdateSaleMutation>;
export type UpdateSaleMutationResult = Apollo.MutationResult<UpdateSaleMutation>;
export type UpdateSaleMutationOptions = Apollo.BaseMutationOptions<UpdateSaleMutation, UpdateSaleMutationVariables>;
export const DestroySaleDocument = gql`
    mutation DestroySale($input: DestroySaleMutationInput!) {
  destroySale(input: $input) {
    sale {
      id
      name
    }
  }
}
    `;
export type DestroySaleMutationFn = Apollo.MutationFunction<DestroySaleMutation, DestroySaleMutationVariables>;

/**
 * __useDestroySaleMutation__
 *
 * To run a mutation, you first call `useDestroySaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroySaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroySaleMutation, { data, loading, error }] = useDestroySaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroySaleMutation(baseOptions?: Apollo.MutationHookOptions<DestroySaleMutation, DestroySaleMutationVariables>) {
        return Apollo.useMutation<DestroySaleMutation, DestroySaleMutationVariables>(DestroySaleDocument, baseOptions);
      }
export type DestroySaleMutationHookResult = ReturnType<typeof useDestroySaleMutation>;
export type DestroySaleMutationResult = Apollo.MutationResult<DestroySaleMutation>;
export type DestroySaleMutationOptions = Apollo.BaseMutationOptions<DestroySaleMutation, DestroySaleMutationVariables>;
export const ItemsCountByStateDocument = gql`
    query ItemsCountByState($vendorId: ID) {
  itemsStats(vendorId: $vendorId) {
    total
    inProcessing
    requiringVendorAction
    unsold
    onVacation
    unpaid
    returned
    removed
    refused
    onSale
    sold
    adminLibraryFundEligible
    adminDiscountedEligible
    adminUnpaidEligible
    adminNotEligible
  }
}
    `;

/**
 * __useItemsCountByStateQuery__
 *
 * To run a query within a React component, call `useItemsCountByStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsCountByStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsCountByStateQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useItemsCountByStateQuery(baseOptions?: Apollo.QueryHookOptions<ItemsCountByStateQuery, ItemsCountByStateQueryVariables>) {
        return Apollo.useQuery<ItemsCountByStateQuery, ItemsCountByStateQueryVariables>(ItemsCountByStateDocument, baseOptions);
      }
export function useItemsCountByStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsCountByStateQuery, ItemsCountByStateQueryVariables>) {
          return Apollo.useLazyQuery<ItemsCountByStateQuery, ItemsCountByStateQueryVariables>(ItemsCountByStateDocument, baseOptions);
        }
export type ItemsCountByStateQueryHookResult = ReturnType<typeof useItemsCountByStateQuery>;
export type ItemsCountByStateLazyQueryHookResult = ReturnType<typeof useItemsCountByStateLazyQuery>;
export type ItemsCountByStateQueryResult = Apollo.QueryResult<ItemsCountByStateQuery, ItemsCountByStateQueryVariables>;
export const TagsDocument = gql`
    query Tags($where: TagFilter, $direction: String = "desc", $first: Int = 15, $last: Int = null, $after: String = null, $before: String = null) {
  tags(
    where: $where
    orderBy: {attribute: "updatedAt", direction: $direction}
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      cursor
      node {
        ...TagTable
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${TagTableFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      direction: // value for 'direction'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, baseOptions);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, baseOptions);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const TagDocument = gql`
    query Tag($id: ID!) {
  tag(id: $id) {
    ...TagTable
  }
}
    ${TagTableFragmentDoc}`;

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagQuery(baseOptions: Apollo.QueryHookOptions<TagQuery, TagQueryVariables>) {
        return Apollo.useQuery<TagQuery, TagQueryVariables>(TagDocument, baseOptions);
      }
export function useTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagQuery, TagQueryVariables>) {
          return Apollo.useLazyQuery<TagQuery, TagQueryVariables>(TagDocument, baseOptions);
        }
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagQueryResult = Apollo.QueryResult<TagQuery, TagQueryVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($id: ID!, $attributes: UpdateTagInput!) {
  updateTag(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    tag {
      id
    }
  }
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, baseOptions);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const MergeTagDocument = gql`
    mutation MergeTag($id: ID!, $attributes: MergeTagInput!) {
  mergeTag(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    tag {
      id
    }
  }
}
    `;
export type MergeTagMutationFn = Apollo.MutationFunction<MergeTagMutation, MergeTagMutationVariables>;

/**
 * __useMergeTagMutation__
 *
 * To run a mutation, you first call `useMergeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeTagMutation, { data, loading, error }] = useMergeTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useMergeTagMutation(baseOptions?: Apollo.MutationHookOptions<MergeTagMutation, MergeTagMutationVariables>) {
        return Apollo.useMutation<MergeTagMutation, MergeTagMutationVariables>(MergeTagDocument, baseOptions);
      }
export type MergeTagMutationHookResult = ReturnType<typeof useMergeTagMutation>;
export type MergeTagMutationResult = Apollo.MutationResult<MergeTagMutation>;
export type MergeTagMutationOptions = Apollo.BaseMutationOptions<MergeTagMutation, MergeTagMutationVariables>;
export const DestroyTagDocument = gql`
    mutation DestroyTag($id: ID!) {
  destroyTag(input: {id: $id}) {
    tag {
      id
    }
  }
}
    `;
export type DestroyTagMutationFn = Apollo.MutationFunction<DestroyTagMutation, DestroyTagMutationVariables>;

/**
 * __useDestroyTagMutation__
 *
 * To run a mutation, you first call `useDestroyTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyTagMutation, { data, loading, error }] = useDestroyTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyTagMutation(baseOptions?: Apollo.MutationHookOptions<DestroyTagMutation, DestroyTagMutationVariables>) {
        return Apollo.useMutation<DestroyTagMutation, DestroyTagMutationVariables>(DestroyTagDocument, baseOptions);
      }
export type DestroyTagMutationHookResult = ReturnType<typeof useDestroyTagMutation>;
export type DestroyTagMutationResult = Apollo.MutationResult<DestroyTagMutation>;
export type DestroyTagMutationOptions = Apollo.BaseMutationOptions<DestroyTagMutation, DestroyTagMutationVariables>;
export const CreateThirdPartyIntroducerDocument = gql`
    mutation CreateThirdPartyIntroducer($input: CreateThirdPartyIntroducerMutationInput!) {
  createThirdPartyIntroducer(input: $input) {
    thirdPartyIntroducer {
      id
    }
    errors {
      details
    }
  }
}
    `;
export type CreateThirdPartyIntroducerMutationFn = Apollo.MutationFunction<CreateThirdPartyIntroducerMutation, CreateThirdPartyIntroducerMutationVariables>;

/**
 * __useCreateThirdPartyIntroducerMutation__
 *
 * To run a mutation, you first call `useCreateThirdPartyIntroducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThirdPartyIntroducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThirdPartyIntroducerMutation, { data, loading, error }] = useCreateThirdPartyIntroducerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateThirdPartyIntroducerMutation(baseOptions?: Apollo.MutationHookOptions<CreateThirdPartyIntroducerMutation, CreateThirdPartyIntroducerMutationVariables>) {
        return Apollo.useMutation<CreateThirdPartyIntroducerMutation, CreateThirdPartyIntroducerMutationVariables>(CreateThirdPartyIntroducerDocument, baseOptions);
      }
export type CreateThirdPartyIntroducerMutationHookResult = ReturnType<typeof useCreateThirdPartyIntroducerMutation>;
export type CreateThirdPartyIntroducerMutationResult = Apollo.MutationResult<CreateThirdPartyIntroducerMutation>;
export type CreateThirdPartyIntroducerMutationOptions = Apollo.BaseMutationOptions<CreateThirdPartyIntroducerMutation, CreateThirdPartyIntroducerMutationVariables>;
export const UpdateThirdPartyIntroducerDocument = gql`
    mutation UpdateThirdPartyIntroducer($input: UpdateThirdPartyIntroducerMutationInput!) {
  updateThirdPartyIntroducer(input: $input) {
    thirdPartyIntroducer {
      id
    }
    errors {
      details
    }
  }
}
    `;
export type UpdateThirdPartyIntroducerMutationFn = Apollo.MutationFunction<UpdateThirdPartyIntroducerMutation, UpdateThirdPartyIntroducerMutationVariables>;

/**
 * __useUpdateThirdPartyIntroducerMutation__
 *
 * To run a mutation, you first call `useUpdateThirdPartyIntroducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThirdPartyIntroducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThirdPartyIntroducerMutation, { data, loading, error }] = useUpdateThirdPartyIntroducerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateThirdPartyIntroducerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThirdPartyIntroducerMutation, UpdateThirdPartyIntroducerMutationVariables>) {
        return Apollo.useMutation<UpdateThirdPartyIntroducerMutation, UpdateThirdPartyIntroducerMutationVariables>(UpdateThirdPartyIntroducerDocument, baseOptions);
      }
export type UpdateThirdPartyIntroducerMutationHookResult = ReturnType<typeof useUpdateThirdPartyIntroducerMutation>;
export type UpdateThirdPartyIntroducerMutationResult = Apollo.MutationResult<UpdateThirdPartyIntroducerMutation>;
export type UpdateThirdPartyIntroducerMutationOptions = Apollo.BaseMutationOptions<UpdateThirdPartyIntroducerMutation, UpdateThirdPartyIntroducerMutationVariables>;
export const VacationDocument = gql`
    query Vacation($id: ID!) {
  vacation(id: $id) {
    ...Vacation
  }
}
    ${VacationFragmentDoc}`;

/**
 * __useVacationQuery__
 *
 * To run a query within a React component, call `useVacationQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVacationQuery(baseOptions: Apollo.QueryHookOptions<VacationQuery, VacationQueryVariables>) {
        return Apollo.useQuery<VacationQuery, VacationQueryVariables>(VacationDocument, baseOptions);
      }
export function useVacationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacationQuery, VacationQueryVariables>) {
          return Apollo.useLazyQuery<VacationQuery, VacationQueryVariables>(VacationDocument, baseOptions);
        }
export type VacationQueryHookResult = ReturnType<typeof useVacationQuery>;
export type VacationLazyQueryHookResult = ReturnType<typeof useVacationLazyQuery>;
export type VacationQueryResult = Apollo.QueryResult<VacationQuery, VacationQueryVariables>;
export const VacationsDocument = gql`
    query Vacations($where: VacationFilter, $orderByAttribute: [ItemOrderType!] = [{attribute: "name", direction: "asc"}], $first: Int = 300, $last: Int = null, $after: String = null, $before: String = null) {
  vacations(
    where: $where
    orderBy: $orderByAttribute
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    ...VacationEdges
  }
}
    ${VacationEdgesFragmentDoc}`;

/**
 * __useVacationsQuery__
 *
 * To run a query within a React component, call `useVacationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderByAttribute: // value for 'orderByAttribute'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useVacationsQuery(baseOptions?: Apollo.QueryHookOptions<VacationsQuery, VacationsQueryVariables>) {
        return Apollo.useQuery<VacationsQuery, VacationsQueryVariables>(VacationsDocument, baseOptions);
      }
export function useVacationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacationsQuery, VacationsQueryVariables>) {
          return Apollo.useLazyQuery<VacationsQuery, VacationsQueryVariables>(VacationsDocument, baseOptions);
        }
export type VacationsQueryHookResult = ReturnType<typeof useVacationsQuery>;
export type VacationsLazyQueryHookResult = ReturnType<typeof useVacationsLazyQuery>;
export type VacationsQueryResult = Apollo.QueryResult<VacationsQuery, VacationsQueryVariables>;
export const CreateVacationDocument = gql`
    mutation CreateVacation($input: CreateVacationMutationInput!) {
  createVacation(input: $input) {
    vacation {
      id
      name
    }
  }
}
    `;
export type CreateVacationMutationFn = Apollo.MutationFunction<CreateVacationMutation, CreateVacationMutationVariables>;

/**
 * __useCreateVacationMutation__
 *
 * To run a mutation, you first call `useCreateVacationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVacationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVacationMutation, { data, loading, error }] = useCreateVacationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVacationMutation(baseOptions?: Apollo.MutationHookOptions<CreateVacationMutation, CreateVacationMutationVariables>) {
        return Apollo.useMutation<CreateVacationMutation, CreateVacationMutationVariables>(CreateVacationDocument, baseOptions);
      }
export type CreateVacationMutationHookResult = ReturnType<typeof useCreateVacationMutation>;
export type CreateVacationMutationResult = Apollo.MutationResult<CreateVacationMutation>;
export type CreateVacationMutationOptions = Apollo.BaseMutationOptions<CreateVacationMutation, CreateVacationMutationVariables>;
export const UpdateVacationDocument = gql`
    mutation UpdateVacation($input: UpdateVacationMutationInput!) {
  updateVacation(input: $input) {
    vacation {
      id
      name
    }
  }
}
    `;
export type UpdateVacationMutationFn = Apollo.MutationFunction<UpdateVacationMutation, UpdateVacationMutationVariables>;

/**
 * __useUpdateVacationMutation__
 *
 * To run a mutation, you first call `useUpdateVacationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVacationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVacationMutation, { data, loading, error }] = useUpdateVacationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVacationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVacationMutation, UpdateVacationMutationVariables>) {
        return Apollo.useMutation<UpdateVacationMutation, UpdateVacationMutationVariables>(UpdateVacationDocument, baseOptions);
      }
export type UpdateVacationMutationHookResult = ReturnType<typeof useUpdateVacationMutation>;
export type UpdateVacationMutationResult = Apollo.MutationResult<UpdateVacationMutation>;
export type UpdateVacationMutationOptions = Apollo.BaseMutationOptions<UpdateVacationMutation, UpdateVacationMutationVariables>;
export const DestroyVacationDocument = gql`
    mutation DestroyVacation($input: DestroyVacationMutationInput!) {
  destroyVacation(input: $input) {
    vacation {
      id
      name
    }
  }
}
    `;
export type DestroyVacationMutationFn = Apollo.MutationFunction<DestroyVacationMutation, DestroyVacationMutationVariables>;

/**
 * __useDestroyVacationMutation__
 *
 * To run a mutation, you first call `useDestroyVacationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyVacationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyVacationMutation, { data, loading, error }] = useDestroyVacationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyVacationMutation(baseOptions?: Apollo.MutationHookOptions<DestroyVacationMutation, DestroyVacationMutationVariables>) {
        return Apollo.useMutation<DestroyVacationMutation, DestroyVacationMutationVariables>(DestroyVacationDocument, baseOptions);
      }
export type DestroyVacationMutationHookResult = ReturnType<typeof useDestroyVacationMutation>;
export type DestroyVacationMutationResult = Apollo.MutationResult<DestroyVacationMutation>;
export type DestroyVacationMutationOptions = Apollo.BaseMutationOptions<DestroyVacationMutation, DestroyVacationMutationVariables>;
export const CreateVendorAddressDocument = gql`
    mutation CreateVendorAddress($attributes: VendorAddressInput!) {
  createVendorAddress(input: {attributes: $attributes}) {
    address {
      ...VendorAddress
    }
    errors {
      fullMessages
    }
  }
}
    ${VendorAddressFragmentDoc}`;
export type CreateVendorAddressMutationFn = Apollo.MutationFunction<CreateVendorAddressMutation, CreateVendorAddressMutationVariables>;

/**
 * __useCreateVendorAddressMutation__
 *
 * To run a mutation, you first call `useCreateVendorAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorAddressMutation, { data, loading, error }] = useCreateVendorAddressMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateVendorAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorAddressMutation, CreateVendorAddressMutationVariables>) {
        return Apollo.useMutation<CreateVendorAddressMutation, CreateVendorAddressMutationVariables>(CreateVendorAddressDocument, baseOptions);
      }
export type CreateVendorAddressMutationHookResult = ReturnType<typeof useCreateVendorAddressMutation>;
export type CreateVendorAddressMutationResult = Apollo.MutationResult<CreateVendorAddressMutation>;
export type CreateVendorAddressMutationOptions = Apollo.BaseMutationOptions<CreateVendorAddressMutation, CreateVendorAddressMutationVariables>;
export const UpdateVendorAddressDocument = gql`
    mutation UpdateVendorAddress($id: ID!, $attributes: VendorAddressInput!) {
  updateVendorAddress(input: {id: $id, attributes: $attributes}) {
    address {
      ...VendorAddress
    }
    errors {
      fullMessages
    }
  }
}
    ${VendorAddressFragmentDoc}`;
export type UpdateVendorAddressMutationFn = Apollo.MutationFunction<UpdateVendorAddressMutation, UpdateVendorAddressMutationVariables>;

/**
 * __useUpdateVendorAddressMutation__
 *
 * To run a mutation, you first call `useUpdateVendorAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorAddressMutation, { data, loading, error }] = useUpdateVendorAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateVendorAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorAddressMutation, UpdateVendorAddressMutationVariables>) {
        return Apollo.useMutation<UpdateVendorAddressMutation, UpdateVendorAddressMutationVariables>(UpdateVendorAddressDocument, baseOptions);
      }
export type UpdateVendorAddressMutationHookResult = ReturnType<typeof useUpdateVendorAddressMutation>;
export type UpdateVendorAddressMutationResult = Apollo.MutationResult<UpdateVendorAddressMutation>;
export type UpdateVendorAddressMutationOptions = Apollo.BaseMutationOptions<UpdateVendorAddressMutation, UpdateVendorAddressMutationVariables>;
export const DestroyVendorAddressDocument = gql`
    mutation DestroyVendorAddress($id: ID!) {
  destroyVendorAddress(input: {id: $id}) {
    deletedAddressId
    errors {
      fullMessages
    }
  }
}
    `;
export type DestroyVendorAddressMutationFn = Apollo.MutationFunction<DestroyVendorAddressMutation, DestroyVendorAddressMutationVariables>;

/**
 * __useDestroyVendorAddressMutation__
 *
 * To run a mutation, you first call `useDestroyVendorAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyVendorAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyVendorAddressMutation, { data, loading, error }] = useDestroyVendorAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyVendorAddressMutation(baseOptions?: Apollo.MutationHookOptions<DestroyVendorAddressMutation, DestroyVendorAddressMutationVariables>) {
        return Apollo.useMutation<DestroyVendorAddressMutation, DestroyVendorAddressMutationVariables>(DestroyVendorAddressDocument, baseOptions);
      }
export type DestroyVendorAddressMutationHookResult = ReturnType<typeof useDestroyVendorAddressMutation>;
export type DestroyVendorAddressMutationResult = Apollo.MutationResult<DestroyVendorAddressMutation>;
export type DestroyVendorAddressMutationOptions = Apollo.BaseMutationOptions<DestroyVendorAddressMutation, DestroyVendorAddressMutationVariables>;
export const SetVendorDefaultAddressDocument = gql`
    mutation SetVendorDefaultAddress($purpose: VendorAddressPurposeEnum!, $addressId: ID) {
  setVendorDefaultAddress(input: {purpose: $purpose, addressId: $addressId}) {
    vendor {
      id
      ...VendorDefaultAddresses
    }
    errors {
      fullMessages
    }
  }
}
    ${VendorDefaultAddressesFragmentDoc}`;
export type SetVendorDefaultAddressMutationFn = Apollo.MutationFunction<SetVendorDefaultAddressMutation, SetVendorDefaultAddressMutationVariables>;

/**
 * __useSetVendorDefaultAddressMutation__
 *
 * To run a mutation, you first call `useSetVendorDefaultAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVendorDefaultAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVendorDefaultAddressMutation, { data, loading, error }] = useSetVendorDefaultAddressMutation({
 *   variables: {
 *      purpose: // value for 'purpose'
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useSetVendorDefaultAddressMutation(baseOptions?: Apollo.MutationHookOptions<SetVendorDefaultAddressMutation, SetVendorDefaultAddressMutationVariables>) {
        return Apollo.useMutation<SetVendorDefaultAddressMutation, SetVendorDefaultAddressMutationVariables>(SetVendorDefaultAddressDocument, baseOptions);
      }
export type SetVendorDefaultAddressMutationHookResult = ReturnType<typeof useSetVendorDefaultAddressMutation>;
export type SetVendorDefaultAddressMutationResult = Apollo.MutationResult<SetVendorDefaultAddressMutation>;
export type SetVendorDefaultAddressMutationOptions = Apollo.BaseMutationOptions<SetVendorDefaultAddressMutation, SetVendorDefaultAddressMutationVariables>;
export const GetVendorAddressesDocument = gql`
    query GetVendorAddresses($id: ID!, $after: String, $search: String) {
  vendor(id: $id) {
    id
    account {
      id
      firstName
      lastName
      companyName
      phone
      email
    }
    ...VendorDefaultAddresses
    addresses(first: 10, after: $after, search: $search) {
      nodes {
        ...VendorAddress
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${VendorDefaultAddressesFragmentDoc}
${VendorAddressFragmentDoc}`;

/**
 * __useGetVendorAddressesQuery__
 *
 * To run a query within a React component, call `useGetVendorAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorAddressesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetVendorAddressesQuery(baseOptions: Apollo.QueryHookOptions<GetVendorAddressesQuery, GetVendorAddressesQueryVariables>) {
        return Apollo.useQuery<GetVendorAddressesQuery, GetVendorAddressesQueryVariables>(GetVendorAddressesDocument, baseOptions);
      }
export function useGetVendorAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorAddressesQuery, GetVendorAddressesQueryVariables>) {
          return Apollo.useLazyQuery<GetVendorAddressesQuery, GetVendorAddressesQueryVariables>(GetVendorAddressesDocument, baseOptions);
        }
export type GetVendorAddressesQueryHookResult = ReturnType<typeof useGetVendorAddressesQuery>;
export type GetVendorAddressesLazyQueryHookResult = ReturnType<typeof useGetVendorAddressesLazyQuery>;
export type GetVendorAddressesQueryResult = Apollo.QueryResult<GetVendorAddressesQuery, GetVendorAddressesQueryVariables>;
export const UpdateVendorAccountDocument = gql`
    mutation UpdateVendorAccount($id: ID!, $attributes: UpdateAccountInput!) {
  customUpdateAccount(input: {id: $id, attributes: $attributes}) {
    clientMutationId
    account {
      id
      firstName
      lastName
      email
      phone
      state
      accountable {
        ... on Expert {
          id
        }
        ... on Vendor {
          id
        }
        ... on Buyer {
          id
        }
        ... on Writer {
          id
        }
        __typename
      }
    }
  }
}
    `;
export type UpdateVendorAccountMutationFn = Apollo.MutationFunction<UpdateVendorAccountMutation, UpdateVendorAccountMutationVariables>;

/**
 * __useUpdateVendorAccountMutation__
 *
 * To run a mutation, you first call `useUpdateVendorAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorAccountMutation, { data, loading, error }] = useUpdateVendorAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateVendorAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorAccountMutation, UpdateVendorAccountMutationVariables>) {
        return Apollo.useMutation<UpdateVendorAccountMutation, UpdateVendorAccountMutationVariables>(UpdateVendorAccountDocument, baseOptions);
      }
export type UpdateVendorAccountMutationHookResult = ReturnType<typeof useUpdateVendorAccountMutation>;
export type UpdateVendorAccountMutationResult = Apollo.MutationResult<UpdateVendorAccountMutation>;
export type UpdateVendorAccountMutationOptions = Apollo.BaseMutationOptions<UpdateVendorAccountMutation, UpdateVendorAccountMutationVariables>;
export const VendorOnboardingChecklistDocument = gql`
    query VendorOnboardingChecklist($accountId: ID!) {
  account(id: $accountId) {
    ...OnboardingAccount
    accountable {
      __typename
      ... on Vendor {
        id
        stripeConnectOnboardedAt
        shippingOptions
        pickupHours {
          day
        }
      }
    }
  }
  customers(first: 1) {
    totalCount
  }
  writers(first: 1) {
    totalCount
  }
}
    ${OnboardingAccountFragmentDoc}`;

/**
 * __useVendorOnboardingChecklistQuery__
 *
 * To run a query within a React component, call `useVendorOnboardingChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorOnboardingChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorOnboardingChecklistQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useVendorOnboardingChecklistQuery(baseOptions: Apollo.QueryHookOptions<VendorOnboardingChecklistQuery, VendorOnboardingChecklistQueryVariables>) {
        return Apollo.useQuery<VendorOnboardingChecklistQuery, VendorOnboardingChecklistQueryVariables>(VendorOnboardingChecklistDocument, baseOptions);
      }
export function useVendorOnboardingChecklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorOnboardingChecklistQuery, VendorOnboardingChecklistQueryVariables>) {
          return Apollo.useLazyQuery<VendorOnboardingChecklistQuery, VendorOnboardingChecklistQueryVariables>(VendorOnboardingChecklistDocument, baseOptions);
        }
export type VendorOnboardingChecklistQueryHookResult = ReturnType<typeof useVendorOnboardingChecklistQuery>;
export type VendorOnboardingChecklistLazyQueryHookResult = ReturnType<typeof useVendorOnboardingChecklistLazyQuery>;
export type VendorOnboardingChecklistQueryResult = Apollo.QueryResult<VendorOnboardingChecklistQuery, VendorOnboardingChecklistQueryVariables>;
export const VendorPaymentTableDocument = gql`
    query VendorPaymentTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $where: MonthlyVendorPaymentFilter) {
  monthlyVendorPayments(
    first: $first
    last: $last
    after: $after
    before: $before
    where: $where
    orderBy: {attribute: "createdAt", direction: "desc"}
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...VendorPaymentTable
      }
    }
  }
}
    ${VendorPaymentTableFragmentDoc}`;

/**
 * __useVendorPaymentTableQuery__
 *
 * To run a query within a React component, call `useVendorPaymentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPaymentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPaymentTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVendorPaymentTableQuery(baseOptions?: Apollo.QueryHookOptions<VendorPaymentTableQuery, VendorPaymentTableQueryVariables>) {
        return Apollo.useQuery<VendorPaymentTableQuery, VendorPaymentTableQueryVariables>(VendorPaymentTableDocument, baseOptions);
      }
export function useVendorPaymentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorPaymentTableQuery, VendorPaymentTableQueryVariables>) {
          return Apollo.useLazyQuery<VendorPaymentTableQuery, VendorPaymentTableQueryVariables>(VendorPaymentTableDocument, baseOptions);
        }
export type VendorPaymentTableQueryHookResult = ReturnType<typeof useVendorPaymentTableQuery>;
export type VendorPaymentTableLazyQueryHookResult = ReturnType<typeof useVendorPaymentTableLazyQuery>;
export type VendorPaymentTableQueryResult = Apollo.QueryResult<VendorPaymentTableQuery, VendorPaymentTableQueryVariables>;
export const GetVendorsDocument = gql`
    query getVendors($where: VendorFilter) {
  vendors(where: $where) {
    edges {
      node {
        ...VendorSelectField
      }
    }
  }
}
    ${VendorSelectFieldFragmentDoc}`;

/**
 * __useGetVendorsQuery__
 *
 * To run a query within a React component, call `useGetVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetVendorsQuery(baseOptions?: Apollo.QueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
        return Apollo.useQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, baseOptions);
      }
export function useGetVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
          return Apollo.useLazyQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, baseOptions);
        }
export type GetVendorsQueryHookResult = ReturnType<typeof useGetVendorsQuery>;
export type GetVendorsLazyQueryHookResult = ReturnType<typeof useGetVendorsLazyQuery>;
export type GetVendorsQueryResult = Apollo.QueryResult<GetVendorsQuery, GetVendorsQueryVariables>;
export const VendorStatementPaymentTableDocument = gql`
    query VendorStatementPaymentTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $where: VendorStatementPaymentFilter) {
  vendorStatementPayments(
    first: $first
    last: $last
    after: $after
    before: $before
    where: $where
    orderBy: {attribute: "createdAt", direction: "desc"}
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...VendorStatementPaymentTable
      }
    }
  }
}
    ${VendorStatementPaymentTableFragmentDoc}`;

/**
 * __useVendorStatementPaymentTableQuery__
 *
 * To run a query within a React component, call `useVendorStatementPaymentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorStatementPaymentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorStatementPaymentTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVendorStatementPaymentTableQuery(baseOptions?: Apollo.QueryHookOptions<VendorStatementPaymentTableQuery, VendorStatementPaymentTableQueryVariables>) {
        return Apollo.useQuery<VendorStatementPaymentTableQuery, VendorStatementPaymentTableQueryVariables>(VendorStatementPaymentTableDocument, baseOptions);
      }
export function useVendorStatementPaymentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorStatementPaymentTableQuery, VendorStatementPaymentTableQueryVariables>) {
          return Apollo.useLazyQuery<VendorStatementPaymentTableQuery, VendorStatementPaymentTableQueryVariables>(VendorStatementPaymentTableDocument, baseOptions);
        }
export type VendorStatementPaymentTableQueryHookResult = ReturnType<typeof useVendorStatementPaymentTableQuery>;
export type VendorStatementPaymentTableLazyQueryHookResult = ReturnType<typeof useVendorStatementPaymentTableLazyQuery>;
export type VendorStatementPaymentTableQueryResult = Apollo.QueryResult<VendorStatementPaymentTableQuery, VendorStatementPaymentTableQueryVariables>;
export const VendorStatementsDocument = gql`
    query VendorStatements($where: VendorStatementFilter) {
  vendorStatements(
    where: $where
    orderBy: {attribute: "updatedAt", direction: "desc"}
  ) {
    ...VendorStatementEdges
  }
}
    ${VendorStatementEdgesFragmentDoc}`;

/**
 * __useVendorStatementsQuery__
 *
 * To run a query within a React component, call `useVendorStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorStatementsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVendorStatementsQuery(baseOptions?: Apollo.QueryHookOptions<VendorStatementsQuery, VendorStatementsQueryVariables>) {
        return Apollo.useQuery<VendorStatementsQuery, VendorStatementsQueryVariables>(VendorStatementsDocument, baseOptions);
      }
export function useVendorStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorStatementsQuery, VendorStatementsQueryVariables>) {
          return Apollo.useLazyQuery<VendorStatementsQuery, VendorStatementsQueryVariables>(VendorStatementsDocument, baseOptions);
        }
export type VendorStatementsQueryHookResult = ReturnType<typeof useVendorStatementsQuery>;
export type VendorStatementsLazyQueryHookResult = ReturnType<typeof useVendorStatementsLazyQuery>;
export type VendorStatementsQueryResult = Apollo.QueryResult<VendorStatementsQuery, VendorStatementsQueryVariables>;
export const VendorsTableDocument = gql`
    query VendorsTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $where: VendorFilter) {
  vendors(
    first: $first
    last: $last
    after: $after
    before: $before
    where: $where
    orderBy: {attribute: "updatedAt", direction: "desc"}
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...VendorTable
      }
    }
  }
}
    ${VendorTableFragmentDoc}`;

/**
 * __useVendorsTableQuery__
 *
 * To run a query within a React component, call `useVendorsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVendorsTableQuery(baseOptions?: Apollo.QueryHookOptions<VendorsTableQuery, VendorsTableQueryVariables>) {
        return Apollo.useQuery<VendorsTableQuery, VendorsTableQueryVariables>(VendorsTableDocument, baseOptions);
      }
export function useVendorsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorsTableQuery, VendorsTableQueryVariables>) {
          return Apollo.useLazyQuery<VendorsTableQuery, VendorsTableQueryVariables>(VendorsTableDocument, baseOptions);
        }
export type VendorsTableQueryHookResult = ReturnType<typeof useVendorsTableQuery>;
export type VendorsTableLazyQueryHookResult = ReturnType<typeof useVendorsTableLazyQuery>;
export type VendorsTableQueryResult = Apollo.QueryResult<VendorsTableQuery, VendorsTableQueryVariables>;
export const GetWriterDocument = gql`
    query GetWriter($id: ID!) {
  writer(id: $id) {
    ...Writer
  }
}
    ${WriterFragmentDoc}`;

/**
 * __useGetWriterQuery__
 *
 * To run a query within a React component, call `useGetWriterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWriterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWriterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWriterQuery(baseOptions: Apollo.QueryHookOptions<GetWriterQuery, GetWriterQueryVariables>) {
        return Apollo.useQuery<GetWriterQuery, GetWriterQueryVariables>(GetWriterDocument, baseOptions);
      }
export function useGetWriterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWriterQuery, GetWriterQueryVariables>) {
          return Apollo.useLazyQuery<GetWriterQuery, GetWriterQueryVariables>(GetWriterDocument, baseOptions);
        }
export type GetWriterQueryHookResult = ReturnType<typeof useGetWriterQuery>;
export type GetWriterLazyQueryHookResult = ReturnType<typeof useGetWriterLazyQuery>;
export type GetWriterQueryResult = Apollo.QueryResult<GetWriterQuery, GetWriterQueryVariables>;
export const WriterPaymentTableDocument = gql`
    query WriterPaymentTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $where: WriterPaymentFilter) {
  writerPayments(
    first: $first
    last: $last
    after: $after
    before: $before
    where: $where
    orderBy: {attribute: "createdAt", direction: "desc"}
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...WriterPaymentTable
      }
    }
  }
}
    ${WriterPaymentTableFragmentDoc}`;

/**
 * __useWriterPaymentTableQuery__
 *
 * To run a query within a React component, call `useWriterPaymentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriterPaymentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriterPaymentTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useWriterPaymentTableQuery(baseOptions?: Apollo.QueryHookOptions<WriterPaymentTableQuery, WriterPaymentTableQueryVariables>) {
        return Apollo.useQuery<WriterPaymentTableQuery, WriterPaymentTableQueryVariables>(WriterPaymentTableDocument, baseOptions);
      }
export function useWriterPaymentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WriterPaymentTableQuery, WriterPaymentTableQueryVariables>) {
          return Apollo.useLazyQuery<WriterPaymentTableQuery, WriterPaymentTableQueryVariables>(WriterPaymentTableDocument, baseOptions);
        }
export type WriterPaymentTableQueryHookResult = ReturnType<typeof useWriterPaymentTableQuery>;
export type WriterPaymentTableLazyQueryHookResult = ReturnType<typeof useWriterPaymentTableLazyQuery>;
export type WriterPaymentTableQueryResult = Apollo.QueryResult<WriterPaymentTableQuery, WriterPaymentTableQueryVariables>;
export const GetWritersDocument = gql`
    query getWriters($where: WriterFilter) {
  writers(where: $where) {
    edges {
      node {
        ...WriterSelectField
      }
    }
  }
}
    ${WriterSelectFieldFragmentDoc}`;

/**
 * __useGetWritersQuery__
 *
 * To run a query within a React component, call `useGetWritersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWritersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWritersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetWritersQuery(baseOptions?: Apollo.QueryHookOptions<GetWritersQuery, GetWritersQueryVariables>) {
        return Apollo.useQuery<GetWritersQuery, GetWritersQueryVariables>(GetWritersDocument, baseOptions);
      }
export function useGetWritersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWritersQuery, GetWritersQueryVariables>) {
          return Apollo.useLazyQuery<GetWritersQuery, GetWritersQueryVariables>(GetWritersDocument, baseOptions);
        }
export type GetWritersQueryHookResult = ReturnType<typeof useGetWritersQuery>;
export type GetWritersLazyQueryHookResult = ReturnType<typeof useGetWritersLazyQuery>;
export type GetWritersQueryResult = Apollo.QueryResult<GetWritersQuery, GetWritersQueryVariables>;
export const WriterStatementPaymentTableDocument = gql`
    query WriterStatementPaymentTable($first: Int = 20, $last: Int = null, $after: String = null, $before: String = null, $where: WriterStatementPaymentFilter) {
  writerStatementPayments(
    first: $first
    last: $last
    after: $after
    before: $before
    where: $where
    orderBy: {attribute: "createdAt", direction: "desc"}
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        ...WriterStatementPaymentTable
      }
    }
  }
}
    ${WriterStatementPaymentTableFragmentDoc}`;

/**
 * __useWriterStatementPaymentTableQuery__
 *
 * To run a query within a React component, call `useWriterStatementPaymentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriterStatementPaymentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriterStatementPaymentTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useWriterStatementPaymentTableQuery(baseOptions?: Apollo.QueryHookOptions<WriterStatementPaymentTableQuery, WriterStatementPaymentTableQueryVariables>) {
        return Apollo.useQuery<WriterStatementPaymentTableQuery, WriterStatementPaymentTableQueryVariables>(WriterStatementPaymentTableDocument, baseOptions);
      }
export function useWriterStatementPaymentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WriterStatementPaymentTableQuery, WriterStatementPaymentTableQueryVariables>) {
          return Apollo.useLazyQuery<WriterStatementPaymentTableQuery, WriterStatementPaymentTableQueryVariables>(WriterStatementPaymentTableDocument, baseOptions);
        }
export type WriterStatementPaymentTableQueryHookResult = ReturnType<typeof useWriterStatementPaymentTableQuery>;
export type WriterStatementPaymentTableLazyQueryHookResult = ReturnType<typeof useWriterStatementPaymentTableLazyQuery>;
export type WriterStatementPaymentTableQueryResult = Apollo.QueryResult<WriterStatementPaymentTableQuery, WriterStatementPaymentTableQueryVariables>;
export const WriterDocument = gql`
    query Writer($id: ID!) {
  writer(id: $id) {
    ...WriterTable
    nbItemsCreated {
      currentMonth
      lastMonth
      total
      totalAmountCurrentMonth
      totalAmountLastMonth
    }
    nbItemsAfterAccepted {
      currentMonth
      lastMonth
      total
      totalAmountCurrentMonth
      totalAmountLastMonth
    }
    kpis {
      totalFromBeginning
      itemAcceptedPercentage
      itemPercentageStates {
        draft
        accepted
        refused
        needUpdate
        waitingExpertise
        underExpertise
      }
    }
    financialStats {
      totalPaid
      totalPending
      nextPaymentDate
      fixedFeesTotal
      percentageFeesTotal
      itemsSoldCount
      itemsOnSaleCount
      totalSalesAmount
      totalPendingWithoutPayment
      cutoffDate
    }
    monthlyEarningsVendor(months: 12) {
      month
      amount
      year
      monthNumber
    }
    monthlyEarningsDodecade(months: 12) {
      month
      amount
      year
      monthNumber
    }
    itemsOnSale(first: 10) {
      edges {
        node {
          id
          title
          finalPrice
          writerCommission
          highEstimatedPrice
          state
          sale {
            id
            endAt
          }
        }
      }
    }
    itemsSold(first: 10) {
      edges {
        node {
          id
          title
          finalPrice
          writerCommission
          highEstimatedPrice
          state
          soldAt
        }
      }
    }
    writerPayments(first: 20) {
      edges {
        node {
          id
          paid
          startAt
          endAt
          writerPaymentLines {
            edges {
              node {
                id
                amount
              }
            }
          }
        }
      }
    }
  }
}
    ${WriterTableFragmentDoc}`;

/**
 * __useWriterQuery__
 *
 * To run a query within a React component, call `useWriterQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWriterQuery(baseOptions: Apollo.QueryHookOptions<WriterQuery, WriterQueryVariables>) {
        return Apollo.useQuery<WriterQuery, WriterQueryVariables>(WriterDocument, baseOptions);
      }
export function useWriterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WriterQuery, WriterQueryVariables>) {
          return Apollo.useLazyQuery<WriterQuery, WriterQueryVariables>(WriterDocument, baseOptions);
        }
export type WriterQueryHookResult = ReturnType<typeof useWriterQuery>;
export type WriterLazyQueryHookResult = ReturnType<typeof useWriterLazyQuery>;
export type WriterQueryResult = Apollo.QueryResult<WriterQuery, WriterQueryVariables>;
export const WritersDocument = gql`
    query Writers($where: WriterFilter) {
  writers(where: $where, orderBy: {attribute: "updatedAt", direction: "desc"}) {
    edges {
      node {
        ...WriterTable
      }
    }
  }
}
    ${WriterTableFragmentDoc}`;

/**
 * __useWritersQuery__
 *
 * To run a query within a React component, call `useWritersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWritersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWritersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useWritersQuery(baseOptions?: Apollo.QueryHookOptions<WritersQuery, WritersQueryVariables>) {
        return Apollo.useQuery<WritersQuery, WritersQueryVariables>(WritersDocument, baseOptions);
      }
export function useWritersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WritersQuery, WritersQueryVariables>) {
          return Apollo.useLazyQuery<WritersQuery, WritersQueryVariables>(WritersDocument, baseOptions);
        }
export type WritersQueryHookResult = ReturnType<typeof useWritersQuery>;
export type WritersLazyQueryHookResult = ReturnType<typeof useWritersLazyQuery>;
export type WritersQueryResult = Apollo.QueryResult<WritersQuery, WritersQueryVariables>;
export const SetWriterProjectRoleDocument = gql`
    mutation SetWriterProjectRole($input: SetWriterProjectRoleMutationInput!) {
  setWriterProjectRole(input: $input) {
    writer {
      id
      adminProjectsIds
    }
  }
}
    `;
export type SetWriterProjectRoleMutationFn = Apollo.MutationFunction<SetWriterProjectRoleMutation, SetWriterProjectRoleMutationVariables>;

/**
 * __useSetWriterProjectRoleMutation__
 *
 * To run a mutation, you first call `useSetWriterProjectRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWriterProjectRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWriterProjectRoleMutation, { data, loading, error }] = useSetWriterProjectRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWriterProjectRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetWriterProjectRoleMutation, SetWriterProjectRoleMutationVariables>) {
        return Apollo.useMutation<SetWriterProjectRoleMutation, SetWriterProjectRoleMutationVariables>(SetWriterProjectRoleDocument, baseOptions);
      }
export type SetWriterProjectRoleMutationHookResult = ReturnType<typeof useSetWriterProjectRoleMutation>;
export type SetWriterProjectRoleMutationResult = Apollo.MutationResult<SetWriterProjectRoleMutation>;
export type SetWriterProjectRoleMutationOptions = Apollo.BaseMutationOptions<SetWriterProjectRoleMutation, SetWriterProjectRoleMutationVariables>;
export const AdminItemCategoriesDocument = gql`
    query AdminItemCategories {
  itemCategories {
    edges {
      node {
        id
        name
        externalRainworxId
        itemsCount
        archived
        archivedAt
        itemSubCategories {
          edges {
            node {
              id
              name
              externalRainworxId
              itemsCount
              archived
              archivedAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdminItemCategoriesQuery__
 *
 * To run a query within a React component, call `useAdminItemCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminItemCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminItemCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminItemCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AdminItemCategoriesQuery, AdminItemCategoriesQueryVariables>) {
        return Apollo.useQuery<AdminItemCategoriesQuery, AdminItemCategoriesQueryVariables>(AdminItemCategoriesDocument, baseOptions);
      }
export function useAdminItemCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminItemCategoriesQuery, AdminItemCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<AdminItemCategoriesQuery, AdminItemCategoriesQueryVariables>(AdminItemCategoriesDocument, baseOptions);
        }
export type AdminItemCategoriesQueryHookResult = ReturnType<typeof useAdminItemCategoriesQuery>;
export type AdminItemCategoriesLazyQueryHookResult = ReturnType<typeof useAdminItemCategoriesLazyQuery>;
export type AdminItemCategoriesQueryResult = Apollo.QueryResult<AdminItemCategoriesQuery, AdminItemCategoriesQueryVariables>;
export const CreateItemCategoryDocument = gql`
    mutation CreateItemCategory($name: String!, $externalRainworxId: Int) {
  createItemCategory(
    input: {name: $name, externalRainworxId: $externalRainworxId}
  ) {
    itemCategory {
      id
      name
      externalRainworxId
      itemsCount
      itemSubCategories {
        edges {
          node {
            id
            name
            externalRainworxId
            itemsCount
          }
        }
      }
    }
    errors
  }
}
    `;
export type CreateItemCategoryMutationFn = Apollo.MutationFunction<CreateItemCategoryMutation, CreateItemCategoryMutationVariables>;

/**
 * __useCreateItemCategoryMutation__
 *
 * To run a mutation, you first call `useCreateItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemCategoryMutation, { data, loading, error }] = useCreateItemCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      externalRainworxId: // value for 'externalRainworxId'
 *   },
 * });
 */
export function useCreateItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemCategoryMutation, CreateItemCategoryMutationVariables>) {
        return Apollo.useMutation<CreateItemCategoryMutation, CreateItemCategoryMutationVariables>(CreateItemCategoryDocument, baseOptions);
      }
export type CreateItemCategoryMutationHookResult = ReturnType<typeof useCreateItemCategoryMutation>;
export type CreateItemCategoryMutationResult = Apollo.MutationResult<CreateItemCategoryMutation>;
export type CreateItemCategoryMutationOptions = Apollo.BaseMutationOptions<CreateItemCategoryMutation, CreateItemCategoryMutationVariables>;
export const UpdateItemCategoryDocument = gql`
    mutation UpdateItemCategory($id: ID!, $name: String, $externalRainworxId: Int) {
  updateItemCategory(
    input: {id: $id, name: $name, externalRainworxId: $externalRainworxId}
  ) {
    itemCategory {
      id
      name
      externalRainworxId
      itemsCount
    }
    errors
  }
}
    `;
export type UpdateItemCategoryMutationFn = Apollo.MutationFunction<UpdateItemCategoryMutation, UpdateItemCategoryMutationVariables>;

/**
 * __useUpdateItemCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemCategoryMutation, { data, loading, error }] = useUpdateItemCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      externalRainworxId: // value for 'externalRainworxId'
 *   },
 * });
 */
export function useUpdateItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemCategoryMutation, UpdateItemCategoryMutationVariables>) {
        return Apollo.useMutation<UpdateItemCategoryMutation, UpdateItemCategoryMutationVariables>(UpdateItemCategoryDocument, baseOptions);
      }
export type UpdateItemCategoryMutationHookResult = ReturnType<typeof useUpdateItemCategoryMutation>;
export type UpdateItemCategoryMutationResult = Apollo.MutationResult<UpdateItemCategoryMutation>;
export type UpdateItemCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateItemCategoryMutation, UpdateItemCategoryMutationVariables>;
export const DestroyItemCategoryDocument = gql`
    mutation DestroyItemCategory($id: ID!) {
  destroyItemCategory(input: {id: $id}) {
    success
    errors
  }
}
    `;
export type DestroyItemCategoryMutationFn = Apollo.MutationFunction<DestroyItemCategoryMutation, DestroyItemCategoryMutationVariables>;

/**
 * __useDestroyItemCategoryMutation__
 *
 * To run a mutation, you first call `useDestroyItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyItemCategoryMutation, { data, loading, error }] = useDestroyItemCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DestroyItemCategoryMutation, DestroyItemCategoryMutationVariables>) {
        return Apollo.useMutation<DestroyItemCategoryMutation, DestroyItemCategoryMutationVariables>(DestroyItemCategoryDocument, baseOptions);
      }
export type DestroyItemCategoryMutationHookResult = ReturnType<typeof useDestroyItemCategoryMutation>;
export type DestroyItemCategoryMutationResult = Apollo.MutationResult<DestroyItemCategoryMutation>;
export type DestroyItemCategoryMutationOptions = Apollo.BaseMutationOptions<DestroyItemCategoryMutation, DestroyItemCategoryMutationVariables>;
export const CreateItemSubCategoryDocument = gql`
    mutation CreateItemSubCategory($name: String!, $itemCategoryId: ID!, $externalRainworxId: Int) {
  createItemSubCategory(
    input: {name: $name, itemCategoryId: $itemCategoryId, externalRainworxId: $externalRainworxId}
  ) {
    itemSubCategory {
      id
      name
      externalRainworxId
      itemsCount
    }
    errors
  }
}
    `;
export type CreateItemSubCategoryMutationFn = Apollo.MutationFunction<CreateItemSubCategoryMutation, CreateItemSubCategoryMutationVariables>;

/**
 * __useCreateItemSubCategoryMutation__
 *
 * To run a mutation, you first call `useCreateItemSubCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemSubCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemSubCategoryMutation, { data, loading, error }] = useCreateItemSubCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      itemCategoryId: // value for 'itemCategoryId'
 *      externalRainworxId: // value for 'externalRainworxId'
 *   },
 * });
 */
export function useCreateItemSubCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemSubCategoryMutation, CreateItemSubCategoryMutationVariables>) {
        return Apollo.useMutation<CreateItemSubCategoryMutation, CreateItemSubCategoryMutationVariables>(CreateItemSubCategoryDocument, baseOptions);
      }
export type CreateItemSubCategoryMutationHookResult = ReturnType<typeof useCreateItemSubCategoryMutation>;
export type CreateItemSubCategoryMutationResult = Apollo.MutationResult<CreateItemSubCategoryMutation>;
export type CreateItemSubCategoryMutationOptions = Apollo.BaseMutationOptions<CreateItemSubCategoryMutation, CreateItemSubCategoryMutationVariables>;
export const UpdateItemSubCategoryDocument = gql`
    mutation UpdateItemSubCategory($id: ID!, $name: String, $externalRainworxId: Int) {
  updateItemSubCategory(
    input: {id: $id, name: $name, externalRainworxId: $externalRainworxId}
  ) {
    itemSubCategory {
      id
      name
      externalRainworxId
      itemsCount
    }
    errors
  }
}
    `;
export type UpdateItemSubCategoryMutationFn = Apollo.MutationFunction<UpdateItemSubCategoryMutation, UpdateItemSubCategoryMutationVariables>;

/**
 * __useUpdateItemSubCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateItemSubCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemSubCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemSubCategoryMutation, { data, loading, error }] = useUpdateItemSubCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      externalRainworxId: // value for 'externalRainworxId'
 *   },
 * });
 */
export function useUpdateItemSubCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemSubCategoryMutation, UpdateItemSubCategoryMutationVariables>) {
        return Apollo.useMutation<UpdateItemSubCategoryMutation, UpdateItemSubCategoryMutationVariables>(UpdateItemSubCategoryDocument, baseOptions);
      }
export type UpdateItemSubCategoryMutationHookResult = ReturnType<typeof useUpdateItemSubCategoryMutation>;
export type UpdateItemSubCategoryMutationResult = Apollo.MutationResult<UpdateItemSubCategoryMutation>;
export type UpdateItemSubCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateItemSubCategoryMutation, UpdateItemSubCategoryMutationVariables>;
export const DestroyItemSubCategoryDocument = gql`
    mutation DestroyItemSubCategory($id: ID!) {
  destroyItemSubCategory(input: {id: $id}) {
    success
    errors
  }
}
    `;
export type DestroyItemSubCategoryMutationFn = Apollo.MutationFunction<DestroyItemSubCategoryMutation, DestroyItemSubCategoryMutationVariables>;

/**
 * __useDestroyItemSubCategoryMutation__
 *
 * To run a mutation, you first call `useDestroyItemSubCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyItemSubCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyItemSubCategoryMutation, { data, loading, error }] = useDestroyItemSubCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyItemSubCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DestroyItemSubCategoryMutation, DestroyItemSubCategoryMutationVariables>) {
        return Apollo.useMutation<DestroyItemSubCategoryMutation, DestroyItemSubCategoryMutationVariables>(DestroyItemSubCategoryDocument, baseOptions);
      }
export type DestroyItemSubCategoryMutationHookResult = ReturnType<typeof useDestroyItemSubCategoryMutation>;
export type DestroyItemSubCategoryMutationResult = Apollo.MutationResult<DestroyItemSubCategoryMutation>;
export type DestroyItemSubCategoryMutationOptions = Apollo.BaseMutationOptions<DestroyItemSubCategoryMutation, DestroyItemSubCategoryMutationVariables>;
export const ArchiveItemCategoryDocument = gql`
    mutation ArchiveItemCategory($id: ID!) {
  archiveItemCategory(input: {id: $id}) {
    itemCategory {
      id
      archived
      archivedAt
    }
    errors
  }
}
    `;
export type ArchiveItemCategoryMutationFn = Apollo.MutationFunction<ArchiveItemCategoryMutation, ArchiveItemCategoryMutationVariables>;

/**
 * __useArchiveItemCategoryMutation__
 *
 * To run a mutation, you first call `useArchiveItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveItemCategoryMutation, { data, loading, error }] = useArchiveItemCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveItemCategoryMutation, ArchiveItemCategoryMutationVariables>) {
        return Apollo.useMutation<ArchiveItemCategoryMutation, ArchiveItemCategoryMutationVariables>(ArchiveItemCategoryDocument, baseOptions);
      }
export type ArchiveItemCategoryMutationHookResult = ReturnType<typeof useArchiveItemCategoryMutation>;
export type ArchiveItemCategoryMutationResult = Apollo.MutationResult<ArchiveItemCategoryMutation>;
export type ArchiveItemCategoryMutationOptions = Apollo.BaseMutationOptions<ArchiveItemCategoryMutation, ArchiveItemCategoryMutationVariables>;
export const UnarchiveItemCategoryDocument = gql`
    mutation UnarchiveItemCategory($id: ID!) {
  unarchiveItemCategory(input: {id: $id}) {
    itemCategory {
      id
      archived
      archivedAt
    }
    errors
  }
}
    `;
export type UnarchiveItemCategoryMutationFn = Apollo.MutationFunction<UnarchiveItemCategoryMutation, UnarchiveItemCategoryMutationVariables>;

/**
 * __useUnarchiveItemCategoryMutation__
 *
 * To run a mutation, you first call `useUnarchiveItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveItemCategoryMutation, { data, loading, error }] = useUnarchiveItemCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveItemCategoryMutation, UnarchiveItemCategoryMutationVariables>) {
        return Apollo.useMutation<UnarchiveItemCategoryMutation, UnarchiveItemCategoryMutationVariables>(UnarchiveItemCategoryDocument, baseOptions);
      }
export type UnarchiveItemCategoryMutationHookResult = ReturnType<typeof useUnarchiveItemCategoryMutation>;
export type UnarchiveItemCategoryMutationResult = Apollo.MutationResult<UnarchiveItemCategoryMutation>;
export type UnarchiveItemCategoryMutationOptions = Apollo.BaseMutationOptions<UnarchiveItemCategoryMutation, UnarchiveItemCategoryMutationVariables>;
export const ArchiveItemSubCategoryDocument = gql`
    mutation ArchiveItemSubCategory($id: ID!) {
  archiveItemSubCategory(input: {id: $id}) {
    itemSubCategory {
      id
      archived
      archivedAt
    }
    errors
  }
}
    `;
export type ArchiveItemSubCategoryMutationFn = Apollo.MutationFunction<ArchiveItemSubCategoryMutation, ArchiveItemSubCategoryMutationVariables>;

/**
 * __useArchiveItemSubCategoryMutation__
 *
 * To run a mutation, you first call `useArchiveItemSubCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveItemSubCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveItemSubCategoryMutation, { data, loading, error }] = useArchiveItemSubCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveItemSubCategoryMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveItemSubCategoryMutation, ArchiveItemSubCategoryMutationVariables>) {
        return Apollo.useMutation<ArchiveItemSubCategoryMutation, ArchiveItemSubCategoryMutationVariables>(ArchiveItemSubCategoryDocument, baseOptions);
      }
export type ArchiveItemSubCategoryMutationHookResult = ReturnType<typeof useArchiveItemSubCategoryMutation>;
export type ArchiveItemSubCategoryMutationResult = Apollo.MutationResult<ArchiveItemSubCategoryMutation>;
export type ArchiveItemSubCategoryMutationOptions = Apollo.BaseMutationOptions<ArchiveItemSubCategoryMutation, ArchiveItemSubCategoryMutationVariables>;
export const UnarchiveItemSubCategoryDocument = gql`
    mutation UnarchiveItemSubCategory($id: ID!) {
  unarchiveItemSubCategory(input: {id: $id}) {
    itemSubCategory {
      id
      archived
      archivedAt
    }
    errors
  }
}
    `;
export type UnarchiveItemSubCategoryMutationFn = Apollo.MutationFunction<UnarchiveItemSubCategoryMutation, UnarchiveItemSubCategoryMutationVariables>;

/**
 * __useUnarchiveItemSubCategoryMutation__
 *
 * To run a mutation, you first call `useUnarchiveItemSubCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveItemSubCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveItemSubCategoryMutation, { data, loading, error }] = useUnarchiveItemSubCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveItemSubCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveItemSubCategoryMutation, UnarchiveItemSubCategoryMutationVariables>) {
        return Apollo.useMutation<UnarchiveItemSubCategoryMutation, UnarchiveItemSubCategoryMutationVariables>(UnarchiveItemSubCategoryDocument, baseOptions);
      }
export type UnarchiveItemSubCategoryMutationHookResult = ReturnType<typeof useUnarchiveItemSubCategoryMutation>;
export type UnarchiveItemSubCategoryMutationResult = Apollo.MutationResult<UnarchiveItemSubCategoryMutation>;
export type UnarchiveItemSubCategoryMutationOptions = Apollo.BaseMutationOptions<UnarchiveItemSubCategoryMutation, UnarchiveItemSubCategoryMutationVariables>;
export const VendorsLateOrdersDocument = gql`
    query VendorsLateOrders {
  vendorsLateOrders {
    vendorId
    vendorName
    vendorEmail
    vendorPhone
    lateOrderItems3Days {
      id
      state
      order {
        id
        dodecadeOrderRef
        paidAt
        totalPrice
      }
    }
    lateOrderItems5Days {
      id
      state
      order {
        id
        dodecadeOrderRef
        paidAt
        totalPrice
      }
    }
  }
}
    `;

/**
 * __useVendorsLateOrdersQuery__
 *
 * To run a query within a React component, call `useVendorsLateOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsLateOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsLateOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorsLateOrdersQuery(baseOptions?: Apollo.QueryHookOptions<VendorsLateOrdersQuery, VendorsLateOrdersQueryVariables>) {
        return Apollo.useQuery<VendorsLateOrdersQuery, VendorsLateOrdersQueryVariables>(VendorsLateOrdersDocument, baseOptions);
      }
export function useVendorsLateOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorsLateOrdersQuery, VendorsLateOrdersQueryVariables>) {
          return Apollo.useLazyQuery<VendorsLateOrdersQuery, VendorsLateOrdersQueryVariables>(VendorsLateOrdersDocument, baseOptions);
        }
export type VendorsLateOrdersQueryHookResult = ReturnType<typeof useVendorsLateOrdersQuery>;
export type VendorsLateOrdersLazyQueryHookResult = ReturnType<typeof useVendorsLateOrdersLazyQuery>;
export type VendorsLateOrdersQueryResult = Apollo.QueryResult<VendorsLateOrdersQuery, VendorsLateOrdersQueryVariables>;
export const SendLateOrdersReminderDocument = gql`
    mutation SendLateOrdersReminder($input: SendLateOrdersReminderMutationInput!) {
  sendLateOrdersReminder(input: $input) {
    success
    errors
    message
  }
}
    `;
export type SendLateOrdersReminderMutationFn = Apollo.MutationFunction<SendLateOrdersReminderMutation, SendLateOrdersReminderMutationVariables>;

/**
 * __useSendLateOrdersReminderMutation__
 *
 * To run a mutation, you first call `useSendLateOrdersReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLateOrdersReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLateOrdersReminderMutation, { data, loading, error }] = useSendLateOrdersReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendLateOrdersReminderMutation(baseOptions?: Apollo.MutationHookOptions<SendLateOrdersReminderMutation, SendLateOrdersReminderMutationVariables>) {
        return Apollo.useMutation<SendLateOrdersReminderMutation, SendLateOrdersReminderMutationVariables>(SendLateOrdersReminderDocument, baseOptions);
      }
export type SendLateOrdersReminderMutationHookResult = ReturnType<typeof useSendLateOrdersReminderMutation>;
export type SendLateOrdersReminderMutationResult = Apollo.MutationResult<SendLateOrdersReminderMutation>;
export type SendLateOrdersReminderMutationOptions = Apollo.BaseMutationOptions<SendLateOrdersReminderMutation, SendLateOrdersReminderMutationVariables>;
export const VendorsLatePickupsDocument = gql`
    query VendorsLatePickups {
  vendorsLatePickups {
    vendorId
    vendorName
    vendorEmail
    vendorPhone
    latePickupItems3Days {
      id
      state
      order {
        id
        dodecadeOrderRef
        paidAt
        totalPrice
        carrierName
      }
    }
    latePickupItems5Days {
      id
      state
      order {
        id
        dodecadeOrderRef
        paidAt
        totalPrice
        carrierName
      }
    }
  }
}
    `;

/**
 * __useVendorsLatePickupsQuery__
 *
 * To run a query within a React component, call `useVendorsLatePickupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsLatePickupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsLatePickupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorsLatePickupsQuery(baseOptions?: Apollo.QueryHookOptions<VendorsLatePickupsQuery, VendorsLatePickupsQueryVariables>) {
        return Apollo.useQuery<VendorsLatePickupsQuery, VendorsLatePickupsQueryVariables>(VendorsLatePickupsDocument, baseOptions);
      }
export function useVendorsLatePickupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorsLatePickupsQuery, VendorsLatePickupsQueryVariables>) {
          return Apollo.useLazyQuery<VendorsLatePickupsQuery, VendorsLatePickupsQueryVariables>(VendorsLatePickupsDocument, baseOptions);
        }
export type VendorsLatePickupsQueryHookResult = ReturnType<typeof useVendorsLatePickupsQuery>;
export type VendorsLatePickupsLazyQueryHookResult = ReturnType<typeof useVendorsLatePickupsLazyQuery>;
export type VendorsLatePickupsQueryResult = Apollo.QueryResult<VendorsLatePickupsQuery, VendorsLatePickupsQueryVariables>;
export const SendLatePickupsReminderDocument = gql`
    mutation SendLatePickupsReminder($input: SendLatePickupsReminderMutationInput!) {
  sendLatePickupsReminder(input: $input) {
    success
    errors
    message
  }
}
    `;
export type SendLatePickupsReminderMutationFn = Apollo.MutationFunction<SendLatePickupsReminderMutation, SendLatePickupsReminderMutationVariables>;

/**
 * __useSendLatePickupsReminderMutation__
 *
 * To run a mutation, you first call `useSendLatePickupsReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLatePickupsReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLatePickupsReminderMutation, { data, loading, error }] = useSendLatePickupsReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendLatePickupsReminderMutation(baseOptions?: Apollo.MutationHookOptions<SendLatePickupsReminderMutation, SendLatePickupsReminderMutationVariables>) {
        return Apollo.useMutation<SendLatePickupsReminderMutation, SendLatePickupsReminderMutationVariables>(SendLatePickupsReminderDocument, baseOptions);
      }
export type SendLatePickupsReminderMutationHookResult = ReturnType<typeof useSendLatePickupsReminderMutation>;
export type SendLatePickupsReminderMutationResult = Apollo.MutationResult<SendLatePickupsReminderMutation>;
export type SendLatePickupsReminderMutationOptions = Apollo.BaseMutationOptions<SendLatePickupsReminderMutation, SendLatePickupsReminderMutationVariables>;
export const BuyerDetailDocument = gql`
    query BuyerDetail($id: ID!) {
  buyer(id: $id) {
    id
    createdAt
    account {
      id
      civility
      firstName
      lastName
      companyName
      isProfessional
      email
      emailState
      phone
      createdAt
    }
    desiresReviewedAt
    desiresReviewedBy
    unsubscriptions {
      kind
    }
    stats {
      ordersCount
      totalSpent
      averageBasket
      purchasesCount
      firstOrderAt
      lastOrderAt
      desiresCount
      activeDesiresCount
      favoritesCount
      newslettersReceivedCount
      newslettersOpenedCount
      newslettersClickedCount
      lastOpenedAt
    }
    topTags(limit: 15) {
      purchasesCount
      tag {
        id
        name
      }
    }
    desires(first: 100) {
      totalCount
      nodes {
        id
        title
        active
        validated
        usable
        unusableReasonLabel
        matchingWords
        alertsSentCount
        lastAlertSentAt
        createdAt
        tags(first: 20) {
          nodes {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBuyerDetailQuery__
 *
 * To run a query within a React component, call `useBuyerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuyerDetailQuery(baseOptions: Apollo.QueryHookOptions<BuyerDetailQuery, BuyerDetailQueryVariables>) {
        return Apollo.useQuery<BuyerDetailQuery, BuyerDetailQueryVariables>(BuyerDetailDocument, baseOptions);
      }
export function useBuyerDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerDetailQuery, BuyerDetailQueryVariables>) {
          return Apollo.useLazyQuery<BuyerDetailQuery, BuyerDetailQueryVariables>(BuyerDetailDocument, baseOptions);
        }
export type BuyerDetailQueryHookResult = ReturnType<typeof useBuyerDetailQuery>;
export type BuyerDetailLazyQueryHookResult = ReturnType<typeof useBuyerDetailLazyQuery>;
export type BuyerDetailQueryResult = Apollo.QueryResult<BuyerDetailQuery, BuyerDetailQueryVariables>;
export const BuyerPurchasesDocument = gql`
    query BuyerPurchases($id: ID!, $first: Int = 24, $after: String = null) {
  buyer(id: $id) {
    id
    purchases(first: $first, after: $after) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        ...BuyerPurchase
      }
    }
  }
}
    ${BuyerPurchaseFragmentDoc}`;

/**
 * __useBuyerPurchasesQuery__
 *
 * To run a query within a React component, call `useBuyerPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerPurchasesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBuyerPurchasesQuery(baseOptions: Apollo.QueryHookOptions<BuyerPurchasesQuery, BuyerPurchasesQueryVariables>) {
        return Apollo.useQuery<BuyerPurchasesQuery, BuyerPurchasesQueryVariables>(BuyerPurchasesDocument, baseOptions);
      }
export function useBuyerPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerPurchasesQuery, BuyerPurchasesQueryVariables>) {
          return Apollo.useLazyQuery<BuyerPurchasesQuery, BuyerPurchasesQueryVariables>(BuyerPurchasesDocument, baseOptions);
        }
export type BuyerPurchasesQueryHookResult = ReturnType<typeof useBuyerPurchasesQuery>;
export type BuyerPurchasesLazyQueryHookResult = ReturnType<typeof useBuyerPurchasesLazyQuery>;
export type BuyerPurchasesQueryResult = Apollo.QueryResult<BuyerPurchasesQuery, BuyerPurchasesQueryVariables>;
export const BuyerFavoritesDocument = gql`
    query BuyerFavorites($id: ID!, $first: Int = 24, $after: String = null) {
  buyer(id: $id) {
    id
    favorites(first: $first, after: $after) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        ...BuyerFavorite
      }
    }
  }
}
    ${BuyerFavoriteFragmentDoc}`;

/**
 * __useBuyerFavoritesQuery__
 *
 * To run a query within a React component, call `useBuyerFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerFavoritesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBuyerFavoritesQuery(baseOptions: Apollo.QueryHookOptions<BuyerFavoritesQuery, BuyerFavoritesQueryVariables>) {
        return Apollo.useQuery<BuyerFavoritesQuery, BuyerFavoritesQueryVariables>(BuyerFavoritesDocument, baseOptions);
      }
export function useBuyerFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerFavoritesQuery, BuyerFavoritesQueryVariables>) {
          return Apollo.useLazyQuery<BuyerFavoritesQuery, BuyerFavoritesQueryVariables>(BuyerFavoritesDocument, baseOptions);
        }
export type BuyerFavoritesQueryHookResult = ReturnType<typeof useBuyerFavoritesQuery>;
export type BuyerFavoritesLazyQueryHookResult = ReturnType<typeof useBuyerFavoritesLazyQuery>;
export type BuyerFavoritesQueryResult = Apollo.QueryResult<BuyerFavoritesQuery, BuyerFavoritesQueryVariables>;
export const ContactDetailDocument = gql`
    query ContactDetail($id: ID!) {
  customer(id: $id) {
    id
    createdAt
    email
    firstName
    lastName
    fullName
    phone1
    phone2
    addressLine1
    addressLine2
    zip
    city
    country
    emailState
    subscribed
    desiresReviewedAt
    desiresReviewedBy
    unsubscriptions {
      kind
      createdAt
      source
    }
    stats {
      recordsCount
      newslettersReceivedCount
      lastNewsletterAt
      newslettersOpenedCount
      lastOpenedAt
      newslettersClickedCount
      desiresCount
      activeDesiresCount
      ordersCount
      totalSpent
      matchedBuyer {
        id
      }
    }
    origins {
      createdAt
      importFilename
    }
    itemCategories(first: 50) {
      nodes {
        id
        name
      }
    }
    itemSubCategories(first: 50) {
      nodes {
        id
        name
      }
    }
    tags(first: 50) {
      nodes {
        id
        name
      }
    }
    desires(first: 100) {
      totalCount
      nodes {
        id
        title
        active
        validated
        usable
        unusableReasonLabel
        matchingWords
        alertsSentCount
        lastAlertSentAt
        createdAt
        tags(first: 20) {
          nodes {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useContactDetailQuery__
 *
 * To run a query within a React component, call `useContactDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactDetailQuery(baseOptions: Apollo.QueryHookOptions<ContactDetailQuery, ContactDetailQueryVariables>) {
        return Apollo.useQuery<ContactDetailQuery, ContactDetailQueryVariables>(ContactDetailDocument, baseOptions);
      }
export function useContactDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactDetailQuery, ContactDetailQueryVariables>) {
          return Apollo.useLazyQuery<ContactDetailQuery, ContactDetailQueryVariables>(ContactDetailDocument, baseOptions);
        }
export type ContactDetailQueryHookResult = ReturnType<typeof useContactDetailQuery>;
export type ContactDetailLazyQueryHookResult = ReturnType<typeof useContactDetailLazyQuery>;
export type ContactDetailQueryResult = Apollo.QueryResult<ContactDetailQuery, ContactDetailQueryVariables>;
export const ContactsSummaryDocument = gql`
    query ContactsSummary($dormantMinNewsletters: Int = 5) {
  customerContactsSummary(dormantMinNewsletters: $dormantMinNewsletters) {
    totalCount
    sendableCount
    blockedCount
    flaggedUnsubscribedCount
    sendableNeverBoughtCount
    dormantCount
    withDesiresCount
    engagedNeverBoughtCount
    neverOpenedCount
    salesUnsubscribedCount
    weeklyUnsubscribedCount
    emailStates {
      state
      count
    }
  }
}
    `;

/**
 * __useContactsSummaryQuery__
 *
 * To run a query within a React component, call `useContactsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsSummaryQuery({
 *   variables: {
 *      dormantMinNewsletters: // value for 'dormantMinNewsletters'
 *   },
 * });
 */
export function useContactsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ContactsSummaryQuery, ContactsSummaryQueryVariables>) {
        return Apollo.useQuery<ContactsSummaryQuery, ContactsSummaryQueryVariables>(ContactsSummaryDocument, baseOptions);
      }
export function useContactsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsSummaryQuery, ContactsSummaryQueryVariables>) {
          return Apollo.useLazyQuery<ContactsSummaryQuery, ContactsSummaryQueryVariables>(ContactsSummaryDocument, baseOptions);
        }
export type ContactsSummaryQueryHookResult = ReturnType<typeof useContactsSummaryQuery>;
export type ContactsSummaryLazyQueryHookResult = ReturnType<typeof useContactsSummaryLazyQuery>;
export type ContactsSummaryQueryResult = Apollo.QueryResult<ContactsSummaryQuery, ContactsSummaryQueryVariables>;
export const CreateCpImportDocument = gql`
    mutation CreateCpImport($attributes: CreateCpImportInput!) {
  createCpImport(input: {attributes: $attributes}) {
    clientMutationId
    import {
      id
    }
  }
}
    `;
export type CreateCpImportMutationFn = Apollo.MutationFunction<CreateCpImportMutation, CreateCpImportMutationVariables>;

/**
 * __useCreateCpImportMutation__
 *
 * To run a mutation, you first call `useCreateCpImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCpImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCpImportMutation, { data, loading, error }] = useCreateCpImportMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateCpImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateCpImportMutation, CreateCpImportMutationVariables>) {
        return Apollo.useMutation<CreateCpImportMutation, CreateCpImportMutationVariables>(CreateCpImportDocument, baseOptions);
      }
export type CreateCpImportMutationHookResult = ReturnType<typeof useCreateCpImportMutation>;
export type CreateCpImportMutationResult = Apollo.MutationResult<CreateCpImportMutation>;
export type CreateCpImportMutationOptions = Apollo.BaseMutationOptions<CreateCpImportMutation, CreateCpImportMutationVariables>;
export const CreateItemFromSaleDocument = gql`
    query CreateItemFromSale($saleId: ID!) {
  sale(id: $saleId) {
    id
    name
    typeOfSale
  }
  projects(orderBy: {attribute: "createdAt", direction: "desc"}, first: 500) {
    edges {
      node {
        id
        title
        number
      }
    }
  }
  plannedItems: items(where: {plannedSaleId: {equalTo: $saleId}}, first: 500) {
    edges {
      node {
        id
        project {
          id
        }
      }
    }
  }
  saleItems: items(where: {saleId: {equalTo: $saleId}}, first: 500) {
    edges {
      node {
        id
        project {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useCreateItemFromSaleQuery__
 *
 * To run a query within a React component, call `useCreateItemFromSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateItemFromSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateItemFromSaleQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useCreateItemFromSaleQuery(baseOptions: Apollo.QueryHookOptions<CreateItemFromSaleQuery, CreateItemFromSaleQueryVariables>) {
        return Apollo.useQuery<CreateItemFromSaleQuery, CreateItemFromSaleQueryVariables>(CreateItemFromSaleDocument, baseOptions);
      }
export function useCreateItemFromSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateItemFromSaleQuery, CreateItemFromSaleQueryVariables>) {
          return Apollo.useLazyQuery<CreateItemFromSaleQuery, CreateItemFromSaleQueryVariables>(CreateItemFromSaleDocument, baseOptions);
        }
export type CreateItemFromSaleQueryHookResult = ReturnType<typeof useCreateItemFromSaleQuery>;
export type CreateItemFromSaleLazyQueryHookResult = ReturnType<typeof useCreateItemFromSaleLazyQuery>;
export type CreateItemFromSaleQueryResult = Apollo.QueryResult<CreateItemFromSaleQuery, CreateItemFromSaleQueryVariables>;
export const DesireAlertStatsDocument = gql`
    query DesireAlertStats($limit: Int = 30, $hours: Int = 72, $days: Int = 30) {
  desireAlertSummary(days: $days) {
    desiresCount
    itemsCount
    salesCount
    stats {
      sent
      opened
      clicked
      bounced
      spam
      unsub
      openRate
      clickRate
    }
  }
  desireAlertSales(limit: $limit) {
    firstSentAt
    desiresCount
    itemsCount
    sale {
      id
      name
    }
    stats {
      sent
      opened
      clicked
      bounced
      spam
      unsub
      openRate
      clickRate
    }
  }
  desireAlertHourlyStats(hours: $hours) {
    hour
    sent
    opened
    clicked
  }
}
    `;

/**
 * __useDesireAlertStatsQuery__
 *
 * To run a query within a React component, call `useDesireAlertStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesireAlertStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesireAlertStatsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      hours: // value for 'hours'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useDesireAlertStatsQuery(baseOptions?: Apollo.QueryHookOptions<DesireAlertStatsQuery, DesireAlertStatsQueryVariables>) {
        return Apollo.useQuery<DesireAlertStatsQuery, DesireAlertStatsQueryVariables>(DesireAlertStatsDocument, baseOptions);
      }
export function useDesireAlertStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesireAlertStatsQuery, DesireAlertStatsQueryVariables>) {
          return Apollo.useLazyQuery<DesireAlertStatsQuery, DesireAlertStatsQueryVariables>(DesireAlertStatsDocument, baseOptions);
        }
export type DesireAlertStatsQueryHookResult = ReturnType<typeof useDesireAlertStatsQuery>;
export type DesireAlertStatsLazyQueryHookResult = ReturnType<typeof useDesireAlertStatsLazyQuery>;
export type DesireAlertStatsQueryResult = Apollo.QueryResult<DesireAlertStatsQuery, DesireAlertStatsQueryVariables>;
export const CreateDesireImportDocument = gql`
    mutation CreateDesireImport($attributes: CreateDesiresRainworxImportInput!) {
  createDesiresRainworxImport(input: {attributes: $attributes}) {
    clientMutationId
    import {
      id
    }
  }
}
    `;
export type CreateDesireImportMutationFn = Apollo.MutationFunction<CreateDesireImportMutation, CreateDesireImportMutationVariables>;

/**
 * __useCreateDesireImportMutation__
 *
 * To run a mutation, you first call `useCreateDesireImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDesireImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDesireImportMutation, { data, loading, error }] = useCreateDesireImportMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateDesireImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateDesireImportMutation, CreateDesireImportMutationVariables>) {
        return Apollo.useMutation<CreateDesireImportMutation, CreateDesireImportMutationVariables>(CreateDesireImportDocument, baseOptions);
      }
export type CreateDesireImportMutationHookResult = ReturnType<typeof useCreateDesireImportMutation>;
export type CreateDesireImportMutationResult = Apollo.MutationResult<CreateDesireImportMutation>;
export type CreateDesireImportMutationOptions = Apollo.BaseMutationOptions<CreateDesireImportMutation, CreateDesireImportMutationVariables>;
export const CreateImportDocument = gql`
    mutation CreateImport($attributes: CreateImportInput!) {
  createImport(input: {attributes: $attributes}) {
    clientMutationId
    import {
      id
    }
  }
}
    `;
export type CreateImportMutationFn = Apollo.MutationFunction<CreateImportMutation, CreateImportMutationVariables>;

/**
 * __useCreateImportMutation__
 *
 * To run a mutation, you first call `useCreateImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportMutation, { data, loading, error }] = useCreateImportMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateImportMutation, CreateImportMutationVariables>) {
        return Apollo.useMutation<CreateImportMutation, CreateImportMutationVariables>(CreateImportDocument, baseOptions);
      }
export type CreateImportMutationHookResult = ReturnType<typeof useCreateImportMutation>;
export type CreateImportMutationResult = Apollo.MutationResult<CreateImportMutation>;
export type CreateImportMutationOptions = Apollo.BaseMutationOptions<CreateImportMutation, CreateImportMutationVariables>;
export const DodecadeStatementPaymentsDocument = gql`
    query DodecadeStatementPayments($where: DodecadeStatementPaymentFilter) {
  dodecadeStatementPayments(where: $where) {
    nodes {
      id
      totalAmount
      totalVendorAmount
      totalPlatformFee
      stripePayoutId
      stripePayoutStatus
      stripePayoutMode
      stripePaidOutAt
      periodStartAt
      periodEndAt
      paid
      paymentDate
      createdAt
      vendorStatementPayments {
        edges {
          node {
            id
            totalAmount
            vendor {
              id
              account {
                firstName
                lastName
              }
            }
            stripeTransferStatus
          }
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useDodecadeStatementPaymentsQuery__
 *
 * To run a query within a React component, call `useDodecadeStatementPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDodecadeStatementPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDodecadeStatementPaymentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDodecadeStatementPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<DodecadeStatementPaymentsQuery, DodecadeStatementPaymentsQueryVariables>) {
        return Apollo.useQuery<DodecadeStatementPaymentsQuery, DodecadeStatementPaymentsQueryVariables>(DodecadeStatementPaymentsDocument, baseOptions);
      }
export function useDodecadeStatementPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DodecadeStatementPaymentsQuery, DodecadeStatementPaymentsQueryVariables>) {
          return Apollo.useLazyQuery<DodecadeStatementPaymentsQuery, DodecadeStatementPaymentsQueryVariables>(DodecadeStatementPaymentsDocument, baseOptions);
        }
export type DodecadeStatementPaymentsQueryHookResult = ReturnType<typeof useDodecadeStatementPaymentsQuery>;
export type DodecadeStatementPaymentsLazyQueryHookResult = ReturnType<typeof useDodecadeStatementPaymentsLazyQuery>;
export type DodecadeStatementPaymentsQueryResult = Apollo.QueryResult<DodecadeStatementPaymentsQuery, DodecadeStatementPaymentsQueryVariables>;
export const DodecadeStatementPaymentDocument = gql`
    query DodecadeStatementPayment($id: ID!) {
  dodecadeStatementPayment(id: $id) {
    id
    totalAmount
    totalVendorAmount
    totalPlatformFee
    stripePayoutId
    stripePayoutStatus
    stripePayoutMode
    stripePaidOutAt
    periodStartAt
    periodEndAt
    paid
    paymentDate
    createdAt
    vendorStatementPayments {
      edges {
        node {
          id
          totalAmount
          paid
          stripeTransferId
          stripeTransferStatus
          stripeTransferError
          stripeTransferredAt
          vendor {
            id
            stripeConnectAccountId
            account {
              firstName
              lastName
              bankInformation {
                iban
                bic
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDodecadeStatementPaymentQuery__
 *
 * To run a query within a React component, call `useDodecadeStatementPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDodecadeStatementPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDodecadeStatementPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDodecadeStatementPaymentQuery(baseOptions: Apollo.QueryHookOptions<DodecadeStatementPaymentQuery, DodecadeStatementPaymentQueryVariables>) {
        return Apollo.useQuery<DodecadeStatementPaymentQuery, DodecadeStatementPaymentQueryVariables>(DodecadeStatementPaymentDocument, baseOptions);
      }
export function useDodecadeStatementPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DodecadeStatementPaymentQuery, DodecadeStatementPaymentQueryVariables>) {
          return Apollo.useLazyQuery<DodecadeStatementPaymentQuery, DodecadeStatementPaymentQueryVariables>(DodecadeStatementPaymentDocument, baseOptions);
        }
export type DodecadeStatementPaymentQueryHookResult = ReturnType<typeof useDodecadeStatementPaymentQuery>;
export type DodecadeStatementPaymentLazyQueryHookResult = ReturnType<typeof useDodecadeStatementPaymentLazyQuery>;
export type DodecadeStatementPaymentQueryResult = Apollo.QueryResult<DodecadeStatementPaymentQuery, DodecadeStatementPaymentQueryVariables>;
export const TriggerDodecadePayoutDocument = gql`
    mutation TriggerDodecadePayout($input: TriggerDodecadePayoutMutationInput!) {
  triggerDodecadePayout(input: $input) {
    dodecadeStatementPayment {
      id
      stripePayoutId
      stripePayoutStatus
      stripePaidOutAt
    }
    errors
  }
}
    `;
export type TriggerDodecadePayoutMutationFn = Apollo.MutationFunction<TriggerDodecadePayoutMutation, TriggerDodecadePayoutMutationVariables>;

/**
 * __useTriggerDodecadePayoutMutation__
 *
 * To run a mutation, you first call `useTriggerDodecadePayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerDodecadePayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerDodecadePayoutMutation, { data, loading, error }] = useTriggerDodecadePayoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerDodecadePayoutMutation(baseOptions?: Apollo.MutationHookOptions<TriggerDodecadePayoutMutation, TriggerDodecadePayoutMutationVariables>) {
        return Apollo.useMutation<TriggerDodecadePayoutMutation, TriggerDodecadePayoutMutationVariables>(TriggerDodecadePayoutDocument, baseOptions);
      }
export type TriggerDodecadePayoutMutationHookResult = ReturnType<typeof useTriggerDodecadePayoutMutation>;
export type TriggerDodecadePayoutMutationResult = Apollo.MutationResult<TriggerDodecadePayoutMutation>;
export type TriggerDodecadePayoutMutationOptions = Apollo.BaseMutationOptions<TriggerDodecadePayoutMutation, TriggerDodecadePayoutMutationVariables>;
export const CreateDrouotImportDocument = gql`
    mutation CreateDrouotImport($attributes: CreateDrouotImportInput!) {
  createDrouotImport(input: {attributes: $attributes}) {
    clientMutationId
    import {
      id
    }
  }
}
    `;
export type CreateDrouotImportMutationFn = Apollo.MutationFunction<CreateDrouotImportMutation, CreateDrouotImportMutationVariables>;

/**
 * __useCreateDrouotImportMutation__
 *
 * To run a mutation, you first call `useCreateDrouotImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDrouotImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDrouotImportMutation, { data, loading, error }] = useCreateDrouotImportMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateDrouotImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateDrouotImportMutation, CreateDrouotImportMutationVariables>) {
        return Apollo.useMutation<CreateDrouotImportMutation, CreateDrouotImportMutationVariables>(CreateDrouotImportDocument, baseOptions);
      }
export type CreateDrouotImportMutationHookResult = ReturnType<typeof useCreateDrouotImportMutation>;
export type CreateDrouotImportMutationResult = Apollo.MutationResult<CreateDrouotImportMutation>;
export type CreateDrouotImportMutationOptions = Apollo.BaseMutationOptions<CreateDrouotImportMutation, CreateDrouotImportMutationVariables>;
export const ExpertDashboardDocument = gql`
    query ExpertDashboard {
  waitingExpertise: items(
    where: {state: ["waitingExpertise", "underExpertise"], projectId: {equalTo: null}}
    first: 0
  ) {
    totalCount
  }
  needUpdate: items(
    where: {state: ["needUpdate"], projectId: {equalTo: null}}
    first: 0
  ) {
    totalCount
  }
  accepted: items(
    where: {state: ["accepted"], projectId: {equalTo: null}}
    first: 0
  ) {
    totalCount
  }
  itemsStats {
    onSale
    onVacation
    adminLibraryFundEligible
    adminDiscountedEligible
    adminUnpaidEligible
  }
  sales(where: {state: ["draft", "onSale"]}, first: 30) {
    edges {
      node {
        id
        name
        state
        startAt
        endAt
        nbItems
        typeOfSale
      }
    }
  }
}
    `;

/**
 * __useExpertDashboardQuery__
 *
 * To run a query within a React component, call `useExpertDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpertDashboardQuery(baseOptions?: Apollo.QueryHookOptions<ExpertDashboardQuery, ExpertDashboardQueryVariables>) {
        return Apollo.useQuery<ExpertDashboardQuery, ExpertDashboardQueryVariables>(ExpertDashboardDocument, baseOptions);
      }
export function useExpertDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertDashboardQuery, ExpertDashboardQueryVariables>) {
          return Apollo.useLazyQuery<ExpertDashboardQuery, ExpertDashboardQueryVariables>(ExpertDashboardDocument, baseOptions);
        }
export type ExpertDashboardQueryHookResult = ReturnType<typeof useExpertDashboardQuery>;
export type ExpertDashboardLazyQueryHookResult = ReturnType<typeof useExpertDashboardLazyQuery>;
export type ExpertDashboardQueryResult = Apollo.QueryResult<ExpertDashboardQuery, ExpertDashboardQueryVariables>;
export const ExpertDashboardAdminDocument = gql`
    query ExpertDashboardAdmin($from: ISO8601DateTime!, $to: ISO8601DateTime!) {
  kpis: analytics(
    scope: {from: $from, to: $to}
    metrics: [GMV, DODECADE_MARGIN, SALE_RATE]
    compareTo: PREVIOUS_PERIOD
  ) {
    metrics {
      name
      value
      comparison {
        previousValue
        deltaPercentage
      }
    }
  }
  vendorsLateOrders {
    vendorId
  }
  vendorsLatePickups {
    vendorId
  }
}
    `;

/**
 * __useExpertDashboardAdminQuery__
 *
 * To run a query within a React component, call `useExpertDashboardAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertDashboardAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertDashboardAdminQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useExpertDashboardAdminQuery(baseOptions: Apollo.QueryHookOptions<ExpertDashboardAdminQuery, ExpertDashboardAdminQueryVariables>) {
        return Apollo.useQuery<ExpertDashboardAdminQuery, ExpertDashboardAdminQueryVariables>(ExpertDashboardAdminDocument, baseOptions);
      }
export function useExpertDashboardAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertDashboardAdminQuery, ExpertDashboardAdminQueryVariables>) {
          return Apollo.useLazyQuery<ExpertDashboardAdminQuery, ExpertDashboardAdminQueryVariables>(ExpertDashboardAdminDocument, baseOptions);
        }
export type ExpertDashboardAdminQueryHookResult = ReturnType<typeof useExpertDashboardAdminQuery>;
export type ExpertDashboardAdminLazyQueryHookResult = ReturnType<typeof useExpertDashboardAdminLazyQuery>;
export type ExpertDashboardAdminQueryResult = Apollo.QueryResult<ExpertDashboardAdminQuery, ExpertDashboardAdminQueryVariables>;
export const GetExpertDocument = gql`
    query getExpert($id: ID!) {
  expert(id: $id) {
    id
    account {
      id
      state
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useGetExpertQuery__
 *
 * To run a query within a React component, call `useGetExpertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpertQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExpertQuery(baseOptions: Apollo.QueryHookOptions<GetExpertQuery, GetExpertQueryVariables>) {
        return Apollo.useQuery<GetExpertQuery, GetExpertQueryVariables>(GetExpertDocument, baseOptions);
      }
export function useGetExpertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpertQuery, GetExpertQueryVariables>) {
          return Apollo.useLazyQuery<GetExpertQuery, GetExpertQueryVariables>(GetExpertDocument, baseOptions);
        }
export type GetExpertQueryHookResult = ReturnType<typeof useGetExpertQuery>;
export type GetExpertLazyQueryHookResult = ReturnType<typeof useGetExpertLazyQuery>;
export type GetExpertQueryResult = Apollo.QueryResult<GetExpertQuery, GetExpertQueryVariables>;
export const UpdateExpertPaymentDocument = gql`
    mutation UpdateExpertPayment($input: UpdateExpertPaymentMutationInput!) {
  updateExpertPayment(input: $input) {
    expertPayment {
      id
    }
  }
}
    `;
export type UpdateExpertPaymentMutationFn = Apollo.MutationFunction<UpdateExpertPaymentMutation, UpdateExpertPaymentMutationVariables>;

/**
 * __useUpdateExpertPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateExpertPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpertPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpertPaymentMutation, { data, loading, error }] = useUpdateExpertPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpertPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpertPaymentMutation, UpdateExpertPaymentMutationVariables>) {
        return Apollo.useMutation<UpdateExpertPaymentMutation, UpdateExpertPaymentMutationVariables>(UpdateExpertPaymentDocument, baseOptions);
      }
export type UpdateExpertPaymentMutationHookResult = ReturnType<typeof useUpdateExpertPaymentMutation>;
export type UpdateExpertPaymentMutationResult = Apollo.MutationResult<UpdateExpertPaymentMutation>;
export type UpdateExpertPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateExpertPaymentMutation, UpdateExpertPaymentMutationVariables>;
export const ExpertPaymentDocument = gql`
    query ExpertPayment($id: ID!) {
  expertPayment(id: $id) {
    id
    orderItems {
      edges {
        node {
          id
          totalPrice
          order {
            id
            sale {
              id
              name
            }
          }
        }
      }
    }
    paid
    startAt
    endAt
    expertPaymentLines {
      edges {
        node {
          id
          amount
        }
      }
    }
    invoices {
      ...File
    }
    expert {
      id
      account {
        id
        lastName
        firstName
        bankInformation {
          iban
          bic
        }
      }
    }
  }
}
    ${FileFragmentDoc}`;

/**
 * __useExpertPaymentQuery__
 *
 * To run a query within a React component, call `useExpertPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpertPaymentQuery(baseOptions: Apollo.QueryHookOptions<ExpertPaymentQuery, ExpertPaymentQueryVariables>) {
        return Apollo.useQuery<ExpertPaymentQuery, ExpertPaymentQueryVariables>(ExpertPaymentDocument, baseOptions);
      }
export function useExpertPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertPaymentQuery, ExpertPaymentQueryVariables>) {
          return Apollo.useLazyQuery<ExpertPaymentQuery, ExpertPaymentQueryVariables>(ExpertPaymentDocument, baseOptions);
        }
export type ExpertPaymentQueryHookResult = ReturnType<typeof useExpertPaymentQuery>;
export type ExpertPaymentLazyQueryHookResult = ReturnType<typeof useExpertPaymentLazyQuery>;
export type ExpertPaymentQueryResult = Apollo.QueryResult<ExpertPaymentQuery, ExpertPaymentQueryVariables>;
export const ExpertPaymentListDocument = gql`
    query ExpertPaymentList {
  unpaidExpertPayments: expertPayments(
    where: {paid: {equalTo: false}, expertStatementPaymentId: {isBlank: true}}
    first: 1
  ) {
    totalCount
  }
  unpaidExpertStatementPayments: expertStatementPayments(
    where: {paid: {equalTo: false}}
    first: 1
  ) {
    totalCount
  }
  allExpertPayments: expertPayments(
    where: {expertStatementPaymentId: {isBlank: true}}
    first: 1
  ) {
    totalCount
  }
}
    `;

/**
 * __useExpertPaymentListQuery__
 *
 * To run a query within a React component, call `useExpertPaymentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertPaymentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertPaymentListQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpertPaymentListQuery(baseOptions?: Apollo.QueryHookOptions<ExpertPaymentListQuery, ExpertPaymentListQueryVariables>) {
        return Apollo.useQuery<ExpertPaymentListQuery, ExpertPaymentListQueryVariables>(ExpertPaymentListDocument, baseOptions);
      }
export function useExpertPaymentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertPaymentListQuery, ExpertPaymentListQueryVariables>) {
          return Apollo.useLazyQuery<ExpertPaymentListQuery, ExpertPaymentListQueryVariables>(ExpertPaymentListDocument, baseOptions);
        }
export type ExpertPaymentListQueryHookResult = ReturnType<typeof useExpertPaymentListQuery>;
export type ExpertPaymentListLazyQueryHookResult = ReturnType<typeof useExpertPaymentListLazyQuery>;
export type ExpertPaymentListQueryResult = Apollo.QueryResult<ExpertPaymentListQuery, ExpertPaymentListQueryVariables>;
export const ExpertStatementPaymentDocument = gql`
    query ExpertStatementPayment($id: ID!) {
  expertStatementPayment(id: $id) {
    id
    expert {
      id
      account {
        firstName
        lastName
        bankInformation {
          iban
          bic
        }
      }
    }
    startAt
    endAt
    paymentDate
    paid
    totalAmount
    totalLinesCount
    totalSalesCount
    invoices {
      imageUrl
      filename
      blobId
    }
    createdAt
    updatedAt
    expertPayments {
      edges {
        node {
          id
          sale {
            id
            name
          }
          expertPaymentLines {
            edges {
              node {
                amount
              }
            }
          }
          orderItems {
            edges {
              node {
                id
                totalPrice
                order {
                  createdAt
                }
                item {
                  id
                  title
                  firstImage {
                    imageUrl
                  }
                  finalPrice
                  lowEstimatedPrice
                  highEstimatedPrice
                }
              }
            }
          }
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useExpertStatementPaymentQuery__
 *
 * To run a query within a React component, call `useExpertStatementPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertStatementPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertStatementPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpertStatementPaymentQuery(baseOptions: Apollo.QueryHookOptions<ExpertStatementPaymentQuery, ExpertStatementPaymentQueryVariables>) {
        return Apollo.useQuery<ExpertStatementPaymentQuery, ExpertStatementPaymentQueryVariables>(ExpertStatementPaymentDocument, baseOptions);
      }
export function useExpertStatementPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertStatementPaymentQuery, ExpertStatementPaymentQueryVariables>) {
          return Apollo.useLazyQuery<ExpertStatementPaymentQuery, ExpertStatementPaymentQueryVariables>(ExpertStatementPaymentDocument, baseOptions);
        }
export type ExpertStatementPaymentQueryHookResult = ReturnType<typeof useExpertStatementPaymentQuery>;
export type ExpertStatementPaymentLazyQueryHookResult = ReturnType<typeof useExpertStatementPaymentLazyQuery>;
export type ExpertStatementPaymentQueryResult = Apollo.QueryResult<ExpertStatementPaymentQuery, ExpertStatementPaymentQueryVariables>;
export const UpdateExpertStatementPaymentDocument = gql`
    mutation UpdateExpertStatementPayment($input: UpdateExpertStatementPaymentMutationInput!) {
  updateExpertStatementPayment(input: $input) {
    expertStatementPayment {
      id
      paid
      paymentDate
    }
    errors {
      fullMessages
    }
  }
}
    `;
export type UpdateExpertStatementPaymentMutationFn = Apollo.MutationFunction<UpdateExpertStatementPaymentMutation, UpdateExpertStatementPaymentMutationVariables>;

/**
 * __useUpdateExpertStatementPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateExpertStatementPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpertStatementPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpertStatementPaymentMutation, { data, loading, error }] = useUpdateExpertStatementPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpertStatementPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpertStatementPaymentMutation, UpdateExpertStatementPaymentMutationVariables>) {
        return Apollo.useMutation<UpdateExpertStatementPaymentMutation, UpdateExpertStatementPaymentMutationVariables>(UpdateExpertStatementPaymentDocument, baseOptions);
      }
export type UpdateExpertStatementPaymentMutationHookResult = ReturnType<typeof useUpdateExpertStatementPaymentMutation>;
export type UpdateExpertStatementPaymentMutationResult = Apollo.MutationResult<UpdateExpertStatementPaymentMutation>;
export type UpdateExpertStatementPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateExpertStatementPaymentMutation, UpdateExpertStatementPaymentMutationVariables>;
export const GetExpertsPerfAnalyticsDocument = gql`
    query getExpertsPerfAnalytics($from: ISO8601DateTime!, $to: ISO8601DateTime!, $compareTo: CompareToEnum!, $expertId: ID, $categoryId: ID) {
  kpis: analytics(
    scope: {from: $from, to: $to, expertId: $expertId, categoryId: $categoryId}
    metrics: [EXPERT_VOLUME, AVG_PROCESSING_DELAY, EXPERT_REFUSAL_RATE, EXPERT_ACCEPTANCE_RATE, EXPERT_QUALITY_LOOP, EXPERT_CURRENT_LOAD]
    compareTo: $compareTo
  ) {
    metrics {
      name
      value
      comparison {
        previousValue
        delta
        deltaPercentage
      }
    }
  }
  byExperts: analytics(
    scope: {from: $from, to: $to, expertId: $expertId, categoryId: $categoryId}
    metrics: [EXPERT_VOLUME, AVG_PROCESSING_DELAY, EXPERT_REFUSAL_RATE, EXPERT_ACCEPTANCE_RATE, EXPERT_QUALITY_LOOP, EXPERT_CURRENT_LOAD]
    breakdown: {dimension: EXPERT}
  ) {
    metrics {
      name
      breakdown {
        name
        dimensionId
        value
      }
    }
  }
  volume: analytics(
    scope: {from: $from, to: $to, expertId: $expertId, categoryId: $categoryId}
    metrics: [EXPERT_VOLUME]
    timeSeries: {granularity: MONTH}
  ) {
    metrics {
      name
      timeSeries {
        ...AnalyticsVolumeAndDelayChartCard
      }
    }
  }
  delay: analytics(
    scope: {from: $from, to: $to, expertId: $expertId, categoryId: $categoryId}
    metrics: [AVG_PROCESSING_DELAY]
    timeSeries: {granularity: MONTH}
  ) {
    metrics {
      name
      timeSeries {
        ...AnalyticsVolumeAndDelayChartCard
      }
    }
  }
}
    ${AnalyticsVolumeAndDelayChartCardFragmentDoc}`;

/**
 * __useGetExpertsPerfAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetExpertsPerfAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpertsPerfAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpertsPerfAnalyticsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      compareTo: // value for 'compareTo'
 *      expertId: // value for 'expertId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetExpertsPerfAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetExpertsPerfAnalyticsQuery, GetExpertsPerfAnalyticsQueryVariables>) {
        return Apollo.useQuery<GetExpertsPerfAnalyticsQuery, GetExpertsPerfAnalyticsQueryVariables>(GetExpertsPerfAnalyticsDocument, baseOptions);
      }
export function useGetExpertsPerfAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpertsPerfAnalyticsQuery, GetExpertsPerfAnalyticsQueryVariables>) {
          return Apollo.useLazyQuery<GetExpertsPerfAnalyticsQuery, GetExpertsPerfAnalyticsQueryVariables>(GetExpertsPerfAnalyticsDocument, baseOptions);
        }
export type GetExpertsPerfAnalyticsQueryHookResult = ReturnType<typeof useGetExpertsPerfAnalyticsQuery>;
export type GetExpertsPerfAnalyticsLazyQueryHookResult = ReturnType<typeof useGetExpertsPerfAnalyticsLazyQuery>;
export type GetExpertsPerfAnalyticsQueryResult = Apollo.QueryResult<GetExpertsPerfAnalyticsQuery, GetExpertsPerfAnalyticsQueryVariables>;
export const CreateFavoriteImportDocument = gql`
    mutation CreateFavoriteImport($attributes: CreateFavoritesRainworxImportInput!) {
  createFavoritesRainworxImport(input: {attributes: $attributes}) {
    clientMutationId
    import {
      id
    }
  }
}
    `;
export type CreateFavoriteImportMutationFn = Apollo.MutationFunction<CreateFavoriteImportMutation, CreateFavoriteImportMutationVariables>;

/**
 * __useCreateFavoriteImportMutation__
 *
 * To run a mutation, you first call `useCreateFavoriteImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoriteImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoriteImportMutation, { data, loading, error }] = useCreateFavoriteImportMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateFavoriteImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateFavoriteImportMutation, CreateFavoriteImportMutationVariables>) {
        return Apollo.useMutation<CreateFavoriteImportMutation, CreateFavoriteImportMutationVariables>(CreateFavoriteImportDocument, baseOptions);
      }
export type CreateFavoriteImportMutationHookResult = ReturnType<typeof useCreateFavoriteImportMutation>;
export type CreateFavoriteImportMutationResult = Apollo.MutationResult<CreateFavoriteImportMutation>;
export type CreateFavoriteImportMutationOptions = Apollo.BaseMutationOptions<CreateFavoriteImportMutation, CreateFavoriteImportMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email) {
    success
    errors {
      details
      message
    }
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, baseOptions);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GetFunnelPerfAnalyticsDocument = gql`
    query getFunnelPerfAnalytics($from: ISO8601DateTime!, $to: ISO8601DateTime!, $compareTo: CompareToEnum!, $vendorId: ID, $categoryId: ID) {
  kpis: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [REFUSAL_RATE, ACCEPTANCE_RATE, ONSALE_TO_SOLD_RATE, END_TO_END_DELAY]
    compareTo: $compareTo
  ) {
    metrics {
      name
      value
      comparison {
        previousValue
        delta
        deltaPercentage
      }
    }
  }
  funnelStates: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [FUNNEL, STAGE_DELAYS]
  ) {
    metrics {
      name
      value
    }
  }
  saleRateByAttempt: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [SALE_RATE_BY_ATTEMPT, UNSOLD_COUNT_DISTRIBUTION]
  ) {
    metrics {
      name
      value
    }
  }
  unsoldFunnel: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [RESALE_BREAKDOWN]
  ) {
    metrics {
      name
      value
    }
  }
}
    `;

/**
 * __useGetFunnelPerfAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetFunnelPerfAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunnelPerfAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunnelPerfAnalyticsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      compareTo: // value for 'compareTo'
 *      vendorId: // value for 'vendorId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetFunnelPerfAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetFunnelPerfAnalyticsQuery, GetFunnelPerfAnalyticsQueryVariables>) {
        return Apollo.useQuery<GetFunnelPerfAnalyticsQuery, GetFunnelPerfAnalyticsQueryVariables>(GetFunnelPerfAnalyticsDocument, baseOptions);
      }
export function useGetFunnelPerfAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunnelPerfAnalyticsQuery, GetFunnelPerfAnalyticsQueryVariables>) {
          return Apollo.useLazyQuery<GetFunnelPerfAnalyticsQuery, GetFunnelPerfAnalyticsQueryVariables>(GetFunnelPerfAnalyticsDocument, baseOptions);
        }
export type GetFunnelPerfAnalyticsQueryHookResult = ReturnType<typeof useGetFunnelPerfAnalyticsQuery>;
export type GetFunnelPerfAnalyticsLazyQueryHookResult = ReturnType<typeof useGetFunnelPerfAnalyticsLazyQuery>;
export type GetFunnelPerfAnalyticsQueryResult = Apollo.QueryResult<GetFunnelPerfAnalyticsQuery, GetFunnelPerfAnalyticsQueryVariables>;
export const ImportPaymentDocument = gql`
    query ImportPayment($id: ID!) {
  importPayment(id: $id) {
    ...ImportPayment
    account {
      ...ImportAccount
      bankInformation {
        iban
        bic
      }
    }
  }
}
    ${ImportPaymentFragmentDoc}
${ImportAccountFragmentDoc}`;

/**
 * __useImportPaymentQuery__
 *
 * To run a query within a React component, call `useImportPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportPaymentQuery(baseOptions: Apollo.QueryHookOptions<ImportPaymentQuery, ImportPaymentQueryVariables>) {
        return Apollo.useQuery<ImportPaymentQuery, ImportPaymentQueryVariables>(ImportPaymentDocument, baseOptions);
      }
export function useImportPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportPaymentQuery, ImportPaymentQueryVariables>) {
          return Apollo.useLazyQuery<ImportPaymentQuery, ImportPaymentQueryVariables>(ImportPaymentDocument, baseOptions);
        }
export type ImportPaymentQueryHookResult = ReturnType<typeof useImportPaymentQuery>;
export type ImportPaymentLazyQueryHookResult = ReturnType<typeof useImportPaymentLazyQuery>;
export type ImportPaymentQueryResult = Apollo.QueryResult<ImportPaymentQuery, ImportPaymentQueryVariables>;
export const UpdateImportPaymentDocument = gql`
    mutation UpdateImportPayment($input: UpdateImportPaymentMutationInput!) {
  updateImportPayment(input: $input) {
    importPayment {
      id
    }
  }
}
    `;
export type UpdateImportPaymentMutationFn = Apollo.MutationFunction<UpdateImportPaymentMutation, UpdateImportPaymentMutationVariables>;

/**
 * __useUpdateImportPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateImportPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImportPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImportPaymentMutation, { data, loading, error }] = useUpdateImportPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImportPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImportPaymentMutation, UpdateImportPaymentMutationVariables>) {
        return Apollo.useMutation<UpdateImportPaymentMutation, UpdateImportPaymentMutationVariables>(UpdateImportPaymentDocument, baseOptions);
      }
export type UpdateImportPaymentMutationHookResult = ReturnType<typeof useUpdateImportPaymentMutation>;
export type UpdateImportPaymentMutationResult = Apollo.MutationResult<UpdateImportPaymentMutation>;
export type UpdateImportPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateImportPaymentMutation, UpdateImportPaymentMutationVariables>;
export const ImportPaymentListDocument = gql`
    query ImportPaymentList {
  unpaidImportPayments: importPayments(
    where: {paid: {equalTo: false}, importStatementPaymentId: {isBlank: true}}
    first: 1
  ) {
    totalCount
  }
  unpaidImportStatementPayments: importStatementPayments(
    where: {paid: {equalTo: false}}
    first: 1
  ) {
    totalCount
  }
  allImportPayments: importPayments(
    where: {importStatementPaymentId: {isBlank: true}}
    first: 1
  ) {
    totalCount
  }
}
    `;

/**
 * __useImportPaymentListQuery__
 *
 * To run a query within a React component, call `useImportPaymentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportPaymentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportPaymentListQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportPaymentListQuery(baseOptions?: Apollo.QueryHookOptions<ImportPaymentListQuery, ImportPaymentListQueryVariables>) {
        return Apollo.useQuery<ImportPaymentListQuery, ImportPaymentListQueryVariables>(ImportPaymentListDocument, baseOptions);
      }
export function useImportPaymentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportPaymentListQuery, ImportPaymentListQueryVariables>) {
          return Apollo.useLazyQuery<ImportPaymentListQuery, ImportPaymentListQueryVariables>(ImportPaymentListDocument, baseOptions);
        }
export type ImportPaymentListQueryHookResult = ReturnType<typeof useImportPaymentListQuery>;
export type ImportPaymentListLazyQueryHookResult = ReturnType<typeof useImportPaymentListLazyQuery>;
export type ImportPaymentListQueryResult = Apollo.QueryResult<ImportPaymentListQuery, ImportPaymentListQueryVariables>;
export const ImportStatementPaymentDocument = gql`
    query ImportStatementPayment($id: ID!) {
  importStatementPayment(id: $id) {
    id
    account {
      firstName
      lastName
    }
    startAt
    endAt
    paymentDate
    paid
    totalAmount
    totalLinesCount
    totalSalesCount
    invoices {
      imageUrl
      filename
      blobId
    }
    createdAt
    updatedAt
    importPayments {
      edges {
        node {
          id
          sale {
            id
            name
          }
          importPaymentLines {
            edges {
              node {
                amount
                feePercentage
              }
            }
          }
          orderItems {
            edges {
              node {
                id
                totalPrice
                order {
                  createdAt
                }
                item {
                  id
                  title
                  firstImage {
                    imageUrl
                  }
                  finalPrice
                  lowEstimatedPrice
                  highEstimatedPrice
                }
              }
            }
          }
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useImportStatementPaymentQuery__
 *
 * To run a query within a React component, call `useImportStatementPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportStatementPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportStatementPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportStatementPaymentQuery(baseOptions: Apollo.QueryHookOptions<ImportStatementPaymentQuery, ImportStatementPaymentQueryVariables>) {
        return Apollo.useQuery<ImportStatementPaymentQuery, ImportStatementPaymentQueryVariables>(ImportStatementPaymentDocument, baseOptions);
      }
export function useImportStatementPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportStatementPaymentQuery, ImportStatementPaymentQueryVariables>) {
          return Apollo.useLazyQuery<ImportStatementPaymentQuery, ImportStatementPaymentQueryVariables>(ImportStatementPaymentDocument, baseOptions);
        }
export type ImportStatementPaymentQueryHookResult = ReturnType<typeof useImportStatementPaymentQuery>;
export type ImportStatementPaymentLazyQueryHookResult = ReturnType<typeof useImportStatementPaymentLazyQuery>;
export type ImportStatementPaymentQueryResult = Apollo.QueryResult<ImportStatementPaymentQuery, ImportStatementPaymentQueryVariables>;
export const UpdateImportStatementPaymentDocument = gql`
    mutation UpdateImportStatementPayment($input: UpdateImportStatementPaymentMutationInput!) {
  updateImportStatementPayment(input: $input) {
    importStatementPayment {
      id
      paid
      paymentDate
    }
    errors {
      fullMessages
    }
  }
}
    `;
export type UpdateImportStatementPaymentMutationFn = Apollo.MutationFunction<UpdateImportStatementPaymentMutation, UpdateImportStatementPaymentMutationVariables>;

/**
 * __useUpdateImportStatementPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateImportStatementPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImportStatementPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImportStatementPaymentMutation, { data, loading, error }] = useUpdateImportStatementPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImportStatementPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImportStatementPaymentMutation, UpdateImportStatementPaymentMutationVariables>) {
        return Apollo.useMutation<UpdateImportStatementPaymentMutation, UpdateImportStatementPaymentMutationVariables>(UpdateImportStatementPaymentDocument, baseOptions);
      }
export type UpdateImportStatementPaymentMutationHookResult = ReturnType<typeof useUpdateImportStatementPaymentMutation>;
export type UpdateImportStatementPaymentMutationResult = Apollo.MutationResult<UpdateImportStatementPaymentMutation>;
export type UpdateImportStatementPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateImportStatementPaymentMutation, UpdateImportStatementPaymentMutationVariables>;
export const ItemHistoryDocument = gql`
    query ItemHistory($id: ID!) {
  item(id: $id) {
    id
    salePassages {
      ...ItemHistoryPassage
    }
    itemSaleHistories {
      ...ItemHistorySaleEvent
    }
    itemOrderHistories {
      ...ItemHistoryOrderEvent
    }
  }
}
    ${ItemHistoryPassageFragmentDoc}
${ItemHistorySaleEventFragmentDoc}
${ItemHistoryOrderEventFragmentDoc}`;

/**
 * __useItemHistoryQuery__
 *
 * To run a query within a React component, call `useItemHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useItemHistoryQuery(baseOptions: Apollo.QueryHookOptions<ItemHistoryQuery, ItemHistoryQueryVariables>) {
        return Apollo.useQuery<ItemHistoryQuery, ItemHistoryQueryVariables>(ItemHistoryDocument, baseOptions);
      }
export function useItemHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemHistoryQuery, ItemHistoryQueryVariables>) {
          return Apollo.useLazyQuery<ItemHistoryQuery, ItemHistoryQueryVariables>(ItemHistoryDocument, baseOptions);
        }
export type ItemHistoryQueryHookResult = ReturnType<typeof useItemHistoryQuery>;
export type ItemHistoryLazyQueryHookResult = ReturnType<typeof useItemHistoryLazyQuery>;
export type ItemHistoryQueryResult = Apollo.QueryResult<ItemHistoryQuery, ItemHistoryQueryVariables>;
export const LogInDocument = gql`
    mutation logIn($email: String!, $password: String!) {
  customSignIn(email: $email, password: $password, rememberMe: false) {
    success
    sessionToken
    user {
      id
      email
      firstName
      lastName
      lastAccountTypeUsed
      accounts {
        edges {
          node {
            id
            accountable {
              ... on Expert {
                id
              }
              ... on Vendor {
                id
              }
              __typename
            }
          }
        }
      }
    }
  }
}
    `;
export type LogInMutationFn = Apollo.MutationFunction<LogInMutation, LogInMutationVariables>;

/**
 * __useLogInMutation__
 *
 * To run a mutation, you first call `useLogInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logInMutation, { data, loading, error }] = useLogInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLogInMutation(baseOptions?: Apollo.MutationHookOptions<LogInMutation, LogInMutationVariables>) {
        return Apollo.useMutation<LogInMutation, LogInMutationVariables>(LogInDocument, baseOptions);
      }
export type LogInMutationHookResult = ReturnType<typeof useLogInMutation>;
export type LogInMutationResult = Apollo.MutationResult<LogInMutation>;
export type LogInMutationOptions = Apollo.BaseMutationOptions<LogInMutation, LogInMutationVariables>;
export const GetMarginAndGmvAnalyticsDocument = gql`
    query getMarginAndGmvAnalytics($from: ISO8601DateTime!, $to: ISO8601DateTime!, $fromN1: ISO8601DateTime!, $toN1: ISO8601DateTime!, $compareTo: CompareToEnum!, $vendorId: ID, $categoryId: ID) {
  kpis: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [GMV, DODECADE_MARGIN, TAKE_RATE, SHIPPING_INSURANCE_COLLECTED]
    compareTo: $compareTo
  ) {
    metrics {
      name
      value
      comparison {
        previousValue
        delta
        deltaPercentage
      }
    }
  }
  gmv: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [GMV]
    timeSeries: {granularity: MONTH}
  ) {
    metrics {
      name
      timeSeries {
        ...AnalyticsRevenueAndMarginChartCard
      }
    }
  }
  margin: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [DODECADE_MARGIN]
    timeSeries: {granularity: MONTH}
  ) {
    metrics {
      name
      timeSeries {
        ...AnalyticsRevenueAndMarginChartCard
      }
    }
  }
  gmvN1: analytics(
    scope: {from: $fromN1, to: $toN1, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [GMV]
    timeSeries: {granularity: MONTH}
  ) {
    metrics {
      name
      timeSeries {
        ...AnalyticsRevenueAndMarginChartCard
      }
    }
  }
  topVendors: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [TOP_VENDORS]
    breakdown: {dimension: VENDOR}
  ) {
    metrics {
      name
      breakdown {
        dimensionId
        name
        value
      }
    }
  }
  unpaidRate: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [UNPAID_RATE]
    breakdown: {dimension: CATEGORY}
  ) {
    metrics {
      name
      value
      breakdown {
        dimensionId
        name
        value
      }
    }
  }
  unsoldRate: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [UNSOLD_RATE]
    breakdown: {dimension: CATEGORY}
  ) {
    metrics {
      name
      value
      breakdown {
        dimensionId
        name
        value
      }
    }
  }
  revenueBreakdown: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [REVENUE_BREAKDOWN]
  ) {
    metrics {
      name
      value
    }
  }
}
    ${AnalyticsRevenueAndMarginChartCardFragmentDoc}`;

/**
 * __useGetMarginAndGmvAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetMarginAndGmvAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarginAndGmvAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarginAndGmvAnalyticsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      fromN1: // value for 'fromN1'
 *      toN1: // value for 'toN1'
 *      compareTo: // value for 'compareTo'
 *      vendorId: // value for 'vendorId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetMarginAndGmvAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetMarginAndGmvAnalyticsQuery, GetMarginAndGmvAnalyticsQueryVariables>) {
        return Apollo.useQuery<GetMarginAndGmvAnalyticsQuery, GetMarginAndGmvAnalyticsQueryVariables>(GetMarginAndGmvAnalyticsDocument, baseOptions);
      }
export function useGetMarginAndGmvAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarginAndGmvAnalyticsQuery, GetMarginAndGmvAnalyticsQueryVariables>) {
          return Apollo.useLazyQuery<GetMarginAndGmvAnalyticsQuery, GetMarginAndGmvAnalyticsQueryVariables>(GetMarginAndGmvAnalyticsDocument, baseOptions);
        }
export type GetMarginAndGmvAnalyticsQueryHookResult = ReturnType<typeof useGetMarginAndGmvAnalyticsQuery>;
export type GetMarginAndGmvAnalyticsLazyQueryHookResult = ReturnType<typeof useGetMarginAndGmvAnalyticsLazyQuery>;
export type GetMarginAndGmvAnalyticsQueryResult = Apollo.QueryResult<GetMarginAndGmvAnalyticsQuery, GetMarginAndGmvAnalyticsQueryVariables>;
export const CreateMyAlertsDesireImportDocument = gql`
    mutation CreateMyAlertsDesireImport($attributes: CreateMyAlertsDesiresImportInput!) {
  createMyAlertsDesiresImport(input: {attributes: $attributes}) {
    clientMutationId
    import {
      id
    }
  }
}
    `;
export type CreateMyAlertsDesireImportMutationFn = Apollo.MutationFunction<CreateMyAlertsDesireImportMutation, CreateMyAlertsDesireImportMutationVariables>;

/**
 * __useCreateMyAlertsDesireImportMutation__
 *
 * To run a mutation, you first call `useCreateMyAlertsDesireImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyAlertsDesireImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyAlertsDesireImportMutation, { data, loading, error }] = useCreateMyAlertsDesireImportMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateMyAlertsDesireImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyAlertsDesireImportMutation, CreateMyAlertsDesireImportMutationVariables>) {
        return Apollo.useMutation<CreateMyAlertsDesireImportMutation, CreateMyAlertsDesireImportMutationVariables>(CreateMyAlertsDesireImportDocument, baseOptions);
      }
export type CreateMyAlertsDesireImportMutationHookResult = ReturnType<typeof useCreateMyAlertsDesireImportMutation>;
export type CreateMyAlertsDesireImportMutationResult = Apollo.MutationResult<CreateMyAlertsDesireImportMutation>;
export type CreateMyAlertsDesireImportMutationOptions = Apollo.BaseMutationOptions<CreateMyAlertsDesireImportMutation, CreateMyAlertsDesireImportMutationVariables>;
export const NewsletterStatsDocument = gql`
    query NewsletterStats($limit: Int = 30, $hours: Int = 72) {
  newsletterCampaigns(limit: $limit) {
    id
    createdAt
    newsletterType
    subject
    sale {
      id
      name
    }
    stats {
      sent
      opened
      clicked
      bounced
      spam
      unsub
      openRate
      clickRate
    }
  }
  newsletterHourlyStats(hours: $hours) {
    hour
    sent
    opened
    clicked
  }
}
    `;

/**
 * __useNewsletterStatsQuery__
 *
 * To run a query within a React component, call `useNewsletterStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterStatsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useNewsletterStatsQuery(baseOptions?: Apollo.QueryHookOptions<NewsletterStatsQuery, NewsletterStatsQueryVariables>) {
        return Apollo.useQuery<NewsletterStatsQuery, NewsletterStatsQueryVariables>(NewsletterStatsDocument, baseOptions);
      }
export function useNewsletterStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsletterStatsQuery, NewsletterStatsQueryVariables>) {
          return Apollo.useLazyQuery<NewsletterStatsQuery, NewsletterStatsQueryVariables>(NewsletterStatsDocument, baseOptions);
        }
export type NewsletterStatsQueryHookResult = ReturnType<typeof useNewsletterStatsQuery>;
export type NewsletterStatsLazyQueryHookResult = ReturnType<typeof useNewsletterStatsLazyQuery>;
export type NewsletterStatsQueryResult = Apollo.QueryResult<NewsletterStatsQuery, NewsletterStatsQueryVariables>;
export const UpdateUserOnBoardingDocument = gql`
    mutation updateUserOnBoarding($userId: ID!, $firstName: String!, $lastName: String!) {
  updateUser(
    input: {id: $userId, attributes: {firstName: $firstName, lastName: $lastName}}
  ) {
    id
    firstName
    lastName
  }
}
    `;
export type UpdateUserOnBoardingMutationFn = Apollo.MutationFunction<UpdateUserOnBoardingMutation, UpdateUserOnBoardingMutationVariables>;

/**
 * __useUpdateUserOnBoardingMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnBoardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnBoardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnBoardingMutation, { data, loading, error }] = useUpdateUserOnBoardingMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateUserOnBoardingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnBoardingMutation, UpdateUserOnBoardingMutationVariables>) {
        return Apollo.useMutation<UpdateUserOnBoardingMutation, UpdateUserOnBoardingMutationVariables>(UpdateUserOnBoardingDocument, baseOptions);
      }
export type UpdateUserOnBoardingMutationHookResult = ReturnType<typeof useUpdateUserOnBoardingMutation>;
export type UpdateUserOnBoardingMutationResult = Apollo.MutationResult<UpdateUserOnBoardingMutation>;
export type UpdateUserOnBoardingMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnBoardingMutation, UpdateUserOnBoardingMutationVariables>;
export const CreateAccountDocument = gql`
    mutation createAccount($attributes: CreateAccountInput!) {
  createAccount(input: {attributes: $attributes}) {
    account {
      id
      firstName
      lastName
      email
      accountable {
        ... on Expert {
          id
        }
        ... on Vendor {
          id
        }
        ... on Buyer {
          id
        }
        ... on Writer {
          id
        }
        __typename
      }
    }
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, baseOptions);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const PickupRequestContextDocument = gql`
    query PickupRequestContext {
  viewer(accountableType: "Vendor") {
    id
    accounts(accountableType: "Vendor") {
      edges {
        node {
          id
          accountable {
            ... on Vendor {
              id
              shippingOptions
              ...VendorDefaultAddresses
            }
          }
        }
      }
    }
  }
  availablePickupLabels(first: 1) {
    totalCount
  }
}
    ${VendorDefaultAddressesFragmentDoc}`;

/**
 * __usePickupRequestContextQuery__
 *
 * To run a query within a React component, call `usePickupRequestContextQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickupRequestContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickupRequestContextQuery({
 *   variables: {
 *   },
 * });
 */
export function usePickupRequestContextQuery(baseOptions?: Apollo.QueryHookOptions<PickupRequestContextQuery, PickupRequestContextQueryVariables>) {
        return Apollo.useQuery<PickupRequestContextQuery, PickupRequestContextQueryVariables>(PickupRequestContextDocument, baseOptions);
      }
export function usePickupRequestContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickupRequestContextQuery, PickupRequestContextQueryVariables>) {
          return Apollo.useLazyQuery<PickupRequestContextQuery, PickupRequestContextQueryVariables>(PickupRequestContextDocument, baseOptions);
        }
export type PickupRequestContextQueryHookResult = ReturnType<typeof usePickupRequestContextQuery>;
export type PickupRequestContextLazyQueryHookResult = ReturnType<typeof usePickupRequestContextLazyQuery>;
export type PickupRequestContextQueryResult = Apollo.QueryResult<PickupRequestContextQuery, PickupRequestContextQueryVariables>;
export const CreateStripeAccountSessionDocument = gql`
    mutation CreateStripeAccountSession($input: CreateStripeAccountSessionMutationInput!) {
  createStripeAccountSession(input: $input) {
    clientSecret
    errors
  }
}
    `;
export type CreateStripeAccountSessionMutationFn = Apollo.MutationFunction<CreateStripeAccountSessionMutation, CreateStripeAccountSessionMutationVariables>;

/**
 * __useCreateStripeAccountSessionMutation__
 *
 * To run a mutation, you first call `useCreateStripeAccountSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeAccountSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeAccountSessionMutation, { data, loading, error }] = useCreateStripeAccountSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStripeAccountSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeAccountSessionMutation, CreateStripeAccountSessionMutationVariables>) {
        return Apollo.useMutation<CreateStripeAccountSessionMutation, CreateStripeAccountSessionMutationVariables>(CreateStripeAccountSessionDocument, baseOptions);
      }
export type CreateStripeAccountSessionMutationHookResult = ReturnType<typeof useCreateStripeAccountSessionMutation>;
export type CreateStripeAccountSessionMutationResult = Apollo.MutationResult<CreateStripeAccountSessionMutation>;
export type CreateStripeAccountSessionMutationOptions = Apollo.BaseMutationOptions<CreateStripeAccountSessionMutation, CreateStripeAccountSessionMutationVariables>;
export const BusinessIntroducersDocument = gql`
    query BusinessIntroducers($where: BusinessIntroducerFilter, $first: Int = 50) {
  businessIntroducers(
    where: $where
    orderBy: {attribute: "createdAt", direction: "asc"}
    first: $first
  ) {
    ...BusinessIntroducerEdges
  }
}
    ${BusinessIntroducerEdgesFragmentDoc}`;

/**
 * __useBusinessIntroducersQuery__
 *
 * To run a query within a React component, call `useBusinessIntroducersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessIntroducersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessIntroducersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useBusinessIntroducersQuery(baseOptions?: Apollo.QueryHookOptions<BusinessIntroducersQuery, BusinessIntroducersQueryVariables>) {
        return Apollo.useQuery<BusinessIntroducersQuery, BusinessIntroducersQueryVariables>(BusinessIntroducersDocument, baseOptions);
      }
export function useBusinessIntroducersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessIntroducersQuery, BusinessIntroducersQueryVariables>) {
          return Apollo.useLazyQuery<BusinessIntroducersQuery, BusinessIntroducersQueryVariables>(BusinessIntroducersDocument, baseOptions);
        }
export type BusinessIntroducersQueryHookResult = ReturnType<typeof useBusinessIntroducersQuery>;
export type BusinessIntroducersLazyQueryHookResult = ReturnType<typeof useBusinessIntroducersLazyQuery>;
export type BusinessIntroducersQueryResult = Apollo.QueryResult<BusinessIntroducersQuery, BusinessIntroducersQueryVariables>;
export const CreateBusinessIntroducerDocument = gql`
    mutation CreateBusinessIntroducer($input: CreateBusinessIntroducerMutationInput!) {
  createBusinessIntroducer(input: $input) {
    businessIntroducer {
      ...BusinessIntroducer
    }
  }
}
    ${BusinessIntroducerFragmentDoc}`;
export type CreateBusinessIntroducerMutationFn = Apollo.MutationFunction<CreateBusinessIntroducerMutation, CreateBusinessIntroducerMutationVariables>;

/**
 * __useCreateBusinessIntroducerMutation__
 *
 * To run a mutation, you first call `useCreateBusinessIntroducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessIntroducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessIntroducerMutation, { data, loading, error }] = useCreateBusinessIntroducerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBusinessIntroducerMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessIntroducerMutation, CreateBusinessIntroducerMutationVariables>) {
        return Apollo.useMutation<CreateBusinessIntroducerMutation, CreateBusinessIntroducerMutationVariables>(CreateBusinessIntroducerDocument, baseOptions);
      }
export type CreateBusinessIntroducerMutationHookResult = ReturnType<typeof useCreateBusinessIntroducerMutation>;
export type CreateBusinessIntroducerMutationResult = Apollo.MutationResult<CreateBusinessIntroducerMutation>;
export type CreateBusinessIntroducerMutationOptions = Apollo.BaseMutationOptions<CreateBusinessIntroducerMutation, CreateBusinessIntroducerMutationVariables>;
export const UpdateBusinessIntroducerDocument = gql`
    mutation UpdateBusinessIntroducer($input: UpdateBusinessIntroducerMutationInput!) {
  updateBusinessIntroducer(input: $input) {
    businessIntroducer {
      ...BusinessIntroducer
    }
  }
}
    ${BusinessIntroducerFragmentDoc}`;
export type UpdateBusinessIntroducerMutationFn = Apollo.MutationFunction<UpdateBusinessIntroducerMutation, UpdateBusinessIntroducerMutationVariables>;

/**
 * __useUpdateBusinessIntroducerMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessIntroducerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessIntroducerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessIntroducerMutation, { data, loading, error }] = useUpdateBusinessIntroducerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessIntroducerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessIntroducerMutation, UpdateBusinessIntroducerMutationVariables>) {
        return Apollo.useMutation<UpdateBusinessIntroducerMutation, UpdateBusinessIntroducerMutationVariables>(UpdateBusinessIntroducerDocument, baseOptions);
      }
export type UpdateBusinessIntroducerMutationHookResult = ReturnType<typeof useUpdateBusinessIntroducerMutation>;
export type UpdateBusinessIntroducerMutationResult = Apollo.MutationResult<UpdateBusinessIntroducerMutation>;
export type UpdateBusinessIntroducerMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessIntroducerMutation, UpdateBusinessIntroducerMutationVariables>;
export const ThirdPartyIntroducersDocument = gql`
    query ThirdPartyIntroducers($where: ThirdPartyIntroducerFilter, $first: Int = 50) {
  thirdPartyIntroducers(
    where: $where
    orderBy: {attribute: "createdAt", direction: "asc"}
    first: $first
  ) {
    ...ThirdPartyIntroducerEdges
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${ThirdPartyIntroducerEdgesFragmentDoc}`;

/**
 * __useThirdPartyIntroducersQuery__
 *
 * To run a query within a React component, call `useThirdPartyIntroducersQuery` and pass it any options that fit your needs.
 * When your component renders, `useThirdPartyIntroducersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThirdPartyIntroducersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useThirdPartyIntroducersQuery(baseOptions?: Apollo.QueryHookOptions<ThirdPartyIntroducersQuery, ThirdPartyIntroducersQueryVariables>) {
        return Apollo.useQuery<ThirdPartyIntroducersQuery, ThirdPartyIntroducersQueryVariables>(ThirdPartyIntroducersDocument, baseOptions);
      }
export function useThirdPartyIntroducersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThirdPartyIntroducersQuery, ThirdPartyIntroducersQueryVariables>) {
          return Apollo.useLazyQuery<ThirdPartyIntroducersQuery, ThirdPartyIntroducersQueryVariables>(ThirdPartyIntroducersDocument, baseOptions);
        }
export type ThirdPartyIntroducersQueryHookResult = ReturnType<typeof useThirdPartyIntroducersQuery>;
export type ThirdPartyIntroducersLazyQueryHookResult = ReturnType<typeof useThirdPartyIntroducersLazyQuery>;
export type ThirdPartyIntroducersQueryResult = Apollo.QueryResult<ThirdPartyIntroducersQuery, ThirdPartyIntroducersQueryVariables>;
export const ProjectIntroducerPaymentDocument = gql`
    query ProjectIntroducerPayment($id: ID!) {
  projectIntroducerPayment(id: $id) {
    id
    startAt
    endAt
    paid
    lockedAt
    createdAt
    updatedAt
    payableId
    payableType
    payableName
    sale {
      id
      name
    }
    invoices {
      filename
      imageUrl
    }
    projectIntroducerPaymentLines {
      edges {
        node {
          id
          amount
          createdAt
          updatedAt
          orderItems {
            edges {
              node {
                id
                totalPrice
                order {
                  id
                  sale {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
    orderItems {
      edges {
        node {
          id
          totalPrice
          order {
            id
            sale {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProjectIntroducerPaymentQuery__
 *
 * To run a query within a React component, call `useProjectIntroducerPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectIntroducerPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectIntroducerPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectIntroducerPaymentQuery(baseOptions: Apollo.QueryHookOptions<ProjectIntroducerPaymentQuery, ProjectIntroducerPaymentQueryVariables>) {
        return Apollo.useQuery<ProjectIntroducerPaymentQuery, ProjectIntroducerPaymentQueryVariables>(ProjectIntroducerPaymentDocument, baseOptions);
      }
export function useProjectIntroducerPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectIntroducerPaymentQuery, ProjectIntroducerPaymentQueryVariables>) {
          return Apollo.useLazyQuery<ProjectIntroducerPaymentQuery, ProjectIntroducerPaymentQueryVariables>(ProjectIntroducerPaymentDocument, baseOptions);
        }
export type ProjectIntroducerPaymentQueryHookResult = ReturnType<typeof useProjectIntroducerPaymentQuery>;
export type ProjectIntroducerPaymentLazyQueryHookResult = ReturnType<typeof useProjectIntroducerPaymentLazyQuery>;
export type ProjectIntroducerPaymentQueryResult = Apollo.QueryResult<ProjectIntroducerPaymentQuery, ProjectIntroducerPaymentQueryVariables>;
export const ProjectIntroducerPaymentsDocument = gql`
    query ProjectIntroducerPayments($where: ProjectIntroducerPaymentFilter, $first: Int, $last: Int, $after: String, $before: String) {
  projectIntroducerPayments(
    where: $where
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        startAt
        endAt
        paid
        lockedAt
        createdAt
        updatedAt
        payableId
        payableType
        payableName
        invoices {
          filename
          imageUrl
        }
        sale {
          id
          name
        }
        projectIntroducerPaymentLines {
          edges {
            node {
              id
              amount
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProjectIntroducerPaymentsQuery__
 *
 * To run a query within a React component, call `useProjectIntroducerPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectIntroducerPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectIntroducerPaymentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useProjectIntroducerPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectIntroducerPaymentsQuery, ProjectIntroducerPaymentsQueryVariables>) {
        return Apollo.useQuery<ProjectIntroducerPaymentsQuery, ProjectIntroducerPaymentsQueryVariables>(ProjectIntroducerPaymentsDocument, baseOptions);
      }
export function useProjectIntroducerPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectIntroducerPaymentsQuery, ProjectIntroducerPaymentsQueryVariables>) {
          return Apollo.useLazyQuery<ProjectIntroducerPaymentsQuery, ProjectIntroducerPaymentsQueryVariables>(ProjectIntroducerPaymentsDocument, baseOptions);
        }
export type ProjectIntroducerPaymentsQueryHookResult = ReturnType<typeof useProjectIntroducerPaymentsQuery>;
export type ProjectIntroducerPaymentsLazyQueryHookResult = ReturnType<typeof useProjectIntroducerPaymentsLazyQuery>;
export type ProjectIntroducerPaymentsQueryResult = Apollo.QueryResult<ProjectIntroducerPaymentsQuery, ProjectIntroducerPaymentsQueryVariables>;
export const UpdateProjectIntroducerPaymentDocument = gql`
    mutation UpdateProjectIntroducerPayment($input: UpdateProjectIntroducerPaymentMutationInput!) {
  updateProjectIntroducerPayment(input: $input) {
    projectIntroducerPayment {
      id
      paid
      invoices {
        filename
        imageUrl
      }
    }
    errors {
      details
      fullMessages
    }
  }
}
    `;
export type UpdateProjectIntroducerPaymentMutationFn = Apollo.MutationFunction<UpdateProjectIntroducerPaymentMutation, UpdateProjectIntroducerPaymentMutationVariables>;

/**
 * __useUpdateProjectIntroducerPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateProjectIntroducerPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectIntroducerPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectIntroducerPaymentMutation, { data, loading, error }] = useUpdateProjectIntroducerPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectIntroducerPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectIntroducerPaymentMutation, UpdateProjectIntroducerPaymentMutationVariables>) {
        return Apollo.useMutation<UpdateProjectIntroducerPaymentMutation, UpdateProjectIntroducerPaymentMutationVariables>(UpdateProjectIntroducerPaymentDocument, baseOptions);
      }
export type UpdateProjectIntroducerPaymentMutationHookResult = ReturnType<typeof useUpdateProjectIntroducerPaymentMutation>;
export type UpdateProjectIntroducerPaymentMutationResult = Apollo.MutationResult<UpdateProjectIntroducerPaymentMutation>;
export type UpdateProjectIntroducerPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateProjectIntroducerPaymentMutation, UpdateProjectIntroducerPaymentMutationVariables>;
export const BulkMarkProjectIntroducerPaymentsAsPaidDocument = gql`
    mutation BulkMarkProjectIntroducerPaymentsAsPaid($input: BulkMarkProjectIntroducerPaymentsAsPaidInput!) {
  bulkMarkProjectIntroducerPaymentsAsPaid(input: $input) {
    updatedCount
    errors
  }
}
    `;
export type BulkMarkProjectIntroducerPaymentsAsPaidMutationFn = Apollo.MutationFunction<BulkMarkProjectIntroducerPaymentsAsPaidMutation, BulkMarkProjectIntroducerPaymentsAsPaidMutationVariables>;

/**
 * __useBulkMarkProjectIntroducerPaymentsAsPaidMutation__
 *
 * To run a mutation, you first call `useBulkMarkProjectIntroducerPaymentsAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkProjectIntroducerPaymentsAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkProjectIntroducerPaymentsAsPaidMutation, { data, loading, error }] = useBulkMarkProjectIntroducerPaymentsAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMarkProjectIntroducerPaymentsAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<BulkMarkProjectIntroducerPaymentsAsPaidMutation, BulkMarkProjectIntroducerPaymentsAsPaidMutationVariables>) {
        return Apollo.useMutation<BulkMarkProjectIntroducerPaymentsAsPaidMutation, BulkMarkProjectIntroducerPaymentsAsPaidMutationVariables>(BulkMarkProjectIntroducerPaymentsAsPaidDocument, baseOptions);
      }
export type BulkMarkProjectIntroducerPaymentsAsPaidMutationHookResult = ReturnType<typeof useBulkMarkProjectIntroducerPaymentsAsPaidMutation>;
export type BulkMarkProjectIntroducerPaymentsAsPaidMutationResult = Apollo.MutationResult<BulkMarkProjectIntroducerPaymentsAsPaidMutation>;
export type BulkMarkProjectIntroducerPaymentsAsPaidMutationOptions = Apollo.BaseMutationOptions<BulkMarkProjectIntroducerPaymentsAsPaidMutation, BulkMarkProjectIntroducerPaymentsAsPaidMutationVariables>;
export const ProjectPaymentListDocument = gql`
    query ProjectPaymentList($vendorId: ID, $onlyDue: Boolean) {
  projectPayments(vendorId: $vendorId, onlyDue: $onlyDue) {
    salesCount
    soldAmountHt
    transferredAmountHt
    generatedAmountHt
    toPayAmountHt
    dueAmountHt
    inProgressAmountHt
    awaitingBuyerAmountHt
    project {
      id
      title
      vendor {
        ...VendorSelectField
      }
    }
  }
}
    ${VendorSelectFieldFragmentDoc}`;

/**
 * __useProjectPaymentListQuery__
 *
 * To run a query within a React component, call `useProjectPaymentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPaymentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPaymentListQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      onlyDue: // value for 'onlyDue'
 *   },
 * });
 */
export function useProjectPaymentListQuery(baseOptions?: Apollo.QueryHookOptions<ProjectPaymentListQuery, ProjectPaymentListQueryVariables>) {
        return Apollo.useQuery<ProjectPaymentListQuery, ProjectPaymentListQueryVariables>(ProjectPaymentListDocument, baseOptions);
      }
export function useProjectPaymentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPaymentListQuery, ProjectPaymentListQueryVariables>) {
          return Apollo.useLazyQuery<ProjectPaymentListQuery, ProjectPaymentListQueryVariables>(ProjectPaymentListDocument, baseOptions);
        }
export type ProjectPaymentListQueryHookResult = ReturnType<typeof useProjectPaymentListQuery>;
export type ProjectPaymentListLazyQueryHookResult = ReturnType<typeof useProjectPaymentListLazyQuery>;
export type ProjectPaymentListQueryResult = Apollo.QueryResult<ProjectPaymentListQuery, ProjectPaymentListQueryVariables>;
export const ProjectPaymentSummaryDocument = gql`
    query ProjectPaymentSummary($id: ID!) {
  project(id: $id) {
    id
    paymentSummary {
      ...ProjectPaymentAmounts
      sales {
        soldCount
        soldAmountHt
        transferredAmountHt
        generatedAmountHt
        toPayAmountHt
        inProgressAmountHt
        dueAmountHt
        awaitingBuyerAmountHt
        unpaidByBuyerAmountHt
        svvAmountHt
        sale {
          id
          name
          startAt
        }
        vendorPayments {
          id
          paid
          netAmount
        }
      }
    }
  }
}
    ${ProjectPaymentAmountsFragmentDoc}`;

/**
 * __useProjectPaymentSummaryQuery__
 *
 * To run a query within a React component, call `useProjectPaymentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPaymentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPaymentSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectPaymentSummaryQuery(baseOptions: Apollo.QueryHookOptions<ProjectPaymentSummaryQuery, ProjectPaymentSummaryQueryVariables>) {
        return Apollo.useQuery<ProjectPaymentSummaryQuery, ProjectPaymentSummaryQueryVariables>(ProjectPaymentSummaryDocument, baseOptions);
      }
export function useProjectPaymentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPaymentSummaryQuery, ProjectPaymentSummaryQueryVariables>) {
          return Apollo.useLazyQuery<ProjectPaymentSummaryQuery, ProjectPaymentSummaryQueryVariables>(ProjectPaymentSummaryDocument, baseOptions);
        }
export type ProjectPaymentSummaryQueryHookResult = ReturnType<typeof useProjectPaymentSummaryQuery>;
export type ProjectPaymentSummaryLazyQueryHookResult = ReturnType<typeof useProjectPaymentSummaryLazyQuery>;
export type ProjectPaymentSummaryQueryResult = Apollo.QueryResult<ProjectPaymentSummaryQuery, ProjectPaymentSummaryQueryVariables>;
export const ProjectPaymentSaleItemsDocument = gql`
    query ProjectPaymentSaleItems($id: ID!, $saleId: ID!) {
  project(id: $id) {
    id
    paymentSaleItems(saleId: $saleId) {
      id
      bucket
      hammerPrice
      orderId
      orderRef
      orderState
      shippingPriceTaxIncluded
      insurancePriceTaxIncluded
      buyerFeeTaxIncluded
      commissionTtc
      fixedFeesTtc
      netAmount
      vendorPaymentId
      vendorPaymentPaid
      item {
        id
        title
        sku
        firstImage {
          id
          imageUrl
        }
      }
    }
  }
}
    `;

/**
 * __useProjectPaymentSaleItemsQuery__
 *
 * To run a query within a React component, call `useProjectPaymentSaleItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPaymentSaleItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPaymentSaleItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useProjectPaymentSaleItemsQuery(baseOptions: Apollo.QueryHookOptions<ProjectPaymentSaleItemsQuery, ProjectPaymentSaleItemsQueryVariables>) {
        return Apollo.useQuery<ProjectPaymentSaleItemsQuery, ProjectPaymentSaleItemsQueryVariables>(ProjectPaymentSaleItemsDocument, baseOptions);
      }
export function useProjectPaymentSaleItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPaymentSaleItemsQuery, ProjectPaymentSaleItemsQueryVariables>) {
          return Apollo.useLazyQuery<ProjectPaymentSaleItemsQuery, ProjectPaymentSaleItemsQueryVariables>(ProjectPaymentSaleItemsDocument, baseOptions);
        }
export type ProjectPaymentSaleItemsQueryHookResult = ReturnType<typeof useProjectPaymentSaleItemsQuery>;
export type ProjectPaymentSaleItemsLazyQueryHookResult = ReturnType<typeof useProjectPaymentSaleItemsLazyQuery>;
export type ProjectPaymentSaleItemsQueryResult = Apollo.QueryResult<ProjectPaymentSaleItemsQuery, ProjectPaymentSaleItemsQueryVariables>;
export const BulkRemoveReturnedItemsDocument = gql`
    mutation BulkRemoveReturnedItems($itemIds: [ID!]!) {
  bulkRemoveReturnedItems(input: {itemIds: $itemIds}) {
    success
    errors
    message
  }
}
    `;
export type BulkRemoveReturnedItemsMutationFn = Apollo.MutationFunction<BulkRemoveReturnedItemsMutation, BulkRemoveReturnedItemsMutationVariables>;

/**
 * __useBulkRemoveReturnedItemsMutation__
 *
 * To run a mutation, you first call `useBulkRemoveReturnedItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveReturnedItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveReturnedItemsMutation, { data, loading, error }] = useBulkRemoveReturnedItemsMutation({
 *   variables: {
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function useBulkRemoveReturnedItemsMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveReturnedItemsMutation, BulkRemoveReturnedItemsMutationVariables>) {
        return Apollo.useMutation<BulkRemoveReturnedItemsMutation, BulkRemoveReturnedItemsMutationVariables>(BulkRemoveReturnedItemsDocument, baseOptions);
      }
export type BulkRemoveReturnedItemsMutationHookResult = ReturnType<typeof useBulkRemoveReturnedItemsMutation>;
export type BulkRemoveReturnedItemsMutationResult = Apollo.MutationResult<BulkRemoveReturnedItemsMutation>;
export type BulkRemoveReturnedItemsMutationOptions = Apollo.BaseMutationOptions<BulkRemoveReturnedItemsMutation, BulkRemoveReturnedItemsMutationVariables>;
export const SalePlannedItemsDocument = gql`
    query SalePlannedItems($saleId: ID!) {
  sale(id: $saleId) {
    id
    name
    typeOfSale
    pendingPlannedItemsCount
    readyForExport
  }
  items(where: {plannedSaleId: {equalTo: $saleId}}, first: 1) {
    totalCount
  }
}
    `;

/**
 * __useSalePlannedItemsQuery__
 *
 * To run a query within a React component, call `useSalePlannedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalePlannedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalePlannedItemsQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useSalePlannedItemsQuery(baseOptions: Apollo.QueryHookOptions<SalePlannedItemsQuery, SalePlannedItemsQueryVariables>) {
        return Apollo.useQuery<SalePlannedItemsQuery, SalePlannedItemsQueryVariables>(SalePlannedItemsDocument, baseOptions);
      }
export function useSalePlannedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalePlannedItemsQuery, SalePlannedItemsQueryVariables>) {
          return Apollo.useLazyQuery<SalePlannedItemsQuery, SalePlannedItemsQueryVariables>(SalePlannedItemsDocument, baseOptions);
        }
export type SalePlannedItemsQueryHookResult = ReturnType<typeof useSalePlannedItemsQuery>;
export type SalePlannedItemsLazyQueryHookResult = ReturnType<typeof useSalePlannedItemsLazyQuery>;
export type SalePlannedItemsQueryResult = Apollo.QueryResult<SalePlannedItemsQuery, SalePlannedItemsQueryVariables>;
export const ValidateSaleItemsDocument = gql`
    mutation ValidateSaleItems($input: ValidateSaleItemsMutationInput!) {
  validateSaleItems(input: $input) {
    validatedCount
    errors
    blockingItems {
      id
      sku
      title
      state
    }
    sale {
      id
      pendingPlannedItemsCount
      readyForExport
    }
  }
}
    `;
export type ValidateSaleItemsMutationFn = Apollo.MutationFunction<ValidateSaleItemsMutation, ValidateSaleItemsMutationVariables>;

/**
 * __useValidateSaleItemsMutation__
 *
 * To run a mutation, you first call `useValidateSaleItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSaleItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSaleItemsMutation, { data, loading, error }] = useValidateSaleItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateSaleItemsMutation(baseOptions?: Apollo.MutationHookOptions<ValidateSaleItemsMutation, ValidateSaleItemsMutationVariables>) {
        return Apollo.useMutation<ValidateSaleItemsMutation, ValidateSaleItemsMutationVariables>(ValidateSaleItemsDocument, baseOptions);
      }
export type ValidateSaleItemsMutationHookResult = ReturnType<typeof useValidateSaleItemsMutation>;
export type ValidateSaleItemsMutationResult = Apollo.MutationResult<ValidateSaleItemsMutation>;
export type ValidateSaleItemsMutationOptions = Apollo.BaseMutationOptions<ValidateSaleItemsMutation, ValidateSaleItemsMutationVariables>;
export const SaleReadyForExportDocument = gql`
    query SaleReadyForExport($id: ID!) {
  sale(id: $id) {
    id
    typeOfSale
    readyForExport
  }
}
    `;

/**
 * __useSaleReadyForExportQuery__
 *
 * To run a query within a React component, call `useSaleReadyForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleReadyForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleReadyForExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaleReadyForExportQuery(baseOptions: Apollo.QueryHookOptions<SaleReadyForExportQuery, SaleReadyForExportQueryVariables>) {
        return Apollo.useQuery<SaleReadyForExportQuery, SaleReadyForExportQueryVariables>(SaleReadyForExportDocument, baseOptions);
      }
export function useSaleReadyForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleReadyForExportQuery, SaleReadyForExportQueryVariables>) {
          return Apollo.useLazyQuery<SaleReadyForExportQuery, SaleReadyForExportQueryVariables>(SaleReadyForExportDocument, baseOptions);
        }
export type SaleReadyForExportQueryHookResult = ReturnType<typeof useSaleReadyForExportQuery>;
export type SaleReadyForExportLazyQueryHookResult = ReturnType<typeof useSaleReadyForExportLazyQuery>;
export type SaleReadyForExportQueryResult = Apollo.QueryResult<SaleReadyForExportQuery, SaleReadyForExportQueryVariables>;
export const SignUpDocument = gql`
    mutation signUp($email: String!, $password: String!, $passwordConfirmation: String!, $role: String!, $firstName: String!, $lastName: String!, $phone: String!) {
  customSignUp(
    email: $email
    password: $password
    passwordConfirmation: $passwordConfirmation
    role: $role
    firstName: $firstName
    lastName: $lastName
    phone: $phone
  ) {
    sessionToken
    success
    user {
      id
      email
      firstName
      lastName
      accounts {
        edges {
          node {
            id
            accountable {
              ... on Expert {
                id
              }
              ... on Vendor {
                id
              }
              __typename
            }
          }
        }
      }
    }
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      role: // value for 'role'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, baseOptions);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const SingleItemFormItemDocument = gql`
    query SingleItemFormItem($id: ID!) {
  item(id: $id) {
    id
    title
    saleTitle
    subtitle
    autoDescription
    descriptionHeader
    description
    descriptionFooter
    descriptionSuggestion
    descriptionSuggestionGeneratedAt
    generationStatus
    customDescription
    customDescriptionEnabled
    autoDescription
    state
    mode
    customSkuPart
    sku
    lowEstimatedPrice
    highEstimatedPrice
    startingPrice
    reservedPrice
    unitCount
    weight
    length
    width
    height
    otherComment
    conditionAccepted
    artistUnknown
    artistCollectif
    artistKnownButNotMentioned
    project {
      id
      title
    }
    template {
      __typename
    }
    itemCategory {
      ...SingleItemFormCategory
    }
    itemSubCategory {
      ...SingleItemFormSubCategory
    }
    artists {
      edges {
        node {
          ...SingleItemFormArtist
        }
      }
    }
    itemSteps {
      edges {
        node {
          ...SingleItemFormStep
        }
      }
    }
    images {
      ...SingleItemFormImage
    }
    invoices {
      ...SingleItemFormDocument
    }
    authenticityDocuments {
      ...SingleItemFormDocument
    }
    globalComment
    vacation {
      id
      name
    }
    tags {
      edges {
        node {
          id
          name
        }
      }
    }
    autoTags {
      edges {
        node {
          id
          name
        }
      }
    }
    orderItem {
      id
      state
      totalPrice
      order {
        id
        state
        totalPrice
        totalPriceTaxIncluded
        trackingNumbers
        buyer {
          account {
            firstName
            lastName
            email
          }
        }
      }
    }
  }
}
    ${SingleItemFormCategoryFragmentDoc}
${SingleItemFormSubCategoryFragmentDoc}
${SingleItemFormArtistFragmentDoc}
${SingleItemFormStepFragmentDoc}
${SingleItemFormImageFragmentDoc}
${SingleItemFormDocumentFragmentDoc}`;

/**
 * __useSingleItemFormItemQuery__
 *
 * To run a query within a React component, call `useSingleItemFormItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleItemFormItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleItemFormItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleItemFormItemQuery(baseOptions: Apollo.QueryHookOptions<SingleItemFormItemQuery, SingleItemFormItemQueryVariables>) {
        return Apollo.useQuery<SingleItemFormItemQuery, SingleItemFormItemQueryVariables>(SingleItemFormItemDocument, baseOptions);
      }
export function useSingleItemFormItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleItemFormItemQuery, SingleItemFormItemQueryVariables>) {
          return Apollo.useLazyQuery<SingleItemFormItemQuery, SingleItemFormItemQueryVariables>(SingleItemFormItemDocument, baseOptions);
        }
export type SingleItemFormItemQueryHookResult = ReturnType<typeof useSingleItemFormItemQuery>;
export type SingleItemFormItemLazyQueryHookResult = ReturnType<typeof useSingleItemFormItemLazyQuery>;
export type SingleItemFormItemQueryResult = Apollo.QueryResult<SingleItemFormItemQuery, SingleItemFormItemQueryVariables>;
export const ItemAiSuggestionDocument = gql`
    query ItemAiSuggestion($id: ID!) {
  item(id: $id) {
    id
    descriptionSuggestion
    descriptionSuggestionGeneratedAt
    generationStatus
  }
}
    `;

/**
 * __useItemAiSuggestionQuery__
 *
 * To run a query within a React component, call `useItemAiSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemAiSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemAiSuggestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useItemAiSuggestionQuery(baseOptions: Apollo.QueryHookOptions<ItemAiSuggestionQuery, ItemAiSuggestionQueryVariables>) {
        return Apollo.useQuery<ItemAiSuggestionQuery, ItemAiSuggestionQueryVariables>(ItemAiSuggestionDocument, baseOptions);
      }
export function useItemAiSuggestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemAiSuggestionQuery, ItemAiSuggestionQueryVariables>) {
          return Apollo.useLazyQuery<ItemAiSuggestionQuery, ItemAiSuggestionQueryVariables>(ItemAiSuggestionDocument, baseOptions);
        }
export type ItemAiSuggestionQueryHookResult = ReturnType<typeof useItemAiSuggestionQuery>;
export type ItemAiSuggestionLazyQueryHookResult = ReturnType<typeof useItemAiSuggestionLazyQuery>;
export type ItemAiSuggestionQueryResult = Apollo.QueryResult<ItemAiSuggestionQuery, ItemAiSuggestionQueryVariables>;
export const SingleItemFormHeaderDocument = gql`
    query SingleItemFormHeader($id: ID!) {
  item(id: $id) {
    id
    sku
    state
    saleTitle
    title
    createdAt
    sale {
      id
      name
    }
    plannedSale {
      id
      name
    }
    expert {
      ...ItemExpert
    }
    vendor {
      account {
        firstName
        lastName
      }
    }
    writer {
      account {
        firstName
        lastName
      }
    }
  }
}
    ${ItemExpertFragmentDoc}`;

/**
 * __useSingleItemFormHeaderQuery__
 *
 * To run a query within a React component, call `useSingleItemFormHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleItemFormHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleItemFormHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleItemFormHeaderQuery(baseOptions: Apollo.QueryHookOptions<SingleItemFormHeaderQuery, SingleItemFormHeaderQueryVariables>) {
        return Apollo.useQuery<SingleItemFormHeaderQuery, SingleItemFormHeaderQueryVariables>(SingleItemFormHeaderDocument, baseOptions);
      }
export function useSingleItemFormHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleItemFormHeaderQuery, SingleItemFormHeaderQueryVariables>) {
          return Apollo.useLazyQuery<SingleItemFormHeaderQuery, SingleItemFormHeaderQueryVariables>(SingleItemFormHeaderDocument, baseOptions);
        }
export type SingleItemFormHeaderQueryHookResult = ReturnType<typeof useSingleItemFormHeaderQuery>;
export type SingleItemFormHeaderLazyQueryHookResult = ReturnType<typeof useSingleItemFormHeaderLazyQuery>;
export type SingleItemFormHeaderQueryResult = Apollo.QueryResult<SingleItemFormHeaderQuery, SingleItemFormHeaderQueryVariables>;
export const StripeBalanceSnapshotDocument = gql`
    query StripeBalanceSnapshot {
  stripeBalanceSnapshot {
    theoreticalBalance
    belongsToVendors
    belongsToDodecade
    actualStripeBalance
    discrepancy
    openDisputesCount
    openDisputesAmount
  }
}
    `;

/**
 * __useStripeBalanceSnapshotQuery__
 *
 * To run a query within a React component, call `useStripeBalanceSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeBalanceSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeBalanceSnapshotQuery({
 *   variables: {
 *   },
 * });
 */
export function useStripeBalanceSnapshotQuery(baseOptions?: Apollo.QueryHookOptions<StripeBalanceSnapshotQuery, StripeBalanceSnapshotQueryVariables>) {
        return Apollo.useQuery<StripeBalanceSnapshotQuery, StripeBalanceSnapshotQueryVariables>(StripeBalanceSnapshotDocument, baseOptions);
      }
export function useStripeBalanceSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeBalanceSnapshotQuery, StripeBalanceSnapshotQueryVariables>) {
          return Apollo.useLazyQuery<StripeBalanceSnapshotQuery, StripeBalanceSnapshotQueryVariables>(StripeBalanceSnapshotDocument, baseOptions);
        }
export type StripeBalanceSnapshotQueryHookResult = ReturnType<typeof useStripeBalanceSnapshotQuery>;
export type StripeBalanceSnapshotLazyQueryHookResult = ReturnType<typeof useStripeBalanceSnapshotLazyQuery>;
export type StripeBalanceSnapshotQueryResult = Apollo.QueryResult<StripeBalanceSnapshotQuery, StripeBalanceSnapshotQueryVariables>;
export const BulkRelistItemsDocument = gql`
    mutation BulkRelistItems($itemIds: [ID!]!, $saleId: ID, $forceLibraryFund: Boolean) {
  bulkRelistItems(
    input: {itemIds: $itemIds, saleId: $saleId, forceLibraryFund: $forceLibraryFund}
  ) {
    success
    errors
    message
  }
}
    `;
export type BulkRelistItemsMutationFn = Apollo.MutationFunction<BulkRelistItemsMutation, BulkRelistItemsMutationVariables>;

/**
 * __useBulkRelistItemsMutation__
 *
 * To run a mutation, you first call `useBulkRelistItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRelistItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRelistItemsMutation, { data, loading, error }] = useBulkRelistItemsMutation({
 *   variables: {
 *      itemIds: // value for 'itemIds'
 *      saleId: // value for 'saleId'
 *      forceLibraryFund: // value for 'forceLibraryFund'
 *   },
 * });
 */
export function useBulkRelistItemsMutation(baseOptions?: Apollo.MutationHookOptions<BulkRelistItemsMutation, BulkRelistItemsMutationVariables>) {
        return Apollo.useMutation<BulkRelistItemsMutation, BulkRelistItemsMutationVariables>(BulkRelistItemsDocument, baseOptions);
      }
export type BulkRelistItemsMutationHookResult = ReturnType<typeof useBulkRelistItemsMutation>;
export type BulkRelistItemsMutationResult = Apollo.MutationResult<BulkRelistItemsMutation>;
export type BulkRelistItemsMutationOptions = Apollo.BaseMutationOptions<BulkRelistItemsMutation, BulkRelistItemsMutationVariables>;
export const BulkReturnItemsDocument = gql`
    mutation BulkReturnItems($itemIds: [ID!]!) {
  bulkReturnItems(input: {itemIds: $itemIds}) {
    success
    errors
    returnSlipId
    message
  }
}
    `;
export type BulkReturnItemsMutationFn = Apollo.MutationFunction<BulkReturnItemsMutation, BulkReturnItemsMutationVariables>;

/**
 * __useBulkReturnItemsMutation__
 *
 * To run a mutation, you first call `useBulkReturnItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkReturnItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkReturnItemsMutation, { data, loading, error }] = useBulkReturnItemsMutation({
 *   variables: {
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function useBulkReturnItemsMutation(baseOptions?: Apollo.MutationHookOptions<BulkReturnItemsMutation, BulkReturnItemsMutationVariables>) {
        return Apollo.useMutation<BulkReturnItemsMutation, BulkReturnItemsMutationVariables>(BulkReturnItemsDocument, baseOptions);
      }
export type BulkReturnItemsMutationHookResult = ReturnType<typeof useBulkReturnItemsMutation>;
export type BulkReturnItemsMutationResult = Apollo.MutationResult<BulkReturnItemsMutation>;
export type BulkReturnItemsMutationOptions = Apollo.BaseMutationOptions<BulkReturnItemsMutation, BulkReturnItemsMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($password: String!, $passwordConfirmation: String!, $resetPasswordToken: String!) {
  resetPassword(
    password: $password
    passwordConfirmation: $passwordConfirmation
    resetPasswordToken: $resetPasswordToken
  ) {
    success
    errors {
      details
      message
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      resetPasswordToken: // value for 'resetPasswordToken'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, baseOptions);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const GenerateVendorAccountingExportDocument = gql`
    mutation GenerateVendorAccountingExport($input: GenerateVendorAccountingExportMutationInput!) {
  generateVendorAccountingExport(input: $input) {
    message
    errors
  }
}
    `;
export type GenerateVendorAccountingExportMutationFn = Apollo.MutationFunction<GenerateVendorAccountingExportMutation, GenerateVendorAccountingExportMutationVariables>;

/**
 * __useGenerateVendorAccountingExportMutation__
 *
 * To run a mutation, you first call `useGenerateVendorAccountingExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateVendorAccountingExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateVendorAccountingExportMutation, { data, loading, error }] = useGenerateVendorAccountingExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateVendorAccountingExportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateVendorAccountingExportMutation, GenerateVendorAccountingExportMutationVariables>) {
        return Apollo.useMutation<GenerateVendorAccountingExportMutation, GenerateVendorAccountingExportMutationVariables>(GenerateVendorAccountingExportDocument, baseOptions);
      }
export type GenerateVendorAccountingExportMutationHookResult = ReturnType<typeof useGenerateVendorAccountingExportMutation>;
export type GenerateVendorAccountingExportMutationResult = Apollo.MutationResult<GenerateVendorAccountingExportMutation>;
export type GenerateVendorAccountingExportMutationOptions = Apollo.BaseMutationOptions<GenerateVendorAccountingExportMutation, GenerateVendorAccountingExportMutationVariables>;
export const VendorDashboardItemsStatsDocument = gql`
    query VendorDashboardItemsStats($vendorId: ID!) {
  itemsStats(vendorId: $vendorId) {
    onSale
    sold
    unsold
    unpaid
    requiringVendorAction
  }
}
    `;

/**
 * __useVendorDashboardItemsStatsQuery__
 *
 * To run a query within a React component, call `useVendorDashboardItemsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorDashboardItemsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorDashboardItemsStatsQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useVendorDashboardItemsStatsQuery(baseOptions: Apollo.QueryHookOptions<VendorDashboardItemsStatsQuery, VendorDashboardItemsStatsQueryVariables>) {
        return Apollo.useQuery<VendorDashboardItemsStatsQuery, VendorDashboardItemsStatsQueryVariables>(VendorDashboardItemsStatsDocument, baseOptions);
      }
export function useVendorDashboardItemsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorDashboardItemsStatsQuery, VendorDashboardItemsStatsQueryVariables>) {
          return Apollo.useLazyQuery<VendorDashboardItemsStatsQuery, VendorDashboardItemsStatsQueryVariables>(VendorDashboardItemsStatsDocument, baseOptions);
        }
export type VendorDashboardItemsStatsQueryHookResult = ReturnType<typeof useVendorDashboardItemsStatsQuery>;
export type VendorDashboardItemsStatsLazyQueryHookResult = ReturnType<typeof useVendorDashboardItemsStatsLazyQuery>;
export type VendorDashboardItemsStatsQueryResult = Apollo.QueryResult<VendorDashboardItemsStatsQuery, VendorDashboardItemsStatsQueryVariables>;
export const VendorDashboardDocument = gql`
    query VendorDashboard($vendorId: ID!) {
  vendor(id: $vendorId) {
    id
    vendorFinancialStats {
      currentMonthNetAmount
      lastMonthNetAmount
      pendingPaymentAmount
      pendingPaymentCount
      totalEarnedAllTime
      ordersThisMonthCount
      ordersThisMonthPickupCount
      ordersThisMonthShippingCount
    }
    ordersToShipCount
    ordersToPickupCount
    lateOrders3DaysCount
    lateOrders5DaysCount
  }
}
    `;

/**
 * __useVendorDashboardQuery__
 *
 * To run a query within a React component, call `useVendorDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorDashboardQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useVendorDashboardQuery(baseOptions: Apollo.QueryHookOptions<VendorDashboardQuery, VendorDashboardQueryVariables>) {
        return Apollo.useQuery<VendorDashboardQuery, VendorDashboardQueryVariables>(VendorDashboardDocument, baseOptions);
      }
export function useVendorDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorDashboardQuery, VendorDashboardQueryVariables>) {
          return Apollo.useLazyQuery<VendorDashboardQuery, VendorDashboardQueryVariables>(VendorDashboardDocument, baseOptions);
        }
export type VendorDashboardQueryHookResult = ReturnType<typeof useVendorDashboardQuery>;
export type VendorDashboardLazyQueryHookResult = ReturnType<typeof useVendorDashboardLazyQuery>;
export type VendorDashboardQueryResult = Apollo.QueryResult<VendorDashboardQuery, VendorDashboardQueryVariables>;
export const GetVendorDocument = gql`
    query getVendor($id: ID!) {
  vendor(id: $id) {
    id
    kind
    account {
      id
      firstName
      lastName
      email
      phone
      state
      ribDocuments {
        filename
        imageUrl
      }
      identityDocuments {
        filename
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useGetVendorQuery__
 *
 * To run a query within a React component, call `useGetVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVendorQuery(baseOptions: Apollo.QueryHookOptions<GetVendorQuery, GetVendorQueryVariables>) {
        return Apollo.useQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, baseOptions);
      }
export function useGetVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>) {
          return Apollo.useLazyQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, baseOptions);
        }
export type GetVendorQueryHookResult = ReturnType<typeof useGetVendorQuery>;
export type GetVendorLazyQueryHookResult = ReturnType<typeof useGetVendorLazyQuery>;
export type GetVendorQueryResult = Apollo.QueryResult<GetVendorQuery, GetVendorQueryVariables>;
export const VendorLatePickupsViewDocument = gql`
    query VendorLatePickupsView($vendorId: ID!) {
  vendorLatePickups(vendorId: $vendorId) {
    vendorId
    latePickupItems3Days {
      id
      state
      order {
        id
        dodecadeOrderRef
        paidAt
        totalPrice
        carrierName
      }
    }
    latePickupItems5Days {
      id
      state
      order {
        id
        dodecadeOrderRef
        paidAt
        totalPrice
        carrierName
      }
    }
  }
}
    `;

/**
 * __useVendorLatePickupsViewQuery__
 *
 * To run a query within a React component, call `useVendorLatePickupsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorLatePickupsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorLatePickupsViewQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useVendorLatePickupsViewQuery(baseOptions: Apollo.QueryHookOptions<VendorLatePickupsViewQuery, VendorLatePickupsViewQueryVariables>) {
        return Apollo.useQuery<VendorLatePickupsViewQuery, VendorLatePickupsViewQueryVariables>(VendorLatePickupsViewDocument, baseOptions);
      }
export function useVendorLatePickupsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorLatePickupsViewQuery, VendorLatePickupsViewQueryVariables>) {
          return Apollo.useLazyQuery<VendorLatePickupsViewQuery, VendorLatePickupsViewQueryVariables>(VendorLatePickupsViewDocument, baseOptions);
        }
export type VendorLatePickupsViewQueryHookResult = ReturnType<typeof useVendorLatePickupsViewQuery>;
export type VendorLatePickupsViewLazyQueryHookResult = ReturnType<typeof useVendorLatePickupsViewLazyQuery>;
export type VendorLatePickupsViewQueryResult = Apollo.QueryResult<VendorLatePickupsViewQuery, VendorLatePickupsViewQueryVariables>;
export const MonthlyVendorPaymentDocument = gql`
    query MonthlyVendorPayment($id: ID!) {
  monthlyVendorPayment(id: $id) {
    ...MonthlyVendorPayment
    paymentStats {
      saleTotalSoldAmountHt
      saleTotalSoldCount
      previouslyPaidAmountHt
      previouslyPaidCount
      previousPaymentsCount
      currentPaymentAmountHt
      currentPaymentCount
      currentPaymentFeesTtc
      currentPaymentNetTtc
      remainingToPayAmountHt
      remainingToPayCount
      isSaleFullyPaid
      percentagePaidAfter
    }
    vendor {
      ...Vendor
      account {
        ...VendorAccount
        bankInformation {
          iban
          bic
        }
      }
    }
  }
}
    ${MonthlyVendorPaymentFragmentDoc}
${VendorFragmentDoc}
${VendorAccountFragmentDoc}`;

/**
 * __useMonthlyVendorPaymentQuery__
 *
 * To run a query within a React component, call `useMonthlyVendorPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyVendorPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyVendorPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMonthlyVendorPaymentQuery(baseOptions: Apollo.QueryHookOptions<MonthlyVendorPaymentQuery, MonthlyVendorPaymentQueryVariables>) {
        return Apollo.useQuery<MonthlyVendorPaymentQuery, MonthlyVendorPaymentQueryVariables>(MonthlyVendorPaymentDocument, baseOptions);
      }
export function useMonthlyVendorPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonthlyVendorPaymentQuery, MonthlyVendorPaymentQueryVariables>) {
          return Apollo.useLazyQuery<MonthlyVendorPaymentQuery, MonthlyVendorPaymentQueryVariables>(MonthlyVendorPaymentDocument, baseOptions);
        }
export type MonthlyVendorPaymentQueryHookResult = ReturnType<typeof useMonthlyVendorPaymentQuery>;
export type MonthlyVendorPaymentLazyQueryHookResult = ReturnType<typeof useMonthlyVendorPaymentLazyQuery>;
export type MonthlyVendorPaymentQueryResult = Apollo.QueryResult<MonthlyVendorPaymentQuery, MonthlyVendorPaymentQueryVariables>;
export const UpdateMonthlyVendorPaymentDocument = gql`
    mutation UpdateMonthlyVendorPayment($input: UpdateMonthlyVendorPaymentMutationInput!) {
  updateMonthlyVendorPayment(input: $input) {
    monthlyVendorPayment {
      id
    }
  }
}
    `;
export type UpdateMonthlyVendorPaymentMutationFn = Apollo.MutationFunction<UpdateMonthlyVendorPaymentMutation, UpdateMonthlyVendorPaymentMutationVariables>;

/**
 * __useUpdateMonthlyVendorPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateMonthlyVendorPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMonthlyVendorPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMonthlyVendorPaymentMutation, { data, loading, error }] = useUpdateMonthlyVendorPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMonthlyVendorPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMonthlyVendorPaymentMutation, UpdateMonthlyVendorPaymentMutationVariables>) {
        return Apollo.useMutation<UpdateMonthlyVendorPaymentMutation, UpdateMonthlyVendorPaymentMutationVariables>(UpdateMonthlyVendorPaymentDocument, baseOptions);
      }
export type UpdateMonthlyVendorPaymentMutationHookResult = ReturnType<typeof useUpdateMonthlyVendorPaymentMutation>;
export type UpdateMonthlyVendorPaymentMutationResult = Apollo.MutationResult<UpdateMonthlyVendorPaymentMutation>;
export type UpdateMonthlyVendorPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateMonthlyVendorPaymentMutation, UpdateMonthlyVendorPaymentMutationVariables>;
export const TriggerStripeTransferDocument = gql`
    mutation TriggerStripeTransfer($input: TriggerStripeTransferMutationInput!) {
  triggerStripeTransfer(input: $input) {
    vendorStatementPayment {
      id
      stripeTransferId
      stripeTransferStatus
      stripeTransferError
      stripeTransferredAt
    }
    errors
  }
}
    `;
export type TriggerStripeTransferMutationFn = Apollo.MutationFunction<TriggerStripeTransferMutation, TriggerStripeTransferMutationVariables>;

/**
 * __useTriggerStripeTransferMutation__
 *
 * To run a mutation, you first call `useTriggerStripeTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerStripeTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerStripeTransferMutation, { data, loading, error }] = useTriggerStripeTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerStripeTransferMutation(baseOptions?: Apollo.MutationHookOptions<TriggerStripeTransferMutation, TriggerStripeTransferMutationVariables>) {
        return Apollo.useMutation<TriggerStripeTransferMutation, TriggerStripeTransferMutationVariables>(TriggerStripeTransferDocument, baseOptions);
      }
export type TriggerStripeTransferMutationHookResult = ReturnType<typeof useTriggerStripeTransferMutation>;
export type TriggerStripeTransferMutationResult = Apollo.MutationResult<TriggerStripeTransferMutation>;
export type TriggerStripeTransferMutationOptions = Apollo.BaseMutationOptions<TriggerStripeTransferMutation, TriggerStripeTransferMutationVariables>;
export const VendorPaymentListDocument = gql`
    query VendorPaymentList {
  unpaidVendorPayments: monthlyVendorPayments(
    where: {paid: {equalTo: false}, vendorStatementPaymentId: {isBlank: true}}
    first: 1
  ) {
    totalCount
  }
  unpaidVendorStatementPayments: vendorStatementPayments(
    where: {paid: {equalTo: false}}
    first: 1
  ) {
    totalCount
  }
  allVendorPayments: monthlyVendorPayments(
    where: {vendorStatementPaymentId: {isBlank: true}}
    first: 1
  ) {
    totalCount
  }
}
    `;

/**
 * __useVendorPaymentListQuery__
 *
 * To run a query within a React component, call `useVendorPaymentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPaymentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPaymentListQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorPaymentListQuery(baseOptions?: Apollo.QueryHookOptions<VendorPaymentListQuery, VendorPaymentListQueryVariables>) {
        return Apollo.useQuery<VendorPaymentListQuery, VendorPaymentListQueryVariables>(VendorPaymentListDocument, baseOptions);
      }
export function useVendorPaymentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorPaymentListQuery, VendorPaymentListQueryVariables>) {
          return Apollo.useLazyQuery<VendorPaymentListQuery, VendorPaymentListQueryVariables>(VendorPaymentListDocument, baseOptions);
        }
export type VendorPaymentListQueryHookResult = ReturnType<typeof useVendorPaymentListQuery>;
export type VendorPaymentListLazyQueryHookResult = ReturnType<typeof useVendorPaymentListLazyQuery>;
export type VendorPaymentListQueryResult = Apollo.QueryResult<VendorPaymentListQuery, VendorPaymentListQueryVariables>;
export const VendorPickupWaitingDocument = gql`
    query VendorPickupWaiting($vendorId: ID!) {
  pickupWaitingBuyers(vendorId: $vendorId) {
    buyerId
    buyerName
    buyerEmail
    ordersCount
    itemsCount
    oldestPaidAt
    canRemind
    lastReminderAt
    nextReminderAvailableAt
    reminders {
      batchId
      kind
      ordersCount
      sentAt
      sentByName
    }
    waitingOrderItems {
      id
      order {
        id
        dodecadeOrderRef
        paidAt
      }
      item {
        title
        dodecadeItemRef
      }
    }
  }
}
    `;

/**
 * __useVendorPickupWaitingQuery__
 *
 * To run a query within a React component, call `useVendorPickupWaitingQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPickupWaitingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPickupWaitingQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useVendorPickupWaitingQuery(baseOptions: Apollo.QueryHookOptions<VendorPickupWaitingQuery, VendorPickupWaitingQueryVariables>) {
        return Apollo.useQuery<VendorPickupWaitingQuery, VendorPickupWaitingQueryVariables>(VendorPickupWaitingDocument, baseOptions);
      }
export function useVendorPickupWaitingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorPickupWaitingQuery, VendorPickupWaitingQueryVariables>) {
          return Apollo.useLazyQuery<VendorPickupWaitingQuery, VendorPickupWaitingQueryVariables>(VendorPickupWaitingDocument, baseOptions);
        }
export type VendorPickupWaitingQueryHookResult = ReturnType<typeof useVendorPickupWaitingQuery>;
export type VendorPickupWaitingLazyQueryHookResult = ReturnType<typeof useVendorPickupWaitingLazyQuery>;
export type VendorPickupWaitingQueryResult = Apollo.QueryResult<VendorPickupWaitingQuery, VendorPickupWaitingQueryVariables>;
export const SendPickupReminderToBuyerDocument = gql`
    mutation SendPickupReminderToBuyer($input: SendPickupReminderToBuyerMutationInput!) {
  sendPickupReminderToBuyer(input: $input) {
    success
    errors
    message
  }
}
    `;
export type SendPickupReminderToBuyerMutationFn = Apollo.MutationFunction<SendPickupReminderToBuyerMutation, SendPickupReminderToBuyerMutationVariables>;

/**
 * __useSendPickupReminderToBuyerMutation__
 *
 * To run a mutation, you first call `useSendPickupReminderToBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPickupReminderToBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPickupReminderToBuyerMutation, { data, loading, error }] = useSendPickupReminderToBuyerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPickupReminderToBuyerMutation(baseOptions?: Apollo.MutationHookOptions<SendPickupReminderToBuyerMutation, SendPickupReminderToBuyerMutationVariables>) {
        return Apollo.useMutation<SendPickupReminderToBuyerMutation, SendPickupReminderToBuyerMutationVariables>(SendPickupReminderToBuyerDocument, baseOptions);
      }
export type SendPickupReminderToBuyerMutationHookResult = ReturnType<typeof useSendPickupReminderToBuyerMutation>;
export type SendPickupReminderToBuyerMutationResult = Apollo.MutationResult<SendPickupReminderToBuyerMutation>;
export type SendPickupReminderToBuyerMutationOptions = Apollo.BaseMutationOptions<SendPickupReminderToBuyerMutation, SendPickupReminderToBuyerMutationVariables>;
export const VendorRemunerationReportDocument = gql`
    query VendorRemunerationReport($month: ISO8601Date!) {
  vendorRemunerationReport(month: $month) {
    summary {
      totalCreation
      totalCommission
      total
    }
    details {
      writerId
      writerName
      fichesCount
      perFicheRate
      creationAmount
      caVentes
      taux
      commissionAmount
      total
    }
    dailySeries {
      date
      creationAmount
      commissionAmount
      total
    }
  }
}
    `;

/**
 * __useVendorRemunerationReportQuery__
 *
 * To run a query within a React component, call `useVendorRemunerationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorRemunerationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorRemunerationReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *   },
 * });
 */
export function useVendorRemunerationReportQuery(baseOptions: Apollo.QueryHookOptions<VendorRemunerationReportQuery, VendorRemunerationReportQueryVariables>) {
        return Apollo.useQuery<VendorRemunerationReportQuery, VendorRemunerationReportQueryVariables>(VendorRemunerationReportDocument, baseOptions);
      }
export function useVendorRemunerationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorRemunerationReportQuery, VendorRemunerationReportQueryVariables>) {
          return Apollo.useLazyQuery<VendorRemunerationReportQuery, VendorRemunerationReportQueryVariables>(VendorRemunerationReportDocument, baseOptions);
        }
export type VendorRemunerationReportQueryHookResult = ReturnType<typeof useVendorRemunerationReportQuery>;
export type VendorRemunerationReportLazyQueryHookResult = ReturnType<typeof useVendorRemunerationReportLazyQuery>;
export type VendorRemunerationReportQueryResult = Apollo.QueryResult<VendorRemunerationReportQuery, VendorRemunerationReportQueryVariables>;
export const VendorStatementPaymentDocument = gql`
    query VendorStatementPayment($id: ID!) {
  vendorStatementPayment(id: $id) {
    id
    vendor {
      id
      stripeConnectAccountId
      account {
        firstName
        lastName
        bankInformation {
          iban
          bic
        }
      }
    }
    startAt
    endAt
    paymentDate
    paid
    totalAmount
    totalLinesCount
    totalSalesCount
    stripeTransferId
    stripeTransferStatus
    stripeTransferError
    stripeTransferredAt
    createdAt
    updatedAt
    vendorStatements {
      edges {
        node {
          id
          document {
            filename
            imageUrl
          }
        }
      }
    }
    monthlyVendorPayments {
      edges {
        node {
          id
          sale {
            id
            name
            endAt
          }
          netAmount
          totalSales
          totalFees
          netAmount
          vendorPaymentLines {
            edges {
              node {
                amount
                feePercentage
                feeAmount
              }
            }
          }
          orderItems {
            edges {
              node {
                id
                totalPrice
                commissionTtc
                order {
                  id
                  createdAt
                }
                item {
                  id
                  title
                  firstImage {
                    imageUrl
                  }
                  finalPrice
                  lowEstimatedPrice
                  highEstimatedPrice
                }
              }
            }
          }
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useVendorStatementPaymentQuery__
 *
 * To run a query within a React component, call `useVendorStatementPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorStatementPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorStatementPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVendorStatementPaymentQuery(baseOptions: Apollo.QueryHookOptions<VendorStatementPaymentQuery, VendorStatementPaymentQueryVariables>) {
        return Apollo.useQuery<VendorStatementPaymentQuery, VendorStatementPaymentQueryVariables>(VendorStatementPaymentDocument, baseOptions);
      }
export function useVendorStatementPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorStatementPaymentQuery, VendorStatementPaymentQueryVariables>) {
          return Apollo.useLazyQuery<VendorStatementPaymentQuery, VendorStatementPaymentQueryVariables>(VendorStatementPaymentDocument, baseOptions);
        }
export type VendorStatementPaymentQueryHookResult = ReturnType<typeof useVendorStatementPaymentQuery>;
export type VendorStatementPaymentLazyQueryHookResult = ReturnType<typeof useVendorStatementPaymentLazyQuery>;
export type VendorStatementPaymentQueryResult = Apollo.QueryResult<VendorStatementPaymentQuery, VendorStatementPaymentQueryVariables>;
export const UpdateVendorStatementPaymentDocument = gql`
    mutation UpdateVendorStatementPayment($input: UpdateVendorStatementPaymentMutationInput!) {
  updateVendorStatementPayment(input: $input) {
    vendorStatementPayment {
      id
      paid
      paymentDate
    }
    errors {
      fullMessages
    }
  }
}
    `;
export type UpdateVendorStatementPaymentMutationFn = Apollo.MutationFunction<UpdateVendorStatementPaymentMutation, UpdateVendorStatementPaymentMutationVariables>;

/**
 * __useUpdateVendorStatementPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateVendorStatementPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorStatementPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorStatementPaymentMutation, { data, loading, error }] = useUpdateVendorStatementPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVendorStatementPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorStatementPaymentMutation, UpdateVendorStatementPaymentMutationVariables>) {
        return Apollo.useMutation<UpdateVendorStatementPaymentMutation, UpdateVendorStatementPaymentMutationVariables>(UpdateVendorStatementPaymentDocument, baseOptions);
      }
export type UpdateVendorStatementPaymentMutationHookResult = ReturnType<typeof useUpdateVendorStatementPaymentMutation>;
export type UpdateVendorStatementPaymentMutationResult = Apollo.MutationResult<UpdateVendorStatementPaymentMutation>;
export type UpdateVendorStatementPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateVendorStatementPaymentMutation, UpdateVendorStatementPaymentMutationVariables>;
export const TriggerStripeTransferVspDocument = gql`
    mutation TriggerStripeTransferVSP($input: TriggerStripeTransferMutationInput!) {
  triggerStripeTransfer(input: $input) {
    vendorStatementPayment {
      id
      stripeTransferId
      stripeTransferStatus
      stripeTransferError
      stripeTransferredAt
    }
    errors
  }
}
    `;
export type TriggerStripeTransferVspMutationFn = Apollo.MutationFunction<TriggerStripeTransferVspMutation, TriggerStripeTransferVspMutationVariables>;

/**
 * __useTriggerStripeTransferVspMutation__
 *
 * To run a mutation, you first call `useTriggerStripeTransferVspMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerStripeTransferVspMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerStripeTransferVspMutation, { data, loading, error }] = useTriggerStripeTransferVspMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerStripeTransferVspMutation(baseOptions?: Apollo.MutationHookOptions<TriggerStripeTransferVspMutation, TriggerStripeTransferVspMutationVariables>) {
        return Apollo.useMutation<TriggerStripeTransferVspMutation, TriggerStripeTransferVspMutationVariables>(TriggerStripeTransferVspDocument, baseOptions);
      }
export type TriggerStripeTransferVspMutationHookResult = ReturnType<typeof useTriggerStripeTransferVspMutation>;
export type TriggerStripeTransferVspMutationResult = Apollo.MutationResult<TriggerStripeTransferVspMutation>;
export type TriggerStripeTransferVspMutationOptions = Apollo.BaseMutationOptions<TriggerStripeTransferVspMutation, TriggerStripeTransferVspMutationVariables>;
export const GetVendorsPerfAnalyticsDocument = gql`
    query getVendorsPerfAnalytics($from: ISO8601DateTime!, $to: ISO8601DateTime!, $fromN1: ISO8601DateTime!, $toN1: ISO8601DateTime!, $compareTo: CompareToEnum!, $vendorId: ID, $categoryId: ID) {
  topVendors: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [VENDOR_COMPARISON]
    breakdown: {dimension: VENDOR}
  ) {
    metrics {
      name
      breakdown {
        dimensionId
        name
        value
      }
    }
  }
  kpis: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [SALE_RATE, PRICE_VS_ESTIMATION, VENDOR_MARGIN, UNSOLD_RATE]
    compareTo: $compareTo
  ) {
    metrics {
      name
      value
      comparison {
        previousValue
        delta
        deltaPercentage
      }
    }
  }
  priceDetailByCategory: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [PRICE_DETAIL_BY_CATEGORY]
    breakdown: {dimension: CATEGORY}
  ) {
    metrics {
      name
      breakdown {
        dimensionId
        name
        value
      }
    }
  }
  saleRate: analytics(
    scope: {from: $from, to: $to, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [SALE_RATE]
    timeSeries: {granularity: MONTH}
  ) {
    metrics {
      name
      timeSeries {
        period
        value
      }
    }
  }
  saleRateN1: analytics(
    scope: {from: $fromN1, to: $toN1, vendorId: $vendorId, categoryId: $categoryId}
    metrics: [SALE_RATE]
    timeSeries: {granularity: MONTH}
  ) {
    metrics {
      name
      timeSeries {
        period
        value
      }
    }
  }
}
    `;

/**
 * __useGetVendorsPerfAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetVendorsPerfAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorsPerfAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorsPerfAnalyticsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      fromN1: // value for 'fromN1'
 *      toN1: // value for 'toN1'
 *      compareTo: // value for 'compareTo'
 *      vendorId: // value for 'vendorId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetVendorsPerfAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetVendorsPerfAnalyticsQuery, GetVendorsPerfAnalyticsQueryVariables>) {
        return Apollo.useQuery<GetVendorsPerfAnalyticsQuery, GetVendorsPerfAnalyticsQueryVariables>(GetVendorsPerfAnalyticsDocument, baseOptions);
      }
export function useGetVendorsPerfAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorsPerfAnalyticsQuery, GetVendorsPerfAnalyticsQueryVariables>) {
          return Apollo.useLazyQuery<GetVendorsPerfAnalyticsQuery, GetVendorsPerfAnalyticsQueryVariables>(GetVendorsPerfAnalyticsDocument, baseOptions);
        }
export type GetVendorsPerfAnalyticsQueryHookResult = ReturnType<typeof useGetVendorsPerfAnalyticsQuery>;
export type GetVendorsPerfAnalyticsLazyQueryHookResult = ReturnType<typeof useGetVendorsPerfAnalyticsLazyQuery>;
export type GetVendorsPerfAnalyticsQueryResult = Apollo.QueryResult<GetVendorsPerfAnalyticsQuery, GetVendorsPerfAnalyticsQueryVariables>;
export const WriterItemsWriterDocument = gql`
    query WriterItemsWriter($id: ID!) {
  writer(id: $id) {
    id
    account {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useWriterItemsWriterQuery__
 *
 * To run a query within a React component, call `useWriterItemsWriterQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriterItemsWriterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriterItemsWriterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWriterItemsWriterQuery(baseOptions: Apollo.QueryHookOptions<WriterItemsWriterQuery, WriterItemsWriterQueryVariables>) {
        return Apollo.useQuery<WriterItemsWriterQuery, WriterItemsWriterQueryVariables>(WriterItemsWriterDocument, baseOptions);
      }
export function useWriterItemsWriterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WriterItemsWriterQuery, WriterItemsWriterQueryVariables>) {
          return Apollo.useLazyQuery<WriterItemsWriterQuery, WriterItemsWriterQueryVariables>(WriterItemsWriterDocument, baseOptions);
        }
export type WriterItemsWriterQueryHookResult = ReturnType<typeof useWriterItemsWriterQuery>;
export type WriterItemsWriterLazyQueryHookResult = ReturnType<typeof useWriterItemsWriterLazyQuery>;
export type WriterItemsWriterQueryResult = Apollo.QueryResult<WriterItemsWriterQuery, WriterItemsWriterQueryVariables>;
export const WriterPaymentDocument = gql`
    query WriterPayment($id: ID!) {
  writerPayment(id: $id) {
    id
    orderItems {
      edges {
        node {
          id
          totalPrice
          order {
            id
            sale {
              id
              name
            }
          }
        }
      }
    }
    paid
    startAt
    endAt
    writerPaymentLines {
      edges {
        node {
          id
          amount
        }
      }
    }
    invoices {
      ...File
    }
    writer {
      id
      account {
        id
        lastName
        firstName
        bankInformation {
          iban
          bic
        }
      }
    }
  }
}
    ${FileFragmentDoc}`;

/**
 * __useWriterPaymentQuery__
 *
 * To run a query within a React component, call `useWriterPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriterPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriterPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWriterPaymentQuery(baseOptions: Apollo.QueryHookOptions<WriterPaymentQuery, WriterPaymentQueryVariables>) {
        return Apollo.useQuery<WriterPaymentQuery, WriterPaymentQueryVariables>(WriterPaymentDocument, baseOptions);
      }
export function useWriterPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WriterPaymentQuery, WriterPaymentQueryVariables>) {
          return Apollo.useLazyQuery<WriterPaymentQuery, WriterPaymentQueryVariables>(WriterPaymentDocument, baseOptions);
        }
export type WriterPaymentQueryHookResult = ReturnType<typeof useWriterPaymentQuery>;
export type WriterPaymentLazyQueryHookResult = ReturnType<typeof useWriterPaymentLazyQuery>;
export type WriterPaymentQueryResult = Apollo.QueryResult<WriterPaymentQuery, WriterPaymentQueryVariables>;
export const UpdateWriterStatementPaymentDocument = gql`
    mutation UpdateWriterStatementPayment($input: UpdateWriterStatementPaymentMutationInput!) {
  updateWriterStatementPayment(input: $input) {
    writerStatementPayment {
      id
      paid
      paymentDate
    }
    errors {
      fullMessages
    }
  }
}
    `;
export type UpdateWriterStatementPaymentMutationFn = Apollo.MutationFunction<UpdateWriterStatementPaymentMutation, UpdateWriterStatementPaymentMutationVariables>;

/**
 * __useUpdateWriterStatementPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateWriterStatementPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWriterStatementPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWriterStatementPaymentMutation, { data, loading, error }] = useUpdateWriterStatementPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWriterStatementPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWriterStatementPaymentMutation, UpdateWriterStatementPaymentMutationVariables>) {
        return Apollo.useMutation<UpdateWriterStatementPaymentMutation, UpdateWriterStatementPaymentMutationVariables>(UpdateWriterStatementPaymentDocument, baseOptions);
      }
export type UpdateWriterStatementPaymentMutationHookResult = ReturnType<typeof useUpdateWriterStatementPaymentMutation>;
export type UpdateWriterStatementPaymentMutationResult = Apollo.MutationResult<UpdateWriterStatementPaymentMutation>;
export type UpdateWriterStatementPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateWriterStatementPaymentMutation, UpdateWriterStatementPaymentMutationVariables>;
export const UpdateWriterPaymentDocument = gql`
    mutation UpdateWriterPayment($input: UpdateWriterPaymentMutationInput!) {
  updateWriterPayment(input: $input) {
    writerPayment {
      id
    }
  }
}
    `;
export type UpdateWriterPaymentMutationFn = Apollo.MutationFunction<UpdateWriterPaymentMutation, UpdateWriterPaymentMutationVariables>;

/**
 * __useUpdateWriterPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateWriterPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWriterPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWriterPaymentMutation, { data, loading, error }] = useUpdateWriterPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWriterPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWriterPaymentMutation, UpdateWriterPaymentMutationVariables>) {
        return Apollo.useMutation<UpdateWriterPaymentMutation, UpdateWriterPaymentMutationVariables>(UpdateWriterPaymentDocument, baseOptions);
      }
export type UpdateWriterPaymentMutationHookResult = ReturnType<typeof useUpdateWriterPaymentMutation>;
export type UpdateWriterPaymentMutationResult = Apollo.MutationResult<UpdateWriterPaymentMutation>;
export type UpdateWriterPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateWriterPaymentMutation, UpdateWriterPaymentMutationVariables>;
export const WriterPaymentListDocument = gql`
    query WriterPaymentList {
  unpaidWriterPayments: writerPayments(
    where: {paid: {equalTo: false}, writerStatementPaymentId: {isBlank: true}}
    first: 1
  ) {
    totalCount
  }
  unpaidWriterStatementPayments: writerStatementPayments(
    where: {paid: {equalTo: false}}
    first: 1
  ) {
    totalCount
  }
  allWriterPayments: writerPayments(
    where: {writerStatementPaymentId: {isBlank: true}}
    first: 1
  ) {
    totalCount
  }
}
    `;

/**
 * __useWriterPaymentListQuery__
 *
 * To run a query within a React component, call `useWriterPaymentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriterPaymentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriterPaymentListQuery({
 *   variables: {
 *   },
 * });
 */
export function useWriterPaymentListQuery(baseOptions?: Apollo.QueryHookOptions<WriterPaymentListQuery, WriterPaymentListQueryVariables>) {
        return Apollo.useQuery<WriterPaymentListQuery, WriterPaymentListQueryVariables>(WriterPaymentListDocument, baseOptions);
      }
export function useWriterPaymentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WriterPaymentListQuery, WriterPaymentListQueryVariables>) {
          return Apollo.useLazyQuery<WriterPaymentListQuery, WriterPaymentListQueryVariables>(WriterPaymentListDocument, baseOptions);
        }
export type WriterPaymentListQueryHookResult = ReturnType<typeof useWriterPaymentListQuery>;
export type WriterPaymentListLazyQueryHookResult = ReturnType<typeof useWriterPaymentListLazyQuery>;
export type WriterPaymentListQueryResult = Apollo.QueryResult<WriterPaymentListQuery, WriterPaymentListQueryVariables>;
export const WriterStatementPaymentDocument = gql`
    query WriterStatementPayment($id: ID!) {
  writerStatementPayment(id: $id) {
    id
    totalAmount
    totalSalesCount
    writer {
      account {
        id
        lastName
        firstName
        bankInformation {
          iban
          bic
        }
      }
    }
    paid
    startAt
    endAt
    invoices {
      ...File
    }
    writerPayments {
      edges {
        node {
          id
          sale {
            id
            name
          }
          orderItems {
            edges {
              node {
                id
                totalPrice
                item {
                  id
                  title
                  firstImage {
                    imageUrl
                  }
                  lowEstimatedPrice
                  highEstimatedPrice
                  finalPrice
                  writerCommission
                }
              }
            }
          }
          writerPaymentLines {
            edges {
              node {
                id
                amount
              }
            }
          }
        }
      }
    }
  }
}
    ${FileFragmentDoc}`;

/**
 * __useWriterStatementPaymentQuery__
 *
 * To run a query within a React component, call `useWriterStatementPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriterStatementPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriterStatementPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWriterStatementPaymentQuery(baseOptions: Apollo.QueryHookOptions<WriterStatementPaymentQuery, WriterStatementPaymentQueryVariables>) {
        return Apollo.useQuery<WriterStatementPaymentQuery, WriterStatementPaymentQueryVariables>(WriterStatementPaymentDocument, baseOptions);
      }
export function useWriterStatementPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WriterStatementPaymentQuery, WriterStatementPaymentQueryVariables>) {
          return Apollo.useLazyQuery<WriterStatementPaymentQuery, WriterStatementPaymentQueryVariables>(WriterStatementPaymentDocument, baseOptions);
        }
export type WriterStatementPaymentQueryHookResult = ReturnType<typeof useWriterStatementPaymentQuery>;
export type WriterStatementPaymentLazyQueryHookResult = ReturnType<typeof useWriterStatementPaymentLazyQuery>;
export type WriterStatementPaymentQueryResult = Apollo.QueryResult<WriterStatementPaymentQuery, WriterStatementPaymentQueryVariables>;
export const WriterStatsReportDocument = gql`
    query WriterStatsReport($startDate: ISO8601Date!, $endDate: ISO8601Date!) {
  writerStatsReport(startDate: $startDate, endDate: $endDate) {
    summary {
      totalCreated
      inProgress
      sold
      unsold
      saleRate
      totalRevenue
      averagePrice
    }
    rankings {
      writerId
      writerName
      writerType
      inProgressCount
      createdCount
      soldCount
      saleRate
      totalRevenue
      revenuePerDay
      avgPhotos
    }
    dailyProduction {
      date
      createdCount
      avgPhotos
    }
    dailyRevenue {
      date
      revenue
      soldCount
    }
  }
}
    `;

/**
 * __useWriterStatsReportQuery__
 *
 * To run a query within a React component, call `useWriterStatsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriterStatsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriterStatsReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useWriterStatsReportQuery(baseOptions: Apollo.QueryHookOptions<WriterStatsReportQuery, WriterStatsReportQueryVariables>) {
        return Apollo.useQuery<WriterStatsReportQuery, WriterStatsReportQueryVariables>(WriterStatsReportDocument, baseOptions);
      }
export function useWriterStatsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WriterStatsReportQuery, WriterStatsReportQueryVariables>) {
          return Apollo.useLazyQuery<WriterStatsReportQuery, WriterStatsReportQueryVariables>(WriterStatsReportDocument, baseOptions);
        }
export type WriterStatsReportQueryHookResult = ReturnType<typeof useWriterStatsReportQuery>;
export type WriterStatsReportLazyQueryHookResult = ReturnType<typeof useWriterStatsReportLazyQuery>;
export type WriterStatsReportQueryResult = Apollo.QueryResult<WriterStatsReportQuery, WriterStatsReportQueryVariables>;
export const WriterWeeklyFollowUpDocument = gql`
    query WriterWeeklyFollowUp($startDate: ISO8601Date!, $endDate: ISO8601Date!) {
  writerWeeklyFollowUp(startDate: $startDate, endDate: $endDate) {
    writers {
      writerId
      writerName
    }
    dailyProduction {
      date
      entries {
        writerId
        createdCount
        draftCount
      }
    }
    dailyRevenue {
      date
      entries {
        writerId
        revenue
      }
    }
  }
}
    `;

/**
 * __useWriterWeeklyFollowUpQuery__
 *
 * To run a query within a React component, call `useWriterWeeklyFollowUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriterWeeklyFollowUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriterWeeklyFollowUpQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useWriterWeeklyFollowUpQuery(baseOptions: Apollo.QueryHookOptions<WriterWeeklyFollowUpQuery, WriterWeeklyFollowUpQueryVariables>) {
        return Apollo.useQuery<WriterWeeklyFollowUpQuery, WriterWeeklyFollowUpQueryVariables>(WriterWeeklyFollowUpDocument, baseOptions);
      }
export function useWriterWeeklyFollowUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WriterWeeklyFollowUpQuery, WriterWeeklyFollowUpQueryVariables>) {
          return Apollo.useLazyQuery<WriterWeeklyFollowUpQuery, WriterWeeklyFollowUpQueryVariables>(WriterWeeklyFollowUpDocument, baseOptions);
        }
export type WriterWeeklyFollowUpQueryHookResult = ReturnType<typeof useWriterWeeklyFollowUpQuery>;
export type WriterWeeklyFollowUpLazyQueryHookResult = ReturnType<typeof useWriterWeeklyFollowUpLazyQuery>;
export type WriterWeeklyFollowUpQueryResult = Apollo.QueryResult<WriterWeeklyFollowUpQuery, WriterWeeklyFollowUpQueryVariables>;
export const GetWritersPerfAnalyticsDocument = gql`
    query getWritersPerfAnalytics($from: ISO8601DateTime!, $to: ISO8601DateTime!, $compareTo: CompareToEnum!, $writerId: ID, $categoryId: ID) {
  kpis: analytics(
    scope: {from: $from, to: $to, writerId: $writerId, categoryId: $categoryId}
    metrics: [WRITER_VOLUME, WRITER_DOWNSTREAM]
    compareTo: $compareTo
  ) {
    metrics {
      name
      value
      comparison {
        previousValue
        delta
        deltaPercentage
      }
    }
  }
  byWriters: analytics(
    scope: {from: $from, to: $to, writerId: $writerId, categoryId: $categoryId}
    metrics: [WRITER_VOLUME, WRITER_DOWNSTREAM]
    breakdown: {dimension: WRITER}
  ) {
    metrics {
      name
      breakdown {
        name
        dimensionId
        value
      }
    }
  }
  volume: analytics(
    scope: {from: $from, to: $to, writerId: $writerId, categoryId: $categoryId}
    metrics: [WRITER_VOLUME]
    timeSeries: {granularity: MONTH}
  ) {
    metrics {
      name
      timeSeries {
        ...AnalyticsVolumeAndDelayChartCard
      }
    }
  }
}
    ${AnalyticsVolumeAndDelayChartCardFragmentDoc}`;

/**
 * __useGetWritersPerfAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetWritersPerfAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWritersPerfAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWritersPerfAnalyticsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      compareTo: // value for 'compareTo'
 *      writerId: // value for 'writerId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetWritersPerfAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetWritersPerfAnalyticsQuery, GetWritersPerfAnalyticsQueryVariables>) {
        return Apollo.useQuery<GetWritersPerfAnalyticsQuery, GetWritersPerfAnalyticsQueryVariables>(GetWritersPerfAnalyticsDocument, baseOptions);
      }
export function useGetWritersPerfAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWritersPerfAnalyticsQuery, GetWritersPerfAnalyticsQueryVariables>) {
          return Apollo.useLazyQuery<GetWritersPerfAnalyticsQuery, GetWritersPerfAnalyticsQueryVariables>(GetWritersPerfAnalyticsDocument, baseOptions);
        }
export type GetWritersPerfAnalyticsQueryHookResult = ReturnType<typeof useGetWritersPerfAnalyticsQuery>;
export type GetWritersPerfAnalyticsLazyQueryHookResult = ReturnType<typeof useGetWritersPerfAnalyticsLazyQuery>;
export type GetWritersPerfAnalyticsQueryResult = Apollo.QueryResult<GetWritersPerfAnalyticsQuery, GetWritersPerfAnalyticsQueryVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($id: ID!) {
  customer(id: $id) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, baseOptions);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, baseOptions);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const CreateCustomerDocument = gql`
    mutation createCustomer($attributes: CreateCustomerInput!) {
  createCustomer(input: {attributes: $attributes}) {
    clientMutationId
    customer {
      ...Customer
    }
  }
}
    ${CustomerFragmentDoc}`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, baseOptions);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const ItemDocument = gql`
    query Item($id: ID!) {
  item(id: $id) {
    id
    customDescription
    autoDescription
    ...ItemSteps
    ...ItemImages
    state
    mode
    customSkuPart
    sku
    project {
      id
    }
    template {
      __typename
      ... on Watch {
        ...Watch
      }
    }
    ...ItemCategory
  }
}
    ${ItemStepsFragmentDoc}
${ItemImagesFragmentDoc}
${WatchFragmentDoc}
${ItemCategoryFragmentDoc}`;

/**
 * __useItemQuery__
 *
 * To run a query within a React component, call `useItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useItemQuery(baseOptions: Apollo.QueryHookOptions<ItemQuery, ItemQueryVariables>) {
        return Apollo.useQuery<ItemQuery, ItemQueryVariables>(ItemDocument, baseOptions);
      }
export function useItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemQuery, ItemQueryVariables>) {
          return Apollo.useLazyQuery<ItemQuery, ItemQueryVariables>(ItemDocument, baseOptions);
        }
export type ItemQueryHookResult = ReturnType<typeof useItemQuery>;
export type ItemLazyQueryHookResult = ReturnType<typeof useItemLazyQuery>;
export type ItemQueryResult = Apollo.QueryResult<ItemQuery, ItemQueryVariables>;
export const UpdateImageOrderDocument = gql`
    mutation UpdateImageOrder($id: ID!, $imageIds: [ID!]!) {
  updateItem(input: {id: $id, attributes: {imageOrder: $imageIds}}) {
    clientMutationId
    errors
  }
}
    `;
export type UpdateImageOrderMutationFn = Apollo.MutationFunction<UpdateImageOrderMutation, UpdateImageOrderMutationVariables>;

/**
 * __useUpdateImageOrderMutation__
 *
 * To run a mutation, you first call `useUpdateImageOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageOrderMutation, { data, loading, error }] = useUpdateImageOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageIds: // value for 'imageIds'
 *   },
 * });
 */
export function useUpdateImageOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImageOrderMutation, UpdateImageOrderMutationVariables>) {
        return Apollo.useMutation<UpdateImageOrderMutation, UpdateImageOrderMutationVariables>(UpdateImageOrderDocument, baseOptions);
      }
export type UpdateImageOrderMutationHookResult = ReturnType<typeof useUpdateImageOrderMutation>;
export type UpdateImageOrderMutationResult = Apollo.MutationResult<UpdateImageOrderMutation>;
export type UpdateImageOrderMutationOptions = Apollo.BaseMutationOptions<UpdateImageOrderMutation, UpdateImageOrderMutationVariables>;
export const RemoveImagesDocument = gql`
    mutation RemoveImages($id: ID!, $imageIds: [ID!]!) {
  updateItem(input: {id: $id, attributes: {imageIdsToDelete: $imageIds}}) {
    clientMutationId
    errors
  }
}
    `;
export type RemoveImagesMutationFn = Apollo.MutationFunction<RemoveImagesMutation, RemoveImagesMutationVariables>;

/**
 * __useRemoveImagesMutation__
 *
 * To run a mutation, you first call `useRemoveImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeImagesMutation, { data, loading, error }] = useRemoveImagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageIds: // value for 'imageIds'
 *   },
 * });
 */
export function useRemoveImagesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveImagesMutation, RemoveImagesMutationVariables>) {
        return Apollo.useMutation<RemoveImagesMutation, RemoveImagesMutationVariables>(RemoveImagesDocument, baseOptions);
      }
export type RemoveImagesMutationHookResult = ReturnType<typeof useRemoveImagesMutation>;
export type RemoveImagesMutationResult = Apollo.MutationResult<RemoveImagesMutation>;
export type RemoveImagesMutationOptions = Apollo.BaseMutationOptions<RemoveImagesMutation, RemoveImagesMutationVariables>;
export const StartItemDescriptionGenerationDocument = gql`
    mutation StartItemDescriptionGeneration($id: ID!) {
  startItemDescriptionGeneration(input: {id: $id}) {
    item {
      id
      mode
      generationStatus
      generationError
      descriptionSuggestion
      descriptionSuggestionGeneratedAt
    }
  }
}
    `;
export type StartItemDescriptionGenerationMutationFn = Apollo.MutationFunction<StartItemDescriptionGenerationMutation, StartItemDescriptionGenerationMutationVariables>;

/**
 * __useStartItemDescriptionGenerationMutation__
 *
 * To run a mutation, you first call `useStartItemDescriptionGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartItemDescriptionGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startItemDescriptionGenerationMutation, { data, loading, error }] = useStartItemDescriptionGenerationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartItemDescriptionGenerationMutation(baseOptions?: Apollo.MutationHookOptions<StartItemDescriptionGenerationMutation, StartItemDescriptionGenerationMutationVariables>) {
        return Apollo.useMutation<StartItemDescriptionGenerationMutation, StartItemDescriptionGenerationMutationVariables>(StartItemDescriptionGenerationDocument, baseOptions);
      }
export type StartItemDescriptionGenerationMutationHookResult = ReturnType<typeof useStartItemDescriptionGenerationMutation>;
export type StartItemDescriptionGenerationMutationResult = Apollo.MutationResult<StartItemDescriptionGenerationMutation>;
export type StartItemDescriptionGenerationMutationOptions = Apollo.BaseMutationOptions<StartItemDescriptionGenerationMutation, StartItemDescriptionGenerationMutationVariables>;
export const StartItemWatchDescriptionGenerationDocument = gql`
    mutation StartItemWatchDescriptionGeneration($id: ID!) {
  startItemWatchDescriptionGeneration(input: {id: $id}) {
    item {
      id
      mode
      generationStatus
      generationError
      descriptionSuggestion
      descriptionSuggestionGeneratedAt
    }
  }
}
    `;
export type StartItemWatchDescriptionGenerationMutationFn = Apollo.MutationFunction<StartItemWatchDescriptionGenerationMutation, StartItemWatchDescriptionGenerationMutationVariables>;

/**
 * __useStartItemWatchDescriptionGenerationMutation__
 *
 * To run a mutation, you first call `useStartItemWatchDescriptionGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartItemWatchDescriptionGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startItemWatchDescriptionGenerationMutation, { data, loading, error }] = useStartItemWatchDescriptionGenerationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartItemWatchDescriptionGenerationMutation(baseOptions?: Apollo.MutationHookOptions<StartItemWatchDescriptionGenerationMutation, StartItemWatchDescriptionGenerationMutationVariables>) {
        return Apollo.useMutation<StartItemWatchDescriptionGenerationMutation, StartItemWatchDescriptionGenerationMutationVariables>(StartItemWatchDescriptionGenerationDocument, baseOptions);
      }
export type StartItemWatchDescriptionGenerationMutationHookResult = ReturnType<typeof useStartItemWatchDescriptionGenerationMutation>;
export type StartItemWatchDescriptionGenerationMutationResult = Apollo.MutationResult<StartItemWatchDescriptionGenerationMutation>;
export type StartItemWatchDescriptionGenerationMutationOptions = Apollo.BaseMutationOptions<StartItemWatchDescriptionGenerationMutation, StartItemWatchDescriptionGenerationMutationVariables>;